// Generated by scripts/update-international-catalogues.py; do not edit.
export const ELF_CATALOGUE = [
    {
        code: '09K3',
        country: 'FO',
        jurisdiction: 'FO',
        jurisdictionName: 'Faroe Islands',
        name: 'Samstarvsfelag við ábyrgd',
        abbreviation: '',
        active: true,
        aliases: ['Samstarvsfelag við ábyrgd'],
    },
    {
        code: '0AWU',
        country: 'US',
        jurisdiction: 'US-OR',
        jurisdictionName: 'Oregon',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: '0GY3',
        country: 'US',
        jurisdiction: 'US-CO',
        jurisdictionName: 'Colorado',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: '0NYS',
        country: 'SG',
        jurisdiction: 'SG',
        jurisdictionName: 'Singapore',
        name: 'Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Partnership'],
    },
    {
        code: '0OCP',
        country: 'VN',
        jurisdiction: 'VN',
        jurisdictionName: 'Viet Nam',
        name: 'công ty trách nhiệm hữu hạn',
        abbreviation: '',
        active: true,
        aliases: ['công ty trách nhiệm hữu hạn'],
    },
    {
        code: '0SKB',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: '0WOU',
        country: 'US',
        jurisdiction: 'US-KS',
        jurisdictionName: 'Kansas',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: '106J',
        country: 'BY',
        jurisdiction: 'BY',
        jurisdictionName: 'Belarus',
        name: 'Закрытае акцыянернае таварыства',
        abbreviation: 'ЗАТ',
        active: true,
        aliases: [
            'Закрытае акцыянернае таварыства',
            'Zakrytae akcyyanernae tavarystva',
            'ЗАТ',
            'ZAT',
            'Закрытое акционерное общество',
            'Zakrytoe akcionernoe obshchestvo',
            'ЗАО',
            'ZAО',
        ],
    },
    {
        code: '10GE',
        country: 'US',
        jurisdiction: 'US-WI',
        jurisdictionName: 'Wisconsin',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: '10ST',
        country: 'VC',
        jurisdiction: 'VC',
        jurisdictionName: 'Saint Vincent and the Grenadines',
        name: 'association',
        abbreviation: '',
        active: true,
        aliases: ['association'],
    },
    {
        code: '10UR',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Syndicat coopératif',
        abbreviation: '',
        active: true,
        aliases: ['Syndicat coopératif'],
    },
    {
        code: '11GD',
        country: 'US',
        jurisdiction: 'US-SC',
        jurisdictionName: 'South Carolina',
        name: 'Nonprofit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation'],
    },
    {
        code: '12F9',
        country: 'HN',
        jurisdiction: 'HN',
        jurisdictionName: 'Honduras',
        name: 'Sociedades de Capital Variable',
        abbreviation: 'de C. V.',
        active: true,
        aliases: ['Sociedades de Capital Variable', 'de C. V.'],
    },
    {
        code: '12KO',
        country: 'KR',
        jurisdiction: 'KR',
        jurisdictionName: 'Korea (Republic of)',
        name: '회사형 펀드',
        abbreviation: '',
        active: true,
        aliases: ['회사형 펀드', 'HoeSaHyeong fund'],
    },
    {
        code: '12MV',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Kommanditaktiengesellschaft',
        abbreviation: '',
        active: true,
        aliases: ['Kommanditaktiengesellschaft'],
    },
    {
        code: '12N6',
        country: 'US',
        jurisdiction: 'US-DE',
        jurisdictionName: 'Delaware',
        name: 'Unincorporated Nonprofit Association',
        abbreviation: '',
        active: true,
        aliases: ['Unincorporated Nonprofit Association'],
    },
    {
        code: '135L',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società Costituita In Base A Leggi Di Altro Stato',
        abbreviation: '',
        active: false,
        aliases: [
            'Società Costituita In Base A Leggi Di Altro Stato',
            "Societa' Costituita In Base A Leggi Di Altro Stato",
        ],
    },
    {
        code: '13AV',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Versicherungsverein auf Gegenseitigkeit',
        abbreviation: 'VVaG',
        active: true,
        aliases: ['Versicherungsverein auf Gegenseitigkeit', 'VVaG'],
    },
    {
        code: '13T9',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Europos bendrovės',
        abbreviation: 'EB',
        active: true,
        aliases: ['Europos bendrovės', 'EB'],
    },
    {
        code: '13ZV',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'samodzielny publiczny zakład opieki zdrowotnej',
        abbreviation: '',
        active: true,
        aliases: ['samodzielny publiczny zakład opieki zdrowotnej'],
    },
    {
        code: '149O',
        country: 'MK',
        jurisdiction: 'MK',
        jurisdictionName: 'North Macedonia',
        name: 'Командитно друштво со акции',
        abbreviation: 'KDA',
        active: true,
        aliases: ['Командитно друштво со акции', 'Komanditno drustvo so akcii', 'KDA'],
    },
    {
        code: '14AT',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Javna agencija',
        abbreviation: '',
        active: true,
        aliases: ['Javna agencija'],
    },
    {
        code: '14NU',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Rozpočtové a príspevkové organizácie',
        abbreviation: '',
        active: true,
        aliases: ['Rozpočtové a príspevkové organizácie'],
    },
    {
        code: '14OD',
        country: 'US',
        jurisdiction: 'US',
        jurisdictionName: 'United States of America',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: '14U1',
        country: 'TW',
        jurisdiction: 'TW',
        jurisdictionName: 'Taiwan (Province of China)',
        name: '兩合公司',
        abbreviation: '',
        active: true,
        aliases: ['兩合公司', 'Wúxiàn zérèn gǔdōng de wúxiàn gōngsī'],
    },
    {
        code: '157O',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Régie d'une collectivité locale à caractère administratif",
        abbreviation: '',
        active: true,
        aliases: ["Régie d'une collectivité locale à caractère administratif"],
    },
    {
        code: '15A2',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Объединения (ассоциации и союзы) благотворительных организаций',
        abbreviation: '',
        active: true,
        aliases: [
            'Объединения (ассоциации и союзы) благотворительных организаций',
            'Ob"yedineniya (assotsiatsii i soyuzy) blagotvoritel\'nykh organizatsiy',
        ],
    },
    {
        code: '15BP',
        country: 'KH',
        jurisdiction: 'KH',
        jurisdictionName: 'Cambodia',
        name: 'Private Limited Company',
        abbreviation: '',
        active: true,
        aliases: [
            'Private Limited Company',
            'ក្រុមហ៊ុនឯកជនទទួលខុសត្រូវមានកម្រិត',
            'kromhoun ekachn ttuolkhosatrauv meanokamrit',
        ],
    },
    {
        code: '15JS',
        country: 'US',
        jurisdiction: 'US-SD',
        jurisdictionName: 'South Dakota',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP'],
    },
    {
        code: '16GH',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les cercles agricoles',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur les cercles agricoles'],
    },
    {
        code: '16RL',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur la mise en marché des produits agricoles',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur la mise en marché des produits agricoles',
        ],
    },
    {
        code: '17FJ',
        country: 'SG',
        jurisdiction: 'SG',
        jurisdictionName: 'Singapore',
        name: 'Limited Partnership',
        abbreviation: 'LP;limited partnership;Limited Partnership',
        active: true,
        aliases: ['Limited Partnership', 'LP;limited partnership;Limited Partnership'],
    },
    {
        code: '17R0',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Community Interest Company',
        abbreviation: 'CIC',
        active: true,
        aliases: ['Community Interest Company', 'CIC'],
    },
    {
        code: '17R7',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Общества с ограниченной ответственностью',
        abbreviation: '',
        active: true,
        aliases: [
            'Общества с ограниченной ответственностью',
            "Obshchestva s ogranichennoy otvetstvennost'yu",
        ],
    },
    {
        code: '180P',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Stand Alone Primary Dealer',
        abbreviation: '',
        active: true,
        aliases: ['Stand Alone Primary Dealer'],
    },
    {
        code: '189Q',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Špecializovaná organizačná jednotka ČSD',
        abbreviation: 'Špec.org.jednotka ČSD',
        active: true,
        aliases: ['Špecializovaná organizačná jednotka ČSD', 'Špec.org.jednotka ČSD'],
    },
    {
        code: '194I',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Professional Corporation',
        abbreviation: '',
        active: false,
        aliases: ['Professional Corporation', 'Corporación Especial para el Desarrollo Municipal'],
    },
    {
        code: '1A0A',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Besloten vennootschap',
        abbreviation: '',
        active: true,
        aliases: ['Besloten vennootschap'],
    },
    {
        code: '1ADA',
        country: 'US',
        jurisdiction: 'US-MO',
        jurisdictionName: 'Missouri',
        name: 'Family Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Family Trust Company'],
    },
    {
        code: '1ADH',
        country: 'CA',
        jurisdiction: 'CA-NT',
        jurisdictionName: 'Northwest Territories',
        name: 'Extra-Territorial Corporation(for profit and not-for-profit)',
        abbreviation: 'Ltd.;Ltée.;Inc.;Corp.;Ltd;Limited',
        active: true,
        aliases: [
            'Extra-Territorial Corporation(for profit and not-for-profit)',
            'Ltd.;Ltée.;Inc.;Corp.;Ltd;Limited',
        ],
    },
    {
        code: '1AFG',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Muu yhtiö',
        abbreviation: '',
        active: true,
        aliases: ['Muu yhtiö', 'Annat bolag'],
    },
    {
        code: '1ASH',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Religious corporations',
        abbreviation: '',
        active: true,
        aliases: ['Religious corporations'],
    },
    {
        code: '1B88',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SCP de médecins',
        abbreviation: '',
        active: true,
        aliases: ['SCP de médecins'],
    },
    {
        code: '1BL5',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Swiss branch of an enterprise domiciled abroad not registered in the commercial register',
        abbreviation: 'Foreign Coop. & Ltd.Co.',
        active: false,
        aliases: [
            'Swiss branch of an enterprise domiciled abroad not registered in the commercial register',
            'Foreign Coop. & Ltd.Co.',
            "Succursale suisse d'une entreprise domiciliée à l'étranger non inscrite au registre de commerce",
            'Coop & Sarl étranger',
            'Ausländische Niederlassung nicht im Handelsregister eingetragen',
            'Ausl. Gen. & GMBH',
            "Succursali svizzere di una impresa domiciliata all'estero non iscritta al registro di commercio",
            'Coop. & SAGL estero',
        ],
    },
    {
        code: '1CDX',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Societate europeană',
        abbreviation: 'SE',
        active: true,
        aliases: ['Societate europeană', 'SE'],
    },
    {
        code: '1CML',
        country: 'CA',
        jurisdiction: 'CA-BC',
        jurisdictionName: 'British Columbia',
        name: 'Sole proprietorship',
        abbreviation: 'LLP;SRL;SENCRL',
        active: true,
        aliases: ['Sole proprietorship', 'LLP;SRL;SENCRL'],
    },
    {
        code: '1CSW',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Obecný podnik',
        abbreviation: '',
        active: true,
        aliases: ['Obecný podnik'],
    },
    {
        code: '1CSZ',
        country: 'SX',
        jurisdiction: 'SX',
        jurisdictionName: 'Sint Maarten',
        name: 'vereniging',
        abbreviation: '',
        active: true,
        aliases: ['vereniging'],
    },
    {
        code: '1CZS',
        country: 'US',
        jurisdiction: 'US-UT',
        jurisdictionName: 'Utah',
        name: 'General Partnership',
        abbreviation: '',
        active: true,
        aliases: ['General Partnership'],
    },
    {
        code: '1DGT',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Treuunternehmen',
        abbreviation: 'Trust reg.',
        active: true,
        aliases: ['Treuunternehmen', 'Trust reg.'],
    },
    {
        code: '1E9M',
        country: 'CA',
        jurisdiction: 'CA-NL',
        jurisdictionName: 'Newfoundland and Labrador',
        name: 'Limited Partnership',
        abbreviation: 'LP;limited partnership;Limited Partnership',
        active: true,
        aliases: ['Limited Partnership', 'LP;limited partnership;Limited Partnership'],
    },
    {
        code: '1EQC',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'trade name/sole proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['trade name/sole proprietorship'],
    },
    {
        code: '1G26',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Public Limited by Guarantee and not having a Share Capital (1931 Act)',
        abbreviation: '',
        active: true,
        aliases: ['Public Limited by Guarantee and not having a Share Capital (1931 Act)'],
    },
    {
        code: '1G29',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Limitada Laboral (o Sociedad de Responsabilidad Limitada laboral)',
        abbreviation: 'S.R.L.L.;S.L.L.',
        active: true,
        aliases: [
            'Sociedad Limitada Laboral (o Sociedad de Responsabilidad Limitada laboral)',
            'S.R.L.L.;S.L.L.',
        ],
    },
    {
        code: '1GLU',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Jednotka železničného správneho úradu',
        abbreviation: 'Jednot.žel.správ.úradu',
        active: true,
        aliases: ['Jednotka železničného správneho úradu', 'Jednot.žel.správ.úradu'],
    },
    {
        code: '1GNM',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Syndicat de salariés',
        abbreviation: '',
        active: true,
        aliases: ['Syndicat de salariés'],
    },
    {
        code: '1GR6',
        country: 'VG',
        jurisdiction: 'VG',
        jurisdictionName: 'Virgin Islands (British)',
        name: 'Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Partnership'],
    },
    {
        code: '1HEP',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Rozpočtová organizácia',
        abbreviation: '',
        active: true,
        aliases: ['Rozpočtová organizácia'],
    },
    {
        code: '1HGD',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Cooperativa',
        abbreviation: '',
        active: true,
        aliases: ['Cooperativa'],
    },
    {
        code: '1HXP',
        country: 'US',
        jurisdiction: 'US-DE',
        jurisdictionName: 'Delaware',
        name: 'Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Partnership'],
    },
    {
        code: '1IPK',
        country: 'LV',
        jurisdiction: 'LV',
        jurisdictionName: 'Latvia',
        name: 'Komandītsabiedrība',
        abbreviation: 'KS',
        active: true,
        aliases: ['Komandītsabiedrība', 'KS'],
    },
    {
        code: '1IWK',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '外国常驻新闻机构',
        abbreviation: '',
        active: true,
        aliases: ['外国常驻新闻机构', 'wai guo chang zhu xin wen ji gou'],
    },
    {
        code: '1JGX',
        country: 'CA',
        jurisdiction: 'CA-ON',
        jurisdictionName: 'Ontario',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: '1JK6',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Svépomocné zemědělské družstvo',
        abbreviation: '',
        active: true,
        aliases: ['Svépomocné zemědělské družstvo'],
    },
    {
        code: '1JXS',
        country: 'US',
        jurisdiction: 'US-CO',
        jurisdictionName: 'Colorado',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: '1K73',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Zahraničná osoba, právnická osoba so sídlom mimo územia SR',
        abbreviation: 'Zahranič.osoba,právnická',
        active: true,
        aliases: [
            'Zahraničná osoba, právnická osoba so sídlom mimo územia SR',
            'Zahranič.osoba,právnická',
        ],
    },
    {
        code: '1K9U',
        country: 'US',
        jurisdiction: 'US-AR',
        jurisdictionName: 'Arkansas',
        name: 'Non-Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Non-Profit Corporation'],
    },
    {
        code: '1KU4',
        country: 'US',
        jurisdiction: 'US-IL',
        jurisdictionName: 'Illinois',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: '1L24',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Autre société civile',
        abbreviation: '',
        active: true,
        aliases: ['Autre société civile'],
    },
    {
        code: '1MBR',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Άλλη νομική μορφή',
        abbreviation: '',
        active: false,
        aliases: ['Άλλη νομική μορφή', 'Alli nomiki morfi'],
    },
    {
        code: '1MJ0',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Крестьянские (фермерские) хозяйства',
        abbreviation: '',
        active: true,
        aliases: ['Крестьянские (фермерские) хозяйства', "Krest'yanskiye (fermerskiye) khozyaystva"],
    },
    {
        code: '1MQ6',
        country: 'PE',
        jurisdiction: 'PE',
        jurisdictionName: 'Peru',
        name: 'Sociedad en Comandita por Acciones',
        abbreviation: 'S. en C. por A.',
        active: true,
        aliases: ['Sociedad en Comandita por Acciones', 'S. en C. por A.'],
    },
    {
        code: '1MWR',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Fond',
        abbreviation: '',
        active: true,
        aliases: ['Fond'],
    },
    {
        code: '1NF1',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA nationale à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA nationale à conseil d'administration"],
    },
    {
        code: '1NKP',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Sihtasutus',
        abbreviation: 'SA',
        active: true,
        aliases: ['Sihtasutus', 'SA'],
    },
    {
        code: '1NOX',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Sonstiger Rechtsträger',
        abbreviation: '',
        active: true,
        aliases: ['Sonstiger Rechtsträger'],
    },
    {
        code: '1ONH',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Public Benefit Corporations',
        abbreviation: '',
        active: true,
        aliases: ['Public Benefit Corporations'],
    },
    {
        code: '1OR3',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'delniška družba',
        abbreviation: 'd.d.',
        active: true,
        aliases: ['delniška družba', 'd.d.'],
    },
    {
        code: '1PAD',
        country: 'CO',
        jurisdiction: 'CO',
        jurisdictionName: 'Colombia',
        name: 'Empresa Unipersonal',
        abbreviation: 'E.U.',
        active: true,
        aliases: ['Empresa Unipersonal', 'E.U.'],
    },
    {
        code: '1PWF',
        country: 'VC',
        jurisdiction: 'VC',
        jurisdictionName: 'Saint Vincent and the Grenadines',
        name: 'public company',
        abbreviation: '',
        active: true,
        aliases: ['public company'],
    },
    {
        code: '1Q16',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société créée de fait entre personnes physiques',
        abbreviation: '',
        active: true,
        aliases: ['Société créée de fait entre personnes physiques'],
    },
    {
        code: '1Q2B',
        country: 'GG',
        jurisdiction: 'GG',
        jurisdictionName: 'Alderney',
        name: 'company limited by guarantee',
        abbreviation: '',
        active: true,
        aliases: ['company limited by guarantee'],
    },
    {
        code: '1QMT',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Business Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation',
        active: true,
        aliases: [
            'Business Corporation',
            'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation',
        ],
    },
    {
        code: '1QNZ',
        country: 'UY',
        jurisdiction: 'UY',
        jurisdictionName: 'Uruguay',
        name: 'Fundacion',
        abbreviation: '',
        active: true,
        aliases: ['Fundacion'],
    },
    {
        code: '1QU8',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Cooperativa',
        abbreviation: 'S.Coop',
        active: true,
        aliases: ['Sociedad Cooperativa', 'S.Coop'],
    },
    {
        code: '1RI9',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Ente Ecclesiastico Civilmente Riconosciuto',
        abbreviation: '',
        active: true,
        aliases: ['Ente Ecclesiastico Civilmente Riconosciuto'],
    },
    {
        code: '1RJ2',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Автономные некоммерческие организации',
        abbreviation: '',
        active: true,
        aliases: ['Автономные некоммерческие организации', 'Avtonomnyye nekommercheskiye organizatsii'],
    },
    {
        code: '1RKS',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Foreign public administration (e.g. embassy)',
        abbreviation: 'Embassy',
        active: false,
        aliases: [
            'Foreign public administration (e.g. embassy)',
            'Embassy',
            'Administration publique étrangère (ex. Ambassade)',
            'Ambassade',
            'Ausländische öffentliche Verwaltung',
            'Botschaft',
            'Amministrazione pubblica estera (ex. ambasciata)',
            'Ambasciate',
        ],
    },
    {
        code: '1RPE',
        country: 'WS',
        jurisdiction: 'WS',
        jurisdictionName: 'Samoa',
        name: 'Charitable trust',
        abbreviation: '',
        active: true,
        aliases: ['Charitable trust'],
    },
    {
        code: '1S9L',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Professional Series Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Professional Series Limited Liability Company'],
    },
    {
        code: '1SL4',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Empresario Individual',
        abbreviation: '',
        active: true,
        aliases: ['Empresario Individual'],
    },
    {
        code: '1SOY',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Europäische Genossenschaft',
        abbreviation: 'SCE',
        active: true,
        aliases: ['Europäische Genossenschaft', 'SCE'],
    },
    {
        code: '1SVL',
        country: 'CW',
        jurisdiction: 'CW',
        jurisdictionName: 'Curaçao',
        name: 'Stille vennootschap',
        abbreviation: '',
        active: true,
        aliases: ['Stille vennootschap'],
    },
    {
        code: '1T06',
        country: 'CW',
        jurisdiction: 'CW',
        jurisdictionName: 'Curaçao',
        name: 'Stichting',
        abbreviation: '',
        active: true,
        aliases: ['Stichting'],
    },
    {
        code: '1T9S',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: '1TG4',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Low Profit LLC',
        abbreviation: '',
        active: true,
        aliases: ['Low Profit LLC', 'Compañía de Responsabilidad Limitada con Fin Social'],
    },
    {
        code: '1TN0',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Ideell förening (som bedriver näringsverksamhet)',
        abbreviation: 'I',
        active: true,
        aliases: ['Ideell förening (som bedriver näringsverksamhet)', 'I'],
    },
    {
        code: '1TON',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Associazione',
        abbreviation: '',
        active: true,
        aliases: ['Associazione'],
    },
    {
        code: '1TX8',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Commanditaire vennootschap op aandelen met een sociaal oogmerk',
        abbreviation: 'CVA SO',
        active: true,
        aliases: [
            'Commanditaire vennootschap op aandelen met een sociaal oogmerk',
            'CVA SO',
            'Société en commandite par actions à finalité sociale',
            'SCA FS',
            'Kommanditgesellschaft auf Aktien mit sozialer Zielsetzung',
            'KGaAmsZ',
        ],
    },
    {
        code: '1U7Y',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Благотворительные учреждения',
        abbreviation: '',
        active: true,
        aliases: ['Благотворительные учреждения', "Blagotvoritel'nyye uchrezhdeniya"],
    },
    {
        code: '1V0I',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Domestic Benefit Corporation',
        abbreviation: 'A Benefit Corporation',
        active: true,
        aliases: ['Domestic Benefit Corporation', 'A Benefit Corporation'],
    },
    {
        code: '1VTA',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les évêques catholiques romains',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur les évêques catholiques romains'],
    },
    {
        code: '1W62',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Oversea Company',
        abbreviation: '',
        active: false,
        aliases: ['Oversea Company'],
    },
    {
        code: '1W6I',
        country: 'BS',
        jurisdiction: 'BS',
        jurisdictionName: 'Bahamas',
        name: 'Limited Liability Partnership',
        abbreviation: 'LLP',
        active: true,
        aliases: ['Limited Liability Partnership', 'LLP'],
    },
    {
        code: '1W8B',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Zahraničná osoba',
        abbreviation: '',
        active: true,
        aliases: ['Zahraničná osoba'],
    },
    {
        code: '1WZP',
        country: 'US',
        jurisdiction: 'US-IL',
        jurisdictionName: 'Illinois',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP;LLLP',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP;LLLP'],
    },
    {
        code: '1XME',
        country: 'US',
        jurisdiction: 'US-MA',
        jurisdictionName: 'Massachusetts',
        name: 'Housing Cooperative Corporation',
        abbreviation: 'Company;Corporation;Corp.;Incorporated;Inc.',
        active: true,
        aliases: ['Housing Cooperative Corporation', 'Company;Corporation;Corp.;Incorporated;Inc.'],
    },
    {
        code: '1XOG',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Agricultural Marketing Association',
        abbreviation: '',
        active: true,
        aliases: ['Agricultural Marketing Association'],
    },
    {
        code: '1Y0C',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SARL d'attribution",
        abbreviation: '',
        active: true,
        aliases: ["SARL d'attribution"],
    },
    {
        code: '1YA4',
        country: 'US',
        jurisdiction: 'US-WY',
        jurisdictionName: 'Wyoming',
        name: 'Statutory Foundation',
        abbreviation: 'SF;S.F.',
        active: true,
        aliases: ['Statutory Foundation', 'SF;S.F.'],
    },
    {
        code: '1YIR',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Metsänhoitoyhdistys',
        abbreviation: '',
        active: true,
        aliases: ['Metsänhoitoyhdistys', 'Skogsvårdsförening'],
    },
    {
        code: '1ZHJ',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Colectiva Profesional (o Sociedad regular colectiva profesional)',
        abbreviation: 'S.C.P.;S.R.C.P.',
        active: true,
        aliases: [
            'Sociedad Colectiva Profesional (o Sociedad regular colectiva profesional)',
            'S.C.P.;S.R.C.P.',
        ],
    },
    {
        code: '211B',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société coopérative agricole',
        abbreviation: '',
        active: true,
        aliases: ['Société coopérative agricole'],
    },
    {
        code: '21F4',
        country: 'JE',
        jurisdiction: 'JE',
        jurisdictionName: 'Jersey',
        name: 'Separate Limited Partnerships',
        abbreviation: 'S.L.P.;SLP;Separate Limited Partnership;separate limited partnership;Separate Limited Partnerships;separate limited partnerships',
        active: true,
        aliases: [
            'Separate Limited Partnerships',
            'S.L.P.;SLP;Separate Limited Partnership;separate limited partnership;Separate Limited Partnerships;separate limited partnerships',
        ],
    },
    {
        code: '21OE',
        country: 'US',
        jurisdiction: 'US-MO',
        jurisdictionName: 'Missouri',
        name: 'Limited Liability Partnership',
        abbreviation: 'L.L.P.;LLP',
        active: true,
        aliases: ['Limited Liability Partnership', 'L.L.P.;LLP'],
    },
    {
        code: '22EO',
        country: 'US',
        jurisdiction: 'US-MA',
        jurisdictionName: 'Massachusetts',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: '22SC',
        country: 'US',
        jurisdiction: 'US-IL',
        jurisdictionName: 'Illinois',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: '233U',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Συνεταιρισμός',
        abbreviation: '',
        active: true,
        aliases: ['Συνεταιρισμός', 'Synetairismos'],
    },
    {
        code: '23Q4',
        country: 'US',
        jurisdiction: 'US-PA',
        jurisdictionName: 'Pennsylvania',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: '23V9',
        country: 'CA',
        jurisdiction: 'CA-BC',
        jurisdictionName: 'British Columbia',
        name: 'Limited partnership',
        abbreviation: 'LLP;SRL;SENCRL',
        active: true,
        aliases: ['Limited partnership', 'LLP;SRL;SENCRL'],
    },
    {
        code: '23XJ',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, sociedad de información crediticia',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima de capital variable, sociedad de información crediticia'],
    },
    {
        code: '24EG',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Kreditna unija',
        abbreviation: '',
        active: true,
        aliases: ['Kreditna unija'],
    },
    {
        code: '24TU',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Союзы (ассоциации) общественных объединений',
        abbreviation: '',
        active: true,
        aliases: [
            'Союзы (ассоциации) общественных объединений',
            'Soyuzy (assotsiatsii) obshchestvennykh ob"yedineniy',
        ],
    },
    {
        code: '254M',
        country: 'HK',
        jurisdiction: 'HK',
        jurisdictionName: 'Hong Kong',
        name: '私人股份有限公司',
        abbreviation: '有限公司',
        active: true,
        aliases: [
            '私人股份有限公司',
            'Si ren gu fen you xian gong si',
            '有限公司',
            'Private company limited by shares',
            'Ltd;Ltd.;Limited',
        ],
    },
    {
        code: '274G',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Udruga',
        abbreviation: '',
        active: true,
        aliases: ['Udruga'],
    },
    {
        code: '27AW',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'offentlig enhet',
        abbreviation: '',
        active: true,
        aliases: ['offentlig enhet'],
    },
    {
        code: '27WJ',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les cités et villes',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur les cités et villes'],
    },
    {
        code: '28FE',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Coöperatieve vennootschap',
        abbreviation: 'CV',
        active: true,
        aliases: [
            'Coöperatieve vennootschap',
            'CV',
            'Société coopérative',
            'SC',
            'Genossenschaft',
            'Gen.',
        ],
    },
    {
        code: '28RA',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Fond',
        abbreviation: '',
        active: true,
        aliases: ['Fond'],
    },
    {
        code: '29FA',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Institution interrégionale ou entente',
        abbreviation: '',
        active: true,
        aliases: ['Institution interrégionale ou entente'],
    },
    {
        code: '29OB',
        country: 'KN',
        jurisdiction: 'KN',
        jurisdictionName: 'Saint Kitts and Nevis',
        name: 'foundation',
        abbreviation: '',
        active: true,
        aliases: ['foundation'],
    },
    {
        code: '2A44',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Egyéni cég',
        abbreviation: '',
        active: true,
        aliases: ['Egyéni cég'],
    },
    {
        code: '2AUN',
        country: 'GG',
        jurisdiction: 'GG',
        jurisdictionName: 'Guernsey',
        name: 'incorporated cell',
        abbreviation: 'ICC',
        active: true,
        aliases: ['incorporated cell', 'ICC'],
    },
    {
        code: '2B81',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Simple partnership',
        abbreviation: 'Simple Co.',
        active: true,
        aliases: [
            'Simple partnership',
            'Simple Co.',
            'Société simple',
            'Einfache Gesellschaft',
            'Einfache Gesellsch.',
            'Sociéta semplice',
        ],
    },
    {
        code: '2CC3',
        country: 'SX',
        jurisdiction: 'SX',
        jurisdictionName: 'Sint Maarten',
        name: 'besloten vennootschap',
        abbreviation: 'BV',
        active: true,
        aliases: ['besloten vennootschap', 'BV'],
    },
    {
        code: '2CTG',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'zadruga',
        abbreviation: '',
        active: true,
        aliases: ['zadruga'],
    },
    {
        code: '2DGO',
        country: 'BN',
        jurisdiction: 'BN',
        jurisdictionName: 'Brunei Darussalam',
        name: 'Public Company',
        abbreviation: 'Sdn Bhd;Bhd',
        active: true,
        aliases: ['Public Company', 'Sdn Bhd;Bhd'],
    },
    {
        code: '2DK3',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Podnik nebo hospodářské zařízení politické strany',
        abbreviation: '',
        active: true,
        aliases: ['Podnik nebo hospodářské zařízení politické strany'],
    },
    {
        code: '2DVA',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Cooperative Society',
        abbreviation: '',
        active: true,
        aliases: ['Cooperative Society'],
    },
    {
        code: '2DY1',
        country: 'TR',
        jurisdiction: 'TR',
        jurisdictionName: 'Türkiye',
        name: 'kamu tüzel kişiliği',
        abbreviation: '',
        active: true,
        aliases: ['kamu tüzel kişiliği'],
    },
    {
        code: '2EEG',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Akciová spoločnosť',
        abbreviation: 'Akc. spol.',
        active: true,
        aliases: ['Akciová spoločnosť', 'Akc. spol.'],
    },
    {
        code: '2EPF',
        country: 'US',
        jurisdiction: 'US-OH',
        jurisdictionName: 'Ohio',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: '2F0A',
        country: 'KN',
        jurisdiction: 'KN-N',
        jurisdictionName: 'Nevis',
        name: 'limited liability company',
        abbreviation: 'LLC;LC',
        active: true,
        aliases: ['limited liability company', 'LLC;LC'],
    },
    {
        code: '2FED',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Gospodarsko interesno udruženje',
        abbreviation: 'GIU',
        active: true,
        aliases: ['Gospodarsko interesno udruženje', 'GIU'],
    },
    {
        code: '2FHC',
        country: 'CA',
        jurisdiction: 'CA-NS',
        jurisdictionName: 'Nova Scotia',
        name: 'partnerships',
        abbreviation: '',
        active: true,
        aliases: ['partnerships'],
    },
    {
        code: '2GEJ',
        country: 'NE',
        jurisdiction: 'NE',
        jurisdictionName: 'Niger',
        name: 'Société à Responsabilité Limitée',
        abbreviation: 'SARL',
        active: true,
        aliases: ['Société à Responsabilité Limitée', 'SARL'],
    },
    {
        code: '2GV9',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'Irish Collective Asset-management Vehicle',
        abbreviation: 'ICAV',
        active: true,
        aliases: ['Irish Collective Asset-management Vehicle', 'ICAV'],
    },
    {
        code: '2H36',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Союзы (ассоциации) кооперативов',
        abbreviation: '',
        active: true,
        aliases: ['Союзы (ассоциации) кооперативов', 'Soyuzy (assotsiatsii) kooperativov'],
    },
    {
        code: '2HBR',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Gesellschaft mit beschränkter Haftung',
        abbreviation: 'GmbH',
        active: true,
        aliases: ['Gesellschaft mit beschränkter Haftung', 'GmbH'],
    },
    {
        code: '2HC6',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'pubblica amministrazione',
        abbreviation: '',
        active: true,
        aliases: ['pubblica amministrazione'],
    },
    {
        code: '2I4P',
        country: 'US',
        jurisdiction: 'US-UT',
        jurisdictionName: 'Utah',
        name: 'Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Profit Corporation'],
    },
    {
        code: '2IGL',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Entreprise individuelle',
        abbreviation: 'EI',
        active: true,
        aliases: ['Entreprise individuelle', 'EI'],
    },
    {
        code: '2J66',
        country: 'CW',
        jurisdiction: 'CW',
        jurisdictionName: 'Curaçao',
        name: 'Stichting Particulier Fonds',
        abbreviation: '',
        active: true,
        aliases: ['Stichting Particulier Fonds'],
    },
    {
        code: '2J7Z',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Consorzio con attività Esterna',
        abbreviation: '',
        active: true,
        aliases: ['Consorzio con attività Esterna'],
    },
    {
        code: '2JB4',
        country: 'US',
        jurisdiction: 'US-NH',
        jurisdictionName: 'New Hampshire',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: '2JEI',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Association sans but lucratif',
        abbreviation: 'ASBL',
        active: true,
        aliases: ['Association sans but lucratif', 'ASBL'],
    },
    {
        code: '2JZ4',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Foundation',
        abbreviation: '',
        active: true,
        aliases: ['Foundation', 'Fondation', 'Stiftung', 'Fondazione'],
    },
    {
        code: '2KMA',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Štátny podnik v oddieli Pšn',
        abbreviation: '',
        active: true,
        aliases: ['Štátny podnik v oddieli Pšn'],
    },
    {
        code: '2L5O',
        country: 'NE',
        jurisdiction: 'NE',
        jurisdictionName: 'Niger',
        name: "Groupement d'intérêt économique",
        abbreviation: 'GIE',
        active: true,
        aliases: ["Groupement d'intérêt économique", 'GIE'],
    },
    {
        code: '2LB5',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Munkavállalói Résztulajdonosi Program szervezet',
        abbreviation: '',
        active: true,
        aliases: ['Munkavállalói Résztulajdonosi Program szervezet'],
    },
    {
        code: '2LNV',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, institución de seguros',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima de capital variable, institución de seguros'],
    },
    {
        code: '2M6Y',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '基金会',
        abbreviation: '',
        active: true,
        aliases: ['基金会', 'ji jin hui'],
    },
    {
        code: '2MAO',
        country: 'BH',
        jurisdiction: 'BH',
        jurisdictionName: 'Bahrain',
        name: 'الشركة غير هادفة للربح',
        abbreviation: '',
        active: true,
        aliases: ['الشركة غير هادفة للربح', 'Alsharikat ghayr hadifat lilribih'],
    },
    {
        code: '2N4L',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: '(Autre) Collectivité territoriale',
        abbreviation: '',
        active: true,
        aliases: ['(Autre) Collectivité territoriale'],
    },
    {
        code: '2N9X',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Česká konsolidační agentura',
        abbreviation: '',
        active: true,
        aliases: ['Česká konsolidační agentura'],
    },
    {
        code: '2NAI',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Comunidad',
        abbreviation: '',
        active: true,
        aliases: ['Comunidad'],
    },
    {
        code: '2NL6',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'État, collectivité ou établissement public étranger',
        abbreviation: '',
        active: false,
        aliases: ['État, collectivité ou établissement public étranger'],
    },
    {
        code: '2NRQ',
        country: 'JP',
        jurisdiction: 'JP',
        jurisdictionName: 'Japan',
        name: '地方公共団体',
        abbreviation: '',
        active: true,
        aliases: ['地方公共団体', 'chihokokyoudantai'],
    },
    {
        code: '2ODA',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les sociétés agricoles et laitières',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur les sociétés agricoles et laitières'],
    },
    {
        code: '2OJP',
        country: 'IS',
        jurisdiction: 'IS',
        jurisdictionName: 'Iceland',
        name: 'Samlagshlutafélag',
        abbreviation: 'slhf.',
        active: true,
        aliases: ['Samlagshlutafélag', 'slhf.'],
    },
    {
        code: '2ONM',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA d'attribution à directoire",
        abbreviation: '',
        active: true,
        aliases: ["SA d'attribution à directoire"],
    },
    {
        code: '2OTW',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Муниципальные автономные учреждения',
        abbreviation: '',
        active: true,
        aliases: ['Муниципальные автономные учреждения', "Munitsipal'nyye avtonomnyye uchrezhdeniya"],
    },
    {
        code: '2PHU',
        country: 'SG',
        jurisdiction: 'SG',
        jurisdictionName: 'Singapore',
        name: 'Business',
        abbreviation: '',
        active: false,
        aliases: ['Business'],
    },
    {
        code: '2PRK',
        country: 'AM',
        jurisdiction: 'AM',
        jurisdictionName: 'Armenia',
        name: 'Լիակատար ընկերակցություն',
        abbreviation: 'ԼԸ',
        active: true,
        aliases: ['Լիակատար ընկերակցություն', 'Liakatar enkeraktsʿutʿyun', 'ԼԸ', 'LĒ'],
    },
    {
        code: '2QMJ',
        country: 'HK',
        jurisdiction: 'HK',
        jurisdictionName: 'Hong Kong',
        name: 'Trust',
        abbreviation: '',
        active: true,
        aliases: ['Trust'],
    },
    {
        code: '2QSA',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Coöperatieve vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk',
        abbreviation: 'CVBA SO',
        active: true,
        aliases: [
            'Coöperatieve vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk',
            'CVBA SO',
            'Société coopérative à responsabilité limitée à finalité sociale',
            'SCRL FS',
            'Genossenschaft mit beschränkter Haftung mit sozialer Zielsetzung',
            'GbHsZ',
        ],
    },
    {
        code: '2R1N',
        country: 'US',
        jurisdiction: 'US-OH',
        jurisdictionName: 'Ohio',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: '2R46',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Товарищества собственников жилья',
        abbreviation: '',
        active: true,
        aliases: ['Товарищества собственников жилья', "Tovarishchestva sobstvennikov zhil'ya"],
    },
    {
        code: '2R82',
        country: 'JO',
        jurisdiction: 'JO',
        jurisdictionName: 'Jordan',
        name: 'شركة رأس المال المغامر',
        abbreviation: '',
        active: true,
        aliases: ['شركة رأس المال المغامر', 'sharikat raas almal almughamir'],
    },
    {
        code: '2RK5',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Kunta',
        abbreviation: '',
        active: true,
        aliases: ['Kunta', 'Kommun'],
    },
    {
        code: '2RVP',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima promotora de inversión de capital variable, sociedad financiera de objeto múltiple, entidad no regulada',
        abbreviation: 'S.A.P.I. DE C.V., SOFOM E.N.R.',
        active: true,
        aliases: [
            'Sociedad anónima promotora de inversión de capital variable, sociedad financiera de objeto múltiple, entidad no regulada',
            'S.A.P.I. DE C.V., SOFOM E.N.R.',
        ],
    },
    {
        code: '2S2U',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: "Association d'épargne pension",
        abbreviation: 'ASSEP',
        active: true,
        aliases: ["Association d'épargne pension", 'ASSEP'],
    },
    {
        code: '2SPI',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Islamic Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Islamic Limited Partnership'],
    },
    {
        code: '2SZI',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Ente Sociale',
        abbreviation: '',
        active: true,
        aliases: ['Ente Sociale'],
    },
    {
        code: '2T7B',
        country: 'BB',
        jurisdiction: 'BB',
        jurisdictionName: 'Barbados',
        name: 'society with restricted liability',
        abbreviation: 'SRL',
        active: true,
        aliases: ['society with restricted liability', 'SRL'],
    },
    {
        code: '2U3G',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Société en nom collectif à responsabilité limitée',
        abbreviation: 'S.E.N.C.R.L.',
        active: true,
        aliases: ['Société en nom collectif à responsabilité limitée', 'S.E.N.C.R.L.'],
    },
    {
        code: '2UAX',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Trossamfund (som bedriver näringsverksamhet)',
        abbreviation: 'TSF',
        active: true,
        aliases: ['Trossamfund (som bedriver näringsverksamhet)', 'TSF'],
    },
    {
        code: '2UBX',
        country: 'SX',
        jurisdiction: 'SX',
        jurisdictionName: 'Sint Maarten',
        name: 'commanditaire vennootschap op aandelen',
        abbreviation: '',
        active: true,
        aliases: ['commanditaire vennootschap op aandelen'],
    },
    {
        code: '2UZP',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Sociedad Colectiva Civil',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad Colectiva Civil'],
    },
    {
        code: '2W1A',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Civil',
        abbreviation: 'SC',
        active: true,
        aliases: ['Sociedad Civil', 'SC'],
    },
    {
        code: '2WCH',
        country: 'US',
        jurisdiction: 'US-OR',
        jurisdictionName: 'Oregon',
        name: 'savings bank',
        abbreviation: '',
        active: true,
        aliases: ['savings bank'],
    },
    {
        code: '2WFG',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Foreign public company',
        abbreviation: 'Foreign legal nature',
        active: false,
        aliases: [
            'Foreign public company',
            'Foreign legal nature',
            'Entreprise publique étrangère',
            'Nature jur. étran.',
            'Ausländisches öffentliches Unternehmen',
            'Ausl. Rechtsform',
            'Impresa pubblica estera',
            'Natura guiri. estera',
        ],
    },
    {
        code: '2WJZ',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Cooperative Association',
        abbreviation: 'coop;co-op;assn.;assoc.',
        active: true,
        aliases: ['Cooperative Association', 'coop;co-op;assn.;assoc.'],
    },
    {
        code: '2WMP',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Autre personne morale de droit administratif',
        abbreviation: '',
        active: true,
        aliases: ['Autre personne morale de droit administratif'],
    },
    {
        code: '2XIK',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Mutuelle',
        abbreviation: '',
        active: true,
        aliases: ['Mutuelle'],
    },
    {
        code: '2XJA',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Federal administration',
        abbreviation: 'Federal administration',
        active: true,
        aliases: [
            'Federal administration',
            'Administration de la Confédération',
            'Confédération',
            'Verwaltung des Bundes',
            'Bund',
            'Amministrazione della Confederazione',
            'Confederazione',
        ],
    },
    {
        code: '2XNE',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Komoditná burza',
        abbreviation: '',
        active: true,
        aliases: ['Komoditná burza'],
    },
    {
        code: '2XXG',
        country: 'US',
        jurisdiction: 'US-ME',
        jurisdictionName: 'Maine',
        name: 'Nonprofit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation'],
    },
    {
        code: '2XXH',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società Semplice',
        abbreviation: 'SS;S.S.',
        active: true,
        aliases: ['Società Semplice', 'SS;S.S.'],
    },
    {
        code: '2Y95',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Special Purpose Vehicle - Company',
        abbreviation: '',
        active: true,
        aliases: ['Special Purpose Vehicle - Company'],
    },
    {
        code: '2YZO',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Partnerschaftsgesellschaft mit beschränkter Berufshaftung',
        abbreviation: 'PartG mbB',
        active: true,
        aliases: ['Partnerschaftsgesellschaft mit beschränkter Berufshaftung', 'PartG mbB'],
    },
    {
        code: '2ZB3',
        country: 'ID',
        jurisdiction: 'ID',
        jurisdictionName: 'Indonesia',
        name: 'Perseroan Publik',
        abbreviation: '',
        active: true,
        aliases: ['Perseroan Publik'],
    },
    {
        code: '30D6',
        country: 'US',
        jurisdiction: 'US-OK',
        jurisdictionName: 'Oklahoma',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: '30IT',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Société par actions constitué par Loi sur les compagnies minières',
        abbreviation: '',
        active: true,
        aliases: ['Société par actions constitué par Loi sur les compagnies minières'],
    },
    {
        code: '30PQ',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Limited Liability Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Limited Partnership'],
    },
    {
        code: '30TX',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Trust Company'],
    },
    {
        code: '31N9',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Partido político',
        abbreviation: '',
        active: true,
        aliases: ['Partido político'],
    },
    {
        code: '326Y',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Ansvarlig selskap',
        abbreviation: 'ANS',
        active: true,
        aliases: ['Ansvarlig selskap', 'ANS'],
    },
    {
        code: '328X',
        country: 'IL',
        jurisdiction: 'IL',
        jurisdictionName: 'Israel',
        name: 'חברה ציבורית בע"מ',
        abbreviation: '',
        active: true,
        aliases: ['חברה ציבורית בע"מ', 'Chevra Tziburit'],
    },
    {
        code: '32AX',
        country: 'US',
        jurisdiction: 'US-IA',
        jurisdictionName: 'Iowa',
        name: 'Cooperative Association',
        abbreviation: '',
        active: true,
        aliases: ['Cooperative Association'],
    },
    {
        code: '32HC',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Verein',
        abbreviation: 'e.V.',
        active: true,
        aliases: ['Verein', 'e.V.'],
    },
    {
        code: '32J9',
        country: 'UY',
        jurisdiction: 'UY',
        jurisdictionName: 'Uruguay',
        name: 'Sociedad por Acciones Simplificada',
        abbreviation: 'S.A.S.',
        active: true,
        aliases: ['Sociedad por Acciones Simplificada', 'S.A.S.'],
    },
    {
        code: '33IP',
        country: 'JE',
        jurisdiction: 'JE',
        jurisdictionName: 'Jersey',
        name: 'Incorporated Limited Partnerships',
        abbreviation: 'I.L.P.;ILP;Inc.;L. P.;Inc;LP.;Incorporated Limited Partnerships;incorporated limited partnership',
        active: true,
        aliases: [
            'Incorporated Limited Partnerships',
            'I.L.P.;ILP;Inc.;L. P.;Inc;LP.;Incorporated Limited Partnerships;incorporated limited partnership',
        ],
    },
    {
        code: '33MN',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'vereniging met volledige rechtsbevoegdheid',
        abbreviation: '',
        active: true,
        aliases: ['vereniging met volledige rechtsbevoegdheid'],
    },
    {
        code: '346N',
        country: 'TW',
        jurisdiction: 'TW',
        jurisdictionName: 'Taiwan (Province of China)',
        name: '公益社團法人',
        abbreviation: '',
        active: true,
        aliases: ['公益社團法人', 'Císhàn tuántǐ'],
    },
    {
        code: '34PA',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Centralna banka',
        abbreviation: '',
        active: true,
        aliases: ['Centralna banka'],
    },
    {
        code: '34QS',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Autre personne morale de droit privé',
        abbreviation: '',
        active: true,
        aliases: ['Autre personne morale de droit privé'],
    },
    {
        code: '358I',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Nonprofit Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation',
        active: true,
        aliases: [
            'Nonprofit Corporation',
            'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation',
        ],
    },
    {
        code: '35BX',
        country: 'AE',
        jurisdiction: 'AE-RK',
        jurisdictionName: 'Ras Al Khaimah',
        name: 'Intellectual Property Holding Company ',
        abbreviation: '',
        active: false,
        aliases: ['Intellectual Property Holding Company '],
    },
    {
        code: '35QN',
        country: 'US',
        jurisdiction: 'US-KS',
        jurisdictionName: 'Kansas',
        name: 'Public Benefit Corporation',
        abbreviation: 'P.B.C.;PBC',
        active: true,
        aliases: ['Public Benefit Corporation', 'P.B.C.;PBC'],
    },
    {
        code: '35RF',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Company', 'Compañía de Responsabilidad Limitada'],
    },
    {
        code: '363J',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'European Economic Interest Grouping',
        abbreviation: 'EEIG',
        active: true,
        aliases: [
            'European Economic Interest Grouping',
            'EEIG',
            'Grupail Eorpach um Leas Eacnamaioch',
            'GELE',
        ],
    },
    {
        code: '36AO',
        country: 'CW',
        jurisdiction: 'CW',
        jurisdictionName: 'Curaçao',
        name: 'Naamloze Vennootschap',
        abbreviation: '',
        active: true,
        aliases: ['Naamloze Vennootschap'],
    },
    {
        code: '36KV',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Europese vennootschap (Societas Europaea)',
        abbreviation: 'SE',
        active: true,
        aliases: [
            'Europese vennootschap (Societas Europaea)',
            'SE',
            'Société européenne (Societas Europaea)',
            'Europäische Gesellschaft (Societas Europaea)',
        ],
    },
    {
        code: '36YD',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Unlimited Company',
        abbreviation: '',
        active: true,
        aliases: ['Unlimited Company'],
    },
    {
        code: '375P',
        country: 'AE',
        jurisdiction: 'AE-DU',
        jurisdictionName: 'Dubai',
        name: 'Foundation',
        abbreviation: '',
        active: true,
        aliases: ['Foundation'],
    },
    {
        code: '37F5',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Professional Firms',
        abbreviation: '',
        active: true,
        aliases: ['Professional Firms'],
    },
    {
        code: '37G2',
        country: 'PE',
        jurisdiction: 'PE',
        jurisdictionName: 'Peru',
        name: 'Sociedad por Acciones Cerrada Simplificada',
        abbreviation: 'S.A.C.S.',
        active: true,
        aliases: ['Sociedad por Acciones Cerrada Simplificada', 'S.A.C.S.'],
    },
    {
        code: '37GR',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Elinkeinoyhtymä',
        abbreviation: '',
        active: true,
        aliases: ['Elinkeinoyhtymä', 'Näringssammanslutning'],
    },
    {
        code: '37II',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Cooperativă meșteșugărească',
        abbreviation: '',
        active: true,
        aliases: ['Cooperativă meșteșugărească'],
    },
    {
        code: '37UT',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Region',
        abbreviation: '',
        active: true,
        aliases: ['Region'],
    },
    {
        code: '37YG',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Федеральные казенные предприятия',
        abbreviation: '',
        active: true,
        aliases: ['Федеральные казенные предприятия', "Federal'nyye kazennyye predpriyatiya"],
    },
    {
        code: '380O',
        country: 'US',
        jurisdiction: 'US',
        jurisdictionName: 'United States of America',
        name: 'Federal Savings Association',
        abbreviation: 'FSA',
        active: true,
        aliases: ['Federal Savings Association', 'FSA'],
    },
    {
        code: '381R',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Medlemsbank',
        abbreviation: 'MB',
        active: true,
        aliases: ['Medlemsbank', 'MB'],
    },
    {
        code: '38JQ',
        country: 'BO',
        jurisdiction: 'BO',
        jurisdictionName: 'Bolivia (Plurinational State of)',
        name: 'Empresa Unipersonal',
        abbreviation: '',
        active: true,
        aliases: ['Empresa Unipersonal'],
    },
    {
        code: '3AMJ',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Сельскохозяйственные производственные кооперативы',
        abbreviation: '',
        active: true,
        aliases: [
            'Сельскохозяйственные производственные кооперативы',
            "Sel'skokhozyaystvennyye proizvodstvennyye kooperativy",
        ],
    },
    {
        code: '3AZY',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Coopérative d'utilisation de matériel agricole en commun (CUMA)",
        abbreviation: '',
        active: true,
        aliases: ["Coopérative d'utilisation de matériel agricole en commun (CUMA)"],
    },
    {
        code: '3BJG',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'spółka partnerska',
        abbreviation: 'sp.p.',
        active: true,
        aliases: ['spółka partnerska', 'sp.p.'],
    },
    {
        code: '3BX3',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Evropské seskupení pro územní spolupráci',
        abbreviation: '',
        active: true,
        aliases: ['Evropské seskupení pro územní spolupráci'],
    },
    {
        code: '3C5P',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur la probation et sur les établissements de détention',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur la probation et sur les établissements de détention',
        ],
    },
    {
        code: '3C7U',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Stiftelse',
        abbreviation: '',
        active: true,
        aliases: ['Stiftelse'],
    },
    {
        code: '3DXJ',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Professional Limited Liability Company',
        abbreviation: 'PLLC',
        active: true,
        aliases: ['Professional Limited Liability Company', 'PLLC'],
    },
    {
        code: '3EAX',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Производственные кооперативы (кроме сельскохозяйственных производственных кооперативов)',
        abbreviation: '',
        active: true,
        aliases: [
            'Производственные кооперативы (кроме сельскохозяйственных производственных кооперативов)',
            "Proizvodstvennyye kooperativy (krome sel'skokhozyaystvennykh proizvodstvennykh kooperativov)",
        ],
    },
    {
        code: '3EKS',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Limited liability company',
        abbreviation: 'Ltd;Ltd.;Limited',
        active: true,
        aliases: [
            'Limited liability company',
            'Ltd;Ltd.;Limited',
            'Société à responsabilité limitée',
            'Sàrl',
            'Gesellschaft mit beschränkter Haftung',
            'GmbH',
            'Società a garanzia limitata',
            'Sagl',
        ],
    },
    {
        code: '3EPR',
        country: 'NZ',
        jurisdiction: 'NZ',
        jurisdictionName: 'New Zealand',
        name: 'Incorporated Society',
        abbreviation: 'IS; Inc Soc',
        active: true,
        aliases: ['Incorporated Society', 'IS; Inc Soc'],
    },
    {
        code: '3F98',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Учреждения',
        abbreviation: '',
        active: true,
        aliases: ['Учреждения', 'Uchrezhdeniya'],
    },
    {
        code: '3FCU',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Société d'exercice libéral par action simplifiée",
        abbreviation: '',
        active: true,
        aliases: ["Société d'exercice libéral par action simplifiée"],
    },
    {
        code: '3FI5',
        country: 'MM',
        jurisdiction: 'MM',
        jurisdictionName: 'Myanmar',
        name: 'ခံ၀န်ချက်အားဖြင့် တာ၀န်ကန့်သတ်ထားသည့်ကုမ္ပဏီ၊',
        abbreviation: '',
        active: true,
        aliases: [
            'ခံ၀န်ချက်အားဖြင့် တာ၀န်ကန့်သတ်ထားသည့်ကုမ္ပဏီ၊',
            'hkan 0 n hkyet aarrhpyint tar 0 n k ant saathtarr saeet kumpane',
        ],
    },
    {
        code: '3FP6',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les corporations de fonds de sécurité',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur les corporations de fonds de sécurité',
        ],
    },
    {
        code: '3FUP',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Европейско кооперативно дружество с ограничена отговорност',
        abbreviation: '',
        active: true,
        aliases: [
            'Европейско кооперативно дружество с ограничена отговорност',
            'Evropeysko kooperativno druzhestvo s ogranichena otgovornost',
        ],
    },
    {
        code: '3G3D',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Nadace',
        abbreviation: '',
        active: true,
        aliases: ['Nadace'],
    },
    {
        code: '3GQ5',
        country: 'KW',
        jurisdiction: 'KW',
        jurisdictionName: 'Kuwait',
        name: 'ملكية فردية ( شركة الشخص الواحد)',
        abbreviation: '',
        active: true,
        aliases: ['ملكية فردية ( شركة الشخص الواحد)', 'Milkiat fardia'],
    },
    {
        code: '3GTV',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Sanitary & Improvement District',
        abbreviation: '',
        active: true,
        aliases: ['Sanitary & Improvement District'],
    },
    {
        code: '3HLJ',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Поделение на eвропейско обединение по икономически интереси',
        abbreviation: '',
        active: false,
        aliases: [
            'Поделение на eвропейско обединение по икономически интереси',
            'Podelenie na evropeysko obedinenie po ikonomicheski interesi',
        ],
    },
    {
        code: '3JTE',
        country: 'US',
        jurisdiction: 'US-PA',
        jurisdictionName: 'Pennsylvania',
        name: 'Business Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.;P.C.',
        active: true,
        aliases: ['Business Corporation', 'corp.;inc.;co.;ltd.;P.C.'],
    },
    {
        code: '3KNT',
        country: 'US',
        jurisdiction: 'US',
        jurisdictionName: 'United States of America',
        name: 'Federal Government Entity',
        abbreviation: '',
        active: true,
        aliases: ['Federal Government Entity'],
    },
    {
        code: '3L58',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Kommunalt foretak',
        abbreviation: 'KF',
        active: true,
        aliases: ['Kommunalt foretak', 'KF'],
    },
    {
        code: '3L7Q',
        country: 'US',
        jurisdiction: 'US-PA',
        jurisdictionName: 'Pennsylvania',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: '3LCY',
        country: 'LV',
        jurisdiction: 'LV',
        jurisdictionName: 'Latvia',
        name: 'Pilnsabiedrība',
        abbreviation: 'PS',
        active: true,
        aliases: ['Pilnsabiedrība', 'PS'],
    },
    {
        code: '3LHF',
        country: 'PE',
        jurisdiction: 'PE',
        jurisdictionName: 'Peru',
        name: 'Sociedad Colectiva',
        abbreviation: 'S.C.',
        active: true,
        aliases: ['Sociedad Colectiva', 'S.C.'],
    },
    {
        code: '3LMA',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Buitenlandse onderneming',
        abbreviation: 'BO',
        active: false,
        aliases: [
            'Buitenlandse onderneming',
            'BO',
            'Entreprise étrangère',
            'ENT E',
            'Ausländische Gesellschaft',
            'AGes.',
        ],
    },
    {
        code: '3LNE',
        country: 'US',
        jurisdiction: 'US-NH',
        jurisdictionName: 'New Hampshire',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: '3LXM',
        country: 'US',
        jurisdiction: 'US-FL',
        jurisdictionName: 'Florida',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: '3M14',
        country: 'CA',
        jurisdiction: 'CA-NS',
        jurisdictionName: 'Nova Scotia',
        name: 'A company formed under the Companies Act may seek designation as a Community Interest Company (a hybrid structure having characteristics of both for profit and non-profit entities)',
        abbreviation: 'Community Interest Company;société d’intérêt communautaire;C.I.C.;CIC;S.I.C.;SIC',
        active: true,
        aliases: [
            'A company formed under the Companies Act may seek designation as a Community Interest Company (a hybrid structure having characteristics of both for profit and non-profit entities)',
            'Community Interest Company;société d’intérêt communautaire;C.I.C.;CIC;S.I.C.;SIC',
        ],
    },
    {
        code: '3MM4',
        country: 'US',
        jurisdiction: 'US',
        jurisdictionName: 'United States of America',
        name: 'Edge Act Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Edge Act Corporation'],
    },
    {
        code: '3MMY',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'Limited Liability Limited Partership',
        abbreviation: 'LLLP;LIMITED LIABILITY LIMITED PARTNERSHIP',
        active: true,
        aliases: ['Limited Liability Limited Partership', 'LLLP;LIMITED LIABILITY LIMITED PARTNERSHIP'],
    },
    {
        code: '3N55',
        country: 'US',
        jurisdiction: 'US-FL',
        jurisdictionName: 'Florida',
        name: 'Non-Profit Corporation',
        abbreviation: 'Corporation;Incorporated;Corp.;Inc.',
        active: true,
        aliases: ['Non-Profit Corporation', 'Corporation;Incorporated;Corp.;Inc.'],
    },
    {
        code: '3N94',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Onderneming-natuurlijk persoon',
        abbreviation: 'ONP',
        active: true,
        aliases: [
            'Onderneming-natuurlijk persoon',
            'ONP',
            'Entreprise personne physique',
            'EPP',
            'Unternehmen natürliche Person',
            'UNP',
        ],
    },
    {
        code: '3NJL',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Autre personne de droit privé inscrite au registre du commerce et des sociétés',
        abbreviation: '',
        active: true,
        aliases: ['Autre personne de droit privé inscrite au registre du commerce et des sociétés'],
    },
    {
        code: '3OK3',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SCP de notaires',
        abbreviation: '',
        active: true,
        aliases: ['SCP de notaires'],
    },
    {
        code: '3OVJ',
        country: 'CA',
        jurisdiction: 'CA-SK',
        jurisdictionName: 'Saskatchewan',
        name: 'Non-profit Corporations',
        abbreviation: 'Inc.;Corp.',
        active: true,
        aliases: ['Non-profit Corporations', 'Inc.;Corp.'],
    },
    {
        code: '3OW3',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Europsko gospodarsko interesno udruženje (skraćeno EGIU)',
        abbreviation: 'EGIU',
        active: true,
        aliases: ['Europsko gospodarsko interesno udruženje (skraćeno EGIU)', 'EGIU'],
    },
    {
        code: '3P03',
        country: 'AE',
        jurisdiction: 'AE-DU',
        jurisdictionName: 'Dubai',
        name: 'Open Ended Investment Company',
        abbreviation: '',
        active: true,
        aliases: ['Open Ended Investment Company'],
    },
    {
        code: '3P3W',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Družstevný podnik (s jedným zakladateľom)',
        abbreviation: '',
        active: true,
        aliases: ['Družstevný podnik (s jedným zakladateľom)'],
    },
    {
        code: '3Q15',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'partnership',
        abbreviation: '',
        active: true,
        aliases: ['partnership', 'société en nom collectif'],
    },
    {
        code: '3QSG',
        country: 'VC',
        jurisdiction: 'VC',
        jurisdictionName: 'Saint Vincent and the Grenadines',
        name: 'international business company - limited duration company',
        abbreviation: 'LDC;(LDC) Limited;(LDC) Ltd',
        active: true,
        aliases: [
            'international business company - limited duration company',
            'LDC;(LDC) Limited;(LDC) Ltd',
        ],
    },
    {
        code: '3QSR',
        country: 'ZA',
        jurisdiction: 'ZA',
        jurisdictionName: 'South Africa',
        name: 'pension fund',
        abbreviation: '',
        active: true,
        aliases: ['pension fund'],
    },
    {
        code: '3QX8',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Limited Liability Company',
        abbreviation: '',
        active: false,
        aliases: ['Limited Liability Company', 'Cooperative de Juvenil'],
    },
    {
        code: '3RHN',
        country: 'CO',
        jurisdiction: 'CO',
        jurisdictionName: 'Colombia',
        name: 'Sociedad Anónima',
        abbreviation: 'S.A.',
        active: true,
        aliases: ['Sociedad Anónima', 'S.A.'],
    },
    {
        code: '3RHO',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Ναυτική εταιρία',
        abbreviation: 'SC',
        active: true,
        aliases: ['Ναυτική εταιρία', 'Naftiki eteria', 'SC'],
    },
    {
        code: '3RMA',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Státní fond ze zákona',
        abbreviation: '',
        active: true,
        aliases: ['Státní fond ze zákona'],
    },
    {
        code: '3S6E',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Service départemental d'incendie et de secours (SDIS)",
        abbreviation: '',
        active: true,
        aliases: ["Service départemental d'incendie et de secours (SDIS)"],
    },
    {
        code: '3SHX',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Сдружение в обществена полза',
        abbreviation: '',
        active: true,
        aliases: ['Сдружение в обществена полза', 'Sdruzhenie v obshtestvena polza'],
    },
    {
        code: '3TOV',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Профсоюзные организации',
        abbreviation: '',
        active: true,
        aliases: ['Профсоюзные организации', 'Profsoyuznyye organizatsii'],
    },
    {
        code: '3U3Y',
        country: 'MT',
        jurisdiction: 'MT',
        jurisdictionName: 'Malta',
        name: 'foundation',
        abbreviation: '',
        active: true,
        aliases: ['foundation'],
    },
    {
        code: '3U8X',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Прочие юридические лица, являющиеся коммерческими организациями',
        abbreviation: '',
        active: true,
        aliases: [
            'Прочие юридические лица, являющиеся коммерческими организациями',
            'Prochiye yuridicheskiye litsa, yavlyayushchiyesya kommercheskimi organizatsiyami',
        ],
    },
    {
        code: '3UPJ',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Füüsilisest isikust ettevõtja',
        abbreviation: 'FIE',
        active: true,
        aliases: ['Füüsilisest isikust ettevõtja', 'FIE'],
    },
    {
        code: '3VSP',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Public Financial Institutions',
        abbreviation: '',
        active: true,
        aliases: ['Public Financial Institutions'],
    },
    {
        code: '3W7E',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Besloten Vennootschap',
        abbreviation: 'BV',
        active: true,
        aliases: [
            'Besloten Vennootschap',
            'BV',
            'Société à responsabilité limitée',
            'SRL',
            'Gesellschaft mit beschränkter Haftung',
            'GmbH',
        ],
    },
    {
        code: '3WVI',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad de Responsabilidad Limitada Microindustrial',
        abbreviation: 'S. DE R.L. MI',
        active: true,
        aliases: ['Sociedad de Responsabilidad Limitada Microindustrial', 'S. DE R.L. MI'],
    },
    {
        code: '3XTE',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SARL coopérative de consommation',
        abbreviation: '',
        active: true,
        aliases: ['SARL coopérative de consommation'],
    },
    {
        code: '3Y5C',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Besloten vennootschap naar Nederlands recht',
        abbreviation: '',
        active: true,
        aliases: ['Besloten vennootschap naar Nederlands recht'],
    },
    {
        code: '3Y5V',
        country: 'CA',
        jurisdiction: 'CA-NL',
        jurisdictionName: 'Newfoundland and Labrador',
        name: 'co-operatives',
        abbreviation: 'Co-operative;Coopérative',
        active: true,
        aliases: ['co-operatives', 'Co-operative;Coopérative'],
    },
    {
        code: '3YIH',
        country: 'IL',
        jurisdiction: 'IL',
        jurisdictionName: 'Israel',
        name: 'שׁוּתָפוּת',
        abbreviation: '',
        active: true,
        aliases: ['שׁוּתָפוּת', 'shutafut'],
    },
    {
        code: '3YUD',
        country: 'XK',
        jurisdiction: 'XK',
        jurisdictionName: 'Kosovo',
        name: 'Ndërmarrjet shoqërore nën administrimin e Agjencisë Kosovare të Privatizimit',
        abbreviation: 'NSH',
        active: true,
        aliases: [
            'Ndërmarrjet shoqërore nën administrimin e Agjencisë Kosovare të Privatizimit',
            'NSH',
        ],
    },
    {
        code: '3YUS',
        country: 'SC',
        jurisdiction: 'SC',
        jurisdictionName: 'Seychelles',
        name: 'Foundation',
        abbreviation: '',
        active: true,
        aliases: ['Foundation'],
    },
    {
        code: '3ZBR',
        country: 'DO',
        jurisdiction: 'DO',
        jurisdictionName: 'Dominican Republic',
        name: 'Sociedad Anónima',
        abbreviation: 'S. A.',
        active: true,
        aliases: ['Sociedad Anónima', 'S. A.'],
    },
    {
        code: '3ZXC',
        country: 'US',
        jurisdiction: 'US-UT',
        jurisdictionName: 'Utah',
        name: 'Limited Liability Company (LLC)',
        abbreviation: 'L.L.C.;LLC;L.C.;LC',
        active: true,
        aliases: ['Limited Liability Company (LLC)', 'L.L.C.;LLC;L.C.;LC'],
    },
    {
        code: '40A7',
        country: 'JE',
        jurisdiction: 'JE',
        jurisdictionName: 'Jersey',
        name: 'Foundation',
        abbreviation: '',
        active: true,
        aliases: ['Foundation'],
    },
    {
        code: '40DB',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Offene Handelsgesellschaft',
        abbreviation: 'OHG;OHG mbH;GmbH & Co. OHG;AG & Co. OHG',
        active: true,
        aliases: ['Offene Handelsgesellschaft', 'OHG;OHG mbH;GmbH & Co. OHG;AG & Co. OHG'],
    },
    {
        code: '40JO',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'société en commandite',
        abbreviation: '',
        active: false,
        aliases: ['société en commandite'],
    },
    {
        code: '40R4',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Forening',
        abbreviation: '',
        active: true,
        aliases: ['Forening'],
    },
    {
        code: '40SO',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Mutual Benefit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Mutual Benefit Corporation'],
    },
    {
        code: '42GN',
        country: 'CA',
        jurisdiction: 'CA-NS',
        jurisdictionName: 'Nova Scotia',
        name: 'unlimited company',
        abbreviation: 'Unlimited company;Company;Co.;Corporation;Corp.;U.L.C.;ULC',
        active: true,
        aliases: ['unlimited company', 'Unlimited company;Company;Co.;Corporation;Corp.;U.L.C.;ULC'],
    },
    {
        code: '43JO',
        country: 'FJ',
        jurisdiction: 'FJ',
        jurisdictionName: 'Fiji',
        name: 'Sole Trader',
        abbreviation: '',
        active: true,
        aliases: ['Sole Trader'],
    },
    {
        code: '43LY',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: '43MZ',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Príspevková organizácia',
        abbreviation: '',
        active: true,
        aliases: ['Príspevková organizácia'],
    },
    {
        code: '449I',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad de responsabilidad limitada',
        abbreviation: 'S. de R. L.',
        active: true,
        aliases: ['Sociedad de responsabilidad limitada', 'S. de R. L.'],
    },
    {
        code: '44CQ',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'samfallighetsförening',
        abbreviation: '',
        active: true,
        aliases: ['samfallighetsförening'],
    },
    {
        code: '44LR',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'professional corporation',
        abbreviation: 'P.C.',
        active: true,
        aliases: ['professional corporation', 'P.C.', 'corporation professionnelle', 'c.p.'],
    },
    {
        code: '456O',
        country: 'US',
        jurisdiction: 'US-VA',
        jurisdictionName: 'Virginia',
        name: 'Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Partnership'],
    },
    {
        code: '456Q',
        country: 'CA',
        jurisdiction: 'CA-ON',
        jurisdictionName: 'Ontario',
        name: 'business name/sole proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['business name/sole proprietorship'],
    },
    {
        code: '45D7',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Клон на чуждестранен търговец',
        abbreviation: '',
        active: false,
        aliases: ['Клон на чуждестранен търговец', 'Klon na chuzhdestranen targovets'],
    },
    {
        code: '468Q',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'United Kingdom Societas',
        abbreviation: 'UKS',
        active: true,
        aliases: ['United Kingdom Societas', 'UKS'],
    },
    {
        code: '46CD',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Pobočka sporiteľne',
        abbreviation: '',
        active: true,
        aliases: ['Pobočka sporiteľne'],
    },
    {
        code: '46FG',
        country: 'TH',
        jurisdiction: 'TH',
        jurisdictionName: 'Thailand',
        name: 'จังหวัด',
        abbreviation: '',
        active: true,
        aliases: ['จังหวัด', 'Cạngh̄wạd'],
    },
    {
        code: '46QC',
        country: 'AE',
        jurisdiction: 'AE-DU',
        jurisdictionName: 'Dubai',
        name: 'Public Company Limited by Shares',
        abbreviation: '',
        active: true,
        aliases: ['Public Company Limited by Shares'],
    },
    {
        code: '478A',
        country: 'MM',
        jurisdiction: 'MM',
        jurisdictionName: 'Myanmar',
        name: 'အစုအားဖြင့်တာ၀န်ကန့်သတ်ထားသည့်အများနှင့် မသက်ဆိုင်သည့်ကုမ္ပဏီ၊',
        abbreviation: '',
        active: true,
        aliases: [
            'အစုအားဖြင့်တာ၀န်ကန့်သတ်ထားသည့်အများနှင့် မသက်ဆိုင်သည့်ကုမ္ပဏီ၊',
            'a hcu aarr hpyint tar 0 n k ant saathtarr saeet a myarrnhaint masaatsine saeet kumpane',
        ],
    },
    {
        code: '47LQ',
        country: 'US',
        jurisdiction: 'US-MI',
        jurisdictionName: 'Michigan',
        name: 'Corporation (Nonprofit)',
        abbreviation: '',
        active: true,
        aliases: ['Corporation (Nonprofit)'],
    },
    {
        code: '487E',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Établissement public local d'enseignement",
        abbreviation: '',
        active: true,
        aliases: ["Établissement public local d'enseignement"],
    },
    {
        code: '487P',
        country: 'CA',
        jurisdiction: 'CA-PE',
        jurisdictionName: 'Prince Edward Island',
        name: 'corporation created by an Act of the Legislature',
        abbreviation: '',
        active: true,
        aliases: ['corporation created by an Act of the Legislature'],
    },
    {
        code: '48X2',
        country: 'PY',
        jurisdiction: 'PY',
        jurisdictionName: 'Paraguay',
        name: 'Empresa Unipersonal De Responsabilidad Limitada',
        abbreviation: 'E.I.R.L',
        active: true,
        aliases: ['Empresa Unipersonal De Responsabilidad Limitada', 'E.I.R.L'],
    },
    {
        code: '491H',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Association non déclarée',
        abbreviation: '',
        active: true,
        aliases: ['Association non déclarée'],
    },
    {
        code: '4A26',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Zájmová organizace družstev',
        abbreviation: '',
        active: true,
        aliases: ['Zájmová organizace družstev'],
    },
    {
        code: '4A3J',
        country: 'GB',
        jurisdiction: 'GB-NIR',
        jurisdictionName: 'Northern Ireland',
        name: 'Northern Ireland Company',
        abbreviation: '',
        active: true,
        aliases: ['Northern Ireland Company'],
    },
    {
        code: '4A8T',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'evropska delniška družba',
        abbreviation: 'SE',
        active: true,
        aliases: ['evropska delniška družba', 'SE'],
    },
    {
        code: '4AJY',
        country: 'MU',
        jurisdiction: 'MU',
        jurisdictionName: 'Mauritius',
        name: 'Business',
        abbreviation: '',
        active: true,
        aliases: ['Business'],
    },
    {
        code: '4B4B',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Société par actions constitué par Loi sur les sociétés de patrons de fabriques de producteurs laitiers',
        abbreviation: '',
        active: true,
        aliases: [
            'Société par actions constitué par Loi sur les sociétés de patrons de fabriques de producteurs laitiers',
        ],
    },
    {
        code: '4BEM',
        country: 'US',
        jurisdiction: 'US-OR',
        jurisdictionName: 'Oregon',
        name: 'Assumed Business Name',
        abbreviation: 'Sole Proprietor;DBA;General Partnership',
        active: true,
        aliases: ['Assumed Business Name', 'Sole Proprietor;DBA;General Partnership'],
    },
    {
        code: '4C0J',
        country: 'GG',
        jurisdiction: 'GG',
        jurisdictionName: 'Guernsey',
        name: 'protected cell company',
        abbreviation: 'PCC',
        active: true,
        aliases: ['protected cell company', 'PCC'],
    },
    {
        code: '4C5L',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Ügyvédi Iroda',
        abbreviation: '',
        active: true,
        aliases: ['Ügyvédi Iroda'],
    },
    {
        code: '4CKX',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Krajský úrad',
        abbreviation: '',
        active: true,
        aliases: ['Krajský úrad'],
    },
    {
        code: '4DZU',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Autre SARL coopérative',
        abbreviation: '',
        active: true,
        aliases: ['Autre SARL coopérative'],
    },
    {
        code: '4E5P',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Coöperatieve vennootschap met onbeperkte aansprakelijkheid met een sociaal oogmerk',
        abbreviation: 'CVOA SO',
        active: true,
        aliases: [
            'Coöperatieve vennootschap met onbeperkte aansprakelijkheid met een sociaal oogmerk',
            'CVOA SO',
            'Société coopérative à responsabilité illimitée à finalité sociale',
            'SCRI FS',
            'Genossenschaft mit unbeschränkter Haftung mit sozialer Zielsetzung',
            'GuHsZ',
        ],
    },
    {
        code: '4EP1',
        country: 'KN',
        jurisdiction: 'KN-N',
        jurisdictionName: 'Nevis',
        name: 'multiform foundation',
        abbreviation: '',
        active: true,
        aliases: ['multiform foundation'],
    },
    {
        code: '4EWZ',
        country: 'NP',
        jurisdiction: 'NP',
        jurisdictionName: 'Nepal',
        name: 'Partnership Firm',
        abbreviation: '',
        active: true,
        aliases: ['Partnership Firm', 'साझेदारी फर्म ', 'sajhedari farm '],
    },
    {
        code: '4FSX',
        country: 'US',
        jurisdiction: 'US-DE',
        jurisdictionName: 'Delaware',
        name: 'Statutory Trust',
        abbreviation: '',
        active: true,
        aliases: ['Statutory Trust'],
    },
    {
        code: '4GJI',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Private Limited by Guarantee',
        abbreviation: 'Ltd;Ltd.;Limited',
        active: true,
        aliases: ['Private Limited by Guarantee', 'Ltd;Ltd.;Limited'],
    },
    {
        code: '4GX1',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Národný výbor',
        abbreviation: '',
        active: true,
        aliases: ['Národný výbor'],
    },
    {
        code: '4H0F',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Autre établissement public local de coopération non spécialisé ou entente',
        abbreviation: '',
        active: true,
        aliases: ['Autre établissement public local de coopération non spécialisé ou entente'],
    },
    {
        code: '4H61',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Keskinäinen vakuutusyhtiö',
        abbreviation: '',
        active: true,
        aliases: ['Keskinäinen vakuutusyhtiö', 'Ömsesidigt försäkringsbolag'],
    },
    {
        code: '4H8O',
        country: 'OM',
        jurisdiction: 'OM',
        jurisdictionName: 'Oman',
        name: 'شركة المساهمة عامة',
        abbreviation: '',
        active: true,
        aliases: ['شركة المساهمة عامة', 'sharikat almusahamat eamatan'],
    },
    {
        code: '4HBI',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad cooperativa de ahorro y préstamo de capital variable',
        abbreviation: 'S.C. de A. P. de C. V.',
        active: true,
        aliases: [
            'Sociedad cooperativa de ahorro y préstamo de capital variable',
            'S.C. de A. P. de C. V.',
        ],
    },
    {
        code: '4HC4',
        country: 'US',
        jurisdiction: 'US-WV',
        jurisdictionName: 'West Virginia',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: '4HD1',
        country: 'GH',
        jurisdiction: 'GH',
        jurisdictionName: 'Ghana',
        name: 'Sole Proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['Sole Proprietorship'],
    },
    {
        code: '4HTX',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Private Fund Limited Partnership ',
        abbreviation: 'PFLP',
        active: true,
        aliases: ['Private Fund Limited Partnership ', 'PFLP'],
    },
    {
        code: '4IXL',
        country: 'BW',
        jurisdiction: 'BW',
        jurisdictionName: 'Botswana',
        name: 'Close Companies ',
        abbreviation: '',
        active: true,
        aliases: ['Close Companies '],
    },
    {
        code: '4JCS',
        country: 'US',
        jurisdiction: 'US-CA',
        jurisdictionName: 'California',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: '4JS0',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Association syndicale autorisée',
        abbreviation: '',
        active: true,
        aliases: ['Association syndicale autorisée'],
    },
    {
        code: '4L1X',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Autonoom gemeentebedrijf',
        abbreviation: '',
        active: true,
        aliases: ['Autonoom gemeentebedrijf', 'Régie communale autonome', 'Autonome Gemeinderegie'],
    },
    {
        code: '4LCX',
        country: 'PE',
        jurisdiction: 'PE',
        jurisdictionName: 'Peru',
        name: 'Empresas de Derecho Público',
        abbreviation: '',
        active: true,
        aliases: ['Empresas de Derecho Público'],
    },
    {
        code: '4LEA',
        country: 'NZ',
        jurisdiction: 'NZ',
        jurisdictionName: 'New Zealand',
        name: 'Unlimited Liability Company',
        abbreviation: 'Unltd;Ultd',
        active: true,
        aliases: ['Unlimited Liability Company', 'Unltd;Ultd'],
    },
    {
        code: '4LKE',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'County Agricultural Fair',
        abbreviation: 'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation',
        active: true,
        aliases: [
            'County Agricultural Fair',
            'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation',
        ],
    },
    {
        code: '4LKN',
        country: 'BR',
        jurisdiction: 'BR',
        jurisdictionName: 'Brazil',
        name: 'Empresa Pública',
        abbreviation: 'EP',
        active: true,
        aliases: ['Empresa Pública', 'EP'],
    },
    {
        code: '4LZW',
        country: 'US',
        jurisdiction: 'US-SD',
        jurisdictionName: 'South Dakota',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: '4M62',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'loan company',
        abbreviation: 'Loan Corporation;Loan Corp.;Loan Company',
        active: true,
        aliases: [
            'loan company',
            'Loan Corporation;Loan Corp.;Loan Company',
            'compagnie de prêt',
            'Corporation de prêt;Société de prêt;Compagnie de prêt',
        ],
    },
    {
        code: '4NMI',
        country: 'US',
        jurisdiction: 'US-RI',
        jurisdictionName: 'Rhode island',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: '4OTK',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Regionální rada regionu soudržnosti',
        abbreviation: '',
        active: true,
        aliases: ['Regionální rada regionu soudržnosti'],
    },
    {
        code: '4OYE',
        country: 'CO',
        jurisdiction: 'CO',
        jurisdictionName: 'Colombia',
        name: 'Persona natural comerciante',
        abbreviation: '',
        active: true,
        aliases: ['Persona natural comerciante'],
    },
    {
        code: '4P36',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: '4PZX',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Учреждения, созданные субъектом Российской Федерации',
        abbreviation: '',
        active: true,
        aliases: [
            'Учреждения, созданные субъектом Российской Федерации',
            'Uchrezhdeniya, sozdannyye sub"yektom Rossiyskoy Federatsii',
        ],
    },
    {
        code: '4QBB',
        country: 'PY',
        jurisdiction: 'PY',
        jurisdictionName: 'Paraguay',
        name: 'Sociedad En Comandita Simple',
        abbreviation: 'S.C',
        active: true,
        aliases: ['Sociedad En Comandita Simple', 'S.C'],
    },
    {
        code: '4QIE',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Sole Proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['Sole Proprietorship'],
    },
    {
        code: '4QRE',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Önkormányzat',
        abbreviation: '',
        active: true,
        aliases: ['Önkormányzat'],
    },
    {
        code: '4QXM',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'eenmanszaak',
        abbreviation: '',
        active: true,
        aliases: ['eenmanszaak'],
    },
    {
        code: '4RPP',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Kollektivgesellschaft mit beschränkter Haftung',
        abbreviation: '',
        active: true,
        aliases: ['Kollektivgesellschaft mit beschränkter Haftung'],
    },
    {
        code: '4RT7',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA de HLM à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA de HLM à conseil d'administration"],
    },
    {
        code: '4RXL',
        country: 'VN',
        jurisdiction: 'VN',
        jurisdictionName: 'Viet Nam',
        name: 'công ty trách nhiệm hữu hạn một thành viên',
        abbreviation: '',
        active: true,
        aliases: ['công ty trách nhiệm hữu hạn một thành viên'],
    },
    {
        code: '4S4Z',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Commanditaire vennootschap met meerdere beherende vennoten',
        abbreviation: '',
        active: true,
        aliases: ['Commanditaire vennootschap met meerdere beherende vennoten'],
    },
    {
        code: '4S57',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Caja de Ahorros',
        abbreviation: '',
        active: true,
        aliases: ['Caja de Ahorros'],
    },
    {
        code: '4SFS',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Institución Autónoma',
        abbreviation: '',
        active: true,
        aliases: ['Institución Autónoma'],
    },
    {
        code: '4SJR',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Agraría de Trasformación',
        abbreviation: 'S.A.T.',
        active: true,
        aliases: ['Sociedad Agraría de Trasformación', 'S.A.T.'],
    },
    {
        code: '4TMV',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Domestic Limited Cooperative Association',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Limited Cooperative Association'],
    },
    {
        code: '4TNX',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Profession libérale',
        abbreviation: '',
        active: false,
        aliases: ['Profession libérale'],
    },
    {
        code: '4TYO',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Публичные акционерные общества',
        abbreviation: '',
        active: true,
        aliases: ['Публичные акционерные общества', 'Publichnyye aktsionernyye obshchestva'],
    },
    {
        code: '4U9V',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Professional Limited Liabity Partnership',
        abbreviation: 'LLP;L.L.P.;PLLP;P.L.L.P',
        active: true,
        aliases: ['Professional Limited Liabity Partnership', 'LLP;L.L.P.;PLLP;P.L.L.P'],
    },
    {
        code: '4UB2',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Garanční fond obchodníků s cennými papíry',
        abbreviation: '',
        active: true,
        aliases: ['Garanční fond obchodníků s cennými papíry'],
    },
    {
        code: '4V0A',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Grupul european de interes economic',
        abbreviation: 'GEIE',
        active: true,
        aliases: ['Grupul european de interes economic', 'GEIE'],
    },
    {
        code: '4VD7',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Pôle d'équilibre territorial et rural (PETR)",
        abbreviation: '',
        active: true,
        aliases: ["Pôle d'équilibre territorial et rural (PETR)"],
    },
    {
        code: '4VH5',
        country: 'US',
        jurisdiction: 'US-NY',
        jurisdictionName: 'New York',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: '4VPM',
        country: 'AE',
        jurisdiction: 'AE-AZ',
        jurisdictionName: 'Abu Dhabi',
        name: 'Incorporated Cell',
        abbreviation: '',
        active: false,
        aliases: ['Incorporated Cell'],
    },
    {
        code: '4VTZ',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Ассоциации (союзы)',
        abbreviation: '',
        active: true,
        aliases: ['Ассоциации (союзы)', 'Assotsiatsii (soyuzy)'],
    },
    {
        code: '4WN7',
        country: 'US',
        jurisdiction: 'US-VA',
        jurisdictionName: 'Virginia',
        name: 'Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Company'],
    },
    {
        code: '4WTP',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: '4WV7',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Egyéb köztestület',
        abbreviation: '',
        active: true,
        aliases: ['Egyéb köztestület'],
    },
    {
        code: '4XMS',
        country: 'PK',
        jurisdiction: 'PK',
        jurisdictionName: 'Pakistan',
        name: 'Private Limited Company (multi member)',
        abbreviation: 'Pvt. Ltd.',
        active: true,
        aliases: ['Private Limited Company (multi member)', 'Pvt. Ltd.'],
    },
    {
        code: '4XP8',
        country: 'KY',
        jurisdiction: 'KY',
        jurisdictionName: 'Cayman Islands',
        name: 'company limited by guarantee',
        abbreviation: 'Ltd',
        active: true,
        aliases: ['company limited by guarantee', 'Ltd'],
    },
    {
        code: '4XY9',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Trust',
        abbreviation: '',
        active: false,
        aliases: ['Trust', 'Entidad Financiera Internacional (Corporación)'],
    },
    {
        code: '4Y4D',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Entidad Creada por Ley Especial',
        abbreviation: '',
        active: true,
        aliases: ['Entidad Creada por Ley Especial'],
    },
    {
        code: '4YAK',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Stálý rozhodčí soud',
        abbreviation: '',
        active: true,
        aliases: ['Stálý rozhodčí soud'],
    },
    {
        code: '4YOA',
        country: 'US',
        jurisdiction: 'US-NM',
        jurisdictionName: 'New Mexico',
        name: 'Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Company'],
    },
    {
        code: '4YUU',
        country: 'ZA',
        jurisdiction: 'ZA',
        jurisdictionName: 'South Africa',
        name: 'Close Corporation',
        abbreviation: 'CC',
        active: true,
        aliases: ['Close Corporation', 'CC'],
    },
    {
        code: '4ZBE',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Maatschap',
        abbreviation: '',
        active: true,
        aliases: ['Maatschap'],
    },
    {
        code: '4ZF3',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Valstybės įmonės',
        abbreviation: 'VI',
        active: true,
        aliases: ['Valstybės įmonės', 'VI'],
    },
    {
        code: '4ZRR',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Norskregistrert utenlandsk foretak',
        abbreviation: 'NUF',
        active: false,
        aliases: ['Norskregistrert utenlandsk foretak', 'NUF'],
    },
    {
        code: '50TD',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Statsforetak',
        abbreviation: 'SF',
        active: true,
        aliases: ['Statsforetak', 'SF'],
    },
    {
        code: '50Z9',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Société par actions constitué par Loi sur les assurances',
        abbreviation: '',
        active: true,
        aliases: ['Société par actions constitué par Loi sur les assurances'],
    },
    {
        code: '51AN',
        country: 'US',
        jurisdiction: 'US-PA',
        jurisdictionName: 'Pennsylvania',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: '51RC',
        country: 'US',
        jurisdiction: 'US-NY',
        jurisdictionName: 'New York',
        name: 'Not-for-profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Not-for-profit Corporation'],
    },
    {
        code: '51WZ',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Vereniging met beperkte rechtsbevoegdheid',
        abbreviation: '',
        active: true,
        aliases: ['Vereniging met beperkte rechtsbevoegdheid'],
    },
    {
        code: '520I',
        country: 'US',
        jurisdiction: 'US-NH',
        jurisdictionName: 'New Hampshire',
        name: 'Foundation',
        abbreviation: '',
        active: true,
        aliases: ['Foundation'],
    },
    {
        code: '528Z',
        country: 'MC',
        jurisdiction: 'MC',
        jurisdictionName: 'Monaco',
        name: 'Société en Commandite Simple',
        abbreviation: 'SCS',
        active: true,
        aliases: ['Société en Commandite Simple', 'SCS'],
    },
    {
        code: '529B',
        country: 'BR',
        jurisdiction: 'BR',
        jurisdictionName: 'Brazil',
        name: 'Sociedade em Nome Coletivo',
        abbreviation: 'S.N.C.',
        active: true,
        aliases: ['Sociedade em Nome Coletivo', 'S.N.C.'],
    },
    {
        code: '52AV',
        country: 'SX',
        jurisdiction: 'SX',
        jurisdictionName: 'Sint Maarten',
        name: 'stichting particulier fonds',
        abbreviation: 'SPF',
        active: true,
        aliases: ['stichting particulier fonds', 'SPF'],
    },
    {
        code: '52CK',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les villes minières',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur les villes minières'],
    },
    {
        code: '52TH',
        country: 'AZ',
        jurisdiction: 'AZ',
        jurisdictionName: 'Azerbaijan',
        name: 'Törəmə təsərrüfat cəmiyyəti',
        abbreviation: '',
        active: true,
        aliases: ['Törəmə təsərrüfat cəmiyyəti'],
    },
    {
        code: '52U0',
        country: 'US',
        jurisdiction: 'US-OH',
        jurisdictionName: 'Ohio',
        name: 'Limited Liability Partnership',
        abbreviation: 'registered limited liability partnership;registered partnership having limited liability;limited liability partnership;R.L.L.P.;P.L.L.;L.L.P.;RLLP',
        active: true,
        aliases: [
            'Limited Liability Partnership',
            'registered limited liability partnership;registered partnership having limited liability;limited liability partnership;R.L.L.P.;P.L.L.;L.L.P.;RLLP',
        ],
    },
    {
        code: '530K',
        country: 'US',
        jurisdiction: 'US-ID',
        jurisdictionName: 'Idaho',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP'],
    },
    {
        code: '53DC',
        country: 'US',
        jurisdiction: 'US-ME',
        jurisdictionName: 'Maine',
        name: 'Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Company'],
    },
    {
        code: '53QF',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Treuhänderschaft',
        abbreviation: '',
        active: true,
        aliases: ['Treuhänderschaft'],
    },
    {
        code: '54AL',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Ετερόρρυθμη Εταιρία',
        abbreviation: 'EE',
        active: true,
        aliases: ['Ετερόρρυθμη Εταιρία', 'Eterórithmi Etería', 'EE'],
    },
    {
        code: '54M6',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'besloten vennootschap met beperkte aansprakelijkheid',
        abbreviation: 'BV;bv;B.V.;b.v.',
        active: true,
        aliases: ['besloten vennootschap met beperkte aansprakelijkheid', 'BV;bv;B.V.;b.v.'],
    },
    {
        code: '54P7',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Europabolag',
        abbreviation: 'SE;S.E.',
        active: true,
        aliases: ['Europabolag', 'SE;S.E.'],
    },
    {
        code: '54SK',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'Friendly Society',
        abbreviation: '',
        active: true,
        aliases: ['Friendly Society'],
    },
    {
        code: '54WI',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Investment company with fixed capital',
        abbreviation: '',
        active: true,
        aliases: [
            'Investment company with fixed capital',
            "Société d'investissement à capital fixe (SICAF)",
            'Investmentgesellschaft mit festem Kapital (SICAF)',
            'Società di investimento a capitale fisso (SICAF)',
        ],
    },
    {
        code: '55MA',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Cwmni Cyfyngedig Cyhoeddus',
        abbreviation: 'CCC;C.C.C.',
        active: false,
        aliases: ['Cwmni Cyfyngedig Cyhoeddus', 'CCC;C.C.C.'],
    },
    {
        code: '56KZ',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'agricultural fair association',
        abbreviation: '',
        active: false,
        aliases: ['agricultural fair association'],
    },
    {
        code: '56MU',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Aandeelhouder bestuurde Besloten vennootschap',
        abbreviation: '',
        active: true,
        aliases: ['Aandeelhouder bestuurde Besloten vennootschap'],
    },
    {
        code: '56NA',
        country: 'GH',
        jurisdiction: 'GH',
        jurisdictionName: 'Ghana',
        name: 'Private Limited By Share',
        abbreviation: '',
        active: true,
        aliases: ['Private Limited By Share'],
    },
    {
        code: '57V7',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Private Unlimited',
        abbreviation: '',
        active: true,
        aliases: ['Private Unlimited'],
    },
    {
        code: '58N0',
        country: 'US',
        jurisdiction: 'US-MI',
        jurisdictionName: 'Michigan',
        name: 'Limited Partnership',
        abbreviation: 'Limited Partnership',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: '599X',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Fonde og andre selvejende institutioner',
        abbreviation: '',
        active: true,
        aliases: ['Fonde og andre selvejende institutioner'],
    },
    {
        code: '59F9',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Groupement foncier agricole',
        abbreviation: '',
        active: true,
        aliases: ['Groupement foncier agricole'],
    },
    {
        code: '59T2',
        country: 'CA',
        jurisdiction: 'CA',
        jurisdictionName: 'Canada',
        name: 'board of trade',
        abbreviation: '',
        active: true,
        aliases: ['board of trade', 'chambre de commerce'],
    },
    {
        code: '5A9K',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '军队事业单位',
        abbreviation: '',
        active: true,
        aliases: ['军队事业单位', 'jun dui shi ye dan wei'],
    },
    {
        code: '5AAO',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: '5ABK',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Unlimited with Shares (2006 Act)',
        abbreviation: '',
        active: true,
        aliases: ['Unlimited with Shares (2006 Act)'],
    },
    {
        code: '5AE9',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Builidng and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Builidng and Loan Association'],
    },
    {
        code: '5AJO',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Caisse d'Épargne et de Prévoyance",
        abbreviation: '',
        active: true,
        aliases: ["Caisse d'Épargne et de Prévoyance"],
    },
    {
        code: '5AM3',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Zastupiteľské orgány iných štátov',
        abbreviation: 'Zastup.org.iných štátov',
        active: true,
        aliases: ['Zastupiteľské orgány iných štátov', 'Zastup.org.iných štátov'],
    },
    {
        code: '5AP3',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Pobočná mezinárodní organizace zaměstnavatelů',
        abbreviation: '',
        active: true,
        aliases: ['Pobočná mezinárodní organizace zaměstnavatelů'],
    },
    {
        code: '5AWN',
        country: 'AR',
        jurisdiction: 'AR',
        jurisdictionName: 'Argentina',
        name: 'Sociedad del Estado',
        abbreviation: 'S.E',
        active: true,
        aliases: ['Sociedad del Estado', 'S.E'],
    },
    {
        code: '5AWU',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Asociación civil',
        abbreviation: 'A. C.',
        active: true,
        aliases: ['Asociación civil', 'A. C.'],
    },
    {
        code: '5AX8',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'Designated Activity Company Limited by Guarantee',
        abbreviation: 'DAC – (limited by guarantee)',
        active: true,
        aliases: [
            'Designated Activity Company Limited by Guarantee',
            'DAC – (limited by guarantee)',
            'Cuideachta Ghníomhaíochta Ainmnithe',
            'cga',
        ],
    },
    {
        code: '5BEZ',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Special legal form',
        abbreviation: '',
        active: true,
        aliases: [
            'Special legal form',
            'Forme juridique particulière',
            'Besondere Rechtsform',
            'Natura giuridica particolare',
        ],
    },
    {
        code: '5BY2',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Europos kooperatinės bendrovės',
        abbreviation: 'EKB',
        active: true,
        aliases: ['Europos kooperatinės bendrovės', 'EKB'],
    },
    {
        code: '5CIE',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Advokatų profesinės bendrijos',
        abbreviation: 'APB',
        active: true,
        aliases: ['Advokatų profesinės bendrijos', 'APB'],
    },
    {
        code: '5D9I',
        country: 'CA',
        jurisdiction: 'CA-SK',
        jurisdictionName: 'Saskatchewan',
        name: 'Limited Liabilty Partnerships',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liabilty Partnerships'],
    },
    {
        code: '5DBJ',
        country: 'US',
        jurisdiction: 'US-SC',
        jurisdictionName: 'South Carolina',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: '5DS0',
        country: 'US',
        jurisdiction: 'US-FL',
        jurisdictionName: 'Florida',
        name: 'Limited Partnership',
        abbreviation: 'Limited; L.P.; Ltd.',
        active: true,
        aliases: ['Limited Partnership', 'Limited; L.P.; Ltd.'],
    },
    {
        code: '5DWL',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Association momentanée',
        abbreviation: 'AM',
        active: false,
        aliases: ['Association momentanée', 'AM'],
    },
    {
        code: '5E0K',
        country: 'US',
        jurisdiction: 'US-RI',
        jurisdictionName: 'Rhode Island',
        name: 'Benefit Professional Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Benefit Professional Corporation'],
    },
    {
        code: '5EEA',
        country: 'CA',
        jurisdiction: 'CA-SK',
        jurisdictionName: 'Saskatchewan',
        name: 'Corporations formed by an Act of the Saskatchewan legislature',
        abbreviation: '',
        active: true,
        aliases: ['Corporations formed by an Act of the Saskatchewan legislature'],
    },
    {
        code: '5EKE',
        country: 'VC',
        jurisdiction: 'VC',
        jurisdictionName: 'Saint Vincent and the Grenadines',
        name: 'international business company - company limited by shares',
        abbreviation: 'Ltd;Corp;Inc',
        active: true,
        aliases: ['international business company - company limited by shares', 'Ltd;Corp;Inc'],
    },
    {
        code: '5F76',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'cechy i izby rzemieślnicze, izby gospodarcze',
        abbreviation: '',
        active: true,
        aliases: ['cechy i izby rzemieślnicze, izby gospodarcze'],
    },
    {
        code: '5F9K',
        country: 'BJ',
        jurisdiction: 'BJ',
        jurisdictionName: 'Benin',
        name: "Groupement d'intérêt Économique",
        abbreviation: 'GIE',
        active: true,
        aliases: ["Groupement d'intérêt Économique", 'GIE'],
    },
    {
        code: '5FRT',
        country: 'GB',
        jurisdiction: 'GB-NIR',
        jurisdictionName: 'Northern Ireland',
        name: 'Other Type of Company (in Northern Ireland)',
        abbreviation: '',
        active: true,
        aliases: ['Other Type of Company (in Northern Ireland)'],
    },
    {
        code: '5GGB',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Société anonyme',
        abbreviation: 'SA ',
        active: true,
        aliases: ['Société anonyme', 'SA '],
    },
    {
        code: '5GXA',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '村级集体经济组织',
        abbreviation: '',
        active: true,
        aliases: ['村级集体经济组织', 'cun ji ji ti jing ji zu zhi'],
    },
    {
        code: '5H68',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Commerçant',
        abbreviation: '',
        active: false,
        aliases: ['Commerçant'],
    },
    {
        code: '5HQ4',
        country: 'US',
        jurisdiction: 'US-CA',
        jurisdictionName: 'California',
        name: 'Limited Partnership',
        abbreviation: 'LP;L.P.;LLLP;L.L.L.P.',
        active: true,
        aliases: ['Limited Partnership', 'LP;L.P.;LLLP;L.L.L.P.'],
    },
    {
        code: '5I7B',
        country: 'GU',
        jurisdiction: 'GU',
        jurisdictionName: 'Guam',
        name: 'limited liability company',
        abbreviation: '',
        active: true,
        aliases: ['limited liability company'],
    },
    {
        code: '5IL6',
        country: 'BB',
        jurisdiction: 'BB',
        jurisdictionName: 'Barbados',
        name: 'sole proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['sole proprietorship'],
    },
    {
        code: '5J5Y',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Verejná obchodná spoločnosť',
        abbreviation: 'Ver. obch. spol.',
        active: true,
        aliases: ['Verejná obchodná spoločnosť', 'Ver. obch. spol.'],
    },
    {
        code: '5JAL',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Insurance Company',
        abbreviation: 'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation',
        active: true,
        aliases: ['Insurance Company', 'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation'],
    },
    {
        code: '5K0Q',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Établissement public local social et médico-social',
        abbreviation: '',
        active: true,
        aliases: ['Établissement public local social et médico-social'],
    },
    {
        code: '5K70',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima bursátil de capital variable, casa de bolsa',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima bursátil de capital variable, casa de bolsa'],
    },
    {
        code: '5KRB',
        country: 'US',
        jurisdiction: 'US-ME',
        jurisdictionName: 'Maine',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: '5KU5',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Veřejná obchodní společnost',
        abbreviation: '',
        active: true,
        aliases: ['Veřejná obchodní společnost'],
    },
    {
        code: '5KVH',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Cooperativa de 2º Grau',
        abbreviation: '',
        active: true,
        aliases: ['Cooperativa de 2º Grau'],
    },
    {
        code: '5KVT',
        country: 'TZ',
        jurisdiction: 'TZ',
        jurisdictionName: 'Tanzania',
        name: 'Unlimited company',
        abbreviation: '',
        active: true,
        aliases: ['Unlimited company'],
    },
    {
        code: '5LXY',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Verska skupnost in podobne verske organizacije',
        abbreviation: '',
        active: true,
        aliases: ['Verska skupnost in podobne verske organizacije'],
    },
    {
        code: '5MNR',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'Professional Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Professional Corporation'],
    },
    {
        code: '5MRP',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Close Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Close Corporation'],
    },
    {
        code: '5MVV',
        country: 'JP',
        jurisdiction: 'JP',
        jurisdictionName: 'Japan',
        name: '合資会社',
        abbreviation: '資',
        active: true,
        aliases: ['合資会社', 'gousigaisya', '資'],
    },
    {
        code: '5NCK',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Organizație non-guvernamentală',
        abbreviation: 'ONG',
        active: true,
        aliases: ['Organizație non-guvernamentală', 'ONG'],
    },
    {
        code: '5ODO',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Ente Diritto Pubblico',
        abbreviation: '',
        active: true,
        aliases: ['Ente Diritto Pubblico'],
    },
    {
        code: '5OET',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Foreign Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Limited Liability Company'],
    },
    {
        code: '5OKA',
        country: 'KW',
        jurisdiction: 'KW',
        jurisdictionName: 'Kuwait',
        name: 'شركة المساھمة المقفلة',
        abbreviation: '',
        active: true,
        aliases: ['شركة المساھمة المقفلة', 'Sharikat almusaھmat almuqfala'],
    },
    {
        code: '5ONY',
        country: 'CA',
        jurisdiction: 'CA-MB',
        jurisdictionName: 'Manitoba',
        name: 'Religious Society',
        abbreviation: 'a religious society;communauté religieuse',
        active: true,
        aliases: ['Religious Society', 'a religious society;communauté religieuse'],
    },
    {
        code: '5OZV',
        country: 'CW',
        jurisdiction: 'CW',
        jurisdictionName: 'Curaçao',
        name: 'Eenmanszaak',
        abbreviation: '',
        active: true,
        aliases: ['Eenmanszaak'],
    },
    {
        code: '5Q1W',
        country: 'IL',
        jurisdiction: 'IL',
        jurisdictionName: 'Israel',
        name: 'עוסק מורשה',
        abbreviation: '',
        active: true,
        aliases: ['עוסק מורשה', 'Osek Murshe'],
    },
    {
        code: '5Q66',
        country: 'VU',
        jurisdiction: 'VU',
        jurisdictionName: 'Vanuatu',
        name: 'International Company',
        abbreviation: '',
        active: true,
        aliases: ['International Company'],
    },
    {
        code: '5QS7',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Iværksætterselskab',
        abbreviation: 'IVS',
        active: true,
        aliases: ['Iværksætterselskab', 'IVS'],
    },
    {
        code: '5RCH',
        country: 'KR',
        jurisdiction: 'KR',
        jurisdictionName: 'Korea (Republic of)',
        name: '주식회사',
        abbreviation: '㈜',
        active: true,
        aliases: ['주식회사', 'JuSikHoeSa', '㈜', '(Ju)'],
    },
    {
        code: '5RDO',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Anonima',
        abbreviation: 'S.A.',
        active: true,
        aliases: ['Sociedad Anonima', 'S.A.'],
    },
    {
        code: '5RRE',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'Corporation (professional)',
        abbreviation: 'PSC;PROFESSIONAL SERVICE CORPORATION',
        active: true,
        aliases: ['Corporation (professional)', 'PSC;PROFESSIONAL SERVICE CORPORATION'],
    },
    {
        code: '5SGE',
        country: 'CA',
        jurisdiction: 'CA-PE',
        jurisdictionName: 'Prince Edward Island',
        name: 'condominium corporation',
        abbreviation: '',
        active: true,
        aliases: ['condominium corporation'],
    },
    {
        code: '5SGV',
        country: 'SG',
        jurisdiction: 'SG',
        jurisdictionName: 'Singapore',
        name: 'Limited Liability Partnership',
        abbreviation: 'limited liability partnership;LLP;Limited Liability Partnership',
        active: true,
        aliases: [
            'Limited Liability Partnership',
            'limited liability partnership;LLP;Limited Liability Partnership',
        ],
    },
    {
        code: '5T3H',
        country: 'TR',
        jurisdiction: 'TR',
        jurisdictionName: 'Türkiye',
        name: 'Fonlar',
        abbreviation: '',
        active: true,
        aliases: ['Fonlar'],
    },
    {
        code: '5T3W',
        country: 'BO',
        jurisdiction: 'BO',
        jurisdictionName: 'Bolivia (Plurinational State of)',
        name: 'Sociedad Anónima',
        abbreviation: 'S.A.',
        active: true,
        aliases: ['Sociedad Anónima', 'S.A.'],
    },
    {
        code: '5TA8',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Šeimynos',
        abbreviation: 'S',
        active: true,
        aliases: ['Šeimynos', 'S'],
    },
    {
        code: '5ULL',
        country: 'LV',
        jurisdiction: 'LV',
        jurisdictionName: 'Latvia',
        name: 'Eiropas Ekonomisko interešu grupa',
        abbreviation: 'EEIG',
        active: true,
        aliases: ['Eiropas Ekonomisko interešu grupa', 'EEIG'],
    },
    {
        code: '5V5S',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Kommune',
        abbreviation: '',
        active: true,
        aliases: ['Kommune'],
    },
    {
        code: '5VCF',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SA à directoire (s.a.i.)',
        abbreviation: '',
        active: true,
        aliases: ['SA à directoire (s.a.i.)'],
    },
    {
        code: '5VMR',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Адвокаты, учредившие адвокатский кабинет',
        abbreviation: '',
        active: true,
        aliases: [
            'Адвокаты, учредившие адвокатский кабинет',
            'Advokaty, uchredivshiye advokatskiy kabinet',
        ],
    },
    {
        code: '5WI2',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Eläkesäätiö',
        abbreviation: '',
        active: true,
        aliases: ['Eläkesäätiö', 'Pensionsstiftelse'],
    },
    {
        code: '5WU6',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'Europees Economisch Samenwerkingsverband',
        abbreviation: 'EESV;E.E.S.V.',
        active: true,
        aliases: ['Europees Economisch Samenwerkingsverband', 'EESV;E.E.S.V.'],
    },
    {
        code: '5WWO',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Privatstiftung',
        abbreviation: '',
        active: true,
        aliases: ['Privatstiftung'],
    },
    {
        code: '5Y1L',
        country: 'US',
        jurisdiction: 'US-CA',
        jurisdictionName: 'California',
        name: 'Industrial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Industrial Bank'],
    },
    {
        code: '5Y4V',
        country: 'US',
        jurisdiction: 'US-VA',
        jurisdictionName: 'Virginia',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: '5YBL',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Stavovská organizácia - profesná komora',
        abbreviation: '',
        active: true,
        aliases: ['Stavovská organizácia - profesná komora'],
    },
    {
        code: '5Z8W',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Samostatne hospodáriaci roľník zapísaný v obchodnom registri',
        abbreviation: 'SHR roľník v OR',
        active: true,
        aliases: ['Samostatne hospodáriaci roľník zapísaný v obchodnom registri', 'SHR roľník v OR'],
    },
    {
        code: '5ZTZ',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Fylkeskommunalt foretak',
        abbreviation: 'FKF',
        active: true,
        aliases: ['Fylkeskommunalt foretak', 'FKF'],
    },
    {
        code: '60BG',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'organy władzy, administracji rządowej, kontroli państwowej i ochrony prawa oraz sądy i trybunały',
        abbreviation: '',
        active: true,
        aliases: [
            'organy władzy, administracji rządowej, kontroli państwowej i ochrony prawa oraz sądy i trybunały',
        ],
    },
    {
        code: '60IF',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Private Unlimited/No Share Capital',
        abbreviation: '',
        active: true,
        aliases: ['Private Unlimited/No Share Capital'],
    },
    {
        code: '60MF',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'Alberta trust corporation',
        abbreviation: '',
        active: true,
        aliases: ['Alberta trust corporation'],
    },
    {
        code: '61WE',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Institution de retraite supplémentaire',
        abbreviation: '',
        active: true,
        aliases: ['Institution de retraite supplémentaire'],
    },
    {
        code: '629I',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'spółka jawna',
        abbreviation: 's.j.;Sp.j.',
        active: true,
        aliases: ['spółka jawna', 's.j.;Sp.j.'],
    },
    {
        code: '62L3',
        country: 'US',
        jurisdiction: 'US-NV',
        jurisdictionName: 'Nevada',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP'],
    },
    {
        code: '62VJ',
        country: 'US',
        jurisdiction: 'US',
        jurisdictionName: 'United States of America',
        name: 'National Bank',
        abbreviation: 'N.A.',
        active: true,
        aliases: ['National Bank', 'N.A.'],
    },
    {
        code: '62Y3',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'vennootschap onder firma',
        abbreviation: 'VOF;vof;V.O.F.;v.o.f.',
        active: true,
        aliases: ['vennootschap onder firma', 'VOF;vof;V.O.F.;v.o.f.'],
    },
    {
        code: '634M',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Gruppo Europeo Di Interesse Economico',
        abbreviation: 'GEIE',
        active: true,
        aliases: ['Gruppo Europeo Di Interesse Economico', 'GEIE'],
    },
    {
        code: '639V',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Non Profit Domesticated Foreign Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Non Profit Domesticated Foreign Corporation'],
    },
    {
        code: '63KS',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Unternehmergesellschaft',
        abbreviation: 'GmbH UG;UG (haftungsbeschränkt)',
        active: true,
        aliases: ['Unternehmergesellschaft', 'GmbH UG;UG (haftungsbeschränkt)'],
    },
    {
        code: '63P9',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Société en commandite simple',
        abbreviation: 'SECS',
        active: true,
        aliases: ['Société en commandite simple', 'SECS'],
    },
    {
        code: '649C',
        country: 'PE',
        jurisdiction: 'PE',
        jurisdictionName: 'Peru',
        name: 'Sociedad Civil de Responsabilidad Limitada',
        abbreviation: 'S. Civil de R. L.',
        active: true,
        aliases: ['Sociedad Civil de Responsabilidad Limitada', 'S. Civil de R. L.'],
    },
    {
        code: '64HG',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Professional Limited Liability Company',
        abbreviation: 'LLC;L.L.C.;PLLC;P.L.L.C.',
        active: true,
        aliases: ['Professional Limited Liability Company', 'LLC;L.L.C.;PLLC;P.L.L.C.'],
    },
    {
        code: '64XG',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'association coopérative',
        abbreviation: 'limitée;ltée',
        active: false,
        aliases: ['association coopérative', 'limitée;ltée'],
    },
    {
        code: '65B6',
        country: 'US',
        jurisdiction: 'US-UT',
        jurisdictionName: 'Utah',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: '66JQ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Syndicat de copropriété',
        abbreviation: '',
        active: true,
        aliases: ['Syndicat de copropriété'],
    },
    {
        code: '66T3',
        country: 'SX',
        jurisdiction: 'SX',
        jurisdictionName: 'Sint Maarten',
        name: 'eenmanszaak',
        abbreviation: '',
        active: true,
        aliases: ['eenmanszaak'],
    },
    {
        code: '672E',
        country: 'US',
        jurisdiction: 'US-MA',
        jurisdictionName: 'Massachusetts',
        name: 'Cooperative Corporation',
        abbreviation: 'Company;Corporation;Corp.;Incorporated;Inc.',
        active: true,
        aliases: ['Cooperative Corporation', 'Company;Corporation;Corp.;Incorporated;Inc.'],
    },
    {
        code: '68J6',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Association agricole',
        abbreviation: 'AA',
        active: true,
        aliases: ['Association agricole', 'AA'],
    },
    {
        code: '68PD',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Representação Permanente',
        abbreviation: '',
        active: false,
        aliases: ['Representação Permanente'],
    },
    {
        code: '69H1',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Europäische Genossenschaft (SCE)',
        abbreviation: 'SCE',
        active: true,
        aliases: ['Europäische Genossenschaft (SCE)', 'SCE'],
    },
    {
        code: '6B39',
        country: 'JO',
        jurisdiction: 'JO',
        jurisdictionName: 'Jordan',
        name: 'الشركة ذات المسؤولية المحدودة',
        abbreviation: 'ذ.م.م',
        active: true,
        aliases: ['الشركة ذات المسؤولية المحدودة', 'alsharika zat almasuwliat almahduda', 'ذ.م.م'],
    },
    {
        code: '6CHY',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'société par actions simplifiée',
        abbreviation: 'SAS',
        active: true,
        aliases: ['société par actions simplifiée', 'SAS'],
    },
    {
        code: '6CJJ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SCP de géomètres experts',
        abbreviation: '',
        active: true,
        aliases: ['SCP de géomètres experts'],
    },
    {
        code: '6CQN',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Akciová společnost',
        abbreviation: '',
        active: true,
        aliases: ['Akciová společnost'],
    },
    {
        code: '6D9L',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Svěřenský fond',
        abbreviation: '',
        active: true,
        aliases: ['Svěřenský fond'],
    },
    {
        code: '6DE6',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Close Corporation',
        abbreviation: '',
        active: false,
        aliases: ['Close Corporation', 'Centro Bancario Internacional (Corporación)'],
    },
    {
        code: '6DGX',
        country: 'BE',
        jurisdiction: 'BE-VLG',
        jurisdictionName: 'Flemish Region',
        name: 'Dienstverlenende vereniging (Vlaams Gewest)',
        abbreviation: '',
        active: true,
        aliases: [
            'Dienstverlenende vereniging (Vlaams Gewest)',
            'Association prestataire de services (Région flamande)',
            'Dienstleistungsvereinigung (Flämische Region)',
        ],
    },
    {
        code: '6DVA',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Foreign Non-Profit Limited Liability Company',
        abbreviation: 'limited liability company;L.L.C.;L.C.',
        active: true,
        aliases: [
            'Foreign Non-Profit Limited Liability Company',
            'limited liability company;L.L.C.;L.C.',
        ],
    },
    {
        code: '6DYI',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société de Participations Financières de Profession Libérale Société à responsabilité limitée (SPFPL SARL)',
        abbreviation: '',
        active: true,
        aliases: [
            'Société de Participations Financières de Profession Libérale Société à responsabilité limitée (SPFPL SARL)',
        ],
    },
    {
        code: '6E4G',
        country: 'US',
        jurisdiction: 'US-MI',
        jurisdictionName: 'Michigan',
        name: 'Limited Liability Partnership',
        abbreviation: 'L.L.P.;LLP;Limited Liability Partnership',
        active: true,
        aliases: ['Limited Liability Partnership', 'L.L.P.;LLP;Limited Liability Partnership'],
    },
    {
        code: '6EDK',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Domestic Non-Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Non-Profit Corporation'],
    },
    {
        code: '6EH6',
        country: 'VG',
        jurisdiction: 'VG',
        jurisdictionName: 'Virgin Islands (British)',
        name: 'company limited by shares',
        abbreviation: 'Ltd;Corp;Inc;S.A.',
        active: true,
        aliases: ['company limited by shares', 'Ltd;Corp;Inc;S.A.'],
    },
    {
        code: '6ETM',
        country: 'HN',
        jurisdiction: 'HN',
        jurisdictionName: 'Honduras',
        name: 'Sociedad en Comandita por Acciones.',
        abbreviation: 'S. en C.',
        active: true,
        aliases: [
            'Sociedad en Comandita por Acciones.',
            'Sociedad en Comandita por Acciones',
            'S. en C.',
        ],
    },
    {
        code: '6EYT',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad por acciones simplificada de capital variable',
        abbreviation: 'S. A. S. de C. V.',
        active: true,
        aliases: ['Sociedad por acciones simplificada de capital variable', 'S. A. S. de C. V.'],
    },
    {
        code: '6FAI',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Státní podnik',
        abbreviation: '',
        active: true,
        aliases: ['Státní podnik'],
    },
    {
        code: '6GEC',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'Limited Liability Company (professional)',
        abbreviation: 'PLLC;PROFESSONAL LIMITED LIABILITY COMPANY',
        active: true,
        aliases: [
            'Limited Liability Company (professional)',
            'PLLC;PROFESSONAL LIMITED LIABILITY COMPANY',
        ],
    },
    {
        code: '6H83',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Сельскохозяйственные потребительские животноводческие кооперативы',
        abbreviation: '',
        active: true,
        aliases: [
            'Сельскохозяйственные потребительские животноводческие кооперативы',
            "Sel'skokhozyaystvennyye potrebitel'skiye zhivotnovodcheskiye kooperativy",
        ],
    },
    {
        code: '6H9F',
        country: 'AE',
        jurisdiction: 'AE-AZ',
        jurisdictionName: 'Abu Dhabi',
        name: 'Open Ended Investment Company',
        abbreviation: '',
        active: false,
        aliases: ['Open Ended Investment Company'],
    },
    {
        code: '6HT0',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Limited Partnership'],
    },
    {
        code: '6I0P',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Hooneühistu',
        abbreviation: 'HÜ',
        active: true,
        aliases: ['Hooneühistu', 'HÜ'],
    },
    {
        code: '6I75',
        country: 'US',
        jurisdiction: 'US-MA',
        jurisdictionName: 'Massachusetts',
        name: 'Professional Corporation',
        abbreviation: 'company;co.;corporation;corp.;incorporated;or inc.;limited or ltd.;professional corporation or p.c.',
        active: true,
        aliases: [
            'Professional Corporation',
            'company;co.;corporation;corp.;incorporated;or inc.;limited or ltd.;professional corporation or p.c.',
        ],
    },
    {
        code: '6ICB',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Foreign Corp Professional Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Corp Professional Corporation'],
    },
    {
        code: '6IIE',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA coopérative (d'intérêt) maritime à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA coopérative (d'intérêt) maritime à conseil d'administration"],
    },
    {
        code: '6IIM',
        country: 'US',
        jurisdiction: 'US-GA',
        jurisdictionName: 'Georgia',
        name: 'Limited Liability Company',
        abbreviation: 'L.L.C.;LLC;L.C.;LC',
        active: true,
        aliases: ['Limited Liability Company', 'L.L.C.;LLC;L.C.;LC'],
    },
    {
        code: '6IK8',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Entidade Empresarial Intermunicipal',
        abbreviation: '',
        active: true,
        aliases: ['Entidade Empresarial Intermunicipal'],
    },
    {
        code: '6JCE',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'General Partnership',
        abbreviation: 'GP;G.P.',
        active: true,
        aliases: ['General Partnership', 'GP;G.P.'],
    },
    {
        code: '6JDN',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Profesinės sąjungos ir jų susivienijimai',
        abbreviation: 'PS',
        active: true,
        aliases: ['Profesinės sąjungos ir jų susivienijimai', 'PS'],
    },
    {
        code: '6JHZ',
        country: 'AZ',
        jurisdiction: 'AZ',
        jurisdictionName: 'Azerbaijan',
        name: 'Məhdud məsuliyyətli cəmiyyəti',
        abbreviation: 'MMC',
        active: true,
        aliases: ['Məhdud məsuliyyətli cəmiyyəti', 'MMC'],
    },
    {
        code: '6JS5',
        country: 'SM',
        jurisdiction: 'SM',
        jurisdictionName: 'San Marino',
        name: 'Società a responsabilità limitata',
        abbreviation: 'SRL',
        active: true,
        aliases: ['Società a responsabilità limitata', 'SRL'],
    },
    {
        code: '6KC0',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '宗教院校',
        abbreviation: '',
        active: true,
        aliases: ['宗教院校', 'zong jiao yuan xiao'],
    },
    {
        code: '6KSC',
        country: 'JO',
        jurisdiction: 'JO',
        jurisdictionName: 'Jordan',
        name: 'شركة التوصية البسيطة',
        abbreviation: 'توصية بسيطة',
        active: true,
        aliases: ['شركة التوصية البسيطة', 'sharikat altawsia albasita', 'توصية بسيطة'],
    },
    {
        code: '6KWU',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Société d'exercice libéral en commandite par actions",
        abbreviation: '',
        active: true,
        aliases: ["Société d'exercice libéral en commandite par actions"],
    },
    {
        code: '6L6P',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Fundo',
        abbreviation: '',
        active: true,
        aliases: ['Fundo'],
    },
    {
        code: '6LI8',
        country: 'TW',
        jurisdiction: 'TW',
        jurisdictionName: 'Taiwan (Province of China)',
        name: '營利社團法人',
        abbreviation: '',
        active: true,
        aliases: ['營利社團法人', 'Yíng lì shè tuán fǎ rén'],
    },
    {
        code: '6LUM',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'główny oddział zagranicznego zakładu reasekuracji',
        abbreviation: '',
        active: true,
        aliases: ['główny oddział zagranicznego zakładu reasekuracji'],
    },
    {
        code: '6M6O',
        country: 'US',
        jurisdiction: 'US-NH',
        jurisdictionName: 'New Hampshire',
        name: 'Business Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Business Corporation'],
    },
    {
        code: '6M6Z',
        country: 'MU',
        jurisdiction: 'MU',
        jurisdictionName: 'Mauritius',
        name: 'Public Company Limited By Guarantee',
        abbreviation: 'PC;PLC;LTD;LTEE',
        active: true,
        aliases: ['Public Company Limited By Guarantee', 'PC;PLC;LTD;LTEE'],
    },
    {
        code: '6M8Y',
        country: 'AR',
        jurisdiction: 'AR',
        jurisdictionName: 'Argentina',
        name: 'Sociedad Colectiva',
        abbreviation: 'Soc.Col.',
        active: true,
        aliases: ['Sociedad Colectiva', 'Soc.Col.'],
    },
    {
        code: '6MB6',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Limited Liability Limited Partnership',
        abbreviation: 'L.L.L.P.;LLLP',
        active: true,
        aliases: ['Limited Liability Limited Partnership', 'L.L.L.P.;LLLP'],
    },
    {
        code: '6MPY',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Ustanova',
        abbreviation: '',
        active: true,
        aliases: ['Ustanova'],
    },
    {
        code: '6MS4',
        country: 'SC',
        jurisdiction: 'SC',
        jurisdictionName: 'Seychelles',
        name: 'Company Limited by Shares',
        abbreviation: '',
        active: true,
        aliases: ['Company Limited by Shares'],
    },
    {
        code: '6NI8',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Railroad',
        abbreviation: 'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation',
        active: true,
        aliases: ['Railroad', 'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation'],
    },
    {
        code: '6NSC',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '律师执业机构',
        abbreviation: '',
        active: true,
        aliases: ['律师执业机构', 'lv shi zhi ye ji gou'],
    },
    {
        code: '6OGF',
        country: 'US',
        jurisdiction: 'US-UT',
        jurisdictionName: 'Utah',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: '6OMW',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Organizační jednotka občanského sdružení',
        abbreviation: '',
        active: true,
        aliases: ['Organizační jednotka občanského sdružení'],
    },
    {
        code: '6OYI',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'zrzeszenie',
        abbreviation: '',
        active: true,
        aliases: ['zrzeszenie'],
    },
    {
        code: '6PEQ',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Paikallisyhteisö',
        abbreviation: '',
        active: true,
        aliases: ['Paikallisyhteisö', 'Lokalsamfund'],
    },
    {
        code: '6Q6D',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Pravna osoba Katoličke Crkve',
        abbreviation: '',
        active: true,
        aliases: ['Pravna osoba Katoličke Crkve'],
    },
    {
        code: '6QCE',
        country: 'VI',
        jurisdiction: 'VI',
        jurisdictionName: 'Virgin Islands (U.S.)',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: '6QQB',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Aktiengesellschaft',
        abbreviation: 'AG',
        active: true,
        aliases: ['Aktiengesellschaft', 'AG'],
    },
    {
        code: '6R72',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Samostatne hospodáriaci roľník nezapísaný v obchodnom registri',
        abbreviation: 'SHR roľník',
        active: true,
        aliases: ['Samostatne hospodáriaci roľník nezapísaný v obchodnom registri', 'SHR roľník'],
    },
    {
        code: '6R7O',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: '6RD2',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Agencije I druge samostalne pravne osobe s javnim ovlastima',
        abbreviation: '',
        active: true,
        aliases: ['Agencije I druge samostalne pravne osobe s javnim ovlastima'],
    },
    {
        code: '6RUE',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Groupement européen d'intérêt économique (GEIE)",
        abbreviation: 'GEIE',
        active: true,
        aliases: ["Groupement européen d'intérêt économique (GEIE)", 'GEIE'],
    },
    {
        code: '6RZK',
        country: 'US',
        jurisdiction: 'US-MI',
        jurisdictionName: 'Michigan',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: '6S32',
        country: 'US',
        jurisdiction: 'US-WI',
        jurisdictionName: 'Wisconsin',
        name: 'Business Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.',
        active: true,
        aliases: ['Business Corporation', 'corp.;inc.;co.;ltd.'],
    },
    {
        code: '6SYJ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SA de HLM à directoire',
        abbreviation: '',
        active: true,
        aliases: ['SA de HLM à directoire'],
    },
    {
        code: '6TGS',
        country: 'US',
        jurisdiction: 'US-SD',
        jurisdictionName: 'South Dakota',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: '6TPA',
        country: 'PA',
        jurisdiction: 'PA',
        jurisdictionName: 'Panama',
        name: 'Sociedad Anónima',
        abbreviation: 'S.A.',
        active: true,
        aliases: ['Sociedad Anónima', 'S.A.'],
    },
    {
        code: '6TPE',
        country: 'EC',
        jurisdiction: 'EC',
        jurisdictionName: 'Ecuador',
        name: 'Compañía en nombre colectivo',
        abbreviation: 'CNCOL',
        active: true,
        aliases: ['Compañía en nombre colectivo', 'CNCOL'],
    },
    {
        code: '6TRA',
        country: 'CA',
        jurisdiction: 'CA',
        jurisdictionName: 'Canada',
        name: 'corporations enacted by an Act of Parliament',
        abbreviation: '',
        active: true,
        aliases: [
            'corporations enacted by an Act of Parliament',
            'corporation constituée par une loi du Parlement',
        ],
    },
    {
        code: '6U2Q',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'condominium corporation',
        abbreviation: '',
        active: true,
        aliases: ['condominium corporation', 'association condominiale'],
    },
    {
        code: '6UED',
        country: 'PG',
        jurisdiction: 'PG',
        jurisdictionName: 'Papua New Guinea',
        name: 'Local Company',
        abbreviation: '',
        active: true,
        aliases: ['Local Company'],
    },
    {
        code: '6UPM',
        country: 'RS',
        jurisdiction: 'RS',
        jurisdictionName: 'Serbia',
        name: 'Задружни савез',
        abbreviation: '',
        active: true,
        aliases: ['Задружни савез', 'Zadružni savez'],
    },
    {
        code: '6UYJ',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: '6VCW',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: '6W6X',
        country: 'AU',
        jurisdiction: 'AU',
        jurisdictionName: 'Australia',
        name: 'Co-operative',
        abbreviation: 'Co-operative Limited;Cooperative Limited;Co-op Limited;Coop Limited;Co-operative Ltd.;Cooperative Ltd.;Co-opLtd.;Coop Ltd.;Co-operative;Cooperative;Co-op;Coop',
        active: true,
        aliases: [
            'Co-operative',
            'Co-operative Limited;Cooperative Limited;Co-op Limited;Coop Limited;Co-operative Ltd.;Cooperative Ltd.;Co-opLtd.;Coop Ltd.;Co-operative;Cooperative;Co-op;Coop',
        ],
    },
    {
        code: '6WQ5',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Organismos de investimento colectivo em valores mobiliários',
        abbreviation: 'UCITS',
        active: true,
        aliases: ['Organismos de investimento colectivo em valores mobiliários', 'UCITS'],
    },
    {
        code: '6X4Q',
        country: 'BJ',
        jurisdiction: 'BJ',
        jurisdictionName: 'Benin',
        name: 'Société en Commandite Simple',
        abbreviation: 'SCS',
        active: true,
        aliases: ['Société en Commandite Simple', 'SCS'],
    },
    {
        code: '6XB7',
        country: 'KY',
        jurisdiction: 'KY',
        jurisdictionName: 'Cayman Islands',
        name: 'exempted limited partnership',
        abbreviation: 'ELP',
        active: true,
        aliases: ['exempted limited partnership', 'ELP'],
    },
    {
        code: '6YHU',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA d'intérêt collectif agricole (SICA) à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA d'intérêt collectif agricole (SICA) à conseil d'administration"],
    },
    {
        code: '6Z8B',
        country: 'CO',
        jurisdiction: 'CO',
        jurisdictionName: 'Colombia',
        name: 'Sucursal de Sociedad Extranjera',
        abbreviation: '',
        active: true,
        aliases: ['Sucursal de Sociedad Extranjera'],
    },
    {
        code: '6ZAR',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Partnership'],
    },
    {
        code: '6ZCO',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur la formation et la qualification professionnelles de la main-d’œuvre',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur la formation et la qualification professionnelles de la main-d’œuvre',
        ],
    },
    {
        code: '702U',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les Chevaliers de Colomb de la province de Québec',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur les Chevaliers de Colomb de la province de Québec',
        ],
    },
    {
        code: '70BS',
        country: 'BO',
        jurisdiction: 'BO',
        jurisdictionName: 'Bolivia (Plurinational State of)',
        name: 'Empresa Estatal',
        abbreviation: '',
        active: true,
        aliases: ['Empresa Estatal'],
    },
    {
        code: '70EO',
        country: 'AE',
        jurisdiction: 'AE-DU',
        jurisdictionName: 'Dubai',
        name: 'Private Company Limited by Shares',
        abbreviation: '',
        active: true,
        aliases: ['Private Company Limited by Shares'],
    },
    {
        code: '70GJ',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Government Organization',
        abbreviation: '',
        active: true,
        aliases: ['Government Organization'],
    },
    {
        code: '70NZ',
        country: 'CK',
        jurisdiction: 'CK',
        jurisdictionName: 'Cook Islands',
        name: 'International Company',
        abbreviation: '',
        active: true,
        aliases: ['International Company'],
    },
    {
        code: '70X0',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Fondazione Impresa',
        abbreviation: '',
        active: true,
        aliases: ['Fondazione Impresa'],
    },
    {
        code: '71ZI',
        country: 'US',
        jurisdiction: 'US-WY',
        jurisdictionName: 'Wyoming',
        name: 'Registered Limited Liability Partnership',
        abbreviation: 'RLLP, LLP, R.L.L.P., L.L.P.',
        active: true,
        aliases: ['Registered Limited Liability Partnership', 'RLLP, LLP, R.L.L.P., L.L.P.'],
    },
    {
        code: '724Q',
        country: 'US',
        jurisdiction: 'US-WV',
        jurisdictionName: 'West Virginia',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: '72BT',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Organismo Internacional',
        abbreviation: '',
        active: true,
        aliases: ['Organismo Internacional'],
    },
    {
        code: '72CA',
        country: 'US',
        jurisdiction: 'US-FL',
        jurisdictionName: 'Florida',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: '72I6',
        country: 'ID',
        jurisdiction: 'ID',
        jurisdictionName: 'Indonesia',
        name: 'Koperasi',
        abbreviation: '',
        active: true,
        aliases: ['Koperasi'],
    },
    {
        code: '72R7',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Stredná škola',
        abbreviation: '',
        active: true,
        aliases: ['Stredná škola'],
    },
    {
        code: '73C0',
        country: 'PE',
        jurisdiction: 'PE',
        jurisdictionName: 'Peru',
        name: 'Sociedad Comercial de Responsabilidad Limitada',
        abbreviation: 'SRL',
        active: true,
        aliases: ['Sociedad Comercial de Responsabilidad Limitada', 'SRL'],
    },
    {
        code: '73MQ',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Samosprávny kraj (úrad samosprávneho kraja)',
        abbreviation: '',
        active: true,
        aliases: ['Samosprávny kraj (úrad samosprávneho kraja)'],
    },
    {
        code: '73PZ',
        country: 'RS',
        jurisdiction: 'RS',
        jurisdictionName: 'Serbia',
        name: 'Командитно друштво',
        abbreviation: 'к.д;кд',
        active: true,
        aliases: ['Командитно друштво', 'Komanditno društvo', 'к.д;кд', 'k.d.;kd'],
    },
    {
        code: '747U',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Společnost komanditní na akcie',
        abbreviation: '',
        active: true,
        aliases: ['Společnost komanditní na akcie'],
    },
    {
        code: '74HH',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SCP de vétérinaires',
        abbreviation: '',
        active: true,
        aliases: ['SCP de vétérinaires'],
    },
    {
        code: '74LJ',
        country: 'US',
        jurisdiction: 'US-DC',
        jurisdictionName: 'District of Columbia',
        name: 'Limited Partnership (including Limited Liability Limited Partnership)',
        abbreviation: 'L.L.L.P.;LLLP;R.L.L.L.P.;RLLLP',
        active: true,
        aliases: [
            'Limited Partnership (including Limited Liability Limited Partnership)',
            'L.L.L.P.;LLLP;R.L.L.L.P.;RLLLP',
        ],
    },
    {
        code: '74W6',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Státní příspěvková organizace ostatní',
        abbreviation: '',
        active: true,
        aliases: ['Státní příspěvková organizace ostatní'],
    },
    {
        code: '752Q',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Euroopa äriühing',
        abbreviation: 'SE',
        active: true,
        aliases: ['Euroopa äriühing', 'SE'],
    },
    {
        code: '75WC',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Fondazione',
        abbreviation: '',
        active: true,
        aliases: ['Fondazione'],
    },
    {
        code: '75XK',
        country: 'GG',
        jurisdiction: 'GG',
        jurisdictionName: 'Guernsey',
        name: 'limited partnership (without separate legal personality)',
        abbreviation: '',
        active: true,
        aliases: ['limited partnership (without separate legal personality)'],
    },
    {
        code: '760X',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Muu yhdistys',
        abbreviation: '',
        active: true,
        aliases: ['Muu yhdistys', 'Annan förening'],
    },
    {
        code: '761Z',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad de producción rural de responsabilidad limitada de capital variable',
        abbreviation: 'S.P.R. DE R.L. DE C.V.',
        active: true,
        aliases: [
            'Sociedad de producción rural de responsabilidad limitada de capital variable',
            'S.P.R. DE R.L. DE C.V.',
        ],
    },
    {
        code: '76ME',
        country: 'PH',
        jurisdiction: 'PH',
        jurisdictionName: 'Philippines',
        name: 'nonstock corporation',
        abbreviation: '',
        active: true,
        aliases: ['nonstock corporation'],
    },
    {
        code: '771I',
        country: 'BW',
        jurisdiction: 'BW',
        jurisdictionName: 'Botswana',
        name: 'Private Limited Liability Companies',
        abbreviation: '',
        active: true,
        aliases: ['Private Limited Liability Companies'],
    },
    {
        code: '776G',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad de producción rural de responsabilidad ilimitada',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad de producción rural de responsabilidad ilimitada'],
    },
    {
        code: '784B',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, sociedad controladora',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima de capital variable, sociedad controladora'],
    },
    {
        code: '78H5',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'Corporation (Nonprofit)',
        abbreviation: '',
        active: true,
        aliases: ['Corporation (Nonprofit)'],
    },
    {
        code: '78PB',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Professional Corporation',
        abbreviation: 'Professional Corporation;Professional Service Corporation;PC;PSC',
        active: true,
        aliases: [
            'Professional Corporation',
            'Professional Corporation;Professional Service Corporation;PC;PSC',
        ],
    },
    {
        code: '78QF',
        country: 'BS',
        jurisdiction: 'BS',
        jurisdictionName: 'Bahamas',
        name: 'Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Partnership'],
    },
    {
        code: '78SG',
        country: 'PY',
        jurisdiction: 'PY',
        jurisdictionName: 'Paraguay',
        name: 'Empresa Unipersonal',
        abbreviation: 'E.U',
        active: true,
        aliases: ['Empresa Unipersonal', 'E.U'],
    },
    {
        code: '78VH',
        country: 'SA',
        jurisdiction: 'SA',
        jurisdictionName: 'Saudi Arabia',
        name: 'شركة مساهمة',
        abbreviation: '',
        active: true,
        aliases: ['شركة مساهمة', 'sharikat musahama'],
    },
    {
        code: '78VN',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Asociación',
        abbreviation: '',
        active: true,
        aliases: ['Asociación'],
    },
    {
        code: '790T',
        country: 'CA',
        jurisdiction: 'CA-PE',
        jurisdictionName: 'Prince Edward Island',
        name: 'non-profit company',
        abbreviation: 'Ltd.;Inc.;Corp.;Ltée',
        active: true,
        aliases: ['non-profit company', 'Ltd.;Inc.;Corp.;Ltée'],
    },
    {
        code: '79H0',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Nicht eingetragener Verein',
        abbreviation: '',
        active: true,
        aliases: ['Nicht eingetragener Verein'],
    },
    {
        code: '7AJT',
        country: 'US',
        jurisdiction: 'US-UT',
        jurisdictionName: 'Utah',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: '7AS7',
        country: 'BM',
        jurisdiction: 'BM',
        jurisdictionName: 'Bermuda',
        name: 'Exempted Companies Limited by Shares',
        abbreviation: '',
        active: true,
        aliases: ['Exempted Companies Limited by Shares'],
    },
    {
        code: '7AWY',
        country: 'FJ',
        jurisdiction: 'FJ',
        jurisdictionName: 'Fiji',
        name: 'Public Limited Company',
        abbreviation: '',
        active: true,
        aliases: ['Public Limited Company'],
    },
    {
        code: '7B9H',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Societate cooperativă',
        abbreviation: '',
        active: true,
        aliases: ['Societate cooperativă'],
    },
    {
        code: '7BQ5',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Non Stock Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Non Stock Corporation'],
    },
    {
        code: '7CAL',
        country: 'KW',
        jurisdiction: 'KW',
        jurisdictionName: 'Kuwait',
        name: 'شركة المساهمة العامة',
        abbreviation: '',
        active: true,
        aliases: ['شركة المساهمة العامة', 'Sharikat musahima'],
    },
    {
        code: '7CDL',
        country: 'US',
        jurisdiction: 'US-CA',
        jurisdictionName: 'California',
        name: 'For-Profit Corporation Close',
        abbreviation: 'Corporation;Company;Incorporated;Incorporation;Limited;Corp;Co;Inc;Ltd',
        active: true,
        aliases: [
            'For-Profit Corporation Close',
            'Corporation;Company;Incorporated;Incorporation;Limited;Corp;Co;Inc;Ltd',
        ],
    },
    {
        code: '7CKN',
        country: 'SM',
        jurisdiction: 'SM',
        jurisdictionName: 'San Marino',
        name: 'Società in nome collettivo',
        abbreviation: 'SNC',
        active: true,
        aliases: ['Società in nome collettivo', 'SNC'],
    },
    {
        code: '7EG2',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Fondy',
        abbreviation: '',
        active: true,
        aliases: ['Fondy'],
    },
    {
        code: '7F5B',
        country: 'US',
        jurisdiction: 'US-MO',
        jurisdictionName: 'Missouri',
        name: 'Limited Liability Company',
        abbreviation: 'L.L.C.;LLC;L.C.;LC',
        active: true,
        aliases: ['Limited Liability Company', 'L.L.C.;LLC;L.C.;LC'],
    },
    {
        code: '7FCS',
        country: 'BB',
        jurisdiction: 'BB',
        jurisdictionName: 'Barbados',
        name: 'partnership',
        abbreviation: '',
        active: true,
        aliases: ['partnership'],
    },
    {
        code: '7G15',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad Nacional de Crédito',
        abbreviation: 'S.N.C.',
        active: true,
        aliases: ['Sociedad Nacional de Crédito', 'S.N.C.'],
    },
    {
        code: '7G8G',
        country: 'US',
        jurisdiction: 'US-MA',
        jurisdictionName: 'Massachusetts',
        name: 'Cooperative Bank',
        abbreviation: '',
        active: true,
        aliases: ['Cooperative Bank'],
    },
    {
        code: '7GMS',
        country: 'US',
        jurisdiction: 'US-NM',
        jurisdictionName: 'New Mexico',
        name: 'Cooperative Association',
        abbreviation: '',
        active: true,
        aliases: ['Cooperative Association'],
    },
    {
        code: '7GTR',
        country: 'US',
        jurisdiction: 'US-AK',
        jurisdictionName: 'Alaska',
        name: 'Public Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Public Corporation'],
    },
    {
        code: '7H0X',
        country: 'US',
        jurisdiction: 'US-UT',
        jurisdictionName: 'Utah',
        name: 'Limited Liability Partnership',
        abbreviation: 'RLLP, LLP, R.L.L.P., L.L.P.',
        active: true,
        aliases: ['Limited Liability Partnership', 'RLLP, LLP, R.L.L.P., L.L.P.'],
    },
    {
        code: '7H63',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad civil',
        abbreviation: 'S. C.',
        active: true,
        aliases: ['Sociedad civil', 'S. C.'],
    },
    {
        code: '7HCE',
        country: 'BM',
        jurisdiction: 'BM',
        jurisdictionName: 'Bermuda',
        name: 'Exempted LLC',
        abbreviation: '',
        active: true,
        aliases: ['Exempted LLC'],
    },
    {
        code: '7HY7',
        country: 'US',
        jurisdiction: 'US-NJ',
        jurisdictionName: 'New Jersey',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP'],
    },
    {
        code: '7IKZ',
        country: 'CA',
        jurisdiction: 'CA-SK',
        jurisdictionName: 'Saskatchewan',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: '7IYW',
        country: 'PK',
        jurisdiction: 'PK',
        jurisdictionName: 'Pakistan',
        name: 'Company Limited by Guarantee (having share capital)',
        abbreviation: '(Guarantee) Ltd.',
        active: true,
        aliases: ['Company Limited by Guarantee (having share capital)', '(Guarantee) Ltd.'],
    },
    {
        code: '7J3S',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Wirtschaftlicher Verein',
        abbreviation: '',
        active: true,
        aliases: ['Wirtschaftlicher Verein'],
    },
    {
        code: '7JAI',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Special Employee Owned Corporation',
        abbreviation: '',
        active: false,
        aliases: ['Special Employee Owned Corporation', 'Empressa Municipal'],
    },
    {
        code: '7K6U',
        country: 'US',
        jurisdiction: 'US-NV',
        jurisdictionName: 'Nevada',
        name: 'Limited Liability Partnership',
        abbreviation: 'L.L.P.;LLP',
        active: true,
        aliases: ['Limited Liability Partnership', 'L.L.P.;LLP'],
    },
    {
        code: '7L83',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Unión ganadera regional especializada',
        abbreviation: '',
        active: true,
        aliases: ['Unión ganadera regional especializada'],
    },
    {
        code: '7MGJ',
        country: 'BM',
        jurisdiction: 'BM',
        jurisdictionName: 'Bermuda',
        name: 'Exempted Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Exempted Limited Partnership'],
    },
    {
        code: '7MNN',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Public sector institution',
        abbreviation: 'Pub. Sec. inst.',
        active: true,
        aliases: [
            'Public sector institution',
            'Pub. Sec. inst.',
            'Institut de droit public',
            'Inst. droit public',
            'Institut des öffentlichen Rechts',
            'Inst. öff. Recht',
            'Istituti di diritto pubblico',
            'Ist. dir. pubblico',
        ],
    },
    {
        code: '7O89',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Európske družstvo',
        abbreviation: 'SCE',
        active: true,
        aliases: ['Európske družstvo', 'SCE'],
    },
    {
        code: '7O94',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Groupement forestier',
        abbreviation: '',
        active: true,
        aliases: ['Groupement forestier'],
    },
    {
        code: '7OS8',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Congressional Chartered Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Congressional Chartered Corporation'],
    },
    {
        code: '7OYN',
        country: 'MY',
        jurisdiction: 'MY',
        jurisdictionName: 'Malaysia',
        name: 'Public Limited Company',
        abbreviation: 'Bhd;Ltd',
        active: true,
        aliases: ['Public Limited Company', 'Bhd;Ltd', 'Berhad'],
    },
    {
        code: '7OZQ',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Zájmové sdružení',
        abbreviation: '',
        active: true,
        aliases: ['Zájmové sdružení'],
    },
    {
        code: '7P8Y',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'limited partnership',
        abbreviation: 'LP',
        active: true,
        aliases: ['limited partnership', 'LP', 'société en commandite'],
    },
    {
        code: '7PC4',
        country: 'NP',
        jurisdiction: 'NP',
        jurisdictionName: 'Nepal',
        name: 'Public Company',
        abbreviation: 'Limited; Ltd.',
        active: true,
        aliases: ['Public Company', 'Limited; Ltd.', 'पब्लिक कम्पनी ', 'pablik kampani', 'Limited; Li'],
    },
    {
        code: '7PKK',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad en comandita simple de capital variable',
        abbreviation: 'S. en C. de C. V.',
        active: true,
        aliases: ['Sociedad en comandita simple de capital variable', 'S. en C. de C. V.'],
    },
    {
        code: '7QEH',
        country: 'SC',
        jurisdiction: 'SC',
        jurisdictionName: 'Seychelles',
        name: 'International Business Company - Company Limited by Shares',
        abbreviation: 'IBC',
        active: true,
        aliases: ['International Business Company - Company Limited by Shares', 'IBC'],
    },
    {
        code: '7QKB',
        country: 'US',
        jurisdiction: 'US-AK',
        jurisdictionName: 'Alaska',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: '7QQ0',
        country: 'JP',
        jurisdiction: 'JP',
        jurisdictionName: 'Japan',
        name: '合同会社',
        abbreviation: '合',
        active: true,
        aliases: ['合同会社', 'goudougaisya', '合'],
    },
    {
        code: '7QSE',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Zastúpenie zahraničnej právnickej osoby',
        abbreviation: 'Zastúp.zahr.práv.osoby',
        active: false,
        aliases: ['Zastúpenie zahraničnej právnickej osoby', 'Zastúp.zahr.práv.osoby'],
    },
    {
        code: '7QV2',
        country: 'US',
        jurisdiction: 'US-SC',
        jurisdictionName: 'South Carolina',
        name: 'Business Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Business Corporation'],
    },
    {
        code: '7QWA',
        country: 'TZ',
        jurisdiction: 'TZ',
        jurisdictionName: 'Tanzania',
        name: 'Private Limited Company',
        abbreviation: 'LTD; LLC',
        active: true,
        aliases: ['Private Limited Company', 'LTD; LLC'],
    },
    {
        code: '7RLC',
        country: 'US',
        jurisdiction: 'US-RI',
        jurisdictionName: 'Rhode Island',
        name: 'Limited Liability Partnership',
        abbreviation: 'L.L.P.;LLP',
        active: true,
        aliases: ['Limited Liability Partnership', 'L.L.P.;LLP'],
    },
    {
        code: '7RRP',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Aktiengesellschaft',
        abbreviation: 'AG',
        active: true,
        aliases: ['Aktiengesellschaft', 'AG'],
    },
    {
        code: '7RZH',
        country: 'JE',
        jurisdiction: 'JE',
        jurisdictionName: 'Jersey',
        name: 'Limited Liability Partnership',
        abbreviation: 'LLP;L.L.P.;limited liability partnership;Limited Liability Partnership',
        active: true,
        aliases: [
            'Limited Liability Partnership',
            'LLP;L.L.P.;limited liability partnership;Limited Liability Partnership',
        ],
    },
    {
        code: '7SIZ',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Mutuelle',
        abbreviation: '',
        active: true,
        aliases: ['Mutuelle'],
    },
    {
        code: '7SJP',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Europees economisch samenwerkingsverband',
        abbreviation: 'EESV',
        active: true,
        aliases: [
            'Europees economisch samenwerkingsverband',
            'EESV',
            "Groupement européen d'intérêt économique",
            'GEIE',
            'Europäische wirtschaftliche Interessenvereinigung',
            'EWIV',
        ],
    },
    {
        code: '7SZH',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Autre groupement de droit privé non doté de la personnalité morale',
        abbreviation: '',
        active: false,
        aliases: ['Autre groupement de droit privé non doté de la personnalité morale'],
    },
    {
        code: '7T6S',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Sociedad Legal Minera',
        abbreviation: 'SLM',
        active: true,
        aliases: ['Sociedad Legal Minera', 'SLM'],
    },
    {
        code: '7T8N',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Charitable Incorporated Organisation',
        abbreviation: '',
        active: true,
        aliases: ['Charitable Incorporated Organisation'],
    },
    {
        code: '7TJ1',
        country: 'US',
        jurisdiction: 'US-TN',
        jurisdictionName: 'Tennessee',
        name: 'General Partnership',
        abbreviation: '',
        active: true,
        aliases: ['General Partnership'],
    },
    {
        code: '7TPC',
        country: 'AU',
        jurisdiction: 'AU',
        jurisdictionName: 'Australia',
        name: 'Trust',
        abbreviation: '',
        active: true,
        aliases: ['Trust'],
    },
    {
        code: '7U4R',
        country: 'GI',
        jurisdiction: 'GI',
        jurisdictionName: 'Gibraltar',
        name: 'European Economic Interest Groupings',
        abbreviation: 'E.E.I.G',
        active: true,
        aliases: ['European Economic Interest Groupings', 'E.E.I.G'],
    },
    {
        code: '7U8O',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedades de Inversion Inmobiliaria',
        abbreviation: 'S.I.I.',
        active: true,
        aliases: ['Sociedades de Inversion Inmobiliaria', 'S.I.I.'],
    },
    {
        code: '7U8S',
        country: 'US',
        jurisdiction: 'US-KS',
        jurisdictionName: 'Kansas',
        name: 'General Partnership',
        abbreviation: '',
        active: true,
        aliases: ['General Partnership'],
    },
    {
        code: '7UHA',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Collectivité et territoire d'Outre Mer",
        abbreviation: '',
        active: true,
        aliases: ["Collectivité et territoire d'Outre Mer"],
    },
    {
        code: '7VK5',
        country: 'US',
        jurisdiction: 'US-OH',
        jurisdictionName: 'Ohio',
        name: 'Corporation (Nonprofit)',
        abbreviation: '',
        active: true,
        aliases: ['Corporation (Nonprofit)'],
    },
    {
        code: '7VKC',
        country: 'CA',
        jurisdiction: 'CA-ON',
        jurisdictionName: 'Ontario',
        name: 'Condominium Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Condominium Corporation'],
    },
    {
        code: '7VVZ',
        country: 'GB',
        jurisdiction: 'GB-NIR',
        jurisdictionName: 'Northern Ireland',
        name: 'Co-operative Society (Northern Ireland)',
        abbreviation: 'Co-op',
        active: true,
        aliases: ['Co-operative Society (Northern Ireland)', 'Co-op'],
    },
    {
        code: '7W53',
        country: 'US',
        jurisdiction: 'US-CT',
        jurisdictionName: 'Connecticut',
        name: 'Nonstock Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonstock Corporation'],
    },
    {
        code: '7W9B',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Organizații cooperatiste de credit și casele centrale ale acestora',
        abbreviation: '',
        active: true,
        aliases: ['Organizații cooperatiste de credit și casele centrale ale acestora'],
    },
    {
        code: '7WL9',
        country: 'WS',
        jurisdiction: 'WS',
        jurisdictionName: 'Samoa',
        name: 'Public limited company',
        abbreviation: '',
        active: true,
        aliases: ['Public limited company'],
    },
    {
        code: '7WQO',
        country: 'US',
        jurisdiction: 'US-MS',
        jurisdictionName: 'Mississippi',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: '7WRN',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Interessentskab',
        abbreviation: 'I/S',
        active: true,
        aliases: ['Interessentskab', 'I/S'],
    },
    {
        code: '7XPF',
        country: 'US',
        jurisdiction: 'US-IA',
        jurisdictionName: 'Iowa',
        name: 'Limited Liability Company',
        abbreviation: 'L.L.C.;LLC;L.C.;LC',
        active: true,
        aliases: ['Limited Liability Company', 'L.L.C.;LLC;L.C.;LC'],
    },
    {
        code: '7XPP',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Fundo de Investimento Alternativo',
        abbreviation: 'AIF',
        active: true,
        aliases: ['Fundo de Investimento Alternativo', 'AIF'],
    },
    {
        code: '7XUS',
        country: 'SC',
        jurisdiction: 'SC',
        jurisdictionName: 'Seychelles',
        name: 'Special License Company',
        abbreviation: 'CSL',
        active: true,
        aliases: ['Special License Company', 'CSL'],
    },
    {
        code: '7XZL',
        country: 'CA',
        jurisdiction: 'CA-SK',
        jurisdictionName: 'Saskatchewan',
        name: 'New Generation Co-operatives',
        abbreviation: 'co-op. ltd.',
        active: true,
        aliases: ['New Generation Co-operatives', 'co-op. ltd.'],
    },
    {
        code: '7Z3M',
        country: 'KN',
        jurisdiction: 'KN-N',
        jurisdictionName: 'Nevis',
        name: 'public company',
        abbreviation: '',
        active: true,
        aliases: ['public company'],
    },
    {
        code: '7ZMX',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Asociación Gremial',
        abbreviation: 'A.G.',
        active: true,
        aliases: ['Asociación Gremial', 'A.G.'],
    },
    {
        code: '7ZU4',
        country: 'JM',
        jurisdiction: 'JM',
        jurisdictionName: 'Jamaica',
        name: 'collective investment scheme company',
        abbreviation: '',
        active: true,
        aliases: ['collective investment scheme company'],
    },
    {
        code: '814Y',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Société en participation',
        abbreviation: '',
        active: true,
        aliases: ['Société en participation'],
    },
    {
        code: '81G5',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Société en commandite par actions',
        abbreviation: 'SECA',
        active: true,
        aliases: ['Société en commandite par actions', 'SECA'],
    },
    {
        code: '81KA',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Akcinės bendrovės',
        abbreviation: 'AB',
        active: true,
        aliases: ['Akcinės bendrovės', 'AB'],
    },
    {
        code: '81WV',
        country: 'US',
        jurisdiction: 'US-CO',
        jurisdictionName: 'Colorado',
        name: 'Limited Cooperative Association',
        abbreviation: 'L.C.A.;LCA',
        active: true,
        aliases: ['Limited Cooperative Association', 'L.C.A.;LCA'],
    },
    {
        code: '81YI',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'International Financial Entity (LLC)',
        abbreviation: '',
        active: false,
        aliases: ['International Financial Entity (LLC)', 'Cooperative de Trabajadores'],
    },
    {
        code: '828X',
        country: 'US',
        jurisdiction: 'US-TX',
        jurisdictionName: 'Texas',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: '82QO',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Service déconcentré de l'État à compétence (inter) départementale",
        abbreviation: '',
        active: true,
        aliases: ["Service déconcentré de l'État à compétence (inter) départementale"],
    },
    {
        code: '84DD',
        country: 'BZ',
        jurisdiction: 'BZ',
        jurisdictionName: 'Belize',
        name: 'International Business Company',
        abbreviation: '',
        active: true,
        aliases: ['International Business Company'],
    },
    {
        code: '84J8',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Státní hospodářská organizace řízená okresním úřadem',
        abbreviation: '',
        active: true,
        aliases: ['Státní hospodářská organizace řízená okresním úřadem'],
    },
    {
        code: '85EC',
        country: 'CA',
        jurisdiction: 'CA-NT',
        jurisdictionName: 'Northwest Territories',
        name: 'Limited Liability partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability partnership'],
    },
    {
        code: '85K5',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Reprezentanta',
        abbreviation: '',
        active: true,
        aliases: ['Reprezentanta'],
    },
    {
        code: '85PM',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'Europejskie Zgrupowanie Interesów Gospodarczych',
        abbreviation: 'EZIG',
        active: true,
        aliases: ['Europejskie Zgrupowanie Interesów Gospodarczych', 'EZIG'],
    },
    {
        code: '85VD',
        country: 'HK',
        jurisdiction: 'HK',
        jurisdictionName: 'Hong Kong',
        name: '註冊受託人',
        abbreviation: '',
        active: true,
        aliases: ['註冊受託人', 'zhu ce shou tuo ren', 'Registered trustee'],
    },
    {
        code: '85YQ',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'Statutory Trust',
        abbreviation: 'limited;LTD',
        active: true,
        aliases: ['Statutory Trust', 'limited;LTD'],
    },
    {
        code: '876R',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Egyéb egyesület',
        abbreviation: '',
        active: true,
        aliases: ['Egyéb egyesület'],
    },
    {
        code: '876U',
        country: 'CA',
        jurisdiction: 'CA-NS',
        jurisdictionName: 'Nova Scotia',
        name: 'Credit Unions',
        abbreviation: 'credit union;caisse populaire;Limited;Limitée;Ltd.;Ltée',
        active: true,
        aliases: ['Credit Unions', 'credit union;caisse populaire;Limited;Limitée;Ltd.;Ltée'],
    },
    {
        code: '87N3',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Consumer Cooperative',
        abbreviation: '',
        active: true,
        aliases: ['Consumer Cooperative', 'Cooperativa de Consumo'],
    },
    {
        code: '87OW',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: "Personne morale sans but lucratif par Loi sur les collèges d'enseignement général et professionnel",
        abbreviation: '',
        active: true,
        aliases: [
            "Personne morale sans but lucratif par Loi sur les collèges d'enseignement général et professionnel",
        ],
    },
    {
        code: '87VO',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Safer anonyme à directoire',
        abbreviation: '',
        active: true,
        aliases: ['Safer anonyme à directoire'],
    },
    {
        code: '883O',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Sivuliike',
        abbreviation: '',
        active: false,
        aliases: ['Sivuliike', 'Filial'],
    },
    {
        code: '88OX',
        country: 'PK',
        jurisdiction: 'PK',
        jurisdictionName: 'Pakistan',
        name: 'Private Limited Company (single member)',
        abbreviation: 'SMC',
        active: true,
        aliases: ['Private Limited Company (single member)', 'SMC'],
    },
    {
        code: '88TX',
        country: 'RS',
        jurisdiction: 'RS',
        jurisdictionName: 'Serbia',
        name: 'Друштвено предузеће',
        abbreviation: 'ДП',
        active: true,
        aliases: ['Друштвено предузеће', 'Društveno preduzeće', 'ДП', 'DP'],
    },
    {
        code: '88XU',
        country: 'US',
        jurisdiction: 'US-MI',
        jurisdictionName: 'Michigan',
        name: 'Sole proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['Sole proprietorship'],
    },
    {
        code: '8AGD',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Unión ganadera regional general',
        abbreviation: '',
        active: true,
        aliases: ['Unión ganadera regional general'],
    },
    {
        code: '8APW',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Domestic Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Limited Liability Company'],
    },
    {
        code: '8AXV',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società Consortile Cooperativa a Responsabilità Limitata',
        abbreviation: '',
        active: true,
        aliases: ['Società Consortile Cooperativa a Responsabilità Limitata'],
    },
    {
        code: '8B9A',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Жилищные или жилищно-строительные кооперативы',
        abbreviation: '',
        active: true,
        aliases: [
            'Жилищные или жилищно-строительные кооперативы',
            "Zhilishchnyye ili zhilishchno-stroitel'nyye kooperativy",
        ],
    },
    {
        code: '8BL9',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Ευρωπαϊκή Δημόσια Εταιρεία Περιορισμένης Ευθύνης',
        abbreviation: '',
        active: true,
        aliases: [
            'Ευρωπαϊκή Δημόσια Εταιρεία Περιορισμένης Ευθύνης',
            'Evropaiki Dimosia Etaireia Periorismenis Efthynis',
        ],
    },
    {
        code: '8BXP',
        country: 'TR',
        jurisdiction: 'TR',
        jurisdictionName: 'Türkiye',
        name: 'kooperatif',
        abbreviation: '',
        active: true,
        aliases: ['kooperatif'],
    },
    {
        code: '8CF0',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Assurance Company',
        abbreviation: '',
        active: true,
        aliases: ['Assurance Company'],
    },
    {
        code: '8CIC',
        country: 'KW',
        jurisdiction: 'KW',
        jurisdictionName: 'Kuwait',
        name: 'الشركات غیر الھادفة للربح.',
        abbreviation: '',
        active: true,
        aliases: ['الشركات غیر الھادفة للربح.', 'Alsharikat ghayr alھadifat lilrabhi.'],
    },
    {
        code: '8CM0',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Partnerschaftsgesellschaft',
        abbreviation: 'PartG',
        active: true,
        aliases: ['Partnerschaftsgesellschaft', 'PartG'],
    },
    {
        code: '8E0H',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: '8E2A',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Coöperatieve vennootschap met beperkte aansprakelijkheid',
        abbreviation: 'CVBA',
        active: true,
        aliases: [
            'Coöperatieve vennootschap met beperkte aansprakelijkheid',
            'CVBA',
            'Société coopérative à responsabilité limitée',
            'SCRL',
            'Genossenschaft mit beschränkter Haftung',
            'Gen.mbH',
        ],
    },
    {
        code: '8EHB',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad de Inversión de Capital Variable',
        abbreviation: 'SICAV',
        active: true,
        aliases: ['Sociedad de Inversión de Capital Variable', 'SICAV'],
    },
    {
        code: '8ER6',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Stanovanjska zadruga',
        abbreviation: '',
        active: true,
        aliases: ['Stanovanjska zadruga'],
    },
    {
        code: '8FD2',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Cooperativă de consum',
        abbreviation: '',
        active: true,
        aliases: ['Cooperativă de consum'],
    },
    {
        code: '8FZW',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SCP de conseils juridiques',
        abbreviation: '',
        active: true,
        aliases: ['SCP de conseils juridiques'],
    },
    {
        code: '8G07',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: '(Autre) Personne physique',
        abbreviation: '',
        active: false,
        aliases: ['(Autre) Personne physique'],
    },
    {
        code: '8GEA',
        country: 'BR',
        jurisdiction: 'BR',
        jurisdictionName: 'Brazil',
        name: 'Sociedade Simples',
        abbreviation: 'S/S',
        active: true,
        aliases: ['Sociedade Simples', 'S/S'],
    },
    {
        code: '8GTU',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "(Autre) Service déconcentré de l'État à compétence territoriale",
        abbreviation: '',
        active: true,
        aliases: ["(Autre) Service déconcentré de l'État à compétence territoriale"],
    },
    {
        code: '8GU1',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società A Responsabilità Limitata Semplificata',
        abbreviation: 'S.R.L.S.;S.R.L. semplificata',
        active: true,
        aliases: ['Società A Responsabilità Limitata Semplificata', 'S.R.L.S.;S.R.L. semplificata'],
    },
    {
        code: '8HGS',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Erityislainsäädäntöön perustuva yhdistys',
        abbreviation: '',
        active: true,
        aliases: [
            'Erityislainsäädäntöön perustuva yhdistys',
            'Förening som grundar sig på speciallagstiftning',
        ],
    },
    {
        code: '8HNT',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Foreign Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Corporation'],
    },
    {
        code: '8HR7',
        country: 'KY',
        jurisdiction: 'KY',
        jurisdictionName: 'Cayman Islands',
        name: 'unlimited company',
        abbreviation: '',
        active: true,
        aliases: ['unlimited company'],
    },
    {
        code: '8II5',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Autre SA coopérative à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["Autre SA coopérative à conseil d'administration"],
    },
    {
        code: '8IWA',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Commune associée et commune déléguée',
        abbreviation: '',
        active: true,
        aliases: ['Commune associée et commune déléguée'],
    },
    {
        code: '8JWV',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Государственные академии наук',
        abbreviation: '',
        active: true,
        aliases: ['Государственные академии наук', 'Gosudarstvennyye akademii nauk'],
    },
    {
        code: '8K5T',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Spotřební družstvo',
        abbreviation: '',
        active: true,
        aliases: ['Spotřební družstvo'],
    },
    {
        code: '8KA4',
        country: 'US',
        jurisdiction: 'US-VA',
        jurisdictionName: 'Virginia',
        name: 'Registered Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Registered Limited Liability Partnership'],
    },
    {
        code: '8KHD',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Jednotka zboru ozbrojenej ochrany železníc',
        abbreviation: 'Jed.zboru ochrany žel.',
        active: true,
        aliases: ['Jednotka zboru ozbrojenej ochrany železníc', 'Jed.zboru ochrany žel.'],
    },
    {
        code: '8KL5',
        country: 'CA',
        jurisdiction: 'CA-SK',
        jurisdictionName: 'Saskatchewan',
        name: 'Condominium Corporations',
        abbreviation: '',
        active: true,
        aliases: ['Condominium Corporations'],
    },
    {
        code: '8LX5',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Autre régime de prévoyance sociale',
        abbreviation: '',
        active: true,
        aliases: ['Autre régime de prévoyance sociale'],
    },
    {
        code: '8M03',
        country: 'CA',
        jurisdiction: 'CA-NS',
        jurisdictionName: 'Nova Scotia',
        name: 'Condominiums',
        abbreviation: 'Condominium Corporation',
        active: true,
        aliases: ['Condominiums', 'Condominium Corporation'],
    },
    {
        code: '8M3D',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad cooperativa de productores de bienes y/o servicios de capital variable',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad cooperativa de productores de bienes y/o servicios de capital variable'],
    },
    {
        code: '8MBD',
        country: 'US',
        jurisdiction: 'US-TN',
        jurisdictionName: 'Tennessee',
        name: 'Limited Liability Partnership',
        abbreviation: 'L.L.P.;LLP',
        active: true,
        aliases: ['Limited Liability Partnership', 'L.L.P.;LLP'],
    },
    {
        code: '8MEC',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'New Brunswick limited liability partnership',
        abbreviation: 'LLP',
        active: true,
        aliases: [
            'New Brunswick limited liability partnership',
            'LLP',
            'société à responsabilité limitée du Nouveau-Brunswick',
        ],
    },
    {
        code: '8MQM',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Государственные бюджетные учреждения субъектов Российской Федерации',
        abbreviation: '',
        active: true,
        aliases: [
            'Государственные бюджетные учреждения субъектов Российской Федерации',
            'Gosudarstvennyye byudzhetnyye uchrezhdeniya sub"yektov Rossiyskoy Federatsii',
        ],
    },
    {
        code: '8MS6',
        country: 'SR',
        jurisdiction: 'SR',
        jurisdictionName: 'Suriname',
        name: 'Stichting',
        abbreviation: '',
        active: true,
        aliases: ['Stichting'],
    },
    {
        code: '8MY7',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, valuadora de acciones de fondos de inversión',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima de capital variable, valuadora de acciones de fondos de inversión'],
    },
    {
        code: '8N0C',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: '8N21',
        country: 'US',
        jurisdiction: 'US-FL',
        jurisdictionName: 'Florida',
        name: 'Limited Liability Company',
        abbreviation: 'LLC;L.L.C.; P.L.L.C.;PLLC',
        active: true,
        aliases: ['Limited Liability Company', 'LLC;L.L.C.; P.L.L.C.;PLLC'],
    },
    {
        code: '8NF7',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Федеральные государственные бюджетные учреждения',
        abbreviation: '',
        active: true,
        aliases: [
            'Федеральные государственные бюджетные учреждения',
            "Federal'nyye gosudarstvennyye byudzhetnyye uchrezhdeniya",
        ],
    },
    {
        code: '8NZE',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Садоводческие, огороднические или дачные потребительские кооперативы',
        abbreviation: '',
        active: true,
        aliases: [
            'Садоводческие, огороднические или дачные потребительские кооперативы',
            "Sadovodcheskiye, ogorodnicheskiye ili dachnyye potrebitel'skiye kooperativy",
        ],
    },
    {
        code: '8OK2',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Business Trusts',
        abbreviation: '',
        active: true,
        aliases: ['Business Trusts'],
    },
    {
        code: '8OKM',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Service déconcentré à compétence nationale d'un ministère (hors Défense)",
        abbreviation: '',
        active: true,
        aliases: ["Service déconcentré à compétence nationale d'un ministère (hors Défense)"],
    },
    {
        code: '8OZ0',
        country: 'CA',
        jurisdiction: 'CA-NS',
        jurisdictionName: 'Nova Scotia',
        name: 'limited liability partnerships',
        abbreviation: 'limited liability partnership;LLP;Limited Liability Partnership',
        active: true,
        aliases: [
            'limited liability partnerships',
            'limited liability partnership;LLP;Limited Liability Partnership',
        ],
    },
    {
        code: '8PIA',
        country: 'SB',
        jurisdiction: 'SB',
        jurisdictionName: 'Solomon Islands',
        name: 'Private Company',
        abbreviation: '',
        active: true,
        aliases: ['Private Company'],
    },
    {
        code: '8PUO',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Foreign Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Partnership'],
    },
    {
        code: '8QMN',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Professional Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation;PC',
        active: true,
        aliases: [
            'Professional Corporation',
            'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation;PC',
        ],
    },
    {
        code: '8QZA',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad cooperativa de responsabilidad limitada de capital variable',
        abbreviation: 'S.C. DE R.L. DE C.V.',
        active: true,
        aliases: [
            'Sociedad cooperativa de responsabilidad limitada de capital variable',
            'S.C. DE R.L. DE C.V.',
        ],
    },
    {
        code: '8R2G',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société civile immobilière de construction-vente',
        abbreviation: '',
        active: true,
        aliases: ['Société civile immobilière de construction-vente'],
    },
    {
        code: '8RE3',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Družstevný podnik poľnohospodársky',
        abbreviation: 'Družstevný podnik poľ.',
        active: true,
        aliases: ['Družstevný podnik poľnohospodársky', 'Družstevný podnik poľ.'],
    },
    {
        code: '8RIH',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Публично-правовые компании',
        abbreviation: '',
        active: true,
        aliases: ['Публично-правовые компании', 'Publichno-pravovyye kompanii'],
    },
    {
        code: '8RLE',
        country: 'US',
        jurisdiction: 'US-IL',
        jurisdictionName: 'Illinois',
        name: 'Limited Liability Company',
        abbreviation: 'LLC;L.L.C',
        active: true,
        aliases: ['Limited Liability Company', 'LLC;L.L.C'],
    },
    {
        code: '8RRB',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad cooperativa de ahorro y préstamo',
        abbreviation: 'S.C. de A. P.',
        active: true,
        aliases: ['Sociedad cooperativa de ahorro y préstamo', 'S.C. de A. P.'],
    },
    {
        code: '8S9H',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Gjensidig forsikringsselskap',
        abbreviation: '',
        active: true,
        aliases: ['Gjensidig forsikringsselskap'],
    },
    {
        code: '8T79',
        country: 'IS',
        jurisdiction: 'IS',
        jurisdictionName: 'Iceland',
        name: 'Samlagsfélag',
        abbreviation: 'slf.',
        active: true,
        aliases: ['Samlagsfélag', 'slf.'],
    },
    {
        code: '8TOF',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'spółdzielnia',
        abbreviation: '',
        active: true,
        aliases: ['spółdzielnia'],
    },
    {
        code: '8TYA',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Autre SA coopérative à directoire',
        abbreviation: '',
        active: true,
        aliases: ['Autre SA coopérative à directoire'],
    },
    {
        code: '8UE6',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Organizačná jednotka politickej strany, politického hnutia',
        abbreviation: 'Org.jedn.pol.strany,hn.',
        active: true,
        aliases: [
            'Organizačná jednotka politickej strany, politického hnutia',
            'Org.jedn.pol.strany,hn.',
        ],
    },
    {
        code: '8UEG',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Nyilvánosan működő részvénytársaság',
        abbreviation: 'Nyrt.',
        active: true,
        aliases: ['Nyilvánosan működő részvénytársaság', 'Nyrt.'],
    },
    {
        code: '8UMK',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Európai gazdasági egyesülés',
        abbreviation: 'EGE',
        active: true,
        aliases: ['Európai gazdasági egyesülés', 'EGE'],
    },
    {
        code: '8VDW',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Société d'assurance à forme mutuelle",
        abbreviation: '',
        active: true,
        aliases: ["Société d'assurance à forme mutuelle"],
    },
    {
        code: '8VFX',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'vereniging met beperkte rechtsbevoegdheid',
        abbreviation: '',
        active: true,
        aliases: ['vereniging met beperkte rechtsbevoegdheid'],
    },
    {
        code: '8VH3',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Befektetési alap',
        abbreviation: '',
        active: true,
        aliases: ['Befektetési alap'],
    },
    {
        code: '8VLM',
        country: 'US',
        jurisdiction: 'US-IA',
        jurisdictionName: 'Iowa',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: '8VRU',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Europska zadruga (Societas Cooperativa Europaea, skraćeno SCE)',
        abbreviation: 'SCE',
        active: true,
        aliases: ['Europska zadruga (Societas Cooperativa Europaea, skraćeno SCE)', 'SCE'],
    },
    {
        code: '8VWR',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA d'économie mixte à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA d'économie mixte à conseil d'administration"],
    },
    {
        code: '8VZ0',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Trust',
        abbreviation: '',
        active: true,
        aliases: ['Trust'],
    },
    {
        code: '8W32',
        country: 'SX',
        jurisdiction: 'SX',
        jurisdictionName: 'Sint Maarten',
        name: 'openbare vennootschap',
        abbreviation: '',
        active: true,
        aliases: ['openbare vennootschap'],
    },
    {
        code: '8WH8',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Autre personne morale de droit étranger',
        abbreviation: '',
        active: false,
        aliases: ['Autre personne morale de droit étranger'],
    },
    {
        code: '8WJ7',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Keskinäinen kiinteistöosakeyhtiö',
        abbreviation: '',
        active: true,
        aliases: ['Keskinäinen kiinteistöosakeyhtiö', 'Ömsesidigt fastighetsaktiebolag'],
    },
    {
        code: '8WM4',
        country: 'US',
        jurisdiction: 'US-NV',
        jurisdictionName: 'Nevada',
        name: 'Profit Corporation',
        abbreviation: 'Inc.;Ltd.;Co.;Corp.',
        active: true,
        aliases: ['Profit Corporation', 'Inc.;Ltd.;Co.;Corp.'],
    },
    {
        code: '8WQ9',
        country: 'DO',
        jurisdiction: 'DO',
        jurisdictionName: 'Dominican Republic',
        name: 'Sociedad en Comandita Simple',
        abbreviation: 'S. en C.',
        active: true,
        aliases: ['Sociedad en Comandita Simple', 'S. en C.'],
    },
    {
        code: '8XAW',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '外国在华文化中心',
        abbreviation: '',
        active: true,
        aliases: ['外国在华文化中心', 'wai guo zai hua wen hua zhong xin'],
    },
    {
        code: '8XDD',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Советы муниципальных образований субъектов Российской Федерации',
        abbreviation: '',
        active: true,
        aliases: [
            'Советы муниципальных образований субъектов Российской Федерации',
            'Sovety munitsipal\'nykh obrazovaniy sub"yektov Rossiyskoy Federatsii',
        ],
    },
    {
        code: '8XDK',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA d'aménagement foncier et d'équipement rural (SAFER) à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA d'aménagement foncier et d'équipement rural (SAFER) à conseil d'administration"],
    },
    {
        code: '8XDW',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Genossenschaft',
        abbreviation: '',
        active: true,
        aliases: ['Genossenschaft'],
    },
    {
        code: '8XN0',
        country: 'US',
        jurisdiction: 'US-VT',
        jurisdictionName: 'Vermont',
        name: 'Limited Liability Partnership',
        abbreviation: 'RLLP;LLP',
        active: true,
        aliases: ['Limited Liability Partnership', 'RLLP;LLP'],
    },
    {
        code: '8YBQ',
        country: 'US',
        jurisdiction: 'US-MS',
        jurisdictionName: 'Mississippi',
        name: 'General Partnership',
        abbreviation: '',
        active: true,
        aliases: ['General Partnership'],
    },
    {
        code: '8YLB',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Instelling zonder winstoogmerk',
        abbreviation: 'IZW',
        active: true,
        aliases: [
            'Instelling zonder winstoogmerk',
            'IZW',
            'Institution sans but lucratif',
            'ISBL',
            'Einrichtung ohne Gewinnerzielungsabsicht',
            'EoG',
        ],
    },
    {
        code: '8Z6G',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Kommanditgesellschaft',
        abbreviation: 'KG;GmbH & Co. KG;UG (haftungsbeschränkt) & Co. KG AG & Co. KG;KGaA & Co. KG;Stiftung & Co. KG',
        active: true,
        aliases: [
            'Kommanditgesellschaft',
            'KG;GmbH & Co. KG;UG (haftungsbeschränkt) & Co. KG AG & Co. KG;KGaA & Co. KG;Stiftung & Co. KG',
        ],
    },
    {
        code: '8Z76',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: '8ZH8',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'Alberta Business Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Alberta Business Corporation'],
    },
    {
        code: '8ZLF',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Special Purpose Vehicle - Trust',
        abbreviation: '',
        active: true,
        aliases: ['Special Purpose Vehicle - Trust'],
    },
    {
        code: '8ZQE',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Korteriühistu',
        abbreviation: 'KÜ',
        active: true,
        aliases: ['Korteriühistu', 'KÜ'],
    },
    {
        code: '8ZUV',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima, sociedad financiera de objeto múltiple, entidad regulada',
        abbreviation: 'S.A., SOFOM E.R.',
        active: true,
        aliases: [
            'Sociedad anónima, sociedad financiera de objeto múltiple, entidad regulada',
            'S.A., SOFOM E.R.',
        ],
    },
    {
        code: '90YN',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Sociálna a zdravotné poisťovne',
        abbreviation: 'Sociál.,zdrav.poisťovňa',
        active: true,
        aliases: ['Sociálna a zdravotné poisťovne', 'Sociál.,zdrav.poisťovňa'],
    },
    {
        code: '917C',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Česká tisková kancelář',
        abbreviation: '',
        active: true,
        aliases: ['Česká tisková kancelář'],
    },
    {
        code: '92JZ',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Stichting',
        abbreviation: '',
        active: true,
        aliases: ['Stichting'],
    },
    {
        code: '92OB',
        country: 'US',
        jurisdiction: 'US-NV',
        jurisdictionName: 'Nevada',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: '93CA',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Agricultural Association',
        abbreviation: '',
        active: true,
        aliases: ['Agricultural Association'],
    },
    {
        code: '93LG',
        country: 'KW',
        jurisdiction: 'KW',
        jurisdictionName: 'Kuwait',
        name: 'شركة التوصية البسيطة',
        abbreviation: '',
        active: true,
        aliases: ['شركة التوصية البسيطة', 'Sharikat altawsiat albasitat lilshiraka'],
    },
    {
        code: '93WZ',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Podnikateľ-fyzická osoba-zapís.v OR-podnikajúca súčasne ako sam.hosp.roľník',
        abbreviation: 'Živ. a SHR roľník v OR',
        active: true,
        aliases: [
            'Podnikateľ-fyzická osoba-zapís.v OR-podnikajúca súčasne ako sam.hosp.roľník',
            'Živ. a SHR roľník v OR',
        ],
    },
    {
        code: '946C',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Едноличен търговец',
        abbreviation: 'ЕТ',
        active: true,
        aliases: ['Едноличен търговец', 'Ednolichen targovets', 'ЕТ', 'ET'],
    },
    {
        code: '94UQ',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'public recreation company',
        abbreviation: '',
        active: true,
        aliases: ['public recreation company'],
    },
    {
        code: '94WO',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'District urbain',
        abbreviation: '',
        active: true,
        aliases: ['District urbain'],
    },
    {
        code: '956I',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Limitada de nueva empresa',
        abbreviation: 'S.L.N.E.',
        active: false,
        aliases: ['Sociedad Limitada de nueva empresa', 'S.L.N.E.'],
    },
    {
        code: '95AW',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Islamic Charitable Trust',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Islamic Charitable Trust'],
    },
    {
        code: '95EN',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les services de santé et les services sociaux pour les autochtones cris',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur les services de santé et les services sociaux pour les autochtones cris',
        ],
    },
    {
        code: '95G8',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Podnikající fyzická osoba tuzemská',
        abbreviation: '',
        active: true,
        aliases: ['Podnikající fyzická osoba tuzemská'],
    },
    {
        code: '95MS',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Slobodné povolanie-fyzická osoba podnikajúca na základe iného ako živnostenského zákona',
        abbreviation: 'FO-slob.povolanie',
        active: true,
        aliases: [
            'Slobodné povolanie-fyzická osoba podnikajúca na základe iného ako živnostenského zákona',
            'FO-slob.povolanie',
        ],
    },
    {
        code: '95OK',
        country: 'US',
        jurisdiction: 'US-OH',
        jurisdictionName: 'Ohio',
        name: 'General Partnership',
        abbreviation: '',
        active: true,
        aliases: ['General Partnership'],
    },
    {
        code: '95W7',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Financial Institution',
        abbreviation: '',
        active: true,
        aliases: ['Financial Institution'],
    },
    {
        code: '96OC',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad cooperativa',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad cooperativa'],
    },
    {
        code: '96XK',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'fundacja',
        abbreviation: '',
        active: true,
        aliases: ['fundacja'],
    },
    {
        code: '971Y',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Podnik nebo hospodářské zařízení sdružení',
        abbreviation: '',
        active: true,
        aliases: ['Podnik nebo hospodářské zařízení sdružení'],
    },
    {
        code: '97PB',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Vakuutuskassa',
        abbreviation: '',
        active: true,
        aliases: ['Vakuutuskassa', 'Försäkringskassa'],
    },
    {
        code: '97PZ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SARL coopérative d'intérêt maritime",
        abbreviation: '',
        active: true,
        aliases: ["SARL coopérative d'intérêt maritime"],
    },
    {
        code: '982Z',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Service Mark',
        abbreviation: '',
        active: false,
        aliases: ['Service Mark'],
    },
    {
        code: '98A8',
        country: 'BS',
        jurisdiction: 'BS',
        jurisdictionName: 'Bahamas',
        name: 'Company Limited by Shares',
        abbreviation: 'Ltd',
        active: true,
        aliases: ['Company Limited by Shares', 'Ltd'],
    },
    {
        code: '990B',
        country: 'BH',
        jurisdiction: 'BH',
        jurisdictionName: 'Bahrain',
        name: 'وصية الشراكة من قبل شركة الأسهم (شركة التوصية بالأسهم)',
        abbreviation: '',
        active: true,
        aliases: [
            'وصية الشراكة من قبل شركة الأسهم (شركة التوصية بالأسهم)',
            "Wasiat alshirakat min qibal sharikat al'ashum",
        ],
    },
    {
        code: '995K',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Magánnyugdíjpénztár',
        abbreviation: '',
        active: true,
        aliases: ['Magánnyugdíjpénztár'],
    },
    {
        code: '99JD',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Agrupamento Europeu de Interesse Económico',
        abbreviation: 'AEIE',
        active: true,
        aliases: ['Agrupamento Europeu de Interesse Económico', 'AEIE'],
    },
    {
        code: '9A4Q',
        country: 'US',
        jurisdiction: 'US-AK',
        jurisdictionName: 'Alaska',
        name: 'Religious Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Religious Corporation'],
    },
    {
        code: '9AAK',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'maatschap',
        abbreviation: '',
        active: true,
        aliases: ['maatschap'],
    },
    {
        code: '9AAS',
        country: 'US',
        jurisdiction: 'US-TX',
        jurisdictionName: 'Texas',
        name: 'Professional Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Professional Corporation'],
    },
    {
        code: '9AQ8',
        country: 'US',
        jurisdiction: 'US-DC',
        jurisdictionName: 'District of Columbia',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: '9ASJ',
        country: 'US',
        jurisdiction: 'US-DE',
        jurisdictionName: 'Delaware',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: '9AUC',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Vakuutusyhdistys',
        abbreviation: '',
        active: true,
        aliases: ['Vakuutusyhdistys', 'Försäkringsförening'],
    },
    {
        code: '9B78',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Royal Charter Company',
        abbreviation: '',
        active: true,
        aliases: ['Royal Charter Company'],
    },
    {
        code: '9BH2',
        country: 'US',
        jurisdiction: 'US-MO',
        jurisdictionName: 'Missouri',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: '9BIS',
        country: 'BR',
        jurisdiction: 'BR',
        jurisdictionName: 'Brazil',
        name: 'Organização Religiosa',
        abbreviation: '',
        active: true,
        aliases: ['Organização Religiosa'],
    },
    {
        code: '9BPE',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'Credit Union',
        abbreviation: '',
        active: true,
        aliases: ['Credit Union'],
    },
    {
        code: '9BQH',
        country: 'NE',
        jurisdiction: 'NE',
        jurisdictionName: 'Niger',
        name: 'Société Anonyme',
        abbreviation: 'SA',
        active: true,
        aliases: ['Société Anonyme', 'SA'],
    },
    {
        code: '9C19',
        country: 'US',
        jurisdiction: 'US-PA',
        jurisdictionName: 'Pennsylvania',
        name: 'Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Company'],
    },
    {
        code: '9C91',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Société d’épargne-pension à capital variable',
        abbreviation: 'SEPCAV',
        active: true,
        aliases: ['Société d’épargne-pension à capital variable', 'SEPCAV'],
    },
    {
        code: '9CB2',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: "Société par actions constitué par Loi sur les syndicats d'élevage",
        abbreviation: '',
        active: true,
        aliases: ["Société par actions constitué par Loi sur les syndicats d'élevage"],
    },
    {
        code: '9CEN',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: "Société par actions constitué par Loi sur les sociétés d'exploration minière",
        abbreviation: '',
        active: true,
        aliases: ["Société par actions constitué par Loi sur les sociétés d'exploration minière"],
    },
    {
        code: '9D1K',
        country: 'CA',
        jurisdiction: 'CA-MB',
        jurisdictionName: 'Manitoba',
        name: 'non-share corporations',
        abbreviation: 'Incorporated;Incorporee;Corporation;Inc.;Corp.',
        active: true,
        aliases: ['non-share corporations', 'Incorporated;Incorporee;Corporation;Inc.;Corp.'],
    },
    {
        code: '9D9U',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Trgovac pojedinac',
        abbreviation: 't.p.',
        active: true,
        aliases: ['Trgovac pojedinac', 't.p.'],
    },
    {
        code: '9DI1',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Boligbyggelag',
        abbreviation: 'BBL',
        active: true,
        aliases: ['Boligbyggelag', 'BBL'],
    },
    {
        code: '9E0Q',
        country: 'CW',
        jurisdiction: 'CW',
        jurisdictionName: 'Curaçao',
        name: 'Commanditaire vennootschap',
        abbreviation: '',
        active: true,
        aliases: ['Commanditaire vennootschap'],
    },
    {
        code: '9EGO',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Bank (LLC)',
        abbreviation: '',
        active: true,
        aliases: ['Bank (LLC)', 'Banco (CRL)'],
    },
    {
        code: '9EJ6',
        country: 'US',
        jurisdiction: 'US-PA',
        jurisdictionName: 'Pennsylvania',
        name: 'Nonprofit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation'],
    },
    {
        code: '9F78',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Чуждестранно дружество - физическо лице',
        abbreviation: '',
        active: false,
        aliases: [
            'Чуждестранно дружество - физическо лице',
            'Chuzhdestranno druzhestvo - fizichesko litse',
        ],
    },
    {
        code: '9FD9',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Master Limited Liability Company',
        abbreviation: 'Limited Liabilty Company;LLC',
        active: true,
        aliases: ['Master Limited Liability Company', 'Limited Liabilty Company;LLC'],
    },
    {
        code: '9FPZ',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Anonima Europea',
        abbreviation: 'S.E.',
        active: true,
        aliases: ['Sociedad Anonima Europea', 'S.E.'],
    },
    {
        code: '9G8O',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: '9GXA',
        country: 'US',
        jurisdiction: 'US-WY',
        jurisdictionName: 'Wyoming',
        name: 'Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Profit Corporation'],
    },
    {
        code: '9HC8',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société en participation entre personnes physiques',
        abbreviation: '',
        active: true,
        aliases: ['Société en participation entre personnes physiques'],
    },
    {
        code: '9HKD',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Financial Corporations',
        abbreviation: '',
        active: true,
        aliases: ['Financial Corporations'],
    },
    {
        code: '9HLU',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Společnost s ručením omezeným',
        abbreviation: '',
        active: true,
        aliases: ['Společnost s ručením omezeným'],
    },
    {
        code: '9I4Y',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Non-Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Non-Profit Corporation'],
    },
    {
        code: '9I58',
        country: 'AE',
        jurisdiction: 'AE-AZ',
        jurisdictionName: 'Abu Dhabi',
        name: 'Private Company Unlimited without Shares',
        abbreviation: '',
        active: true,
        aliases: ['Private Company Unlimited without Shares'],
    },
    {
        code: '9IF2',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les associations coopératives',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur les associations coopératives'],
    },
    {
        code: '9JGX',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Landesinnungsverband',
        abbreviation: '',
        active: true,
        aliases: ['Landesinnungsverband'],
    },
    {
        code: '9JWK',
        country: 'US',
        jurisdiction: 'US-SC',
        jurisdictionName: 'South Carolina',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: '9KGS',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società Cooperativa Europea',
        abbreviation: 'SCE',
        active: true,
        aliases: ['Società Cooperativa Europea', 'SCE'],
    },
    {
        code: '9KSX',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Partnerselskab',
        abbreviation: 'P/S',
        active: true,
        aliases: ['Partnerselskab', 'P/S'],
    },
    {
        code: '9KU7',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Union de sociétés coopératives agricoles',
        abbreviation: '',
        active: true,
        aliases: ['Union de sociétés coopératives agricoles'],
    },
    {
        code: '9L6B',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Foreign Limited Liability Company',
        abbreviation: 'limited liability company;L.L.C.;L.C.',
        active: true,
        aliases: ['Foreign Limited Liability Company', 'limited liability company;L.L.C.;L.C.'],
    },
    {
        code: '9L9V',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Poľnohospodárske družstvo',
        abbreviation: 'Poľnohospodár.družstvo',
        active: true,
        aliases: ['Poľnohospodárske družstvo', 'Poľnohospodár.družstvo'],
    },
    {
        code: '9LJA',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Aktsiaselts',
        abbreviation: 'AS',
        active: true,
        aliases: ['Aktsiaselts', 'AS'],
    },
    {
        code: '9M15',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Центральный банк',
        abbreviation: '',
        active: true,
        aliases: ['Центральный банк', "Central'nyj bank"],
    },
    {
        code: '9M2Q',
        country: 'US',
        jurisdiction: 'US-NH',
        jurisdictionName: 'New Hampshire',
        name: 'Benefit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Benefit Corporation'],
    },
    {
        code: '9ME5',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Non profit company',
        abbreviation: '',
        active: true,
        aliases: ['Non profit company'],
    },
    {
        code: '9N1F',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA d'intérêt collectif agricole (SICA)",
        abbreviation: '',
        active: true,
        aliases: ["SA d'intérêt collectif agricole (SICA)"],
    },
    {
        code: '9NBN',
        country: 'JO',
        jurisdiction: 'JO',
        jurisdictionName: 'Jordan',
        name: 'شركة التضامن',
        abbreviation: '',
        active: true,
        aliases: ['شركة التضامن', 'sharikat altadamun'],
    },
    {
        code: '9NSV',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Neinvestičný fond',
        abbreviation: '',
        active: true,
        aliases: ['Neinvestičný fond'],
    },
    {
        code: '9O0S',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Association fonciére urbaine',
        abbreviation: '',
        active: true,
        aliases: ['Association fonciére urbaine'],
    },
    {
        code: '9O67',
        country: 'RS',
        jurisdiction: 'RS',
        jurisdictionName: 'Serbia',
        name: 'Предузетник',
        abbreviation: 'ПР',
        active: true,
        aliases: ['Предузетник', 'Preduzetnik', 'ПР', 'PR'],
    },
    {
        code: '9OSW',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Partnership'],
    },
    {
        code: '9PZC',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Fundacija',
        abbreviation: '',
        active: true,
        aliases: ['Fundacija'],
    },
    {
        code: '9QHJ',
        country: 'MT',
        jurisdiction: 'MT',
        jurisdictionName: 'Malta',
        name: 'government entity',
        abbreviation: '',
        active: true,
        aliases: ['government entity'],
    },
    {
        code: '9RQZ',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Государственные унитарные предприятия субъектов Российской Федерации',
        abbreviation: '',
        active: true,
        aliases: [
            'Государственные унитарные предприятия субъектов Российской Федерации',
            'Gosudarstvennyye unitarnyye predpriyatiya sub"yektov Rossiyskoy Federatsii',
        ],
    },
    {
        code: '9RVC',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Družstvo',
        abbreviation: '',
        active: true,
        aliases: ['Družstvo'],
    },
    {
        code: '9STD',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Corporation'],
    },
    {
        code: '9T5S',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Fondation',
        abbreviation: '',
        active: true,
        aliases: ['Fondation'],
    },
    {
        code: '9TCY',
        country: 'BM',
        jurisdiction: 'BM',
        jurisdictionName: 'Bermuda',
        name: 'Mutual Company (Part XII)',
        abbreviation: '',
        active: true,
        aliases: ['Mutual Company (Part XII)'],
    },
    {
        code: '9U5M',
        country: 'US',
        jurisdiction: 'US-WA',
        jurisdictionName: 'Washington',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: '9U6F',
        country: 'AE',
        jurisdiction: 'AE-AZ',
        jurisdictionName: 'Abu Dhabi',
        name: 'Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Partnership'],
    },
    {
        code: '9X63',
        country: 'BY',
        jurisdiction: 'BY',
        jurisdictionName: 'Belarus',
        name: 'Унітарнае прадпрыемства',
        abbreviation: 'УП',
        active: true,
        aliases: [
            'Унітарнае прадпрыемства',
            'Unіtarnae pradpryemstva',
            'УП',
            'UP',
            'Унитарное предприятие',
            'Unitarnoe predpriyatie',
        ],
    },
    {
        code: '9XDB',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Občanské sdružení',
        abbreviation: '',
        active: true,
        aliases: ['Občanské sdružení'],
    },
    {
        code: '9XFK',
        country: 'GG',
        jurisdiction: 'GG',
        jurisdictionName: 'Guernsey',
        name: 'Foundation',
        abbreviation: 'FDN.;Fdn.',
        active: true,
        aliases: ['Foundation', 'FDN.;Fdn.'],
    },
    {
        code: '9XHE',
        country: 'CA',
        jurisdiction: 'CA-NS',
        jurisdictionName: 'Nova Scotia',
        name: 'business names',
        abbreviation: '',
        active: true,
        aliases: ['business names'],
    },
    {
        code: '9YIP',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Europakooperativ',
        abbreviation: 'SCE;S.C.E.',
        active: true,
        aliases: ['Europakooperativ', 'SCE;S.C.E.'],
    },
    {
        code: 'A0J6',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Asociación',
        abbreviation: '',
        active: true,
        aliases: ['Asociación'],
    },
    {
        code: 'A0PS',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Partnership Firm',
        abbreviation: '',
        active: true,
        aliases: ['Partnership Firm'],
    },
    {
        code: 'A0VZ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SCP d'architectes",
        abbreviation: '',
        active: true,
        aliases: ["SCP d'architectes"],
    },
    {
        code: 'A0W7',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'publiekrechtelijke rechtspersoon',
        abbreviation: '',
        active: true,
        aliases: ['publiekrechtelijke rechtspersoon'],
    },
    {
        code: 'A2A8',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad en comandita por acciones',
        abbreviation: 'S. en C. por A.',
        active: true,
        aliases: ['Sociedad en comandita por acciones', 'S. en C. por A.'],
    },
    {
        code: 'A2GC',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Religines bendruomenes, bendrijos ir centrai',
        abbreviation: 'RB',
        active: true,
        aliases: ['Religines bendruomenes, bendrijos ir centrai', 'RB'],
    },
    {
        code: 'A2X8',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Unregistered Company',
        abbreviation: '',
        active: false,
        aliases: ['Unregistered Company'],
    },
    {
        code: 'A30N',
        country: 'VI',
        jurisdiction: 'VI',
        jurisdictionName: 'Virgin Islands (U.S.)',
        name: 'Foreign Trade & Labor Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Trade & Labor Corporation'],
    },
    {
        code: 'A338',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Individualios įmonės',
        abbreviation: 'II',
        active: true,
        aliases: ['Individualios įmonės', 'II'],
    },
    {
        code: 'A35I',
        country: 'VU',
        jurisdiction: 'VU',
        jurisdictionName: 'Vanuatu',
        name: 'Overseas Company',
        abbreviation: '',
        active: false,
        aliases: ['Overseas Company'],
    },
    {
        code: 'A3YH',
        country: 'US',
        jurisdiction: 'US-AL',
        jurisdictionName: 'Alabama',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'A4MM',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'International Banking Center (Corporation)',
        abbreviation: '',
        active: false,
        aliases: ['International Banking Center (Corporation)', 'Compañía de Seguros'],
    },
    {
        code: 'A770',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Professional Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Professional Corporation'],
    },
    {
        code: 'A7G6',
        country: 'CK',
        jurisdiction: 'CK',
        jurisdictionName: 'Cook Islands',
        name: 'Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Company'],
    },
    {
        code: 'A7KA',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Selon la loi par Loi spéciale du Québec à caractère public',
        abbreviation: '',
        active: true,
        aliases: ['Selon la loi par Loi spéciale du Québec à caractère public'],
    },
    {
        code: 'A7VA',
        country: 'SB',
        jurisdiction: 'SB',
        jurisdictionName: 'Solomon Islands',
        name: 'Community Company',
        abbreviation: '',
        active: true,
        aliases: ['Community Company'],
    },
    {
        code: 'A8CT',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Entidade Pública Empresarial',
        abbreviation: '',
        active: true,
        aliases: ['Entidade Pública Empresarial'],
    },
    {
        code: 'A97B',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Mutualidad de Prevision Social',
        abbreviation: 'M.P.S.',
        active: true,
        aliases: ['Mutualidad de Prevision Social', 'M.P.S.'],
    },
    {
        code: 'A9AW',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'A9N4',
        country: 'BS',
        jurisdiction: 'BS',
        jurisdictionName: 'Bahamas',
        name: 'International Business Company',
        abbreviation: '',
        active: true,
        aliases: ['International Business Company'],
    },
    {
        code: 'A9VQ',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'Limited Cooperative Assocation',
        abbreviation: 'LCA;LIMITED COOPERATIVE ASSOCIATION;LIMITED COOPERATIVE;LTD CO-OP',
        active: true,
        aliases: [
            'Limited Cooperative Assocation',
            'LCA;LIMITED COOPERATIVE ASSOCIATION;LIMITED COOPERATIVE;LTD CO-OP',
        ],
    },
    {
        code: 'AABD',
        country: 'BY',
        jurisdiction: 'BY',
        jurisdictionName: 'Belarus',
        name: 'Таварыства з абмежаванай адказнасцю',
        abbreviation: 'ТАА',
        active: true,
        aliases: [
            'Таварыства з абмежаванай адказнасцю',
            'Tavarystva z abmezhavanaj adkaznascyu',
            'ТАА',
            'Общество с ограниченной ответственностью',
            "Obshchestvo s ogranichennoj otvetstvennost'yu",
            'ООО',
        ],
    },
    {
        code: 'AABQ',
        country: 'PE',
        jurisdiction: 'PE',
        jurisdictionName: 'Peru',
        name: 'Empresas Multicomunales',
        abbreviation: '',
        active: true,
        aliases: ['Empresas Multicomunales'],
    },
    {
        code: 'AAL7',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Kommandit-Erwerbsgesellschaft',
        abbreviation: 'KEG',
        active: true,
        aliases: ['Kommandit-Erwerbsgesellschaft', 'KEG'],
    },
    {
        code: 'AB76',
        country: 'US',
        jurisdiction: 'US-ID',
        jurisdictionName: 'Idaho',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'ABII',
        country: 'VC',
        jurisdiction: 'VC',
        jurisdictionName: 'Saint Vincent and the Grenadines',
        name: 'international business company - unlimited company not authorised to issue shares',
        abbreviation: 'Unltd',
        active: true,
        aliases: [
            'international business company - unlimited company not authorised to issue shares',
            'Unltd',
        ],
    },
    {
        code: 'AD0H',
        country: 'US',
        jurisdiction: 'US-GA',
        jurisdictionName: 'Georgia',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'ADAZ',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Istituto Religioso',
        abbreviation: '',
        active: true,
        aliases: ['Istituto Religioso'],
    },
    {
        code: 'ADF8',
        country: 'CW',
        jurisdiction: 'CW',
        jurisdictionName: 'Curaçao',
        name: 'Coöperatie',
        abbreviation: '',
        active: true,
        aliases: ['Coöperatie'],
    },
    {
        code: 'ADV0',
        country: 'QA',
        jurisdiction: 'QA',
        jurisdictionName: 'Qatar',
        name: 'الشركة ذات المسؤولية المحدودة',
        abbreviation: 'ذ.م.م',
        active: true,
        aliases: ['الشركة ذات المسؤولية المحدودة', 'Sharika That Almasuliah Almahduda', 'ذ.م.م'],
    },
    {
        code: 'ADXG',
        country: 'AU',
        jurisdiction: 'AU',
        jurisdictionName: 'Australia',
        name: 'Fund',
        abbreviation: '',
        active: true,
        aliases: ['Fund'],
    },
    {
        code: 'AEJF',
        country: 'US',
        jurisdiction: 'US-OH',
        jurisdictionName: 'Ohio',
        name: 'Professional Association',
        abbreviation: 'company, co.;corporation;corp.;incorporated;inc.',
        active: true,
        aliases: ['Professional Association', 'company, co.;corporation;corp.;incorporated;inc.'],
    },
    {
        code: 'AEK0',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Company'],
    },
    {
        code: 'AEV1',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Partrederi',
        abbreviation: '',
        active: true,
        aliases: ['Partrederi'],
    },
    {
        code: 'AEZW',
        country: 'ID',
        jurisdiction: 'ID',
        jurisdictionName: 'Indonesia',
        name: 'Perseroan Terbuka',
        abbreviation: 'Tbk',
        active: true,
        aliases: ['Perseroan Terbuka', 'Tbk'],
    },
    {
        code: 'AF67',
        country: 'TN',
        jurisdiction: 'TN',
        jurisdictionName: 'Tunisia',
        name: 'Société unipersonnelle à responsabilité limitée',
        abbreviation: 'SUARL',
        active: true,
        aliases: ['Société unipersonnelle à responsabilité limitée', 'SUARL'],
    },
    {
        code: 'AGSR',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Jednotka štátnej železnično - technickej inšpekcie',
        abbreviation: 'Jedn.štát.žel.tech.inš.',
        active: true,
        aliases: ['Jednotka štátnej železnično - technickej inšpekcie', 'Jedn.štát.žel.tech.inš.'],
    },
    {
        code: 'AHBR',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SA à participation ouvrière à directoire',
        abbreviation: '',
        active: true,
        aliases: ['SA à participation ouvrière à directoire'],
    },
    {
        code: 'AHJG',
        country: 'KR',
        jurisdiction: 'KR',
        jurisdictionName: 'Korea (Republic of)',
        name: '조합형 펀드',
        abbreviation: '',
        active: true,
        aliases: ['조합형 펀드', 'JoHabHyeong fund'],
    },
    {
        code: 'AHK4',
        country: 'US',
        jurisdiction: 'US-MS',
        jurisdictionName: 'Mississippi',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'AHRM',
        country: 'KN',
        jurisdiction: 'KN',
        jurisdictionName: 'Saint Kitts and Nevis',
        name: 'limited partnership',
        abbreviation: '',
        active: true,
        aliases: ['limited partnership'],
    },
    {
        code: 'AI01',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Persoana fizica independentă',
        abbreviation: 'PFI',
        active: true,
        aliases: ['Persoana fizica independentă', 'PFI'],
    },
    {
        code: 'AIR0',
        country: 'AE',
        jurisdiction: 'AE-DU',
        jurisdictionName: 'Dubai',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'AIR5',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Fond commun de placement',
        abbreviation: 'FCP',
        active: true,
        aliases: ['Fond commun de placement', 'FCP'],
    },
    {
        code: 'AJ2Y',
        country: 'TV',
        jurisdiction: 'TV',
        jurisdictionName: 'Tuvalu',
        name: 'proprietary company',
        abbreviation: 'PTY',
        active: true,
        aliases: ['proprietary company', 'PTY'],
    },
    {
        code: 'AJ9U',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Anonima Profesional',
        abbreviation: 'S.A.P.',
        active: true,
        aliases: ['Sociedad Anonima Profesional', 'S.A.P.'],
    },
    {
        code: 'AKF5',
        country: 'KR',
        jurisdiction: 'KR',
        jurisdictionName: 'Korea (Republic of)',
        name: '재단법인',
        abbreviation: '',
        active: true,
        aliases: ['재단법인', 'JaeDanBeobIn'],
    },
    {
        code: 'AL8W',
        country: 'BR',
        jurisdiction: 'BR',
        jurisdictionName: 'Brazil',
        name: 'Sociedade Limitada Unipessoal',
        abbreviation: 'SLU',
        active: true,
        aliases: ['Sociedade Limitada Unipessoal', 'SLU'],
    },
    {
        code: 'AL9T',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'samorządowe jednostki organizacyjne',
        abbreviation: '',
        active: true,
        aliases: ['samorządowe jednostki organizacyjne'],
    },
    {
        code: 'ALDM',
        country: 'TW',
        jurisdiction: 'TW',
        jurisdictionName: 'Taiwan (Province of China)',
        name: '合作社',
        abbreviation: '',
        active: true,
        aliases: ['合作社', 'Hé zuò shè'],
    },
    {
        code: 'ALPT',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Associação',
        abbreviation: '',
        active: true,
        aliases: ['Associação'],
    },
    {
        code: 'ALW3',
        country: 'US',
        jurisdiction: 'US-GA',
        jurisdictionName: 'Georgia',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: 'AM3T',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Státní fond ze zákona nezapisující se do obchodního rejstříku',
        abbreviation: '',
        active: true,
        aliases: ['Státní fond ze zákona nezapisující se do obchodního rejstříku'],
    },
    {
        code: 'AMFI',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Autorité constitutionnelle',
        abbreviation: '',
        active: true,
        aliases: ['Autorité constitutionnelle'],
    },
    {
        code: 'AMKW',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'REIT-Aktiengesellschaft',
        abbreviation: 'REIT-AG',
        active: true,
        aliases: ['REIT-Aktiengesellschaft', 'REIT-AG'],
    },
    {
        code: 'AMV2',
        country: 'US',
        jurisdiction: 'US-VT',
        jurisdictionName: 'Vermont',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'AN8Z',
        country: 'VI',
        jurisdiction: 'VI',
        jurisdictionName: 'Virgin Islands (U.S.)',
        name: 'Foreign Limited Partnership / Limited Liability Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Limited Partnership / Limited Liability Limited Partnership'],
    },
    {
        code: 'ANDT',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Societate pe acţiuni',
        abbreviation: 'SA ',
        active: true,
        aliases: ['Societate pe acţiuni', 'SA '],
    },
    {
        code: 'ANHM',
        country: 'BR',
        jurisdiction: 'BR',
        jurisdictionName: 'Brazil',
        name: 'Partido Político',
        abbreviation: '',
        active: true,
        aliases: ['Partido Político'],
    },
    {
        code: 'ANSR',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Kommanditgesellschaft',
        abbreviation: 'KG',
        active: true,
        aliases: ['Kommanditgesellschaft', 'KG'],
    },
    {
        code: 'ANXC',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Federación de sindicatos',
        abbreviation: '',
        active: true,
        aliases: ['Federación de sindicatos'],
    },
    {
        code: 'AO0O',
        country: 'BZ',
        jurisdiction: 'BZ',
        jurisdictionName: 'Belize',
        name: 'Unlimited Company',
        abbreviation: '',
        active: true,
        aliases: ['Unlimited Company'],
    },
    {
        code: 'AOKU',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Unión de ejidos',
        abbreviation: '',
        active: true,
        aliases: ['Unión de ejidos'],
    },
    {
        code: 'AOS4',
        country: 'MU',
        jurisdiction: 'MU',
        jurisdictionName: 'Mauritius',
        name: 'Private Company Limited By Guarantee',
        abbreviation: 'PT;PLC;LTD;LTEE',
        active: true,
        aliases: ['Private Company Limited By Guarantee', 'PT;PLC;LTD;LTEE'],
    },
    {
        code: 'APEN',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Správa železniční dopravní cesty, státní organizace',
        abbreviation: '',
        active: true,
        aliases: ['Správa železniční dopravní cesty, státní organizace'],
    },
    {
        code: 'AQBO',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP'],
    },
    {
        code: 'ARDP',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Civil Profesional',
        abbreviation: '',
        active: false,
        aliases: ['Sociedad Civil Profesional'],
    },
    {
        code: 'AREY',
        country: 'US',
        jurisdiction: 'US-KS',
        jurisdictionName: 'Kansas',
        name: 'Sole Proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['Sole Proprietorship'],
    },
    {
        code: 'ARJF',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Ente Morale',
        abbreviation: '',
        active: true,
        aliases: ['Ente Morale'],
    },
    {
        code: 'ARON',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'limited partnership',
        abbreviation: 'LP;Ltd. Partnership.;Ltd. Partnership',
        active: true,
        aliases: ['limited partnership', 'LP;Ltd. Partnership.;Ltd. Partnership'],
    },
    {
        code: 'AS4W',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Stichting particulier fonds',
        abbreviation: '',
        active: true,
        aliases: ['Stichting particulier fonds'],
    },
    {
        code: 'AS78',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Адвокатские бюро',
        abbreviation: '',
        active: true,
        aliases: ['Адвокатские бюро', 'Advokatskiye byuro'],
    },
    {
        code: 'AS7L',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Société par actions constitué par Loi sur les compagnies de gaz, d’eau et d’électricité',
        abbreviation: '',
        active: true,
        aliases: [
            'Société par actions constitué par Loi sur les compagnies de gaz, d’eau et d’électricité',
        ],
    },
    {
        code: 'ASC7',
        country: 'US',
        jurisdiction: 'US-GA',
        jurisdictionName: 'Georgia',
        name: 'Professional Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Professional Corporation'],
    },
    {
        code: 'ASR5',
        country: 'BM',
        jurisdiction: 'BM',
        jurisdictionName: 'Bermuda',
        name: 'Exempted Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Exempted Partnership'],
    },
    {
        code: 'ASWX',
        country: 'CA',
        jurisdiction: 'CA-NL',
        jurisdictionName: 'Newfoundland and Labrador',
        name: 'share corporations',
        abbreviation: 'Limited;Limitee;Incorporated;Incorporee;Corporation;Ltd.;Ltee.;Inc.;Corp.;Ltd',
        active: true,
        aliases: [
            'share corporations',
            'Limited;Limitee;Incorporated;Incorporee;Corporation;Ltd.;Ltee.;Inc.;Corp.;Ltd',
        ],
    },
    {
        code: 'AT9F',
        country: 'US',
        jurisdiction: 'US-ME',
        jurisdictionName: 'Maine',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'ATQY',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Société en nom collectif',
        abbreviation: 'SENC',
        active: true,
        aliases: ['Société en nom collectif', 'SENC'],
    },
    {
        code: 'AUPV',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Muu kiinteistöosakeyhtiö',
        abbreviation: '',
        active: true,
        aliases: ['Muu kiinteistöosakeyhtiö', 'Annat fastighetsaktiebolag'],
    },
    {
        code: 'AVFT',
        country: 'EC',
        jurisdiction: 'EC',
        jurisdictionName: 'Ecuador',
        name: 'Cooperativa',
        abbreviation: '',
        active: true,
        aliases: ['Cooperativa'],
    },
    {
        code: 'AVLE',
        country: 'US',
        jurisdiction: 'US-RI',
        jurisdictionName: 'Rhode Island',
        name: 'Non-profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Non-profit Corporation'],
    },
    {
        code: 'AVYY',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Government Entity',
        abbreviation: '',
        active: true,
        aliases: ['Government Entity'],
    },
    {
        code: 'AW80',
        country: 'CA',
        jurisdiction: 'CA-BC',
        jurisdictionName: 'British Columbia',
        name: 'Association (includes housing cooperative and community service cooperative)',
        abbreviation: 'coop;co-op',
        active: true,
        aliases: [
            'Association (includes housing cooperative and community service cooperative)',
            'coop;co-op',
        ],
    },
    {
        code: 'AXEQ',
        country: 'KR',
        jurisdiction: 'KR',
        jurisdictionName: 'Korea (Republic of)',
        name: '합명회사',
        abbreviation: '',
        active: true,
        aliases: ['합명회사', 'HabMyeongHoeSa'],
    },
    {
        code: 'AXS5',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad de Capital-Riesgo',
        abbreviation: 'SCR',
        active: true,
        aliases: ['Sociedad de Capital-Riesgo', 'SCR'],
    },
    {
        code: 'AXSB',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Gesellschaft mit beschränkter Haftung',
        abbreviation: 'GmbH;Ges.m.b.H.',
        active: true,
        aliases: ['Gesellschaft mit beschränkter Haftung', 'GmbH;Ges.m.b.H.'],
    },
    {
        code: 'AXW3',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'depends on Act of the Legislature',
        abbreviation: '',
        active: true,
        aliases: ['depends on Act of the Legislature', 'selon la loi de la Législature'],
    },
    {
        code: 'AZ8V',
        country: 'SM',
        jurisdiction: 'SM',
        jurisdictionName: 'San Marino',
        name: 'Società per azioni',
        abbreviation: 'SPA',
        active: true,
        aliases: ['Società per azioni', 'SPA'],
    },
    {
        code: 'AZA0',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Sole proprietorship',
        abbreviation: 'Individually owned Co.',
        active: true,
        aliases: [
            'Sole proprietorship',
            'Individually owned Co.',
            'Entreprise individuelle',
            'Raison individuelle',
            'Einzelunternehmen',
            'Einzelfirma',
            'Ditta individuale',
            'Ragione individuale',
        ],
    },
    {
        code: 'AZFE',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Eingetragene Genossenschaft',
        abbreviation: 'eG',
        active: true,
        aliases: ['Eingetragene Genossenschaft', 'eG'],
    },
    {
        code: 'AZH4',
        country: 'US',
        jurisdiction: 'US-MD',
        jurisdictionName: 'Maryland',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'AZTM',
        country: 'LV',
        jurisdiction: 'LV',
        jurisdictionName: 'Latvia',
        name: 'Eiropas komercsabiedrība',
        abbreviation: 'SE',
        active: true,
        aliases: ['Eiropas komercsabiedrība', 'SE'],
    },
    {
        code: 'AZTO',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Sambruksförening',
        abbreviation: 'SF',
        active: true,
        aliases: ['Sambruksförening', 'SF'],
    },
    {
        code: 'AZUK',
        country: 'US',
        jurisdiction: 'US-IL',
        jurisdictionName: 'Illinois',
        name: 'Business Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.',
        active: true,
        aliases: ['Business Corporation', 'corp.;inc.;co.;ltd.'],
    },
    {
        code: 'AZYL',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'B0LD',
        country: 'MU',
        jurisdiction: 'MU',
        jurisdictionName: 'Mauritius',
        name: 'Ministries And Parastal Bodies',
        abbreviation: '',
        active: true,
        aliases: ['Ministries And Parastal Bodies'],
    },
    {
        code: 'B0V5',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Cooperativa Profesional',
        abbreviation: 'S.Coop.P.',
        active: true,
        aliases: ['Sociedad Cooperativa Profesional', 'S.Coop.P.'],
    },
    {
        code: 'B12O',
        country: 'US',
        jurisdiction: 'US-UT',
        jurisdictionName: 'Utah',
        name: 'Business Trust',
        abbreviation: '',
        active: true,
        aliases: ['Business Trust'],
    },
    {
        code: 'B13W',
        country: 'AE',
        jurisdiction: 'AE-AZ',
        jurisdictionName: 'Abu Dhabi',
        name: 'Restricted Scope Company',
        abbreviation: '',
        active: true,
        aliases: ['Restricted Scope Company'],
    },
    {
        code: 'B21W',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'prosta spółka akcyjna',
        abbreviation: 'PSA',
        active: true,
        aliases: ['prosta spółka akcyjna', 'PSA'],
    },
    {
        code: 'B2F4',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Cooperative Association',
        abbreviation: '',
        active: true,
        aliases: ['Cooperative Association'],
    },
    {
        code: 'B2N4',
        country: 'BJ',
        jurisdiction: 'BJ',
        jurisdictionName: 'Benin',
        name: 'Entreprise Individuelle',
        abbreviation: '',
        active: true,
        aliases: ['Entreprise Individuelle'],
    },
    {
        code: 'B2UK',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Nevenvestiging met hoofdvestiging buiten bonaire',
        abbreviation: '',
        active: false,
        aliases: ['Nevenvestiging met hoofdvestiging buiten bonaire'],
    },
    {
        code: 'B35X',
        country: 'DO',
        jurisdiction: 'DO',
        jurisdictionName: 'Dominican Republic',
        name: 'Sociedad en Participación(sin personalidad jurídica)',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad en Participación(sin personalidad jurídica)'],
    },
    {
        code: 'B38Q',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'General Partnership',
        abbreviation: '',
        active: true,
        aliases: ['General Partnership'],
    },
    {
        code: 'B3JS',
        country: 'SA',
        jurisdiction: 'SA',
        jurisdictionName: 'Saudi Arabia',
        name: 'شركات  اشخاص',
        abbreviation: '',
        active: true,
        aliases: ['شركات  اشخاص', "sharikat 'ashkhas"],
    },
    {
        code: 'B3RX',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'corporation',
        abbreviation: 'Ltd.;Inc.;Corp.',
        active: true,
        aliases: ['corporation', 'Ltd.;Inc.;Corp.'],
    },
    {
        code: 'B3WQ',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, unión de crédito',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima de capital variable, unión de crédito'],
    },
    {
        code: 'B4L0',
        country: 'QA',
        jurisdiction: 'QA',
        jurisdictionName: 'Qatar',
        name: 'شركة المحاصة',
        abbreviation: '',
        active: true,
        aliases: ['شركة المحاصة', 'Sharikat Almahasah'],
    },
    {
        code: 'B4OI',
        country: 'SX',
        jurisdiction: 'SX',
        jurisdictionName: 'Sint Maarten',
        name: 'onderlinge waarborgmaatschappij',
        abbreviation: 'OWM',
        active: true,
        aliases: ['onderlinge waarborgmaatschappij', 'OWM'],
    },
    {
        code: 'B56A',
        country: 'XK',
        jurisdiction: 'XK',
        jurisdictionName: 'Kosovo',
        name: 'Zyra e Përfaqësisë së Shoqërisë së Huaj Tregtare në Kosovë',
        abbreviation: '',
        active: true,
        aliases: ['Zyra e Përfaqësisë së Shoqërisë së Huaj Tregtare në Kosovë'],
    },
    {
        code: 'B5GH',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Казачьи общества, внесенные в государственный реестр казачьих обществ в Российской Федерации',
        abbreviation: '',
        active: true,
        aliases: [
            'Казачьи общества, внесенные в государственный реестр казачьих обществ в Российской Федерации',
            "Kazach'i obshchestva, vnesennyye v gosudarstvennyy reyestr kazach'ikh obshchestv v Rossiyskoy Federatsii",
        ],
    },
    {
        code: 'B5PM',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'naamloze vennootschap',
        abbreviation: 'NV;nv;N.V.;n.v.',
        active: true,
        aliases: ['naamloze vennootschap', 'NV;nv;N.V.;n.v.'],
    },
    {
        code: 'B5TO',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società a Responsabilità Limitata con Unico Socio',
        abbreviation: '',
        active: true,
        aliases: ['Società a Responsabilità Limitata con Unico Socio'],
    },
    {
        code: 'B5UZ',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '事业单位',
        abbreviation: '',
        active: true,
        aliases: ['事业单位', 'shi ye dan wei'],
    },
    {
        code: 'B5YE',
        country: 'US',
        jurisdiction: 'US-WI',
        jurisdictionName: 'Wisconsin',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: 'B645',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA d'attribution à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA d'attribution à conseil d'administration"],
    },
    {
        code: 'B69V',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'Alberta private non-profit company',
        abbreviation: '',
        active: true,
        aliases: ['Alberta private non-profit company'],
    },
    {
        code: 'B6ES',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Public Limited Company',
        abbreviation: 'PLC;P.L.C;plc;p.l.c',
        active: true,
        aliases: [
            'Public Limited Company',
            'PLC;P.L.C;plc;p.l.c',
            'Cwmni Cyfyngedig Cyhoeddus',
            'CCC;C.C.C.',
        ],
    },
    {
        code: 'B7I7',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA coopérative artisanale à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA coopérative artisanale à conseil d'administration"],
    },
    {
        code: 'B843',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Domestic Professional Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Professional Limited Liability Company'],
    },
    {
        code: 'B8CE',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima',
        abbreviation: 'S. A.',
        active: true,
        aliases: ['Sociedad anónima', 'S. A.'],
    },
    {
        code: 'B8KO',
        country: 'US',
        jurisdiction: 'US-PA',
        jurisdictionName: 'Pennsylvania',
        name: 'Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Partnership'],
    },
    {
        code: 'B8OI',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Entidad religiosa',
        abbreviation: '',
        active: true,
        aliases: ['Entidad religiosa'],
    },
    {
        code: 'B8VT',
        country: 'ID',
        jurisdiction: 'ID',
        jurisdictionName: 'Indonesia',
        name: 'Commanditaire Vennootschap',
        abbreviation: 'CV',
        active: true,
        aliases: ['Commanditaire Vennootschap', 'CV'],
    },
    {
        code: 'B8XC',
        country: 'US',
        jurisdiction: 'US-OK',
        jurisdictionName: 'Oklahoma',
        name: 'Limited Liability Company',
        abbreviation: 'L.L.C.;LLC;L.C.;LC',
        active: true,
        aliases: ['Limited Liability Company', 'L.L.C.;LLC;L.C.;LC'],
    },
    {
        code: 'B910',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Vennootschap onder firma met een sociaal oogmerk',
        abbreviation: 'VOF SO',
        active: true,
        aliases: [
            'Vennootschap onder firma met een sociaal oogmerk',
            'VOF SO',
            'Société en nom collectif à finalité sociale',
            'SNC FS',
            'Offene Handelsgesellschaft mit sozialer Zielsetzung',
            'OHGmsZ',
        ],
    },
    {
        code: 'BADE',
        country: 'US',
        jurisdiction: 'US-CA',
        jurisdictionName: 'California',
        name: 'Nonprofit Common Interest Development Association',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Common Interest Development Association'],
    },
    {
        code: 'BAK2',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Exploitation agricole à responsabilité limitée',
        abbreviation: '',
        active: true,
        aliases: ['Exploitation agricole à responsabilité limitée'],
    },
    {
        code: 'BAMJ',
        country: 'SG',
        jurisdiction: 'SG',
        jurisdictionName: 'Singapore',
        name: 'Unlimited Private Company',
        abbreviation: '',
        active: true,
        aliases: ['Unlimited Private Company'],
    },
    {
        code: 'BASA',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'Alberta cooperative',
        abbreviation: '',
        active: true,
        aliases: ['Alberta cooperative'],
    },
    {
        code: 'BAUQ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA de crédit immobilier à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA de crédit immobilier à conseil d'administration"],
    },
    {
        code: 'BB0P',
        country: 'VN',
        jurisdiction: 'VN',
        jurisdictionName: 'Viet Nam',
        name: 'doanh nghiệp tư nhân',
        abbreviation: '',
        active: true,
        aliases: ['doanh nghiệp tư nhân'],
    },
    {
        code: 'BB5Y',
        country: 'SC',
        jurisdiction: 'SC',
        jurisdictionName: 'Seychelles',
        name: 'International Trust',
        abbreviation: '',
        active: true,
        aliases: ['International Trust'],
    },
    {
        code: 'BBB8',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Kommanditärengesellschaft',
        abbreviation: '',
        active: true,
        aliases: ['Kommanditärengesellschaft'],
    },
    {
        code: 'BBEB',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'Europese naamloze vennootschap (Societas Europaea)',
        abbreviation: 'SE;S.E.',
        active: true,
        aliases: ['Europese naamloze vennootschap (Societas Europaea)', 'SE;S.E.'],
    },
    {
        code: 'BC32',
        country: 'US',
        jurisdiction: 'US-CO',
        jurisdictionName: 'Colorado',
        name: 'Limited Partnership Association',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership Association'],
    },
    {
        code: 'BC38',
        country: 'AU',
        jurisdiction: 'AU',
        jurisdictionName: 'Australia',
        name: 'Incorporated association',
        abbreviation: 'Inc;inc;Inc.;inc.',
        active: true,
        aliases: ['Incorporated association', 'Inc;inc;Inc.;inc.'],
    },
    {
        code: 'BCF5',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Δημόσια Εταιρεία Περιορισμένης Ευθύνης με μετοχές',
        abbreviation: '',
        active: true,
        aliases: [
            'Δημόσια Εταιρεία Περιορισμένης Ευθύνης με μετοχές',
            'Dimosia Etaireia Periorismenis Efthynis me metoches',
        ],
    },
    {
        code: 'BCM3',
        country: 'WS',
        jurisdiction: 'WS',
        jurisdictionName: 'Samoa',
        name: 'Credit Union',
        abbreviation: '',
        active: true,
        aliases: ['Credit Union'],
    },
    {
        code: 'BCSV',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Flexible Kapitalgesellschaft',
        abbreviation: 'FlexKapG',
        active: true,
        aliases: ['Flexible Kapitalgesellschaft', 'FlexKapG'],
    },
    {
        code: 'BDDP',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SCP d'infirmiers",
        abbreviation: '',
        active: true,
        aliases: ["SCP d'infirmiers"],
    },
    {
        code: 'BDTI',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '编办直接管理机构编制的群众团体',
        abbreviation: '',
        active: true,
        aliases: [
            '编办直接管理机构编制的群众团体',
            'bian ban zhi jie guan li ji gou bian zhi de qun zhong tuan ti',
        ],
    },
    {
        code: 'BDYL',
        country: 'AM',
        jurisdiction: 'AM',
        jurisdictionName: 'Armenia',
        name: 'Պետական լիազորություններով օժտված իրավաբանական անձ',
        abbreviation: '',
        active: true,
        aliases: [
            'Պետական լիազորություններով օժտված իրավաբանական անձ',
            'Petakan liazorutʿyunnerov ozhdvats iravabanakan andz',
        ],
    },
    {
        code: 'BE3O',
        country: 'US',
        jurisdiction: 'US-MA',
        jurisdictionName: 'Massachusetts',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'BE56',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Avalik-õiguslik juriidiline isik',
        abbreviation: '',
        active: true,
        aliases: ['Avalik-õiguslik juriidiline isik'],
    },
    {
        code: 'BEAN',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: "Société d'investissement à capital fixe",
        abbreviation: 'SICAF',
        active: true,
        aliases: ["Société d'investissement à capital fixe", 'SICAF'],
    },
    {
        code: 'BEAY',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Handelsbolag',
        abbreviation: 'HB',
        active: true,
        aliases: ['Handelsbolag', 'HB'],
    },
    {
        code: 'BEWI',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Association déclarée',
        abbreviation: '',
        active: true,
        aliases: ['Association déclarée'],
    },
    {
        code: 'BF9N',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Federal public company',
        abbreviation: 'Fed. publ. co.',
        active: true,
        aliases: [
            'Federal public company',
            'Fed. publ. co.',
            'Entreprise publique fédérale',
            'Ent. pub. fédérale',
            'Unternehmen des Bundes',
            'öff. Unt. Bund',
            'Impresa pubblica federale',
            'Imp. pubb. federale',
        ],
    },
    {
        code: 'BFIV',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima, casa de cambio',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima, casa de cambio'],
    },
    {
        code: 'BG8P',
        country: 'US',
        jurisdiction: 'US-MS',
        jurisdictionName: 'Mississippi',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'BGH4',
        country: 'US',
        jurisdiction: 'US-OK',
        jurisdictionName: 'Oklahoma',
        name: 'Profit Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.',
        active: true,
        aliases: ['Profit Corporation', 'corp.;inc.;co.;ltd.'],
    },
    {
        code: 'BGPJ',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Europos ekonominių interesų grupės',
        abbreviation: 'EEIG',
        active: true,
        aliases: ['Europos ekonominių interesų grupės', 'EEIG'],
    },
    {
        code: 'BH5D',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'rural utility cooperative',
        abbreviation: '',
        active: true,
        aliases: ['rural utility cooperative'],
    },
    {
        code: 'BI3B',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Agrupacion Europea de Interes Economico',
        abbreviation: 'A.E.I.E.',
        active: true,
        aliases: ['Agrupacion Europea de Interes Economico', 'A.E.I.E.'],
    },
    {
        code: 'BJ2V',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Foreign Professional Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Professional Limited Liability Company'],
    },
    {
        code: 'BJ65',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Pensjonskasse',
        abbreviation: '',
        active: true,
        aliases: ['Pensjonskasse'],
    },
    {
        code: 'BJ8Q',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Egyéni vállalkozás',
        abbreviation: '',
        active: true,
        aliases: ['Egyéni vállalkozás'],
    },
    {
        code: 'BJT3',
        country: 'ID',
        jurisdiction: 'ID',
        jurisdictionName: 'Indonesia',
        name: 'Firma',
        abbreviation: 'Fa',
        active: true,
        aliases: ['Firma', 'Fa'],
    },
    {
        code: 'BKAB',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: "Association d'assurances mutuelles",
        abbreviation: 'AAM',
        active: true,
        aliases: ["Association d'assurances mutuelles", 'AAM'],
    },
    {
        code: 'BKEB',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Oblastný závod poisťovne',
        abbreviation: 'Oblast. závod poisťovne',
        active: true,
        aliases: ['Oblastný závod poisťovne', 'Oblast. závod poisťovne'],
    },
    {
        code: 'BKQO',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Valtio ja sen laitokset',
        abbreviation: '',
        active: true,
        aliases: ['Valtio ja sen laitokset', 'Staten och dess inrättningar'],
    },
    {
        code: 'BKUX',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Zártkörűen működő részvénytársaság',
        abbreviation: 'Zrt.',
        active: true,
        aliases: ['Zártkörűen működő részvénytársaság', 'Zrt.'],
    },
    {
        code: 'BKVI',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Hypoteekkiyhdistys',
        abbreviation: '',
        active: true,
        aliases: ['Hypoteekkiyhdistys', 'Hypoteksförening'],
    },
    {
        code: 'BL4B',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Obecně prospěšná společnost',
        abbreviation: '',
        active: true,
        aliases: ['Obecně prospěšná společnost'],
    },
    {
        code: 'BL52',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società Consortile A Responsabilità Limitata',
        abbreviation: 'S.C.A.R.L.;S.C.R.L.',
        active: true,
        aliases: ['Società Consortile A Responsabilità Limitata', 'S.C.A.R.L.;S.C.R.L.'],
    },
    {
        code: 'BL60',
        country: 'JO',
        jurisdiction: 'JO',
        jurisdictionName: 'Jordan',
        name: 'الشركة المساهمة العامة',
        abbreviation: 'ش.م.ع',
        active: true,
        aliases: ['الشركة المساهمة العامة', 'alsharika almusahama aleama', 'ش.م.ع'],
    },
    {
        code: 'BLVV',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Кредитные потребительские кооперативы',
        abbreviation: '',
        active: true,
        aliases: ['Кредитные потребительские кооперативы', "Kreditnyye potrebitel'skiye kooperativy"],
    },
    {
        code: 'BMYJ',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Egyéb alapítvány',
        abbreviation: '',
        active: true,
        aliases: ['Egyéb alapítvány'],
    },
    {
        code: 'BNYZ',
        country: 'NE',
        jurisdiction: 'NE',
        jurisdictionName: 'Niger',
        name: 'Organisme mutualiste ou mutuel',
        abbreviation: 'MUT',
        active: true,
        aliases: ['Organisme mutualiste ou mutuel', 'MUT'],
    },
    {
        code: 'BO6L',
        country: 'US',
        jurisdiction: 'US-NY',
        jurisdictionName: 'New York',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'BOEX',
        country: 'US',
        jurisdiction: 'US-VA',
        jurisdictionName: 'Virginia',
        name: 'Business Trust',
        abbreviation: '',
        active: true,
        aliases: ['Business Trust'],
    },
    {
        code: 'BOF1',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad en nombre colectivo',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad en nombre colectivo'],
    },
    {
        code: 'BOYK',
        country: 'CA',
        jurisdiction: 'CA-ON',
        jurisdictionName: 'Ontario',
        name: 'Corporations formed by an Act of the Ontario Legislative Assembly',
        abbreviation: '',
        active: true,
        aliases: ['Corporations formed by an Act of the Ontario Legislative Assembly'],
    },
    {
        code: 'BPLS',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Uždarosios akcinės bendrovės',
        abbreviation: 'UAB',
        active: true,
        aliases: ['Uždarosios akcinės bendrovės', 'UAB'],
    },
    {
        code: 'BQ0P',
        country: 'KH',
        jurisdiction: 'KH',
        jurisdictionName: 'Cambodia',
        name: 'Public Limited Company',
        abbreviation: '',
        active: true,
        aliases: [
            'Public Limited Company',
            'ក្រុមហ៊ុនមហាជនទទួលខុសត្រូវមានកម្រិត',
            'kromhoun mhachn ttuolkhosatrauv meanokamrit',
        ],
    },
    {
        code: 'BQ19',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Laivanisännistöyhtiö',
        abbreviation: '',
        active: true,
        aliases: ['Laivanisännistöyhtiö', 'Rederibolag'],
    },
    {
        code: 'BQ3A',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Гаражные и гаражно-строительные кооперативы',
        abbreviation: '',
        active: true,
        aliases: [
            'Гаражные и гаражно-строительные кооперативы',
            "Garazhnyye i garazhno-stroitel'nyye kooperativy",
        ],
    },
    {
        code: 'BQ6L',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Sponsored By Municipal Corporation',
        abbreviation: '',
        active: false,
        aliases: ['Sponsored By Municipal Corporation', 'Entidad Financiera Internacional (CRL)'],
    },
    {
        code: 'BQRL',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Company'],
    },
    {
        code: 'BRGA',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA immobilière d'investissement à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA immobilière d'investissement à conseil d'administration"],
    },
    {
        code: 'BRHI',
        country: 'US',
        jurisdiction: 'US-TN',
        jurisdictionName: 'Tennessee',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'BRO8',
        country: 'US',
        jurisdiction: 'US-AK',
        jurisdictionName: 'Alaska',
        name: 'Business Corporation',
        abbreviation: 'INC',
        active: true,
        aliases: ['Business Corporation', 'INC'],
    },
    {
        code: 'BS22',
        country: 'LV',
        jurisdiction: 'LV',
        jurisdictionName: 'Latvia',
        name: 'Individuālais komersants',
        abbreviation: 'IK',
        active: true,
        aliases: ['Individuālais komersants', 'IK'],
    },
    {
        code: 'BSJT',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'spółka komandytowa',
        abbreviation: 'sp.k.',
        active: true,
        aliases: ['spółka komandytowa', 'sp.k.'],
    },
    {
        code: 'BSK1',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Oktatási intézmények',
        abbreviation: '',
        active: true,
        aliases: ['Oktatási intézmények'],
    },
    {
        code: 'BSLM',
        country: 'US',
        jurisdiction: 'US-MD',
        jurisdictionName: 'Maryland',
        name: 'Limited Partnership',
        abbreviation: 'LP',
        active: true,
        aliases: ['Limited Partnership', 'LP'],
    },
    {
        code: 'BSN7',
        country: 'PA',
        jurisdiction: 'PA',
        jurisdictionName: 'Panama',
        name: 'Asociación',
        abbreviation: '',
        active: true,
        aliases: ['Asociación'],
    },
    {
        code: 'BST2',
        country: 'VG',
        jurisdiction: 'VG',
        jurisdictionName: 'Virgin Islands (British)',
        name: 'company limited by guarantee that is not authorised to issue shares',
        abbreviation: 'Ltd;Corp;Inc;S.A.',
        active: true,
        aliases: [
            'company limited by guarantee that is not authorised to issue shares',
            'Ltd;Corp;Inc;S.A.',
        ],
    },
    {
        code: 'BSZ8',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Stiftung',
        abbreviation: '',
        active: true,
        aliases: ['Stiftung'],
    },
    {
        code: 'BTQ1',
        country: 'US',
        jurisdiction: 'US-OH',
        jurisdictionName: 'Ohio',
        name: 'Corporation (For-Profit)',
        abbreviation: 'company, co.;corporation;corp.;incorporated;inc.',
        active: true,
        aliases: ['Corporation (For-Profit)', 'company, co.;corporation;corp.;incorporated;inc.'],
    },
    {
        code: 'BUMI',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Európska spoločnosť',
        abbreviation: 'SE',
        active: true,
        aliases: ['Európska spoločnosť', 'SE'],
    },
    {
        code: 'BUSK',
        country: 'ID',
        jurisdiction: 'ID',
        jurisdictionName: 'Indonesia',
        name: 'Perusahaan Umum',
        abbreviation: 'Perum',
        active: true,
        aliases: ['Perusahaan Umum', 'Perum'],
    },
    {
        code: 'BVJ0',
        country: 'MT',
        jurisdiction: 'MT',
        jurisdictionName: 'Malta',
        name: 'Partnership en commendite or limited partnership',
        abbreviation: 'LP;limited partnership;Limited Partnership;L.P.',
        active: true,
        aliases: [
            'Partnership en commendite or limited partnership',
            'LP;limited partnership;Limited Partnership;L.P.',
            'Soċjetà in akkomandita jew soċjetà limitata',
            'Limited Partnership;LP;L.P.',
        ],
    },
    {
        code: 'BVOE',
        country: 'GG',
        jurisdiction: 'GG',
        jurisdictionName: 'Guernsey',
        name: 'Limited Company',
        abbreviation: 'Ltd;Ltd.;Limited',
        active: false,
        aliases: ['Limited Company', 'Ltd;Ltd.;Limited'],
    },
    {
        code: 'BVPF',
        country: 'MU',
        jurisdiction: 'MU',
        jurisdictionName: 'Mauritius',
        name: 'Cooperative',
        abbreviation: 'COOP',
        active: true,
        aliases: ['Cooperative', 'COOP'],
    },
    {
        code: 'BW92',
        country: 'KR',
        jurisdiction: 'KR',
        jurisdictionName: 'Korea (Republic of)',
        name: '합자회사',
        abbreviation: '',
        active: true,
        aliases: ['합자회사', 'HabJaHoeSa'],
    },
    {
        code: 'BX6Y',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Friendly Society',
        abbreviation: '',
        active: true,
        aliases: ['Friendly Society'],
    },
    {
        code: 'BXZH',
        country: 'KN',
        jurisdiction: 'KN-N',
        jurisdictionName: 'Nevis',
        name: 'limited partnership',
        abbreviation: '',
        active: true,
        aliases: ['limited partnership'],
    },
    {
        code: 'BY2Z',
        country: 'IL',
        jurisdiction: 'IL',
        jurisdictionName: 'Israel',
        name: 'אגודה שיתופית',
        abbreviation: '',
        active: true,
        aliases: ['אגודה שיתופית', 'Aguda Shitufit'],
    },
    {
        code: 'BYFU',
        country: 'US',
        jurisdiction: 'US-MA',
        jurisdictionName: 'Massachusetts',
        name: 'Limited Liability Company',
        abbreviation: 'Limited Liability Company;LLC;L.L.C;Limited Company;LC;L.C.',
        active: true,
        aliases: [
            'Limited Liability Company',
            'Limited Liability Company;LLC;L.L.C;Limited Company;LC;L.C.',
        ],
    },
    {
        code: 'BYQJ',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Bankaktiebolag',
        abbreviation: 'BAB',
        active: true,
        aliases: ['Bankaktiebolag', 'BAB'],
    },
    {
        code: 'BYZF',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Paroisse hors zone concordataire',
        abbreviation: '',
        active: true,
        aliases: ['Paroisse hors zone concordataire'],
    },
    {
        code: 'BZQL',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Организационно-правовые формы для деятельности граждан (физических лиц)',
        abbreviation: '',
        active: true,
        aliases: [
            'Организационно-правовые формы для деятельности граждан (физических лиц)',
            "Organizatsionno-pravovyye formy dlya deyatel'nosti grazhdan (fizicheskikh lits)",
        ],
    },
    {
        code: 'C061',
        country: 'MT',
        jurisdiction: 'MT',
        jurisdictionName: 'Malta',
        name: 'Public Limited Liability Company',
        abbreviation: 'PLC;P.L.C;plc;p.l.c.',
        active: true,
        aliases: ['Public Limited Liability Company', 'PLC;P.L.C;plc;p.l.c.', 'kumpanija pubblika'],
    },
    {
        code: 'C0CR',
        country: 'US',
        jurisdiction: 'US-WI',
        jurisdictionName: 'Wisconsin',
        name: 'Cooperative Association',
        abbreviation: '',
        active: true,
        aliases: ['Cooperative Association'],
    },
    {
        code: 'C0VE',
        country: 'US',
        jurisdiction: 'US-AK',
        jurisdictionName: 'Alaska',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'C1F4',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Domestic Public Benefit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Public Benefit Corporation'],
    },
    {
        code: 'C1IC',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società Cooperativa Consortile',
        abbreviation: '',
        active: true,
        aliases: ['Società Cooperativa Consortile'],
    },
    {
        code: 'C276',
        country: 'US',
        jurisdiction: 'US-SD',
        jurisdictionName: 'South Dakota',
        name: 'Limited Liability Company',
        abbreviation: 'L.L.C.;LLC;L.C.;LC',
        active: true,
        aliases: ['Limited Liability Company', 'L.L.C.;LLC;L.C.;LC'],
    },
    {
        code: 'C2O4',
        country: 'US',
        jurisdiction: 'US-RI',
        jurisdictionName: 'Rhode island',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'C38B',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '其他（外交）',
        abbreviation: '',
        active: true,
        aliases: ['其他（外交）', 'qi ta（ wai jiao ）'],
    },
    {
        code: 'C3RQ',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Организационно-правовые формы юридических лиц, являющихся коммерческими корпоративными организациями',
        abbreviation: '',
        active: true,
        aliases: [
            'Организационно-правовые формы юридических лиц, являющихся коммерческими корпоративными организациями',
            'Organizatsionno-pravovyyу formy yuridicheskikh lits, yavlyayushchikhsya kommercheskimi korporativnymi organizatsiyami',
        ],
    },
    {
        code: 'C42J',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SARL immobilière de gestion',
        abbreviation: '',
        active: true,
        aliases: ['SARL immobilière de gestion'],
    },
    {
        code: 'C4D7',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Ensemble urbain',
        abbreviation: '',
        active: true,
        aliases: ['Ensemble urbain'],
    },
    {
        code: 'C4PZ',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Podnikateľ-fyzická osoba-nezapísaný v obchodnom registri',
        abbreviation: 'Živnostník',
        active: true,
        aliases: ['Podnikateľ-fyzická osoba-nezapísaný v obchodnom registri', 'Živnostník'],
    },
    {
        code: 'C4Q2',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Všeobecná zdravotní pojišťovna',
        abbreviation: '',
        active: true,
        aliases: ['Všeobecná zdravotní pojišťovna'],
    },
    {
        code: 'C4Z4',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Asociación rural de interés colectivo',
        abbreviation: '',
        active: true,
        aliases: ['Asociación rural de interés colectivo'],
    },
    {
        code: 'C51L',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Eurooppalainen taloudellinen etuyhtymä sivutoimipaikka',
        abbreviation: '',
        active: true,
        aliases: [
            'Eurooppalainen taloudellinen etuyhtymä sivutoimipaikka',
            'Filial för en europeisk ekonomisk intressegrupp',
        ],
    },
    {
        code: 'C58S',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'Company Limited by Guarantee',
        abbreviation: 'CLG',
        active: true,
        aliases: [
            'Company Limited by Guarantee',
            'CLG',
            'Cuideachta faoi Theorainn Ráthaíochta',
            'ctr',
        ],
    },
    {
        code: 'C5FE',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Samostatná drobná provozovna (obecního úřadu)',
        abbreviation: '',
        active: true,
        aliases: ['Samostatná drobná provozovna (obecního úřadu)'],
    },
    {
        code: 'C5K7',
        country: 'US',
        jurisdiction: 'US-TX',
        jurisdictionName: 'Texas',
        name: 'For-Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['For-Profit Corporation'],
    },
    {
        code: 'C605',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Private Limited by Shares (Section 30 Exemption)',
        abbreviation: '',
        active: false,
        aliases: ['Private Limited by Shares (Section 30 Exemption)'],
    },
    {
        code: 'C609',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Eenpersoons besloten vennootschap met beperkte aansprakelijkheid',
        abbreviation: 'EBVBA',
        active: true,
        aliases: [
            'Eenpersoons besloten vennootschap met beperkte aansprakelijkheid',
            'EBVBA',
            'Société privée à responsabilité limitée unipersonnelle',
            'SPRLU',
            'Privatgesellschaft mit beschränkter Haftung mit einem Alleingesellschafter',
            'PGmbHmA',
        ],
    },
    {
        code: 'C61P',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Ekonomisk förening',
        abbreviation: 'Ek. för.',
        active: true,
        aliases: ['Ekonomisk förening', 'Ek. för.'],
    },
    {
        code: 'C639',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Industrial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Industrial Bank'],
    },
    {
        code: 'C6AH',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Cooperativa',
        abbreviation: '',
        active: true,
        aliases: ['Cooperativa'],
    },
    {
        code: 'C7GZ',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Výrobní družstvo',
        abbreviation: '',
        active: true,
        aliases: ['Výrobní družstvo'],
    },
    {
        code: 'C7TI',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Ассоциации (союзы) садоводческих, огороднических и дачных некоммерческих объединений',
        abbreviation: '',
        active: true,
        aliases: [
            'Ассоциации (союзы) садоводческих, огороднических и дачных некоммерческих объединений',
            'Assotsiatsii (soyuzy) sadovodcheskikh, ogorodnicheskikh i dachnykh nekommercheskikh ob"yedineniy',
        ],
    },
    {
        code: 'C8HJ',
        country: 'US',
        jurisdiction: 'US-TN',
        jurisdictionName: 'Tennessee',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'C907',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Youth Cooperative',
        abbreviation: '',
        active: false,
        aliases: ['Youth Cooperative', 'Sociedad de Responsabilidad Limitada'],
    },
    {
        code: 'C9KZ',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'Alberta professional corporation',
        abbreviation: '',
        active: true,
        aliases: ['Alberta professional corporation'],
    },
    {
        code: 'CAF9',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima, centro cambiario',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima, centro cambiario'],
    },
    {
        code: 'CAGH',
        country: 'US',
        jurisdiction: 'US-MA',
        jurisdictionName: 'Massachusetts',
        name: 'Limited Liability Partnership',
        abbreviation: 'Registered Limited Liability Partnership;Limited Liability Partnership;L.L.P.;LLP',
        active: true,
        aliases: [
            'Limited Liability Partnership',
            'Registered Limited Liability Partnership;Limited Liability Partnership;L.L.P.;LLP',
        ],
    },
    {
        code: 'CANT',
        country: 'US',
        jurisdiction: 'US-KS',
        jurisdictionName: 'Kansas',
        name: 'Professional Association',
        abbreviation: 'P.A.;PA',
        active: true,
        aliases: ['Professional Association', 'P.A.;PA'],
    },
    {
        code: 'CAQ1',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Versicherungsverein auf Gegenseitigkeit',
        abbreviation: '',
        active: true,
        aliases: ['Versicherungsverein auf Gegenseitigkeit'],
    },
    {
        code: 'CATU',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Spolek',
        abbreviation: '',
        active: true,
        aliases: ['Spolek'],
    },
    {
        code: 'CAX5',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Régime général de la Sécurité Sociale',
        abbreviation: '',
        active: true,
        aliases: ['Régime général de la Sécurité Sociale'],
    },
    {
        code: 'CB98',
        country: 'GI',
        jurisdiction: 'GI',
        jurisdictionName: 'Gibraltar',
        name: 'Foundations',
        abbreviation: '',
        active: true,
        aliases: ['Foundations'],
    },
    {
        code: 'CBO2',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Service du ministère de la Défense',
        abbreviation: '',
        active: true,
        aliases: ['Service du ministère de la Défense'],
    },
    {
        code: 'CD28',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Společnost komanditní',
        abbreviation: '',
        active: true,
        aliases: ['Společnost komanditní'],
    },
    {
        code: 'CD8F',
        country: 'LS',
        jurisdiction: 'LS',
        jurisdictionName: 'Lesotho',
        name: 'Non-profit Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-profit Company'],
    },
    {
        code: 'CD96',
        country: 'US',
        jurisdiction: 'US-OK',
        jurisdictionName: 'Oklahoma',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'CD9O',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Domestic Limited Liability Company',
        abbreviation: 'limited liability company;L.L.C.;L.C.',
        active: true,
        aliases: ['Domestic Limited Liability Company', 'limited liability company;L.L.C.;L.C.'],
    },
    {
        code: 'CDOT',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'UK Establishment',
        abbreviation: 'BR',
        active: false,
        aliases: ['UK Establishment', 'BR'],
    },
    {
        code: 'CDOV',
        country: 'AG',
        jurisdiction: 'AG',
        jurisdictionName: 'Antigua and Barbuda',
        name: 'International Business Corporation',
        abbreviation: '',
        active: true,
        aliases: ['International Business Corporation'],
    },
    {
        code: 'CDXK',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Company'],
    },
    {
        code: 'CDYY',
        country: 'SC',
        jurisdiction: 'SC',
        jurisdictionName: 'Seychelles',
        name: 'Company Limited by Guarantee',
        abbreviation: '',
        active: true,
        aliases: ['Company Limited by Guarantee'],
    },
    {
        code: 'CF56',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Mutualité sociale agricole',
        abbreviation: '',
        active: true,
        aliases: ['Mutualité sociale agricole'],
    },
    {
        code: 'CF5L',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Ansvarlig selskap, delt ansvar',
        abbreviation: 'DA',
        active: true,
        aliases: ['Ansvarlig selskap, delt ansvar', 'DA'],
    },
    {
        code: 'CFH5',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Vennootschap of vereniging zonder rechtspersoonlijkheid',
        abbreviation: 'VVZRL',
        active: true,
        aliases: [
            'Vennootschap of vereniging zonder rechtspersoonlijkheid',
            'VVZRL',
            'Société ou association sans personnalité juridique',
            'SASPJ',
            'Gesellschaften oder Vereinigungen ohne Rechtspersönlichkeit',
            'GVoRP',
        ],
    },
    {
        code: 'CG81',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur la Société d’habitation du Québec',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur la Société d’habitation du Québec'],
    },
    {
        code: 'CGSO',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società in Accomandita Semplice',
        abbreviation: '',
        active: true,
        aliases: ['Società in Accomandita Semplice'],
    },
    {
        code: 'CHJR',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Podnik se zahraniční majetkovou účastí',
        abbreviation: '',
        active: true,
        aliases: ['Podnik se zahraniční majetkovou účastí'],
    },
    {
        code: 'CHWX',
        country: 'VI',
        jurisdiction: 'VI',
        jurisdictionName: 'Virgin Islands (U.S.)',
        name: 'Domestic Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Limited Liability Company'],
    },
    {
        code: 'CHX6',
        country: 'PE',
        jurisdiction: 'PE',
        jurisdictionName: 'Peru',
        name: 'Sociedad Anónima Cerrada',
        abbreviation: 'SAC',
        active: true,
        aliases: ['Sociedad Anónima Cerrada', 'SAC'],
    },
    {
        code: 'CIO8',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Veřejná výzkumná instituce',
        abbreviation: '',
        active: true,
        aliases: ['Veřejná výzkumná instituce'],
    },
    {
        code: 'CIUP',
        country: 'NE',
        jurisdiction: 'NE',
        jurisdictionName: 'Niger',
        name: 'Société multinationale',
        abbreviation: 'MULTI',
        active: true,
        aliases: ['Société multinationale', 'MULTI'],
    },
    {
        code: 'CJ58',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Cooperative Association',
        abbreviation: 'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation;coop.;cooperative',
        active: true,
        aliases: [
            'Cooperative Association',
            'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation;coop.;cooperative',
        ],
    },
    {
        code: 'CJO4',
        country: 'OM',
        jurisdiction: 'OM',
        jurisdictionName: 'Oman',
        name: 'الشركة محدودة المسؤولية ',
        abbreviation: '',
        active: true,
        aliases: ['الشركة محدودة المسؤولية ', 'alsharikat mahdudat almaswuwlia'],
    },
    {
        code: 'CKOS',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Usuline ühendus',
        abbreviation: '',
        active: true,
        aliases: ['Usuline ühendus'],
    },
    {
        code: 'CKTA',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Некоммерческие партнерства',
        abbreviation: '',
        active: true,
        aliases: ['Некоммерческие партнерства', 'Nekommercheskiye partnerstva'],
    },
    {
        code: 'CMB6',
        country: 'CA',
        jurisdiction: 'CA-ON',
        jurisdictionName: 'Ontario',
        name: 'Not-For-Profit corporations',
        abbreviation: '',
        active: true,
        aliases: ['Not-For-Profit corporations'],
    },
    {
        code: 'CMHQ',
        country: 'IS',
        jurisdiction: 'IS',
        jurisdictionName: 'Iceland',
        name: 'Evrópufélag',
        abbreviation: 'SE',
        active: true,
        aliases: ['Evrópufélag', 'SE'],
    },
    {
        code: 'CN7I',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Фонды проката',
        abbreviation: '',
        active: true,
        aliases: ['Фонды проката', 'Fondy prokata'],
    },
    {
        code: 'CNQ3',
        country: 'US',
        jurisdiction: 'US-DC',
        jurisdictionName: 'District of Columbia',
        name: 'Business Corporation (including professional corporation)',
        abbreviation: 'Corp.;Inc.;Co.;Ltd.;P.C.;Chtd',
        active: true,
        aliases: [
            'Business Corporation (including professional corporation)',
            'Corp.;Inc.;Co.;Ltd.;P.C.;Chtd',
        ],
    },
    {
        code: 'CNSS',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société en participation de professions libérales',
        abbreviation: '',
        active: true,
        aliases: ['Société en participation de professions libérales'],
    },
    {
        code: 'CNXL',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Artisan-commerçant',
        abbreviation: '',
        active: false,
        aliases: ['Artisan-commerçant'],
    },
    {
        code: 'CODH',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'commanditaire vennootschap',
        abbreviation: 'CV;cv;C.V.;c.v.',
        active: true,
        aliases: ['commanditaire vennootschap', 'CV;cv;C.V.;c.v.'],
    },
    {
        code: 'COKS',
        country: 'US',
        jurisdiction: 'US-IL',
        jurisdictionName: 'Illinois',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'COVJ',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Organismo de integración financiera rural',
        abbreviation: '',
        active: true,
        aliases: ['Organismo de integración financiera rural'],
    },
    {
        code: 'COZR',
        country: 'MY',
        jurisdiction: 'MY',
        jurisdictionName: 'Malaysia',
        name: 'Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Partnership'],
    },
    {
        code: 'CPK1',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Mutual Aid Cooperative',
        abbreviation: 'coop;co-op',
        active: true,
        aliases: ['Mutual Aid Cooperative', 'coop;co-op'],
    },
    {
        code: 'CPNU',
        country: 'MM',
        jurisdiction: 'MM',
        jurisdictionName: 'Myanmar',
        name: 'စီးပွားရေးလုပ်ငန်းအသင်းအဖွဲ့၊',
        abbreviation: '',
        active: true,
        aliases: ['စီးပွားရေးလုပ်ငန်းအသင်းအဖွဲ့၊', 'hceepwarrrayylotengaann aasainnaahpwal'],
    },
    {
        code: 'CQ5X',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Ευρωπαϊκή Εταιρεία',
        abbreviation: 'SE',
        active: true,
        aliases: ['Ευρωπαϊκή Εταιρεία', 'Εvropaiki Εtaireia', 'SE'],
    },
    {
        code: 'CQJI',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Région',
        abbreviation: '',
        active: true,
        aliases: ['Région'],
    },
    {
        code: 'CQMY',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Limited partnership',
        abbreviation: 'Ltd partnership',
        active: true,
        aliases: [
            'Limited partnership',
            'Ltd partnership',
            'Société en commandite',
            'SCm',
            'Kommanditgesellschaft',
            'KmG',
            'Società in accomandita',
            'SAc',
        ],
    },
    {
        code: 'CR3H',
        country: 'US',
        jurisdiction: 'US-AL',
        jurisdictionName: 'Alabama',
        name: 'Registered Limited Liability Partnership',
        abbreviation: 'L.L.P.;LLP',
        active: true,
        aliases: ['Registered Limited Liability Partnership', 'L.L.P.;LLP'],
    },
    {
        code: 'CR7N',
        country: 'MT',
        jurisdiction: 'MT',
        jurisdictionName: 'Malta',
        name: 'European Company',
        abbreviation: 'SE',
        active: true,
        aliases: ['European Company', 'SE', 'Societas Europaea'],
    },
    {
        code: 'CRL9',
        country: 'AW',
        jurisdiction: 'AW',
        jurisdictionName: 'Aruba',
        name: 'Stichting',
        abbreviation: '',
        active: true,
        aliases: ['Stichting'],
    },
    {
        code: 'CRX3',
        country: 'XK',
        jurisdiction: 'XK',
        jurisdictionName: 'Kosovo',
        name: 'Kooperativa Bujqësore',
        abbreviation: 'KB',
        active: true,
        aliases: ['Kooperativa Bujqësore', 'KB'],
    },
    {
        code: 'CS15',
        country: 'CA',
        jurisdiction: 'CA-NT',
        jurisdictionName: 'Northwest Territories',
        name: 'NT society',
        abbreviation: '',
        active: true,
        aliases: ['NT society'],
    },
    {
        code: 'CS8B',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Štátna hospodárska organizácia riadená okresným úradom',
        abbreviation: 'Štát.hosp.org.riad.okr.',
        active: true,
        aliases: ['Štátna hospodárska organizácia riadená okresným úradom', 'Štát.hosp.org.riad.okr.'],
    },
    {
        code: 'CSUT',
        country: 'BJ',
        jurisdiction: 'BJ',
        jurisdictionName: 'Benin',
        name: 'Société Anonyme',
        abbreviation: 'SA',
        active: true,
        aliases: ['Société Anonyme', 'SA'],
    },
    {
        code: 'CT3J',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: "Personne morale sans but lucratif par Loi sur les compagnies (Partie II et Partie III), Code des professions, Loi concernant le regroupement et la gestion des commissions scolaires , Loi sur l’aménagement et l’urbanisme, Loi sur l’instruction publique, Loi sur l’organisation municipale de certains territoires, Loi sur la conservation de la faune, Loi sur la conservation et la mise en valeur de la faune, Loi sur la constitution de certaines Églises, Loi sur la Fédération des guides catholiques du Québec , Loi sur la Fédération des scouts catholiques du Québec , Loi sur la formation et la qualification professionnelles de la main-d’œuvre, Loi sur la mise en marché des produits agricoles, alimentaires et de la pêche, Loi sur la mise en marché des produits agricoles, Loi sur la probation et sur les établissements de détention, Loi sur la santé et la sécurité du travail, Loi sur la Société d’habitation du Québec, Loi sur la société Saint-Jean-Baptiste de Trois-Rivières, Loi sur la société Saint-Jean-Baptiste du Québec, Loi sur les associations coopératives, Loi sur les assurances, Loi sur les cercles agricoles, Loi sur les Chevaliers de Colomb de la province de Québec, Loi sur les cités et villes, Loi sur les clubs de chasse et de pêche, Loi sur les clubs de récréation, Loi sur les collèges d'enseignement général et professionnel, Loi sur les compagnies de cimetière, Loi sur les compagnies de cimetières catholiques romains, Loi sur les corporations de fonds de sécurité, Loi sur les corporations religieuses, Loi sur les décrets de convention collective, Loi sur les évêques catholiques romains, Loi sur les fabriques, Loi sur les services correctionnels, Loi sur les services de santé et les services sociaux pour les autochtones cris, Loi sur les services de santé et les services sociaux, Loi sur les sociétés agricoles et laitières, Loi sur les sociétés d'agriculture, Loi sur les sociétés d'horticulture, Loi sur les sociétés nationales de bienfaisance, Loi sur les syndicats professionnels, Loi sur les villages miniers, Loi sur les villages nordiques et l’Administration régionale Kativik, Loi sur les villes minières, Loi sur l'organisation territoriale municipale, Loi sur les sociétés préventives de cruauté envers les animaux",
        abbreviation: '',
        active: false,
        aliases: [
            "Personne morale sans but lucratif par Loi sur les compagnies (Partie II et Partie III), Code des professions, Loi concernant le regroupement et la gestion des commissions scolaires , Loi sur l’aménagement et l’urbanisme, Loi sur l’instruction publique, Loi sur l’organisation municipale de certains territoires, Loi sur la conservation de la faune, Loi sur la conservation et la mise en valeur de la faune, Loi sur la constitution de certaines Églises, Loi sur la Fédération des guides catholiques du Québec , Loi sur la Fédération des scouts catholiques du Québec , Loi sur la formation et la qualification professionnelles de la main-d’œuvre, Loi sur la mise en marché des produits agricoles, alimentaires et de la pêche, Loi sur la mise en marché des produits agricoles, Loi sur la probation et sur les établissements de détention, Loi sur la santé et la sécurité du travail, Loi sur la Société d’habitation du Québec, Loi sur la société Saint-Jean-Baptiste de Trois-Rivières, Loi sur la société Saint-Jean-Baptiste du Québec, Loi sur les associations coopératives, Loi sur les assurances, Loi sur les cercles agricoles, Loi sur les Chevaliers de Colomb de la province de Québec, Loi sur les cités et villes, Loi sur les clubs de chasse et de pêche, Loi sur les clubs de récréation, Loi sur les collèges d'enseignement général et professionnel, Loi sur les compagnies de cimetière, Loi sur les compagnies de cimetières catholiques romains, Loi sur les corporations de fonds de sécurité, Loi sur les corporations religieuses, Loi sur les décrets de convention collective, Loi sur les évêques catholiques romains, Loi sur les fabriques, Loi sur les services correctionnels, Loi sur les services de santé et les services sociaux pour les autochtones cris, Loi sur les services de santé et les services sociaux, Loi sur les sociétés agricoles et laitières, Loi sur les sociétés d'agriculture, Loi sur les sociétés d'horticulture, Loi sur les sociétés nationales de bienfaisance, Loi sur les syndicats professionnels, Loi sur les villages miniers, Loi sur les villages nordiques et l’Administration régionale Kativik, Loi sur les villes minières, Loi sur l'organisation territoriale municipale, Loi sur les sociétés préventives de cruauté envers les animaux",
        ],
    },
    {
        code: 'CTBD',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Alte forme de proprietate',
        abbreviation: '',
        active: true,
        aliases: ['Alte forme de proprietate'],
    },
    {
        code: 'CTCH',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Кооперация',
        abbreviation: '',
        active: true,
        aliases: ['Кооперация', 'Kooperatsia', 'Coop'],
    },
    {
        code: 'CTNS',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società Cooperativa a Responsabilità Limitata',
        abbreviation: '',
        active: true,
        aliases: ['Società Cooperativa a Responsabilità Limitata'],
    },
    {
        code: 'CU5R',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Asociación ganadera local general',
        abbreviation: '',
        active: true,
        aliases: ['Asociación ganadera local general'],
    },
    {
        code: 'CU68',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad cooperativa limitada de capital variable',
        abbreviation: 'S.C.L. de C.V.',
        active: true,
        aliases: ['Sociedad cooperativa limitada de capital variable', 'S.C.L. de C.V.'],
    },
    {
        code: 'CUGP',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Regie autonomă',
        abbreviation: 'RA',
        active: true,
        aliases: ['Regie autonomă', 'RA'],
    },
    {
        code: 'CUIH',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Mutua',
        abbreviation: '',
        active: true,
        aliases: ['Mutua'],
    },
    {
        code: 'CUKQ',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Mezinárodní organizace zaměstnavatelů',
        abbreviation: '',
        active: true,
        aliases: ['Mezinárodní organizace zaměstnavatelů'],
    },
    {
        code: 'CUQF',
        country: 'CA',
        jurisdiction: 'CA-PE',
        jurisdictionName: 'Prince Edward Island',
        name: 'public unlimited liability corporation',
        abbreviation: 'ULC',
        active: true,
        aliases: ['public unlimited liability corporation', 'ULC'],
    },
    {
        code: 'CVDP',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Sociedad de Responsabilidad Limitada',
        abbreviation: 'SRL',
        active: true,
        aliases: ['Sociedad de Responsabilidad Limitada', 'SRL'],
    },
    {
        code: 'CVH6',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SARL d'aménagement foncier et d'équipement rural (SAFER)",
        abbreviation: '',
        active: true,
        aliases: ["SARL d'aménagement foncier et d'équipement rural (SAFER)"],
    },
    {
        code: 'CVXK',
        country: 'US',
        jurisdiction: 'US-CA',
        jurisdictionName: 'California',
        name: 'Nonprofit Corporation Religious',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation Religious'],
    },
    {
        code: 'CW38',
        country: 'BM',
        jurisdiction: 'BM',
        jurisdictionName: 'Bermuda',
        name: 'Local Company Limited by Guarantee',
        abbreviation: '',
        active: true,
        aliases: ['Local Company Limited by Guarantee'],
    },
    {
        code: 'CWRI',
        country: 'US',
        jurisdiction: 'US-AL',
        jurisdictionName: 'Alabama',
        name: 'Limited Liability Company',
        abbreviation: 'L.L.C.;LLC',
        active: true,
        aliases: ['Limited Liability Company', 'L.L.C.;LLC'],
    },
    {
        code: 'CWTQ',
        country: 'MC',
        jurisdiction: 'MC',
        jurisdictionName: 'Monaco',
        name: 'Société Anonyme Monégasque',
        abbreviation: 'SAM',
        active: true,
        aliases: ['Société Anonyme Monégasque', 'SAM'],
    },
    {
        code: 'CX05',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Kommanditbolag',
        abbreviation: 'KB',
        active: true,
        aliases: ['Kommanditbolag', 'KB'],
    },
    {
        code: 'CXIO',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Domesticated Foreign Corporation Professional Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Domesticated Foreign Corporation Professional Corporation'],
    },
    {
        code: 'CXWJ',
        country: 'ZA',
        jurisdiction: 'ZA',
        jurisdictionName: 'South Africa',
        name: 'Co-operatives (Secondary)',
        abbreviation: '',
        active: true,
        aliases: ['Co-operatives (Secondary)'],
    },
    {
        code: 'CY1M',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'instytucje gospodarki budżetowej',
        abbreviation: '',
        active: true,
        aliases: ['instytucje gospodarki budżetowej'],
    },
    {
        code: 'CYV6',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '其他（中央军委改革和编制办公室）',
        abbreviation: '',
        active: true,
        aliases: [
            '其他（中央军委改革和编制办公室）',
            'qi ta（ zhong yang jun wei gai ge he bian zhi ban gong shi ）',
        ],
    },
    {
        code: 'CYW2',
        country: 'AW',
        jurisdiction: 'AW',
        jurisdictionName: 'Aruba',
        name: 'Vennootschap onder firma',
        abbreviation: 'VOF;vof;V.O.F.;v.o.f.',
        active: true,
        aliases: ['Vennootschap onder firma', 'VOF;vof;V.O.F.;v.o.f.'],
    },
    {
        code: 'CZCE',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Sociedad Colectiva Comercial',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad Colectiva Comercial'],
    },
    {
        code: 'CZPI',
        country: 'VN',
        jurisdiction: 'VN',
        jurisdictionName: 'Viet Nam',
        name: 'doanh nghiệp nhà nước',
        abbreviation: '',
        active: true,
        aliases: ['doanh nghiệp nhà nước'],
    },
    {
        code: 'CZUA',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Zahraniční fyzická osoba',
        abbreviation: '',
        active: true,
        aliases: ['Zahraniční fyzická osoba'],
    },
    {
        code: 'D094',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Экологические фонды',
        abbreviation: '',
        active: true,
        aliases: ['Экологические фонды', 'Ekologicheskiye fondy'],
    },
    {
        code: 'D155',
        country: 'US',
        jurisdiction: 'US-FL',
        jurisdictionName: 'Florida',
        name: 'Limited Liability Limited Partnership',
        abbreviation: 'L.L.L.P.; LLLP',
        active: true,
        aliases: ['Limited Liability Limited Partnership', 'L.L.L.P.; LLLP'],
    },
    {
        code: 'D18J',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Jednoduchá spoločnosť na akcie',
        abbreviation: 'Jednoduchá spol. na akcie',
        active: true,
        aliases: ['Jednoduchá spoločnosť na akcie', 'Jednoduchá spol. na akcie'],
    },
    {
        code: 'D1IZ',
        country: 'NE',
        jurisdiction: 'NE',
        jurisdictionName: 'Niger',
        name: 'Coopérative',
        abbreviation: 'COOP',
        active: true,
        aliases: ['Coopérative', 'COOP'],
    },
    {
        code: 'D1SL',
        country: 'BZ',
        jurisdiction: 'BZ',
        jurisdictionName: 'Belize',
        name: 'Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Partnership'],
    },
    {
        code: 'D1VK',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Školská právnická osoba',
        abbreviation: '',
        active: true,
        aliases: ['Školská právnická osoba'],
    },
    {
        code: 'D2EI',
        country: 'US',
        jurisdiction: 'US-SC',
        jurisdictionName: 'South Carolina',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'D2I2',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Syndicat intercommunal à vocation multiple (SIVOM)',
        abbreviation: '',
        active: true,
        aliases: ['Syndicat intercommunal à vocation multiple (SIVOM)'],
    },
    {
        code: 'D2MO',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Joint Public Agency',
        abbreviation: '',
        active: true,
        aliases: ['Joint Public Agency'],
    },
    {
        code: 'D2T3',
        country: 'CO',
        jurisdiction: 'CO',
        jurisdictionName: 'Colombia',
        name: 'Empresa Asociativa de Trabajo',
        abbreviation: '',
        active: true,
        aliases: ['Empresa Asociativa de Trabajo'],
    },
    {
        code: 'D2T8',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les compagnies (Partie II et Partie III)',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur les compagnies (Partie II et Partie III)',
        ],
    },
    {
        code: 'D35X',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Zahraniční spolek',
        abbreviation: '',
        active: true,
        aliases: ['Zahraniční spolek'],
    },
    {
        code: 'D37H',
        country: 'XK',
        jurisdiction: 'XK',
        jurisdictionName: 'Kosovo',
        name: 'Shoqëri me Përgjegjësi të Kufizuar',
        abbreviation: 'SHPK',
        active: true,
        aliases: ['Shoqëri me Përgjegjësi të Kufizuar', 'SHPK'],
    },
    {
        code: 'D3E0',
        country: 'AR',
        jurisdiction: 'AR',
        jurisdictionName: 'Argentina',
        name: 'Sociedad de Capital e Industria',
        abbreviation: 'S.C.e I.',
        active: true,
        aliases: ['Sociedad de Capital e Industria', 'S.C.e I.'],
    },
    {
        code: 'D3UY',
        country: 'KH',
        jurisdiction: 'KH',
        jurisdictionName: 'Cambodia',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: [
            'Limited Partnership',
            'ក្រុមហ៊ុនសហកម្មសិទ្ធិមានកម្រិត',
            'kromhoun sahakammosetthi meanokamrit',
        ],
    },
    {
        code: 'D40E',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Verein alten Rechts',
        abbreviation: '',
        active: true,
        aliases: ['Verein alten Rechts'],
    },
    {
        code: 'D4KQ',
        country: 'TR',
        jurisdiction: 'TR',
        jurisdictionName: 'Türkiye',
        name: 'özel mevzuat ile kurulmuş kuruluş',
        abbreviation: '',
        active: true,
        aliases: ['özel mevzuat ile kurulmuş kuruluş'],
    },
    {
        code: 'D4PU',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Frivillig forening',
        abbreviation: '',
        active: true,
        aliases: ['Frivillig forening'],
    },
    {
        code: 'D4YS',
        country: 'US',
        jurisdiction: 'US-AK',
        jurisdictionName: 'Alaska',
        name: 'Limited Liability Company',
        abbreviation: 'L.L.C.;LLC',
        active: true,
        aliases: ['Limited Liability Company', 'L.L.C.;LLC'],
    },
    {
        code: 'D5L6',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Consumer Cooperative',
        abbreviation: '',
        active: false,
        aliases: ['Consumer Cooperative', 'Centro Bancario Internacional (CRL)'],
    },
    {
        code: 'D64E',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Gospodarska zbornica',
        abbreviation: '',
        active: true,
        aliases: ['Gospodarska zbornica'],
    },
    {
        code: 'D6JI',
        country: 'US',
        jurisdiction: 'US-NY',
        jurisdictionName: 'New York',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'D7OA',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Entidade Empresarial Municipal',
        abbreviation: '',
        active: true,
        aliases: ['Entidade Empresarial Municipal'],
    },
    {
        code: 'D84J',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Общественные организации',
        abbreviation: '',
        active: true,
        aliases: ['Общественные организации', 'Obshchestvennyye organizatsii'],
    },
    {
        code: 'D87D',
        country: 'TH',
        jurisdiction: 'TH',
        jurisdictionName: 'Thailand',
        name: 'มูลนิธิจดทะเบียน',
        abbreviation: '',
        active: true,
        aliases: ['มูลนิธิจดทะเบียน', 'Mūlniṭhi cdthabeīyn'],
    },
    {
        code: 'D8PB',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'Business Development Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Business Development Corporation'],
    },
    {
        code: 'D8UQ',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'professional corporation',
        abbreviation: 'P.C.',
        active: false,
        aliases: ['professional corporation', 'P.C.'],
    },
    {
        code: 'D8XQ',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Municipal Enterprise',
        abbreviation: '',
        active: true,
        aliases: ['Municipal Enterprise', 'Empressa Municipal'],
    },
    {
        code: 'D90J',
        country: 'CA',
        jurisdiction: 'CA',
        jurisdictionName: 'Canada',
        name: 'corporation without share capital',
        abbreviation: '',
        active: true,
        aliases: ['corporation without share capital', 'organisation sans capital-actions'],
    },
    {
        code: 'D92T',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Limited Liability Partnership',
        abbreviation: 'Limited Liability Partnership;LLP',
        active: true,
        aliases: ['Limited Liability Partnership', 'Limited Liability Partnership;LLP'],
    },
    {
        code: 'DA06',
        country: 'MC',
        jurisdiction: 'MC',
        jurisdictionName: 'Monaco',
        name: 'Société à Responsabilité Limitée',
        abbreviation: 'SARL',
        active: true,
        aliases: ['Société à Responsabilité Limitée', 'SARL'],
    },
    {
        code: 'DAEG',
        country: 'BS',
        jurisdiction: 'BS',
        jurisdictionName: 'Bahamas',
        name: 'Unlimited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Unlimited Liability Company'],
    },
    {
        code: 'DAFV',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Vakuutusosakeyhtiö',
        abbreviation: '',
        active: true,
        aliases: ['Vakuutusosakeyhtiö', 'Försäkringsaktiebolag'],
    },
    {
        code: 'DAQC',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Základná škola',
        abbreviation: '',
        active: true,
        aliases: ['Základná škola'],
    },
    {
        code: 'DAVB',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'Corporation (non-profit)',
        abbreviation: 'CORPORATION;COMPANY;LIMITED;CORP;INC;CO;LTD',
        active: true,
        aliases: ['Corporation (non-profit)', 'CORPORATION;COMPANY;LIMITED;CORP;INC;CO;LTD'],
    },
    {
        code: 'DBGD',
        country: 'US',
        jurisdiction: 'US-SC',
        jurisdictionName: 'South Carolina',
        name: 'Limited Liability Company',
        abbreviation: 'L.L.C.;LLC;L.C.;LC;Ltd. Co.',
        active: true,
        aliases: ['Limited Liability Company', 'L.L.C.;LLC;L.C.;LC;Ltd. Co.'],
    },
    {
        code: 'DBU3',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima  de capital variable, financiera comunitaria',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima  de capital variable, financiera comunitaria'],
    },
    {
        code: 'DCRK',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Consorzio Fidi',
        abbreviation: '',
        active: true,
        aliases: ['Consorzio Fidi'],
    },
    {
        code: 'DDES',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad de Capital-Riesgo-Pyme',
        abbreviation: 'SCR-Pyme',
        active: true,
        aliases: ['Sociedad de Capital-Riesgo-Pyme', 'SCR-Pyme'],
    },
    {
        code: 'DDKQ',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Public Limited Company',
        abbreviation: 'Ltd;Ltd.;LTD',
        active: true,
        aliases: ['Public Limited Company', 'Ltd;Ltd.;LTD'],
    },
    {
        code: 'DE0G',
        country: 'US',
        jurisdiction: 'US-TN',
        jurisdictionName: 'Tennessee',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'DE7H',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Professional Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Professional Corporation', 'Corporación Professional'],
    },
    {
        code: 'DEF6',
        country: 'RS',
        jurisdiction: 'RS',
        jurisdictionName: 'Serbia',
        name: 'Јавно предузеће',
        abbreviation: 'ЈП',
        active: true,
        aliases: ['Јавно предузеће', 'Javno preduzeće', 'ЈП', 'JP'],
    },
    {
        code: 'DEG4',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société en commandite par actions',
        abbreviation: '',
        active: true,
        aliases: ['Société en commandite par actions'],
    },
    {
        code: 'DEJ0',
        country: 'CO',
        jurisdiction: 'CO',
        jurisdictionName: 'Colombia',
        name: 'Sociedad Colectiva',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad Colectiva'],
    },
    {
        code: 'DEMP',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'General Partnership',
        abbreviation: '',
        active: true,
        aliases: ['General Partnership'],
    },
    {
        code: 'DEO1',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'onderlinge waarborgmaatschappij',
        abbreviation: 'OWM;owm;O.W.M.;o.w.m.',
        active: true,
        aliases: ['onderlinge waarborgmaatschappij', 'OWM;owm;O.W.M.;o.w.m.'],
    },
    {
        code: 'DFE5',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Sociedade Anónima',
        abbreviation: '',
        active: true,
        aliases: ['Sociedade Anónima'],
    },
    {
        code: 'DFPP',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Domestic Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Limited Partnership'],
    },
    {
        code: 'DHGI',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'project company',
        abbreviation: '',
        active: true,
        aliases: ['project company', 'gérant de projet'],
    },
    {
        code: 'DHY2',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima financiera comunitaria',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima financiera comunitaria'],
    },
    {
        code: 'DJ2D',
        country: 'MT',
        jurisdiction: 'MT',
        jurisdictionName: 'Malta',
        name: 'sole trader',
        abbreviation: '',
        active: true,
        aliases: ['sole trader'],
    },
    {
        code: 'DK7L',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'Alberta loan corporation',
        abbreviation: '',
        active: true,
        aliases: ['Alberta loan corporation'],
    },
    {
        code: 'DKUW',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Osakeyhtiö',
        abbreviation: 'oy',
        active: true,
        aliases: ['Osakeyhtiö', 'oy', 'Aktiebolag', 'ab'],
    },
    {
        code: 'DL9Z',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Ulkomainen yhteisö',
        abbreviation: '',
        active: true,
        aliases: ['Ulkomainen yhteisö', 'Utländskt samfund'],
    },
    {
        code: 'DLCX',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Tikrosios ūkinės bendrijos',
        abbreviation: 'TUB',
        active: true,
        aliases: ['Tikrosios ūkinės bendrijos', 'TUB'],
    },
    {
        code: 'DLEK',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '乡镇级集体经济组织',
        abbreviation: '',
        active: true,
        aliases: ['乡镇级集体经济组织', 'xiang zhen ji ji ti jing ji zu zhi'],
    },
    {
        code: 'DLEW',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Nonprofit Limited Liability Company',
        abbreviation: 'LLC;L.L.C.',
        active: true,
        aliases: ['Nonprofit Limited Liability Company', 'LLC;L.L.C.'],
    },
    {
        code: 'DLS4',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società in Accomandita per Azioni',
        abbreviation: '',
        active: true,
        aliases: ['Società in Accomandita per Azioni'],
    },
    {
        code: 'DLUP',
        country: 'GT',
        jurisdiction: 'GT',
        jurisdictionName: 'Guatemala',
        name: 'Asociacion civil',
        abbreviation: '',
        active: true,
        aliases: ['Asociacion civil'],
    },
    {
        code: 'DM88',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Europäische wirtschaftliche Interessenvereinigung',
        abbreviation: '',
        active: true,
        aliases: ['Europäische wirtschaftliche Interessenvereinigung'],
    },
    {
        code: 'DMNZ',
        country: 'VI',
        jurisdiction: 'VI',
        jurisdictionName: 'Virgin Islands (U.S.)',
        name: 'Foreign Non-Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Non-Profit Corporation'],
    },
    {
        code: 'DMT8',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Työeläkekassa',
        abbreviation: '',
        active: true,
        aliases: ['Työeläkekassa', 'Arbetspensionskassa'],
    },
    {
        code: 'DN6F',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Kölcsönös biztosító egyesület',
        abbreviation: '',
        active: true,
        aliases: ['Kölcsönös biztosító egyesület'],
    },
    {
        code: 'DNF1',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima, sociedad financiera de objeto múltiple, entidad no regulada',
        abbreviation: 'S.A., SOFOM E.N.R.',
        active: true,
        aliases: [
            'Sociedad anónima, sociedad financiera de objeto múltiple, entidad no regulada',
            'S.A., SOFOM E.N.R.',
        ],
    },
    {
        code: 'DO25',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Государственные компании',
        abbreviation: '',
        active: true,
        aliases: ['Государственные компании', 'Gosudarstvennyye kompanii'],
    },
    {
        code: 'DP2E',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'International organisation',
        abbreviation: 'Internat. Org.',
        active: true,
        aliases: [
            'International organisation',
            'Internat. Org.',
            'Organisation Internationale',
            'Org. Internationales',
            'Internationale Organisation',
            'Int. Organisation',
            'Organizazioni Internazionali',
            'Org. Internazionali',
        ],
    },
    {
        code: 'DP3Q',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad de Responsabilidad Limitada',
        abbreviation: 'S.L.;S.R.L.',
        active: true,
        aliases: ['Sociedad de Responsabilidad Limitada', 'S.L.;S.R.L.'],
    },
    {
        code: 'DPY1',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Egyéb szövetkezet',
        abbreviation: '',
        active: true,
        aliases: ['Egyéb szövetkezet'],
    },
    {
        code: 'DQAU',
        country: 'DO',
        jurisdiction: 'DO',
        jurisdictionName: 'Dominican Republic',
        name: 'Sociedad Anónima Simplificada',
        abbreviation: 'SAS',
        active: true,
        aliases: ['Sociedad Anónima Simplificada', 'SAS'],
    },
    {
        code: 'DQBZ',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Limited Liability Company',
        abbreviation: 'Limited Liability Company;LLC',
        active: true,
        aliases: ['Limited Liability Company', 'Limited Liability Company;LLC'],
    },
    {
        code: 'DQMJ',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Naamloze vennootschap',
        abbreviation: '',
        active: true,
        aliases: ['Naamloze vennootschap'],
    },
    {
        code: 'DQMV',
        country: 'US',
        jurisdiction: 'US-VA',
        jurisdictionName: 'Virginia',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'DQUB',
        country: 'US',
        jurisdiction: 'US-TN',
        jurisdictionName: 'Tennessee',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP'],
    },
    {
        code: 'DRPL',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Europeisk økonomisk foretaksgruppe',
        abbreviation: 'EØFG',
        active: true,
        aliases: ['Europeisk økonomisk foretaksgruppe', 'EØFG'],
    },
    {
        code: 'DRQM',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA coopérative de construction à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA coopérative de construction à conseil d'administration"],
    },
    {
        code: 'DRSE',
        country: 'US',
        jurisdiction: 'US-RI',
        jurisdictionName: 'Rhode Island',
        name: 'Limited Liability Company',
        abbreviation: 'l.l.c.',
        active: true,
        aliases: ['Limited Liability Company', 'l.l.c.'],
    },
    {
        code: 'DSII',
        country: 'MH',
        jurisdiction: 'MH',
        jurisdictionName: 'Marshall Islands',
        name: 'Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Corporation'],
    },
    {
        code: 'DSML',
        country: 'BO',
        jurisdiction: 'BO',
        jurisdictionName: 'Bolivia (Plurinational State of)',
        name: 'Institución Financiera De Desarrollo',
        abbreviation: '',
        active: true,
        aliases: ['Institución Financiera De Desarrollo'],
    },
    {
        code: 'DSSD',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Azienda Autonoma Statale',
        abbreviation: '',
        active: true,
        aliases: ['Azienda Autonoma Statale'],
    },
    {
        code: 'DTAX',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Autre organisme mutualiste',
        abbreviation: '',
        active: true,
        aliases: ['Autre organisme mutualiste'],
    },
    {
        code: 'DTIU',
        country: 'MK',
        jurisdiction: 'MK',
        jurisdictionName: 'North Macedonia',
        name: 'Акционерско друштво',
        abbreviation: 'AD',
        active: true,
        aliases: ['Акционерско друштво', 'Akcionersko drustvo', 'AD'],
    },
    {
        code: 'DU35',
        country: 'US',
        jurisdiction: 'US-IA',
        jurisdictionName: 'Iowa',
        name: 'Profit Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.',
        active: true,
        aliases: ['Profit Corporation', 'corp.;inc.;co.;ltd.'],
    },
    {
        code: 'DU8H',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad cooperativa de consumidores de bienes y/o servicios de capital variable',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad cooperativa de consumidores de bienes y/o servicios de capital variable'],
    },
    {
        code: 'DUGD',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Intreprindere individuala',
        abbreviation: 'II',
        active: true,
        aliases: ['Intreprindere individuala', 'II'],
    },
    {
        code: 'DURX',
        country: 'US',
        jurisdiction: 'US-WV',
        jurisdictionName: 'West Virginia',
        name: 'Voluntary Association',
        abbreviation: '',
        active: true,
        aliases: ['Voluntary Association'],
    },
    {
        code: 'DUXT',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Junta de Educación y Junta Administrativa de Patronatos Escolares',
        abbreviation: '',
        active: true,
        aliases: ['Junta de Educación y Junta Administrativa de Patronatos Escolares'],
    },
    {
        code: 'DVXS',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Société à responsabilité limitée',
        abbreviation: 'SARL ',
        active: true,
        aliases: ['Société à responsabilité limitée', 'SARL '],
    },
    {
        code: 'DW2W',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Company Limited by Guarantee',
        abbreviation: '',
        active: true,
        aliases: ['Company Limited by Guarantee'],
    },
    {
        code: 'DW9N',
        country: 'SA',
        jurisdiction: 'SA',
        jurisdictionName: 'Saudi Arabia',
        name: 'شركة توصية بالأسهم',
        abbreviation: '',
        active: true,
        aliases: ['شركة توصية بالأسهم', "sharikat tawsiat bial'ashum"],
    },
    {
        code: 'DWEA',
        country: 'AZ',
        jurisdiction: 'AZ',
        jurisdictionName: 'Azerbaijan',
        name: 'Kooperativlər',
        abbreviation: '',
        active: true,
        aliases: ['Kooperativlər'],
    },
    {
        code: 'DWS3',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'General Partnership',
        abbreviation: '',
        active: true,
        aliases: ['General Partnership'],
    },
    {
        code: 'DWYD',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Association déclarée d'insertion par l'économique",
        abbreviation: '',
        active: true,
        aliases: ["Association déclarée d'insertion par l'économique"],
    },
    {
        code: 'DX2N',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Nonprofit Corporation',
        abbreviation: 'Corp.;Ltd.;Inc.',
        active: true,
        aliases: ['Nonprofit Corporation', 'Corp.;Ltd.;Inc.'],
    },
    {
        code: 'DX6Z',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Verein',
        abbreviation: '',
        active: true,
        aliases: ['Verein'],
    },
    {
        code: 'DXQH',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société civile foncière',
        abbreviation: '',
        active: true,
        aliases: ['Société civile foncière'],
    },
    {
        code: 'DYQK',
        country: 'JP',
        jurisdiction: 'JP',
        jurisdictionName: 'Japan',
        name: '有限会社',
        abbreviation: '有',
        active: true,
        aliases: ['有限会社', 'yugengaisya', '有'],
    },
    {
        code: 'DZSY',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Казенные предприятия субъектов Российской Федерации',
        abbreviation: '',
        active: true,
        aliases: [
            'Казенные предприятия субъектов Российской Федерации',
            'Kazennyye predpriyatiya sub"yektov Rossiyskoy Federatsii',
        ],
    },
    {
        code: 'E01X',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'zadruga v zasebni lasti',
        abbreviation: '',
        active: true,
        aliases: ['zadruga v zasebni lasti'],
    },
    {
        code: 'E0FR',
        country: 'FO',
        jurisdiction: 'FO',
        jurisdictionName: 'Faroe Islands',
        name: 'Partafelag',
        abbreviation: '',
        active: true,
        aliases: ['Partafelag'],
    },
    {
        code: 'E0NE',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Public corporation',
        abbreviation: 'Public corporation',
        active: true,
        aliases: [
            'Public corporation',
            'Corporation de droit public',
            'Corp. droit public',
            'öffentlich-rechtliche Körperschaft (Verwaltung)',
            'öff.-rechtl. Körp.',
            'Amm. corporazioni, consorzi, patriziati di diritto pubblico',
            'Corp. diritto pubb.',
        ],
    },
    {
        code: 'E0VI',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Государственные корпорации',
        abbreviation: '',
        active: true,
        aliases: ['Государственные корпорации', 'Gosudarstvennyye korporatsii'],
    },
    {
        code: 'E0YF',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA coopérative d'intérêt maritime à directoire",
        abbreviation: '',
        active: true,
        aliases: ["SA coopérative d'intérêt maritime à directoire"],
    },
    {
        code: 'E0YZ',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad de producción rural de responsabilidad suplementada',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad de producción rural de responsabilidad suplementada'],
    },
    {
        code: 'E12O',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Building Society',
        abbreviation: '',
        active: true,
        aliases: ['Building Society'],
    },
    {
        code: 'E1SE',
        country: 'HK',
        jurisdiction: 'HK',
        jurisdictionName: 'Hong Kong',
        name: '根據法例成立的實體',
        abbreviation: '',
        active: true,
        aliases: [
            '根據法例成立的實體',
            'gen ju fa li cheng li de shi ti',
            'Entity established by Ordinance',
        ],
    },
    {
        code: 'E1VK',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Medzinárodné organizácie a združenia',
        abbreviation: 'Medzinár. org. a združ.',
        active: true,
        aliases: ['Medzinárodné organizácie a združenia', 'Medzinár. org. a združ.'],
    },
    {
        code: 'E26K',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Sociedad Profesional',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad Profesional'],
    },
    {
        code: 'E281',
        country: 'CA',
        jurisdiction: 'CA-PE',
        jurisdictionName: 'Prince Edward Island',
        name: 'limited partnership',
        abbreviation: '',
        active: true,
        aliases: ['limited partnership'],
    },
    {
        code: 'E3YL',
        country: 'SC',
        jurisdiction: 'SC',
        jurisdictionName: 'Seychelles',
        name: 'Company Limited by Shares and Guarantee',
        abbreviation: '',
        active: true,
        aliases: ['Company Limited by Shares and Guarantee'],
    },
    {
        code: 'E4CI',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Bytové družstvo',
        abbreviation: '',
        active: true,
        aliases: ['Bytové družstvo'],
    },
    {
        code: 'E4FG',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '民办非企业单位',
        abbreviation: '',
        active: true,
        aliases: ['民办非企业单位', 'min ban fei qi ye dan wei'],
    },
    {
        code: 'E4HU',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Lietuvos prekybos, pramonės ir amatų rūmų asociacija',
        abbreviation: 'LPRA',
        active: true,
        aliases: ['Lietuvos prekybos, pramonės ir amatų rūmų asociacija', 'LPRA'],
    },
    {
        code: 'E4KB',
        country: 'IS',
        jurisdiction: 'IS',
        jurisdictionName: 'Iceland',
        name: 'Hlutafélag',
        abbreviation: 'hf.',
        active: true,
        aliases: ['Hlutafélag', 'hf.'],
    },
    {
        code: 'E4LW',
        country: 'US',
        jurisdiction: 'US-FL',
        jurisdictionName: 'Florida',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'E4YV',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '港澳台地区旅游部门常驻内地(大陆)代表机构',
        abbreviation: '',
        active: true,
        aliases: [
            '港澳台地区旅游部门常驻内地(大陆)代表机构',
            'gang ao tai di qu lv you bu men chang zhu nei di ( da lu ) dai biao ji gou',
        ],
    },
    {
        code: 'E6J3',
        country: 'GG',
        jurisdiction: 'GG',
        jurisdictionName: 'Guernsey',
        name: 'company limited by shares',
        abbreviation: 'Ltd',
        active: true,
        aliases: ['company limited by shares', 'Ltd'],
    },
    {
        code: 'E6YB',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Caisse (fédérale) de crédit mutuel',
        abbreviation: '',
        active: true,
        aliases: ['Caisse (fédérale) de crédit mutuel'],
    },
    {
        code: 'E7JZ',
        country: 'HN',
        jurisdiction: 'HN',
        jurisdictionName: 'Honduras',
        name: 'Comerciante Individual',
        abbreviation: '',
        active: true,
        aliases: ['Comerciante Individual'],
    },
    {
        code: 'E7W8',
        country: 'RS',
        jurisdiction: 'RS',
        jurisdictionName: 'Serbia',
        name: 'Задруга',
        abbreviation: '',
        active: true,
        aliases: ['Задруга', 'Zadruga'],
    },
    {
        code: 'E85L',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Limited Liability Partnership',
        abbreviation: '',
        active: false,
        aliases: ['Limited Liability Partnership', 'Corporación'],
    },
    {
        code: 'E88S',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '公证处',
        abbreviation: '',
        active: true,
        aliases: ['公证处', 'gong zheng chu'],
    },
    {
        code: 'E9BI',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'stiftelse',
        abbreviation: '',
        active: true,
        aliases: ['stiftelse'],
    },
    {
        code: 'E9CM',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Europsko društvo (Societas Europaea, skraćeno SE)',
        abbreviation: 'SE',
        active: true,
        aliases: ['Europsko društvo (Societas Europaea, skraćeno SE)', 'SE'],
    },
    {
        code: 'E9OX',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Gemeinnützige Stiftung',
        abbreviation: '',
        active: true,
        aliases: ['Gemeinnützige Stiftung'],
    },
    {
        code: 'E9SH',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Zahraničná osoba, fyzická osoba s bydliskom mimo územia SR',
        abbreviation: 'Zahranič.osoba,fyzická',
        active: true,
        aliases: [
            'Zahraničná osoba, fyzická osoba s bydliskom mimo územia SR',
            'Zahranič.osoba,fyzická',
        ],
    },
    {
        code: 'EABD',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société civile coopérative entre médecins',
        abbreviation: '',
        active: true,
        aliases: ['Société civile coopérative entre médecins'],
    },
    {
        code: 'EAC8',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société coopérative de production de HLM anonyme à directoire',
        abbreviation: '',
        active: true,
        aliases: ['Société coopérative de production de HLM anonyme à directoire'],
    },
    {
        code: 'EAD0',
        country: 'BZ',
        jurisdiction: 'BZ',
        jurisdictionName: 'Belize',
        name: 'Company Limited by Shares',
        abbreviation: '',
        active: true,
        aliases: ['Company Limited by Shares'],
    },
    {
        code: 'EBP8',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'General Partnership',
        abbreviation: '',
        active: true,
        aliases: ['General Partnership'],
    },
    {
        code: 'EBRQ',
        country: 'JM',
        jurisdiction: 'JM',
        jurisdictionName: 'Jamaica',
        name: 'unlimited company',
        abbreviation: '',
        active: true,
        aliases: ['unlimited company'],
    },
    {
        code: 'EBYQ',
        country: 'CA',
        jurisdiction: 'CA-NL',
        jurisdictionName: 'Newfoundland and Labrador',
        name: 'Credit Union',
        abbreviation: 'credit union Limited;credit union Ltd;credit union Ltd.;caisse populaire limitée;caisee populaire ltée',
        active: true,
        aliases: [
            'Credit Union',
            'credit union Limited;credit union Ltd;credit union Ltd.;caisse populaire limitée;caisee populaire ltée',
        ],
    },
    {
        code: 'ECAK',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '企业',
        abbreviation: '',
        active: true,
        aliases: ['企业', 'qi ye'],
    },
    {
        code: 'ECLT',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Domestic Corporation Professional Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Corporation Professional Corporation'],
    },
    {
        code: 'ECUL',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Secteur de commune',
        abbreviation: '',
        active: true,
        aliases: ['Secteur de commune'],
    },
    {
        code: 'ECWU',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Einzelunternehmer',
        abbreviation: 'EU',
        active: true,
        aliases: ['Einzelunternehmer', 'EU'],
    },
    {
        code: 'ED84',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Poisťovací spolok',
        abbreviation: '',
        active: true,
        aliases: ['Poisťovací spolok'],
    },
    {
        code: 'EDMK',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Vereniging zonder winstoogmerk van publiek recht',
        abbreviation: 'VZW PR',
        active: true,
        aliases: [
            'Vereniging zonder winstoogmerk van publiek recht',
            'VZW PR',
            'Association sans but lucratif de droit public',
            'ASBL DPU',
            'Öffentlich-rechtliche Vereinigung ohne Gewinnerzielungsabsicht',
            'ÖrVohGza',
        ],
    },
    {
        code: 'EDN7',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Taloudellinen yhdistys',
        abbreviation: '',
        active: true,
        aliases: ['Taloudellinen yhdistys', 'Ekonomisk förening'],
    },
    {
        code: 'EDOR',
        country: 'US',
        jurisdiction: 'US-OK',
        jurisdictionName: 'Oklahoma',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'EDZP',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Ylioppilaskunta tai osakunta',
        abbreviation: '',
        active: true,
        aliases: ['Ylioppilaskunta tai osakunta', 'Studentkår eller studentnation'],
    },
    {
        code: 'EE3W',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Sociedad en Comandita Comercial',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad en Comandita Comercial'],
    },
    {
        code: 'EE90',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Osuuskunta',
        abbreviation: 'osk',
        active: true,
        aliases: ['Osuuskunta', 'osk', 'Andelslag', 'anl'],
    },
    {
        code: 'EF4Y',
        country: 'KN',
        jurisdiction: 'KN-N',
        jurisdictionName: 'Nevis',
        name: 'foundation',
        abbreviation: '',
        active: true,
        aliases: ['foundation'],
    },
    {
        code: 'EFBR',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Grupul de interes economic',
        abbreviation: 'GIE',
        active: true,
        aliases: ['Grupul de interes economic', 'GIE'],
    },
    {
        code: 'EFE3',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Municipalidad',
        abbreviation: '',
        active: true,
        aliases: ['Municipalidad'],
    },
    {
        code: 'EH3M',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Общественные фонды',
        abbreviation: '',
        active: true,
        aliases: ['Общественные фонды', 'Obshchestvennyye fondy'],
    },
    {
        code: 'EHWD',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, de inversión especializada de fondos para el retiro',
        abbreviation: 'S. A. de C.V., Siefore',
        active: true,
        aliases: [
            'Sociedad anónima de capital variable, de inversión especializada de fondos para el retiro',
            'S. A. de C.V., Siefore',
        ],
    },
    {
        code: 'EI4J',
        country: 'US',
        jurisdiction: 'US-CA',
        jurisdictionName: 'California',
        name: 'Limited Liability Company',
        abbreviation: 'LLC;L.L.C.',
        active: true,
        aliases: ['Limited Liability Company', 'LLC;L.L.C.'],
    },
    {
        code: 'EIDL',
        country: 'CA',
        jurisdiction: 'CA-ON',
        jurisdictionName: 'Ontario',
        name: 'Insurance Corporations incorporated under Part V of the Corporations Act',
        abbreviation: '',
        active: true,
        aliases: ['Insurance Corporations incorporated under Part V of the Corporations Act'],
    },
    {
        code: 'EJ06',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Еднолично акционерно дружество',
        abbreviation: 'ЕАД',
        active: true,
        aliases: ['Еднолично акционерно дружество', 'Ednolichno aktsionerno druzhestvo', 'ЕАД', 'EAD'],
    },
    {
        code: 'EJX1',
        country: 'US',
        jurisdiction: 'US-AR',
        jurisdictionName: 'Arkansas',
        name: 'For-Profit Corporation',
        abbreviation: 'Corp.;Inc.;Co.;Ltd.',
        active: true,
        aliases: ['For-Profit Corporation', 'Corp.;Inc.;Co.;Ltd.'],
    },
    {
        code: 'EKJG',
        country: 'BB',
        jurisdiction: 'BB',
        jurisdictionName: 'Barbados',
        name: 'segregated cell company',
        abbreviation: '',
        active: true,
        aliases: ['segregated cell company'],
    },
    {
        code: 'EKRT',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'loan company',
        abbreviation: 'Loan Corporation;Loan Corp.;Loan Company',
        active: false,
        aliases: ['loan company', 'Loan Corporation;Loan Corp.;Loan Company'],
    },
    {
        code: 'EM3H',
        country: 'NP',
        jurisdiction: 'NP',
        jurisdictionName: 'Nepal',
        name: 'Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Partnership', 'साझेदारी ', 'sajhedari'],
    },
    {
        code: 'EMC8',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Muu taloudellinen yhdistys',
        abbreviation: '',
        active: true,
        aliases: ['Muu taloudellinen yhdistys', 'Annan ekonomisk förening'],
    },
    {
        code: 'EMLA',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Limited Partnership - without Legal Personality',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership - without Legal Personality'],
    },
    {
        code: 'EMLK',
        country: 'US',
        jurisdiction: 'US-MO',
        jurisdictionName: 'Missouri',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP'],
    },
    {
        code: 'EO0G',
        country: 'KR',
        jurisdiction: 'KR',
        jurisdictionName: 'Korea (Republic of)',
        name: '변액보험',
        abbreviation: '',
        active: true,
        aliases: ['변액보험', 'ByeonAcBoHeom'],
    },
    {
        code: 'EO24',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Cooperative Grazing Associations',
        abbreviation: 'coop;co-op',
        active: true,
        aliases: ['Cooperative Grazing Associations', 'coop;co-op'],
    },
    {
        code: 'EO9A',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Foreign Real Estate Investment Trust',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Real Estate Investment Trust'],
    },
    {
        code: 'EO9F',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Részvénytársaság',
        abbreviation: 'Rt.',
        active: true,
        aliases: ['Részvénytársaság', 'Rt.'],
    },
    {
        code: 'EPCY',
        country: 'US',
        jurisdiction: 'US-NY',
        jurisdictionName: 'New York',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'EPFN',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'New Brunswick limited liability partnership',
        abbreviation: 'LLP',
        active: false,
        aliases: ['New Brunswick limited liability partnership', 'LLP'],
    },
    {
        code: 'EPG7',
        country: 'HK',
        jurisdiction: 'HK',
        jurisdictionName: 'Hong Kong',
        name: '公眾股份有限公司',
        abbreviation: '有限公司',
        active: true,
        aliases: [
            '公眾股份有限公司',
            'Gong zhong gu fen you xian gong si',
            '有限公司',
            'Public company limited by shares',
            'Ltd;Ltd.;Limited',
        ],
    },
    {
        code: 'EQ7L',
        country: 'NE',
        jurisdiction: 'NE',
        jurisdictionName: 'Niger',
        name: 'Société par Actions Simplifiée',
        abbreviation: 'SAS',
        active: true,
        aliases: ['Société par Actions Simplifiée', 'SAS'],
    },
    {
        code: 'EQAQ',
        country: 'US',
        jurisdiction: 'US-AK',
        jurisdictionName: 'Alaska',
        name: 'Sole Proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['Sole Proprietorship'],
    },
    {
        code: 'EQOV',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Aktiengesellschaft',
        abbreviation: 'AG',
        active: true,
        aliases: ['Aktiengesellschaft', 'AG'],
    },
    {
        code: 'EQQP',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Special Employee Owned Corporation',
        abbreviation: '',
        active: true,
        aliases: [
            'Special Employee Owned Corporation',
            'Corporación Especial Propiedad de Trabajadores',
        ],
    },
    {
        code: 'ER02',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Organizačná jednotka združenia',
        abbreviation: 'Org.jednotka združenia',
        active: true,
        aliases: ['Organizačná jednotka združenia', 'Org.jednotka združenia'],
    },
    {
        code: 'ER0H',
        country: 'CA',
        jurisdiction: 'CA-NL',
        jurisdictionName: 'Newfoundland and Labrador',
        name: 'registration of extra-provincial corporations',
        abbreviation: 'Limited;Limitee;Incorporated;Incorporee;Corporation;Ltd.;Ltee.;Inc.;Corp.;Ltd',
        active: true,
        aliases: [
            'registration of extra-provincial corporations',
            'Limited;Limitee;Incorporated;Incorporee;Corporation;Ltd.;Ltee.;Inc.;Corp.;Ltd',
        ],
    },
    {
        code: 'ER7C',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Publicly Traded Corporation',
        abbreviation: 'corp;inc.',
        active: true,
        aliases: ['Publicly Traded Corporation', 'corp;inc.'],
    },
    {
        code: 'ERUM',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Public Benefit Corporation',
        abbreviation: '',
        active: false,
        aliases: ['Public Benefit Corporation', 'Corporación Especial Propiedad de Trabajadores'],
    },
    {
        code: 'ES2D',
        country: 'LV',
        jurisdiction: 'LV',
        jurisdictionName: 'Latvia',
        name: 'Sabiedrība ar ierobežotu atbildību',
        abbreviation: 'SIA',
        active: true,
        aliases: ['Sabiedrība ar ierobežotu atbildību', 'SIA'],
    },
    {
        code: 'ESTU',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Társasház',
        abbreviation: '',
        active: true,
        aliases: ['Társasház'],
    },
    {
        code: 'ESVK',
        country: 'CA',
        jurisdiction: 'CA-ON',
        jurisdictionName: 'Ontario',
        name: 'Credit Union',
        abbreviation: '',
        active: true,
        aliases: ['Credit Union'],
    },
    {
        code: 'ESZ8',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '其他（农业）',
        abbreviation: '',
        active: true,
        aliases: ['其他（农业）', 'qi ta（ nong ye ）'],
    },
    {
        code: 'ET6Z',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Svazy církví a náboženských společností',
        abbreviation: '',
        active: true,
        aliases: ['Svazy církví a náboženských společností'],
    },
    {
        code: 'ETZT',
        country: 'UY',
        jurisdiction: 'UY',
        jurisdictionName: 'Uruguay',
        name: 'Empresa Unipersonal ',
        abbreviation: '',
        active: true,
        aliases: ['Empresa Unipersonal '],
    },
    {
        code: 'EU0T',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'towarzystwo reasekuracji wzajemnej',
        abbreviation: '',
        active: true,
        aliases: ['towarzystwo reasekuracji wzajemnej'],
    },
    {
        code: 'EULU',
        country: 'BN',
        jurisdiction: 'BN',
        jurisdictionName: 'Brunei Darussalam',
        name: 'Private Limited Company',
        abbreviation: 'Sdn Bhd;Bhd',
        active: true,
        aliases: ['Private Limited Company', 'Sdn Bhd;Bhd'],
    },
    {
        code: 'EURM',
        country: 'BM',
        jurisdiction: 'BM',
        jurisdictionName: 'Bermuda',
        name: 'Local Unlimited Company',
        abbreviation: '',
        active: true,
        aliases: ['Local Unlimited Company'],
    },
    {
        code: 'EUT4',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Société à responsabilité limitée simplifiée',
        abbreviation: 'S.à r.l.-S',
        active: true,
        aliases: [
            'Société à responsabilité limitée simplifiée',
            'société à responsabilité limitée simplifiée',
            'S.à r.l.-S',
        ],
    },
    {
        code: 'EV7F',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Einzelfirma',
        abbreviation: '',
        active: true,
        aliases: ['Einzelfirma'],
    },
    {
        code: 'EVBW',
        country: 'US',
        jurisdiction: 'US-WI',
        jurisdictionName: 'Wisconsin',
        name: 'Corporation Nonstock Nonprofit',
        abbreviation: '',
        active: true,
        aliases: ['Corporation Nonstock Nonprofit'],
    },
    {
        code: 'EVE6',
        country: 'US',
        jurisdiction: 'US-ID',
        jurisdictionName: 'Idaho',
        name: 'Nonprofit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation'],
    },
    {
        code: 'EVYY',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Caisse de crédit maritime mutuel',
        abbreviation: '',
        active: true,
        aliases: ['Caisse de crédit maritime mutuel'],
    },
    {
        code: 'EW8U',
        country: 'US',
        jurisdiction: 'US-MD',
        jurisdictionName: 'Maryland',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'EW9A',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Business Trust',
        abbreviation: '',
        active: true,
        aliases: ['Business Trust'],
    },
    {
        code: 'EWQF',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Организационно-правовые формы для коммерческой деятельности граждан',
        abbreviation: '',
        active: true,
        aliases: [
            'Организационно-правовые формы для коммерческой деятельности граждан',
            "Organizatsionno-pravovyye formy dlya kommercheskoy deyatel'nosti grazhdan",
        ],
    },
    {
        code: 'EX8U',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Alternative Investment Fund',
        abbreviation: '',
        active: true,
        aliases: ['Alternative Investment Fund'],
    },
    {
        code: 'EXD7',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Enkeltpersonforetak',
        abbreviation: 'ENK',
        active: true,
        aliases: ['Enkeltpersonforetak', 'ENK'],
    },
    {
        code: 'EXY8',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Coöperatieve vennootschap met onbeperkte aansprakelijkheid, bij wijze van deelneming van publiek recht',
        abbreviation: 'CVOA CD',
        active: true,
        aliases: [
            'Coöperatieve vennootschap met onbeperkte aansprakelijkheid, bij wijze van deelneming van publiek recht',
            'CVOA CD',
            'Coopérative à responsabilité illimitée, coopérative de participation, de droit public',
            'SCRI CP',
            'Öffentlich-rechtliche Genossenschaft mit unbeschränkter Haftung, Genossenschaft auf Beteiligung',
            'GmuHGB',
        ],
    },
    {
        code: 'EY94',
        country: 'US',
        jurisdiction: 'US-GA',
        jurisdictionName: 'Georgia',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'EYKU',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Stečajna masa',
        abbreviation: '',
        active: true,
        aliases: ['Stečajna masa'],
    },
    {
        code: 'EYRI',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Centre technique industriel ou comité professionnel du développement économique',
        abbreviation: '',
        active: true,
        aliases: ['Centre technique industriel ou comité professionnel du développement économique'],
    },
    {
        code: 'EZ08',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Agricultural Cooperative',
        abbreviation: 'Corporation;Incorporated;Company;Limited;Corp;Inc.;Co.;Ltd.',
        active: true,
        aliases: [
            'Agricultural Cooperative',
            'Corporation;Incorporated;Company;Limited;Corp;Inc.;Co.;Ltd.',
        ],
    },
    {
        code: 'EZG2',
        country: 'OM',
        jurisdiction: 'OM',
        jurisdictionName: 'Oman',
        name: 'الشركة القابضة',
        abbreviation: '',
        active: true,
        aliases: ['الشركة القابضة', 'alsharikat alqabida'],
    },
    {
        code: 'EZHS',
        country: 'BJ',
        jurisdiction: 'BJ',
        jurisdictionName: 'Benin',
        name: 'Société Unipersonnelle à Responsabilité Limitée',
        abbreviation: 'SUARL',
        active: true,
        aliases: ['Société Unipersonnelle à Responsabilité Limitée', 'SUARL'],
    },
    {
        code: 'EZL8',
        country: 'MH',
        jurisdiction: 'MH',
        jurisdictionName: 'Marshall Islands',
        name: 'Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Company'],
    },
    {
        code: 'EZNQ',
        country: 'US',
        jurisdiction: 'US-OH',
        jurisdictionName: 'Ohio',
        name: 'Limited Liability Company',
        abbreviation: 'limited liability company;limited;LLC;L.L.C.;ltd.;ltd',
        active: true,
        aliases: ['Limited Liability Company', 'limited liability company;limited;LLC;L.L.C.;ltd.;ltd'],
    },
    {
        code: 'EZQW',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'rechtspersoon in oprichting',
        abbreviation: 'rp io;RP io;R.P. io',
        active: true,
        aliases: ['rechtspersoon in oprichting', 'rp io;RP io;R.P. io'],
    },
    {
        code: 'F0A6',
        country: 'AR',
        jurisdiction: 'AR',
        jurisdictionName: 'Argentina',
        name: 'Sociedad Anonima',
        abbreviation: 'S.A.',
        active: true,
        aliases: ['Sociedad Anonima', 'S.A.'],
    },
    {
        code: 'F0B6',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société en commandite simple coopérative',
        abbreviation: '',
        active: true,
        aliases: ['Société en commandite simple coopérative'],
    },
    {
        code: 'F0BK',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Societate agricolă',
        abbreviation: '',
        active: true,
        aliases: ['Societate agricolă'],
    },
    {
        code: 'F0IC',
        country: 'GT',
        jurisdiction: 'GT',
        jurisdictionName: 'Guatemala',
        name: 'Sociedad en Comandita por Acciones',
        abbreviation: 'Cía., S.C.A.',
        active: true,
        aliases: ['Sociedad en Comandita por Acciones', 'Cía., S.C.A.'],
    },
    {
        code: 'F21U',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'Skarb Państwa',
        abbreviation: '',
        active: true,
        aliases: ['Skarb Państwa'],
    },
    {
        code: 'F2QV',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'Limited Liability Company (profit)',
        abbreviation: 'LLC;LIMITED LIABILITY COMPANY;LTD. CO',
        active: true,
        aliases: ['Limited Liability Company (profit)', 'LLC;LIMITED LIABILITY COMPANY;LTD. CO'],
    },
    {
        code: 'F2TQ',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Tradicinės religinės bendruomenės ar bendrijos',
        abbreviation: 'TR',
        active: true,
        aliases: ['Tradicinės religinės bendruomenės ar bendrijos', 'TR'],
    },
    {
        code: 'F2ZF',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Asociacijos',
        abbreviation: 'A',
        active: true,
        aliases: ['Asociacijos', 'A'],
    },
    {
        code: 'F3L5',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Fondos de Aseguramiento Agropecuario y Rural',
        abbreviation: '',
        active: true,
        aliases: ['Fondos de Aseguramiento Agropecuario y Rural'],
    },
    {
        code: 'F3UE',
        country: 'AE',
        jurisdiction: 'AE-DU',
        jurisdictionName: 'Dubai',
        name: 'General Partnership',
        abbreviation: '',
        active: true,
        aliases: ['General Partnership'],
    },
    {
        code: 'F502',
        country: 'TN',
        jurisdiction: 'TN',
        jurisdictionName: 'Tunisia',
        name: 'Entreprise individuelle',
        abbreviation: '',
        active: true,
        aliases: ['Entreprise individuelle'],
    },
    {
        code: 'F560',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Spoločná záujmová organizácia družstiev',
        abbreviation: 'Spoločná záuj.org.druž.',
        active: true,
        aliases: ['Spoločná záujmová organizácia družstiev', 'Spoločná záuj.org.druž.'],
    },
    {
        code: 'F5VB',
        country: 'TW',
        jurisdiction: 'TW',
        jurisdictionName: 'Taiwan (Province of China)',
        name: '財團法人',
        abbreviation: '',
        active: true,
        aliases: ['財團法人', 'cái tuán fǎ rén'],
    },
    {
        code: 'F5VL',
        country: 'US',
        jurisdiction: 'US-IL',
        jurisdictionName: 'Illinois',
        name: 'Professional Services Corporation',
        abbreviation: 'Ltd.;Prof. Corp.;P.C.;Chartered',
        active: true,
        aliases: ['Professional Services Corporation', 'Ltd.;Prof. Corp.;P.C.;Chartered'],
    },
    {
        code: 'F5X7',
        country: 'MT',
        jurisdiction: 'MT',
        jurisdictionName: 'Malta',
        name: 'cooperative',
        abbreviation: '',
        active: true,
        aliases: ['cooperative'],
    },
    {
        code: 'F68H',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Societate în nume colectiv',
        abbreviation: 'SNC',
        active: true,
        aliases: ['Societate în nume colectiv', 'SNC'],
    },
    {
        code: 'F69V',
        country: 'US',
        jurisdiction: 'US-NM',
        jurisdictionName: 'New Mexico',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'F6SZ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SA coopérative de production (SCOP) à directoire',
        abbreviation: '',
        active: true,
        aliases: ['SA coopérative de production (SCOP) à directoire'],
    },
    {
        code: 'F72Z',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Établissement public national à caractére industriel ou commercial doté d'un comptable public",
        abbreviation: '',
        active: true,
        aliases: [
            "Établissement public national à caractére industriel ou commercial doté d'un comptable public",
        ],
    },
    {
        code: 'F77L',
        country: 'ID',
        jurisdiction: 'ID',
        jurisdictionName: 'Indonesia',
        name: 'Perusahaan Perseroan',
        abbreviation: 'Persero',
        active: true,
        aliases: ['Perusahaan Perseroan', 'Persero'],
    },
    {
        code: 'F7JY',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Særlig Finansiel virksomhed',
        abbreviation: '',
        active: true,
        aliases: ['Særlig Finansiel virksomhed'],
    },
    {
        code: 'F7KI',
        country: 'NZ',
        jurisdiction: 'NZ',
        jurisdictionName: 'New Zealand',
        name: 'Limited Partnership',
        abbreviation: 'Limited Partnership;LP;L.P.',
        active: true,
        aliases: ['Limited Partnership', 'Limited Partnership;LP;L.P.'],
    },
    {
        code: 'F8DD',
        country: 'US',
        jurisdiction: 'US-WA',
        jurisdictionName: 'Washington',
        name: 'Limited Liability Company',
        abbreviation: 'LLC;L.L.C.',
        active: true,
        aliases: ['Limited Liability Company', 'LLC;L.L.C.'],
    },
    {
        code: 'F8UD',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SCP d'avoués d'appel",
        abbreviation: '',
        active: true,
        aliases: ["SCP d'avoués d'appel"],
    },
    {
        code: 'F8VX',
        country: 'AE',
        jurisdiction: 'AE',
        jurisdictionName: 'United Arab Emirates',
        name: 'Joint Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Joint Liability Company'],
    },
    {
        code: 'F93F',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA immobilière pour le commerce et l'industrie (SICOMI) à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA immobilière pour le commerce et l'industrie (SICOMI) à conseil d'administration"],
    },
    {
        code: 'F99D',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Electric Membership Cooperative',
        abbreviation: 'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation;emc;electric membership corporation',
        active: true,
        aliases: [
            'Electric Membership Cooperative',
            'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation;emc;electric membership corporation',
        ],
    },
    {
        code: 'F9CT',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur l’instruction publique',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur l’instruction publique'],
    },
    {
        code: 'F9I4',
        country: 'US',
        jurisdiction: 'US-KS',
        jurisdictionName: 'Kansas',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'F9J3',
        country: 'CA',
        jurisdiction: 'CA-BC',
        jurisdictionName: 'British Columbia',
        name: 'Limited partnership formed outside of BC',
        abbreviation: 'LLP;SRL;SENCRL',
        active: true,
        aliases: ['Limited partnership formed outside of BC', 'LLP;SRL;SENCRL'],
    },
    {
        code: 'F9OB',
        country: 'US',
        jurisdiction: 'US-GA',
        jurisdictionName: 'Georgia',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'FANM',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'kółka rolnicze',
        abbreviation: '',
        active: true,
        aliases: ['kółka rolnicze'],
    },
    {
        code: 'FBN0',
        country: 'US',
        jurisdiction: 'US-KS',
        jurisdictionName: 'Kansas',
        name: 'Limited Liability Company',
        abbreviation: 'L.C.;L.L.C.;LC;LLC.',
        active: true,
        aliases: ['Limited Liability Company', 'L.C.;L.L.C.;LC;LLC.'],
    },
    {
        code: 'FBQL',
        country: 'CA',
        jurisdiction: 'CA-ON',
        jurisdictionName: 'Ontario',
        name: 'Co-operative Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Co-operative Corporation'],
    },
    {
        code: 'FBX9',
        country: 'SX',
        jurisdiction: 'SX',
        jurisdictionName: 'Sint Maarten',
        name: 'aandeelhouder-bestuurde vennootschap',
        abbreviation: 'ABV',
        active: true,
        aliases: ['aandeelhouder-bestuurde vennootschap', 'ABV'],
    },
    {
        code: 'FBYB',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Représentation ou agence commerciale d'état ou organisme public étranger immatriculé au RCS",
        abbreviation: '',
        active: false,
        aliases: [
            "Représentation ou agence commerciale d'état ou organisme public étranger immatriculé au RCS",
        ],
    },
    {
        code: 'FC7L',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Housing Finance Company',
        abbreviation: '',
        active: true,
        aliases: ['Housing Finance Company'],
    },
    {
        code: 'FCAN',
        country: 'NZ',
        jurisdiction: 'NZ',
        jurisdictionName: 'New Zealand',
        name: 'Māori Incorporation',
        abbreviation: '',
        active: true,
        aliases: ['Māori Incorporation'],
    },
    {
        code: 'FCJF',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Fondo de Inversion en activos del Mercado Monetario',
        abbreviation: 'F.I.A.M.M.',
        active: true,
        aliases: ['Fondo de Inversion en activos del Mercado Monetario', 'F.I.A.M.M.'],
    },
    {
        code: 'FCPM',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Vereniging met volledige rechtsbevoegdheid',
        abbreviation: '',
        active: true,
        aliases: ['Vereniging met volledige rechtsbevoegdheid'],
    },
    {
        code: 'FDRT',
        country: 'TH',
        jurisdiction: 'TH',
        jurisdictionName: 'Thailand',
        name: 'สมาคมจดทะเบียน',
        abbreviation: '',
        active: true,
        aliases: ['สมาคมจดทะเบียน', 'S̄mākhm cdthabeīyn'],
    },
    {
        code: 'FDVU',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Fyzická osoba-príležitostne činná-zapísaná v registri daňového informačného systému',
        abbreviation: 'FO v RDIS',
        active: true,
        aliases: [
            'Fyzická osoba-príležitostne činná-zapísaná v registri daňového informačného systému',
            'FO v RDIS',
        ],
    },
    {
        code: 'FE1L',
        country: 'US',
        jurisdiction: 'US-TX',
        jurisdictionName: 'Texas',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'FE4G',
        country: 'AE',
        jurisdiction: 'AE-AZ',
        jurisdictionName: 'Abu Dhabi',
        name: 'Protected Cell Company',
        abbreviation: '',
        active: false,
        aliases: ['Protected Cell Company'],
    },
    {
        code: 'FE8K',
        country: 'AR',
        jurisdiction: 'AR',
        jurisdictionName: 'Argentina',
        name: 'Sociedad Por Acciones Simplificada',
        abbreviation: 'S.A.S',
        active: true,
        aliases: ['Sociedad Por Acciones Simplificada', 'S.A.S'],
    },
    {
        code: 'FEBD',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Stiftung des öffentlichen Rechts',
        abbreviation: '',
        active: true,
        aliases: ['Stiftung des öffentlichen Rechts'],
    },
    {
        code: 'FEC4',
        country: 'US',
        jurisdiction: 'US-KS',
        jurisdictionName: 'Kansas',
        name: 'Not-For-Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Not-For-Profit Corporation'],
    },
    {
        code: 'FEEA',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Établissement public national ayant fonction d'administration centrale",
        abbreviation: '',
        active: true,
        aliases: ["Établissement public national ayant fonction d'administration centrale"],
    },
    {
        code: 'FF1D',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'Public Unlimited Company that has no share capital',
        abbreviation: 'PULC / uc',
        active: true,
        aliases: [
            'Public Unlimited Company that has no share capital',
            'PULC / uc',
            'Cuideachta Neamhtheoranta',
            'cn',
        ],
    },
    {
        code: 'FFBM',
        country: 'US',
        jurisdiction: 'US-NJ',
        jurisdictionName: 'New Jersey',
        name: 'Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Partnership'],
    },
    {
        code: 'FFQL',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Commune et commune nouvelle',
        abbreviation: '',
        active: true,
        aliases: ['Commune et commune nouvelle'],
    },
    {
        code: 'FFTN',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Cantonal administration',
        abbreviation: 'Cantonal administration',
        active: true,
        aliases: [
            'Cantonal administration',
            'Administration du canton',
            'Canton',
            'Verwaltung des Kantons',
            'Kanton',
            'Amministrazione del cantone',
            'Cantone',
        ],
    },
    {
        code: 'FG2L',
        country: 'VC',
        jurisdiction: 'VC',
        jurisdictionName: 'Saint Vincent and the Grenadines',
        name: 'company',
        abbreviation: 'Ltd;Corp;Inc',
        active: true,
        aliases: ['company', 'Ltd;Corp;Inc'],
    },
    {
        code: 'FG84',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Societas Cooperativa Europaea',
        abbreviation: 'SCE',
        active: true,
        aliases: ['Societas Cooperativa Europaea', 'SCE'],
    },
    {
        code: 'FGSL',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'association condominiale',
        abbreviation: '',
        active: false,
        aliases: ['association condominiale'],
    },
    {
        code: 'FGT5',
        country: 'US',
        jurisdiction: 'US-KS',
        jurisdictionName: 'Kansas',
        name: 'Limited Liability Partnership',
        abbreviation: 'LLP',
        active: true,
        aliases: ['Limited Liability Partnership', 'LLP'],
    },
    {
        code: 'FGVH',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'Corporation (Business or for-profit)',
        abbreviation: '',
        active: true,
        aliases: ['Corporation (Business or for-profit)'],
    },
    {
        code: 'FH4R',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Fondo de Pensiones',
        abbreviation: 'F.P.',
        active: true,
        aliases: ['Fondo de Pensiones', 'F.P.'],
    },
    {
        code: 'FHRL',
        country: 'AE',
        jurisdiction: 'AE-RK',
        jurisdictionName: 'Ras Al Khaimah',
        name: 'Segregated Portfolio Company',
        abbreviation: '',
        active: true,
        aliases: ['Segregated Portfolio Company'],
    },
    {
        code: 'FHZY',
        country: 'NG',
        jurisdiction: 'NG',
        jurisdictionName: 'Nigeria',
        name: 'Private company limited by shares',
        abbreviation: 'PLC',
        active: true,
        aliases: ['Private company limited by shares', 'PLC'],
    },
    {
        code: 'FI4M',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Industrial and Building Society',
        abbreviation: '',
        active: true,
        aliases: ['Industrial and Building Society'],
    },
    {
        code: 'FI9R',
        country: 'SX',
        jurisdiction: 'SX',
        jurisdictionName: 'Sint Maarten',
        name: 'stichting',
        abbreviation: '',
        active: true,
        aliases: ['stichting'],
    },
    {
        code: 'FIP8',
        country: 'US',
        jurisdiction: 'US-AL',
        jurisdictionName: 'Alabama',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'FIPS',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Banka-státní peněžní ústav',
        abbreviation: '',
        active: true,
        aliases: ['Banka-státní peněžní ústav'],
    },
    {
        code: 'FJ0E',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'spółka akcyjna',
        abbreviation: 'S.A.',
        active: true,
        aliases: ['spółka akcyjna', 'S.A.'],
    },
    {
        code: 'FJG4',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Trust',
        abbreviation: '',
        active: true,
        aliases: ['Trust'],
    },
    {
        code: 'FJK0',
        country: 'MM',
        jurisdiction: 'MM',
        jurisdictionName: 'Myanmar',
        name: '၁၉၅၀ ခုနှစ် အထူးကုမ္ပဏီအက်ဥပဒေအရ အစုအားဖြင့်တာ၀န်ကန့်သတ်ထားသည့် အများနှင့် သက်ဆိုင်သည့်ကုမ္ပဏီ၊',
        abbreviation: '',
        active: true,
        aliases: [
            '၁၉၅၀ ခုနှစ် အထူးကုမ္ပဏီအက်ဥပဒေအရ အစုအားဖြင့်တာ၀န်ကန့်သတ်ထားသည့် အများနှင့် သက်ဆိုင်သည့်ကုမ္ပဏီ၊',
            '1 9 5 0 hkunhait aahtuu kumpane aaatupadayaar a hcu aarr hpyint tar 0 n k ant saathtarrsaeet a myarrnhaint saatsine saeet kumpane',
        ],
    },
    {
        code: 'FJQ8',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Persoana fizica autorizata',
        abbreviation: 'PFA',
        active: true,
        aliases: ['Persoana fizica autorizata', 'PFA'],
    },
    {
        code: 'FK53',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Farm/Ranch Limited Liability Company',
        abbreviation: 'LLC;L.L.C.',
        active: true,
        aliases: ['Farm/Ranch Limited Liability Company', 'LLC;L.L.C.'],
    },
    {
        code: 'FKG2',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Organisation internationale',
        abbreviation: '',
        active: true,
        aliases: ['Organisation internationale'],
    },
    {
        code: 'FKG5',
        country: 'UY',
        jurisdiction: 'UY',
        jurisdictionName: 'Uruguay',
        name: 'Sociedad de Responsabilidad Limitada',
        abbreviation: 'S.R.L.',
        active: true,
        aliases: ['Sociedad de Responsabilidad Limitada', 'S.R.L.'],
    },
    {
        code: 'FKVG',
        country: 'EC',
        jurisdiction: 'EC',
        jurisdictionName: 'Ecuador',
        name: 'Compañía en Comandita Simple y dividida por acciones',
        abbreviation: 'CCSDA',
        active: true,
        aliases: ['Compañía en Comandita Simple y dividida por acciones', 'CCSDA'],
    },
    {
        code: 'FLNB',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Fund',
        abbreviation: '',
        active: true,
        aliases: ['Fund', 'Fonds', 'Fondo'],
    },
    {
        code: 'FMPL',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Private Limited by Guarantee and not having a Share Capital (1931 Act)',
        abbreviation: '',
        active: true,
        aliases: ['Private Limited by Guarantee and not having a Share Capital (1931 Act)'],
    },
    {
        code: 'FMUC',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Iné pracovisko vysokej školy/fakulty',
        abbreviation: 'Iné prac.vysokej školy',
        active: true,
        aliases: ['Iné pracovisko vysokej školy/fakulty', 'Iné prac.vysokej školy'],
    },
    {
        code: 'FN6X',
        country: 'CA',
        jurisdiction: 'CA-MB',
        jurisdictionName: 'Manitoba',
        name: 'Share corporations (including professional corporations)',
        abbreviation: 'Limited;Limitee;Incorporated;Incorporee;Corporation;Ltd.;Ltee.;Inc.;Corp.;Ltd',
        active: true,
        aliases: [
            'Share corporations (including professional corporations)',
            'Limited;Limitee;Incorporated;Incorporee;Corporation;Ltd.;Ltee.;Inc.;Corp.;Ltd',
        ],
    },
    {
        code: 'FOUY',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SCP de commissaires aux comptes',
        abbreviation: '',
        active: true,
        aliases: ['SCP de commissaires aux comptes'],
    },
    {
        code: 'FPP2',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Събирателно дружество (СД)/Съдружие',
        abbreviation: 'С-ие;СД;С-ИЕ',
        active: true,
        aliases: [
            'Събирателно дружество (СД)/Съдружие',
            'Sabiratelno druzhestvo (SD)/Sadruzhie',
            'С-ие;СД;С-ИЕ',
            'SD/S-ie;SD;S-IE',
        ],
    },
    {
        code: 'FPZK',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Banking Company - Scheduled Urban Cooperative Bank',
        abbreviation: '',
        active: true,
        aliases: ['Banking Company - Scheduled Urban Cooperative Bank'],
    },
    {
        code: 'FQ5Y',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'organizacje społeczne i zawodowe',
        abbreviation: '',
        active: true,
        aliases: ['organizacje społeczne i zawodowe'],
    },
    {
        code: 'FQJ9',
        country: 'CA',
        jurisdiction: 'CA-NS',
        jurisdictionName: 'Nova Scotia',
        name: 'for profit and not-for profit co-operatives',
        abbreviation: 'Co-operative and Limited;Ltd.;Co-opérative and Limitée;Ltée',
        active: true,
        aliases: [
            'for profit and not-for profit co-operatives',
            'Co-operative and Limited;Ltd.;Co-opérative and Limitée;Ltée',
        ],
    },
    {
        code: 'FQLY',
        country: 'US',
        jurisdiction: 'US-WA',
        jurisdictionName: 'Washington',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'FQRE',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Účelová zahranično - obchodná organizácia',
        abbreviation: 'Účelová zahr.-obch.org.',
        active: true,
        aliases: ['Účelová zahranično - obchodná organizácia', 'Účelová zahr.-obch.org.'],
    },
    {
        code: 'FR3V',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Gesellschaft bürgerlichen Rechts',
        abbreviation: 'GbR',
        active: true,
        aliases: ['Gesellschaft bürgerlichen Rechts', 'GbR'],
    },
    {
        code: 'FRUF',
        country: 'MY',
        jurisdiction: 'MY',
        jurisdictionName: 'Malaysia',
        name: 'Unlimited Company',
        abbreviation: '',
        active: true,
        aliases: ['Unlimited Company'],
    },
    {
        code: 'FSBD',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Forening',
        abbreviation: '',
        active: true,
        aliases: ['Forening'],
    },
    {
        code: 'FTNW',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Cooperative',
        abbreviation: 'Co-op',
        active: true,
        aliases: ['Cooperative', 'Co-op'],
    },
    {
        code: 'FUKI',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Enkeltmandsvirksomhed',
        abbreviation: '',
        active: true,
        aliases: ['Enkeltmandsvirksomhed'],
    },
    {
        code: 'FV0K',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Eμπορική Επωνυμία',
        abbreviation: '',
        active: false,
        aliases: ['Eμπορική Επωνυμία', 'Emporiki Eponymia'],
    },
    {
        code: 'FVGZ',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Industrial and Provident Society',
        abbreviation: '',
        active: false,
        aliases: ['Industrial and Provident Society'],
    },
    {
        code: 'FVTS',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Unión de sociedades de producción rural',
        abbreviation: '',
        active: true,
        aliases: ['Unión de sociedades de producción rural'],
    },
    {
        code: 'FW66',
        country: 'US',
        jurisdiction: 'US-RI',
        jurisdictionName: 'Rhode Island',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP'],
    },
    {
        code: 'FW7S',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Europæisk andelsselskab',
        abbreviation: 'SCE-selskab',
        active: true,
        aliases: ['Europæisk andelsselskab', 'SCE-selskab'],
    },
    {
        code: 'FWGK',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Муниципальные бюджетные учреждения',
        abbreviation: '',
        active: true,
        aliases: ['Муниципальные бюджетные учреждения', "Munitsipal'nyye byudzhetnyye uchrezhdeniya"],
    },
    {
        code: 'FXHR',
        country: 'US',
        jurisdiction: 'US-VT',
        jurisdictionName: 'Vermont',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'FY0F',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société civile immobilière',
        abbreviation: '',
        active: true,
        aliases: ['Société civile immobilière'],
    },
    {
        code: 'FY1B',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Církve a náboženské společnosti',
        abbreviation: '',
        active: true,
        aliases: ['Církve a náboženské společnosti'],
    },
    {
        code: 'FYBN',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SARL mixte d'intérêt agricole (SMIA)",
        abbreviation: '',
        active: true,
        aliases: ["SARL mixte d'intérêt agricole (SMIA)"],
    },
    {
        code: 'FYYY',
        country: 'CA',
        jurisdiction: 'CA-SK',
        jurisdictionName: 'Saskatchewan',
        name: 'Credit Unions',
        abbreviation: '',
        active: true,
        aliases: ['Credit Unions'],
    },
    {
        code: 'FZAC',
        country: 'JO',
        jurisdiction: 'JO',
        jurisdictionName: 'Jordan',
        name: 'الشركة المساهمة الخاصة',
        abbreviation: 'ش.م.خ',
        active: true,
        aliases: ['الشركة المساهمة الخاصة', 'alsharika almusahama alkhasa', 'ش.م.خ'],
    },
    {
        code: 'FZKX',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Производственные кооперативы (артели)',
        abbreviation: '',
        active: true,
        aliases: ['Производственные кооперативы (артели)', 'Proizvodstvennyye kooperativy (arteli)'],
    },
    {
        code: 'FZMT',
        country: 'US',
        jurisdiction: 'US-OH',
        jurisdictionName: 'Ohio',
        name: 'Cooperative',
        abbreviation: 'Cooperative;coop.;co-operative;co-op;association;assn;company;co;incorporated;inc.;corporation;corp.',
        active: true,
        aliases: [
            'Cooperative',
            'Cooperative;coop.;co-operative;co-op;association;assn;company;co;incorporated;inc.;corporation;corp.',
        ],
    },
    {
        code: 'G04R',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Sparbank',
        abbreviation: 'SB',
        active: true,
        aliases: ['Sparbank', 'SB'],
    },
    {
        code: 'G0HE',
        country: 'US',
        jurisdiction: 'US-SC',
        jurisdictionName: 'South Carolina',
        name: 'Statutory Close Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.',
        active: true,
        aliases: ['Statutory Close Corporation', 'corp.;inc.;co.;ltd.'],
    },
    {
        code: 'G12F',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Private Limited by Guarantee/No Share Capital',
        abbreviation: '',
        active: false,
        aliases: ['Private Limited by Guarantee/No Share Capital'],
    },
    {
        code: 'G1P6',
        country: 'US',
        jurisdiction: 'US-CA',
        jurisdictionName: 'California',
        name: 'Nonprofit Corporation Mutual Benefit',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation Mutual Benefit'],
    },
    {
        code: 'G2CW',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Территориальные общественные самоуправления',
        abbreviation: '',
        active: true,
        aliases: [
            'Территориальные общественные самоуправления',
            "Territorial'nyye obshchestvennyye samoupravleniya",
        ],
    },
    {
        code: 'G2I3',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Pobočný spolek',
        abbreviation: '',
        active: true,
        aliases: ['Pobočný spolek'],
    },
    {
        code: 'G3JV',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, operadora de fondos de inversión',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima de capital variable, operadora de fondos de inversión'],
    },
    {
        code: 'G3R6',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Einzelkaufmann',
        abbreviation: '',
        active: true,
        aliases: ['Einzelkaufmann'],
    },
    {
        code: 'G42I',
        country: 'US',
        jurisdiction: 'US-NJ',
        jurisdictionName: 'New Jersey',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'G4V6',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Public Unlimited and having a Share Capital (1931 Act)',
        abbreviation: '',
        active: true,
        aliases: ['Public Unlimited and having a Share Capital (1931 Act)'],
    },
    {
        code: 'G4YY',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Limited Partnership',
        abbreviation: 'Limited Partnership;LP',
        active: true,
        aliases: ['Limited Partnership', 'Limited Partnership;LP'],
    },
    {
        code: 'G522',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad cooperativa de consumidores de bienes y/o servicios',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad cooperativa de consumidores de bienes y/o servicios'],
    },
    {
        code: 'G54B',
        country: 'MM',
        jurisdiction: 'MM',
        jurisdictionName: 'Myanmar',
        name: 'တာ၀န်ကန့်သတ်မထားသည့်ကုမ္ပဏီ၊',
        abbreviation: '',
        active: true,
        aliases: ['တာ၀န်ကန့်သတ်မထားသည့်ကုမ္ပဏီ၊', 'tar 0 n k ant saat m htarr saeet kumpane'],
    },
    {
        code: 'G5RH',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Zadruge',
        abbreviation: '',
        active: true,
        aliases: ['Zadruge'],
    },
    {
        code: 'G5RR',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Fundación',
        abbreviation: '',
        active: true,
        aliases: ['Fundación'],
    },
    {
        code: 'G65S',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'Alberta credit union',
        abbreviation: '',
        active: true,
        aliases: ['Alberta credit union'],
    },
    {
        code: 'G66U',
        country: 'US',
        jurisdiction: 'US-NH',
        jurisdictionName: 'New Hampshire',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'G6M8',
        country: 'SC',
        jurisdiction: 'SC',
        jurisdictionName: 'Seychelles',
        name: 'International Business Company - Protected Cell Company',
        abbreviation: 'IBC',
        active: true,
        aliases: ['International Business Company - Protected Cell Company', 'IBC'],
    },
    {
        code: 'G6VI',
        country: 'US',
        jurisdiction: 'US-SC',
        jurisdictionName: 'South Carolina',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'G73Q',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, contraparte central de valores',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima de capital variable, contraparte central de valores'],
    },
    {
        code: 'G76T',
        country: 'US',
        jurisdiction: 'US-MA',
        jurisdictionName: 'Massachusetts',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'G7H0',
        country: 'MU',
        jurisdiction: 'MU',
        jurisdictionName: 'Mauritius',
        name: 'Private Company',
        abbreviation: 'PT;PLC;LTD;LTEE',
        active: true,
        aliases: ['Private Company', 'PT;PLC;LTD;LTEE'],
    },
    {
        code: 'G7Z2',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SARL coopérative de construction',
        abbreviation: '',
        active: true,
        aliases: ['SARL coopérative de construction'],
    },
    {
        code: 'G8LP',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Sociétés Interprofessionnelles de Soins Ambulatoires ',
        abbreviation: '',
        active: true,
        aliases: ['Sociétés Interprofessionnelles de Soins Ambulatoires '],
    },
    {
        code: 'G98S',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Ordre professionnel ou assimilé',
        abbreviation: '',
        active: true,
        aliases: ['Ordre professionnel ou assimilé'],
    },
    {
        code: 'G9PJ',
        country: 'CA',
        jurisdiction: 'CA-MB',
        jurisdictionName: 'Manitoba',
        name: 'Limited Liability Partnership (Manitoba and Extra-provincial, lawyers and accountants only)',
        abbreviation: 'Limited Liability Partnership;LLP;Société à Responabilité Limitée;s.r.l.',
        active: true,
        aliases: [
            'Limited Liability Partnership (Manitoba and Extra-provincial, lawyers and accountants only)',
            'Limited Liability Partnership;LLP;Société à Responabilité Limitée;s.r.l.',
        ],
    },
    {
        code: 'GA3A',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Erakond',
        abbreviation: '',
        active: true,
        aliases: ['Erakond'],
    },
    {
        code: 'GAJN',
        country: 'AW',
        jurisdiction: 'AW',
        jurisdictionName: 'Aruba',
        name: 'Commanditaire vennootschap (1)',
        abbreviation: '',
        active: true,
        aliases: ['Commanditaire vennootschap (1)'],
    },
    {
        code: 'GAMO',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les sociétés nationales de bienfaisance',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur les sociétés nationales de bienfaisance',
        ],
    },
    {
        code: 'GBI5',
        country: 'AM',
        jurisdiction: 'AM',
        jurisdictionName: 'Armenia',
        name: 'Սահմանափակ պատասխանատվությամբ ընկերություն',
        abbreviation: 'ՍՊԸ',
        active: true,
        aliases: [
            'Սահմանափակ պատասխանատվությամբ ընկերություն',
            'Sahmanapʿak patasxanatvutʿyan enkerutʿyun',
            'ՍՊԸ',
            'SPĒ',
        ],
    },
    {
        code: 'GCCT',
        country: 'GI',
        jurisdiction: 'GI',
        jurisdictionName: 'Gibraltar',
        name: 'Limited Liability Partnerships',
        abbreviation: 'LLP',
        active: true,
        aliases: ['Limited Liability Partnerships', 'LLP'],
    },
    {
        code: 'GCP3',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'International Financial Entity (LLC)',
        abbreviation: '',
        active: true,
        aliases: ['International Financial Entity (LLC)', 'Entidad Financiera Internacional (CRL)'],
    },
    {
        code: 'GCU5',
        country: 'US',
        jurisdiction: 'US-KS',
        jurisdictionName: 'Kansas',
        name: 'Corporation',
        abbreviation: 'Co.;corp.;inc.;ltd.',
        active: true,
        aliases: ['Corporation', 'Co.;corp.;inc.;ltd.'],
    },
    {
        code: 'GD6J',
        country: 'US',
        jurisdiction: 'US-AR',
        jurisdictionName: 'Arkansas',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'GDH0',
        country: 'US',
        jurisdiction: 'US-IA',
        jurisdictionName: 'Iowa',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'GDT9',
        country: 'PA',
        jurisdiction: 'PA',
        jurisdictionName: 'Panama',
        name: 'Sociedad Civil',
        abbreviation: 'S.C.',
        active: true,
        aliases: ['Sociedad Civil', 'S.C.'],
    },
    {
        code: 'GEE0',
        country: 'US',
        jurisdiction: 'US-OR',
        jurisdictionName: 'Oregon',
        name: 'Limited Partnership',
        abbreviation: 'Limited Partnership',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'GEXT',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'GF6X',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'business name - sole proprietor',
        abbreviation: '',
        active: true,
        aliases: ['business name - sole proprietor', 'appellation commerciale - propriétaire unique'],
    },
    {
        code: 'GF7G',
        country: 'KR',
        jurisdiction: 'KR',
        jurisdictionName: 'Korea (Republic of)',
        name: '개인사업자',
        abbreviation: '',
        active: true,
        aliases: ['개인사업자', 'GaeInSaEopJa'],
    },
    {
        code: 'GFN6',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA coopérative de commerçants-détaillants à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA coopérative de commerçants-détaillants à conseil d'administration"],
    },
    {
        code: 'GFXN',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Primærkommune',
        abbreviation: '',
        active: true,
        aliases: ['Primærkommune'],
    },
    {
        code: 'GG0S',
        country: 'CA',
        jurisdiction: 'CA-NS',
        jurisdictionName: 'Nova Scotia',
        name: 'company limited by guarantee',
        abbreviation: 'limited company and limited by guarantee;Limited;Limitée;Ltd.;Ltée;Incorporated;Inc.;Ltd',
        active: true,
        aliases: [
            'company limited by guarantee',
            'limited company and limited by guarantee;Limited;Limitée;Ltd.;Ltée;Incorporated;Inc.;Ltd',
        ],
    },
    {
        code: 'GGZ5',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '社会团体',
        abbreviation: '',
        active: true,
        aliases: ['社会团体', 'she hui tuan ti'],
    },
    {
        code: 'GHB2',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: '(Business) Limited Liability Company',
        abbreviation: 'LLC;L.L.C.',
        active: true,
        aliases: ['(Business) Limited Liability Company', 'LLC;L.L.C.'],
    },
    {
        code: 'GHC5',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Сельскохозяйственные потребительские огороднические кооперативы',
        abbreviation: '',
        active: true,
        aliases: [
            'Сельскохозяйственные потребительские огороднические кооперативы',
            "Sel'skokhozyaystvennyye potrebitel'skiye ogorodnicheskiye kooperativy",
        ],
    },
    {
        code: 'GIN3',
        country: 'US',
        jurisdiction: 'US-UT',
        jurisdictionName: 'Utah',
        name: 'Benefit LLC',
        abbreviation: 'L.L.C.;LLC;L.C.;LC',
        active: true,
        aliases: ['Benefit LLC', 'L.L.C.;LLC;L.C.;LC'],
    },
    {
        code: 'GIPE',
        country: 'US',
        jurisdiction: 'US-OK',
        jurisdictionName: 'Oklahoma',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'GJJJ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Société d'exercice libéral à responsabilité limitée à associé unique",
        abbreviation: '',
        active: true,
        aliases: ["Société d'exercice libéral à responsabilité limitée à associé unique"],
    },
    {
        code: 'GJKF',
        country: 'BZ',
        jurisdiction: 'BZ',
        jurisdictionName: 'Belize',
        name: 'Association',
        abbreviation: '',
        active: true,
        aliases: ['Association'],
    },
    {
        code: 'GJL1',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Comanditaria por Acciones',
        abbreviation: 'S.Com. p. A.',
        active: true,
        aliases: ['Sociedad Comanditaria por Acciones', 'S.Com. p. A.'],
    },
    {
        code: 'GJTL',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Comanditaria por Acciones Profesional',
        abbreviation: 'S.Com:p.A.P.',
        active: true,
        aliases: ['Sociedad Comanditaria por Acciones Profesional', 'S.Com:p.A.P.'],
    },
    {
        code: 'GKUL',
        country: 'EC',
        jurisdiction: 'EC',
        jurisdictionName: 'Ecuador',
        name: 'Sociedad por Acciones Simplificada',
        abbreviation: 'SAS',
        active: true,
        aliases: ['Sociedad por Acciones Simplificada', 'SAS'],
    },
    {
        code: 'GL07',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Poisťovňa - akciová spoločnosť',
        abbreviation: 'Poisťovna - a. s.',
        active: true,
        aliases: ['Poisťovňa - akciová spoločnosť', 'Poisťovna - a. s.'],
    },
    {
        code: 'GL33',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'International Banking Center (Corporation)',
        abbreviation: '',
        active: true,
        aliases: [
            'International Banking Center (Corporation)',
            'Centro Bancario Internacional (Corporación)',
        ],
    },
    {
        code: 'GLCH',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Σωματεία και Ιδρυμάτα',
        abbreviation: '',
        active: true,
        aliases: ['Σωματεία και Ιδρυμάτα', 'Somateia kai Idrymata'],
    },
    {
        code: 'GLCI',
        country: 'VG',
        jurisdiction: 'VG',
        jurisdictionName: 'Virgin Islands (British)',
        name: 'restricted purposes company',
        abbreviation: '(SPV) Ltd',
        active: true,
        aliases: ['restricted purposes company', '(SPV) Ltd'],
    },
    {
        code: 'GLN8',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Centre Intercommunal d'action sociale (CIAS)",
        abbreviation: '',
        active: true,
        aliases: ["Centre Intercommunal d'action sociale (CIAS)"],
    },
    {
        code: 'GLX2',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'agricultural society',
        abbreviation: '',
        active: false,
        aliases: ['agricultural society'],
    },
    {
        code: 'GM04',
        country: 'CA',
        jurisdiction: 'CA-MB',
        jurisdictionName: 'Manitoba',
        name: 'Cooperative',
        abbreviation: 'Cooperative Limited;Cooperative Ltd.;Cooperative Inc.;Cooperative incorporated;Co-operative Limited;Co-operative Ltd;Co-operative Inc;Co-operative incorporated;Coopérative limitée;Coopérative ltée;Pool Limited;Pool Ltd.;Pool Inc.;Pool incorporated;Co-op Limited;Co-op limitée;Co-op incorporated;Co-op incorporée;Co-op Inc.',
        active: true,
        aliases: [
            'Cooperative',
            'Cooperative Limited;Cooperative Ltd.;Cooperative Inc.;Cooperative incorporated;Co-operative Limited;Co-operative Ltd;Co-operative Inc;Co-operative incorporated;Coopérative limitée;Coopérative ltée;Pool Limited;Pool Ltd.;Pool Inc.;Pool incorporated;Co-op Limited;Co-op limitée;Co-op incorporated;Co-op incorporée;Co-op Inc.',
        ],
    },
    {
        code: 'GMFE',
        country: 'US',
        jurisdiction: 'US-MD',
        jurisdictionName: 'Maryland',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'GNNT',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, administradora de fondos para el retiro',
        abbreviation: 'S. A. de C.V., Afore',
        active: true,
        aliases: [
            'Sociedad anónima de capital variable, administradora de fondos para el retiro',
            'S. A. de C.V., Afore',
        ],
    },
    {
        code: 'GNXT',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'vereniging van eigenaars',
        abbreviation: 'VvE;VVE;V.v.E.;V.V.E.',
        active: true,
        aliases: ['vereniging van eigenaars', 'VvE;VVE;V.v.E.;V.V.E.'],
    },
    {
        code: 'GNYB',
        country: 'GU',
        jurisdiction: 'GU',
        jurisdictionName: 'Guam',
        name: 'sole proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['sole proprietorship'],
    },
    {
        code: 'GOGQ',
        country: 'US',
        jurisdiction: 'US-MA',
        jurisdictionName: 'Massachusetts',
        name: 'Limited Partnership',
        abbreviation: 'Limited Partnership',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'GORM',
        country: 'AE',
        jurisdiction: 'AE',
        jurisdictionName: 'United Arab Emirates',
        name: 'Professional Company',
        abbreviation: '',
        active: true,
        aliases: ['Professional Company'],
    },
    {
        code: 'GP8M',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Local administration',
        abbreviation: 'Local administration',
        active: true,
        aliases: [
            'Local administration',
            'Administration communale',
            'Commune',
            'Verwaltung der Gemeinde',
            'Gemeinde',
            'Amministrazione comunale',
            'Comune',
        ],
    },
    {
        code: 'GPG0',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'compagnie',
        abbreviation: '',
        active: false,
        aliases: ['compagnie'],
    },
    {
        code: 'GPHT',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '其他（文化）',
        abbreviation: '',
        active: true,
        aliases: ['其他（文化）', 'qi ta（ wen hua ）'],
    },
    {
        code: 'GQ8F',
        country: 'AE',
        jurisdiction: 'AE-RK',
        jurisdictionName: 'Ras Al Khaimah',
        name: 'Company Limited By Guarantee',
        abbreviation: '',
        active: true,
        aliases: ['Company Limited By Guarantee'],
    },
    {
        code: 'GQRJ',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Учреждения, созданные Российской Федерацией',
        abbreviation: '',
        active: true,
        aliases: [
            'Учреждения, созданные Российской Федерацией',
            'Uchrezhdeniya, sozdannyye Rossiyskoy Federatsiyey',
        ],
    },
    {
        code: 'GQV4',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA immobilière pour le commerce et l'industrie (SICOMI) à directoire",
        abbreviation: '',
        active: true,
        aliases: ["SA immobilière pour le commerce et l'industrie (SICOMI) à directoire"],
    },
    {
        code: 'GQVQ',
        country: 'ZA',
        jurisdiction: 'ZA',
        jurisdictionName: 'South Africa',
        name: 'Private Company',
        abbreviation: 'Pty Ltd',
        active: true,
        aliases: ['Private Company', 'Pty Ltd'],
    },
    {
        code: 'GR2X',
        country: 'US',
        jurisdiction: 'US-GA',
        jurisdictionName: 'Georgia',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'GRH5',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Workers Cooperative',
        abbreviation: '',
        active: true,
        aliases: ['Workers Cooperative', 'Cooperativa de Trabajadores'],
    },
    {
        code: 'GT4V',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Cooperativă de credit',
        abbreviation: '',
        active: true,
        aliases: ['Cooperativă de credit'],
    },
    {
        code: 'GTBR',
        country: 'CA',
        jurisdiction: 'CA-NL',
        jurisdictionName: 'Newfoundland and Labrador',
        name: 'Condominium Corporation',
        abbreviation: 'Condominium Corporation',
        active: true,
        aliases: ['Condominium Corporation'],
    },
    {
        code: 'GU5E',
        country: 'AE',
        jurisdiction: 'AE-AZ',
        jurisdictionName: 'Abu Dhabi',
        name: 'Public Company Limited by Shares',
        abbreviation: '',
        active: true,
        aliases: ['Public Company Limited by Shares'],
    },
    {
        code: 'GULL',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Selskab med begrænset ansvar',
        abbreviation: 'SMBA',
        active: true,
        aliases: ['Selskab med begrænset ansvar', 'SMBA'],
    },
    {
        code: 'GVPD',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Offene Handelsgesellschaft',
        abbreviation: 'OHG',
        active: true,
        aliases: ['Offene Handelsgesellschaft', 'OHG'],
    },
    {
        code: 'GW1T',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima bursátil',
        abbreviation: 'S.A.B.',
        active: true,
        aliases: ['Sociedad anónima bursátil', 'S.A.B.'],
    },
    {
        code: 'GWHK',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Общины коренных малочисленных народов Российской Федерации',
        abbreviation: '',
        active: true,
        aliases: [
            'Общины коренных малочисленных народов Российской Федерации',
            'Obshchiny korennykh malochislennykh narodov Rossiyskoy Federatsii',
        ],
    },
    {
        code: 'GWZF',
        country: 'MC',
        jurisdiction: 'MC',
        jurisdictionName: 'Monaco',
        name: 'Société Civile Particulière',
        abbreviation: 'SCP',
        active: true,
        aliases: ['Société Civile Particulière', 'SCP'],
    },
    {
        code: 'GXBE',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima promotora de inversión de capital variable, sociedad financiera de objeto múltiple, entidad regulada',
        abbreviation: 'S.A. P.I. de C.V. , SOFOM E.R.',
        active: true,
        aliases: [
            'Sociedad anónima promotora de inversión de capital variable, sociedad financiera de objeto múltiple, entidad regulada',
            'S.A. P.I. de C.V. , SOFOM E.R.',
        ],
    },
    {
        code: 'GXL6',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Autre établissement public national d'enseignement",
        abbreviation: '',
        active: true,
        aliases: ["Autre établissement public national d'enseignement"],
    },
    {
        code: 'GXLH',
        country: 'US',
        jurisdiction: 'US-OH',
        jurisdictionName: 'Ohio',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'GY0L',
        country: 'GT',
        jurisdiction: 'GT',
        jurisdictionName: 'Guatemala',
        name: 'Sociedad Colectiva',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad Colectiva'],
    },
    {
        code: 'GY5R',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Cirkevná organizácia',
        abbreviation: '',
        active: true,
        aliases: ['Cirkevná organizácia'],
    },
    {
        code: 'GYY6',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Annen juridisk person',
        abbreviation: '',
        active: false,
        aliases: ['Annen juridisk person'],
    },
    {
        code: 'GZCQ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SCP de greffiers de tribunal de commerce',
        abbreviation: '',
        active: true,
        aliases: ['SCP de greffiers de tribunal de commerce'],
    },
    {
        code: 'GZE5',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'wspólnota mieszkaniowa',
        abbreviation: '',
        active: true,
        aliases: ['wspólnota mieszkaniowa'],
    },
    {
        code: 'GZF9',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Структурные подразделения обособленных подразделений юридических лиц',
        abbreviation: '',
        active: true,
        aliases: [
            'Структурные подразделения обособленных подразделений юридических лиц',
            'Strukturnyye podrazdeleniya obosoblennykh podrazdeleniy yuridicheskikh lits',
        ],
    },
    {
        code: 'GZMZ',
        country: 'US',
        jurisdiction: 'US-VT',
        jurisdictionName: 'Vermont',
        name: 'Professional Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Professional Corporation'],
    },
    {
        code: 'GZN4',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Anteilsgesellschaft',
        abbreviation: '',
        active: true,
        aliases: ['Anteilsgesellschaft'],
    },
    {
        code: 'H0PO',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Private Limited Company',
        abbreviation: 'Ltd;Ltd.;Limited',
        active: true,
        aliases: ['Private Limited Company', 'Ltd;Ltd.;Limited', 'cyfyngedig', 'cyf;cyf.'],
    },
    {
        code: 'H1J5',
        country: 'US',
        jurisdiction: 'US-ID',
        jurisdictionName: 'Idaho',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'H1U2',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société en nom collectif',
        abbreviation: '',
        active: true,
        aliases: ['Société en nom collectif'],
    },
    {
        code: 'H1UM',
        country: 'US',
        jurisdiction: 'US-CA',
        jurisdictionName: 'California',
        name: 'For-Profit Corporation General Stock',
        abbreviation: 'Corporation;Company;Incorporated;Incorporation;Limited;Corp;Co;Inc;Ltd',
        active: true,
        aliases: [
            'For-Profit Corporation General Stock',
            'Corporation;Company;Incorporated;Incorporation;Limited;Corp;Co;Inc;Ltd',
        ],
    },
    {
        code: 'H2AF',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Товарищества собственников недвижимости',
        abbreviation: '',
        active: true,
        aliases: [
            'Товарищества собственников недвижимости',
            'Tovarishchestva sobstvennikov nedvizhimosti',
        ],
    },
    {
        code: 'H2BW',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Sociedad civil',
        abbreviation: 'A.C.',
        active: true,
        aliases: ['Sociedad civil', 'A.C.'],
    },
    {
        code: 'H2P4',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Кредитные кооперативы второго уровня',
        abbreviation: '',
        active: true,
        aliases: ['Кредитные кооперативы второго уровня', 'Kreditnyye kooperativy vtorogo urovnya'],
    },
    {
        code: 'H35I',
        country: 'SC',
        jurisdiction: 'SC',
        jurisdictionName: 'Seychelles',
        name: 'Public Company',
        abbreviation: '',
        active: true,
        aliases: ['Public Company'],
    },
    {
        code: 'H3Z4',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SA coopérative de transport à directoire',
        abbreviation: '',
        active: true,
        aliases: ['SA coopérative de transport à directoire'],
    },
    {
        code: 'H3ZD',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SARL d'intérêt collectif agricole (SICA)",
        abbreviation: '',
        active: true,
        aliases: ["SARL d'intérêt collectif agricole (SICA)"],
    },
    {
        code: 'H4NY',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Адвокатские палаты',
        abbreviation: '',
        active: true,
        aliases: ['Адвокатские палаты', 'Advokatskiye palaty'],
    },
    {
        code: 'H4VR',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société civile coopérative de consommation',
        abbreviation: '',
        active: true,
        aliases: ['Société civile coopérative de consommation'],
    },
    {
        code: 'H4XQ',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Veřejné neziskové ústavní zdravotnické zařízení',
        abbreviation: '',
        active: true,
        aliases: ['Veřejné neziskové ústavní zdravotnické zařízení'],
    },
    {
        code: 'H5G0',
        country: 'US',
        jurisdiction: 'US-GA',
        jurisdictionName: 'Georgia',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'H64R',
        country: 'KN',
        jurisdiction: 'KN-N',
        jurisdictionName: 'Nevis',
        name: 'private company',
        abbreviation: '',
        active: true,
        aliases: ['private company'],
    },
    {
        code: 'H6OR',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Εταιρία Περιορισμένης Ευθύνης',
        abbreviation: 'EPE',
        active: true,
        aliases: ['Εταιρία Περιορισμένης Ευθύνης', 'Etería Periorisménis Euthínis', 'EPE'],
    },
    {
        code: 'H6WW',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Státní příspěvková organizace',
        abbreviation: '',
        active: true,
        aliases: ['Státní příspěvková organizace'],
    },
    {
        code: 'H70T',
        country: 'AR',
        jurisdiction: 'AR',
        jurisdictionName: 'Argentina',
        name: 'Sociedad en Comandita Simple',
        abbreviation: 'S.C.S.',
        active: true,
        aliases: ['Sociedad en Comandita Simple', 'S.C.S.'],
    },
    {
        code: 'H725',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, fondo de inversión de objeto limitado',
        abbreviation: 'S. A. de C. V., F. I. de O. L.',
        active: true,
        aliases: [
            'Sociedad anónima de capital variable, fondo de inversión de objeto limitado',
            'S. A. de C. V., F. I. de O. L.',
        ],
    },
    {
        code: 'H781',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Association',
        abbreviation: '',
        active: true,
        aliases: [
            'Association',
            'Association politique, religieuse, scientifique, etc.',
            'Verein',
            'Associazione politico, religioso, scientifico, ecc.',
        ],
    },
    {
        code: 'H7D4',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Soggetto Estero',
        abbreviation: '',
        active: false,
        aliases: ['Soggetto Estero'],
    },
    {
        code: 'H7OD',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'spółdzielcza kasa oszczędnościowo-kredytowa',
        abbreviation: '',
        active: true,
        aliases: ['spółdzielcza kasa oszczędnościowo-kredytowa'],
    },
    {
        code: 'H8G2',
        country: 'PE',
        jurisdiction: 'PE',
        jurisdictionName: 'Peru',
        name: 'Empresa Individual de Responsabilidad Limitada',
        abbreviation: 'EIRL',
        active: true,
        aliases: ['Empresa Individual de Responsabilidad Limitada', 'EIRL'],
    },
    {
        code: 'H8MU',
        country: 'AE',
        jurisdiction: 'AE-AZ',
        jurisdictionName: 'Abu Dhabi',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'H8VP',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Anpartsselskab',
        abbreviation: 'ApS',
        active: true,
        aliases: ['Anpartsselskab', 'ApS'],
    },
    {
        code: 'H987',
        country: 'SC',
        jurisdiction: 'SC',
        jurisdictionName: 'Seychelles',
        name: 'Proprietary Company',
        abbreviation: '',
        active: true,
        aliases: ['Proprietary Company'],
    },
    {
        code: 'H99T',
        country: 'US',
        jurisdiction: 'US-ME',
        jurisdictionName: 'Maine',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'HA2W',
        country: 'OM',
        jurisdiction: 'OM',
        jurisdictionName: 'Oman',
        name: 'شركة الشخص الواحد',
        abbreviation: '',
        active: true,
        aliases: ['شركة الشخص الواحد', 'sharikat alshakhs alwahid'],
    },
    {
        code: 'HA3N',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Caisse de crédit municipal',
        abbreviation: '',
        active: true,
        aliases: ['Caisse de crédit municipal'],
    },
    {
        code: 'HA7M',
        country: 'US',
        jurisdiction: 'US-RI',
        jurisdictionName: 'Rhode island',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'HAAY',
        country: 'TR',
        jurisdiction: 'TR',
        jurisdictionName: 'Türkiye',
        name: 'birlik',
        abbreviation: '',
        active: true,
        aliases: ['birlik'],
    },
    {
        code: 'HATI',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Association intermédiaire',
        abbreviation: '',
        active: true,
        aliases: ['Association intermédiaire'],
    },
    {
        code: 'HBCT',
        country: 'CA',
        jurisdiction: 'CA-MB',
        jurisdictionName: 'Manitoba',
        name: 'Ukrainian Catholic Parish',
        abbreviation: 'The Ukrainian Catholic Parish of;La Paroisse catholique ukrainienne de',
        active: true,
        aliases: [
            'Ukrainian Catholic Parish',
            'The Ukrainian Catholic Parish of;La Paroisse catholique ukrainienne de',
        ],
    },
    {
        code: 'HBQK',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Alternate Investment Fund - Sub scheme',
        abbreviation: '',
        active: true,
        aliases: ['Alternate Investment Fund - Sub scheme'],
    },
    {
        code: 'HBR3',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Julkinen keskinäinen vakuutusyhtiö',
        abbreviation: '',
        active: true,
        aliases: ['Julkinen keskinäinen vakuutusyhtiö', 'Publikt ömsesidigt försäkringsaktiebolag'],
    },
    {
        code: 'HC8N',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SARL union de sociétés coopératives',
        abbreviation: '',
        active: true,
        aliases: ['SARL union de sociétés coopératives'],
    },
    {
        code: 'HCBE',
        country: 'JM',
        jurisdiction: 'JM',
        jurisdictionName: 'Jamaica',
        name: 'company limited by shares',
        abbreviation: '',
        active: true,
        aliases: ['company limited by shares'],
    },
    {
        code: 'HCTP',
        country: 'US',
        jurisdiction: 'US-NV',
        jurisdictionName: 'Nevada',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'HDOD',
        country: 'US',
        jurisdiction: 'US-MS',
        jurisdictionName: 'Mississippi',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'HECG',
        country: 'AE',
        jurisdiction: 'AE-AZ',
        jurisdictionName: 'Abu Dhabi',
        name: 'General Partnership',
        abbreviation: '',
        active: false,
        aliases: ['General Partnership'],
    },
    {
        code: 'HELT',
        country: 'ID',
        jurisdiction: 'ID',
        jurisdictionName: 'Indonesia',
        name: 'Yayasan',
        abbreviation: '',
        active: true,
        aliases: ['Yayasan'],
    },
    {
        code: 'HEMZ',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Credit Union',
        abbreviation: '',
        active: true,
        aliases: ['Credit Union'],
    },
    {
        code: 'HEOB',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Kommandiittiyhtiö',
        abbreviation: 'ky',
        active: true,
        aliases: ['Kommandiittiyhtiö', 'ky', 'Kommanditbolag', 'kb'],
    },
    {
        code: 'HEXO',
        country: 'MK',
        jurisdiction: 'MK',
        jurisdictionName: 'North Macedonia',
        name: 'Јавно трговско друштво',
        abbreviation: 'JTD',
        active: true,
        aliases: ['Јавно трговско друштво', 'Javno trgovsko drushtvo', 'JTD'],
    },
    {
        code: 'HF2L',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Association de droit local (Bas-Rhin, Haut-Rhin et Moselle)',
        abbreviation: '',
        active: true,
        aliases: ['Association de droit local (Bas-Rhin, Haut-Rhin et Moselle)'],
    },
    {
        code: 'HFGV',
        country: 'US',
        jurisdiction: 'US-AL',
        jurisdictionName: 'Alabama',
        name: 'For-Profit Corporation',
        abbreviation: 'Inc.;Corp.',
        active: true,
        aliases: ['For-Profit Corporation', 'Inc.;Corp.'],
    },
    {
        code: 'HGMH',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Labdaros ir paramos fondai',
        abbreviation: 'LF',
        active: true,
        aliases: ['Labdaros ir paramos fondai', 'LF'],
    },
    {
        code: 'HH12',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'HHR4',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Société par actions simplifiée',
        abbreviation: 'S.A.S.',
        active: true,
        aliases: ['Société par actions simplifiée', 'S.A.S.'],
    },
    {
        code: 'HHYT',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'European Public Limited-Liability Company (Societas Europaea)',
        abbreviation: 'SE;S.E.',
        active: false,
        aliases: ['European Public Limited-Liability Company (Societas Europaea)', 'SE;S.E.'],
    },
    {
        code: 'HIL6',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Αλλοδαπή Εταιρεία',
        abbreviation: '',
        active: false,
        aliases: ['Αλλοδαπή Εταιρεία', 'Allodapi Etaireia'],
    },
    {
        code: 'HJ1Y',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Bendrijos',
        abbreviation: 'BN',
        active: true,
        aliases: ['Bendrijos', 'BN'],
    },
    {
        code: 'HJCS',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Društvo, zveza društev',
        abbreviation: '',
        active: true,
        aliases: ['Društvo, zveza društev'],
    },
    {
        code: 'HK03',
        country: 'CA',
        jurisdiction: 'CA-PE',
        jurisdictionName: 'Prince Edward Island',
        name: 'public limited corporation',
        abbreviation: 'Ltd.;Inc.;Corp.;Ltée',
        active: true,
        aliases: ['public limited corporation', 'Ltd.;Inc.;Corp.;Ltée'],
    },
    {
        code: 'HKKL',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Федеральные государственные автономные учреждения',
        abbreviation: '',
        active: true,
        aliases: [
            'Федеральные государственные автономные учреждения',
            "Federal'nyye gosudarstvennyye avtonomnyye uchrezhdeniya",
        ],
    },
    {
        code: 'HKL3',
        country: 'AZ',
        jurisdiction: 'AZ',
        jurisdictionName: 'Azerbaijan',
        name: 'Əlavə məsuliyyətli cəmiyyət',
        abbreviation: '',
        active: true,
        aliases: ['Əlavə məsuliyyətli cəmiyyət'],
    },
    {
        code: 'HKVP',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Αστική (Προσωπική) Εταιρία',
        abbreviation: 'SP',
        active: true,
        aliases: ['Αστική (Προσωπική) Εταιρία', 'Astiki (Proswpiki) Eteria', 'SP'],
    },
    {
        code: 'HKWO',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, sociedad financiera de objeto múltiple, entidad no regulada',
        abbreviation: 'S.A. de C.V., SOFOM E.N.R.',
        active: true,
        aliases: [
            'Sociedad anónima de capital variable, sociedad financiera de objeto múltiple, entidad no regulada',
            'S.A. de C.V., SOFOM E.N.R.',
        ],
    },
    {
        code: 'HLBQ',
        country: 'CA',
        jurisdiction: 'CA-BC',
        jurisdictionName: 'British Columbia',
        name: 'Pension fund society',
        abbreviation: '',
        active: true,
        aliases: ['Pension fund society'],
    },
    {
        code: 'HLCG',
        country: 'US',
        jurisdiction: 'US-CO',
        jurisdictionName: 'Colorado',
        name: 'Limited Partnership',
        abbreviation: 'limited;company;l.p.;lp;ltd.;co.',
        active: true,
        aliases: ['Limited Partnership', 'limited;company;l.p.;lp;ltd.;co.'],
    },
    {
        code: 'HLR4',
        country: 'US',
        jurisdiction: 'US-MD',
        jurisdictionName: 'Maryland',
        name: 'Stock Corporation',
        abbreviation: 'Inc.;Corp.;Ltd.',
        active: true,
        aliases: ['Stock Corporation', 'Inc.;Corp.;Ltd.'],
    },
    {
        code: 'HMEI',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Autre société civile coopérative',
        abbreviation: '',
        active: true,
        aliases: ['Autre société civile coopérative'],
    },
    {
        code: 'HN63',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Командитно дружество с акции',
        abbreviation: 'КДА',
        active: true,
        aliases: ['Командитно дружество с акции', 'Komanditno druzhestvo s aktsii', 'КДА', 'KDA'],
    },
    {
        code: 'HN75',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Consorzio',
        abbreviation: "societa' cooperativa;società cooperativa",
        active: true,
        aliases: ['Consorzio', "societa' cooperativa;società cooperativa"],
    },
    {
        code: 'HN8W',
        country: 'US',
        jurisdiction: 'US-AL',
        jurisdictionName: 'Alabama',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'HNJK',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'HNPH',
        country: 'AE',
        jurisdiction: 'AE-RK',
        jurisdictionName: 'Ras Al Khaimah',
        name: 'Restricted Purposes Company',
        abbreviation: '',
        active: true,
        aliases: ['Restricted Purposes Company'],
    },
    {
        code: 'HNSU',
        country: 'BS',
        jurisdiction: 'BS',
        jurisdictionName: 'Bahamas',
        name: 'Public Company Limited by Shares',
        abbreviation: 'Ltd',
        active: true,
        aliases: ['Public Company Limited by Shares', 'Ltd'],
    },
    {
        code: 'HNWB',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Eurooppalainen taloudellinen etuyhtymä',
        abbreviation: 'ETEY',
        active: true,
        aliases: [
            'Eurooppalainen taloudellinen etuyhtymä',
            'ETEY',
            'Europeisk ekonomisk intresseguppering',
            'EEIG',
        ],
    },
    {
        code: 'HOT8',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'partie polityczne',
        abbreviation: '',
        active: true,
        aliases: ['partie polityczne'],
    },
    {
        code: 'HOV4',
        country: 'US',
        jurisdiction: 'US-VA',
        jurisdictionName: 'Virginia',
        name: 'Stock Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Stock Corporation'],
    },
    {
        code: 'HP0B',
        country: 'BS',
        jurisdiction: 'BS',
        jurisdictionName: 'Bahamas',
        name: 'Company Limited both by Shares and by Guarantee',
        abbreviation: 'Ltd',
        active: true,
        aliases: ['Company Limited both by Shares and by Guarantee', 'Ltd'],
    },
    {
        code: 'HPKC',
        country: 'US',
        jurisdiction: 'US-IA',
        jurisdictionName: 'Iowa',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP'],
    },
    {
        code: 'HQJV',
        country: 'US',
        jurisdiction: 'US-MI',
        jurisdictionName: 'Michigan',
        name: 'Professional Corporation',
        abbreviation: 'P.C.;PC;Professional Corporation',
        active: true,
        aliases: ['Professional Corporation', 'P.C.;PC;Professional Corporation'],
    },
    {
        code: 'HQKE',
        country: 'CA',
        jurisdiction: 'CA-ON',
        jurisdictionName: 'Ontario',
        name: 'general partnership',
        abbreviation: '',
        active: true,
        aliases: ['general partnership'],
    },
    {
        code: 'HQPK',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Komora (hospodářská, agrární)',
        abbreviation: '',
        active: true,
        aliases: ['Komora (hospodářská, agrární)'],
    },
    {
        code: 'HQYG',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Foreign Corporation',
        abbreviation: 'corp.;corporation;co.;company;ltd.;limited;inc.;incorporated',
        active: true,
        aliases: [
            'Foreign Corporation',
            'corp.;corporation;co.;company;ltd.;limited;inc.;incorporated',
        ],
    },
    {
        code: 'HRKG',
        country: 'SG',
        jurisdiction: 'SG',
        jurisdictionName: 'Singapore',
        name: 'Public Company Limited by Guarantee',
        abbreviation: '',
        active: true,
        aliases: ['Public Company Limited by Guarantee'],
    },
    {
        code: 'HRQA',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Cooperativa Europea',
        abbreviation: 'S. Coop. E.;SCE',
        active: true,
        aliases: ['Sociedad Cooperativa Europea', 'S. Coop. E.;SCE'],
    },
    {
        code: 'HS5W',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Vnitřní organizační jednotka organizační složky státu',
        abbreviation: '',
        active: true,
        aliases: ['Vnitřní organizační jednotka organizační složky státu'],
    },
    {
        code: 'HSEV',
        country: 'US',
        jurisdiction: 'US-PA',
        jurisdictionName: 'Pennsylvania',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'HSNC',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Podnik zahraničního obchodu',
        abbreviation: '',
        active: true,
        aliases: ['Podnik zahraničního obchodu'],
    },
    {
        code: 'HSPI',
        country: 'US',
        jurisdiction: 'US-IL',
        jurisdictionName: 'Illinois',
        name: 'Nonprofit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation'],
    },
    {
        code: 'HSX9',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Temporalidad de la Iglesia',
        abbreviation: '',
        active: true,
        aliases: ['Temporalidad de la Iglesia'],
    },
    {
        code: 'HSYZ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Autre société civile professionnelle',
        abbreviation: '',
        active: true,
        aliases: ['Autre société civile professionnelle'],
    },
    {
        code: 'HTBY',
        country: 'BB',
        jurisdiction: 'BB',
        jurisdictionName: 'Barbados',
        name: 'company',
        abbreviation: 'ltd.;corp.;inc.',
        active: true,
        aliases: ['company', 'ltd.;corp.;inc.'],
    },
    {
        code: 'HTJD',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Közhasznú társaság',
        abbreviation: 'Kht.',
        active: true,
        aliases: ['Közhasznú társaság', 'Kht.'],
    },
    {
        code: 'HTT9',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Erillishallinnollinen valtion laitos',
        abbreviation: '',
        active: true,
        aliases: ['Erillishallinnollinen valtion laitos', 'Statlig inrättning med separat förvaltning'],
    },
    {
        code: 'HTV5',
        country: 'US',
        jurisdiction: 'US-TX',
        jurisdictionName: 'Texas',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'HUET',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Религиозные организации',
        abbreviation: '',
        active: true,
        aliases: ['Религиозные организации', 'Religioznyye organizatsii'],
    },
    {
        code: 'HUR1',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Сельскохозяйственные потребительские обслуживающие кооперативы',
        abbreviation: '',
        active: true,
        aliases: [
            'Сельскохозяйственные потребительские обслуживающие кооперативы',
            "Sel'skokhozyaystvennyye potrebitel'skiye obsluzhivayushchiye kooperativy",
        ],
    },
    {
        code: 'HUSW',
        country: 'US',
        jurisdiction: 'US-IA',
        jurisdictionName: 'Iowa',
        name: 'Nonprofit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation'],
    },
    {
        code: 'HV3B',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Non Taxable Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Non Taxable Corporation'],
    },
    {
        code: 'HV9Q',
        country: 'US',
        jurisdiction: 'US-PA',
        jurisdictionName: 'Pennsylvania',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'HVWR',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur la constitution de certaines Églises',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur la constitution de certaines Églises'],
    },
    {
        code: 'HW77',
        country: 'KN',
        jurisdiction: 'KN-N',
        jurisdictionName: 'Nevis',
        name: 'International Business Company',
        abbreviation: 'IBC',
        active: true,
        aliases: ['International Business Company', 'IBC'],
    },
    {
        code: 'HX4T',
        country: 'NZ',
        jurisdiction: 'NZ',
        jurisdictionName: 'New Zealand',
        name: 'Building society',
        abbreviation: '',
        active: true,
        aliases: ['Building society'],
    },
    {
        code: 'HX6D',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Private Limited',
        abbreviation: '',
        active: false,
        aliases: ['Private Limited'],
    },
    {
        code: 'HX77',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Cantonal public company',
        abbreviation: 'Cant. publ. co.',
        active: true,
        aliases: [
            'Cantonal public company',
            'Cant. publ. co.',
            'Entreprise publique cantonale',
            'Ent. pub. cantonale',
            'Unternehmen des Kantons',
            'öff. Unt. Kanton',
            'Impresa pubblica cantonale',
            'Imp. pubb. cantonale',
        ],
    },
    {
        code: 'HXKE',
        country: 'US',
        jurisdiction: 'US-WY',
        jurisdictionName: 'Wyoming',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'HY6K',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Organizační složka zahraničního nadačního fondu',
        abbreviation: '',
        active: true,
        aliases: ['Organizační složka zahraničního nadačního fondu'],
    },
    {
        code: 'HZ6C',
        country: 'AR',
        jurisdiction: 'AR',
        jurisdictionName: 'Argentina',
        name: 'Sociedad Cooperativa',
        abbreviation: 'S. Coop.',
        active: true,
        aliases: ['Sociedad Cooperativa', 'S. Coop.'],
    },
    {
        code: 'HZEH',
        country: 'US',
        jurisdiction: 'US-DE',
        jurisdictionName: 'Delaware',
        name: 'Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Company'],
    },
    {
        code: 'HZG7',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Vysoká škola',
        abbreviation: '',
        active: true,
        aliases: ['Vysoká škola'],
    },
    {
        code: 'HZI2',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Banka-štátny peňažný ústav',
        abbreviation: 'Banka-štát.peňaž.ústav',
        active: true,
        aliases: ['Banka-štátny peňažný ústav', 'Banka-štát.peňaž.ústav'],
    },
    {
        code: 'I03S',
        country: 'KN',
        jurisdiction: 'KN-N',
        jurisdictionName: 'Nevis',
        name: 'international exempt trust',
        abbreviation: '',
        active: true,
        aliases: ['international exempt trust'],
    },
    {
        code: 'I0MH',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société civile coopérative de construction',
        abbreviation: '',
        active: true,
        aliases: ['Société civile coopérative de construction'],
    },
    {
        code: 'I0X7',
        country: 'GH',
        jurisdiction: 'GH',
        jurisdictionName: 'Ghana',
        name: 'Private Unlimited By Share',
        abbreviation: '',
        active: true,
        aliases: ['Private Unlimited By Share'],
    },
    {
        code: 'I15K',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Cooperativă agricolă',
        abbreviation: '',
        active: true,
        aliases: ['Cooperativă agricolă'],
    },
    {
        code: 'I1UP',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Täisühing',
        abbreviation: 'TÜ',
        active: true,
        aliases: ['Täisühing', 'TÜ'],
    },
    {
        code: 'I1WG',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Municipal Enterprise',
        abbreviation: '',
        active: false,
        aliases: ['Municipal Enterprise', 'Corporación de Beneficio Social'],
    },
    {
        code: 'I2WU',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Agrupacion de Interes Economico',
        abbreviation: 'A.I.E.',
        active: true,
        aliases: ['Agrupacion de Interes Economico', 'A.I.E.'],
    },
    {
        code: 'I2XB',
        country: 'US',
        jurisdiction: 'US-TN',
        jurisdictionName: 'Tennessee',
        name: 'Limited Liability Company',
        abbreviation: 'LLC;L.L.C.',
        active: true,
        aliases: ['Limited Liability Company', 'LLC;L.L.C.'],
    },
    {
        code: 'I32F',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Sdružení mezinárodního obchodu',
        abbreviation: '',
        active: true,
        aliases: ['Sdružení mezinárodního obchodu'],
    },
    {
        code: 'I39S',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '机关',
        abbreviation: '',
        active: true,
        aliases: ['机关', 'ji guan'],
    },
    {
        code: 'I3UX',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les services de santé et les services sociaux',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur les services de santé et les services sociaux',
        ],
    },
    {
        code: 'I3Z9',
        country: 'US',
        jurisdiction: 'US-CO',
        jurisdictionName: 'Colorado',
        name: 'For-Profit Public Benefit Corporation',
        abbreviation: 'Corporation;Company;Incorporated;Limited;Corp;Co;Inc;Ltd',
        active: true,
        aliases: [
            'For-Profit Public Benefit Corporation',
            'Corporation;Company;Incorporated;Limited;Corp;Co;Inc;Ltd',
        ],
    },
    {
        code: 'I47Z',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'One Person Company',
        abbreviation: '',
        active: true,
        aliases: ['One Person Company'],
    },
    {
        code: 'I4T1',
        country: 'BR',
        jurisdiction: 'BR',
        jurisdictionName: 'Brazil',
        name: 'Fundação',
        abbreviation: 'Fund.',
        active: true,
        aliases: ['Fundação', 'Fund.'],
    },
    {
        code: 'I5NO',
        country: 'CA',
        jurisdiction: 'CA-PE',
        jurisdictionName: 'Prince Edward Island',
        name: 'sole proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['sole proprietorship'],
    },
    {
        code: 'I5XP',
        country: 'US',
        jurisdiction: 'US-WI',
        jurisdictionName: 'Wisconsin',
        name: 'Limited Liability Limited Partnership',
        abbreviation: 'LLLP',
        active: true,
        aliases: ['Limited Liability Limited Partnership', 'LLLP'],
    },
    {
        code: 'I68R',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Organizační jednotka zvláštní organizace pro zastoupení českých zájmů v mezinárodních nevládních organizacích',
        abbreviation: '',
        active: true,
        aliases: [
            'Organizační jednotka zvláštní organizace pro zastoupení českých zájmů v mezinárodních nevládních organizacích',
        ],
    },
    {
        code: 'I695',
        country: 'PE',
        jurisdiction: 'PE',
        jurisdictionName: 'Peru',
        name: 'Socieda Anónima',
        abbreviation: 'SA',
        active: true,
        aliases: ['Socieda Anónima', 'SA'],
    },
    {
        code: 'I6FV',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Savings & Credit Cooperative',
        abbreviation: '',
        active: true,
        aliases: ['Savings & Credit Cooperative', 'Cooperativa de Ahorro y Crédito'],
    },
    {
        code: 'I7AS',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Družstvo',
        abbreviation: '',
        active: true,
        aliases: ['Družstvo'],
    },
    {
        code: 'I7JL',
        country: 'US',
        jurisdiction: 'US-SD',
        jurisdictionName: 'South Dakota',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'I7MN',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Javno podjetje',
        abbreviation: '',
        active: true,
        aliases: ['Javno podjetje'],
    },
    {
        code: 'I8G4',
        country: 'KN',
        jurisdiction: 'KN-N',
        jurisdictionName: 'Nevis',
        name: 'exempt private company',
        abbreviation: '',
        active: true,
        aliases: ['exempt private company'],
    },
    {
        code: 'I8RE',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Αυτοτελώς εργαζόμενος',
        abbreviation: '',
        active: true,
        aliases: ['Αυτοτελώς εργαζόμενος', 'Aftotelos ergazomenos'],
    },
    {
        code: 'I8TE',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA mixte d'intérêt agricole (SMIA)",
        abbreviation: '',
        active: true,
        aliases: ["SA mixte d'intérêt agricole (SMIA)"],
    },
    {
        code: 'I8VP',
        country: 'CA',
        jurisdiction: 'CA-SK',
        jurisdictionName: 'Saskatchewan',
        name: 'Sole Proprietors',
        abbreviation: '',
        active: true,
        aliases: ['Sole Proprietors'],
    },
    {
        code: 'I8Z8',
        country: 'NZ',
        jurisdiction: 'NZ',
        jurisdictionName: 'New Zealand',
        name: 'Credit union',
        abbreviation: '',
        active: true,
        aliases: ['Credit union'],
    },
    {
        code: 'I93O',
        country: 'KN',
        jurisdiction: 'KN',
        jurisdictionName: 'Saint Kitts and Nevis',
        name: 'public company',
        abbreviation: '',
        active: true,
        aliases: ['public company'],
    },
    {
        code: 'I9BB',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Sucursala',
        abbreviation: '',
        active: false,
        aliases: ['Sucursala'],
    },
    {
        code: 'I9K6',
        country: 'VC',
        jurisdiction: 'VC',
        jurisdictionName: 'Saint Vincent and the Grenadines',
        name: 'partnership',
        abbreviation: '',
        active: true,
        aliases: ['partnership'],
    },
    {
        code: 'I9O1',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Сельскохозяйственные потребительские перерабатывающие кооперативы',
        abbreviation: '',
        active: true,
        aliases: [
            'Сельскохозяйственные потребительские перерабатывающие кооперативы',
            "Sel'skokhozyaystvennyye potrebitel'skiye pererabatyvayushchiye kooperativy",
        ],
    },
    {
        code: 'I9V2',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Организационно-правовые формы юридических лиц, являющихся некоммерческими унитарными организациями',
        abbreviation: '',
        active: true,
        aliases: [
            'Организационно-правовые формы юридических лиц, являющихся некоммерческими унитарными организациями',
            'Organizatsionno-pravovyye formy yuridicheskikh lits, yavlyayushchikhsya nekommercheskimi unitarnymi organizatsiyami',
        ],
    },
    {
        code: 'IAP3',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Syndicat intercommunal à vocation unique (SIVU)',
        abbreviation: '',
        active: true,
        aliases: ['Syndicat intercommunal à vocation unique (SIVU)'],
    },
    {
        code: 'IAS6',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad de Garantia Reciproca',
        abbreviation: 'S.G.R.',
        active: true,
        aliases: ['Sociedad de Garantia Reciproca', 'S.G.R.'],
    },
    {
        code: 'IBEM',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '基层法律服务所',
        abbreviation: '',
        active: true,
        aliases: ['基层法律服务所', 'ji ceng fa lv fu wu suo'],
    },
    {
        code: 'IBSS',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Сельскохозяйственные потребительские снабженческие кооперативы',
        abbreviation: '',
        active: true,
        aliases: [
            'Сельскохозяйственные потребительские снабженческие кооперативы',
            "Sel'skokhozyaystvennyye potrebitel'skiye snabzhencheskiye kooperativy",
        ],
    },
    {
        code: 'IC46',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Сельскохозяйственные артели (колхозы)',
        abbreviation: '',
        active: true,
        aliases: ['Сельскохозяйственные артели (колхозы)', "Sel'skokhozyaystvennyye arteli (kolkhozy)"],
    },
    {
        code: 'IC8G',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SCP d'avocats aux conseils",
        abbreviation: '',
        active: true,
        aliases: ["SCP d'avocats aux conseils"],
    },
    {
        code: 'IC98',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SCP de commissaires-priseurs',
        abbreviation: '',
        active: true,
        aliases: ['SCP de commissaires-priseurs'],
    },
    {
        code: 'ICQT',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Družba za vzajemno zavarovanje',
        abbreviation: 'd.v.z.',
        active: true,
        aliases: ['Družba za vzajemno zavarovanje', 'd.v.z.'],
    },
    {
        code: 'ICXT',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, institución para el depósito de valores',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima de capital variable, institución para el depósito de valores'],
    },
    {
        code: 'ID30',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Limited Partnership',
        abbreviation: 'LP;limited partnership;Limited Partnership',
        active: true,
        aliases: ['Limited Partnership', 'LP;limited partnership;Limited Partnership'],
    },
    {
        code: 'IDBS',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'compagnie de fiducie',
        abbreviation: 'Corporation de fiducie;Compagnie de fiducie;Corporation fiduciaire;Compagnie fiduciaire;Société fiduciaire',
        active: false,
        aliases: [
            'compagnie de fiducie',
            'Corporation de fiducie;Compagnie de fiducie;Corporation fiduciaire;Compagnie fiduciaire;Société fiduciaire',
        ],
    },
    {
        code: 'IDFN',
        country: 'US',
        jurisdiction: 'US-UT',
        jurisdictionName: 'Utah',
        name: 'Professional Corporation',
        abbreviation: 'P.C',
        active: true,
        aliases: ['Professional Corporation', 'P.C'],
    },
    {
        code: 'IF49',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Genossenschaft',
        abbreviation: 'eG;e.G.;e.Gen.',
        active: true,
        aliases: ['Genossenschaft', 'eG;e.G.;e.Gen.'],
    },
    {
        code: 'IF7H',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA coopérative de consommation à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA coopérative de consommation à conseil d'administration"],
    },
    {
        code: 'IGSV',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société civile laitière',
        abbreviation: '',
        active: false,
        aliases: ['Société civile laitière'],
    },
    {
        code: 'IHD0',
        country: 'CW',
        jurisdiction: 'CW',
        jurisdictionName: 'Curaçao',
        name: 'Rederij',
        abbreviation: '',
        active: true,
        aliases: ['Rederij'],
    },
    {
        code: 'IHLF',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Savings & Loan Association',
        abbreviation: 'corp.;inc.;co.;ltd. Incorporated;company;limited;corporation;S&L',
        active: true,
        aliases: [
            'Savings & Loan Association',
            'corp.;inc.;co.;ltd. Incorporated;company;limited;corporation;S&L',
        ],
    },
    {
        code: 'IIZ4',
        country: 'US',
        jurisdiction: 'US-ME',
        jurisdictionName: 'Maine',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'IJAO',
        country: 'PY',
        jurisdiction: 'PY',
        jurisdictionName: 'Paraguay',
        name: 'Sociedad Anonima',
        abbreviation: 'S.A.',
        active: true,
        aliases: ['Sociedad Anonima', 'S.A.'],
    },
    {
        code: 'IJHI',
        country: 'US',
        jurisdiction: 'US-WV',
        jurisdictionName: 'West Virginia',
        name: 'Corporation (for profit)',
        abbreviation: '',
        active: true,
        aliases: ['Corporation (for profit)'],
    },
    {
        code: 'IKBN',
        country: 'PT',
        jurisdiction: 'PT-30',
        jurisdictionName: 'Madeira',
        name: 'Trust',
        abbreviation: '',
        active: true,
        aliases: ['Trust'],
    },
    {
        code: 'IKGM',
        country: 'CA',
        jurisdiction: 'CA-NL',
        jurisdictionName: 'Newfoundland and Labrador',
        name: 'non-share corporations',
        abbreviation: 'Incorporated;Incorporee;Corporation;Inc.;Corp.',
        active: true,
        aliases: ['non-share corporations', 'Incorporated;Incorporee;Corporation;Inc.;Corp.'],
    },
    {
        code: 'IKMB',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'co-operative association',
        abbreviation: 'Ltd.;Ltd;Limited',
        active: true,
        aliases: [
            'co-operative association',
            'Ltd.;Ltd;Limited',
            'association coopérative',
            'limitée;ltée',
        ],
    },
    {
        code: 'IKSU',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'société en nom collectif',
        abbreviation: '',
        active: false,
        aliases: ['société en nom collectif'],
    },
    {
        code: 'ILEX',
        country: 'AM',
        jurisdiction: 'AM',
        jurisdictionName: 'Armenia',
        name: 'Հիմնադրամ',
        abbreviation: 'ՀՄԴ',
        active: true,
        aliases: ['Հիմնադրամ', 'Himnadram', 'ՀՄԴ', 'HMD'],
    },
    {
        code: 'ILON',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'caisse populaire',
        abbreviation: '',
        active: false,
        aliases: ['caisse populaire'],
    },
    {
        code: 'ILY0',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Саморегулируемые организации',
        abbreviation: '',
        active: true,
        aliases: ['Саморегулируемые организации', 'Samoreguliruyemyye organizatsii'],
    },
    {
        code: 'IMDT',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'Limited Liability Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Limited Partnership'],
    },
    {
        code: 'IMHA',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Ente Ecclesiastico',
        abbreviation: '',
        active: true,
        aliases: ['Ente Ecclesiastico'],
    },
    {
        code: 'IN4H',
        country: 'US',
        jurisdiction: 'US-MI',
        jurisdictionName: 'Michigan',
        name: 'Professional Limited Liability Company',
        abbreviation: 'P.L.L.C.;PLLC;Professional Limited Liability Company',
        active: true,
        aliases: [
            'Professional Limited Liability Company',
            'P.L.L.C.;PLLC;Professional Limited Liability Company',
        ],
    },
    {
        code: 'INDH',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Corporation',
        abbreviation: '',
        active: false,
        aliases: ['Corporation', 'Compañía de Responsabilidad Limitada'],
    },
    {
        code: 'INIG',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Odborová organizace',
        abbreviation: '',
        active: true,
        aliases: ['Odborová organizace'],
    },
    {
        code: 'INTY',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Εταιρεία Περιορισμένης Ευθύνης με εγγύηση, και που έχει μετοχικό κεφάλαιο',
        abbreviation: '',
        active: true,
        aliases: [
            'Εταιρεία Περιορισμένης Ευθύνης με εγγύηση, και που έχει μετοχικό κεφάλαιο',
            'Etaireia Periorismenis Efthynis me engyisi, kai pou echei metochiko kefalaio',
        ],
    },
    {
        code: 'IODM',
        country: 'PH',
        jurisdiction: 'PH',
        jurisdictionName: 'Philippines',
        name: 'educational corporation',
        abbreviation: '',
        active: true,
        aliases: ['educational corporation'],
    },
    {
        code: 'IOFN',
        country: 'FJ',
        jurisdiction: 'FJ',
        jurisdictionName: 'Fiji',
        name: 'Private Limited Company',
        abbreviation: 'Pte Ltd; Ltd; Pte Limited',
        active: true,
        aliases: ['Private Limited Company', 'Pte Ltd; Ltd; Pte Limited'],
    },
    {
        code: 'IOWN',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Non Profit Foreign Limited Cooperative Association',
        abbreviation: '',
        active: true,
        aliases: ['Non Profit Foreign Limited Cooperative Association'],
    },
    {
        code: 'IPGV',
        country: 'US',
        jurisdiction: 'US-DC',
        jurisdictionName: 'District of Columbia',
        name: 'Limited Cooperative Association',
        abbreviation: 'L.C.A.;LCA;Co-op.;Coop.;Co-op;Coop;Assoc.;Assoc;Assn.;Assn',
        active: true,
        aliases: [
            'Limited Cooperative Association',
            'L.C.A.;LCA;Co-op.;Coop.;Co-op;Coop;Assoc.;Assoc;Assn.;Assn',
        ],
    },
    {
        code: 'IPTQ',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Eenmanszaak met meerdere eigenaren',
        abbreviation: '',
        active: true,
        aliases: ['Eenmanszaak met meerdere eigenaren'],
    },
    {
        code: 'IQ9O',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Společenství vlastníků jednotek',
        abbreviation: '',
        active: true,
        aliases: ['Společenství vlastníků jednotek'],
    },
    {
        code: 'IQGE',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Allmennaksjeselskap',
        abbreviation: 'ASA',
        active: true,
        aliases: ['Allmennaksjeselskap', 'ASA'],
    },
    {
        code: 'IQR2',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Société civile d'intérêt collectif agricole (SICA)",
        abbreviation: '',
        active: true,
        aliases: ["Société civile d'intérêt collectif agricole (SICA)"],
    },
    {
        code: 'ISCZ',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Doplnková dôchodková poisťovňa',
        abbreviation: 'Doplnková dôchod.poisť.',
        active: true,
        aliases: ['Doplnková dôchodková poisťovňa', 'Doplnková dôchod.poisť.'],
    },
    {
        code: 'IT6N',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Emprendedor de Responsabilidad Limitada',
        abbreviation: 'E.R.L.',
        active: true,
        aliases: ['Emprendedor de Responsabilidad Limitada', 'E.R.L.'],
    },
    {
        code: 'IUIY',
        country: 'CO',
        jurisdiction: 'CO',
        jurisdictionName: 'Colombia',
        name: 'Sociedad en comandita simple',
        abbreviation: 'Cía S. en C.',
        active: true,
        aliases: ['Sociedad en comandita simple', 'Cía S. en C.'],
    },
    {
        code: 'IUOP',
        country: 'TW',
        jurisdiction: 'TW',
        jurisdictionName: 'Taiwan (Province of China)',
        name: '商號',
        abbreviation: '',
        active: true,
        aliases: ['商號', 'shāng hào'],
    },
    {
        code: 'IUVI',
        country: 'JP',
        jurisdiction: 'JP',
        jurisdictionName: 'Japan',
        name: '合名会社',
        abbreviation: '名',
        active: true,
        aliases: ['合名会社', 'goumeigaisya', '名'],
    },
    {
        code: 'IVQQ',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'Corporation Sole',
        abbreviation: '',
        active: true,
        aliases: ['Corporation Sole'],
    },
    {
        code: 'IVVD',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Savez zadruga',
        abbreviation: '',
        active: true,
        aliases: ['Savez zadruga'],
    },
    {
        code: 'IW8Z',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Výrobné družstvo',
        abbreviation: '',
        active: true,
        aliases: ['Výrobné družstvo'],
    },
    {
        code: 'IWNQ',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, institución de financiamiento colectivo',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima de capital variable, institución de financiamiento colectivo'],
    },
    {
        code: 'IWRC',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'IWZF',
        country: 'SG',
        jurisdiction: 'SG',
        jurisdictionName: 'Singapore',
        name: 'Private Company Limited by Shares',
        abbreviation: '',
        active: true,
        aliases: ['Private Company Limited by Shares'],
    },
    {
        code: 'IX01',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Empresa Intermunicipal',
        abbreviation: '',
        active: true,
        aliases: ['Empresa Intermunicipal'],
    },
    {
        code: 'IX7U',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Asukashallintoalue',
        abbreviation: '',
        active: true,
        aliases: ['Asukashallintoalue', 'Boendeförvaltningsområde'],
    },
    {
        code: 'IXQK',
        country: 'JO',
        jurisdiction: 'JO',
        jurisdictionName: 'Jordan',
        name: 'شركة التوصية بالأسهم',
        abbreviation: '',
        active: true,
        aliases: ['شركة التوصية بالأسهم', "sharikat altawsia bial'ashum"],
    },
    {
        code: 'IY8C',
        country: 'US',
        jurisdiction: 'US-NV',
        jurisdictionName: 'Nevada',
        name: 'Nonprofit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation'],
    },
    {
        code: 'IYF9',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Evankelis-luterilainen kirkko',
        abbreviation: '',
        active: true,
        aliases: ['Evankelis-luterilainen kirkko', 'Ev.luth. kyrkan'],
    },
    {
        code: 'IYXU',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Community Benefit Society',
        abbreviation: 'BenCom',
        active: true,
        aliases: ['Community Benefit Society', 'BenCom'],
    },
    {
        code: 'IYZI',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Limited Liability Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Limited Partnership'],
    },
    {
        code: 'J18N',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Товарищества на вере (коммандитные товарищества)',
        abbreviation: '',
        active: true,
        aliases: [
            'Товарищества на вере (коммандитные товарищества)',
            'Tovarishchestva na vere (kommanditnyye tovarishchestva)',
        ],
    },
    {
        code: 'J1JO',
        country: 'US',
        jurisdiction: 'US-MO',
        jurisdictionName: 'Missouri',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'J1V0',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Limited Liability Partnership',
        abbreviation: 'LLP;L.L.P.',
        active: true,
        aliases: ['Limited Liability Partnership', 'LLP;L.L.P.'],
    },
    {
        code: 'J2DN',
        country: 'UY',
        jurisdiction: 'UY',
        jurisdictionName: 'Uruguay',
        name: 'Sindicato',
        abbreviation: '',
        active: true,
        aliases: ['Sindicato'],
    },
    {
        code: 'J34T',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Ametiühing',
        abbreviation: 'AÜ',
        active: true,
        aliases: ['Ametiühing', 'AÜ'],
    },
    {
        code: 'J3A3',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'spółka europejska',
        abbreviation: 'SE',
        active: true,
        aliases: ['spółka europejska', 'SE'],
    },
    {
        code: 'J3C5',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'Alberta unlimited liability corporation',
        abbreviation: '',
        active: true,
        aliases: ['Alberta unlimited liability corporation'],
    },
    {
        code: 'J3T2',
        country: 'EC',
        jurisdiction: 'EC',
        jurisdictionName: 'Ecuador',
        name: 'Compañía Anónima',
        abbreviation: 'SA',
        active: true,
        aliases: ['Compañía Anónima', 'SA'],
    },
    {
        code: 'J3U5',
        country: 'KR',
        jurisdiction: 'KR',
        jurisdictionName: 'Korea (Republic of)',
        name: '유한회사',
        abbreviation: '(유)',
        active: true,
        aliases: ['유한회사', 'YuHanHoeSa', '(유)', '(Yu)'],
    },
    {
        code: 'J3VJ',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Συνεταιρισμός',
        abbreviation: 'COOP',
        active: true,
        aliases: ['Συνεταιρισμός', 'Sinetairismos', 'COOP'],
    },
    {
        code: 'J4JC',
        country: 'AU',
        jurisdiction: 'AU',
        jurisdictionName: 'Australia',
        name: 'Limited Partnership',
        abbreviation: 'A Limited Partnership;An Incorporated Limited Partnership;LP;LP.;Lp.;Lp;I.L.P;ILP',
        active: true,
        aliases: [
            'Limited Partnership',
            'A Limited Partnership;An Incorporated Limited Partnership;LP;LP.;Lp.;Lp;I.L.P;ILP',
        ],
    },
    {
        code: 'J4QX',
        country: 'AM',
        jurisdiction: 'AM',
        jurisdictionName: 'Armenia',
        name: 'Նախարարություն',
        abbreviation: '',
        active: true,
        aliases: ['Նախարարություն', 'Naxararutʿyun '],
    },
    {
        code: 'J4S1',
        country: 'MT',
        jurisdiction: 'MT',
        jurisdictionName: 'Malta',
        name: 'association',
        abbreviation: '',
        active: true,
        aliases: ['association'],
    },
    {
        code: 'J5NM',
        country: 'US',
        jurisdiction: 'US-MD',
        jurisdictionName: 'Maryland',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'J5OU',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Economisch samenwerkingsverband',
        abbreviation: 'ESV',
        active: true,
        aliases: [
            'Economisch samenwerkingsverband',
            'ESV',
            "Groupement d'intérêt économique",
            'GIE',
            'Wirtschaftliche Interessenvereinigung',
            'WIV',
        ],
    },
    {
        code: 'J5RC',
        country: 'GH',
        jurisdiction: 'GH',
        jurisdictionName: 'Ghana',
        name: 'Private Limited By Guarantee',
        abbreviation: '',
        active: true,
        aliases: ['Private Limited By Guarantee'],
    },
    {
        code: 'J5SC',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur la conservation et la mise en valeur de la faune',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur la conservation et la mise en valeur de la faune',
        ],
    },
    {
        code: 'J6MO',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Közkereseti társaság',
        abbreviation: 'Kkt.',
        active: true,
        aliases: ['Közkereseti társaság', 'Kkt.'],
    },
    {
        code: 'J76S',
        country: 'MU',
        jurisdiction: 'MU',
        jurisdictionName: 'Mauritius',
        name: 'Limited Partnership',
        abbreviation: 'Limited Partnership;LP;L.P.',
        active: true,
        aliases: ['Limited Partnership', 'Limited Partnership;LP;L.P.'],
    },
    {
        code: 'J7G9',
        country: 'BR',
        jurisdiction: 'BR',
        jurisdictionName: 'Brazil',
        name: 'Associação',
        abbreviation: 'Assoc.',
        active: true,
        aliases: ['Associação', 'Assoc.'],
    },
    {
        code: 'J7L0',
        country: 'ZA',
        jurisdiction: 'ZA',
        jurisdictionName: 'South Africa',
        name: 'Non-Profit Company',
        abbreviation: 'NPC',
        active: true,
        aliases: ['Non-Profit Company', 'NPC'],
    },
    {
        code: 'J7NW',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Простые товарищества',
        abbreviation: '',
        active: true,
        aliases: ['Простые товарищества', 'Prostyye tovarishchestva'],
    },
    {
        code: 'J7SF',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '有限合伙企业',
        abbreviation: '',
        active: true,
        aliases: ['有限合伙企业', 'youxian hehuo qiye'],
    },
    {
        code: 'J8DW',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Podnik zahraničnej osoby (organizačná zložka podniku zahraničnej osoby)',
        abbreviation: 'Podnik zahr. osoby, org. zložka',
        active: true,
        aliases: [
            'Podnik zahraničnej osoby (organizačná zložka podniku zahraničnej osoby)',
            'Podnik zahr. osoby, org. zložka',
        ],
    },
    {
        code: 'J8PB',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Obec',
        abbreviation: '',
        active: true,
        aliases: ['Obec'],
    },
    {
        code: 'J98R',
        country: 'BN',
        jurisdiction: 'BN',
        jurisdictionName: 'Brunei Darussalam',
        name: 'Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Partnership'],
    },
    {
        code: 'J9OZ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Société d'exercice libéral à responsabilité limitée",
        abbreviation: '',
        active: true,
        aliases: ["Société d'exercice libéral à responsabilité limitée"],
    },
    {
        code: 'JAJS',
        country: 'ID',
        jurisdiction: 'ID',
        jurisdictionName: 'Indonesia',
        name: 'Perseroan Terbatas Penanaman Modal Asing',
        abbreviation: 'PT PMA',
        active: true,
        aliases: ['Perseroan Terbatas Penanaman Modal Asing', 'PT PMA'],
    },
    {
        code: 'JAM3',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Coöperatieve vennootschap van publiek recht',
        abbreviation: 'CV PR',
        active: true,
        aliases: [
            'Coöperatieve vennootschap van publiek recht',
            'CV PR',
            'Société coopérative de droit public',
            'SC DPU',
            'Öffentlich-rechtliche Genossenschaft',
            'ÖrGen.',
        ],
    },
    {
        code: 'JB25',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Swiss branch of an enterprise domiciled abroad registered in the commercial registrer',
        abbreviation: 'Foreign PLC',
        active: false,
        aliases: [
            'Swiss branch of an enterprise domiciled abroad registered in the commercial registrer',
            'Foreign PLC',
            "Succursale suisse d'une entreprise domiciliée à l'étranger inscrite au registre de commerce",
            'SAdom. étran.',
            'Ausländische Niederlassung im Handelsregister eingetragen',
            'Ausl. AG & LTD',
            "Succursale di una impresa domiciliata all'estero iscritta al registro di commercio",
            'SA dom. estero',
        ],
    },
    {
        code: 'JB2M',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Limitada Profesional',
        abbreviation: 'S.R.L.P.;S.L.P.',
        active: true,
        aliases: ['Sociedad Limitada Profesional', 'S.R.L.P.;S.L.P.'],
    },
    {
        code: 'JBBW',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'company',
        abbreviation: '',
        active: true,
        aliases: ['company', 'compagnie'],
    },
    {
        code: 'JBIQ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Institution de prévoyance',
        abbreviation: '',
        active: true,
        aliases: ['Institution de prévoyance'],
    },
    {
        code: 'JBQI',
        country: 'US',
        jurisdiction: 'US-OH',
        jurisdictionName: 'Ohio',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: 'JBU2',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les clubs de chasse et de pêche',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur les clubs de chasse et de pêche'],
    },
    {
        code: 'JC0Y',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Osaühing',
        abbreviation: 'OÜ',
        active: true,
        aliases: ['Osaühing', 'OÜ'],
    },
    {
        code: 'JCAD',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Evidované církevní právnické osoby',
        abbreviation: '',
        active: true,
        aliases: ['Evidované církevní právnické osoby'],
    },
    {
        code: 'JCK1',
        country: 'MK',
        jurisdiction: 'MK',
        jurisdictionName: 'North Macedonia',
        name: 'Стопанска интересна заедница',
        abbreviation: 'SIZ',
        active: true,
        aliases: ['Стопанска интересна заедница', 'Stopanska interesna zaednica', 'SIZ'],
    },
    {
        code: 'JCKO',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'państwowe jednostki organizacyjne',
        abbreviation: '',
        active: true,
        aliases: ['państwowe jednostki organizacyjne'],
    },
    {
        code: 'JDX6',
        country: 'KY',
        jurisdiction: 'KY',
        jurisdictionName: 'Cayman Islands',
        name: 'special economic zone company',
        abbreviation: 'SEZC',
        active: true,
        aliases: ['special economic zone company', 'SEZC'],
    },
    {
        code: 'JEMR',
        country: 'AM',
        jurisdiction: 'AM',
        jurisdictionName: 'Armenia',
        name: 'Իրավաբանական անձանց միություն',
        abbreviation: 'ԻԱՄ',
        active: true,
        aliases: ['Իրավաբանական անձանց միություն', 'Iravabanakan andzants miutʿyun', 'ԻԱՄ', 'IAM'],
    },
    {
        code: 'JF6D',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Nonprofit Community Trust',
        abbreviation: 'corp.;inc.;co.;ltd. Incorporated;company;limited;corporation',
        active: true,
        aliases: [
            'Nonprofit Community Trust',
            'corp.;inc.;co.;ltd. Incorporated;company;limited;corporation',
        ],
    },
    {
        code: 'JFET',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société de Participations Financières de Profession Libérale Société anonyme à Directoire (SPFPL SA à directoire)',
        abbreviation: '',
        active: true,
        aliases: [
            'Société de Participations Financières de Profession Libérale Société anonyme à Directoire (SPFPL SA à directoire)',
        ],
    },
    {
        code: 'JFQ5',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Buitenlandse rechtsvorm hoofdvestiging op Bonaire',
        abbreviation: '',
        active: false,
        aliases: ['Buitenlandse rechtsvorm hoofdvestiging op Bonaire'],
    },
    {
        code: 'JGNU',
        country: 'AE',
        jurisdiction: 'AE',
        jurisdictionName: 'United Arab Emirates',
        name: 'Public Joint Stock Company',
        abbreviation: '',
        active: true,
        aliases: ['Public Joint Stock Company'],
    },
    {
        code: 'JGPP',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Rural Cooperative Association',
        abbreviation: '',
        active: true,
        aliases: ['Rural Cooperative Association'],
    },
    {
        code: 'JGV1',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable',
        abbreviation: 'S. A. de C. V.',
        active: true,
        aliases: ['Sociedad anónima de capital variable', 'S. A. de C. V.'],
    },
    {
        code: 'JH78',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Company (Limited By Guarantee)',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Company (Limited By Guarantee)'],
    },
    {
        code: 'JHC4',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Foundation',
        abbreviation: '',
        active: true,
        aliases: ['Foundation'],
    },
    {
        code: 'JHK5',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'fonds voor gemene rekening',
        abbreviation: '',
        active: true,
        aliases: ['fonds voor gemene rekening'],
    },
    {
        code: 'JI3A',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Keskinäinen vahinkovakuutusyhdistys',
        abbreviation: '',
        active: true,
        aliases: ['Keskinäinen vahinkovakuutusyhdistys', 'Ömsesidigt skadeförsäkringsförening'],
    },
    {
        code: 'JI4V',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur la mise en marché des produits agricoles, alimentaires et de la pêche',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur la mise en marché des produits agricoles, alimentaires et de la pêche',
        ],
    },
    {
        code: 'JIF7',
        country: 'US',
        jurisdiction: 'US-KS',
        jurisdictionName: 'Kansas',
        name: 'Statutory Public Benefit Limited Liability Company',
        abbreviation: 'S.P.B.L.L.C.;SPBLLC',
        active: true,
        aliases: ['Statutory Public Benefit Limited Liability Company', 'S.P.B.L.L.C.;SPBLLC'],
    },
    {
        code: 'JIWD',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: "Autres personnes morales dont l'immatriculation est prévue par l'article 1 de la loi modifiée du 19 décembre 2002 concernant le registre de commerce et des sociétés ainsi que la comptabilité et les comptes annuels des entreprises",
        abbreviation: 'OTH',
        active: true,
        aliases: [
            "Autres personnes morales dont l'immatriculation est prévue par l'article 1 de la loi modifiée du 19 décembre 2002 concernant le registre de commerce et des sociétés ainsi que la comptabilité et les comptes annuels des entreprises",
            'OTH',
        ],
    },
    {
        code: 'JIYK',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Syndicat inter hospitalier',
        abbreviation: '',
        active: true,
        aliases: ['Syndicat inter hospitalier'],
    },
    {
        code: 'JJ1V',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Trust',
        abbreviation: '',
        active: true,
        aliases: ['Trust', 'Fideicomiso'],
    },
    {
        code: 'JJ5L',
        country: 'US',
        jurisdiction: 'US-VT',
        jurisdictionName: 'Vermont',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'JJ9M',
        country: 'US',
        jurisdiction: 'US-MD',
        jurisdictionName: 'Maryland',
        name: 'Limited Liability Company',
        abbreviation: 'L.L.C., LLC , L.C., L C',
        active: true,
        aliases: ['Limited Liability Company', 'L.L.C., LLC , L.C., L C'],
    },
    {
        code: 'JJYB',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Zahraniční pobočný spolek',
        abbreviation: '',
        active: true,
        aliases: ['Zahraniční pobočný spolek'],
    },
    {
        code: 'JJYT',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Körperschaft öffentlichen Rechts',
        abbreviation: '',
        active: true,
        aliases: ['Körperschaft öffentlichen Rechts'],
    },
    {
        code: 'JKC5',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Podnik alebo hospodárske zariadenie združenia',
        abbreviation: 'Podnik alebo hosp.zar.',
        active: true,
        aliases: ['Podnik alebo hospodárske zariadenie združenia', 'Podnik alebo hosp.zar.'],
    },
    {
        code: 'JKJX',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Provident fund / Superannuation fund / Gratuity fund / Insurance Fund',
        abbreviation: '',
        active: true,
        aliases: ['Provident fund / Superannuation fund / Gratuity fund / Insurance Fund'],
    },
    {
        code: 'JKOT',
        country: 'US',
        jurisdiction: 'US-CT',
        jurisdictionName: 'Connecticut',
        name: 'Stock Corporation',
        abbreviation: 'Inc.;Co.;Corp.',
        active: true,
        aliases: ['Stock Corporation', 'Inc.;Co.;Corp.'],
    },
    {
        code: 'JLE0',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur la conservation de la faune',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur la conservation de la faune'],
    },
    {
        code: 'JLNM',
        country: 'KW',
        jurisdiction: 'KW',
        jurisdictionName: 'Kuwait',
        name: 'شركة تضامن',
        abbreviation: '',
        active: true,
        aliases: ['شركة تضامن', 'Sharikat tadamun'],
    },
    {
        code: 'JLR3',
        country: 'BY',
        jurisdiction: 'BY',
        jurisdictionName: 'Belarus',
        name: 'Таварыства з дадатковай адказнасцю',
        abbreviation: 'ТДА',
        active: true,
        aliases: [
            'Таварыства з дадатковай адказнасцю',
            'Tavarystva z dadatkovaj adkaznascyu',
            'ТДА',
            'ТDA',
            'Общество с дополнительной ответственностью',
            "Obshchestvo s dopolnitel'noj otvetstvennost'yu",
            'ОДО',
            'ODO',
        ],
    },
    {
        code: 'JLZW',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Société par actions constitué par Loi sur les compagnies de fidéicommis',
        abbreviation: '',
        active: true,
        aliases: ['Société par actions constitué par Loi sur les compagnies de fidéicommis'],
    },
    {
        code: 'JM1W',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SCP de dentistes',
        abbreviation: '',
        active: true,
        aliases: ['SCP de dentistes'],
    },
    {
        code: 'JMO0',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Commission syndicale pour la gestion des biens indivis des communes',
        abbreviation: '',
        active: true,
        aliases: ['Commission syndicale pour la gestion des biens indivis des communes'],
    },
    {
        code: 'JMQU',
        country: 'TR',
        jurisdiction: 'TR',
        jurisdictionName: 'Türkiye',
        name: 'kollektif şirket',
        abbreviation: 'Koll.Şti.',
        active: true,
        aliases: ['kollektif şirket', 'Koll.Şti.'],
    },
    {
        code: 'JMVF',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Investmentaktiengesellschaft',
        abbreviation: 'InvAG',
        active: true,
        aliases: ['Investmentaktiengesellschaft', 'InvAG'],
    },
    {
        code: 'JN2P',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SARL unipersonnelle',
        abbreviation: '',
        active: false,
        aliases: ['SARL unipersonnelle'],
    },
    {
        code: 'JN6Y',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad cooperativa de capital variable',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad cooperativa de capital variable'],
    },
    {
        code: 'JNAD',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Besloten vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk',
        abbreviation: 'BVBA SO',
        active: true,
        aliases: [
            'Besloten vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk',
            'BVBA SO',
            'Société privée à responsabilité limitée à finalité sociale',
            'SPRL FS',
            'Privatgesellschaft mit beschränkter Haftung mit sozialer Zielsetzung',
            'PmbHsZ',
        ],
    },
    {
        code: 'JNCJ',
        country: 'CA',
        jurisdiction: 'CA-SK',
        jurisdictionName: 'Saskatchewan',
        name: 'Co-operatives',
        abbreviation: 'co-op;ltd.',
        active: true,
        aliases: ['Co-operatives', 'co-op;ltd.'],
    },
    {
        code: 'JNDX',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Europäische wirtschaftliche Interessenvereinigung',
        abbreviation: 'EWIV',
        active: true,
        aliases: ['Europäische wirtschaftliche Interessenvereinigung', 'EWIV'],
    },
    {
        code: 'JNJI',
        country: 'BH',
        jurisdiction: 'BH',
        jurisdictionName: 'Bahrain',
        name: 'الشركة ذات المسؤولية المحدودة',
        abbreviation: 'ذ.م.م',
        active: true,
        aliases: ['الشركة ذات المسؤولية المحدودة', 'Sharika That Almasuliah Almahduda', 'ذ.م.م'],
    },
    {
        code: 'JNYX',
        country: 'US',
        jurisdiction: 'US-WI',
        jurisdictionName: 'Wisconsin',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'JOGO',
        country: 'CA',
        jurisdiction: 'CA-PE',
        jurisdictionName: 'Prince Edward Island',
        name: 'credit union',
        abbreviation: 'Ltd.;Ltée',
        active: true,
        aliases: ['credit union', 'Ltd.;Ltée'],
    },
    {
        code: 'JOX1',
        country: 'JE',
        jurisdiction: 'JE',
        jurisdictionName: 'Jersey',
        name: 'Public Limited Company',
        abbreviation: 'LTD;PLC;Limited',
        active: true,
        aliases: ['Public Limited Company', 'LTD;PLC;Limited'],
    },
    {
        code: 'JOZN',
        country: 'MT',
        jurisdiction: 'MT',
        jurisdictionName: 'Malta',
        name: 'Partnership en nom collectif',
        abbreviation: '',
        active: true,
        aliases: ['Partnership en nom collectif', 'soċjetà f’isem kollettiv'],
    },
    {
        code: 'JPMQ',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Организационно-правовые формы организаций, созданных без прав юридического лица',
        abbreviation: '',
        active: true,
        aliases: [
            'Организационно-правовые формы организаций, созданных без прав юридического лица',
            'Organizatsionno-pravovyye formy organizatsiy, sozdannykh bez prav yuridicheskogo litsa',
        ],
    },
    {
        code: 'JPZW',
        country: 'US',
        jurisdiction: 'US-AL',
        jurisdictionName: 'Alabama',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'JQA2',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Kmetijska zadruga',
        abbreviation: '',
        active: true,
        aliases: ['Kmetijska zadruga'],
    },
    {
        code: 'JQNA',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les sociétés préventives de cruauté envers les animaux',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur les sociétés préventives de cruauté envers les animaux',
        ],
    },
    {
        code: 'JQOI',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Sparkasse',
        abbreviation: '',
        active: true,
        aliases: ['Sparkasse'],
    },
    {
        code: 'JR3Z',
        country: 'US',
        jurisdiction: 'US-ME',
        jurisdictionName: 'Maine',
        name: 'Cooperative',
        abbreviation: '',
        active: true,
        aliases: ['Cooperative'],
    },
    {
        code: 'JR6U',
        country: 'US',
        jurisdiction: 'US-AR',
        jurisdictionName: 'Arkansas',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'JR7T',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SARL nationale',
        abbreviation: '',
        active: true,
        aliases: ['SARL nationale'],
    },
    {
        code: 'JRAQ',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Agrupaciones financieras',
        abbreviation: 'A.F.',
        active: true,
        aliases: ['Agrupaciones financieras', 'A.F.'],
    },
    {
        code: 'JRTH',
        country: 'FJ',
        jurisdiction: 'FJ',
        jurisdictionName: 'Fiji',
        name: 'Trusts and Estates',
        abbreviation: '',
        active: true,
        aliases: ['Trusts and Estates'],
    },
    {
        code: 'JS13',
        country: 'PA',
        jurisdiction: 'PA',
        jurisdictionName: 'Panama',
        name: 'Sociedad de Responsabilidad Limitada',
        abbreviation: 'S.R.L.',
        active: true,
        aliases: ['Sociedad de Responsabilidad Limitada', 'S.R.L.'],
    },
    {
        code: 'JS65',
        country: 'VG',
        jurisdiction: 'VG',
        jurisdictionName: 'Virgin Islands (British)',
        name: 'unlimited company that is not authorised to issue shares',
        abbreviation: 'Unltd',
        active: true,
        aliases: ['unlimited company that is not authorised to issue shares', 'Unltd'],
    },
    {
        code: 'JSTL',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad de solidaridad social',
        abbreviation: 'S. de S. S.',
        active: true,
        aliases: ['Sociedad de solidaridad social', 'S. de S. S.'],
    },
    {
        code: 'JTAV',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Offene Gesellschaft',
        abbreviation: 'OG',
        active: true,
        aliases: ['Offene Gesellschaft', 'OG'],
    },
    {
        code: 'JTCO',
        country: 'GB',
        jurisdiction: 'GB-NIR',
        jurisdictionName: 'Northern Ireland',
        name: 'Credit Union (Northern Ireland)',
        abbreviation: '',
        active: true,
        aliases: ['Credit Union (Northern Ireland)'],
    },
    {
        code: 'JTJE',
        country: 'VU',
        jurisdiction: 'VU',
        jurisdictionName: 'Vanuatu',
        name: 'Local Company',
        abbreviation: '',
        active: true,
        aliases: ['Local Company'],
    },
    {
        code: 'JTV5',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Fondo de Capital-Riesgo',
        abbreviation: 'FCR',
        active: true,
        aliases: ['Fondo de Capital-Riesgo', 'FCR'],
    },
    {
        code: 'JU79',
        country: 'US',
        jurisdiction: 'US-DE',
        jurisdictionName: 'Delaware',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'JU82',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Ministére',
        abbreviation: '',
        active: true,
        aliases: ['Ministére'],
    },
    {
        code: 'JUDZ',
        country: 'HN',
        jurisdiction: 'HN',
        jurisdictionName: 'Honduras',
        name: 'Sociedad Anónima',
        abbreviation: 'S.A.',
        active: true,
        aliases: ['Sociedad Anónima', 'S.A.'],
    },
    {
        code: 'JUEU',
        country: 'TH',
        jurisdiction: 'TH',
        jurisdictionName: 'Thailand',
        name: 'ห้างหุ้นส่วนจำกัด',
        abbreviation: '',
        active: true,
        aliases: ['ห้างหุ้นส่วนจำกัด', 'H̄̂āngh̄ûns̄̀wncảkạd'],
    },
    {
        code: 'JUHG',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Offene Erwerbsgesellschaft',
        abbreviation: 'OEG',
        active: true,
        aliases: ['Offene Erwerbsgesellschaft', 'OEG'],
    },
    {
        code: 'JVMD',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: "Société par actions par Fonds mutuel constitué par acte de fiducie, Loi sur les assurances, Loi sur les compagnies de fidéicommis, Loi sur les compagnies de flottage, Loi sur les compagnies de gaz, d’eau et d’électricité, Loi sur les compagnies de télégraphe et de téléphone, Loi sur les compagnies minières, Loi sur les sociétés de construction, Loi sur les sociétés de développement de l'entreprise québécoise, Loi sur les sociétés de fiducie et les sociétés d'épargne, Loi sur les sociétés de patrons de fabriques de producteurs laitiers, Loi sur les sociétés d'entraide économique, Loi sur les sociétés d'exploration minière, Loi sur les syndicats d'élevage",
        abbreviation: '',
        active: false,
        aliases: [
            "Société par actions par Fonds mutuel constitué par acte de fiducie, Loi sur les assurances, Loi sur les compagnies de fidéicommis, Loi sur les compagnies de flottage, Loi sur les compagnies de gaz, d’eau et d’électricité, Loi sur les compagnies de télégraphe et de téléphone, Loi sur les compagnies minières, Loi sur les sociétés de construction, Loi sur les sociétés de développement de l'entreprise québécoise, Loi sur les sociétés de fiducie et les sociétés d'épargne, Loi sur les sociétés de patrons de fabriques de producteurs laitiers, Loi sur les sociétés d'entraide économique, Loi sur les sociétés d'exploration minière, Loi sur les syndicats d'élevage",
        ],
    },
    {
        code: 'JWTD',
        country: 'US',
        jurisdiction: 'US-VT',
        jurisdictionName: 'Vermont',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'JWWT',
        country: 'MU',
        jurisdiction: 'MU',
        jurisdictionName: 'Mauritius',
        name: 'Foundation',
        abbreviation: 'F',
        active: true,
        aliases: ['Foundation', 'F'],
    },
    {
        code: 'JXDX',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'Societas Europaea',
        abbreviation: 'SE',
        active: true,
        aliases: ['Societas Europaea', 'SE'],
    },
    {
        code: 'JXO5',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: "Société par actions constitué par Loi sur les sociétés de fiducie et les sociétés d'épargne",
        abbreviation: '',
        active: true,
        aliases: [
            "Société par actions constitué par Loi sur les sociétés de fiducie et les sociétés d'épargne",
        ],
    },
    {
        code: 'JXUC',
        country: 'US',
        jurisdiction: 'US-ID',
        jurisdictionName: 'Idaho',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'JYAN',
        country: 'BO',
        jurisdiction: 'BO',
        jurisdictionName: 'Bolivia (Plurinational State of)',
        name: 'Empresa Estatal Intergubernamental',
        abbreviation: '',
        active: true,
        aliases: ['Empresa Estatal Intergubernamental'],
    },
    {
        code: 'JYKN',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Λοιπά',
        abbreviation: '',
        active: false,
        aliases: ['Λοιπά', 'Lipa'],
    },
    {
        code: 'JZ1I',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sindicato',
        abbreviation: '',
        active: true,
        aliases: ['Sindicato'],
    },
    {
        code: 'JZBN',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Непубличные акционерные общества',
        abbreviation: '',
        active: true,
        aliases: ['Непубличные акционерные общества', 'Nepublichnyye aktsionernyye obshchestva'],
    },
    {
        code: 'JZED',
        country: 'TZ',
        jurisdiction: 'TZ',
        jurisdictionName: 'Tanzania',
        name: 'Public Limited Company',
        abbreviation: 'PLC',
        active: true,
        aliases: ['Public Limited Company', 'PLC'],
    },
    {
        code: 'JZWN',
        country: 'US',
        jurisdiction: 'US-SD',
        jurisdictionName: 'South Dakota',
        name: 'Business Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.',
        active: true,
        aliases: ['Business Corporation', 'corp.;inc.;co.;ltd.'],
    },
    {
        code: 'K021',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: "Contratto Di Rete Dotato Di Soggettivita' Giuridica",
        abbreviation: '',
        active: true,
        aliases: ["Contratto Di Rete Dotato Di Soggettivita' Giuridica"],
    },
    {
        code: 'K08P',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les compagnies de cimetière',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur les compagnies de cimetière'],
    },
    {
        code: 'K08V',
        country: 'PY',
        jurisdiction: 'PY',
        jurisdictionName: 'Paraguay',
        name: 'Sociedad De Responsabilidad Limitada',
        abbreviation: 'S.R.L',
        active: true,
        aliases: ['Sociedad De Responsabilidad Limitada', 'S.R.L'],
    },
    {
        code: 'K09E',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Yksityinen elinkeinonharjoittaja',
        abbreviation: '',
        active: true,
        aliases: ['Yksityinen elinkeinonharjoittaja', 'Enskild näringsidkare'],
    },
    {
        code: 'K09K',
        country: 'TH',
        jurisdiction: 'TH',
        jurisdictionName: 'Thailand',
        name: 'บริษัทจำกัด',
        abbreviation: '',
        active: true,
        aliases: ['บริษัทจำกัด', 'Bris̄ʹạthcảkạd'],
    },
    {
        code: 'K0RI',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Institucion de Inversion Colectiva',
        abbreviation: 'IIC',
        active: true,
        aliases: ['Institucion de Inversion Colectiva', 'IIC'],
    },
    {
        code: 'K1QX',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'Alberta society',
        abbreviation: '',
        active: true,
        aliases: ['Alberta society'],
    },
    {
        code: 'K26L',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Ente',
        abbreviation: '',
        active: true,
        aliases: ['Ente'],
    },
    {
        code: 'K2BJ',
        country: 'US',
        jurisdiction: 'US-AK',
        jurisdictionName: 'Alaska',
        name: 'Non-Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Non-Profit Corporation'],
    },
    {
        code: 'K2G8',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Muut oikeushenkilöt',
        abbreviation: '',
        active: false,
        aliases: ['Muut oikeushenkilöt', 'Övriga juridiska personer'],
    },
    {
        code: 'K361',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Special Purpose Vehicle-Coop  / Multistate Coop Society',
        abbreviation: '',
        active: true,
        aliases: ['Special Purpose Vehicle-Coop  / Multistate Coop Society'],
    },
    {
        code: 'K39X',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA union de sociétés coopératives à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA union de sociétés coopératives à conseil d'administration"],
    },
    {
        code: 'K3J6',
        country: 'US',
        jurisdiction: 'US-NV',
        jurisdictionName: 'Nevada',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'K4CD',
        country: 'DO',
        jurisdiction: 'DO',
        jurisdictionName: 'Dominican Republic',
        name: 'Empresa Individual de Responsabilidad Limitada ',
        abbreviation: 'EIRL',
        active: true,
        aliases: ['Empresa Individual de Responsabilidad Limitada ', 'EIRL'],
    },
    {
        code: 'K4GR',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Biudžetinės įstaigos',
        abbreviation: 'BI',
        active: true,
        aliases: ['Biudžetinės įstaigos', 'BI'],
    },
    {
        code: 'K4MF',
        country: 'US',
        jurisdiction: 'US-VT',
        jurisdictionName: 'Vermont',
        name: 'Professional Limited Liability Company',
        abbreviation: 'PLC',
        active: true,
        aliases: ['Professional Limited Liability Company', 'PLC'],
    },
    {
        code: 'K4OX',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Special Purpose Vehicle - Partnership Firm',
        abbreviation: '',
        active: true,
        aliases: ['Special Purpose Vehicle - Partnership Firm'],
    },
    {
        code: 'K4ZA',
        country: 'SR',
        jurisdiction: 'SR',
        jurisdictionName: 'Suriname',
        name: 'Cooperatieve Vereniging',
        abbreviation: '',
        active: true,
        aliases: ['Cooperatieve Vereniging'],
    },
    {
        code: 'K575',
        country: 'KY',
        jurisdiction: 'KY',
        jurisdictionName: 'Cayman Islands',
        name: 'foundation company',
        abbreviation: '',
        active: true,
        aliases: ['foundation company'],
    },
    {
        code: 'K5KA',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Régie d'une collectivité locale à caractère industriel ou commercial",
        abbreviation: '',
        active: true,
        aliases: ["Régie d'une collectivité locale à caractère industriel ou commercial"],
    },
    {
        code: 'K5P8',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Samvirkeforetak',
        abbreviation: 'SA',
        active: true,
        aliases: ['Samvirkeforetak', 'SA'],
    },
    {
        code: 'K65D',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA à conseil d'administration (s.a.i.)",
        abbreviation: '',
        active: true,
        aliases: ["SA à conseil d'administration (s.a.i.)"],
    },
    {
        code: 'K69X',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SA de crédit immobilier à directoire',
        abbreviation: '',
        active: true,
        aliases: ['SA de crédit immobilier à directoire'],
    },
    {
        code: 'K6G7',
        country: 'LS',
        jurisdiction: 'LS',
        jurisdictionName: 'Lesotho',
        name: 'Public Company',
        abbreviation: '',
        active: true,
        aliases: ['Public Company'],
    },
    {
        code: 'K6L9',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Civil Profesional',
        abbreviation: '',
        active: false,
        aliases: ['Sociedad Civil Profesional'],
    },
    {
        code: 'K6VE',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Julkinen osakeyhtiö',
        abbreviation: 'oyj',
        active: true,
        aliases: ['Julkinen osakeyhtiö', 'oyj', 'Publikt aktiebolag', 'abp'],
    },
    {
        code: 'K7XQ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Établissement public national à caractére scientifique culturel et professionnel',
        abbreviation: '',
        active: true,
        aliases: ['Établissement public national à caractére scientifique culturel et professionnel'],
    },
    {
        code: 'K7YU',
        country: 'US',
        jurisdiction: 'US-CA',
        jurisdictionName: 'California',
        name: 'Nonprofit Corporation Public Benefit',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation Public Benefit'],
    },
    {
        code: 'K81Q',
        country: 'AZ',
        jurisdiction: 'AZ',
        jurisdictionName: 'Azerbaijan',
        name: 'Açıq səhmdar cəmiyyəti',
        abbreviation: 'ASC',
        active: true,
        aliases: ['Açıq səhmdar cəmiyyəti', 'ASC'],
    },
    {
        code: 'K98U',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Europäische Wirtschaftliche Interessenvereinigung',
        abbreviation: 'EWIV',
        active: true,
        aliases: ['Europäische Wirtschaftliche Interessenvereinigung', 'EWIV'],
    },
    {
        code: 'K99N',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Comité social économique d’établissement',
        abbreviation: '',
        active: true,
        aliases: ['Comité social économique d’établissement'],
    },
    {
        code: 'K9L6',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Ιδιωτική Εταιρεία Περιορισμένης Ευθύνης με μετοχές',
        abbreviation: '',
        active: true,
        aliases: [
            'Ιδιωτική Εταιρεία Περιορισμένης Ευθύνης με μετοχές',
            'Idiotiki Etaireia Periorismenis Efthynis me metoches',
        ],
    },
    {
        code: 'K9SK',
        country: 'TW',
        jurisdiction: 'TW',
        jurisdictionName: 'Taiwan (Province of China)',
        name: '合夥',
        abbreviation: '',
        active: true,
        aliases: ['合夥', 'hé huǒ'],
    },
    {
        code: 'KAEM',
        country: 'AE',
        jurisdiction: 'AE-AZ',
        jurisdictionName: 'Abu Dhabi',
        name: 'Private Company Unlimited with Shares',
        abbreviation: '',
        active: true,
        aliases: ['Private Company Unlimited with Shares'],
    },
    {
        code: 'KAM9',
        country: 'CA',
        jurisdiction: 'CA-NT',
        jurisdictionName: 'Northwest Territories',
        name: 'co-operative',
        abbreviation: 'Ltd.;Ltée.;Inc.;Corp.;Ltd;Limited',
        active: true,
        aliases: ['co-operative', 'Ltd.;Ltée.;Inc.;Corp.;Ltd;Limited'],
    },
    {
        code: 'KB52',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Komanditná spoločnosť',
        abbreviation: 'Kom. spol.',
        active: true,
        aliases: ['Komanditná spoločnosť', 'Kom. spol.'],
    },
    {
        code: 'KBEQ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Société civile immobilière d' accession progressive à la propriété",
        abbreviation: '',
        active: true,
        aliases: ["Société civile immobilière d' accession progressive à la propriété"],
    },
    {
        code: 'KBKD',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'družba z omejeno odgovornostjo',
        abbreviation: 'd.o.o.',
        active: true,
        aliases: ['družba z omejeno odgovornostjo', 'd.o.o.'],
    },
    {
        code: 'KC51',
        country: 'CO',
        jurisdiction: 'CO',
        jurisdictionName: 'Colombia',
        name: 'Sociedad de Economía Mixta',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad de Economía Mixta'],
    },
    {
        code: 'KC7Z',
        country: 'US',
        jurisdiction: 'US-MO',
        jurisdictionName: 'Missouri',
        name: 'For-Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['For-Profit Corporation'],
    },
    {
        code: 'KCHO',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Azienda Speciale Di Cui Al Dlgs 267/2000',
        abbreviation: '',
        active: true,
        aliases: ['Azienda Speciale Di Cui Al Dlgs 267/2000'],
    },
    {
        code: 'KCN5',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Etablissement public administratif, cercle et foyer dans les armées',
        abbreviation: '',
        active: true,
        aliases: ['Etablissement public administratif, cercle et foyer dans les armées'],
    },
    {
        code: 'KCSG',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Ente Impresa',
        abbreviation: 'consorzio',
        active: true,
        aliases: ['Ente Impresa', 'consorzio'],
    },
    {
        code: 'KD84',
        country: 'KH',
        jurisdiction: 'KH',
        jurisdictionName: 'Cambodia',
        name: 'Sole Proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['Sole Proprietorship', 'សហគ្រាស​ឯកបុគ្គល', 'sahakreasa​ ekbokkol'],
    },
    {
        code: 'KEMH',
        country: 'SG',
        jurisdiction: 'SG',
        jurisdictionName: 'Singapore',
        name: 'Company (Foreign Branch)',
        abbreviation: '',
        active: false,
        aliases: ['Company (Foreign Branch)'],
    },
    {
        code: 'KFPS',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Domestic General Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Domestic General Partnership'],
    },
    {
        code: 'KFR1',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Artisan',
        abbreviation: '',
        active: false,
        aliases: ['Artisan'],
    },
    {
        code: 'KGUS',
        country: 'SC',
        jurisdiction: 'SC',
        jurisdictionName: 'Seychelles',
        name: 'International Business Company - Company Limited by Shares and Guarantee',
        abbreviation: 'IBC',
        active: true,
        aliases: ['International Business Company - Company Limited by Shares and Guarantee', 'IBC'],
    },
    {
        code: 'KGZ8',
        country: 'US',
        jurisdiction: 'US-AR',
        jurisdictionName: 'Arkansas',
        name: 'Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Partnership'],
    },
    {
        code: 'KH4O',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Skupnost lastnikov stanovanj',
        abbreviation: '',
        active: true,
        aliases: ['Skupnost lastnikov stanovanj'],
    },
    {
        code: 'KHAB',
        country: 'MK',
        jurisdiction: 'MK',
        jurisdictionName: 'North Macedonia',
        name: 'Друштво со ограничена одговрност',
        abbreviation: 'DOO',
        active: true,
        aliases: ['Друштво со ограничена одговрност', 'Drustvo so ogranicena odgvornost', 'DOO'],
    },
    {
        code: 'KHBL',
        country: 'QA',
        jurisdiction: 'QA',
        jurisdictionName: 'Qatar',
        name: 'شركة التوصية البسيطة',
        abbreviation: '',
        active: true,
        aliases: ['شركة التوصية البسيطة', 'Sharikat Altawsia Albasita'],
    },
    {
        code: 'KHI5',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Julkinen vakuutusosakeyhtiö',
        abbreviation: '',
        active: true,
        aliases: ['Julkinen vakuutusosakeyhtiö', 'Publikt försäkringsaktiebolag'],
    },
    {
        code: 'KHQ2',
        country: 'TW',
        jurisdiction: 'TW',
        jurisdictionName: 'Taiwan (Province of China)',
        name: '無限公司',
        abbreviation: '',
        active: true,
        aliases: ['無限公司', 'Wúxiàn gōngsī'],
    },
    {
        code: 'KIU5',
        country: 'RS',
        jurisdiction: 'RS',
        jurisdictionName: 'Serbia',
        name: 'Друштво са ограниченом одговорношћу',
        abbreviation: 'д.о.о.;доо',
        active: true,
        aliases: [
            'Друштво са ограниченом одговорношћу',
            'Društvo sa ograničenom odgovornošću',
            'д.о.о.;доо',
            'd.o.o.;doo',
        ],
    },
    {
        code: 'KJ0B',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Insurance Company',
        abbreviation: '',
        active: true,
        aliases: ['Insurance Company'],
    },
    {
        code: 'KJ1S',
        country: 'FO',
        jurisdiction: 'FO',
        jurisdictionName: 'Faroe Islands',
        name: 'Fyritøkugrunnur',
        abbreviation: '',
        active: true,
        aliases: ['Fyritøkugrunnur'],
    },
    {
        code: 'KJ1Y',
        country: 'GU',
        jurisdiction: 'GU',
        jurisdictionName: 'Guam',
        name: 'corporation',
        abbreviation: '',
        active: true,
        aliases: ['corporation'],
    },
    {
        code: 'KJ9Q',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Non-commercial power of attorney',
        abbreviation: 'Power Att.',
        active: true,
        aliases: [
            'Non-commercial power of attorney',
            'Power Att.',
            'Procurations non commerciales',
            'Procuration',
            'Nichtkaufmännische Prokuren',
            'Prokura',
            'Procura non commerciale',
            'Procura',
        ],
    },
    {
        code: 'KJOW',
        country: 'PH',
        jurisdiction: 'PH',
        jurisdictionName: 'Philippines',
        name: 'one person corporation',
        abbreviation: 'OPC',
        active: true,
        aliases: ['one person corporation', 'OPC'],
    },
    {
        code: 'KJZ3',
        country: 'SR',
        jurisdiction: 'SR',
        jurisdictionName: 'Suriname',
        name: 'Filiaal of Bijkantoor',
        abbreviation: '',
        active: false,
        aliases: ['Filiaal of Bijkantoor'],
    },
    {
        code: 'KLA2',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Хозяйственные товарищества',
        abbreviation: '',
        active: true,
        aliases: ['Хозяйственные товарищества', 'Khozyaystvennyye tovarishchestva'],
    },
    {
        code: 'KLBO',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Burgerlijke vennootschap onder vorm van commanditaire vennootschap op aandelen',
        abbreviation: 'BV CVA',
        active: false,
        aliases: [
            'Burgerlijke vennootschap onder vorm van commanditaire vennootschap op aandelen',
            'BV CVA',
            'Société civile sous forme de société en commandite par actions',
            'SC SCA',
            'Zivilrechtliche Gesellschaft in der Rechtsform einer Kommanditgesellschaft auf Aktien',
            'ZRG KGaA',
        ],
    },
    {
        code: 'KM1T',
        country: 'CW',
        jurisdiction: 'CW',
        jurisdictionName: 'Curaçao',
        name: 'Openbare vennootschap',
        abbreviation: '',
        active: true,
        aliases: ['Openbare vennootschap'],
    },
    {
        code: 'KM66',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'instytuty badawcze',
        abbreviation: '',
        active: true,
        aliases: ['instytuty badawcze'],
    },
    {
        code: 'KM6O',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Maatschap',
        abbreviation: 'MS',
        active: true,
        aliases: [
            'Maatschap',
            'MS',
            'Société de droit commun',
            'SDC',
            'Gesellschaft des allgemeinen Rechts',
            'GaR',
        ],
    },
    {
        code: 'KM6Z',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Státní banka československá',
        abbreviation: '',
        active: true,
        aliases: ['Státní banka československá'],
    },
    {
        code: 'KMFX',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'Private Unlimited Company',
        abbreviation: 'ULC / uc',
        active: true,
        aliases: ['Private Unlimited Company', 'ULC / uc', 'Cuideachta Neamhtheoranta', 'cn'],
    },
    {
        code: 'KMPN',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Établissement public national à caractére administratif',
        abbreviation: '',
        active: true,
        aliases: ['Établissement public national à caractére administratif'],
    },
    {
        code: 'KNIC',
        country: 'CK',
        jurisdiction: 'CK',
        jurisdictionName: 'Cook Islands',
        name: 'International Partnership',
        abbreviation: '',
        active: true,
        aliases: ['International Partnership'],
    },
    {
        code: 'KO5T',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'KOFC',
        country: 'SC',
        jurisdiction: 'SC',
        jurisdictionName: 'Seychelles',
        name: 'International Business Company - Company Limited by Guarantee',
        abbreviation: 'IBC',
        active: true,
        aliases: ['International Business Company - Company Limited by Guarantee', 'IBC'],
    },
    {
        code: 'KORB',
        country: 'VG',
        jurisdiction: 'VG',
        jurisdictionName: 'Virgin Islands (British)',
        name: 'Limited Partnership',
        abbreviation: 'L.P.',
        active: true,
        aliases: ['Limited Partnership', 'L.P.'],
    },
    {
        code: 'KOYR',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Главы крестьянских (фермерских) хозяйств',
        abbreviation: '',
        active: true,
        aliases: [
            'Главы крестьянских (фермерских) хозяйств',
            "Glavy krest'yanskikh (fermerskikh) khozyaystv",
        ],
    },
    {
        code: 'KP34',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Javno trgovačko društvo',
        abbreviation: 'j.t.d.',
        active: true,
        aliases: ['Javno trgovačko društvo', 'j.t.d.'],
    },
    {
        code: 'KPG6',
        country: 'MC',
        jurisdiction: 'MC',
        jurisdictionName: 'Monaco',
        name: 'Association',
        abbreviation: '',
        active: true,
        aliases: ['Association'],
    },
    {
        code: 'KPH8',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Investment Company',
        abbreviation: '',
        active: true,
        aliases: ['Investment Company'],
    },
    {
        code: 'KPHM',
        country: 'GT',
        jurisdiction: 'GT',
        jurisdictionName: 'Guatemala',
        name: 'Organizacion No Gubernamental',
        abbreviation: 'ONG',
        active: true,
        aliases: ['Organizacion No Gubernamental', 'ONG'],
    },
    {
        code: 'KQH7',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Société civile d'attribution",
        abbreviation: '',
        active: true,
        aliases: ["Société civile d'attribution"],
    },
    {
        code: 'KQWF',
        country: 'VN',
        jurisdiction: 'VN',
        jurisdictionName: 'Viet Nam',
        name: 'Nhóm Cty',
        abbreviation: '',
        active: true,
        aliases: ['Nhóm Cty'],
    },
    {
        code: 'KQXA',
        country: 'US',
        jurisdiction: 'US-CA',
        jurisdictionName: 'California',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'KS9B',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Syndicat patronal',
        abbreviation: '',
        active: true,
        aliases: ['Syndicat patronal'],
    },
    {
        code: 'KSHL',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Commanditaire vennootschap op aandelen',
        abbreviation: '',
        active: true,
        aliases: ['Commanditaire vennootschap op aandelen'],
    },
    {
        code: 'KSUS',
        country: 'HK',
        jurisdiction: 'HK',
        jurisdictionName: 'Hong Kong',
        name: '非香港公司',
        abbreviation: '',
        active: false,
        aliases: ['非香港公司', 'fei xiang gang gong si', 'Non-Hong Kong company'],
    },
    {
        code: 'KU3O',
        country: 'US',
        jurisdiction: 'US-MA',
        jurisdictionName: 'Massachusetts',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: 'KUHK',
        country: 'BJ',
        jurisdiction: 'BJ',
        jurisdictionName: 'Benin',
        name: 'Société à Responsabilité Limitée',
        abbreviation: 'SARL',
        active: true,
        aliases: ['Société à Responsabilité Limitée', 'SARL'],
    },
    {
        code: 'KUQO',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Ναυτιλιακή Εταιρεία Πλοίων Αναψυχής',
        abbreviation: 'Ν.Ε.Π.Α',
        active: true,
        aliases: [
            'Ναυτιλιακή Εταιρεία Πλοίων Αναψυχής',
            'Naftiliakí Etaireía Ploíon Anapsychís',
            'Ν.Ε.Π.Α',
            'N.E.P.A.',
        ],
    },
    {
        code: 'KUUV',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Organismo da Administração Pública',
        abbreviation: '',
        active: true,
        aliases: ['Organismo da Administração Pública'],
    },
    {
        code: 'KUUZ',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Sociedad por Acciones',
        abbreviation: 'SpA',
        active: true,
        aliases: ['Sociedad por Acciones', 'SpA'],
    },
    {
        code: 'KVC1',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'general partnership',
        abbreviation: '',
        active: true,
        aliases: ['general partnership'],
    },
    {
        code: 'KVQU',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Združenie medzinárodného obchodu',
        abbreviation: 'Združ.medzinár.obchodu',
        active: true,
        aliases: ['Združenie medzinárodného obchodu', 'Združ.medzinár.obchodu'],
    },
    {
        code: 'KVSH',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Органы общественной самодеятельности',
        abbreviation: '',
        active: true,
        aliases: ['Органы общественной самодеятельности', "Organy obshchestvennoy samodeyatel'nosti"],
    },
    {
        code: 'KWBA',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Viešosios įstaigos',
        abbreviation: 'VS',
        active: true,
        aliases: ['Viešosios įstaigos', 'VS'],
    },
    {
        code: 'KWFE',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Komora (s výnimkou profesných komôr)',
        abbreviation: '',
        active: true,
        aliases: ['Komora (s výnimkou profesných komôr)'],
    },
    {
        code: 'KWI4',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SCP de masseurs-kinésithérapeutes',
        abbreviation: '',
        active: true,
        aliases: ['SCP de masseurs-kinésithérapeutes'],
    },
    {
        code: 'KX7D',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Fylkeskommune',
        abbreviation: '',
        active: true,
        aliases: ['Fylkeskommune'],
    },
    {
        code: 'KXDY',
        country: 'MK',
        jurisdiction: 'MK',
        jurisdictionName: 'North Macedonia',
        name: 'Подрушница на странско трговско друштво, односно на странски трговрец поединец',
        abbreviation: '',
        active: true,
        aliases: [
            'Подрушница на странско трговско друштво, односно на странски трговрец поединец',
            'Podruznica na stransko trgovsko drustvo, odnosno na stranski trgovec poedinec',
        ],
    },
    {
        code: 'KXZT',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Azienda Speciale',
        abbreviation: '',
        active: true,
        aliases: ['Azienda Speciale'],
    },
    {
        code: 'KYFD',
        country: 'BB',
        jurisdiction: 'BB',
        jurisdictionName: 'Barbados',
        name: 'non-profit company',
        abbreviation: '',
        active: true,
        aliases: ['non-profit company'],
    },
    {
        code: 'KYOI',
        country: 'KN',
        jurisdiction: 'KN',
        jurisdictionName: 'Saint Kitts and Nevis',
        name: 'exempt limited partnership',
        abbreviation: '',
        active: true,
        aliases: ['exempt limited partnership'],
    },
    {
        code: 'KYVO',
        country: 'CO',
        jurisdiction: 'CO',
        jurisdictionName: 'Colombia',
        name: 'Sociedad por Acciones Simplificada',
        abbreviation: 'S.A.S',
        active: true,
        aliases: ['Sociedad por Acciones Simplificada', 'S.A.S'],
    },
    {
        code: 'KZ3R',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Poisťovňa - štátny podnik',
        abbreviation: 'Poisťovňa - š. p.',
        active: true,
        aliases: ['Poisťovňa - štátny podnik', 'Poisťovňa - š. p.'],
    },
    {
        code: 'KZC6',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Фонды',
        abbreviation: '',
        active: true,
        aliases: ['Фонды', 'Fondy'],
    },
    {
        code: 'KZDW',
        country: 'CA',
        jurisdiction: 'CA-SK',
        jurisdictionName: 'Saskatchewan',
        name: 'Syndicates',
        abbreviation: '',
        active: true,
        aliases: ['Syndicates'],
    },
    {
        code: 'KZMF',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Sociedad de usuarios de aguas',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad de usuarios de aguas'],
    },
    {
        code: 'L05H',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Besloten Vennootschap van publiek recht',
        abbreviation: 'BV PR',
        active: true,
        aliases: [
            'Besloten Vennootschap van publiek recht',
            'BV PR',
            'Société à responsabilité limitée de droit public',
            'SRL DPU',
            'Öffentlich-rechtliche Gesellschaft mit beschränkter Haftung',
            'ÖrGmbH',
        ],
    },
    {
        code: 'L10T',
        country: 'US',
        jurisdiction: 'US-CO',
        jurisdictionName: 'Colorado',
        name: 'Limited Liability Company',
        abbreviation: 'limited liability company;ltd. liability company;limited liability co.;ltd. liability co.;limited;l.l.c.;llc;ltd.',
        active: true,
        aliases: [
            'Limited Liability Company',
            'limited liability company;ltd. liability company;limited liability co.;ltd. liability co.;limited;l.l.c.;llc;ltd.',
        ],
    },
    {
        code: 'L1M7',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Fakulta vysokej školy',
        abbreviation: '',
        active: true,
        aliases: ['Fakulta vysokej školy'],
    },
    {
        code: 'L1PM',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Professional Limited Liability Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Professional Limited Liability Limited Partnership'],
    },
    {
        code: 'L1ZJ',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Azienda Municipale',
        abbreviation: '',
        active: true,
        aliases: ['Azienda Municipale'],
    },
    {
        code: 'L22N',
        country: 'US',
        jurisdiction: 'US-IA',
        jurisdictionName: 'Iowa',
        name: 'Professional Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Professional Corporation'],
    },
    {
        code: 'L25Z',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Société anonyme mixte d'intérêt agricole (SMIA) à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["Société anonyme mixte d'intérêt agricole (SMIA) à conseil d'administration"],
    },
    {
        code: 'L26C',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Société par actions par Fonds mutuel constitué par acte de fiducie',
        abbreviation: '',
        active: true,
        aliases: ['Société par actions par Fonds mutuel constitué par acte de fiducie'],
    },
    {
        code: 'L2DM',
        country: 'US',
        jurisdiction: 'US-AR',
        jurisdictionName: 'Arkansas',
        name: 'Limited Liability Limited Partnership',
        abbreviation: 'LLLP;L.L.L.P.',
        active: true,
        aliases: ['Limited Liability Limited Partnership', 'LLLP;L.L.L.P.'],
    },
    {
        code: 'L2MQ',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad de responsabilidad limitada de interés público de capital variable',
        abbreviation: 'S. de R. L. de I. P. de C. V.',
        active: true,
        aliases: [
            'Sociedad de responsabilidad limitada de interés público de capital variable',
            'S. de R. L. de I. P. de C. V.',
        ],
    },
    {
        code: 'L2NN',
        country: 'CA',
        jurisdiction: 'CA-SK',
        jurisdictionName: 'Saskatchewan',
        name: 'Joint Ventures',
        abbreviation: '',
        active: true,
        aliases: ['Joint Ventures'],
    },
    {
        code: 'L2QV',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Corporation',
        abbreviation: 'Corp.;Ltd.;Inc.',
        active: true,
        aliases: ['Corporation', 'Corp.;Ltd.;Inc.'],
    },
    {
        code: 'L2SY',
        country: 'US',
        jurisdiction: 'US-NJ',
        jurisdictionName: 'New Jersey',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'L3XH',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: "Personne morale sans but lucratif par Loi sur les sociétés d'horticulture",
        abbreviation: '',
        active: true,
        aliases: ["Personne morale sans but lucratif par Loi sur les sociétés d'horticulture"],
    },
    {
        code: 'L4HR',
        country: 'NP',
        jurisdiction: 'NP',
        jurisdictionName: 'Nepal',
        name: 'Cooperative Organization',
        abbreviation: '',
        active: true,
        aliases: ['Cooperative Organization', 'सहकारी संस्था ', 'sahakaari sanstha '],
    },
    {
        code: 'L4QF',
        country: 'AR',
        jurisdiction: 'AR',
        jurisdictionName: 'Argentina',
        name: 'Organismo Publico',
        abbreviation: '',
        active: true,
        aliases: ['Organismo Publico'],
    },
    {
        code: 'L5BO',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Trade Name',
        abbreviation: '',
        active: false,
        aliases: ['Trade Name'],
    },
    {
        code: 'L5DU',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Local public company',
        abbreviation: 'Loc. publ. co.',
        active: true,
        aliases: [
            'Local public company',
            'Loc. publ. co.',
            'Entreprise publique communale',
            'Ent. pub. communale',
            'Unternehmen der Gemeinde',
            'öff. Unt. Gemeinde',
            'Impresa pubblica comunale',
            'Imp. pubb. comunale',
        ],
    },
    {
        code: 'L6IY',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Νομικά Πρόσωπα Δημοσίου Δικαίου',
        abbreviation: 'PL',
        active: true,
        aliases: ['Νομικά Πρόσωπα Δημοσίου Δικαίου', 'Nomika Prosopa Dimosiou Dikeou', 'PL'],
    },
    {
        code: 'L6QO',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Régime spécial de Sécurité Sociale',
        abbreviation: '',
        active: true,
        aliases: ['Régime spécial de Sécurité Sociale'],
    },
    {
        code: 'L7HH',
        country: 'US',
        jurisdiction: 'US-CT',
        jurisdictionName: 'Connecticut',
        name: 'Religious Society or Religious Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Religious Society or Religious Corporation'],
    },
    {
        code: 'L7HX',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'kerkgenootschap',
        abbreviation: '',
        active: true,
        aliases: ['kerkgenootschap'],
    },
    {
        code: 'L7XJ',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Paliskunta',
        abbreviation: '',
        active: true,
        aliases: ['Paliskunta', 'Renbeteslag'],
    },
    {
        code: 'L8D6',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Αφανής Εταιρία',
        abbreviation: 'SLP',
        active: true,
        aliases: ['Αφανής Εταιρία', 'Afanis Eteria', 'SLP'],
    },
    {
        code: 'L9JC',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima bursátil de capital variable',
        abbreviation: 'S.A.B. de C.V.',
        active: true,
        aliases: ['Sociedad anónima bursátil de capital variable', 'S.A.B. de C.V.'],
    },
    {
        code: 'L9WT',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Obec (obecný úrad), mesto (mestský úrad)',
        abbreviation: 'Obec, mesto (o.,m.úrad)',
        active: true,
        aliases: ['Obec (obecný úrad), mesto (mestský úrad)', 'Obec, mesto (o.,m.úrad)'],
    },
    {
        code: 'LA47',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Euroopa majandushuviühing',
        abbreviation: 'EMHÜ',
        active: true,
        aliases: ['Euroopa majandushuviühing', 'EMHÜ'],
    },
    {
        code: 'LA66',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Islamic Other Trust',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Islamic Other Trust'],
    },
    {
        code: 'LARO',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société par actions simplifiée à associé unique ou société par actions simplifiée unipersonnelle',
        abbreviation: '',
        active: false,
        aliases: [
            'Société par actions simplifiée à associé unique ou société par actions simplifiée unipersonnelle',
        ],
    },
    {
        code: 'LBJ1',
        country: 'US',
        jurisdiction: 'US-WA',
        jurisdictionName: 'Washington',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP'],
    },
    {
        code: 'LBPW',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima  de capital variable, financiera popular',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima  de capital variable, financiera popular'],
    },
    {
        code: 'LBQS',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Muu yhteisvastuullinen pidätysvelvollinen',
        abbreviation: '',
        active: true,
        aliases: [
            'Muu yhteisvastuullinen pidätysvelvollinen',
            'Annan solidariskt ansvarig innehållningspliktig',
        ],
    },
    {
        code: 'LC2L',
        country: 'BM',
        jurisdiction: 'BM',
        jurisdictionName: 'Bermuda',
        name: 'Exempted Company Limited by Guarantee',
        abbreviation: '',
        active: true,
        aliases: ['Exempted Company Limited by Guarantee'],
    },
    {
        code: 'LCR0',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: "Groupement d'intérêt économique",
        abbreviation: 'GIE',
        active: true,
        aliases: ["Groupement d'intérêt économique", 'GIE'],
    },
    {
        code: 'LCVA',
        country: 'VC',
        jurisdiction: 'VC',
        jurisdictionName: 'Saint Vincent and the Grenadines',
        name: 'international business company - company limited by guarantee not authorised to issue shares',
        abbreviation: 'Ltd;Corp;Inc',
        active: true,
        aliases: [
            'international business company - company limited by guarantee not authorised to issue shares',
            'Ltd;Corp;Inc',
        ],
    },
    {
        code: 'LDBS',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Cooperative (Producer)',
        abbreviation: '',
        active: true,
        aliases: ['Cooperative (Producer)'],
    },
    {
        code: 'LDHG',
        country: 'US',
        jurisdiction: 'US-CO',
        jurisdictionName: 'Colorado',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'LECS',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Сдружение в частна полза',
        abbreviation: '',
        active: true,
        aliases: ['Сдружение в частна полза', 'Sdruzhenie v chastna polza'],
    },
    {
        code: 'LEDI',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Honební společenstvo',
        abbreviation: '',
        active: true,
        aliases: ['Honební společenstvo'],
    },
    {
        code: 'LF4E',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Farm/Ranch Corporation',
        abbreviation: 'corp;inc.',
        active: true,
        aliases: ['Farm/Ranch Corporation', 'corp;inc.'],
    },
    {
        code: 'LFSO',
        country: 'NZ',
        jurisdiction: 'NZ',
        jurisdictionName: 'New Zealand',
        name: 'Industrial and provident society',
        abbreviation: '',
        active: true,
        aliases: ['Industrial and provident society'],
    },
    {
        code: 'LGME',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA à participation ouvrière à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA à participation ouvrière à conseil d'administration"],
    },
    {
        code: 'LGQZ',
        country: 'US',
        jurisdiction: 'US-ID',
        jurisdictionName: 'Idaho',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'LGVF',
        country: 'US',
        jurisdiction: 'US-OR',
        jurisdictionName: 'Oregon',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'LGWG',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'Designated Activity Company',
        abbreviation: 'DAC – (limited by shares)',
        active: true,
        aliases: [
            'Designated Activity Company',
            'DAC – (limited by shares)',
            'Cuideachta Ghníomhaíochta Ainmnithe',
            'cga',
        ],
    },
    {
        code: 'LH0Q',
        country: 'PK',
        jurisdiction: 'PK',
        jurisdictionName: 'Pakistan',
        name: 'Unlimited Company',
        abbreviation: 'Unltd;Ultd;Unlimited',
        active: true,
        aliases: ['Unlimited Company', 'Unltd;Ultd;Unlimited'],
    },
    {
        code: 'LHBB',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Impresa Individuale',
        abbreviation: '',
        active: true,
        aliases: ['Impresa Individuale'],
    },
    {
        code: 'LIEA',
        country: 'US',
        jurisdiction: 'US-CT',
        jurisdictionName: 'Connecticut',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'LJ92',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Československé státní dráhy-státní organizace',
        abbreviation: '',
        active: true,
        aliases: ['Československé státní dráhy-státní organizace'],
    },
    {
        code: 'LJH5',
        country: 'US',
        jurisdiction: 'US-MI',
        jurisdictionName: 'Michigan',
        name: 'Limited Liability Company',
        abbreviation: 'L.L.C.;LLC;L.C.;LC;Limited Liability Company',
        active: true,
        aliases: ['Limited Liability Company', 'L.L.C.;LLC;L.C.;LC;Limited Liability Company'],
    },
    {
        code: 'LJJW',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Verdipapirfond',
        abbreviation: '',
        active: true,
        aliases: ['Verdipapirfond'],
    },
    {
        code: 'LJL0',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Organizační složka státu',
        abbreviation: '',
        active: true,
        aliases: ['Organizační složka státu'],
    },
    {
        code: 'LJTR',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad por acciones simplificada',
        abbreviation: 'S. A. S.',
        active: true,
        aliases: ['Sociedad por acciones simplificada', 'S. A. S.'],
    },
    {
        code: 'LJYQ',
        country: 'BO',
        jurisdiction: 'BO',
        jurisdictionName: 'Bolivia (Plurinational State of)',
        name: 'Sociedad Anónima Mixta',
        abbreviation: 'S.A.M.',
        active: true,
        aliases: ['Sociedad Anónima Mixta', 'S.A.M.'],
    },
    {
        code: 'LKD5',
        country: 'US',
        jurisdiction: 'US-MD',
        jurisdictionName: 'Maryland',
        name: 'Close Corporation',
        abbreviation: 'Inc.;Corp.;Ltd.',
        active: true,
        aliases: ['Close Corporation', 'Inc.;Corp.;Ltd.'],
    },
    {
        code: 'LKQ2',
        country: 'US',
        jurisdiction: 'US-CT',
        jurisdictionName: 'Connecticut',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'LLL8',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Отделения иностранных некоммерческих неправительственных организаций',
        abbreviation: '',
        active: true,
        aliases: [
            'Отделения иностранных некоммерческих неправительственных организаций',
            "Otdeleniya inostrannykh nekommercheskikh nepravitel'stvennykh organizatsiy",
        ],
    },
    {
        code: 'LMIM',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'Limited company',
        abbreviation: 'Ltd;Ltd.;Limited',
        active: false,
        aliases: ['Limited company', 'Ltd;Ltd.;Limited', 'Teoranta', 'teo'],
    },
    {
        code: 'LMSY',
        country: 'CA',
        jurisdiction: 'CA-SK',
        jurisdictionName: 'Saskatchewan',
        name: 'Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Partnership'],
    },
    {
        code: 'LN3N',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les villages miniers',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur les villages miniers'],
    },
    {
        code: 'LN9O',
        country: 'BO',
        jurisdiction: 'BO',
        jurisdictionName: 'Bolivia (Plurinational State of)',
        name: 'Entidad Financiera De Vivienda',
        abbreviation: '',
        active: true,
        aliases: ['Entidad Financiera De Vivienda'],
    },
    {
        code: 'LNBY',
        country: 'CA',
        jurisdiction: 'CA-BC',
        jurisdictionName: 'British Columbia',
        name: 'Limited liability partnership',
        abbreviation: 'LLP;SRL;SENCRL',
        active: true,
        aliases: ['Limited liability partnership', 'LLP;SRL;SENCRL'],
    },
    {
        code: 'LNG8',
        country: 'PY',
        jurisdiction: 'PY',
        jurisdictionName: 'Paraguay',
        name: 'Sociedad En Comandita Por Acciones',
        abbreviation: 'S.C.A',
        active: true,
        aliases: ['Sociedad En Comandita Por Acciones', 'S.C.A'],
    },
    {
        code: 'LNLA',
        country: 'OM',
        jurisdiction: 'OM',
        jurisdictionName: 'Oman',
        name: 'شركة التضامن',
        abbreviation: '',
        active: true,
        aliases: ['شركة التضامن', 'sharikat altadamun'],
    },
    {
        code: 'LNY0',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Egyházi szervezetek',
        abbreviation: '',
        active: true,
        aliases: ['Egyházi szervezetek'],
    },
    {
        code: 'LNYR',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Obrtna zadruga',
        abbreviation: '',
        active: true,
        aliases: ['Obrtna zadruga'],
    },
    {
        code: 'LO9A',
        country: 'JE',
        jurisdiction: 'JE',
        jurisdictionName: 'Jersey',
        name: 'Private Limited by Guarantee',
        abbreviation: 'Ltd;Ltd.;Limited',
        active: true,
        aliases: ['Private Limited by Guarantee', 'Ltd;Ltd.;Limited'],
    },
    {
        code: 'LOB9',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad propietaria de tierras agrícolas, ganaderas o forestales',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad propietaria de tierras agrícolas, ganaderas o forestales'],
    },
    {
        code: 'LOJL',
        country: 'NG',
        jurisdiction: 'NG',
        jurisdictionName: 'Nigeria',
        name: 'Limited partnership',
        abbreviation: 'LP',
        active: true,
        aliases: ['Limited partnership', 'LP'],
    },
    {
        code: 'LOL8',
        country: 'AE',
        jurisdiction: 'AE',
        jurisdictionName: 'United Arab Emirates',
        name: 'Simple Commandite Company',
        abbreviation: '',
        active: true,
        aliases: ['Simple Commandite Company'],
    },
    {
        code: 'LPCQ',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Mezinárodní odborová organizace',
        abbreviation: '',
        active: true,
        aliases: ['Mezinárodní odborová organizace'],
    },
    {
        code: 'LPEE',
        country: 'US',
        jurisdiction: 'US-VT',
        jurisdictionName: 'Vermont',
        name: 'Cooperative',
        abbreviation: 'Corp.',
        active: true,
        aliases: ['Cooperative', 'Corp.'],
    },
    {
        code: 'LPLY',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'LQVG',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Sucesión Indivisa',
        abbreviation: '',
        active: true,
        aliases: ['Sucesión Indivisa'],
    },
    {
        code: 'LQZC',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Nebraska Benefit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nebraska Benefit Corporation'],
    },
    {
        code: 'LRRN',
        country: 'CA',
        jurisdiction: 'CA-BC',
        jurisdictionName: 'British Columbia',
        name: 'Mutual fire insurance company',
        abbreviation: '',
        active: true,
        aliases: ['Mutual fire insurance company'],
    },
    {
        code: 'LSWY',
        country: 'DO',
        jurisdiction: 'DO',
        jurisdictionName: 'Dominican Republic',
        name: 'Sociedad en Nombre Colectivo',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad en Nombre Colectivo'],
    },
    {
        code: 'LT1Y',
        country: 'CA',
        jurisdiction: 'CA-PE',
        jurisdictionName: 'Prince Edward Island',
        name: 'professional corporation',
        abbreviation: 'Ltd.;Inc.;Corp.;Ltée',
        active: true,
        aliases: ['professional corporation', 'Ltd.;Inc.;Corp.;Ltée'],
    },
    {
        code: 'LT9U',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'związek zawodowy',
        abbreviation: '',
        active: true,
        aliases: ['związek zawodowy'],
    },
    {
        code: 'LTKC',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Home Service Contract Provider',
        abbreviation: 'inc.;incorporated;co.;company;corp.;corporation;ltd.;limited;limited liability company;L.L.C.;L.C.',
        active: true,
        aliases: [
            'Home Service Contract Provider',
            'inc.;incorporated;co.;company;corp.;corporation;ltd.;limited;limited liability company;L.L.C.;L.C.',
        ],
    },
    {
        code: 'LU8S',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Associé gérant de Société',
        abbreviation: '',
        active: false,
        aliases: ['Associé gérant de Société'],
    },
    {
        code: 'LU9O',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'Unincorporated Non-Profit Assocation',
        abbreviation: 'Limited;Ltd.',
        active: true,
        aliases: ['Unincorporated Non-Profit Assocation', 'Limited;Ltd.'],
    },
    {
        code: 'LUGM',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Kooperatinės bendrovės (kooperatyvai)',
        abbreviation: 'KO',
        active: true,
        aliases: ['Kooperatinės bendrovės (kooperatyvai)', 'KO'],
    },
    {
        code: 'LUIN',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SARL immobilière pour le commerce et l'industrie (SICOMI)",
        abbreviation: '',
        active: true,
        aliases: ["SARL immobilière pour le commerce et l'industrie (SICOMI)"],
    },
    {
        code: 'LUMA',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Dioničko društvo',
        abbreviation: 'd.d.',
        active: true,
        aliases: ['Dioničko društvo', 'd.d.'],
    },
    {
        code: 'LUOA',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Komanditinės ūkinės bendrijos',
        abbreviation: 'KB',
        active: true,
        aliases: ['Komanditinės ūkinės bendrijos', 'KB'],
    },
    {
        code: 'LURL',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '其他（适用于无登记机构的的情况）',
        abbreviation: '',
        active: true,
        aliases: [
            '其他（适用于无登记机构的的情况）',
            'qi ta（ shi yong yu wu deng ji ji gou de de qing kuang ）',
        ],
    },
    {
        code: 'LV28',
        country: 'CA',
        jurisdiction: 'CA-MB',
        jurisdictionName: 'Manitoba',
        name: 'Condominium Corporation',
        abbreviation: 'Condominium Corporation',
        active: true,
        aliases: ['Condominium Corporation'],
    },
    {
        code: 'LVC6',
        country: 'TZ',
        jurisdiction: 'TZ',
        jurisdictionName: 'Tanzania',
        name: 'Company limited by guarantee',
        abbreviation: '',
        active: true,
        aliases: ['Company limited by guarantee'],
    },
    {
        code: 'LVEQ',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Usaldusühing',
        abbreviation: 'UÜ',
        active: true,
        aliases: ['Usaldusühing', 'UÜ'],
    },
    {
        code: 'LVJZ',
        country: 'AR',
        jurisdiction: 'AR',
        jurisdictionName: 'Argentina',
        name: 'Fundacion',
        abbreviation: '',
        active: true,
        aliases: ['Fundacion'],
    },
    {
        code: 'LVRX',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima, almacén general de depósito, organización auxiliar del crédito',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima, almacén general de depósito, organización auxiliar del crédito'],
    },
    {
        code: 'LWHF',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Coöperatieve vennootschap met onbeperkte aansprakelijkheid',
        abbreviation: 'CVOA',
        active: true,
        aliases: [
            'Coöperatieve vennootschap met onbeperkte aansprakelijkheid',
            'CVOA',
            'Société coopérative à responsabilité illimitée',
            'SCRI',
            'Genossenschaft mit unbeschränkter Haftung',
            'Gen.mubH',
        ],
    },
    {
        code: 'LWOD',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Medarbejderinvesteringsselskab',
        abbreviation: '',
        active: true,
        aliases: ['Medarbejderinvesteringsselskab'],
    },
    {
        code: 'LWV6',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Gewone commanditaire vennootschap',
        abbreviation: 'Comm.V',
        active: true,
        aliases: [
            'Gewone commanditaire vennootschap',
            'Comm.V',
            'Société en commandite simple',
            'SCS',
            'Einfache Kommanditgesellschaft',
            'EKG',
        ],
    },
    {
        code: 'LWXI',
        country: 'SG',
        jurisdiction: 'SG',
        jurisdictionName: 'Singapore',
        name: 'Company (Local)',
        abbreviation: 'Pte Ltd;Ltd;Limited',
        active: false,
        aliases: ['Company (Local)', 'Pte Ltd;Ltd;Limited'],
    },
    {
        code: 'LXI4',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'LYA0',
        country: 'TR',
        jurisdiction: 'TR',
        jurisdictionName: 'Türkiye',
        name: 'dernek',
        abbreviation: '',
        active: true,
        aliases: ['dernek'],
    },
    {
        code: 'LYRX',
        country: 'US',
        jurisdiction: 'US-CA',
        jurisdictionName: 'California',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'LYTH',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Благотворительные фонды',
        abbreviation: '',
        active: true,
        aliases: ['Благотворительные фонды', "Blagotvoritel'nyye fondy"],
    },
    {
        code: 'LZ3H',
        country: 'AE',
        jurisdiction: 'AE-AZ',
        jurisdictionName: 'Abu Dhabi',
        name: 'Close Ended Investment Company',
        abbreviation: '',
        active: false,
        aliases: ['Close Ended Investment Company'],
    },
    {
        code: 'LZFR',
        country: 'AU',
        jurisdiction: 'AU',
        jurisdictionName: 'Australia',
        name: 'Public Company limited by guarantee',
        abbreviation: 'Ltd;Ltd.;Limited',
        active: true,
        aliases: ['Public Company limited by guarantee', 'Ltd;Ltd.;Limited'],
    },
    {
        code: 'LZI3',
        country: 'TV',
        jurisdiction: 'TV',
        jurisdictionName: 'Tuvalu',
        name: 'partnership',
        abbreviation: '',
        active: true,
        aliases: ['partnership'],
    },
    {
        code: 'LZIC',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'Investment Limited Partnership',
        abbreviation: 'ilp',
        active: true,
        aliases: [
            'Investment Limited Partnership',
            'ilp',
            'comhpháirtíocht theoranta infheistíochta',
            'cti',
        ],
    },
    {
        code: 'LZZD',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società Consortile Per Azioni',
        abbreviation: '',
        active: true,
        aliases: ['Società Consortile Per Azioni'],
    },
    {
        code: 'M0ER',
        country: 'US',
        jurisdiction: 'US-NY',
        jurisdictionName: 'New York',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'M0SL',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Municipio',
        abbreviation: 'Mpo.',
        active: true,
        aliases: ['Municipio', 'Mpo.'],
    },
    {
        code: 'M0X8',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Condominio',
        abbreviation: '',
        active: true,
        aliases: ['Condominio'],
    },
    {
        code: 'M0Y0',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Försäkringsförening',
        abbreviation: 'FOF',
        active: true,
        aliases: ['Försäkringsförening', 'FOF'],
    },
    {
        code: 'M1BJ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société civile de moyens',
        abbreviation: '',
        active: true,
        aliases: ['Société civile de moyens'],
    },
    {
        code: 'M1DW',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Önkéntes kölcsönös biztosítópénztár',
        abbreviation: '',
        active: true,
        aliases: ['Önkéntes kölcsönös biztosítópénztár'],
    },
    {
        code: 'M1FY',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: 'M1IZ',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'Overige Privaatrechtelijke Rechtspersoon',
        abbreviation: '',
        active: true,
        aliases: ['Overige Privaatrechtelijke Rechtspersoon'],
    },
    {
        code: 'M27U',
        country: 'AW',
        jurisdiction: 'AW',
        jurisdictionName: 'Aruba',
        name: 'Besloten vennootschap',
        abbreviation: 'BV;bv;B.V.;b.v.',
        active: true,
        aliases: ['Besloten vennootschap', 'BV;bv;B.V.;b.v.'],
    },
    {
        code: 'M2KR',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Limited Liablity Partnership',
        abbreviation: 'L.L.P.;LLP;R.L.L.P.;RLLP',
        active: true,
        aliases: ['Limited Liablity Partnership', 'L.L.P.;LLP;R.L.L.P.;RLLP'],
    },
    {
        code: 'M44Q',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, centro cambiario',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima de capital variable, centro cambiario'],
    },
    {
        code: 'M44Y',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Limited by Shares and by Guarantee (2006 Act)',
        abbreviation: '',
        active: true,
        aliases: ['Limited by Shares and by Guarantee (2006 Act)'],
    },
    {
        code: 'M4FO',
        country: 'US',
        jurisdiction: 'US-AR',
        jurisdictionName: 'Arkansas',
        name: 'Limited Liability Company',
        abbreviation: 'Corporation;Incorporated;Company;Limited;Corp.;Inc.;Co.;Ltd.',
        active: true,
        aliases: [
            'Limited Liability Company',
            'Corporation;Incorporated;Company;Limited;Corp.;Inc.;Co.;Ltd.',
        ],
    },
    {
        code: 'M4IF',
        country: 'CA',
        jurisdiction: 'CA',
        jurisdictionName: 'Canada',
        name: 'pension fund society',
        abbreviation: '',
        active: true,
        aliases: ['pension fund society', 'société de caisse de retraite'],
    },
    {
        code: 'M4LU',
        country: 'AZ',
        jurisdiction: 'AZ',
        jurisdictionName: 'Azerbaijan',
        name: 'Qapalı səhmdar cəmiyyəti',
        abbreviation: 'QSC',
        active: true,
        aliases: ['Qapalı səhmdar cəmiyyəti', 'QSC'],
    },
    {
        code: 'M4TI',
        country: 'GI',
        jurisdiction: 'GI',
        jurisdictionName: 'Gibraltar',
        name: 'Societe Europeas',
        abbreviation: 'SE',
        active: true,
        aliases: ['Societe Europeas', 'SE'],
    },
    {
        code: 'M53U',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'depends on Act of the Legislature',
        abbreviation: '',
        active: false,
        aliases: ['depends on Act of the Legislature'],
    },
    {
        code: 'M5RM',
        country: 'US',
        jurisdiction: 'US-WI',
        jurisdictionName: 'Wisconsin',
        name: 'Limited Liability Company',
        abbreviation: 'LLC;L.L.C.',
        active: true,
        aliases: ['Limited Liability Company', 'LLC;L.L.C.'],
    },
    {
        code: 'M64D',
        country: 'US',
        jurisdiction: 'US-CO',
        jurisdictionName: 'Colorado',
        name: 'Limited Liability Partnership',
        abbreviation: 'Limited;Ltd.;L.L.P.;LLP;RLLP;R.L.L.P.',
        active: true,
        aliases: ['Limited Liability Partnership', 'Limited;Ltd.;L.L.P.;LLP;RLLP;R.L.L.P.'],
    },
    {
        code: 'M673',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Société civile d'exploitation agricole",
        abbreviation: '',
        active: true,
        aliases: ["Société civile d'exploitation agricole"],
    },
    {
        code: 'M6YY',
        country: 'WS',
        jurisdiction: 'WS',
        jurisdictionName: 'Samoa',
        name: 'Private limited company',
        abbreviation: '',
        active: true,
        aliases: ['Private limited company'],
    },
    {
        code: 'M848',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Corpororate public company',
        abbreviation: 'Corp. publ. co.',
        active: true,
        aliases: [
            'Corpororate public company',
            'Corp. publ. co.',
            "Entreprise publique d'une corpororation",
            'Ent. pub. corpor.',
            'öffentlich-rechtliche Körperschaft (Unternehmen)',
            'öff. Unt. Körp.',
            'Impresa o ente pubblico di una corporazione',
            'Imp. pubb. corpora.',
        ],
    },
    {
        code: 'M84A',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Sklad',
        abbreviation: '',
        active: true,
        aliases: ['Sklad'],
    },
    {
        code: 'M886',
        country: 'US',
        jurisdiction: 'US-AK',
        jurisdictionName: 'Alaska',
        name: 'Limited Liability Partnership',
        abbreviation: 'L.L.P.;LLP',
        active: true,
        aliases: ['Limited Liability Partnership', 'L.L.P.;LLP'],
    },
    {
        code: 'M8SS',
        country: 'IS',
        jurisdiction: 'IS',
        jurisdictionName: 'Iceland',
        name: 'Einkahlutafélag',
        abbreviation: 'ehf.',
        active: true,
        aliases: ['Einkahlutafélag', 'ehf.'],
    },
    {
        code: 'M9A1',
        country: 'US',
        jurisdiction: 'US-ME',
        jurisdictionName: 'Maine',
        name: 'Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Partnership'],
    },
    {
        code: 'M9IQ',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Kommandittselskap',
        abbreviation: 'KS',
        active: true,
        aliases: ['Kommandittselskap', 'KS'],
    },
    {
        code: 'MAM6',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Institución de asistencia privada',
        abbreviation: 'I.A.P.',
        active: true,
        aliases: ['Institución de asistencia privada', 'I.A.P.'],
    },
    {
        code: 'MAVU',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Dobrovolný svazek obcí',
        abbreviation: '',
        active: true,
        aliases: ['Dobrovolný svazek obcí'],
    },
    {
        code: 'MB35',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Ejido',
        abbreviation: '',
        active: true,
        aliases: ['Ejido'],
    },
    {
        code: 'MBKN',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'MBPY',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Asumisoikeusyhdistys',
        abbreviation: '',
        active: true,
        aliases: ['Asumisoikeusyhdistys', 'Boenderättsförening'],
    },
    {
        code: 'MBUU',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Příspěvková organizace zřízená územním samosprávným celkem',
        abbreviation: '',
        active: true,
        aliases: ['Příspěvková organizace zřízená územním samosprávným celkem'],
    },
    {
        code: 'MBVS',
        country: 'BM',
        jurisdiction: 'BM',
        jurisdictionName: 'Bermuda',
        name: 'Exempted Unlimited Company',
        abbreviation: '',
        active: true,
        aliases: ['Exempted Unlimited Company'],
    },
    {
        code: 'MCQP',
        country: 'GG',
        jurisdiction: 'GG',
        jurisdictionName: 'Guernsey',
        name: 'limited partnership (with separate legal personality)',
        abbreviation: '',
        active: true,
        aliases: ['limited partnership (with separate legal personality)'],
    },
    {
        code: 'MCWR',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Κοινοπραξία',
        abbreviation: 'JV',
        active: true,
        aliases: ['Κοινοπραξία', 'Kinopraxia', 'JV'],
    },
    {
        code: 'MCY8',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: "Personne morale sans but lucratif par Loi sur les sociétés d'agriculture",
        abbreviation: '',
        active: true,
        aliases: ["Personne morale sans but lucratif par Loi sur les sociétés d'agriculture"],
    },
    {
        code: 'MDOL',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Fundación',
        abbreviation: '',
        active: true,
        aliases: ['Fundación'],
    },
    {
        code: 'ME4Y',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Public Benefit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Public Benefit Corporation', 'Corporación de Beneficio Social'],
    },
    {
        code: 'MEHL',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Islamic Recognized Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Islamic Recognized Limited Liability Partnership'],
    },
    {
        code: 'MEJT',
        country: 'AZ',
        jurisdiction: 'AZ',
        jurisdictionName: 'Azerbaijan',
        name: 'Tam ortaqlıq',
        abbreviation: '',
        active: true,
        aliases: ['Tam ortaqlıq'],
    },
    {
        code: 'MF7P',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Komanditno društvo',
        abbreviation: 'k.d.',
        active: true,
        aliases: ['Komanditno društvo', 'k.d.'],
    },
    {
        code: 'MFHR',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Sociedade Anónima Europeia',
        abbreviation: 'SE',
        active: true,
        aliases: ['Sociedade Anónima Europeia', 'SE'],
    },
    {
        code: 'MFYJ',
        country: 'US',
        jurisdiction: 'US-GA',
        jurisdictionName: 'Georgia',
        name: 'Profit Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.',
        active: true,
        aliases: ['Profit Corporation', 'corp.;inc.;co.;ltd.'],
    },
    {
        code: 'MG22',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Государственные автономные учреждения субъектов Российской Федерации',
        abbreviation: '',
        active: true,
        aliases: [
            'Государственные автономные учреждения субъектов Российской Федерации',
            'Gosudarstvennyye avtonomnyye uchrezhdeniya sub"yektov Rossiyskoy Federatsii',
        ],
    },
    {
        code: 'MG2O',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Institution interdépartementale ou entente',
        abbreviation: '',
        active: true,
        aliases: ['Institution interdépartementale ou entente'],
    },
    {
        code: 'MG8V',
        country: 'US',
        jurisdiction: 'US-RI',
        jurisdictionName: 'Rhode Island',
        name: 'L3C Low Profit LLC',
        abbreviation: '',
        active: true,
        aliases: ['L3C Low Profit LLC'],
    },
    {
        code: 'MGCM',
        country: 'BE',
        jurisdiction: 'BE-VLG',
        jurisdictionName: 'Flemish Region',
        name: 'Opdrachthoudende vereniging (Vlaams Gewest)',
        abbreviation: '',
        active: true,
        aliases: [
            'Opdrachthoudende vereniging (Vlaams Gewest)',
            'Association chargée de mission (Région flamande)',
            'Beauftragte Vereinigung (Flämische Region)',
        ],
    },
    {
        code: 'MGE0',
        country: 'CA',
        jurisdiction: 'CA',
        jurisdictionName: 'Canada',
        name: 'cooperative',
        abbreviation: 'coop;co-op',
        active: true,
        aliases: ['cooperative', 'coop;co-op', 'coopérative'],
    },
    {
        code: 'MGOU',
        country: 'BO',
        jurisdiction: 'BO',
        jurisdictionName: 'Bolivia (Plurinational State of)',
        name: 'Empresa Mixta',
        abbreviation: '',
        active: true,
        aliases: ['Empresa Mixta'],
    },
    {
        code: 'MGUM',
        country: 'VI',
        jurisdiction: 'VI',
        jurisdictionName: 'Virgin Islands (U.S.)',
        name: 'Domestic Limited Partnership / Limited Liability Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Limited Partnership / Limited Liability Limited Partnership'],
    },
    {
        code: 'MH3L',
        country: 'VI',
        jurisdiction: 'VI',
        jurisdictionName: 'Virgin Islands (U.S.)',
        name: 'Domestic Trade & Labor Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Trade & Labor Corporation'],
    },
    {
        code: 'MI0H',
        country: 'US',
        jurisdiction: 'US-MI',
        jurisdictionName: 'Michigan',
        name: 'for profit and not-for profit co-operatives',
        abbreviation: 'Cooperative;coop.;co-operative;or co-op',
        active: true,
        aliases: [
            'for profit and not-for profit co-operatives',
            'Cooperative;coop.;co-operative;or co-op',
        ],
    },
    {
        code: 'MIPY',
        country: 'US',
        jurisdiction: 'US-DE',
        jurisdictionName: 'Delaware',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: 'MJ9Z',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'MJJZ',
        country: 'US',
        jurisdiction: 'US-AR',
        jurisdictionName: 'Arkansas',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'MK1I',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: "Société par actions constitué par Loi sur les sociétés d'entraide économique",
        abbreviation: '',
        active: true,
        aliases: ["Société par actions constitué par Loi sur les sociétés d'entraide économique"],
    },
    {
        code: 'MKAG',
        country: 'AE',
        jurisdiction: 'AE',
        jurisdictionName: 'United Arab Emirates',
        name: 'Cooperative Society',
        abbreviation: '',
        active: true,
        aliases: ['Cooperative Society'],
    },
    {
        code: 'MM8M',
        country: 'US',
        jurisdiction: 'US-NV',
        jurisdictionName: 'Nevada',
        name: 'Limited Liability Company',
        abbreviation: 'L.L.C.;LLC;LC',
        active: true,
        aliases: ['Limited Liability Company', 'L.L.C.;LLC;LC'],
    },
    {
        code: 'MMA4',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SA union de sociétés coopératives à directoire',
        abbreviation: '',
        active: true,
        aliases: ['SA union de sociétés coopératives à directoire'],
    },
    {
        code: 'MMBP',
        country: 'FO',
        jurisdiction: 'FO',
        jurisdictionName: 'Faroe Islands',
        name: 'Samstarv',
        abbreviation: '',
        active: true,
        aliases: ['Samstarv'],
    },
    {
        code: 'MNQ7',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'Private Company Limited by Shares',
        abbreviation: 'Ltd;Ltd.;Limited',
        active: true,
        aliases: ['Private Company Limited by Shares', 'Ltd;Ltd.;Limited', 'Teoranta', 'teo'],
    },
    {
        code: 'MOI8',
        country: 'PK',
        jurisdiction: 'PK',
        jurisdictionName: 'Pakistan',
        name: 'Public Limited Company (not-for profit association)',
        abbreviation: '',
        active: true,
        aliases: ['Public Limited Company (not-for profit association)'],
    },
    {
        code: 'MOUL',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Assurance mutuelle agricole',
        abbreviation: '',
        active: true,
        aliases: ['Assurance mutuelle agricole'],
    },
    {
        code: 'MP7S',
        country: 'KY',
        jurisdiction: 'KY',
        jurisdictionName: 'Cayman Islands',
        name: 'segregated portfolio company',
        abbreviation: 'SPC',
        active: true,
        aliases: ['segregated portfolio company', 'SPC'],
    },
    {
        code: 'MPFG',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Foreign Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Limited Liability Partnership'],
    },
    {
        code: 'MPUG',
        country: 'KY',
        jurisdiction: 'KY',
        jurisdictionName: 'Cayman Islands',
        name: 'limited liability company',
        abbreviation: 'LLC',
        active: true,
        aliases: ['limited liability company', 'LLC'],
    },
    {
        code: 'MQH3',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Commanditaire vennootschap',
        abbreviation: 'CommV',
        active: true,
        aliases: [
            'Commanditaire vennootschap',
            'CommV',
            'Société en commandite',
            'SComm',
            'Kommanditgesellschaft',
            'KommG',
        ],
    },
    {
        code: 'MQPZ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Caisse d'épargne et de prévoyance à forme coopérative",
        abbreviation: '',
        active: true,
        aliases: ["Caisse d'épargne et de prévoyance à forme coopérative"],
    },
    {
        code: 'MQT7',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur la santé et la sécurité du travail',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur la santé et la sécurité du travail'],
    },
    {
        code: 'MQU4',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Domestic Unincorporated Association',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Unincorporated Association'],
    },
    {
        code: 'MQU9',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Organisme de placement collectif en valeurs mobilières sans personnalité morale',
        abbreviation: '',
        active: true,
        aliases: ['Organisme de placement collectif en valeurs mobilières sans personnalité morale'],
    },
    {
        code: 'MR85',
        country: 'BY',
        jurisdiction: 'BY',
        jurisdictionName: 'Belarus',
        name: 'Адкрытае акцыянернае таварыства',
        abbreviation: 'ААТ',
        active: true,
        aliases: [
            'Адкрытае акцыянернае таварыства',
            'Adkrytae akcyyanernae tavarystva',
            'ААТ',
            'AAT',
            'Открытое акционерное общество',
            'Otkrytoe akcionernoe obshchestvo',
            'ОАО',
        ],
    },
    {
        code: 'MR95',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les décrets de convention collective',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur les décrets de convention collective'],
    },
    {
        code: 'MRSY',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'General partnership',
        abbreviation: 'Partnership (general)',
        active: true,
        aliases: [
            'General partnership',
            'Partnership (general)',
            'Société en nom collectif',
            'SNC',
            'Kollektivgesellschaft',
            'KlG',
            'Società in nome collettivo',
        ],
    },
    {
        code: 'MRW9',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Muu julkisoikeudellinen oikeushenkilö',
        abbreviation: '',
        active: true,
        aliases: ['Muu julkisoikeudellinen oikeushenkilö', 'Annan offentligrättslig juridisk person'],
    },
    {
        code: 'MSGT',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Slobodné povolanie-fyzická osoba podnikajúca na základe iného ako živnostenského zákona zapísaná v obchodnom registri',
        abbreviation: 'FO-slob.povolanie v OR',
        active: true,
        aliases: [
            'Slobodné povolanie-fyzická osoba podnikajúca na základe iného ako živnostenského zákona zapísaná v obchodnom registri',
            'FO-slob.povolanie v OR',
        ],
    },
    {
        code: 'MT3A',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Открытое акционерное общество',
        abbreviation: '',
        active: true,
        aliases: ['Открытое акционерное общество', 'Otkrytoye aktsionernoye obshchestvo'],
    },
    {
        code: 'MT4X',
        country: 'NG',
        jurisdiction: 'NG',
        jurisdictionName: 'Nigeria',
        name: 'Limited liability partnership',
        abbreviation: 'LLP',
        active: true,
        aliases: ['Limited liability partnership', 'LLP'],
    },
    {
        code: 'MTDW',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Limited Liability Limited Partnership',
        abbreviation: 'LLLP;L.L.L.P',
        active: true,
        aliases: ['Limited Liability Limited Partnership', 'LLLP;L.L.L.P'],
    },
    {
        code: 'MTLX',
        country: 'NP',
        jurisdiction: 'NP',
        jurisdictionName: 'Nepal',
        name: 'Private Company',
        abbreviation: 'Private Limited; Pvt. Ltd',
        active: true,
        aliases: [
            'Private Company',
            'Private company',
            'Private Limited; Pvt. Ltd',
            'प्राइभेट कम्पनी ',
            'praaibhet kampani',
            'Private Limited; Pra.Li.',
        ],
    },
    {
        code: 'MV1C',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Потребительские общества',
        abbreviation: '',
        active: true,
        aliases: ['Потребительские общества', "Potrebitel'skiye obshchestva"],
    },
    {
        code: 'MV4S',
        country: 'AE',
        jurisdiction: 'AE',
        jurisdictionName: 'United Arab Emirates',
        name: 'Sole Proprietor',
        abbreviation: '',
        active: true,
        aliases: ['Sole Proprietor'],
    },
    {
        code: 'MVII',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Company limited by shares',
        abbreviation: 'PLC',
        active: true,
        aliases: [
            'Company limited by shares',
            'PLC',
            'Société anonyme',
            'SA',
            'Aktiengesellschaft',
            'AG',
            'Società anonima',
        ],
    },
    {
        code: 'MVSF',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Объединения фермерских хозяйств',
        abbreviation: '',
        active: true,
        aliases: ['Объединения фермерских хозяйств', 'Ob"yedineniya fermerskikh khozyaystv'],
    },
    {
        code: 'MX8J',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SA coopérative de commerçants-détaillants à directoire',
        abbreviation: '',
        active: true,
        aliases: ['SA coopérative de commerçants-détaillants à directoire'],
    },
    {
        code: 'MXLT',
        country: 'CA',
        jurisdiction: 'CA-MB',
        jurisdictionName: 'Manitoba',
        name: 'Sole Proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['Sole Proprietorship'],
    },
    {
        code: 'MXMH',
        country: 'JP',
        jurisdiction: 'JP',
        jurisdictionName: 'Japan',
        name: '外国会社等',
        abbreviation: '外',
        active: true,
        aliases: ['外国会社等', 'gaikokugaisyatou', '外'],
    },
    {
        code: 'MXWB',
        country: 'US',
        jurisdiction: 'US-TX',
        jurisdictionName: 'Texas',
        name: 'Professional Association',
        abbreviation: '',
        active: true,
        aliases: ['Professional Association'],
    },
    {
        code: 'MY1S',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Odštepný závod alebo iná organizačná zložka podniku zapisujúca sa do obchodného registra',
        abbreviation: 'Odštepný závod v OR',
        active: true,
        aliases: [
            'Odštepný závod alebo iná organizačná zložka podniku zapisujúca sa do obchodného registra',
            'Odštepný závod v OR',
        ],
    },
    {
        code: 'MY4W',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union', 'caisse populaire'],
    },
    {
        code: 'MY61',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'Limited Liability Company (non-profit)',
        abbreviation: 'LLC;LIMITED LIABILITY COMPANY;LTD. CO',
        active: true,
        aliases: ['Limited Liability Company (non-profit)', 'LLC;LIMITED LIABILITY COMPANY;LTD. CO'],
    },
    {
        code: 'MY93',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Professional Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Professional Limited Liability Company'],
    },
    {
        code: 'MYKG',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Δημόσια Εταιρεία',
        abbreviation: '',
        active: true,
        aliases: ['Δημόσια Εταιρεία', 'Dimosia Etaireia'],
    },
    {
        code: 'MZB1',
        country: 'CW',
        jurisdiction: 'CW',
        jurisdictionName: 'Curaçao',
        name: 'Besloten Vennootschap',
        abbreviation: '',
        active: true,
        aliases: ['Besloten Vennootschap'],
    },
    {
        code: 'MZT6',
        country: 'ZA',
        jurisdiction: 'ZA',
        jurisdictionName: 'South Africa',
        name: 'Co-operatives (Primary)',
        abbreviation: '',
        active: true,
        aliases: ['Co-operatives (Primary)'],
    },
    {
        code: 'N00R',
        country: 'CK',
        jurisdiction: 'CK',
        jurisdictionName: 'Cook Islands',
        name: 'Foundation',
        abbreviation: '',
        active: true,
        aliases: ['Foundation'],
    },
    {
        code: 'N0JF',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima, bolsa de valores',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima, bolsa de valores'],
    },
    {
        code: 'N0YQ',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Insurance Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Insurance Corporation'],
    },
    {
        code: 'N10C',
        country: 'SA',
        jurisdiction: 'SA',
        jurisdictionName: 'Saudi Arabia',
        name: 'شركات ذات رأس مال قابل للتغيير',
        abbreviation: '',
        active: true,
        aliases: ['شركات ذات رأس مال قابل للتغيير', 'sharikat dhat ras mal qabil liltaghyir'],
    },
    {
        code: 'N10D',
        country: 'US',
        jurisdiction: 'US-SC',
        jurisdictionName: 'South Carolina',
        name: 'Professional Corporation',
        abbreviation: 'P.C.;PC;P.A.;PA',
        active: true,
        aliases: ['Professional Corporation', 'P.C.;PC;P.A.;PA'],
    },
    {
        code: 'N124',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, institución de fondos de pago electrónico',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima de capital variable, institución de fondos de pago electrónico'],
    },
    {
        code: 'N1TE',
        country: 'CO',
        jurisdiction: 'CO',
        jurisdictionName: 'Colombia',
        name: 'Sociedad en comandita por acciones',
        abbreviation: 'Cía SCA.',
        active: true,
        aliases: ['Sociedad en comandita por acciones', 'Cía SCA.'],
    },
    {
        code: 'N263',
        country: 'US',
        jurisdiction: 'US-RI',
        jurisdictionName: 'Rhode Island',
        name: 'Workers Cooperative',
        abbreviation: 'corp.;inc.;co.;ltd.',
        active: true,
        aliases: ['Workers Cooperative', 'corp.;inc.;co.;ltd.'],
    },
    {
        code: 'N28C',
        country: 'VG',
        jurisdiction: 'VG',
        jurisdictionName: 'Virgin Islands (British)',
        name: 'restricted purposes company segregated portfolio company',
        abbreviation: '(SPV) SPC',
        active: true,
        aliases: ['restricted purposes company segregated portfolio company', '(SPV) SPC'],
    },
    {
        code: 'N295',
        country: 'US',
        jurisdiction: 'US-CA',
        jurisdictionName: 'California',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'N3JU',
        country: 'JP',
        jurisdiction: 'JP',
        jurisdictionName: 'Japan',
        name: 'その他の設立登記法人',
        abbreviation: '',
        active: true,
        aliases: ['その他の設立登記法人', 'sonotaseturitutoukihouzin'],
    },
    {
        code: 'N3LC',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Rekisteröity uskonnollinen yhdyskunta',
        abbreviation: '',
        active: true,
        aliases: ['Rekisteröity uskonnollinen yhdyskunta', 'Registrerat religiöst samfund'],
    },
    {
        code: 'N3VO',
        country: 'HK',
        jurisdiction: 'HK',
        jurisdictionName: 'Hong Kong',
        name: '有股本的公眾無限公司',
        abbreviation: '無限公司',
        active: true,
        aliases: [
            '有股本的公眾無限公司',
            'You gu ben de gong zhong wu xian gong si',
            '無限公司',
            'Public unlimited company with a share capital',
            'Unltd;Ultd',
        ],
    },
    {
        code: 'N508',
        country: 'US',
        jurisdiction: 'US-NJ',
        jurisdictionName: 'New Jersey',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'N566',
        country: 'US',
        jurisdiction: 'US-OH',
        jurisdictionName: 'Ohio',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'N5MX',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Samostatne podnikajúca fyzická osoba',
        abbreviation: 'Samostatne podnikajúca FO',
        active: true,
        aliases: ['Samostatne podnikajúca fyzická osoba', 'Samostatne podnikajúca FO'],
    },
    {
        code: 'N5NT',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Besloten vennootschap met beperkte aansprakelijkheid',
        abbreviation: 'BVBA',
        active: true,
        aliases: [
            'Besloten vennootschap met beperkte aansprakelijkheid',
            'BVBA',
            'Société privée à responsabilité limitée',
            'SPRL',
            'Privatgesellschaft mit beschränkter Haftung',
            'PGmbH',
        ],
    },
    {
        code: 'N5OS',
        country: 'US',
        jurisdiction: 'US-TX',
        jurisdictionName: 'Texas',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'N66B',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Sociedade em Nome Coletivo',
        abbreviation: '',
        active: true,
        aliases: ['Sociedade em Nome Coletivo'],
    },
    {
        code: 'N69M',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Partnership'],
    },
    {
        code: 'N71W',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Cable & Video Franchise',
        abbreviation: '',
        active: true,
        aliases: ['Cable & Video Franchise'],
    },
    {
        code: 'N745',
        country: 'CA',
        jurisdiction: 'CA-PE',
        jurisdictionName: 'Prince Edward Island',
        name: 'public company',
        abbreviation: 'Ltd.;Inc.;Corp.;Ltée',
        active: true,
        aliases: ['public company', 'Ltd.;Inc.;Corp.;Ltée'],
    },
    {
        code: 'N7I1',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Organizačná zložka príspevkovej organizácie s odvodenou právnou subjektivitou',
        abbreviation: 'Org.zložka prísp.org.',
        active: true,
        aliases: [
            'Organizačná zložka príspevkovej organizácie s odvodenou právnou subjektivitou',
            'Org.zložka prísp.org.',
        ],
    },
    {
        code: 'N7VF',
        country: 'US',
        jurisdiction: 'US-DE',
        jurisdictionName: 'Delaware',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'N8FJ',
        country: 'TH',
        jurisdiction: 'TH',
        jurisdictionName: 'Thailand',
        name: 'ส่วนราชการ',
        abbreviation: '',
        active: true,
        aliases: ['ส่วนราชการ', 'S̄̀wn rāchkār'],
    },
    {
        code: 'N97C',
        country: 'JM',
        jurisdiction: 'JM',
        jurisdictionName: 'Jamaica',
        name: 'company limited by guarantee',
        abbreviation: '',
        active: true,
        aliases: ['company limited by guarantee'],
    },
    {
        code: 'N9QH',
        country: 'EC',
        jurisdiction: 'EC',
        jurisdictionName: 'Ecuador',
        name: 'Compañía de Economía Mixta',
        abbreviation: 'CEMIX',
        active: true,
        aliases: ['Compañía de Economía Mixta', 'CEMIX'],
    },
    {
        code: 'N9QW',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Pobočka štátneho peňažného ústavu',
        abbreviation: 'Pobočka štát.peňaž.úst.',
        active: true,
        aliases: ['Pobočka štátneho peňažného ústavu', 'Pobočka štát.peňaž.úst.'],
    },
    {
        code: 'NA09',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Asociación religiosa',
        abbreviation: '',
        active: true,
        aliases: ['Asociación religiosa'],
    },
    {
        code: 'NAQG',
        country: 'BM',
        jurisdiction: 'BM',
        jurisdictionName: 'Bermuda',
        name: 'Local Company Limited by Shares',
        abbreviation: '',
        active: true,
        aliases: ['Local Company Limited by Shares'],
    },
    {
        code: 'NAUO',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Other Company Type',
        abbreviation: '',
        active: false,
        aliases: ['Other Company Type'],
    },
    {
        code: 'NB58',
        country: 'US',
        jurisdiction: 'US-WY',
        jurisdictionName: 'Wyoming',
        name: 'Limited Liability Company',
        abbreviation: 'L.L.C.;LLC;L.C.;LC',
        active: true,
        aliases: ['Limited Liability Company', 'L.L.C.;LLC;L.C.;LC'],
    },
    {
        code: 'NBA8',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Autre établissement public national administratif à compétence territoriale limitée',
        abbreviation: '',
        active: true,
        aliases: [
            'Autre établissement public national administratif à compétence territoriale limitée',
        ],
    },
    {
        code: 'NBCI',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Banking Company - Others',
        abbreviation: '',
        active: true,
        aliases: ['Banking Company - Others'],
    },
    {
        code: 'NBTW',
        country: 'GB',
        jurisdiction: 'GB-SCT',
        jurisdictionName: 'Scotland',
        name: 'Scottish Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Scottish Partnership'],
    },
    {
        code: 'NC88',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Účelová organizačná jednotka ČSD',
        abbreviation: 'Účelová org. jedn. ČSD',
        active: true,
        aliases: ['Účelová organizačná jednotka ČSD', 'Účelová org. jedn. ČSD'],
    },
    {
        code: 'ND7S',
        country: 'FJ',
        jurisdiction: 'FJ',
        jurisdictionName: 'Fiji',
        name: 'Co-operative',
        abbreviation: '',
        active: true,
        aliases: ['Co-operative'],
    },
    {
        code: 'ND8M',
        country: 'TZ',
        jurisdiction: 'TZ',
        jurisdictionName: 'Tanzania',
        name: 'Non-Governmental Organisation ',
        abbreviation: 'NGO',
        active: true,
        aliases: ['Non-Governmental Organisation ', 'NGO'],
    },
    {
        code: 'ND93',
        country: 'US',
        jurisdiction: 'US-TN',
        jurisdictionName: 'Tennessee',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'NDBR',
        country: 'US',
        jurisdiction: 'US-MS',
        jurisdictionName: 'Mississippi',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP'],
    },
    {
        code: 'NDC3',
        country: 'GG',
        jurisdiction: 'GG',
        jurisdictionName: 'Alderney',
        name: 'private company',
        abbreviation: '',
        active: true,
        aliases: ['private company'],
    },
    {
        code: 'NDEW',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società Consortile Cooperativa',
        abbreviation: '',
        active: false,
        aliases: ['Società Consortile Cooperativa'],
    },
    {
        code: 'NDID',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Kollektivgesellschaft',
        abbreviation: '',
        active: true,
        aliases: ['Kollektivgesellschaft'],
    },
    {
        code: 'NETO',
        country: 'US',
        jurisdiction: 'US-MA',
        jurisdictionName: 'Massachusetts',
        name: 'Employee Cooperative Corporation',
        abbreviation: 'Company;Corporation;Corp.;Incorporated;Inc.',
        active: true,
        aliases: ['Employee Cooperative Corporation', 'Company;Corporation;Corp.;Incorporated;Inc.'],
    },
    {
        code: 'NFCV',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Association coopérative inscrite (droit local Alsace Moselle)',
        abbreviation: '',
        active: true,
        aliases: ['Association coopérative inscrite (droit local Alsace Moselle)'],
    },
    {
        code: 'NFDF',
        country: 'SG',
        jurisdiction: 'SG',
        jurisdictionName: 'Singapore',
        name: 'Sole-Proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['Sole-Proprietorship'],
    },
    {
        code: 'NFFH',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'coöperatie',
        abbreviation: 'coöperatie;coöp',
        active: true,
        aliases: ['coöperatie', 'coöperatie;coöp'],
    },
    {
        code: 'NFHN',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Entidades de Previsión Social Voluntaria ',
        abbreviation: 'EPSV',
        active: true,
        aliases: ['Entidades de Previsión Social Voluntaria ', 'EPSV'],
    },
    {
        code: 'NFPC',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Non-Banking Finance Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-Banking Finance Company'],
    },
    {
        code: 'NFRJ',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Reprezentant fiscal',
        abbreviation: '',
        active: true,
        aliases: ['Reprezentant fiscal'],
    },
    {
        code: 'NFYA',
        country: 'PA',
        jurisdiction: 'PA',
        jurisdictionName: 'Panama',
        name: 'Consorcio',
        abbreviation: '',
        active: true,
        aliases: ['Consorcio'],
    },
    {
        code: 'NG11',
        country: 'OM',
        jurisdiction: 'OM',
        jurisdictionName: 'Oman',
        name: 'شركة المساهمة مقفلة ',
        abbreviation: '',
        active: true,
        aliases: ['شركة المساهمة مقفلة ', 'sharikat almusahamat muqfala'],
    },
    {
        code: 'NGR5',
        country: 'GG',
        jurisdiction: 'GG',
        jurisdictionName: 'Guernsey',
        name: 'mixed liability company',
        abbreviation: 'ML',
        active: true,
        aliases: ['mixed liability company', 'ML'],
    },
    {
        code: 'NGZJ',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Domesticated Foreign Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Domesticated Foreign Corporation'],
    },
    {
        code: 'NHBK',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, fondo de inversión de capitales',
        abbreviation: 'S. A. de C. V., F. I. de C.',
        active: true,
        aliases: [
            'Sociedad anónima de capital variable, fondo de inversión de capitales',
            'S. A. de C. V., F. I. de C.',
        ],
    },
    {
        code: 'NHGN',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Limited Partnership',
        abbreviation: 'LP;L.P.',
        active: true,
        aliases: ['Limited Partnership', 'LP;L.P.'],
    },
    {
        code: 'NHYA',
        country: 'US',
        jurisdiction: 'US-WA',
        jurisdictionName: 'Washington',
        name: 'Profit Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.',
        active: true,
        aliases: ['Profit Corporation', 'corp.;inc.;co.;ltd.'],
    },
    {
        code: 'NI3I',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Veřejnoprávní instituce',
        abbreviation: '',
        active: true,
        aliases: ['Veřejnoprávní instituce'],
    },
    {
        code: 'NI44',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Domestic Corporation',
        abbreviation: 'corp.;corporation;co.;company;ltd.;limited;inc.;incorporated',
        active: true,
        aliases: [
            'Domestic Corporation',
            'corp.;corporation;co.;company;ltd.;limited;inc.;incorporated',
        ],
    },
    {
        code: 'NIJH',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Erwerbs- und Wirtschaftsgenossenschaft',
        abbreviation: '',
        active: true,
        aliases: ['Erwerbs- und Wirtschaftsgenossenschaft'],
    },
    {
        code: 'NIQY',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Entidade Empresarial Metropolitana',
        abbreviation: '',
        active: true,
        aliases: ['Entidade Empresarial Metropolitana'],
    },
    {
        code: 'NJ57',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'NJ87',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Společný podnik (s více zakladateli)',
        abbreviation: '',
        active: true,
        aliases: ['Společný podnik (s více zakladateli)'],
    },
    {
        code: 'NJA5',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Real Estate Investment Trusts',
        abbreviation: 'REIT;R.E.I.T.',
        active: true,
        aliases: ['Real Estate Investment Trusts', 'REIT;R.E.I.T.'],
    },
    {
        code: 'NK3V',
        country: 'US',
        jurisdiction: 'US-MI',
        jurisdictionName: 'Michigan',
        name: 'General Partnership',
        abbreviation: '',
        active: true,
        aliases: ['General Partnership'],
    },
    {
        code: 'NL31',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Spoločný podnik (s viacerými zakladateľmi)',
        abbreviation: '',
        active: true,
        aliases: ['Spoločný podnik (s viacerými zakladateľmi)'],
    },
    {
        code: 'NLI7',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Sporiteľna',
        abbreviation: '',
        active: true,
        aliases: ['Sporiteľna'],
    },
    {
        code: 'NM07',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA immobilière d'investissement à directoire",
        abbreviation: '',
        active: true,
        aliases: ["SA immobilière d'investissement à directoire"],
    },
    {
        code: 'NNLI',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'stille Gesellschaft',
        abbreviation: 'stG',
        active: true,
        aliases: ['stille Gesellschaft', 'stG'],
    },
    {
        code: 'NNLM',
        country: 'VI',
        jurisdiction: 'VI',
        jurisdictionName: 'Virgin Islands (U.S.)',
        name: 'Domestic Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Profit Corporation'],
    },
    {
        code: 'NO20',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Zatiaľ neurčené',
        abbreviation: '',
        active: true,
        aliases: ['Zatiaľ neurčené'],
    },
    {
        code: 'NO8C',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Foreign Company',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Foreign Company'],
    },
    {
        code: 'NOBH',
        country: 'US',
        jurisdiction: 'US-UT',
        jurisdictionName: 'Utah',
        name: 'Non-profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Non-profit Corporation'],
    },
    {
        code: 'NOI8',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Communauté d'agglomération",
        abbreviation: '',
        active: true,
        aliases: ["Communauté d'agglomération"],
    },
    {
        code: 'NONB',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'corporation',
        abbreviation: 'Ltée;Inc.;Corp.',
        active: false,
        aliases: ['corporation', 'Ltée;Inc.;Corp.'],
    },
    {
        code: 'NPFB',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Eenmanszaak',
        abbreviation: '',
        active: true,
        aliases: ['Eenmanszaak'],
    },
    {
        code: 'NPH3',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Česká národní banka',
        abbreviation: '',
        active: true,
        aliases: ['Česká národní banka'],
    },
    {
        code: 'NQCT',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: '(Autre) Établissement public administratif local',
        abbreviation: '',
        active: true,
        aliases: ['(Autre) Établissement public administratif local'],
    },
    {
        code: 'NQHQ',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Komoditní burza',
        abbreviation: '',
        active: true,
        aliases: ['Komoditní burza'],
    },
    {
        code: 'NR96',
        country: 'US',
        jurisdiction: 'US-MI',
        jurisdictionName: 'Michigan',
        name: 'L3C',
        abbreviation: 'L.3.C.;L3C;Low-Profit Limited Liability Company',
        active: true,
        aliases: ['L3C', 'L.3.C.;L3C;Low-Profit Limited Liability Company'],
    },
    {
        code: 'NRK9',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Общественные учреждения',
        abbreviation: '',
        active: true,
        aliases: ['Общественные учреждения', 'Obshchestvennyye uchrezhdeniya'],
    },
    {
        code: 'NRTG',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Podružnica',
        abbreviation: '',
        active: true,
        aliases: ['Podružnica'],
    },
    {
        code: 'NSZI',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Unidad agrícola industrial de la mujer',
        abbreviation: 'UAIM',
        active: true,
        aliases: ['Unidad agrícola industrial de la mujer', 'UAIM'],
    },
    {
        code: 'NUL8',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Kommanditselskab',
        abbreviation: 'K/S',
        active: true,
        aliases: ['Kommanditselskab', 'K/S'],
    },
    {
        code: 'NUMY',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SA coopérative artisanale à directoire',
        abbreviation: '',
        active: true,
        aliases: ['SA coopérative artisanale à directoire'],
    },
    {
        code: 'NUQ2',
        country: 'US',
        jurisdiction: 'US-DC',
        jurisdictionName: 'District of Columbia',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'NV7C',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Muu säätiö',
        abbreviation: '',
        active: true,
        aliases: ['Muu säätiö', 'Annan stiftelse'],
    },
    {
        code: 'NV9X',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Domestic Real Estate Investment Trust',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Real Estate Investment Trust'],
    },
    {
        code: 'NVPY',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Privačių detektyvų bendrijos',
        abbreviation: 'PDB',
        active: true,
        aliases: ['Privačių detektyvų bendrijos', 'PDB'],
    },
    {
        code: 'NVXN',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: "Personne morale sans but lucratif par Loi sur l'organisation territoriale municipale",
        abbreviation: '',
        active: true,
        aliases: [
            "Personne morale sans but lucratif par Loi sur l'organisation territoriale municipale",
        ],
    },
    {
        code: 'NWJX',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '其他（司法行政）',
        abbreviation: '',
        active: true,
        aliases: ['其他（司法行政）', 'qi ta（ si fa xing zheng ）'],
    },
    {
        code: 'NWT1',
        country: 'SX',
        jurisdiction: 'SX',
        jurisdictionName: 'Sint Maarten',
        name: 'coöperatie',
        abbreviation: '',
        active: true,
        aliases: ['coöperatie'],
    },
    {
        code: 'NXHQ',
        country: 'UY',
        jurisdiction: 'UY',
        jurisdictionName: 'Uruguay',
        name: 'Establecimiento Comercial',
        abbreviation: '',
        active: true,
        aliases: ['Establecimiento Comercial'],
    },
    {
        code: 'NY3P',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Islamic Special Trust',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Islamic Special Trust'],
    },
    {
        code: 'NYUD',
        country: 'US',
        jurisdiction: 'US-VT',
        jurisdictionName: 'Vermont',
        name: 'Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Profit Corporation'],
    },
    {
        code: 'NZ85',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Политические партии',
        abbreviation: '',
        active: true,
        aliases: ['Политические партии', 'Politicheskiye partii'],
    },
    {
        code: 'NZAI',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Külföldi székhelyű vállalkozás kereskedelmi képviselete',
        abbreviation: '',
        active: false,
        aliases: ['Külföldi székhelyű vállalkozás kereskedelmi képviselete'],
    },
    {
        code: 'O0EU',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Borettslag',
        abbreviation: 'BRL',
        active: true,
        aliases: ['Borettslag', 'BRL'],
    },
    {
        code: 'O0OZ',
        country: 'TH',
        jurisdiction: 'TH',
        jurisdictionName: 'Thailand',
        name: 'บริษัทมหาชนจำกัด',
        abbreviation: '',
        active: true,
        aliases: ['บริษัทมหาชนจำกัด', 'Bris̄ʹạth mh̄āchn cảkạd'],
    },
    {
        code: 'O0Y2',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Nešpecifikovaná právna forma',
        abbreviation: '',
        active: true,
        aliases: ['Nešpecifikovaná právna forma'],
    },
    {
        code: 'O13B',
        country: 'CA',
        jurisdiction: 'CA-BC',
        jurisdictionName: 'British Columbia',
        name: 'General partnership',
        abbreviation: 'LLP;SRL;SENCRL',
        active: true,
        aliases: ['General partnership', 'LLP;SRL;SENCRL'],
    },
    {
        code: 'O15N',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Чуждестранно дружество - юридическо лице',
        abbreviation: '',
        active: false,
        aliases: [
            'Чуждестранно дружество - юридическо лице',
            'Chuzhdestranno druzhestvo - yuridichesko litse',
        ],
    },
    {
        code: 'O15R',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, casa de cambio',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima de capital variable, casa de cambio'],
    },
    {
        code: 'O1EZ',
        country: 'US',
        jurisdiction: 'US-WV',
        jurisdictionName: 'West Virginia',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'O1KO',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Сельскохозяйственные потребительские сбытовые (торговые) кооперативы',
        abbreviation: '',
        active: true,
        aliases: [
            'Сельскохозяйственные потребительские сбытовые (торговые) кооперативы',
            "Sel'skokhozyaystvennyye potrebitel'skiye sbytovyye (torgovyye) kooperativy",
        ],
    },
    {
        code: 'O1QI',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Ömsesidigt försäkringsbolag',
        abbreviation: 'OFB',
        active: true,
        aliases: ['Ömsesidigt försäkringsbolag', 'OFB'],
    },
    {
        code: 'O256',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Non Profit Foreign Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Non Profit Foreign Corporation'],
    },
    {
        code: 'O2JM',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Youth Cooperative',
        abbreviation: '',
        active: true,
        aliases: ['Youth Cooperative', 'Cooperativa de Juvenil'],
    },
    {
        code: 'O2M6',
        country: 'HN',
        jurisdiction: 'HN',
        jurisdictionName: 'Honduras',
        name: 'Sociedad Colectiva',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad Colectiva'],
    },
    {
        code: 'O35K',
        country: 'US',
        jurisdiction: 'US-DC',
        jurisdictionName: 'District of Columbia',
        name: 'General Cooperative Association',
        abbreviation: 'Co-op;Coop;Assoc.;Assoc;Assn.;Assn',
        active: true,
        aliases: ['General Cooperative Association', 'Co-op;Coop;Assoc.;Assoc;Assn.;Assn'],
    },
    {
        code: 'O4NK',
        country: 'US',
        jurisdiction: 'US-MS',
        jurisdictionName: 'Mississippi',
        name: 'Nonprofit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation'],
    },
    {
        code: 'O4QG',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Partnership', 'Sociedad de Responsabilidad Limitada'],
    },
    {
        code: 'O4X3',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Asociación civil, Asociación deportiva, Federación',
        abbreviation: '',
        active: true,
        aliases: ['Asociación civil, Asociación deportiva, Federación'],
    },
    {
        code: 'O59C',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Economisch samenwerkingsverband met een sociaal oogmerk',
        abbreviation: 'ESV SO',
        active: true,
        aliases: [
            'Economisch samenwerkingsverband met een sociaal oogmerk',
            'ESV SO',
            "Groupement d'intérêt économique à finalité sociale",
            'GIE FS',
            'Wirtschaftliche Interessenvereinigung mit sozialer Zielsetzung',
            'WIVmsZ',
        ],
    },
    {
        code: 'O5HQ',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Burgerlijke vennootschap onder vorm van coöperatieve vennootschap met beperkte aansprakelijkheid',
        abbreviation: 'BV CVBA',
        active: false,
        aliases: [
            'Burgerlijke vennootschap onder vorm van coöperatieve vennootschap met beperkte aansprakelijkheid',
            'BV CVBA',
            'Société civile sous forme de société coopérative à responsabilité limitée',
            'SC SCRL',
            'Zivilrechtliche Gesellschaft in der Rechtsform einer Genossenschaft mit beschränkter Haftung',
            'ZvGGbH',
        ],
    },
    {
        code: 'O5PH',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'Public Benefit Corporation (profit)',
        abbreviation: 'PBC;Benefit Corporation;Public Benefit Corporation',
        active: true,
        aliases: [
            'Public Benefit Corporation (profit)',
            'PBC;Benefit Corporation;Public Benefit Corporation',
        ],
    },
    {
        code: 'O65B',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Europäische Gesellschaft (SE)',
        abbreviation: 'SE',
        active: true,
        aliases: ['Europäische Gesellschaft (SE)', 'SE'],
    },
    {
        code: 'O6AU',
        country: 'US',
        jurisdiction: 'US-CA',
        jurisdictionName: 'California',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'O6QP',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Domestic Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Partnership'],
    },
    {
        code: 'O786',
        country: 'MU',
        jurisdiction: 'MU',
        jurisdictionName: 'Mauritius',
        name: 'Société',
        abbreviation: 'SOCIETE;STE',
        active: true,
        aliases: ['Société', 'SOCIETE;STE'],
    },
    {
        code: 'O7AL',
        country: 'AR',
        jurisdiction: 'AR',
        jurisdictionName: 'Argentina',
        name: 'Sociedad de Garantía Reciproca',
        abbreviation: 'SGR',
        active: true,
        aliases: ['Sociedad de Garantía Reciproca', 'SGR'],
    },
    {
        code: 'O7LB',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Europeisk samvirkeforetak',
        abbreviation: 'SCE',
        active: true,
        aliases: ['Europeisk samvirkeforetak', 'SCE'],
    },
    {
        code: 'O7TC',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Spoločný podnik',
        abbreviation: '',
        active: true,
        aliases: ['Spoločný podnik'],
    },
    {
        code: 'O7XB',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'spółka z ograniczoną odpowiedzialnością',
        abbreviation: 'sp. z o.o.',
        active: true,
        aliases: ['spółka z ograniczoną odpowiedzialnością', 'sp. z o.o.'],
    },
    {
        code: 'O85W',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Company'],
    },
    {
        code: 'O8XV',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'O90R',
        country: 'CA',
        jurisdiction: 'CA-ON',
        jurisdictionName: 'Ontario',
        name: 'Business corporations (which includes professional corporations)',
        abbreviation: '',
        active: true,
        aliases: ['Business corporations (which includes professional corporations)'],
    },
    {
        code: 'O9MN',
        country: 'US',
        jurisdiction: 'US-WV',
        jurisdictionName: 'West Virginia',
        name: 'Business Trust',
        abbreviation: '',
        active: true,
        aliases: ['Business Trust'],
    },
    {
        code: 'O9PW',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Samosprávná stavovská organizace (profesní komora)',
        abbreviation: '',
        active: true,
        aliases: ['Samosprávná stavovská organizace (profesní komora)'],
    },
    {
        code: 'OA6N',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Sociedad Anónima',
        abbreviation: 'S.A.',
        active: true,
        aliases: ['Sociedad Anónima', 'S.A.'],
    },
    {
        code: 'OAGA',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Régime vieillesse ne dépendant pas du régime général de la Sécurité Sociale',
        abbreviation: '',
        active: true,
        aliases: ['Régime vieillesse ne dépendant pas du régime général de la Sécurité Sociale'],
    },
    {
        code: 'OAPE',
        country: 'NE',
        jurisdiction: 'NE',
        jurisdictionName: 'Niger',
        name: 'Société unipersonnelle à responsabilité limitée',
        abbreviation: 'SUARL',
        active: true,
        aliases: ['Société unipersonnelle à responsabilité limitée', 'SUARL'],
    },
    {
        code: 'OB5J',
        country: 'BR',
        jurisdiction: 'BR',
        jurisdictionName: 'Brazil',
        name: 'Empresa Individual de Responsabilidade Limitada',
        abbreviation: 'EIRELI',
        active: false,
        aliases: ['Empresa Individual de Responsabilidade Limitada', 'EIRELI'],
    },
    {
        code: 'OBFU',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Representative of an ownership in undivided shares',
        abbreviation: 'Undivided',
        active: true,
        aliases: [
            'Representative of an ownership in undivided shares',
            'Undivided',
            "Représentants d'indivisions",
            'Indivisions',
            'Haupt von Gemeinderschaften',
            "Rappresentanti d'indivisioni",
            'Indivisioni',
        ],
    },
    {
        code: 'OBTO',
        country: 'SR',
        jurisdiction: 'SR',
        jurisdictionName: 'Suriname',
        name: 'Commanditaire vennootschap (op aandelen) met een beherende vennoot',
        abbreviation: 'CV;cv;C.V.;c.v.',
        active: true,
        aliases: [
            'Commanditaire vennootschap (op aandelen) met een beherende vennoot',
            'CV;cv;C.V.;c.v.',
        ],
    },
    {
        code: 'OCIS',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Федеральные государственные унитарные предприятия',
        abbreviation: '',
        active: true,
        aliases: [
            'Федеральные государственные унитарные предприятия',
            "Federal'nyye gosudarstvennyye unitarnyye predpriyatiya",
        ],
    },
    {
        code: 'OCVJ',
        country: 'US',
        jurisdiction: 'US-MD',
        jurisdictionName: 'Maryland',
        name: 'Religious Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Religious Corporation'],
    },
    {
        code: 'OE6T',
        country: 'US',
        jurisdiction: 'US-VT',
        jurisdictionName: 'Vermont',
        name: 'Limited Liability Company (LLC)',
        abbreviation: 'LLC;Ltd Liability Co;LC;Ltd Co',
        active: true,
        aliases: ['Limited Liability Company (LLC)', 'LLC;Ltd Liability Co;LC;Ltd Co'],
    },
    {
        code: 'OESH',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Public Limited by Guarantee and having a Share Capital (1931 Act)',
        abbreviation: '',
        active: true,
        aliases: ['Public Limited by Guarantee and having a Share Capital (1931 Act)'],
    },
    {
        code: 'OF3Q',
        country: 'US',
        jurisdiction: 'US-VA',
        jurisdictionName: 'Virginia',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: 'OFGO',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'Business Trust',
        abbreviation: 'limited;LTD',
        active: true,
        aliases: ['Business Trust', 'limited;LTD'],
    },
    {
        code: 'OGHV',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Professional Corporation',
        abbreviation: 'corp.;inc.;PC;P.C.',
        active: true,
        aliases: ['Professional Corporation', 'corp.;inc.;PC;P.C.'],
    },
    {
        code: 'OGSS',
        country: 'US',
        jurisdiction: 'US-TX',
        jurisdictionName: 'Texas',
        name: 'Nonprofit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation'],
    },
    {
        code: 'OH9O',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '基层工会',
        abbreviation: '',
        active: true,
        aliases: ['基层工会', 'ji ceng gong hui'],
    },
    {
        code: 'OI5N',
        country: 'US',
        jurisdiction: 'US-NH',
        jurisdictionName: 'New Hampshire',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'OII5',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Egyéni ügyvéd',
        abbreviation: '',
        active: true,
        aliases: ['Egyéni ügyvéd'],
    },
    {
        code: 'OIQA',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Autre organisme professionnel',
        abbreviation: '',
        active: true,
        aliases: ['Autre organisme professionnel'],
    },
    {
        code: 'OJ9I',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Försäkringsaktiebolag',
        abbreviation: 'FAB',
        active: true,
        aliases: ['Försäkringsaktiebolag', 'FAB'],
    },
    {
        code: 'OJ9K',
        country: 'US',
        jurisdiction: 'US-NH',
        jurisdictionName: 'New Hampshire',
        name: 'Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Company'],
    },
    {
        code: 'OJBU',
        country: 'US',
        jurisdiction: 'US-WV',
        jurisdictionName: 'West Virginia',
        name: 'Unincorporated Non-Profit Association',
        abbreviation: '',
        active: true,
        aliases: ['Unincorporated Non-Profit Association'],
    },
    {
        code: 'OJDX',
        country: 'US',
        jurisdiction: 'US-OK',
        jurisdictionName: 'Oklahoma',
        name: 'Limited Liability Partnership',
        abbreviation: 'RLLP, LLP, R.L.L.P., L.L.P.',
        active: true,
        aliases: ['Limited Liability Partnership', 'RLLP, LLP, R.L.L.P., L.L.P.'],
    },
    {
        code: 'OK2B',
        country: 'US',
        jurisdiction: 'US-UT',
        jurisdictionName: 'Utah',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'OKAZ',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Obecný úrad',
        abbreviation: '',
        active: true,
        aliases: ['Obecný úrad'],
    },
    {
        code: 'OL20',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Einzelunternehmen, eingetragener Kaufmann, eingetragene Kauffrau',
        abbreviation: 'e. K.;eK;e. Kfm.;e. Kffr',
        active: true,
        aliases: [
            'Einzelunternehmen, eingetragener Kaufmann, eingetragene Kauffrau',
            'e. K.;eK;e. Kfm.;e. Kffr',
        ],
    },
    {
        code: 'OLAI',
        country: 'AW',
        jurisdiction: 'AW',
        jurisdictionName: 'Aruba',
        name: 'Vereniging',
        abbreviation: '',
        active: true,
        aliases: ['Vereniging'],
    },
    {
        code: 'OLJ1',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Syndicat mixte fermé',
        abbreviation: '',
        active: true,
        aliases: ['Syndicat mixte fermé'],
    },
    {
        code: 'OLTR',
        country: 'AM',
        jurisdiction: 'AM',
        jurisdictionName: 'Armenia',
        name: 'Բաց բաժնետիրական ընկերություն',
        abbreviation: 'ԲԲԸ',
        active: true,
        aliases: ['Բաց բաժնետիրական ընկերություն', 'Bacʿ bazhnetirakan enkerutʿyun', 'ԲԲԸ', 'BBĒ'],
    },
    {
        code: 'OMP4',
        country: 'VN',
        jurisdiction: 'VN',
        jurisdictionName: 'Viet Nam',
        name: 'công ty cổ phần',
        abbreviation: '',
        active: true,
        aliases: ['công ty cổ phần'],
    },
    {
        code: 'OMUD',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '其他（旅游）',
        abbreviation: '',
        active: true,
        aliases: ['其他（旅游）', 'qi ta（ lv you ）'],
    },
    {
        code: 'OMUP',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les clubs de récréation',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur les clubs de récréation'],
    },
    {
        code: 'OMX0',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'spółka komandytowo-akcyjna',
        abbreviation: 'S.K.A.',
        active: true,
        aliases: ['spółka komandytowo-akcyjna', 'S.K.A.'],
    },
    {
        code: 'ONF1',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Kommanditgesellschaft',
        abbreviation: 'KG',
        active: true,
        aliases: ['Kommanditgesellschaft', 'KG'],
    },
    {
        code: 'ONJ1',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Domestic Low-Profit Limited Liability Company',
        abbreviation: 'low-profit limited liability company;L3C',
        active: true,
        aliases: [
            'Domestic Low-Profit Limited Liability Company',
            'low-profit limited liability company;L3C',
        ],
    },
    {
        code: 'ONVA',
        country: 'TR',
        jurisdiction: 'TR',
        jurisdictionName: 'Türkiye',
        name: 'komandit şirket',
        abbreviation: 'Kom.Şti',
        active: true,
        aliases: ['komandit şirket', 'Kom.Şti'],
    },
    {
        code: 'OO14',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Islamic Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Islamic Limited Liability Partnership'],
    },
    {
        code: 'OOX5',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Benefit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Benefit Corporation'],
    },
    {
        code: 'OPDJ',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'komanditna družba',
        abbreviation: 'k.d.',
        active: true,
        aliases: ['komanditna družba', 'k.d.'],
    },
    {
        code: 'OPLQ',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Представительства юридических лиц',
        abbreviation: '',
        active: true,
        aliases: ['Представительства юридических лиц', "Predstavitel'stva yuridicheskikh lits"],
    },
    {
        code: 'OPRT',
        country: 'CA',
        jurisdiction: 'CA-MB',
        jurisdictionName: 'Manitoba',
        name: 'Limited Partnership',
        abbreviation: 'Limited Partnership;LP;SOCIETE EN COMMANDITE;limited partnership',
        active: true,
        aliases: [
            'Limited Partnership',
            'Limited Partnership;LP;SOCIETE EN COMMANDITE;limited partnership',
        ],
    },
    {
        code: 'OQ8C',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Fondo Pensione',
        abbreviation: '',
        active: true,
        aliases: ['Fondo Pensione'],
    },
    {
        code: 'OQWO',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Društvo s ograničenom odgovornošću (jednostavno društvo s ograničenom odgovornošću)',
        abbreviation: 'd.o.o.;j.d.o.o',
        active: true,
        aliases: [
            'Društvo s ograničenom odgovornošću (jednostavno društvo s ograničenom odgovornošću)',
            'd.o.o.;j.d.o.o',
        ],
    },
    {
        code: 'OR18',
        country: 'QA',
        jurisdiction: 'QA',
        jurisdictionName: 'Qatar',
        name: 'شركة التضامن',
        abbreviation: '',
        active: true,
        aliases: ['شركة التضامن', 'Sharikat Altadamun'],
    },
    {
        code: 'OSBR',
        country: 'KY',
        jurisdiction: 'KY',
        jurisdictionName: 'Cayman Islands',
        name: 'company limited by shares',
        abbreviation: 'Ltd',
        active: true,
        aliases: ['company limited by shares', 'Ltd'],
    },
    {
        code: 'OSE2',
        country: 'AE',
        jurisdiction: 'AE-AZ',
        jurisdictionName: 'Abu Dhabi',
        name: 'Private Company Limited by Shares',
        abbreviation: '',
        active: true,
        aliases: ['Private Company Limited by Shares'],
    },
    {
        code: 'OSLZ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société coopérative de banque populaire',
        abbreviation: '',
        active: true,
        aliases: ['Société coopérative de banque populaire'],
    },
    {
        code: 'OT3Y',
        country: 'GG',
        jurisdiction: 'GG',
        jurisdictionName: 'Guernsey',
        name: 'company limited by guarantee',
        abbreviation: 'LBG',
        active: true,
        aliases: ['company limited by guarantee', 'LBG'],
    },
    {
        code: 'OTC0',
        country: 'TV',
        jurisdiction: 'TV',
        jurisdictionName: 'Tuvalu',
        name: 'co-operative society',
        abbreviation: '',
        active: true,
        aliases: ['co-operative society'],
    },
    {
        code: 'OTE3',
        country: 'KN',
        jurisdiction: 'KN-N',
        jurisdictionName: 'Nevis',
        name: 'exempt limited partnership',
        abbreviation: '',
        active: true,
        aliases: ['exempt limited partnership'],
    },
    {
        code: 'OTU7',
        country: 'CA',
        jurisdiction: 'CA-BC',
        jurisdictionName: 'British Columbia',
        name: 'Extraprovincial non-share corporation',
        abbreviation: '',
        active: true,
        aliases: ['Extraprovincial non-share corporation'],
    },
    {
        code: 'OV32',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società A Responsabilità Limitata',
        abbreviation: 'SRL;S.R.L.',
        active: true,
        aliases: ['Società A Responsabilità Limitata', 'SRL;S.R.L.'],
    },
    {
        code: 'OVBT',
        country: 'US',
        jurisdiction: 'US-AK',
        jurisdictionName: 'Alaska',
        name: 'Professional Corporation',
        abbreviation: 'P.C.',
        active: true,
        aliases: ['Professional Corporation', 'P.C.'],
    },
    {
        code: 'OVCL',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'OVKW',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Vysoká škola (veřejná, státní)',
        abbreviation: '',
        active: true,
        aliases: ['Vysoká škola (veřejná, státní)'],
    },
    {
        code: 'OVLN',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Унитарные предприятия, основанные на праве оперативного управления (казенные предприятия)',
        abbreviation: '',
        active: true,
        aliases: [
            'Унитарные предприятия, основанные на праве оперативного управления (казенные предприятия)',
            'Unitarnyye predpriyatiya, osnovannyye na prave operativnogo upravleniya (kazennyye predpriyatiya)',
        ],
    },
    {
        code: 'OWR6',
        country: 'US',
        jurisdiction: 'US-CO',
        jurisdictionName: 'Colorado',
        name: 'For-Profit Corporation',
        abbreviation: 'Corporation;Incorporated;Company;Limited;Corp.;Inc.;Co.;Ltd.',
        active: true,
        aliases: [
            'For-Profit Corporation',
            'Corporation;Incorporated;Company;Limited;Corp.;Inc.;Co.;Ltd.',
        ],
    },
    {
        code: 'OWUN',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Communauté de communes',
        abbreviation: '',
        active: true,
        aliases: ['Communauté de communes'],
    },
    {
        code: 'OXAZ',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Insurance Corporations',
        abbreviation: '',
        active: true,
        aliases: ['Insurance Corporations'],
    },
    {
        code: 'OXLO',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Valtion liikelaitos',
        abbreviation: '',
        active: true,
        aliases: ['Valtion liikelaitos', 'Statlig affärsinrättning'],
    },
    {
        code: 'OXUC',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Sociedade em Comandita',
        abbreviation: '',
        active: true,
        aliases: ['Sociedade em Comandita'],
    },
    {
        code: 'OYDA',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Pension Fund',
        abbreviation: '',
        active: true,
        aliases: ['Pension Fund'],
    },
    {
        code: 'OZ3O',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima promotora de inversión bursátil',
        abbreviation: 'S.A. P.I. B.',
        active: true,
        aliases: ['Sociedad anónima promotora de inversión bursátil', 'S.A. P.I. B.'],
    },
    {
        code: 'OZDY',
        country: 'XK',
        jurisdiction: 'XK',
        jurisdictionName: 'Kosovo',
        name: 'Dega e Shoqërisë së Huaj Tregtare në Kosovë',
        abbreviation: 'Kompani e Huaj',
        active: true,
        aliases: ['Dega e Shoqërisë së Huaj Tregtare në Kosovë', 'Kompani e Huaj'],
    },
    {
        code: 'P0LR',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Company (Unlimited)',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Company (Unlimited)'],
    },
    {
        code: 'P0TZ',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Limited Liability Partnerships',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Limited Liability Partnerships'],
    },
    {
        code: 'P12B',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Ταμεία Προνοίας/ Συντάξεως',
        abbreviation: '',
        active: true,
        aliases: ['Ταμεία Προνοίας/ Συντάξεως', 'Tameia Pronoias/ Syntaxeos'],
    },
    {
        code: 'P1L1',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'główny oddział zagranicznego zakładu ubezpieczeń',
        abbreviation: '',
        active: true,
        aliases: ['główny oddział zagranicznego zakładu ubezpieczeń'],
    },
    {
        code: 'P1VP',
        country: 'US',
        jurisdiction: 'US-ME',
        jurisdictionName: 'Maine',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'P24O',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'Business Trust',
        abbreviation: '',
        active: true,
        aliases: ['Business Trust'],
    },
    {
        code: 'P28E',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, sociedad financiera de objeto múltiple, entidad regulada',
        abbreviation: 'S.A. de C.V., SOFOM E.R.',
        active: true,
        aliases: [
            'Sociedad anónima de capital variable, sociedad financiera de objeto múltiple, entidad regulada',
            'S.A. de C.V., SOFOM E.R.',
        ],
    },
    {
        code: 'P2B9',
        country: 'KR',
        jurisdiction: 'KR',
        jurisdictionName: 'Korea (Republic of)',
        name: '일반 법인 재단',
        abbreviation: '',
        active: true,
        aliases: ['일반 법인 재단', 'Ilban beobin jaedan'],
    },
    {
        code: 'P2R9',
        country: 'NZ',
        jurisdiction: 'NZ',
        jurisdictionName: 'New Zealand',
        name: 'Limited Liability Company',
        abbreviation: 'Ltd;Ltd.;Limited',
        active: true,
        aliases: ['Limited Liability Company', 'Ltd;Ltd.;Limited'],
    },
    {
        code: 'P3J5',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Centre communal d'action sociale",
        abbreviation: '',
        active: true,
        aliases: ["Centre communal d'action sociale"],
    },
    {
        code: 'P3LZ',
        country: 'US',
        jurisdiction: 'US-NH',
        jurisdictionName: 'New Hampshire',
        name: 'Nonprofit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation'],
    },
    {
        code: 'P3YF',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Pobočná odborová organizace a organizace zaměstnavatelů',
        abbreviation: '',
        active: false,
        aliases: ['Pobočná odborová organizace a organizace zaměstnavatelů'],
    },
    {
        code: 'P3YJ',
        country: 'SC',
        jurisdiction: 'SC',
        jurisdictionName: 'Seychelles',
        name: 'Unlimited Company',
        abbreviation: '',
        active: true,
        aliases: ['Unlimited Company'],
    },
    {
        code: 'P418',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società Per Azioni',
        abbreviation: 'SPA;S.P.A.',
        active: true,
        aliases: ['Società Per Azioni', 'SPA;S.P.A.'],
    },
    {
        code: 'P53M',
        country: 'PE',
        jurisdiction: 'PE',
        jurisdictionName: 'Peru',
        name: 'Cooperativas',
        abbreviation: '',
        active: true,
        aliases: ['Cooperativas'],
    },
    {
        code: 'P5JT',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Ευρωπαϊκός Όμιλος Οικονομικού Σκοπού',
        abbreviation: 'ΕΟΟΣ',
        active: true,
        aliases: ['Ευρωπαϊκός Όμιλος Οικονομικού Σκοπού', 'ΕΟΟΣ'],
    },
    {
        code: 'P5S3',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Pessoa Coletiva de Direito Público',
        abbreviation: '',
        active: true,
        aliases: ['Pessoa Coletiva de Direito Público'],
    },
    {
        code: 'P65N',
        country: 'AW',
        jurisdiction: 'AW',
        jurisdictionName: 'Aruba',
        name: 'Naamloze vennootschap',
        abbreviation: 'NV;nv;N.V.;n.v.',
        active: true,
        aliases: ['Naamloze vennootschap', 'NV;nv;N.V.;n.v.'],
    },
    {
        code: 'P6XJ',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Podnik alebo hospodárske zariadenie politickej strany',
        abbreviation: 'Podnik alebo hosp.zar.',
        active: true,
        aliases: ['Podnik alebo hospodárske zariadenie politickej strany', 'Podnik alebo hosp.zar.'],
    },
    {
        code: 'P714',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Association fonciére de remembrement',
        abbreviation: '',
        active: true,
        aliases: ['Association fonciére de remembrement'],
    },
    {
        code: 'P7RH',
        country: 'US',
        jurisdiction: 'US-NJ',
        jurisdictionName: 'New Jersey',
        name: 'Limited Liability Company',
        abbreviation: 'L.L.C.;LLC',
        active: true,
        aliases: ['Limited Liability Company', 'L.L.C.;LLC'],
    },
    {
        code: 'P7VS',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima institución de fianzas',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima institución de fianzas'],
    },
    {
        code: 'P864',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Sociedad de Responsabilidad Limitada o Sociedad Limitada',
        abbreviation: 'S.R.L.;S.L.',
        active: true,
        aliases: ['Sociedad de Responsabilidad Limitada o Sociedad Limitada', 'S.R.L.;S.L.'],
    },
    {
        code: 'P8D7',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima institución de banca múltiple',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima institución de banca múltiple'],
    },
    {
        code: 'P91Q',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'P9CF',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Индивидуальные предприниматели',
        abbreviation: '',
        active: true,
        aliases: ['Индивидуальные предприниматели', "Individual'nyye predprinimateli"],
    },
    {
        code: 'P9F2',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Korlátolt felelősségű társaság',
        abbreviation: 'Kft.',
        active: true,
        aliases: ['Korlátolt felelősségű társaság', 'Kft.'],
    },
    {
        code: 'PA5X',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Ассоциации (союзы) экономического взаимодействия субъектов Российской Федерации',
        abbreviation: '',
        active: true,
        aliases: [
            'Ассоциации (союзы) экономического взаимодействия субъектов Российской Федерации',
            'Assotsiatsii (soyuzy) ekonomicheskogo vzaimodeystviya sub"yektov Rossiyskoy Federatsii',
        ],
    },
    {
        code: 'PAVK',
        country: 'AM',
        jurisdiction: 'AM',
        jurisdictionName: 'Armenia',
        name: 'Հասարակական Կազմակեպություն',
        abbreviation: 'ՀԿ',
        active: true,
        aliases: ['Հասարակական Կազմակեպություն', 'Hasarakakan Kazmakepʿutʿyun', 'ՀԿ', 'HK'],
    },
    {
        code: 'PB3V',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Konkursbo',
        abbreviation: '',
        active: true,
        aliases: ['Konkursbo'],
    },
    {
        code: 'PB7W',
        country: 'BS',
        jurisdiction: 'BS',
        jurisdictionName: 'Bahamas',
        name: 'Company Limited by Guarantee',
        abbreviation: 'Ltd',
        active: true,
        aliases: ['Company Limited by Guarantee', 'Ltd'],
    },
    {
        code: 'PBQH',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Trust',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Trust'],
    },
    {
        code: 'PC5A',
        country: 'BR',
        jurisdiction: 'BR',
        jurisdictionName: 'Brazil',
        name: 'Sociedade Cooperativa',
        abbreviation: '',
        active: true,
        aliases: ['Sociedade Cooperativa'],
    },
    {
        code: 'PCO0',
        country: 'CA',
        jurisdiction: 'CA-ON',
        jurisdictionName: 'Ontario',
        name: 'Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Partnership'],
    },
    {
        code: 'PCRJ',
        country: 'AW',
        jurisdiction: 'AW',
        jurisdictionName: 'Aruba',
        name: 'Cooperatieve vereniging',
        abbreviation: '',
        active: true,
        aliases: ['Cooperatieve vereniging'],
    },
    {
        code: 'PDLV',
        country: 'US',
        jurisdiction: 'US-CO',
        jurisdictionName: 'Colorado',
        name: 'Non-Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Non-Profit Corporation'],
    },
    {
        code: 'PDNU',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'eingetragene Gesellschaft bürgerlichen Rechts',
        abbreviation: 'eGbR',
        active: true,
        aliases: ['eingetragene Gesellschaft bürgerlichen Rechts', 'eGbR'],
    },
    {
        code: 'PDQ0',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Kooperativ hyresrättsförening',
        abbreviation: 'KHF',
        active: true,
        aliases: ['Kooperativ hyresrättsförening', 'KHF'],
    },
    {
        code: 'PDQC',
        country: 'IL',
        jurisdiction: 'IL',
        jurisdictionName: 'Israel',
        name: 'חברה פרטית בע"מ',
        abbreviation: '',
        active: true,
        aliases: ['חברה פרטית בע"מ', "Chevra Pratit Ba'am"],
    },
    {
        code: 'PDYW',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Сельскохозяйственные потребительские садоводческие кооперативы',
        abbreviation: '',
        active: true,
        aliases: [
            'Сельскохозяйственные потребительские садоводческие кооперативы',
            "Sel'skokhozyaystvennyye potrebitel'skiye sadovodcheskiye kooperativy",
        ],
    },
    {
        code: 'PE9A',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Federatja',
        abbreviation: '',
        active: true,
        aliases: ['Federatja'],
    },
    {
        code: 'PESN',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Indivision avec personne morale',
        abbreviation: '',
        active: true,
        aliases: ['Indivision avec personne morale'],
    },
    {
        code: 'PFE5',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Městská část, městský obvod',
        abbreviation: '',
        active: true,
        aliases: ['Městská část, městský obvod'],
    },
    {
        code: 'PFPW',
        country: 'CA',
        jurisdiction: 'CA-PE',
        jurisdictionName: 'Prince Edward Island',
        name: 'private limited corporation',
        abbreviation: 'Ltd.;Inc.;Corp.;Ltée',
        active: true,
        aliases: ['private limited corporation', 'Ltd.;Inc.;Corp.;Ltée'],
    },
    {
        code: 'PFY0',
        country: 'JM',
        jurisdiction: 'JM',
        jurisdictionName: 'Jamaica',
        name: 'partnership',
        abbreviation: '',
        active: true,
        aliases: ['partnership'],
    },
    {
        code: 'PG49',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Confederación de sindicatos',
        abbreviation: '',
        active: true,
        aliases: ['Confederación de sindicatos'],
    },
    {
        code: 'PH5T',
        country: 'GH',
        jurisdiction: 'GH',
        jurisdictionName: 'Ghana',
        name: 'Public Unlimited Company',
        abbreviation: '',
        active: true,
        aliases: ['Public Unlimited Company'],
    },
    {
        code: 'PHMS',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Cooperativa Sociale',
        abbreviation: '',
        active: true,
        aliases: ['Cooperativa Sociale'],
    },
    {
        code: 'PICJ',
        country: 'BS',
        jurisdiction: 'BS',
        jurisdictionName: 'Bahamas',
        name: 'Non-Profit Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-Profit Company'],
    },
    {
        code: 'PIDC',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Empresa Municipal',
        abbreviation: '',
        active: true,
        aliases: ['Empresa Municipal'],
    },
    {
        code: 'PIDT',
        country: 'CA',
        jurisdiction: 'CA-NT',
        jurisdictionName: 'Northwest Territories',
        name: 'NT corporation',
        abbreviation: 'Ltd.;Ltée.;Inc.;Corp.;Ltd;Limited',
        active: true,
        aliases: ['NT corporation', 'Ltd.;Ltée.;Inc.;Corp.;Ltd;Limited'],
    },
    {
        code: 'PIL2',
        country: 'MC',
        jurisdiction: 'MC',
        jurisdictionName: 'Monaco',
        name: 'Société en Commandite par Actions',
        abbreviation: 'SCA',
        active: true,
        aliases: ['Société en Commandite par Actions', 'SCA'],
    },
    {
        code: 'PIOI',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Erhvervsdrivende fond',
        abbreviation: '',
        active: true,
        aliases: ['Erhvervsdrivende fond'],
    },
    {
        code: 'PITR',
        country: 'AZ',
        jurisdiction: 'AZ',
        jurisdictionName: 'Azerbaijan',
        name: 'Hüquqi şəxslərin ittifaqları',
        abbreviation: '',
        active: true,
        aliases: ['Hüquqi şəxslərin ittifaqları'],
    },
    {
        code: 'PJ10',
        country: 'US',
        jurisdiction: 'US-NY',
        jurisdictionName: 'New York',
        name: 'Business Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Business Corporation'],
    },
    {
        code: 'PJ29',
        country: 'BO',
        jurisdiction: 'BO',
        jurisdictionName: 'Bolivia (Plurinational State of)',
        name: 'Sociedad en Comandita por Acciones.',
        abbreviation: 'S.C.A.',
        active: true,
        aliases: ['Sociedad en Comandita por Acciones.', 'S.C.A.'],
    },
    {
        code: 'PJRZ',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Нотариальные палаты',
        abbreviation: '',
        active: true,
        aliases: ['Нотариальные палаты', "Notarial'nyye palaty"],
    },
    {
        code: 'PKAN',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'fonds voor bestaanszekerheid',
        abbreviation: '',
        active: true,
        aliases: [
            'fonds voor bestaanszekerheid',
            "fonds de sécurité d'existence",
            'Fonds für Existenzsicherheit',
        ],
    },
    {
        code: 'PKBG',
        country: 'NG',
        jurisdiction: 'NG',
        jurisdictionName: 'Nigeria',
        name: 'Public company limited by shares',
        abbreviation: 'Ltd',
        active: true,
        aliases: ['Public company limited by shares', 'Ltd'],
    },
    {
        code: 'PKOR',
        country: 'TV',
        jurisdiction: 'TV',
        jurisdictionName: 'Tuvalu',
        name: 'public company',
        abbreviation: 'LTD',
        active: true,
        aliases: ['public company', 'LTD'],
    },
    {
        code: 'PKRY',
        country: 'PE',
        jurisdiction: 'PE',
        jurisdictionName: 'Peru',
        name: 'Socieda Anónima Abierta',
        abbreviation: 'SAA',
        active: true,
        aliases: ['Socieda Anónima Abierta', 'SAA'],
    },
    {
        code: 'PKZ2',
        country: 'VI',
        jurisdiction: 'VI',
        jurisdictionName: 'Virgin Islands (U.S.)',
        name: 'Domestic Non-Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Non-Profit Corporation'],
    },
    {
        code: 'PL6V',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Établissement public local culturel',
        abbreviation: '',
        active: true,
        aliases: ['Établissement public local culturel'],
    },
    {
        code: 'PLMC',
        country: 'US',
        jurisdiction: 'US-VA',
        jurisdictionName: 'Virginia',
        name: 'Nonstock Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonstock Corporation'],
    },
    {
        code: 'PLZ6',
        country: 'AR',
        jurisdiction: 'AR',
        jurisdictionName: 'Argentina',
        name: 'Sociedad en Comandita por Acciones',
        abbreviation: 'S.C.p.A.',
        active: true,
        aliases: ['Sociedad en Comandita por Acciones', 'S.C.p.A.'],
    },
    {
        code: 'PM3Y',
        country: 'US',
        jurisdiction: 'US-WA',
        jurisdictionName: 'Washington',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'PM48',
        country: 'BO',
        jurisdiction: 'BO',
        jurisdictionName: 'Bolivia (Plurinational State of)',
        name: 'Sociedad de Responsabilidad Limitada.',
        abbreviation: 'S.R.L.',
        active: true,
        aliases: ['Sociedad de Responsabilidad Limitada.', 'S.R.L.'],
    },
    {
        code: 'PMJW',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Andelsselskab',
        abbreviation: '',
        active: true,
        aliases: ['Andelsselskab'],
    },
    {
        code: 'PMOF',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Loomeliit',
        abbreviation: '',
        active: true,
        aliases: ['Loomeliit'],
    },
    {
        code: 'PNF3',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Corporate Credit Union',
        abbreviation: '',
        active: true,
        aliases: ['Corporate Credit Union'],
    },
    {
        code: 'PNSZ',
        country: 'US',
        jurisdiction: 'US-SC',
        jurisdictionName: 'South Carolina',
        name: 'Benefit Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.',
        active: true,
        aliases: ['Benefit Corporation', 'corp.;inc.;co.;ltd.'],
    },
    {
        code: 'PNX6',
        country: 'AE',
        jurisdiction: 'AE-AZ',
        jurisdictionName: 'Abu Dhabi',
        name: 'Incorporated Cell Company',
        abbreviation: '',
        active: false,
        aliases: ['Incorporated Cell Company'],
    },
    {
        code: 'PNZI',
        country: 'US',
        jurisdiction: 'US-VT',
        jurisdictionName: 'Vermont',
        name: 'Non-profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Non-profit Corporation'],
    },
    {
        code: 'POG3',
        country: 'US',
        jurisdiction: 'US-NM',
        jurisdictionName: 'New Mexico',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'PPMX',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Avoin yhtiö',
        abbreviation: '',
        active: true,
        aliases: ['Avoin yhtiö', 'Öppet bolag'],
    },
    {
        code: 'PQHL',
        country: 'AU',
        jurisdiction: 'AU',
        jurisdictionName: 'Australia',
        name: 'No Liability Company',
        abbreviation: 'No Liability;NL',
        active: true,
        aliases: ['No Liability Company', 'No Liability;NL'],
    },
    {
        code: 'PQJE',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Mezinárodní nevládní organizace',
        abbreviation: '',
        active: true,
        aliases: ['Mezinárodní nevládní organizace'],
    },
    {
        code: 'PQXK',
        country: 'US',
        jurisdiction: 'US-OK',
        jurisdictionName: 'Oklahoma',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP'],
    },
    {
        code: 'PRTB',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Mittetulundusühing',
        abbreviation: 'MTÜ',
        active: true,
        aliases: ['Mittetulundusühing', 'MTÜ'],
    },
    {
        code: 'PT6C',
        country: 'AW',
        jurisdiction: 'AW',
        jurisdictionName: 'Aruba',
        name: 'Eenmanszaak',
        abbreviation: '',
        active: true,
        aliases: ['Eenmanszaak'],
    },
    {
        code: 'PT6M',
        country: 'SA',
        jurisdiction: 'SA',
        jurisdictionName: 'Saudi Arabia',
        name: 'شركات أموال',
        abbreviation: '',
        active: true,
        aliases: ['شركات أموال', "sharikat 'amwal"],
    },
    {
        code: 'PUJR',
        country: 'US',
        jurisdiction: 'US-WY',
        jurisdictionName: 'Wyoming',
        name: 'Nonprofit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation'],
    },
    {
        code: 'PVT3',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Eenpersoons besloten vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk',
        abbreviation: 'EBVBA SO',
        active: true,
        aliases: [
            'Eenpersoons besloten vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk',
            'EBVBA SO',
            'Société privée à responsabilité limitée unipersonnelle à finalité sociale',
            'SPRLU FS',
            'Privatgesellschaft mit beschränkter Haftung mit sozialer Zielsetzung mit einem Alleingesellschafter',
            'PgbHsZ',
        ],
    },
    {
        code: 'PW3Y',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Акционерно дружество със специална инвестиционна цел',
        abbreviation: 'АДСИЦ',
        active: true,
        aliases: [
            'Акционерно дружество със специална инвестиционна цел',
            'Aktsionerno druzhestvo sas spetsialna investitsionna tsel',
            'АДСИЦ',
            'ADSIC',
        ],
    },
    {
        code: 'PWKL',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Congrégation',
        abbreviation: '',
        active: true,
        aliases: ['Congrégation'],
    },
    {
        code: 'PWX8',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Islamic Foundation',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Islamic Foundation'],
    },
    {
        code: 'PX29',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Iná právnicka osoba',
        abbreviation: '',
        active: true,
        aliases: ['Iná právnicka osoba'],
    },
    {
        code: 'PXGA',
        country: 'US',
        jurisdiction: 'US-WV',
        jurisdictionName: 'West Virginia',
        name: 'Corporation (non-profit)',
        abbreviation: '',
        active: true,
        aliases: ['Corporation (non-profit)'],
    },
    {
        code: 'PXNI',
        country: 'US',
        jurisdiction: 'US-SD',
        jurisdictionName: 'South Dakota',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'PXPK',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'private recreation company',
        abbreviation: '',
        active: true,
        aliases: ['private recreation company'],
    },
    {
        code: 'PY5Y',
        country: 'PA',
        jurisdiction: 'PA',
        jurisdictionName: 'Panama',
        name: 'Sociedad en Comandita por acciones',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad en Comandita por acciones'],
    },
    {
        code: 'PZ6Y',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Andelsselskab med begrænset ansvar',
        abbreviation: 'AMBA',
        active: true,
        aliases: ['Andelsselskab med begrænset ansvar', 'AMBA'],
    },
    {
        code: 'PZCW',
        country: 'KW',
        jurisdiction: 'KW',
        jurisdictionName: 'Kuwait',
        name: 'شركة التوصية بالأسهم',
        abbreviation: '',
        active: true,
        aliases: ['شركة التوصية بالأسهم', "Wasiat alshirakat min qibal sharikat al'ashum"],
    },
    {
        code: 'PZLG',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Métropole',
        abbreviation: '',
        active: true,
        aliases: ['Métropole'],
    },
    {
        code: 'PZR6',
        country: 'US',
        jurisdiction: 'US-CA',
        jurisdictionName: 'California',
        name: 'For-Profit Corporation Professional',
        abbreviation: 'PC',
        active: true,
        aliases: ['For-Profit Corporation Professional', 'PC'],
    },
    {
        code: 'PZV3',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Gemeinderschaft',
        abbreviation: '',
        active: true,
        aliases: ['Gemeinderschaft'],
    },
    {
        code: 'Q0M5',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Unregistered Company',
        abbreviation: '',
        active: true,
        aliases: ['Unregistered Company'],
    },
    {
        code: 'Q0Q1',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Selskap med begrenset ansvar',
        abbreviation: 'BA',
        active: true,
        aliases: ['Selskap med begrenset ansvar', 'BA'],
    },
    {
        code: 'Q17J',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'Q1J0',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Sociedad Contractual Minera',
        abbreviation: 'SCM',
        active: true,
        aliases: ['Sociedad Contractual Minera', 'SCM'],
    },
    {
        code: 'Q1N4',
        country: 'US',
        jurisdiction: 'US-UT',
        jurisdictionName: 'Utah',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP'],
    },
    {
        code: 'Q22D',
        country: 'XK',
        jurisdiction: 'XK',
        jurisdictionName: 'Kosovo',
        name: 'Shoqëri aksionare',
        abbreviation: 'SHA',
        active: true,
        aliases: ['Shoqëri aksionare', 'SHA'],
    },
    {
        code: 'Q25I',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Odborová organizace a organizace zaměstnavatelů',
        abbreviation: '',
        active: false,
        aliases: ['Odborová organizace a organizace zaměstnavatelů'],
    },
    {
        code: 'Q28E',
        country: 'US',
        jurisdiction: 'US-VA',
        jurisdictionName: 'Virginia',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'Q2A1',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société commerciale étrangère immatriculée au RCS',
        abbreviation: '',
        active: false,
        aliases: ['Société commerciale étrangère immatriculée au RCS'],
    },
    {
        code: 'Q2EV',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Evropsko gospodarsko interesno združenje',
        abbreviation: 'EGIZ',
        active: true,
        aliases: ['Evropsko gospodarsko interesno združenje', 'EGIZ'],
    },
    {
        code: 'Q367',
        country: 'VI',
        jurisdiction: 'VI',
        jurisdictionName: 'Virgin Islands (U.S.)',
        name: 'Foreign Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Limited Liability Partnership'],
    },
    {
        code: 'Q3NF',
        country: 'US',
        jurisdiction: 'US-AR',
        jurisdictionName: 'Arkansas',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'Q49K',
        country: 'GG',
        jurisdiction: 'GG',
        jurisdictionName: 'Guernsey',
        name: 'Limited Liability Partnership',
        abbreviation: 'LLP',
        active: true,
        aliases: ['Limited Liability Partnership', 'LLP'],
    },
    {
        code: 'Q4A3',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Prekybos, pramonės ir amatų rūmai',
        abbreviation: 'PER',
        active: true,
        aliases: ['Prekybos, pramonės ir amatų rūmai', 'PER'],
    },
    {
        code: 'Q4BE',
        country: 'NZ',
        jurisdiction: 'NZ',
        jurisdictionName: 'New Zealand',
        name: 'government entity',
        abbreviation: '',
        active: true,
        aliases: ['government entity'],
    },
    {
        code: 'Q4F9',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Mutual Association',
        abbreviation: 'corp.;inc.;co.;ltd. Incorporated;company;limited;corporation',
        active: true,
        aliases: ['Mutual Association', 'corp.;inc.;co.;ltd. Incorporated;company;limited;corporation'],
    },
    {
        code: 'Q4J1',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Mutual de Ahorro y Préstamo',
        abbreviation: '',
        active: true,
        aliases: ['Mutual de Ahorro y Préstamo'],
    },
    {
        code: 'Q62B',
        country: 'VG',
        jurisdiction: 'VG',
        jurisdictionName: 'Virgin Islands (British)',
        name: 'unlimited company that is authorised to issue shares',
        abbreviation: 'Unltd',
        active: true,
        aliases: ['unlimited company that is authorised to issue shares', 'Unltd'],
    },
    {
        code: 'Q634',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Indivision entre personnes physiques',
        abbreviation: '',
        active: true,
        aliases: ['Indivision entre personnes physiques'],
    },
    {
        code: 'Q6EM',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'L3C',
        abbreviation: 'L3C',
        active: true,
        aliases: ['L3C'],
    },
    {
        code: 'Q6K2',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'Q7WY',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, almacén general de depósito, organización auxiliar del crédito',
        abbreviation: '',
        active: true,
        aliases: [
            'Sociedad anónima de capital variable, almacén general de depósito, organización auxiliar del crédito',
        ],
    },
    {
        code: 'Q82Q',
        country: 'AU',
        jurisdiction: 'AU',
        jurisdictionName: 'Australia',
        name: 'Unlimited Proprietary Company',
        abbreviation: 'Proprietary;PTY;PTY.;Pty.;Pty Ltd',
        active: true,
        aliases: ['Unlimited Proprietary Company', 'Proprietary;PTY;PTY.;Pty.;Pty Ltd'],
    },
    {
        code: 'Q89X',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Sindicatul',
        abbreviation: '',
        active: true,
        aliases: ['Sindicatul'],
    },
    {
        code: 'Q8E2',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société en nom collectif coopérative',
        abbreviation: '',
        active: true,
        aliases: ['Société en nom collectif coopérative'],
    },
    {
        code: 'Q8NY',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les syndicats professionnels',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur les syndicats professionnels'],
    },
    {
        code: 'Q8RV',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Foreign Benefit Corporation',
        abbreviation: 'A Benefit Corporation',
        active: true,
        aliases: ['Foreign Benefit Corporation', 'A Benefit Corporation'],
    },
    {
        code: 'Q8UI',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Nuolatinės arbitražo institucijos',
        abbreviation: 'NA',
        active: true,
        aliases: ['Nuolatinės arbitražo institucijos', 'NA'],
    },
    {
        code: 'Q9FA',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Межправительственные международные организации',
        abbreviation: '',
        active: true,
        aliases: [
            'Межправительственные международные организации',
            "Mezhpravitel'stvennyye mezhdunarodnyye organizatsii",
        ],
    },
    {
        code: 'Q9VK',
        country: 'SC',
        jurisdiction: 'SC',
        jurisdictionName: 'Seychelles',
        name: 'Protected Cell Company',
        abbreviation: 'PCC',
        active: true,
        aliases: ['Protected Cell Company', 'PCC'],
    },
    {
        code: 'Q9Y1',
        country: 'BB',
        jurisdiction: 'BB',
        jurisdictionName: 'Barbados',
        name: 'international business company',
        abbreviation: '',
        active: true,
        aliases: ['international business company'],
    },
    {
        code: 'QA1T',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'savings bank',
        abbreviation: '',
        active: true,
        aliases: ['savings bank'],
    },
    {
        code: 'QACV',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Spotrebné družstvo',
        abbreviation: '',
        active: true,
        aliases: ['Spotrebné družstvo'],
    },
    {
        code: 'QAEW',
        country: 'MY',
        jurisdiction: 'MY',
        jurisdictionName: 'Malaysia',
        name: 'Society / Association',
        abbreviation: '',
        active: true,
        aliases: ['Society / Association', 'Pertubuhan'],
    },
    {
        code: 'QAUY',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad de producción rural de responsabilidad limitada',
        abbreviation: 'SPR',
        active: true,
        aliases: ['Sociedad de producción rural de responsabilidad limitada', 'SPR'],
    },
    {
        code: 'QB0A',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Business Trust',
        abbreviation: '',
        active: true,
        aliases: ['Business Trust'],
    },
    {
        code: 'QB2W',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Coopérative',
        abbreviation: 'coopérative;coopératif;coopération;coop',
        active: true,
        aliases: [
            'Coopérative',
            'coopérative;coopératif;coopération;coop',
            'cooperative;cooperation;coop',
        ],
    },
    {
        code: 'QCA0',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Ιδιωτική Κεφαλαιουχική Εταιρία',
        abbreviation: 'IKE',
        active: true,
        aliases: ['Ιδιωτική Κεφαλαιουχική Εταιρία', 'Idiotiki kefaleouhiki Eteria', 'IKE'],
    },
    {
        code: 'QCJ9',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Spoločnosť komanditná na akcie',
        abbreviation: 'Spol. kom. na akcie',
        active: true,
        aliases: ['Spoločnosť komanditná na akcie', 'Spol. kom. na akcie'],
    },
    {
        code: 'QCRH',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Хозяйственные общества',
        abbreviation: '',
        active: true,
        aliases: ['Хозяйственные общества', 'Khozyaystvennyye obshchestva'],
    },
    {
        code: 'QCSO',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Multistate Cooperative Society',
        abbreviation: '',
        active: true,
        aliases: ['Multistate Cooperative Society'],
    },
    {
        code: 'QCWO',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Groupement agricole d'exploitation en commun (GAEC)",
        abbreviation: '',
        active: true,
        aliases: ["Groupement agricole d'exploitation en commun (GAEC)"],
    },
    {
        code: 'QDZK',
        country: 'US',
        jurisdiction: 'US-WV',
        jurisdictionName: 'West Virginia',
        name: 'Cooperative Association',
        abbreviation: 'corp.;inc.;co.;ltd.;co-op',
        active: true,
        aliases: ['Cooperative Association', 'corp.;inc.;co.;ltd.;co-op'],
    },
    {
        code: 'QEEJ',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'Professional Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Professional Limited Liability Company'],
    },
    {
        code: 'QF4W',
        country: 'US',
        jurisdiction: 'US-DE',
        jurisdictionName: 'Delaware',
        name: 'Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Partnership'],
    },
    {
        code: 'QF8K',
        country: 'NZ',
        jurisdiction: 'NZ',
        jurisdictionName: 'New Zealand',
        name: 'Sole Trader',
        abbreviation: '',
        active: true,
        aliases: ['Sole Trader'],
    },
    {
        code: 'QFGM',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Потребительские кооперативы',
        abbreviation: '',
        active: true,
        aliases: ['Потребительские кооперативы', "Potrebitel'skiye kooperativy"],
    },
    {
        code: 'QFLH',
        country: 'GI',
        jurisdiction: 'GI',
        jurisdictionName: 'Gibraltar',
        name: 'Private Limited by Guarantee',
        abbreviation: 'Limited;Ltd;Ltd.',
        active: true,
        aliases: ['Private Limited by Guarantee', 'Limited;Ltd;Ltd.'],
    },
    {
        code: 'QFXD',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Pessoa Coletiva Internacional',
        abbreviation: '',
        active: true,
        aliases: ['Pessoa Coletiva Internacional'],
    },
    {
        code: 'QFXX',
        country: 'TH',
        jurisdiction: 'TH',
        jurisdictionName: 'Thailand',
        name: 'ห้างหุ้นส่วนสามัญจดทะเบียน',
        abbreviation: '',
        active: true,
        aliases: ['ห้างหุ้นส่วนสามัญจดทะเบียน', 'H̄̂āngh̄ûns̄̀wns̄āmạỵ cdthabeīyn'],
    },
    {
        code: 'QFYC',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Empresa Individual de Responsabilidad Limitada',
        abbreviation: 'E.I.R.L',
        active: true,
        aliases: ['Empresa Individual de Responsabilidad Limitada', 'E.I.R.L'],
    },
    {
        code: 'QG9Y',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Sodininkų bendrijos',
        abbreviation: 'SD',
        active: true,
        aliases: ['Sodininkų bendrijos', 'SD'],
    },
    {
        code: 'QGSA',
        country: 'SG',
        jurisdiction: 'SG',
        jurisdictionName: 'Singapore',
        name: 'Unlimited Public Company',
        abbreviation: '',
        active: true,
        aliases: ['Unlimited Public Company'],
    },
    {
        code: 'QHW1',
        country: 'BR',
        jurisdiction: 'BR',
        jurisdictionName: 'Brazil',
        name: 'Sociedade Limitada',
        abbreviation: 'LTDA.',
        active: true,
        aliases: ['Sociedade Limitada', 'LTDA.'],
    },
    {
        code: 'QIEL',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Kraj',
        abbreviation: '',
        active: true,
        aliases: ['Kraj'],
    },
    {
        code: 'QJ0F',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Ústav',
        abbreviation: '',
        active: true,
        aliases: ['Ústav'],
    },
    {
        code: 'QJ1G',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Industrial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Industrial Bank'],
    },
    {
        code: 'QJ3A',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'gérant de projet',
        abbreviation: '',
        active: false,
        aliases: ['gérant de projet'],
    },
    {
        code: 'QJ9F',
        country: 'US',
        jurisdiction: 'US-TN',
        jurisdictionName: 'Tennessee',
        name: 'For-Profit Corporation',
        abbreviation: 'corp.;inc.;co.',
        active: true,
        aliases: ['For-Profit Corporation', 'corp.;inc.;co.'],
    },
    {
        code: 'QJBA',
        country: 'GG',
        jurisdiction: 'GG',
        jurisdictionName: 'Guernsey',
        name: 'incorporated cell company',
        abbreviation: 'ICC',
        active: true,
        aliases: ['incorporated cell company', 'ICC'],
    },
    {
        code: 'QJVN',
        country: 'AE',
        jurisdiction: 'AE-RK',
        jurisdictionName: 'Ras Al Khaimah',
        name: 'Company Limited By Shares',
        abbreviation: '',
        active: true,
        aliases: ['Company Limited By Shares'],
    },
    {
        code: 'QJWK',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Rada pro veřejný dohled nad auditem',
        abbreviation: '',
        active: true,
        aliases: ['Rada pro veřejný dohled nad auditem'],
    },
    {
        code: 'QK1F',
        country: 'BW',
        jurisdiction: 'BW',
        jurisdictionName: 'Botswana',
        name: 'Public Limited Liability Companies',
        abbreviation: '',
        active: true,
        aliases: ['Public Limited Liability Companies'],
    },
    {
        code: 'QK2J',
        country: 'US',
        jurisdiction: 'US-OR',
        jurisdictionName: 'Oregon',
        name: 'Limited Liability Company',
        abbreviation: 'Limited Liability Company;LLC;L.L.C.',
        active: true,
        aliases: ['Limited Liability Company', 'Limited Liability Company;LLC;L.L.C.'],
    },
    {
        code: 'QKFU',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Учреждения, созданные муниципальным образованием (муниципальные учреждения)',
        abbreviation: '',
        active: true,
        aliases: [
            'Учреждения, созданные муниципальным образованием (муниципальные учреждения)',
            "Uchrezhdeniya, sozdannyye munitsipal'nym obrazovaniyem (munitsipal'nyye uchrezhdeniya)",
        ],
    },
    {
        code: 'QLWR',
        country: 'US',
        jurisdiction: 'US-ID',
        jurisdictionName: 'Idaho',
        name: 'Limited Liability Partnership',
        abbreviation: 'L.L.P.;R.L.L.P.;LLP;RLLP',
        active: true,
        aliases: ['Limited Liability Partnership', 'L.L.P.;R.L.L.P.;LLP;RLLP'],
    },
    {
        code: 'QM7Z',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, casa de bolsa',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima de capital variable, casa de bolsa'],
    },
    {
        code: 'QMEH',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Общества взаимного страхования',
        abbreviation: '',
        active: true,
        aliases: ['Общества взаимного страхования', 'Obshchestva vzaimnogo strakhovaniya'],
    },
    {
        code: 'QMI2',
        country: 'US',
        jurisdiction: 'US-RI',
        jurisdictionName: 'Rhode Island',
        name: 'Benefit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Benefit Corporation'],
    },
    {
        code: 'QMUM',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Fondos de Inversion Inmobiliaria',
        abbreviation: 'F.I.I.',
        active: true,
        aliases: ['Fondos de Inversion Inmobiliaria', 'F.I.I.'],
    },
    {
        code: 'QN8Y',
        country: 'CA',
        jurisdiction: 'CA-NT',
        jurisdictionName: 'Northwest Territories',
        name: 'NT Professional Corporation authorized under the Professional Corporations Act',
        abbreviation: 'Ltd.;Ltée.;Inc.;Corp.;Ltd;Limited',
        active: true,
        aliases: [
            'NT Professional Corporation authorized under the Professional Corporations Act',
            'Ltd.;Ltée.;Inc.;Corp.;Ltd;Limited',
        ],
    },
    {
        code: 'QNSC',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'foreign resident corporation',
        abbreviation: '',
        active: true,
        aliases: ['foreign resident corporation', 'personne morale étrangère résidante', 'C.E.R.'],
    },
    {
        code: 'QNWW',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Ευρωπαϊκός Όμιλος Οικονομικού Σκοπού',
        abbreviation: 'ΕΟΟΣ',
        active: true,
        aliases: [
            'Ευρωπαϊκός Όμιλος Οικονομικού Σκοπού',
            'Evropaikos Ómilos Oikonomikou Skopou',
            'ΕΟΟΣ',
            'EOOS',
        ],
    },
    {
        code: 'QO9Q',
        country: 'UY',
        jurisdiction: 'UY',
        jurisdictionName: 'Uruguay',
        name: 'Cooperativa',
        abbreviation: '',
        active: true,
        aliases: ['Cooperativa'],
    },
    {
        code: 'QODJ',
        country: 'CA',
        jurisdiction: 'CA-BC',
        jurisdictionName: 'British Columbia',
        name: 'Extraprovincial limited liability partnership',
        abbreviation: 'LLP;SRL;SENCRL',
        active: true,
        aliases: ['Extraprovincial limited liability partnership', 'LLP;SRL;SENCRL'],
    },
    {
        code: 'QOO6',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Protected Cell Company',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Protected Cell Company'],
    },
    {
        code: 'QP3O',
        country: 'FJ',
        jurisdiction: 'FJ',
        jurisdictionName: 'Fiji',
        name: 'Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Partnership'],
    },
    {
        code: 'QPC9',
        country: 'SR',
        jurisdiction: 'SR',
        jurisdictionName: 'Suriname',
        name: 'Vereniging',
        abbreviation: '',
        active: true,
        aliases: ['Vereniging'],
    },
    {
        code: 'QQ49',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Zdravotní pojišťovna (mimo VZP)',
        abbreviation: '',
        active: true,
        aliases: ['Zdravotní pojišťovna (mimo VZP)'],
    },
    {
        code: 'QQS1',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Организационно-правовые формы международных организаций, осуществляющих деятельность на территории российской федерации',
        abbreviation: '',
        active: true,
        aliases: [
            'Организационно-правовые формы международных организаций, осуществляющих деятельность на территории российской федерации',
            "Organizatsionno-pravovyye formy mezhdunarodnykh organizatsiy, osushchestvlyayushchikh deyatel'nost' na territorii rossiyskoy federatsii",
        ],
    },
    {
        code: 'QQWG',
        country: 'PE',
        jurisdiction: 'PE',
        jurisdictionName: 'Peru',
        name: 'Sociedad Civil',
        abbreviation: 'S. Civil',
        active: true,
        aliases: ['Sociedad Civil', 'S. Civil'],
    },
    {
        code: 'QR25',
        country: 'PK',
        jurisdiction: 'PK',
        jurisdictionName: 'Pakistan',
        name: 'Company Limited by Guarantee (without share capital)',
        abbreviation: '(Guarantee) Ltd.',
        active: true,
        aliases: ['Company Limited by Guarantee (without share capital)', '(Guarantee) Ltd.'],
    },
    {
        code: 'QR4F',
        country: 'CA',
        jurisdiction: 'CA-NT',
        jurisdictionName: 'Northwest Territories',
        name: 'business name/sole proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['business name/sole proprietorship'],
    },
    {
        code: 'QR4Y',
        country: 'US',
        jurisdiction: 'US-WY',
        jurisdictionName: 'Wyoming',
        name: 'Limited Partnership',
        abbreviation: 'LP',
        active: true,
        aliases: ['Limited Partnership', 'LP'],
    },
    {
        code: 'QR5I',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'QRXD',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Europos teritorinio bendradarbiavimo grupės',
        abbreviation: 'ETBG',
        active: true,
        aliases: ['Europos teritorinio bendradarbiavimo grupės', 'ETBG'],
    },
    {
        code: 'QRZJ',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società Cooperativa',
        abbreviation: 'S.C.;soc. coop.',
        active: true,
        aliases: ['Società Cooperativa', 'S.C.;soc. coop.'],
    },
    {
        code: 'QS6A',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Nadační fond',
        abbreviation: '',
        active: true,
        aliases: ['Nadační fond'],
    },
    {
        code: 'QSHG',
        country: 'US',
        jurisdiction: 'US-MO',
        jurisdictionName: 'Missouri',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: 'QSI2',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Cooperative',
        abbreviation: '',
        active: true,
        aliases: [
            'Cooperative',
            'Société coopérative',
            'SCoo',
            'Genossenschaft',
            'Gen',
            'Società cooperativa',
        ],
    },
    {
        code: 'QSJ1',
        country: 'US',
        jurisdiction: 'US-WI',
        jurisdictionName: 'Wisconsin',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'QSKT',
        country: 'US',
        jurisdiction: 'US-FL',
        jurisdictionName: 'Florida',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'QSXT',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Нотариусы, занимающиеся частной практикой',
        abbreviation: '',
        active: true,
        aliases: [
            'Нотариусы, занимающиеся частной практикой',
            'Notariusy, zanimayushchiyesya chastnoy praktikoy',
        ],
    },
    {
        code: 'QSYQ',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Σωματεία - Ιδρύματα',
        abbreviation: 'CLF',
        active: true,
        aliases: ['Σωματεία - Ιδρύματα', 'Somatia - Idrimata', 'CLF'],
    },
    {
        code: 'QU16',
        country: 'KR',
        jurisdiction: 'KR',
        jurisdictionName: 'Korea (Republic of)',
        name: '국가(정부)',
        abbreviation: '',
        active: true,
        aliases: ['국가(정부)', 'GukGa(JeoungBu)'],
    },
    {
        code: 'QU3G',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA coopérative de production de HLM à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA coopérative de production de HLM à conseil d'administration"],
    },
    {
        code: 'QUB4',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Organisme consulaire',
        abbreviation: '',
        active: true,
        aliases: ['Organisme consulaire'],
    },
    {
        code: 'QUC7',
        country: 'MM',
        jurisdiction: 'MM',
        jurisdictionName: 'Myanmar',
        name: 'အစုအားဖြင့်တာ၀န်ကန့်သတ်ထားသည့်အများနှင့် သက်ဆိုင်သည့်ကုမ္ပဏီ၊',
        abbreviation: '',
        active: true,
        aliases: [
            'အစုအားဖြင့်တာ၀န်ကန့်သတ်ထားသည့်အများနှင့် သက်ဆိုင်သည့်ကုမ္ပဏီ၊',
            'a hcu aarr hpyint tar 0 n k ant saathtarr saeet a myarrnhaint saatsine saeet kumpane',
        ],
    },
    {
        code: 'QUEA',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Tuja pravna oseba po ZZK-1',
        abbreviation: '',
        active: true,
        aliases: ['Tuja pravna oseba po ZZK-1'],
    },
    {
        code: 'QUJ5',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'Benefit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Benefit Corporation'],
    },
    {
        code: 'QUMQ',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Унитарные предприятия, основанные на праве хозяйственного ведения',
        abbreviation: '',
        active: true,
        aliases: [
            'Унитарные предприятия, основанные на праве хозяйственного ведения',
            'Unitarnyye predpriyatiya, osnovannyye na prave khozyaystvennogo vedeniya',
        ],
    },
    {
        code: 'QUNR',
        country: 'US',
        jurisdiction: 'US-AL',
        jurisdictionName: 'Alabama',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'QUX1',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'otwarty fundusz emerytalny',
        abbreviation: 'OFE',
        active: true,
        aliases: ['otwarty fundusz emerytalny', 'OFE'],
    },
    {
        code: 'QV2O',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Société d'exercice libéral à forme anonyme à directoire",
        abbreviation: '',
        active: true,
        aliases: ["Société d'exercice libéral à forme anonyme à directoire"],
    },
    {
        code: 'QVPB',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société anonyme',
        abbreviation: 'SA',
        active: true,
        aliases: ['Société anonyme', 'SA'],
    },
    {
        code: 'QW8S',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Samostojni podjetnik posameznik',
        abbreviation: 's.p.',
        active: true,
        aliases: ['Samostojni podjetnik posameznik', 's.p.'],
    },
    {
        code: 'QWFD',
        country: 'WS',
        jurisdiction: 'WS',
        jurisdictionName: 'Samoa',
        name: 'Overseas company',
        abbreviation: '',
        active: true,
        aliases: ['Overseas company'],
    },
    {
        code: 'QWPR',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'Corporation (profit)',
        abbreviation: 'CORPORATION;COMPANY;LIMITED CORP;INC;CO;LTD',
        active: true,
        aliases: ['Corporation (profit)', 'CORPORATION;COMPANY;LIMITED CORP;INC;CO;LTD'],
    },
    {
        code: 'QWWY',
        country: 'SR',
        jurisdiction: 'SR',
        jurisdictionName: 'Suriname',
        name: 'Commanditaire vennootschap (op aandelen) met meer dan een beherende vennoot',
        abbreviation: 'CV;cv;C.V.;c.v.',
        active: true,
        aliases: [
            'Commanditaire vennootschap (op aandelen) met meer dan een beherende vennoot',
            'CV;cv;C.V.;c.v.',
        ],
    },
    {
        code: 'QX9N',
        country: 'US',
        jurisdiction: 'US-MA',
        jurisdictionName: 'Massachusetts',
        name: 'Domestic Benefit Corporation (including professional corporations)',
        abbreviation: 'Company;Co.;Corporation;Corp.;Incorporated;Inc. Limited;or Ltd. Professional Corporation or P.C. for those rendering professional services.',
        active: true,
        aliases: [
            'Domestic Benefit Corporation (including professional corporations)',
            'Company;Co.;Corporation;Corp.;Incorporated;Inc. Limited;or Ltd. Professional Corporation or P.C. for those rendering professional services.',
        ],
    },
    {
        code: 'QY7A',
        country: 'US',
        jurisdiction: 'US-IL',
        jurisdictionName: 'Illinois',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'QYCU',
        country: 'VN',
        jurisdiction: 'VN',
        jurisdictionName: 'Viet Nam',
        name: 'công ty hợp danh',
        abbreviation: '',
        active: true,
        aliases: ['công ty hợp danh'],
    },
    {
        code: 'QYFI',
        country: 'US',
        jurisdiction: 'US-RI',
        jurisdictionName: 'Rhode Island',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'QYL4',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'placówki systemu oświaty',
        abbreviation: '',
        active: true,
        aliases: ['placówki systemu oświaty'],
    },
    {
        code: 'QYQ5',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Družbeno podjetje',
        abbreviation: '',
        active: true,
        aliases: ['Družbeno podjetje'],
    },
    {
        code: 'QYV5',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Költségvetési szerv',
        abbreviation: '',
        active: true,
        aliases: ['Költségvetési szerv'],
    },
    {
        code: 'QYZD',
        country: 'VC',
        jurisdiction: 'VC',
        jurisdictionName: 'Saint Vincent and the Grenadines',
        name: 'sole proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['sole proprietorship'],
    },
    {
        code: 'QZ3L',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'eingetragener Verein',
        abbreviation: 'e.V.;eV',
        active: true,
        aliases: ['eingetragener Verein', 'e.V.;eV'],
    },
    {
        code: 'QZ84',
        country: 'QA',
        jurisdiction: 'QA',
        jurisdictionName: 'Qatar',
        name: 'شركة المساهمة العامة',
        abbreviation: 'ش.م.ع',
        active: true,
        aliases: ['شركة المساهمة العامة', 'Sharikat Almusahama Alaamah', 'ش.م.ع'],
    },
    {
        code: 'QZAU',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Еднолично aкционерно дружество със специалнa инвестиционна цел',
        abbreviation: '',
        active: true,
        aliases: [
            'Еднолично aкционерно дружество със специалнa инвестиционна цел',
            'Ednolichno aktsionerno druzhestvo sas spetsialna investitsionna tsel',
        ],
    },
    {
        code: 'QZB4',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima bursátil de capital variable, bolsa de valores',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima bursátil de capital variable, bolsa de valores'],
    },
    {
        code: 'QZCG',
        country: 'KW',
        jurisdiction: 'KW',
        jurisdictionName: 'Kuwait',
        name: 'الشركة ذات المسؤولية المحدودة',
        abbreviation: 'ذ.م.م',
        active: true,
        aliases: ['الشركة ذات المسؤولية المحدودة', 'Sharika That Almasuliah Almahduda', 'ذ.م.م'],
    },
    {
        code: 'QZDU',
        country: 'US',
        jurisdiction: 'US',
        jurisdictionName: 'United States of America',
        name: 'National Trust Bank',
        abbreviation: '',
        active: true,
        aliases: ['National Trust Bank'],
    },
    {
        code: 'QZEN',
        country: 'XK',
        jurisdiction: 'XK',
        jurisdictionName: 'Kosovo',
        name: 'Biznes Individual',
        abbreviation: 'BI',
        active: true,
        aliases: ['Biznes Individual', 'BI'],
    },
    {
        code: 'QZIS',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Openbare instelling',
        abbreviation: 'OI',
        active: true,
        aliases: [
            'Openbare instelling',
            'OI',
            'Etablissement public',
            'ETSPUBLI',
            'Öffentliche Einrichtung',
            'ÖE',
        ],
    },
    {
        code: 'QZMH',
        country: 'CA',
        jurisdiction: 'CA-PE',
        jurisdictionName: 'Prince Edward Island',
        name: 'private unlimited liability corporation',
        abbreviation: 'ULC',
        active: true,
        aliases: ['private unlimited liability corporation', 'ULC'],
    },
    {
        code: 'QZP3',
        country: 'IL',
        jurisdiction: 'IL',
        jurisdictionName: 'Israel',
        name: 'חברה פרטית בלתי מוגבלת',
        abbreviation: '',
        active: true,
        aliases: ['חברה פרטית בלתי מוגבלת', 'havra partit lele hagbala'],
    },
    {
        code: 'QZTT',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Private Limited by shares (1931 Act)',
        abbreviation: '',
        active: true,
        aliases: ['Private Limited by shares (1931 Act)'],
    },
    {
        code: 'R0B6',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Groupement d'intérêt économique (GIE)",
        abbreviation: '',
        active: true,
        aliases: ["Groupement d'intérêt économique (GIE)"],
    },
    {
        code: 'R0BI',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'For-Profit Corporation',
        abbreviation: 'Corporation;Incorporated;Company;Limited;Corp;Inc.;Co.;Ltd.',
        active: true,
        aliases: [
            'For-Profit Corporation',
            'Corporation;Incorporated;Company;Limited;Corp;Inc.;Co.;Ltd.',
        ],
    },
    {
        code: 'R0KX',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'private act corporation',
        abbreviation: '',
        active: true,
        aliases: ['private act corporation'],
    },
    {
        code: 'R155',
        country: 'ZA',
        jurisdiction: 'ZA',
        jurisdictionName: 'South Africa',
        name: 'State Owned Company',
        abbreviation: 'SOC',
        active: true,
        aliases: ['State Owned Company', 'SOC'],
    },
    {
        code: 'R18M',
        country: 'US',
        jurisdiction: 'US-OR',
        jurisdictionName: 'Oregon',
        name: 'District Improvement Company',
        abbreviation: 'District Improvement Company',
        active: true,
        aliases: ['District Improvement Company'],
    },
    {
        code: 'R1JO',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Communauté urbaine',
        abbreviation: '',
        active: true,
        aliases: ['Communauté urbaine'],
    },
    {
        code: 'R22H',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Registered Agent Designation',
        abbreviation: '',
        active: true,
        aliases: ['Registered Agent Designation'],
    },
    {
        code: 'R27J',
        country: 'US',
        jurisdiction: 'US-WV',
        jurisdictionName: 'West Virginia',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: 'R2L8',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Anonima Laboral',
        abbreviation: 'S.A.L.',
        active: true,
        aliases: ['Sociedad Anonima Laboral', 'S.A.L.'],
    },
    {
        code: 'R2PI',
        country: 'US',
        jurisdiction: 'US-MD',
        jurisdictionName: 'Maryland',
        name: 'General Partnership',
        abbreviation: '',
        active: true,
        aliases: ['General Partnership'],
    },
    {
        code: 'R2XE',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Organizační jednotka mezinárodní nevládní organizace',
        abbreviation: '',
        active: true,
        aliases: ['Organizační jednotka mezinárodní nevládní organizace'],
    },
    {
        code: 'R2YL',
        country: 'AE',
        jurisdiction: 'AE-AZ',
        jurisdictionName: 'Abu Dhabi',
        name: 'Private Company Limited by Guarantee',
        abbreviation: '',
        active: true,
        aliases: ['Private Company Limited by Guarantee'],
    },
    {
        code: 'R39F',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Kauppakamari',
        abbreviation: '',
        active: true,
        aliases: ['Kauppakamari', 'Handelskammare'],
    },
    {
        code: 'R3J6',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Foreign General Apartnership',
        abbreviation: '',
        active: true,
        aliases: ['Foreign General Apartnership'],
    },
    {
        code: 'R3O0',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '其他（工会）',
        abbreviation: '',
        active: true,
        aliases: ['其他（工会）', 'qi ta（ gong hui ）'],
    },
    {
        code: 'R4KK',
        country: 'AU',
        jurisdiction: 'AU',
        jurisdictionName: 'Australia',
        name: 'Public Company limited by shares',
        abbreviation: 'Ltd;Ltd.;Limited',
        active: true,
        aliases: ['Public Company limited by shares', 'Ltd;Ltd.;Limited'],
    },
    {
        code: 'R4LR',
        country: 'JP',
        jurisdiction: 'JP',
        jurisdictionName: 'Japan',
        name: '国の機関',
        abbreviation: '',
        active: true,
        aliases: ['国の機関', 'kuninokikan'],
    },
    {
        code: 'R59A',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société en commandite par actions coopérative',
        abbreviation: '',
        active: true,
        aliases: ['Société en commandite par actions coopérative'],
    },
    {
        code: 'R59V',
        country: 'ZA',
        jurisdiction: 'ZA',
        jurisdictionName: 'South Africa',
        name: 'External Company',
        abbreviation: '',
        active: false,
        aliases: ['External Company'],
    },
    {
        code: 'R5UT',
        country: 'TR',
        jurisdiction: 'TR',
        jurisdictionName: 'Türkiye',
        name: 'limited şirket',
        abbreviation: 'Ltd. Şti.',
        active: true,
        aliases: ['limited şirket', 'Ltd. Şti.'],
    },
    {
        code: 'R5ZC',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Eurooppaosuuskunnan kiinteä toimipaikka',
        abbreviation: '',
        active: true,
        aliases: [
            'Eurooppaosuuskunnan kiinteä toimipaikka',
            'Fast driftställe för europeisk kooperativ förening',
        ],
    },
    {
        code: 'R6BI',
        country: 'SR',
        jurisdiction: 'SR',
        jurisdictionName: 'Suriname',
        name: 'Eenmanszaak',
        abbreviation: '',
        active: true,
        aliases: ['Eenmanszaak'],
    },
    {
        code: 'R6UB',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Verotusyhtymä',
        abbreviation: '',
        active: true,
        aliases: ['Verotusyhtymä', 'Beskattningssammanslutning'],
    },
    {
        code: 'R6UT',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Limitada Unipersonal',
        abbreviation: 'SLU',
        active: true,
        aliases: ['Sociedad Limitada Unipersonal', 'SLU'],
    },
    {
        code: 'R6WQ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Groupement de coopération sanitaire à gestion publique',
        abbreviation: '',
        active: true,
        aliases: ['Groupement de coopération sanitaire à gestion publique'],
    },
    {
        code: 'R71C',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Sparebank',
        abbreviation: '',
        active: true,
        aliases: ['Sparebank'],
    },
    {
        code: 'R71T',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Акционерные общества',
        abbreviation: '',
        active: true,
        aliases: ['Акционерные общества', 'Aktsionernyye obshchestva'],
    },
    {
        code: 'R7JP',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Non Profit (Dom) Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Non Profit (Dom) Corporation'],
    },
    {
        code: 'R7QO',
        country: 'US',
        jurisdiction: 'US-MA',
        jurisdictionName: 'Massachusetts',
        name: 'Non-Profit Corporation',
        abbreviation: 'Company;Corporation;Corp.;Incorporated;Inc.',
        active: true,
        aliases: ['Non-Profit Corporation', 'Company;Corporation;Corp.;Incorporated;Inc.'],
    },
    {
        code: 'R85P',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Naamloze vennootschap',
        abbreviation: 'NV',
        active: true,
        aliases: ['Naamloze vennootschap', 'NV', 'Société anonyme', 'SA', 'Aktiengesellschaft', 'AG'],
    },
    {
        code: 'R8O9',
        country: 'US',
        jurisdiction: 'US-VT',
        jurisdictionName: 'Vermont',
        name: 'Low Profit LLC',
        abbreviation: 'L3C',
        active: true,
        aliases: ['Low Profit LLC', 'L3C'],
    },
    {
        code: 'R8PY',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, bolsa de valores',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima de capital variable, bolsa de valores'],
    },
    {
        code: 'R8SH',
        country: 'US',
        jurisdiction: 'US-MO',
        jurisdictionName: 'Missouri',
        name: 'Not For Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Not For Profit Corporation'],
    },
    {
        code: 'R997',
        country: 'SG',
        jurisdiction: 'SG',
        jurisdictionName: 'Singapore',
        name: 'Unlimited Exempt Private Company',
        abbreviation: '',
        active: true,
        aliases: ['Unlimited Exempt Private Company'],
    },
    {
        code: 'R9GT',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Samostatná drobná prevádzkareň obecného úradu',
        abbreviation: 'Samost. prevádzkareň OÚ',
        active: true,
        aliases: ['Samostatná drobná prevádzkareň obecného úradu', 'Samost. prevádzkareň OÚ'],
    },
    {
        code: 'R9OY',
        country: 'US',
        jurisdiction: 'US-PA',
        jurisdictionName: 'Pennsylvania',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'R9TC',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Foreign enterprise',
        abbreviation: 'Foreign Enterprise',
        active: false,
        aliases: [
            'Foreign enterprise',
            'Foreign Enterprise',
            'Entreprise étrangère',
            'Ent. Etrangère',
            'Ausländische Unternehmen',
            'Aus. Unt.',
            'Impresa straniera',
            'Imp. Str.',
        ],
    },
    {
        code: 'RA5B',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'International Banking Center (LLC)',
        abbreviation: '',
        active: true,
        aliases: ['International Banking Center (LLC)', 'Centro Bancario Internacional (CRL)'],
    },
    {
        code: 'RAX7',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Zadruga z omejeno odgovornostjo',
        abbreviation: 'z.o.o.',
        active: true,
        aliases: ['Zadruga z omejeno odgovornostjo', 'z.o.o.'],
    },
    {
        code: 'RBBY',
        country: 'CA',
        jurisdiction: 'CA-MB',
        jurisdictionName: 'Manitoba',
        name: 'Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Partnership'],
    },
    {
        code: 'RBGQ',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Evropské hospodářské zájmové sdružení',
        abbreviation: 'EHZS',
        active: true,
        aliases: ['Evropské hospodářské zájmové sdružení', 'EHZS'],
    },
    {
        code: 'RBHP',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'fundusz inwestycyjny',
        abbreviation: '',
        active: true,
        aliases: ['fundusz inwestycyjny'],
    },
    {
        code: 'RC3D',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les villages nordiques et l’Administration régionale Kativik',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur les villages nordiques et l’Administration régionale Kativik',
        ],
    },
    {
        code: 'RC44',
        country: 'US',
        jurisdiction: 'US-UT',
        jurisdictionName: 'Utah',
        name: 'Industrial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Industrial Bank'],
    },
    {
        code: 'RC5L',
        country: 'US',
        jurisdiction: 'US-WV',
        jurisdictionName: 'West Virginia',
        name: 'Limited Liability Company',
        abbreviation: 'L.L.C.;LLC;L.C.;LC',
        active: true,
        aliases: ['Limited Liability Company', 'L.L.C.;LLC;L.C.;LC'],
    },
    {
        code: 'RCE0',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, fondo de inversión de renta variable',
        abbreviation: 'S. A. de C. V., F. I. de R. V.',
        active: true,
        aliases: [
            'Sociedad anónima de capital variable, fondo de inversión de renta variable',
            'S. A. de C. V., F. I. de R. V.',
        ],
    },
    {
        code: 'RCGI',
        country: 'NE',
        jurisdiction: 'NE',
        jurisdictionName: 'Niger',
        name: 'Société Anonyme Unipersonnelle',
        abbreviation: 'SAU',
        active: true,
        aliases: ['Société Anonyme Unipersonnelle', 'SAU'],
    },
    {
        code: 'RCJS',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Corporaciones de carácter público reconocidos por la legislación mexicana',
        abbreviation: '',
        active: true,
        aliases: ['Corporaciones de carácter público reconocidos por la legislación mexicana'],
    },
    {
        code: 'RCNI',
        country: 'US',
        jurisdiction: 'US-NH',
        jurisdictionName: 'New Hampshire',
        name: 'Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Partnership'],
    },
    {
        code: 'RCPI',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Ιδιωτική Εταιρεία',
        abbreviation: '',
        active: true,
        aliases: ['Ιδιωτική Εταιρεία', 'Idiotiki Etaireia'],
    },
    {
        code: 'RD0Z',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Fiducie',
        abbreviation: '',
        active: true,
        aliases: ['Fiducie'],
    },
    {
        code: 'RD1T',
        country: 'US',
        jurisdiction: 'US-TN',
        jurisdictionName: 'Tennessee',
        name: 'Nonprofit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation'],
    },
    {
        code: 'RDD3',
        country: 'AR',
        jurisdiction: 'AR',
        jurisdictionName: 'Argentina',
        name: 'Asociacion civil',
        abbreviation: '',
        active: true,
        aliases: ['Asociacion civil'],
    },
    {
        code: 'RDQZ',
        country: 'US',
        jurisdiction: 'US-WY',
        jurisdictionName: 'Wyoming',
        name: 'Statutory Trust',
        abbreviation: '',
        active: true,
        aliases: ['Statutory Trust'],
    },
    {
        code: 'RDZR',
        country: 'TZ',
        jurisdiction: 'TZ',
        jurisdictionName: 'Tanzania',
        name: 'Sole proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['Sole proprietorship'],
    },
    {
        code: 'REUP',
        country: 'AW',
        jurisdiction: 'AW',
        jurisdictionName: 'Aruba',
        name: 'Aruba vrijgestelde vennootschap',
        abbreviation: 'AVV;avv;A.V.V.;a.v.v.',
        active: true,
        aliases: ['Aruba vrijgestelde vennootschap', 'AVV;avv;A.V.V.;a.v.v.'],
    },
    {
        code: 'REVF',
        country: 'VC',
        jurisdiction: 'VC',
        jurisdictionName: 'Saint Vincent and the Grenadines',
        name: 'international business company - company limited by guarantee authorised to issue shares',
        abbreviation: 'Ltd;Corp;Inc',
        active: true,
        aliases: [
            'international business company - company limited by guarantee authorised to issue shares',
            'Ltd;Corp;Inc',
        ],
    },
    {
        code: 'RF3D',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Združenie (zväz, spolok, spoločnosť, klub ai.)',
        abbreviation: '',
        active: true,
        aliases: ['Združenie (zväz, spolok, spoločnosť, klub ai.)'],
    },
    {
        code: 'RF41',
        country: 'HN',
        jurisdiction: 'HN',
        jurisdictionName: 'Honduras',
        name: 'Sociedad en Comandita Simple',
        abbreviation: 'S. en C.',
        active: true,
        aliases: ['Sociedad en Comandita Simple', 'S. en C.'],
    },
    {
        code: 'RFJT',
        country: 'PE',
        jurisdiction: 'PE',
        jurisdictionName: 'Peru',
        name: 'Sociedad en Comandita Simple',
        abbreviation: 'S. en C.',
        active: true,
        aliases: ['Sociedad en Comandita Simple', 'S. en C.'],
    },
    {
        code: 'RFWH',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Groupement foncier et rural',
        abbreviation: '',
        active: true,
        aliases: ['Groupement foncier et rural'],
    },
    {
        code: 'RG0W',
        country: 'NG',
        jurisdiction: 'NG',
        jurisdictionName: 'Nigeria',
        name: 'Unlimited company',
        abbreviation: 'Ultd',
        active: true,
        aliases: ['Unlimited company', 'Ultd'],
    },
    {
        code: 'RG9Z',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Societas Cooperativa Europaea',
        abbreviation: 'SCE',
        active: true,
        aliases: ['Societas Cooperativa Europaea', 'SCE'],
    },
    {
        code: 'RH6N',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Domestic Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Corporation'],
    },
    {
        code: 'RHFQ',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Družstevní podnik (s 1 zakladatelem)',
        abbreviation: '',
        active: true,
        aliases: ['Družstevní podnik (s 1 zakladatelem)'],
    },
    {
        code: 'RHVP',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'private act non-profit corp',
        abbreviation: '',
        active: true,
        aliases: ['private act non-profit corp'],
    },
    {
        code: 'RIYP',
        country: 'NG',
        jurisdiction: 'NG',
        jurisdictionName: 'Nigeria',
        name: 'Company limited by guarantee',
        abbreviation: 'Ltd/Gte',
        active: true,
        aliases: ['Company limited by guarantee', 'Ltd/Gte'],
    },
    {
        code: 'RJUK',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Садоводческие, огороднические или дачные некоммерческие товарищества',
        abbreviation: '',
        active: true,
        aliases: [
            'Садоводческие, огороднические или дачные некоммерческие товарищества',
            'Sadovodcheskiye, ogorodnicheskiye ili dachnyye nekommercheskiye tovarishchestva',
        ],
    },
    {
        code: 'RJYT',
        country: 'MU',
        jurisdiction: 'MU',
        jurisdictionName: 'Mauritius',
        name: 'Trade Union',
        abbreviation: 'TU',
        active: true,
        aliases: ['Trade Union', 'TU'],
    },
    {
        code: 'RK88',
        country: 'GT',
        jurisdiction: 'GT',
        jurisdictionName: 'Guatemala',
        name: 'Sociedad de Responsabilidad Limitada',
        abbreviation: 'Ltda;Cía. Ltda.',
        active: true,
        aliases: ['Sociedad de Responsabilidad Limitada', 'Ltda;Cía. Ltda.'],
    },
    {
        code: 'RKLI',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima, sociedad de información crediticia',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima, sociedad de información crediticia'],
    },
    {
        code: 'RKYF',
        country: 'PK',
        jurisdiction: 'PK',
        jurisdictionName: 'Pakistan',
        name: 'Public Limited Company (unlisted)',
        abbreviation: 'Ltd;Ltd.;Limited',
        active: true,
        aliases: ['Public Limited Company (unlisted)', 'Ltd;Ltd.;Limited'],
    },
    {
        code: 'RLB2',
        country: 'AE',
        jurisdiction: 'AE',
        jurisdictionName: 'United Arab Emirates',
        name: 'General Partnership',
        abbreviation: '',
        active: true,
        aliases: ['General Partnership'],
    },
    {
        code: 'RLJO',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Europeisk ekonomisk intressegruppering',
        abbreviation: 'EEIG',
        active: true,
        aliases: ['Europeisk ekonomisk intressegruppering', 'EEIG'],
    },
    {
        code: 'RLSQ',
        country: 'TR',
        jurisdiction: 'TR',
        jurisdictionName: 'Türkiye',
        name: 'vakif',
        abbreviation: '',
        active: true,
        aliases: ['vakif'],
    },
    {
        code: 'RN1W',
        country: 'QA',
        jurisdiction: 'QA',
        jurisdictionName: 'Qatar',
        name: 'شركة التوصية بالأسهم',
        abbreviation: '',
        active: true,
        aliases: ['شركة التوصية بالأسهم', "Sharikat Altawsia Blas'hoom"],
    },
    {
        code: 'RN4K',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'Alberta limited partnership',
        abbreviation: '',
        active: true,
        aliases: ['Alberta limited partnership'],
    },
    {
        code: 'RNJZ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société de Participations Financières de Profession Libérale Société en commandite par actions (SPFPL SCA)',
        abbreviation: '',
        active: true,
        aliases: [
            'Société de Participations Financières de Profession Libérale Société en commandite par actions (SPFPL SCA)',
        ],
    },
    {
        code: 'RNQ0',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Organización Comunitaria',
        abbreviation: '',
        active: true,
        aliases: ['Organización Comunitaria'],
    },
    {
        code: 'RNSB',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société étrangère non immatriculée au RCS',
        abbreviation: '',
        active: false,
        aliases: ['Société étrangère non immatriculée au RCS'],
    },
    {
        code: 'RP0E',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Obecní podnik',
        abbreviation: '',
        active: true,
        aliases: ['Obecní podnik'],
    },
    {
        code: 'RPED',
        country: 'US',
        jurisdiction: 'US-PA',
        jurisdictionName: 'Pennsylvania',
        name: 'Body Politic and Corporate',
        abbreviation: '',
        active: true,
        aliases: ['Body Politic and Corporate'],
    },
    {
        code: 'RPGT',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Société par actions constitué par Loi sur les compagnies de télégraphe et de téléphone',
        abbreviation: '',
        active: true,
        aliases: [
            'Société par actions constitué par Loi sur les compagnies de télégraphe et de téléphone',
        ],
    },
    {
        code: 'RQDD',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima bursátil, sociedad financiera de objeto múltiple, entidad regulada',
        abbreviation: 'S.A.B. SOFOM E.R.',
        active: true,
        aliases: [
            'Sociedad anónima bursátil, sociedad financiera de objeto múltiple, entidad regulada',
            'S.A.B. SOFOM E.R.',
        ],
    },
    {
        code: 'RQIC',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Société en commandite',
        abbreviation: 'S.E.C.',
        active: true,
        aliases: ['Société en commandite', 'S.E.C.'],
    },
    {
        code: 'RR3L',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima promotora de inversión bursátil de capital variable',
        abbreviation: 'S.A.P.I.B. de C.V.',
        active: true,
        aliases: [
            'Sociedad anónima promotora de inversión bursátil de capital variable',
            'S.A.P.I.B. de C.V.',
        ],
    },
    {
        code: 'RR8G',
        country: 'US',
        jurisdiction: 'US-WA',
        jurisdictionName: 'Washington',
        name: 'Non-profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Non-profit Corporation'],
    },
    {
        code: 'RRXD',
        country: 'US',
        jurisdiction: 'US-WA',
        jurisdictionName: 'Washington',
        name: 'Limited Liability Partnership',
        abbreviation: 'L.L.P.;LLP',
        active: true,
        aliases: ['Limited Liability Partnership', 'L.L.P.;LLP'],
    },
    {
        code: 'RS5D',
        country: 'TV',
        jurisdiction: 'TV',
        jurisdictionName: 'Tuvalu',
        name: 'association',
        abbreviation: '',
        active: true,
        aliases: ['association'],
    },
    {
        code: 'RSWJ',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'General Partnership',
        abbreviation: '',
        active: true,
        aliases: ['General Partnership'],
    },
    {
        code: 'RT39',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société créée de fait avec personne morale',
        abbreviation: '',
        active: true,
        aliases: ['Société créée de fait avec personne morale'],
    },
    {
        code: 'RT6Y',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Agent commercial',
        abbreviation: '',
        active: false,
        aliases: ['Agent commercial'],
    },
    {
        code: 'RTVE',
        country: 'MU',
        jurisdiction: 'MU',
        jurisdictionName: 'Mauritius',
        name: 'Limited Liability Partnership',
        abbreviation: 'LLP;L.L.P.;limited liability partnership;Limited Liability Partnership',
        active: true,
        aliases: [
            'Limited Liability Partnership',
            'LLP;L.L.P.;limited liability partnership;Limited Liability Partnership',
        ],
    },
    {
        code: 'RU6X',
        country: 'US',
        jurisdiction: 'US-ID',
        jurisdictionName: 'Idaho',
        name: 'Limited Liability Company',
        abbreviation: 'L.L.C.;LLC;L.C.;LC',
        active: true,
        aliases: ['Limited Liability Company', 'L.L.C.;LLC;L.C.;LC'],
    },
    {
        code: 'RUCO',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'oddział przedsiębiorcy zagranicznego',
        abbreviation: '',
        active: false,
        aliases: ['oddział przedsiębiorcy zagranicznego'],
    },
    {
        code: 'RV48',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '个体工商户',
        abbreviation: '',
        active: true,
        aliases: ['个体工商户', 'ge ti gong shang hu'],
    },
    {
        code: 'RVWS',
        country: 'NZ',
        jurisdiction: 'NZ',
        jurisdictionName: 'New Zealand',
        name: 'Friendly society',
        abbreviation: '',
        active: true,
        aliases: ['Friendly society'],
    },
    {
        code: 'RWMC',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Communauté de villes',
        abbreviation: '',
        active: true,
        aliases: ['Communauté de villes'],
    },
    {
        code: 'RWVW',
        country: 'AE',
        jurisdiction: 'AE',
        jurisdictionName: 'United Arab Emirates',
        name: 'Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Company'],
    },
    {
        code: 'RWX4',
        country: 'AE',
        jurisdiction: 'AE-DU',
        jurisdictionName: 'Dubai',
        name: 'Protected Cell Company',
        abbreviation: '',
        active: true,
        aliases: ['Protected Cell Company'],
    },
    {
        code: 'RWZD',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Altre Forme',
        abbreviation: '',
        active: false,
        aliases: ['Altre Forme'],
    },
    {
        code: 'RXJN',
        country: 'BO',
        jurisdiction: 'BO',
        jurisdictionName: 'Bolivia (Plurinational State of)',
        name: 'Empresa Estatal Mixta',
        abbreviation: '',
        active: true,
        aliases: ['Empresa Estatal Mixta'],
    },
    {
        code: 'RXTT',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Euroopa ühistu',
        abbreviation: 'SCE',
        active: true,
        aliases: ['Euroopa ühistu', 'SCE'],
    },
    {
        code: 'RY5B',
        country: 'VC',
        jurisdiction: 'VC',
        jurisdictionName: 'Saint Vincent and the Grenadines',
        name: 'international business company - unlimited company authorised to issue shares',
        abbreviation: 'Unltd',
        active: true,
        aliases: [
            'international business company - unlimited company authorised to issue shares',
            'Unltd',
        ],
    },
    {
        code: 'RYDY',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Европейско обединение по икономически интереси',
        abbreviation: 'ЕОИИ',
        active: true,
        aliases: [
            'Европейско обединение по икономически интереси',
            'Evropeysko obedinenie po ikonomicheski interesi',
            'ЕОИИ',
            'EEIG',
        ],
    },
    {
        code: 'RYFP',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Europeisk gruppering för territoriellt samarbete',
        abbreviation: 'EGTS',
        active: true,
        aliases: ['Europeisk gruppering för territoriellt samarbete', 'EGTS'],
    },
    {
        code: 'RZ5R',
        country: 'US',
        jurisdiction: 'US-RI',
        jurisdictionName: 'Rhode Island',
        name: 'Professional Service Corporation',
        abbreviation: 'corp.;inc.;p.c.;ltd.',
        active: true,
        aliases: ['Professional Service Corporation', 'corp.;inc.;p.c.;ltd.'],
    },
    {
        code: 'S02Y',
        country: 'LS',
        jurisdiction: 'LS',
        jurisdictionName: 'Lesotho',
        name: 'External Company',
        abbreviation: '',
        active: true,
        aliases: ['External Company'],
    },
    {
        code: 'S0BB',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Professional Corporation',
        abbreviation: 'Corp.;Ltd.;Inc.',
        active: true,
        aliases: ['Professional Corporation', 'Corp.;Ltd.;Inc.'],
    },
    {
        code: 'S0X8',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Caisse de crédit agricole mutuel',
        abbreviation: '',
        active: true,
        aliases: ['Caisse de crédit agricole mutuel'],
    },
    {
        code: 'S0Z5',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Fondo de Inversion',
        abbreviation: 'F.I.',
        active: true,
        aliases: ['Fondo de Inversion', 'F.I.'],
    },
    {
        code: 'S1IS',
        country: 'KR',
        jurisdiction: 'KR',
        jurisdictionName: 'Korea (Republic of)',
        name: '일반 법인 협회',
        abbreviation: '',
        active: true,
        aliases: ['일반 법인 협회', 'Ilban beobin hyeophoe'],
    },
    {
        code: 'S1OK',
        country: 'VC',
        jurisdiction: 'VC',
        jurisdictionName: 'Saint Vincent and the Grenadines',
        name: 'non-profit company',
        abbreviation: 'inc.;corp.',
        active: true,
        aliases: ['non-profit company', 'inc.;corp.'],
    },
    {
        code: 'S1UI',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Civilna odvetniška družba',
        abbreviation: '',
        active: true,
        aliases: ['Civilna odvetniška družba'],
    },
    {
        code: 'S2E3',
        country: 'HK',
        jurisdiction: 'HK',
        jurisdictionName: 'Hong Kong',
        name: '擔保有限公司',
        abbreviation: '有限公司',
        active: true,
        aliases: [
            '擔保有限公司',
            'Dan bao you xian gong si',
            '有限公司',
            'Company limited by guarantee',
            'Ltd;Ltd.;Limited',
        ],
    },
    {
        code: 'S2J1',
        country: 'MU',
        jurisdiction: 'MU',
        jurisdictionName: 'Mauritius',
        name: 'Others',
        abbreviation: '',
        active: false,
        aliases: ['Others'],
    },
    {
        code: 'S2K8',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Business Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Business Corporation'],
    },
    {
        code: 'S3DA',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Betéti társaság',
        abbreviation: 'Bt.',
        active: true,
        aliases: ['Betéti társaság', 'Bt.'],
    },
    {
        code: 'S3K4',
        country: 'CA',
        jurisdiction: 'CA-BC',
        jurisdictionName: 'British Columbia',
        name: 'Registered extraprovincial non-share corporation',
        abbreviation: '',
        active: true,
        aliases: ['Registered extraprovincial non-share corporation'],
    },
    {
        code: 'S4U2',
        country: 'US',
        jurisdiction: 'US-VA',
        jurisdictionName: 'Virginia',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'S5E1',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Miestna jednotka bez právnej spôsobilosti',
        abbreviation: '',
        active: true,
        aliases: ['Miestna jednotka bez právnej spôsobilosti'],
    },
    {
        code: 'S68T',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'Electric Cooperative Nonprofit Membership Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Electric Cooperative Nonprofit Membership Corporation'],
    },
    {
        code: 'S69C',
        country: 'MH',
        jurisdiction: 'MH',
        jurisdictionName: 'Marshall Islands',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'S6M8',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad nacional de crédito institución de banca de desarrollo',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad nacional de crédito institución de banca de desarrollo'],
    },
    {
        code: 'S6MS',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Congregación',
        abbreviation: '',
        active: true,
        aliases: ['Congregación'],
    },
    {
        code: 'S6TP',
        country: 'US',
        jurisdiction: 'US-WY',
        jurisdictionName: 'Wyoming',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'S6X7',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Colectiva',
        abbreviation: 'S.C.;S.R.C.',
        active: true,
        aliases: ['Sociedad Colectiva', 'S.C.;S.R.C.'],
    },
    {
        code: 'S72N',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur la Fédération des scouts catholiques du Québec',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur la Fédération des scouts catholiques du Québec',
        ],
    },
    {
        code: 'S745',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: '(Business) Corporation',
        abbreviation: 'corp.;inc.;BC;B.C.',
        active: true,
        aliases: ['(Business) Corporation', 'corp.;inc.;BC;B.C.'],
    },
    {
        code: 'S779',
        country: 'LS',
        jurisdiction: 'LS',
        jurisdictionName: 'Lesotho',
        name: 'Private Company',
        abbreviation: '',
        active: true,
        aliases: ['Private Company'],
    },
    {
        code: 'S7R4',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Pre-Incorporated Company',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Pre-Incorporated Company'],
    },
    {
        code: 'S7VR',
        country: 'US',
        jurisdiction: 'US-GA',
        jurisdictionName: 'Georgia',
        name: 'Nonprofit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation'],
    },
    {
        code: 'S82R',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société de Participations Financières de Profession Libérale Société par actions simplifiée (SPFPL SAS)',
        abbreviation: '',
        active: true,
        aliases: [
            'Société de Participations Financières de Profession Libérale Société par actions simplifiée (SPFPL SAS)',
        ],
    },
    {
        code: 'S8DM',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima institución de seguros',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima institución de seguros'],
    },
    {
        code: 'S8ZK',
        country: 'AM',
        jurisdiction: 'AM',
        jurisdictionName: 'Armenia',
        name: 'Լրացուցիչ պատասխանատվությամբ ընկերություն',
        abbreviation: 'ԼՊԸ',
        active: true,
        aliases: [
            'Լրացուցիչ պատասխանատվությամբ ընկերություն',
            'Lracʿucʿič patasxanatvutʿyan enkerutʿyun',
            'ԼՊԸ',
            'LPĒ',
        ],
    },
    {
        code: 'S94S',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Командитно дружество',
        abbreviation: 'КД',
        active: true,
        aliases: ['Командитно дружество', 'Komanditno druzhestvo', 'КД', 'KD'],
    },
    {
        code: 'S968',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Industrial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Industrial Bank'],
    },
    {
        code: 'S97E',
        country: 'VN',
        jurisdiction: 'VN',
        jurisdictionName: 'Viet Nam',
        name: 'Hợp tác xã',
        abbreviation: '',
        active: true,
        aliases: ['Hợp tác xã'],
    },
    {
        code: 'S97G',
        country: 'US',
        jurisdiction: 'US-NH',
        jurisdictionName: 'New Hampshire',
        name: 'Investment Trust',
        abbreviation: '',
        active: true,
        aliases: ['Investment Trust'],
    },
    {
        code: 'S9UH',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '司法鉴定机构',
        abbreviation: '',
        active: true,
        aliases: ['司法鉴定机构', 'si fa jian ding ji gou'],
    },
    {
        code: 'SAI8',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Private Unlimited and having a Share Capital (1931 Act)',
        abbreviation: '',
        active: true,
        aliases: ['Private Unlimited and having a Share Capital (1931 Act)'],
    },
    {
        code: 'SAST',
        country: 'JO',
        jurisdiction: 'JO',
        jurisdictionName: 'Jordan',
        name: 'الشركة التي لا تهدف لتحقيق الربح',
        abbreviation: 'لا تهدف لتحقيق الربح',
        active: true,
        aliases: [
            'الشركة التي لا تهدف لتحقيق الربح',
            'alsharika alty la tahdof litahqiq alribh',
            'لا تهدف لتحقيق الربح',
        ],
    },
    {
        code: 'SBF3',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Sustainable Business Corporation',
        abbreviation: 'Corp.;Ltd.;Inc.',
        active: true,
        aliases: ['Sustainable Business Corporation', 'Corp.;Ltd.;Inc.'],
    },
    {
        code: 'SBQF',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Sociedad colectiva',
        abbreviation: 'S.C.',
        active: true,
        aliases: ['Sociedad colectiva', 'S.C.'],
    },
    {
        code: 'SBQN',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Consorzio senza Attività Esterna',
        abbreviation: '',
        active: true,
        aliases: ['Consorzio senza Attività Esterna'],
    },
    {
        code: 'SCE1',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Gemeinnützige Gesellschaft mit beschränkter Haftung',
        abbreviation: 'gGmbH',
        active: true,
        aliases: ['Gemeinnützige Gesellschaft mit beschränkter Haftung', 'gGmbH'],
    },
    {
        code: 'SCX8',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Public Benefit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Public Benefit Corporation'],
    },
    {
        code: 'SD81',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'družba z neomejeno odgovornostjo',
        abbreviation: 'd.n.o.',
        active: true,
        aliases: ['družba z neomejeno odgovornostjo', 'd.n.o.'],
    },
    {
        code: 'SDPE',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Työttömyyskassa',
        abbreviation: '',
        active: true,
        aliases: ['Työttömyyskassa', 'Arbetslöshetskassa'],
    },
    {
        code: 'SDVV',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Объединения работодателей',
        abbreviation: '',
        active: true,
        aliases: ['Объединения работодателей', 'Ob"yedineniya rabotodateley'],
    },
    {
        code: 'SDX0',
        country: 'US',
        jurisdiction: 'US-NY',
        jurisdictionName: 'New York',
        name: 'Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Company'],
    },
    {
        code: 'SERH',
        country: 'US',
        jurisdiction: 'US-CT',
        jurisdictionName: 'Connecticut',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'SFK9',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Bendras valdymo ir pranešimų centras',
        abbreviation: 'CRC',
        active: true,
        aliases: ['Bendras valdymo ir pranešimų centras', 'CRC'],
    },
    {
        code: 'SFYA',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Mažosios bendrijos',
        abbreviation: 'MB',
        active: true,
        aliases: ['Mažosios bendrijos', 'MB'],
    },
    {
        code: 'SFZM',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Persoană juridică de drept public',
        abbreviation: '',
        active: true,
        aliases: ['Persoană juridică de drept public'],
    },
    {
        code: 'SGST',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Europäische Aktiengesellschaft',
        abbreviation: 'SE',
        active: true,
        aliases: ['Europäische Aktiengesellschaft', 'SE'],
    },
    {
        code: 'SGT8',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'SH05',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '其他（机构编制）',
        abbreviation: '',
        active: true,
        aliases: ['其他（机构编制）', 'qi ta（ ji gou bian zhi ）'],
    },
    {
        code: 'SHCN',
        country: 'US',
        jurisdiction: 'US-CT',
        jurisdictionName: 'Connecticut',
        name: 'Statutory Trust',
        abbreviation: '',
        active: true,
        aliases: ['Statutory Trust'],
    },
    {
        code: 'SIPP',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Организационно-правовые формы для деятельности граждан, не отнесенной к предпринимательству',
        abbreviation: '',
        active: true,
        aliases: [
            'Организационно-правовые формы для деятельности граждан, не отнесенной к предпринимательству',
            "Organizatsionno-pravovyye formy dlya deyatel'nosti grazhdan, ne otnesennoy k predprinimatel'stvu",
        ],
    },
    {
        code: 'SIRY',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Záujmové združenie právnických osôb',
        abbreviation: 'Záujm. združ. práv.osôb',
        active: true,
        aliases: ['Záujmové združenie právnických osôb', 'Záujm. združ. práv.osôb'],
    },
    {
        code: 'SIST',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Public Transportation Authority',
        abbreviation: 'corp.;inc.;co.;ltd. Incorporated;company;limited;corporation',
        active: true,
        aliases: [
            'Public Transportation Authority',
            'corp.;inc.;co.;ltd. Incorporated;company;limited;corporation',
        ],
    },
    {
        code: 'SJB8',
        country: 'CO',
        jurisdiction: 'CO',
        jurisdictionName: 'Colombia',
        name: 'Sociedades Agrarias de Transformación',
        abbreviation: 'SAT',
        active: true,
        aliases: ['Sociedades Agrarias de Transformación', 'SAT'],
    },
    {
        code: 'SJKV',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Foreign Non-Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Non-Profit Corporation'],
    },
    {
        code: 'SJL9',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Osuuspankki',
        abbreviation: '',
        active: true,
        aliases: ['Osuuspankki', 'Andelsbank'],
    },
    {
        code: 'SJQO',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'SKGX',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Yhteisetuudet',
        abbreviation: '',
        active: true,
        aliases: ['Yhteisetuudet', 'Samfällda förmåner'],
    },
    {
        code: 'SKO4',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad mutualista',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad mutualista'],
    },
    {
        code: 'SLXJ',
        country: 'AZ',
        jurisdiction: 'AZ',
        jurisdictionName: 'Azerbaijan',
        name: 'Asılı təsərrüfat cəmiyyəti',
        abbreviation: '',
        active: true,
        aliases: ['Asılı təsərrüfat cəmiyyəti'],
    },
    {
        code: 'SMCI',
        country: 'BY',
        jurisdiction: 'BY',
        jurisdictionName: 'Belarus',
        name: 'Установа',
        abbreviation: 'Уст',
        active: true,
        aliases: ['Установа', 'Ustanova', 'Уст', 'Ust', 'Учреждение', 'Uchrezhdeniye', 'Учр', 'Uchr'],
    },
    {
        code: 'SMIS',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'przedsiębiorstwo państwowe',
        abbreviation: '',
        active: true,
        aliases: ['przedsiębiorstwo państwowe'],
    },
    {
        code: 'SMUS',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Záujmové združenie',
        abbreviation: '',
        active: true,
        aliases: ['Záujmové združenie'],
    },
    {
        code: 'SMWM',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Sindicato y su Federación',
        abbreviation: '',
        active: true,
        aliases: ['Sindicato y su Federación'],
    },
    {
        code: 'SMZ6',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Société de Participations Financières de Profession Libérale Société anonyme à conseil d'administration (SPFPL SA à conseil d'administration)",
        abbreviation: '',
        active: true,
        aliases: [
            "Société de Participations Financières de Profession Libérale Société anonyme à conseil d'administration (SPFPL SA à conseil d'administration)",
        ],
    },
    {
        code: 'SNRI',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Vennootschap onder Firma',
        abbreviation: '',
        active: true,
        aliases: ['Vennootschap onder Firma'],
    },
    {
        code: 'SNUK',
        country: 'KY',
        jurisdiction: 'KY',
        jurisdictionName: 'Cayman Islands',
        name: 'association',
        abbreviation: '',
        active: true,
        aliases: ['association'],
    },
    {
        code: 'SNWJ',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Podílový, penzijní fond',
        abbreviation: '',
        active: true,
        aliases: ['Podílový, penzijní fond'],
    },
    {
        code: 'SOQ1',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Workers Cooperative',
        abbreviation: '',
        active: false,
        aliases: ['Workers Cooperative', 'Fideicomiso'],
    },
    {
        code: 'SOX5',
        country: 'VI',
        jurisdiction: 'VI',
        jurisdictionName: 'Virgin Islands (U.S.)',
        name: 'Foreign Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Limited Liability Company'],
    },
    {
        code: 'SOXQ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société en libre partenariat',
        abbreviation: 'SLP',
        active: true,
        aliases: ['Société en libre partenariat', 'SLP'],
    },
    {
        code: 'SP0A',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Foundation',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Foundation'],
    },
    {
        code: 'SP4S',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'kościoł i związki wyznaniowe',
        abbreviation: '',
        active: true,
        aliases: ['kościoł i związki wyznaniowe'],
    },
    {
        code: 'SP51',
        country: 'MY',
        jurisdiction: 'MY',
        jurisdictionName: 'Malaysia',
        name: 'Limited Liability Partnership',
        abbreviation: 'LLP; PLT',
        active: true,
        aliases: [
            'Limited Liability Partnership',
            'LLP; PLT',
            'Perkongsian Liabiliti Terhad',
            'PLT; LLP',
        ],
    },
    {
        code: 'SP9F',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Limited by Guarantee (2006 Act)',
        abbreviation: '',
        active: true,
        aliases: ['Limited by Guarantee (2006 Act)'],
    },
    {
        code: 'SPIE',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Podnikateľ-fyzická osoba-zapísaný v obchodnom registri',
        abbreviation: 'Živnostník v OR',
        active: true,
        aliases: ['Podnikateľ-fyzická osoba-zapísaný v obchodnom registri', 'Živnostník v OR'],
    },
    {
        code: 'SPJ7',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Vjerska zajednica',
        abbreviation: '',
        active: true,
        aliases: ['Vjerska zajednica'],
    },
    {
        code: 'SPX9',
        country: 'PH',
        jurisdiction: 'PH',
        jurisdictionName: 'Philippines',
        name: 'close corporation',
        abbreviation: '',
        active: true,
        aliases: ['close corporation'],
    },
    {
        code: 'SQ1A',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Société civile',
        abbreviation: 'SCI',
        active: true,
        aliases: ['Société civile', 'SCI'],
    },
    {
        code: 'SQ4I',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Podnikateľ-fyzická osoba-nezapís.v OR-podnikajúca súčasne ako osoba so slobodným povolaním',
        abbreviation: 'Živ.a sl.povolanie',
        active: true,
        aliases: [
            'Podnikateľ-fyzická osoba-nezapís.v OR-podnikajúca súčasne ako osoba so slobodným povolaním',
            'Živ.a sl.povolanie',
        ],
    },
    {
        code: 'SQ7B',
        country: 'US',
        jurisdiction: 'US-CA',
        jurisdictionName: 'California',
        name: 'General Partnership',
        abbreviation: '',
        active: true,
        aliases: ['General Partnership'],
    },
    {
        code: 'SQ8U',
        country: 'BS',
        jurisdiction: 'BS',
        jurisdictionName: 'Bahamas',
        name: 'Exempted Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Exempted Limited Partnership'],
    },
    {
        code: 'SQFW',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Iné družstvo',
        abbreviation: '',
        active: true,
        aliases: ['Iné družstvo'],
    },
    {
        code: 'SQKS',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Körperschaft des öffentlichen Rechts',
        abbreviation: '',
        active: true,
        aliases: ['Körperschaft des öffentlichen Rechts'],
    },
    {
        code: 'SQOE',
        country: 'US',
        jurisdiction: 'US-DC',
        jurisdictionName: 'District of Columbia',
        name: 'Statutory Trust',
        abbreviation: '',
        active: true,
        aliases: ['Statutory Trust'],
    },
    {
        code: 'SQS1',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Ahvenanmaan maakunta ja sen virastot',
        abbreviation: '',
        active: true,
        aliases: ['Ahvenanmaan maakunta ja sen virastot', 'Lanskapet Åland och dess ämbetsverk'],
    },
    {
        code: 'SQXC',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Insurance Company',
        abbreviation: '',
        active: false,
        aliases: ['Insurance Company', 'Compañía de Responsabilidad Limitada con Fin Social'],
    },
    {
        code: 'SQXV',
        country: 'JE',
        jurisdiction: 'JE',
        jurisdictionName: 'Jersey',
        name: 'Private Limited Company',
        abbreviation: 'LTD;A.R.L;Limited',
        active: true,
        aliases: ['Private Limited Company', 'LTD;A.R.L;Limited'],
    },
    {
        code: 'SRQE',
        country: 'BH',
        jurisdiction: 'BH',
        jurisdictionName: 'Bahrain',
        name: 'شركة التوصية البسيطة للشراكة (شركة التوصية البسيطة)',
        abbreviation: '',
        active: true,
        aliases: [
            'شركة التوصية البسيطة للشراكة (شركة التوصية البسيطة)',
            'Sharikat altawsiat albasitat lilshiraka',
        ],
    },
    {
        code: 'SS0L',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Cooperativa de Credito',
        abbreviation: '',
        active: true,
        aliases: ['Cooperativa de Credito'],
    },
    {
        code: 'SS1V',
        country: 'CA',
        jurisdiction: 'CA-MB',
        jurisdictionName: 'Manitoba',
        name: 'registration of extra-provincial corporations',
        abbreviation: '',
        active: true,
        aliases: ['registration of extra-provincial corporations'],
    },
    {
        code: 'SS3A',
        country: 'CW',
        jurisdiction: 'CW',
        jurisdictionName: 'Curaçao',
        name: 'Onderlinge waarborgmaatschappij',
        abbreviation: '',
        active: true,
        aliases: ['Onderlinge waarborgmaatschappij'],
    },
    {
        code: 'SSHN',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Régime d'assurance chômage",
        abbreviation: '',
        active: true,
        aliases: ["Régime d'assurance chômage"],
    },
    {
        code: 'SSN4',
        country: 'US',
        jurisdiction: 'US-WV',
        jurisdictionName: 'West Virginia',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'SSOM',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Bostadsrättsförening',
        abbreviation: 'BRF',
        active: true,
        aliases: ['Bostadsrättsförening', 'BRF'],
    },
    {
        code: 'SSP9',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Azienda Speciale Rea',
        abbreviation: '',
        active: true,
        aliases: ['Azienda Speciale Rea'],
    },
    {
        code: 'ST2Q',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'Cooperative Marketing Association',
        abbreviation: '',
        active: true,
        aliases: ['Cooperative Marketing Association'],
    },
    {
        code: 'STBC',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Société coopérative organisée sous forme de société anonyme',
        abbreviation: '',
        active: true,
        aliases: ['Société coopérative organisée sous forme de société anonyme'],
    },
    {
        code: 'STUP',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Národná banka Slovenska',
        abbreviation: 'NBS',
        active: true,
        aliases: ['Národná banka Slovenska', 'NBS'],
    },
    {
        code: 'STX7',
        country: 'GB',
        jurisdiction: 'GB-SCT',
        jurisdictionName: 'Scotland',
        name: 'Scottish Charitable Incorporated Organisation',
        abbreviation: '',
        active: true,
        aliases: ['Scottish Charitable Incorporated Organisation'],
    },
    {
        code: 'SU5T',
        country: 'US',
        jurisdiction: 'US-MO',
        jurisdictionName: 'Missouri',
        name: 'Cooperative Association',
        abbreviation: 'Co-op;C.A.',
        active: true,
        aliases: ['Cooperative Association', 'Co-op;C.A.'],
    },
    {
        code: 'SUA1',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Europäische Genossenschaft',
        abbreviation: 'SCE',
        active: true,
        aliases: ['Europäische Genossenschaft', 'SCE'],
    },
    {
        code: 'SUEQ',
        country: 'US',
        jurisdiction: 'US-NV',
        jurisdictionName: 'Nevada',
        name: 'Business Trust',
        abbreviation: 'B.T.;BT',
        active: true,
        aliases: ['Business Trust', 'B.T.;BT'],
    },
    {
        code: 'SUH3',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Záujmová organizácia družstiev',
        abbreviation: 'Záujmová org.družstiev',
        active: true,
        aliases: ['Záujmová organizácia družstiev', 'Záujmová org.družstiev'],
    },
    {
        code: 'SUHV',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Muu verotuksen yksikkö',
        abbreviation: '',
        active: true,
        aliases: ['Muu verotuksen yksikkö', 'Annan enhet inom beskattningen'],
    },
    {
        code: 'SUMS',
        country: 'US',
        jurisdiction: 'US-WV',
        jurisdictionName: 'West Virginia',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP'],
    },
    {
        code: 'SV3F',
        country: 'MY',
        jurisdiction: 'MY',
        jurisdictionName: 'Malaysia',
        name: 'Sole Proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['Sole Proprietorship'],
    },
    {
        code: 'SV6U',
        country: 'OM',
        jurisdiction: 'OM',
        jurisdictionName: 'Oman',
        name: 'شركة التوصية',
        abbreviation: '',
        active: true,
        aliases: ['شركة التوصية', 'sharikat altawsia'],
    },
    {
        code: 'SVA3',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'fundusze inne niż inwestycyjne i inne niż otwarte fundusze emerytalne',
        abbreviation: '',
        active: true,
        aliases: ['fundusze inne niż inwestycyjne i inne niż otwarte fundusze emerytalne'],
    },
    {
        code: 'SW88',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'SWH1',
        country: 'BH',
        jurisdiction: 'BH',
        jurisdictionName: 'Bahrain',
        name: 'شركة تضامن',
        abbreviation: '',
        active: true,
        aliases: ['شركة تضامن', 'Sharikat tadamun'],
    },
    {
        code: 'SWMK',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Societate în comandită pe acţiuni',
        abbreviation: 'SCA',
        active: true,
        aliases: ['Societate în comandită pe acţiuni', 'SCA'],
    },
    {
        code: 'SWO8',
        country: 'DO',
        jurisdiction: 'DO',
        jurisdictionName: 'Dominican Republic',
        name: 'Sociedad de Responsaibilidad Limitada',
        abbreviation: 'S. R. L.',
        active: true,
        aliases: ['Sociedad de Responsaibilidad Limitada', 'S. R. L.'],
    },
    {
        code: 'SWPX',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA coopérative de transport à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA coopérative de transport à conseil d'administration"],
    },
    {
        code: 'SXX9',
        country: 'SX',
        jurisdiction: 'SX',
        jurisdictionName: 'Sint Maarten',
        name: 'naamloze vennootschap',
        abbreviation: 'NV',
        active: true,
        aliases: ['naamloze vennootschap', 'NV'],
    },
    {
        code: 'SXY3',
        country: 'WS',
        jurisdiction: 'WS',
        jurisdictionName: 'Samoa',
        name: 'Incorporated society',
        abbreviation: '',
        active: true,
        aliases: ['Incorporated society'],
    },
    {
        code: 'SYPT',
        country: 'CA',
        jurisdiction: 'CA-NL',
        jurisdictionName: 'Newfoundland and Labrador',
        name: 'Limited Liability Partnership',
        abbreviation: 'limited liability partnership;LLP;Limited Liability Partnership',
        active: true,
        aliases: [
            'Limited Liability Partnership',
            'limited liability partnership;LLP;Limited Liability Partnership',
        ],
    },
    {
        code: 'SZ63',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Service déconcentré de l'État à compétence (inter) régionale",
        abbreviation: '',
        active: true,
        aliases: ["Service déconcentré de l'État à compétence (inter) régionale"],
    },
    {
        code: 'SZW0',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Eвропейско дружество',
        abbreviation: 'ЕД',
        active: true,
        aliases: ['Eвропейско дружество', 'Evropeysko druzhestvo', 'ЕД', 'ED'],
    },
    {
        code: 'T0CV',
        country: 'CA',
        jurisdiction: 'CA-NS',
        jurisdictionName: 'Nova Scotia',
        name: 'limited partnerships formed in NS',
        abbreviation: 'Limited Partnership',
        active: true,
        aliases: ['limited partnerships formed in NS', 'Limited Partnership'],
    },
    {
        code: 'T0KK',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '其他（宗教）',
        abbreviation: '',
        active: true,
        aliases: ['其他（宗教）', 'qi ta（ zong jiao ）'],
    },
    {
        code: 'T0KQ',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Svojpomocné poľnohospodárske družstvo',
        abbreviation: 'Svojpomoc.poľn.družstvo',
        active: true,
        aliases: ['Svojpomocné poľnohospodárske družstvo', 'Svojpomoc.poľn.družstvo'],
    },
    {
        code: 'T0XH',
        country: 'US',
        jurisdiction: 'US-UT',
        jurisdictionName: 'Utah',
        name: 'Benefit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Benefit Corporation'],
    },
    {
        code: 'T0YJ',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Kommanditgesellschaft auf Aktien',
        abbreviation: 'KGaA;GmbH & Co. KGaA;AG & Co. KGaA;Stiftung & Co. KGaA',
        active: true,
        aliases: [
            'Kommanditgesellschaft auf Aktien',
            'KGaA;GmbH & Co. KGaA;AG & Co. KGaA;Stiftung & Co. KGaA',
        ],
    },
    {
        code: 'T172',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Insurance Company',
        abbreviation: '',
        active: true,
        aliases: ['Insurance Company'],
    },
    {
        code: 'T1FT',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Evropská družstevní společnost',
        abbreviation: 'SCE',
        active: true,
        aliases: ['Evropská družstevní společnost', 'SCE'],
    },
    {
        code: 'T1JS',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Οντότητες που διέπονται από το δημόσιο δίκαιο',
        abbreviation: '',
        active: true,
        aliases: [
            'Οντότητες που διέπονται από το δημόσιο δίκαιο',
            'Ontotites pou diepontai apo to dimosio dikaio',
        ],
    },
    {
        code: 'T1LR',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Syndicat de copropriété',
        abbreviation: '',
        active: true,
        aliases: ['Syndicat de copropriété'],
    },
    {
        code: 'T25Y',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SCP d'avocats",
        abbreviation: '',
        active: true,
        aliases: ["SCP d'avocats"],
    },
    {
        code: 'T2DF',
        country: 'US',
        jurisdiction: 'US-OR',
        jurisdictionName: 'Oregon',
        name: 'Business Trust',
        abbreviation: 'trust',
        active: true,
        aliases: ['Business Trust', 'trust'],
    },
    {
        code: 'T2JS',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Close Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Close Corporation', 'Corporación Intima'],
    },
    {
        code: 'T2NA',
        country: 'SA',
        jurisdiction: 'SA',
        jurisdictionName: 'Saudi Arabia',
        name: 'شركة التضامن',
        abbreviation: '',
        active: true,
        aliases: ['شركة التضامن', 'sharikat altadamun'],
    },
    {
        code: 'T2X0',
        country: 'XK',
        jurisdiction: 'XK',
        jurisdictionName: 'Kosovo',
        name: 'Ortakëri e Përgjithshme',
        abbreviation: 'OP',
        active: true,
        aliases: ['Ortakëri e Përgjithshme', 'OP'],
    },
    {
        code: 'T2X1',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società In Nome Collettivo',
        abbreviation: 'SNC;S.N.C.',
        active: true,
        aliases: ['Società In Nome Collettivo', 'SNC;S.N.C.'],
    },
    {
        code: 'T31U',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Kuntainliiton liikelaitos',
        abbreviation: '',
        active: true,
        aliases: ['Kuntainliiton liikelaitos', 'Kommunförbundets affärsinrättning'],
    },
    {
        code: 'T362',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'Limited Liability Partnership',
        abbreviation: 'LLP;LIMITED LIABILITY PARTNERSHIP',
        active: true,
        aliases: ['Limited Liability Partnership', 'LLP;LIMITED LIABILITY PARTNERSHIP'],
    },
    {
        code: 'T3FE',
        country: 'MM',
        jurisdiction: 'MM',
        jurisdictionName: 'Myanmar',
        name: '၁၉၅၀ ခုနှစ် အထူးကုမ္ပဏီအက်ဥပဒေအရ အစုအားဖြင့်တာ၀န်ကန့်သတ်ထားသည့်အများနှင့် မသက်ဆိုင်သည့်ကုမ္ပဏီ၊',
        abbreviation: '',
        active: true,
        aliases: [
            '၁၉၅၀ ခုနှစ် အထူးကုမ္ပဏီအက်ဥပဒေအရ အစုအားဖြင့်တာ၀န်ကန့်သတ်ထားသည့်အများနှင့် မသက်ဆိုင်သည့်ကုမ္ပဏီ၊',
            '1 9 5 0 hkunhait aahtuu kumpane aaatupadayaar a hcu aarr hpyint tar 0 n k ant saathtarr saeet a myarrnhaint masaatsine saeet kumpane',
        ],
    },
    {
        code: 'T3IW',
        country: 'BJ',
        jurisdiction: 'BJ',
        jurisdictionName: 'Benin',
        name: 'Société par Actions Simplifiées',
        abbreviation: 'SAS',
        active: true,
        aliases: ['Société par Actions Simplifiées', 'SAS'],
    },
    {
        code: 'T3K4',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Yhteismetsä',
        abbreviation: '',
        active: true,
        aliases: ['Yhteismetsä', 'Samfälld skog'],
    },
    {
        code: 'T3NK',
        country: 'NE',
        jurisdiction: 'NE',
        jurisdictionName: 'Niger',
        name: 'Société en Nom Collectif',
        abbreviation: 'SNC',
        active: true,
        aliases: ['Société en Nom Collectif', 'SNC'],
    },
    {
        code: 'T3Q1',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Bytové družstvo',
        abbreviation: '',
        active: true,
        aliases: ['Bytové družstvo'],
    },
    {
        code: 'T417',
        country: 'JP',
        jurisdiction: 'JP',
        jurisdictionName: 'Japan',
        name: '株式会社',
        abbreviation: '株',
        active: true,
        aliases: ['株式会社', 'kabusikigaisya', '株'],
    },
    {
        code: 'T4KB',
        country: 'BB',
        jurisdiction: 'BB',
        jurisdictionName: 'Barbados',
        name: 'association',
        abbreviation: '',
        active: true,
        aliases: ['association'],
    },
    {
        code: 'T4LC',
        country: 'DO',
        jurisdiction: 'DO',
        jurisdictionName: 'Dominican Republic',
        name: 'Sociedad en Comandita por Acciones',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad en Comandita por Acciones'],
    },
    {
        code: 'T4M6',
        country: 'US',
        jurisdiction: 'US-NJ',
        jurisdictionName: 'New Jersey',
        name: 'Nonprofit Corporation',
        abbreviation: 'corp.;inc.',
        active: true,
        aliases: ['Nonprofit Corporation', 'corp.;inc.'],
    },
    {
        code: 'T4OL',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Cemetery associations',
        abbreviation: '',
        active: true,
        aliases: ['Cemetery associations'],
    },
    {
        code: 'T5HS',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Isalmic Trust',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Isalmic Trust'],
    },
    {
        code: 'T5MB',
        country: 'NE',
        jurisdiction: 'NE',
        jurisdictionName: 'Niger',
        name: 'Entreprise individuelle',
        abbreviation: 'EI',
        active: true,
        aliases: ['Entreprise individuelle', 'EI'],
    },
    {
        code: 'T5RL',
        country: 'AW',
        jurisdiction: 'AW',
        jurisdictionName: 'Aruba',
        name: 'Vennootschap buitenlands recht',
        abbreviation: '',
        active: false,
        aliases: ['Vennootschap buitenlands recht'],
    },
    {
        code: 'T5UM',
        country: 'KY',
        jurisdiction: 'KY',
        jurisdictionName: 'Cayman Islands',
        name: 'exempted limited duration company',
        abbreviation: 'LDC',
        active: true,
        aliases: ['exempted limited duration company', 'LDC'],
    },
    {
        code: 'T5X4',
        country: 'US',
        jurisdiction: 'US-CT',
        jurisdictionName: 'Connecticut',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'T5ZE',
        country: 'US',
        jurisdiction: 'US-OR',
        jurisdictionName: 'Oregon',
        name: 'Business Corporation',
        abbreviation: 'Corporation;Incorporated;Company;Limited',
        active: true,
        aliases: ['Business Corporation', 'Corporation;Incorporated;Company;Limited'],
    },
    {
        code: 'T61R',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'cyfyngedig',
        abbreviation: 'cyf;cyf.',
        active: false,
        aliases: ['cyfyngedig', 'cyf;cyf.'],
    },
    {
        code: 'T635',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Islamic Spendthrift/Protective Trust',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Islamic Spendthrift/Protective Trust'],
    },
    {
        code: 'T69Z',
        country: 'GH',
        jurisdiction: 'GH',
        jurisdictionName: 'Ghana',
        name: 'External Company',
        abbreviation: '',
        active: true,
        aliases: ['External Company'],
    },
    {
        code: 'T7D4',
        country: 'US',
        jurisdiction: 'US-IA',
        jurisdictionName: 'Iowa',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: 'T7PB',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'wspólnoty samorządowe',
        abbreviation: '',
        active: true,
        aliases: ['wspólnoty samorządowe'],
    },
    {
        code: 'T80N',
        country: 'US',
        jurisdiction: 'US-CT',
        jurisdictionName: 'Connecticut',
        name: 'Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Partnership'],
    },
    {
        code: 'T91C',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Professional Close Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Professional Close Corporation'],
    },
    {
        code: 'T91T',
        country: 'US',
        jurisdiction: 'US-DE',
        jurisdictionName: 'Delaware',
        name: 'Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership'],
    },
    {
        code: 'T922',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Burgerlijke vennootschap onder vorm van gewone commanditaire vennootschap',
        abbreviation: 'BV GCV',
        active: false,
        aliases: [
            'Burgerlijke vennootschap onder vorm van gewone commanditaire vennootschap',
            'BV GCV',
            'Société civile sous forme de société en commandite simple',
            'SC SCS',
            'Zivilrechtliche Gesellschaft in der Rechtsform einer einfachen Kommanditgesellschaft',
            'ZRG EKG',
        ],
    },
    {
        code: 'TA7J',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Société par actions constitué par Loi sur les compagnies de flottage',
        abbreviation: '',
        active: true,
        aliases: ['Société par actions constitué par Loi sur les compagnies de flottage'],
    },
    {
        code: 'TA98',
        country: 'CA',
        jurisdiction: 'CA-NT',
        jurisdictionName: 'Northwest Territories',
        name: 'Limited partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited partnership'],
    },
    {
        code: 'TA9Z',
        country: 'VI',
        jurisdiction: 'VI',
        jurisdictionName: 'Virgin Islands (U.S.)',
        name: 'Domestic Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Limited Liability Partnership'],
    },
    {
        code: 'TAV3',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Iná organizácia verejnej správy',
        abbreviation: 'Iná org.verejnej správy',
        active: true,
        aliases: ['Iná organizácia verejnej správy', 'Iná org.verejnej správy'],
    },
    {
        code: 'TB2C',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Europæisk økonomisk firmagruppe',
        abbreviation: 'EØFG',
        active: true,
        aliases: ['Europæisk økonomisk firmagruppe', 'EØFG'],
    },
    {
        code: 'TBG2',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '外国旅游部门常驻代表机构',
        abbreviation: '',
        active: true,
        aliases: ['外国旅游部门常驻代表机构', 'wai guo lv you bu men chang zhu dai biao ji gou'],
    },
    {
        code: 'TBN1',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Non-Profit Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-Profit Limited Liability Company'],
    },
    {
        code: 'TCC0',
        country: 'US',
        jurisdiction: 'US-VT',
        jurisdictionName: 'Vermont',
        name: 'Mutual Benefit Enterprise',
        abbreviation: 'MBE',
        active: true,
        aliases: ['Mutual Benefit Enterprise', 'MBE'],
    },
    {
        code: 'TCGV',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Дружество учредено по Закона за задълженията и договорите',
        abbreviation: 'ДЗЗД',
        active: true,
        aliases: [
            'Дружество учредено по Закона за задълженията и договорите',
            'Druzhestvo uchredeno po Zakona za zadalzheniyata i dogovorite',
            'ДЗЗД',
            'DZZD',
        ],
    },
    {
        code: 'TCLA',
        country: 'US',
        jurisdiction: 'US-TX',
        jurisdictionName: 'Texas',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'TCVB',
        country: 'SR',
        jurisdiction: 'SR',
        jurisdictionName: 'Suriname',
        name: 'Naamloze Vennootschap / Limited Company by Shares',
        abbreviation: 'NV;nv;N.V.;n.v.',
        active: true,
        aliases: ['Naamloze Vennootschap / Limited Company by Shares', 'NV;nv;N.V.;n.v.'],
    },
    {
        code: 'TD56',
        country: 'AZ',
        jurisdiction: 'AZ',
        jurisdictionName: 'Azerbaijan',
        name: 'Komandit ortaqlıq',
        abbreviation: '',
        active: true,
        aliases: ['Komandit ortaqlıq'],
    },
    {
        code: 'TD8P',
        country: 'TW',
        jurisdiction: 'TW',
        jurisdictionName: 'Taiwan (Province of China)',
        name: '股份有限公司',
        abbreviation: '',
        active: true,
        aliases: ['股份有限公司', 'gǔ fèn yǒu xiàn gōng sī'],
    },
    {
        code: 'TDBW',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Domestic Registered Limited Liability Partnership',
        abbreviation: 'registered limited liability partnership;L.L.P.',
        active: true,
        aliases: [
            'Domestic Registered Limited Liability Partnership',
            'registered limited liability partnership;L.L.P.',
        ],
    },
    {
        code: 'TDD5',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Comanditaria Simple',
        abbreviation: 'S. en C.;S. Com.',
        active: true,
        aliases: ['Sociedad Comanditaria Simple', 'S. en C.;S. Com.'],
    },
    {
        code: 'TE79',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Limited Partnership - with Legal Personality',
        abbreviation: '',
        active: true,
        aliases: ['Limited Partnership - with Legal Personality'],
    },
    {
        code: 'TEGV',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Special Corporation for Municipal Development',
        abbreviation: '',
        active: true,
        aliases: [
            'Special Corporation for Municipal Development',
            'Corporación Especial para el Desarrollo Municipal',
        ],
    },
    {
        code: 'TEPY',
        country: 'BB',
        jurisdiction: 'BB',
        jurisdictionName: 'Barbados',
        name: 'public company',
        abbreviation: 'ltd.;corp.;inc.',
        active: true,
        aliases: ['public company', 'ltd.;corp.;inc.'],
    },
    {
        code: 'TF8L',
        country: 'NZ',
        jurisdiction: 'NZ',
        jurisdictionName: 'New Zealand',
        name: 'Charitable Trust',
        abbreviation: 'CT',
        active: true,
        aliases: ['Charitable Trust', 'CT'],
    },
    {
        code: 'TFNS',
        country: 'BS',
        jurisdiction: 'BS',
        jurisdictionName: 'Bahamas',
        name: 'Bahamas Executive Entity',
        abbreviation: 'BEE',
        active: true,
        aliases: ['Bahamas Executive Entity', 'BEE'],
    },
    {
        code: 'TFXK',
        country: 'MC',
        jurisdiction: 'MC',
        jurisdictionName: 'Monaco',
        name: 'Société Unipersonelle à Responsabilité Limitée',
        abbreviation: 'SURL',
        active: true,
        aliases: ['Société Unipersonelle à Responsabilité Limitée', 'SURL'],
    },
    {
        code: 'TG3X',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Podnikateľ-fyzická osoba-nezapís.v OR-podnikajúca súčasne ako sam.hosp.roľník',
        abbreviation: 'Živ. a SHR roľník',
        active: true,
        aliases: [
            'Podnikateľ-fyzická osoba-nezapís.v OR-podnikajúca súčasne ako sam.hosp.roľník',
            'Živ. a SHR roľník',
        ],
    },
    {
        code: 'TGLV',
        country: 'CA',
        jurisdiction: 'CA-BC',
        jurisdictionName: 'British Columbia',
        name: 'Extraprovincial corporation (registered foreign entity)',
        abbreviation: 'Ltd.;Inc.;Corp.',
        active: true,
        aliases: ['Extraprovincial corporation (registered foreign entity)', 'Ltd.;Inc.;Corp.'],
    },
    {
        code: 'TGMR',
        country: 'US',
        jurisdiction: 'US-DE',
        jurisdictionName: 'Delaware',
        name: 'Limited Liability Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Limited Partnership'],
    },
    {
        code: 'TGRE',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Caisse des écoles',
        abbreviation: '',
        active: true,
        aliases: ['Caisse des écoles'],
    },
    {
        code: 'TGWE',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Islamic Purpose Trust',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Islamic Purpose Trust'],
    },
    {
        code: 'TH8A',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Asociatie familiala',
        abbreviation: 'AF',
        active: true,
        aliases: ['Asociatie familiala', 'AF'],
    },
    {
        code: 'THVZ',
        country: 'IL',
        jurisdiction: 'IL',
        jurisdictionName: 'Israel',
        name: 'עוסק פטור',
        abbreviation: '',
        active: true,
        aliases: ['עוסק פטור', 'Osek Patur'],
    },
    {
        code: 'TIZ2',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Ομόρρυθμη Εταιρία',
        abbreviation: 'OE',
        active: true,
        aliases: ['Ομόρρυθμη Εταιρία', 'Omórithmi Etería', 'OE'],
    },
    {
        code: 'TJ6V',
        country: 'US',
        jurisdiction: 'US-DC',
        jurisdictionName: 'District of Columbia',
        name: 'Limited Liability Partnership',
        abbreviation: 'L.L.P.;R.L.L.P.;LLP;RLLP',
        active: true,
        aliases: ['Limited Liability Partnership', 'L.L.P.;R.L.L.P.;LLP;RLLP'],
    },
    {
        code: 'TKAB',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: "Société par actions constitué par Loi sur les sociétés de développement de l'entreprise québécoise",
        abbreviation: '',
        active: true,
        aliases: [
            "Société par actions constitué par Loi sur les sociétés de développement de l'entreprise québécoise",
        ],
    },
    {
        code: 'TKPE',
        country: 'GI',
        jurisdiction: 'GI',
        jurisdictionName: 'Gibraltar',
        name: 'Private Trust Company',
        abbreviation: 'PTC',
        active: true,
        aliases: ['Private Trust Company', 'PTC'],
    },
    {
        code: 'TL87',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Limited partnership for collective investments',
        abbreviation: 'Ldt part. Coll. Invest.',
        active: true,
        aliases: [
            'Limited partnership for collective investments',
            'Ldt part. Coll. Invest.',
            'Société en commandite de placements collectifs',
            'Soc. com. Investissement',
            'Kommanditgesellschaft fuer kollektive Kapitalanlagen',
            'Kommandit. Kapitalanlagen',
            'Società in accomandita per investimenti collettivi di capitale',
            'Soc. com. investimenti',
        ],
    },
    {
        code: 'TLCB',
        country: 'JM',
        jurisdiction: 'JM',
        jurisdictionName: 'Jamaica',
        name: 'non profit company',
        abbreviation: '',
        active: true,
        aliases: ['non profit company'],
    },
    {
        code: 'TLCJ',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'junta de compensación',
        abbreviation: '',
        active: true,
        aliases: ['junta de compensación'],
    },
    {
        code: 'TLDB',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Союзы потребительских обществ',
        abbreviation: '',
        active: true,
        aliases: ['Союзы потребительских обществ', "Soyuzy potrebitel'skikh obshchestv"],
    },
    {
        code: 'TMHL',
        country: 'UY',
        jurisdiction: 'UY',
        jurisdictionName: 'Uruguay',
        name: 'Asociacion',
        abbreviation: '',
        active: true,
        aliases: ['Asociacion'],
    },
    {
        code: 'TMIG',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Федеральные государственные казенные учреждения',
        abbreviation: '',
        active: true,
        aliases: [
            'Федеральные государственные казенные учреждения',
            "Federal'nyye gosudarstvennyye kazennyye uchrezhdeniya",
        ],
    },
    {
        code: 'TMK1',
        country: 'GU',
        jurisdiction: 'GU',
        jurisdictionName: 'Guam',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'TMU1',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Anstalt',
        abbreviation: '',
        active: true,
        aliases: ['Anstalt'],
    },
    {
        code: 'TMVE',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Zadruga brez odgovornosti',
        abbreviation: 'z.b.o.',
        active: true,
        aliases: ['Zadruga brez odgovornosti', 'z.b.o.'],
    },
    {
        code: 'TNBA',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Odštěpný závod zahraniční právnické osoby',
        abbreviation: '',
        active: false,
        aliases: ['Odštěpný závod zahraniční právnické osoby'],
    },
    {
        code: 'TNHO',
        country: 'BO',
        jurisdiction: 'BO',
        jurisdictionName: 'Bolivia (Plurinational State of)',
        name: 'Sociedad Colectiva',
        abbreviation: 'S.C.',
        active: true,
        aliases: ['Sociedad Colectiva', 'S.C.'],
    },
    {
        code: 'TNPO',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Exploitant agricole',
        abbreviation: '',
        active: false,
        aliases: ['Exploitant agricole'],
    },
    {
        code: 'TOBE',
        country: 'US',
        jurisdiction: 'US-CO',
        jurisdictionName: 'Colorado',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'TOL2',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SA nationale à directoire',
        abbreviation: '',
        active: true,
        aliases: ['SA nationale à directoire'],
    },
    {
        code: 'TOMA',
        country: 'WS',
        jurisdiction: 'WS',
        jurisdictionName: 'Samoa',
        name: 'Co-operative society',
        abbreviation: '',
        active: true,
        aliases: ['Co-operative society'],
    },
    {
        code: 'TPFL',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Bank (Corporation)',
        abbreviation: '',
        active: true,
        aliases: ['Bank (Corporation)', 'Banco (Corporación)'],
    },
    {
        code: 'TPJZ',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima promotora de inversión',
        abbreviation: 'S.A. P.I.',
        active: true,
        aliases: ['Sociedad anónima promotora de inversión', 'S.A. P.I.'],
    },
    {
        code: 'TPNT',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société européenne',
        abbreviation: 'SE',
        active: true,
        aliases: ['Société européenne', 'SE'],
    },
    {
        code: 'TPO4',
        country: 'US',
        jurisdiction: 'US-MI',
        jurisdictionName: 'Michigan',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'TPTU',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Naamloze vennootschap van publiek recht',
        abbreviation: 'NV PR',
        active: true,
        aliases: [
            'Naamloze vennootschap van publiek recht',
            'NV PR',
            'Société anonyme de droit public',
            'SA DPU',
            'Öffentlich-rechtliche Aktiengesellschaft',
            'Ö.-r.AG',
        ],
    },
    {
        code: 'TPZ2',
        country: 'CA',
        jurisdiction: 'CA-NT',
        jurisdictionName: 'Northwest Territories',
        name: 'private act corporation',
        abbreviation: '',
        active: true,
        aliases: ['private act corporation'],
    },
    {
        code: 'TQ3O',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Egyéb, máshova nem sorolt jogi személyiségű vállalkozás',
        abbreviation: '',
        active: false,
        aliases: ['Egyéb, máshova nem sorolt jogi személyiségű vállalkozás'],
    },
    {
        code: 'TQ3Z',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Limited by Shares (2006 Act)',
        abbreviation: '',
        active: true,
        aliases: ['Limited by Shares (2006 Act)'],
    },
    {
        code: 'TRI2',
        country: 'US',
        jurisdiction: 'US-FL',
        jurisdictionName: 'Florida',
        name: 'Profit Corporation',
        abbreviation: 'Corporation;Company;Incorporated;Corp.; Inc.; Co;Chartered;P.A.',
        active: true,
        aliases: [
            'Profit Corporation',
            'Corporation;Company;Incorporated;Corp.; Inc.; Co;Chartered;P.A.',
        ],
    },
    {
        code: 'TRO6',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'agricultural society',
        abbreviation: '',
        active: true,
        aliases: ['agricultural society'],
    },
    {
        code: 'TRS2',
        country: 'US',
        jurisdiction: 'US-AK',
        jurisdictionName: 'Alaska',
        name: 'Cooperative Corporation',
        abbreviation: 'COOP',
        active: true,
        aliases: ['Cooperative Corporation', 'COOP'],
    },
    {
        code: 'TRWS',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Unincorporated Association',
        abbreviation: '',
        active: true,
        aliases: ['Unincorporated Association'],
    },
    {
        code: 'TS1K',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'TS9O',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'religious society',
        abbreviation: '',
        active: true,
        aliases: ['religious society'],
    },
    {
        code: 'TSA0',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Tijelo državne uprave',
        abbreviation: '',
        active: true,
        aliases: ['Tijelo državne uprave'],
    },
    {
        code: 'TSQ7',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'agricultural fair association',
        abbreviation: '',
        active: true,
        aliases: ['agricultural fair association', 'association de foires agricoles'],
    },
    {
        code: 'TSVO',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Szövetség (kivéve sportszövetség)',
        abbreviation: 'kbe',
        active: true,
        aliases: ['Szövetség (kivéve sportszövetség)', 'kbe'],
    },
    {
        code: 'TT2H',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Protected Cell Company',
        abbreviation: '',
        active: true,
        aliases: ['Protected Cell Company'],
    },
    {
        code: 'TTB3',
        country: 'US',
        jurisdiction: 'US-ME',
        jurisdictionName: 'Maine',
        name: 'Business Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Business Corporation'],
    },
    {
        code: 'TTE8',
        country: 'SA',
        jurisdiction: 'SA',
        jurisdictionName: 'Saudi Arabia',
        name: 'شركه ذات مسؤولية محدودة',
        abbreviation: '',
        active: true,
        aliases: ['شركه ذات مسؤولية محدودة', 'sharakah dhat maswuwliat mahduda'],
    },
    {
        code: 'TTIF',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima bursátil de capital variable, sociedad financiera de objeto múltiple, entidad no regulada',
        abbreviation: 'S.A.B. DE C.V., SOFOM E.N.R.',
        active: true,
        aliases: [
            'Sociedad anónima bursátil de capital variable, sociedad financiera de objeto múltiple, entidad no regulada',
            'S.A.B. DE C.V., SOFOM E.N.R.',
        ],
    },
    {
        code: 'TTTV',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Corporation Sole',
        abbreviation: 'Corp.;Ltd.;Inc.',
        active: true,
        aliases: ['Corporation Sole', 'Corp.;Ltd.;Inc.'],
    },
    {
        code: 'TU6A',
        country: 'MC',
        jurisdiction: 'MC',
        jurisdictionName: 'Monaco',
        name: 'Société en Nom Collectif',
        abbreviation: 'SNC',
        active: true,
        aliases: ['Société en Nom Collectif', 'SNC'],
    },
    {
        code: 'TUE5',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Office public d'habitation à loyer modéré (OPHLM)",
        abbreviation: '',
        active: true,
        aliases: ["Office public d'habitation à loyer modéré (OPHLM)"],
    },
    {
        code: 'TUHS',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Corporación de Derecho Público',
        abbreviation: '',
        active: true,
        aliases: ['Corporación de Derecho Público'],
    },
    {
        code: 'TV5P',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Unlimited without Shares (2006 Act)',
        abbreviation: '',
        active: true,
        aliases: ['Unlimited without Shares (2006 Act)'],
    },
    {
        code: 'TV8Y',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Kollektivtreuhänderschaft',
        abbreviation: '',
        active: true,
        aliases: ['Kollektivtreuhänderschaft'],
    },
    {
        code: 'TWLR',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Association',
        abbreviation: '',
        active: true,
        aliases: ['Association'],
    },
    {
        code: 'TXCW',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Recognized Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Recognized Limited Liability Partnership'],
    },
    {
        code: 'TXVC',
        country: 'AU',
        jurisdiction: 'AU',
        jurisdictionName: 'Australia',
        name: 'Limited Proprietary Company',
        abbreviation: 'Proprietary Limited;Proprietary Ltd;Pty Limited;PTY LTD;PTY. LTD.;Pty. Ltd.;Pty Ltd;Pty Ltd.',
        active: true,
        aliases: [
            'Limited Proprietary Company',
            'Proprietary Limited;Proprietary Ltd;Pty Limited;PTY LTD;PTY. LTD.;Pty. Ltd.;Pty Ltd;Pty Ltd.',
        ],
    },
    {
        code: 'TY0S',
        country: 'CA',
        jurisdiction: 'CA-NS',
        jurisdictionName: 'Nova Scotia',
        name: 'A company formed under the Companies Act may seek designation as a Private Investment Holding Company',
        abbreviation: 'Limited;Limitée;Ltd.;Ltée;Incorporated;Inc.;Ltd',
        active: true,
        aliases: [
            'A company formed under the Companies Act may seek designation as a Private Investment Holding Company',
            'Limited;Limitée;Ltd.;Ltée;Incorporated;Inc.;Ltd',
        ],
    },
    {
        code: 'TYJK',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Private Limited by Guarantee/No Share Capital (Use of Limited Exemption)',
        abbreviation: '',
        active: false,
        aliases: ['Private Limited by Guarantee/No Share Capital (Use of Limited Exemption)'],
    },
    {
        code: 'TYW0',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima bursátil de capital variable, sociedad controladora',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima bursátil de capital variable, sociedad controladora'],
    },
    {
        code: 'TZ1U',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Kunnallinen liikelaitos',
        abbreviation: '',
        active: true,
        aliases: ['Kunnallinen liikelaitos', 'Kommunal affärsinrättning'],
    },
    {
        code: 'TZDZ',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'TZQL',
        country: 'US',
        jurisdiction: 'US-DC',
        jurisdictionName: 'District of Columbia',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'U0SP',
        country: 'AZ',
        jurisdiction: 'AZ',
        jurisdictionName: 'Azerbaijan',
        name: 'İctimai birliklər',
        abbreviation: '',
        active: true,
        aliases: ['İctimai birliklər'],
    },
    {
        code: 'U1EG',
        country: 'US',
        jurisdiction: 'US-OR',
        jurisdictionName: 'Oregon',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'U24X',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Συνεργατικά Πιστωτικά Ιδρύματα',
        abbreviation: '',
        active: true,
        aliases: ['Συνεργατικά Πιστωτικά Ιδρύματα', 'Synergatika Pistotika Idrymata'],
    },
    {
        code: 'U2PN',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Commanditaire vennootschap op aandelen',
        abbreviation: 'Comm.VA',
        active: true,
        aliases: [
            'Commanditaire vennootschap op aandelen',
            'Comm.VA',
            'Société en commandite par actions',
            'SCA',
            'Kommanditgesellschaft auf Aktien',
            'KGaA',
        ],
    },
    {
        code: 'U3QQ',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Banka - akciová spoločnosť',
        abbreviation: 'Banka - a. s.',
        active: true,
        aliases: ['Banka - akciová spoločnosť', 'Banka - a. s.'],
    },
    {
        code: 'U5AR',
        country: 'VC',
        jurisdiction: 'VC',
        jurisdictionName: 'Saint Vincent and the Grenadines',
        name: 'statutory company',
        abbreviation: '',
        active: true,
        aliases: ['statutory company'],
    },
    {
        code: 'U5IM',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Železnice SR',
        abbreviation: '',
        active: true,
        aliases: ['Železnice SR'],
    },
    {
        code: 'U5KF',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Burgerlijke vennootschap onder vorm van vennootschap onder firma',
        abbreviation: 'BV VOF',
        active: false,
        aliases: [
            'Burgerlijke vennootschap onder vorm van vennootschap onder firma',
            'BV VOF',
            'Société civile sous forme de société en nom collectif',
            'SC SNC',
            'Zivilrechtliche Gesellschaft in der Rechtsform einer offenen Handelsgesellschaft',
            'ZRG OHG',
        ],
    },
    {
        code: 'U5RF',
        country: 'GU',
        jurisdiction: 'GU',
        jurisdictionName: 'Guam',
        name: 'partnership',
        abbreviation: '',
        active: true,
        aliases: ['partnership'],
    },
    {
        code: 'U5S6',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Limited Liability Partnership',
        abbreviation: 'LLP',
        active: true,
        aliases: ['Limited Liability Partnership', 'LLP'],
    },
    {
        code: 'U6R9',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'European Economic Interest Grouping',
        abbreviation: 'EEIG',
        active: false,
        aliases: ['European Economic Interest Grouping', 'EEIG'],
    },
    {
        code: 'U77P',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, institución de fianzas',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima de capital variable, institución de fianzas'],
    },
    {
        code: 'U7GR',
        country: 'US',
        jurisdiction: 'US-MS',
        jurisdictionName: 'Mississippi',
        name: 'Limited Liability Partnership',
        abbreviation: 'L.L.P.;R.L.L.P.;LLP;RLLP',
        active: true,
        aliases: ['Limited Liability Partnership', 'L.L.P.;R.L.L.P.;LLP;RLLP'],
    },
    {
        code: 'U7HC',
        country: 'US',
        jurisdiction: 'US-MI',
        jurisdictionName: 'Michigan',
        name: 'Corporation (For-Profit)',
        abbreviation: 'Corp.;Corp;Co.;Co;Inc.;Inc;Ltd.;Ltd;Corporation;Company;Incorporated;Limited',
        active: true,
        aliases: [
            'Corporation (For-Profit)',
            'Corp.;Corp;Co.;Co;Inc.;Inc;Ltd.;Ltd;Corporation;Company;Incorporated;Limited',
        ],
    },
    {
        code: 'U7OR',
        country: 'US',
        jurisdiction: 'US-MO',
        jurisdictionName: 'Missouri',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'U7QK',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Nadácia',
        abbreviation: '',
        active: true,
        aliases: ['Nadácia'],
    },
    {
        code: 'U82F',
        country: 'AR',
        jurisdiction: 'AR',
        jurisdictionName: 'Argentina',
        name: 'Sociedad De Responsalided Limitada',
        abbreviation: 'S.R.L',
        active: true,
        aliases: ['Sociedad De Responsalided Limitada', 'S.R.L'],
    },
    {
        code: 'U87X',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Nonprofit Corporation',
        abbreviation: 'corp.;inc.',
        active: true,
        aliases: ['Nonprofit Corporation', 'corp.;inc.'],
    },
    {
        code: 'U89P',
        country: 'ZA',
        jurisdiction: 'ZA',
        jurisdictionName: 'South Africa',
        name: 'Personal Liability Company',
        abbreviation: 'Inc',
        active: true,
        aliases: ['Personal Liability Company', 'Inc'],
    },
    {
        code: 'U8KA',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Société en commandite spéciale',
        abbreviation: 'SECSP',
        active: true,
        aliases: ['Société en commandite spéciale', 'SECSP'],
    },
    {
        code: 'U8LM',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Eвропейско кооперативно дружество',
        abbreviation: 'ЕКД',
        active: true,
        aliases: [
            'Eвропейско кооперативно дружество',
            'Evropeysko kooperativno druzhestvo',
            'ЕКД',
            'EKD',
        ],
    },
    {
        code: 'U8NM',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Mutual Fund',
        abbreviation: '',
        active: true,
        aliases: ['Mutual Fund'],
    },
    {
        code: 'U901',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Instituciones de Seguros',
        abbreviation: '',
        active: true,
        aliases: ['Instituciones de Seguros'],
    },
    {
        code: 'U938',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'Alberta limited liability partnership',
        abbreviation: '',
        active: true,
        aliases: ['Alberta limited liability partnership'],
    },
    {
        code: 'U94O',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Captive Insurance Company',
        abbreviation: 'corp.;inc.;co.;ltd. Incorporated;company;limited;corporation',
        active: true,
        aliases: [
            'Captive Insurance Company',
            'corp.;inc.;co.;ltd. Incorporated;company;limited;corporation',
        ],
    },
    {
        code: 'U95A',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Odštěpný závod zahraniční fyzické osoby',
        abbreviation: '',
        active: true,
        aliases: ['Odštěpný závod zahraniční fyzické osoby'],
    },
    {
        code: 'U9HL',
        country: 'US',
        jurisdiction: 'US-ID',
        jurisdictionName: 'Idaho',
        name: 'General Business Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.',
        active: true,
        aliases: ['General Business Corporation', 'corp.;inc.;co.;ltd.'],
    },
    {
        code: 'UA1O',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Europæisk selskab',
        abbreviation: 'SE-selskab',
        active: true,
        aliases: ['Europæisk selskab', 'SE-selskab'],
    },
    {
        code: 'UAES',
        country: 'AE',
        jurisdiction: 'AE-RK',
        jurisdictionName: 'Ras Al Khaimah',
        name: 'RAK Economic Zone Company',
        abbreviation: 'FZ LLC',
        active: true,
        aliases: ['RAK Economic Zone Company', 'FZ LLC'],
    },
    {
        code: 'UAV1',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Eurooppaosuuskunta',
        abbreviation: 'SCE',
        active: true,
        aliases: ['Eurooppaosuuskunta', 'SCE', 'Europaandelslag'],
    },
    {
        code: 'UBV0',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima de capital variable, fondo de inversión en instrumentos de deuda',
        abbreviation: 'S. A. de C. V., F. I. en I. D.',
        active: true,
        aliases: [
            'Sociedad anónima de capital variable, fondo de inversión en instrumentos de deuda',
            'S. A. de C. V., F. I. en I. D.',
        ],
    },
    {
        code: 'UBWU',
        country: 'JE',
        jurisdiction: 'JE',
        jurisdictionName: 'Jersey',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP;limited partnership;Limited Partnership',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP;limited partnership;Limited Partnership'],
    },
    {
        code: 'UCR1',
        country: 'FO',
        jurisdiction: 'FO',
        jurisdictionName: 'Faroe Islands',
        name: 'Alment partafelag',
        abbreviation: '',
        active: true,
        aliases: ['Alment partafelag'],
    },
    {
        code: 'UCT9',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Burgerlijke Vennootschap onder vorm van Landbouwvennootschap (BV LV)',
        abbreviation: 'BV LV',
        active: false,
        aliases: [
            'Burgerlijke Vennootschap onder vorm van Landbouwvennootschap (BV LV)',
            'BV LV',
            'Société civile sous forme de société agricole',
            'SC SAGR',
            'Zivilrechtliche Gesellschaft in der Rechtsform einer landwirtschaftlichen Gesellschaft',
            'ZRG LG',
        ],
    },
    {
        code: 'UCTO',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Oblastná organizačná jednotka ČSD',
        abbreviation: 'Obl.org.jednotka ČSD',
        active: true,
        aliases: ['Oblastná organizačná jednotka ČSD', 'Obl.org.jednotka ČSD'],
    },
    {
        code: 'UCU5',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Ετερόρρυθμη κατά μετοχές εταιρεία',
        abbreviation: '',
        active: true,
        aliases: ['Ετερόρρυθμη κατά μετοχές εταιρεία', 'Εterorrythmi kata metoches etaireia'],
    },
    {
        code: 'UD1V',
        country: 'ID',
        jurisdiction: 'ID',
        jurisdictionName: 'Indonesia',
        name: 'Perseroan Terbatas Penanaman Modal Dalam Negeri',
        abbreviation: 'PT;PT PMDN',
        active: true,
        aliases: ['Perseroan Terbatas Penanaman Modal Dalam Negeri', 'PT;PT PMDN'],
    },
    {
        code: 'UD8K',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Külföldi székhelyű vállalkozás fióktelepe',
        abbreviation: '',
        active: false,
        aliases: ['Külföldi székhelyű vállalkozás fióktelepe'],
    },
    {
        code: 'UDG6',
        country: 'HK',
        jurisdiction: 'HK',
        jurisdictionName: 'Hong Kong',
        name: '有股本的私人無限公司',
        abbreviation: '無限公司',
        active: true,
        aliases: [
            '有股本的私人無限公司',
            'You gu ben de si ren wu xian gong si',
            '無限公司',
            'Private unlimited company with a share capital',
            'Unltd;Ultd',
        ],
    },
    {
        code: 'UDJG',
        country: 'KR',
        jurisdiction: 'KR',
        jurisdictionName: 'Korea (Republic of)',
        name: '유한책임회사',
        abbreviation: '',
        active: true,
        aliases: ['유한책임회사', 'YuHanChaekImHoeSa'],
    },
    {
        code: 'UDLA',
        country: 'CA',
        jurisdiction: 'CA',
        jurisdictionName: 'Canada',
        name: 'business corporation',
        abbreviation: 'Ltd.;Inc.;Corp.',
        active: true,
        aliases: [
            'business corporation',
            'Ltd.;Inc.;Corp.',
            'société par actions',
            'Ltée;Inc.;S.A.R.F.',
        ],
    },
    {
        code: 'UDQJ',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Gospodarsko interesno združenje',
        abbreviation: 'GIZ',
        active: true,
        aliases: ['Gospodarsko interesno združenje', 'GIZ'],
    },
    {
        code: 'UDY2',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: "Société d'investissement à capital variable",
        abbreviation: 'SICAV',
        active: true,
        aliases: ["Société d'investissement à capital variable", 'SICAV'],
    },
    {
        code: 'UE3G',
        country: 'KY',
        jurisdiction: 'KY',
        jurisdictionName: 'Cayman Islands',
        name: 'exempt company',
        abbreviation: '',
        active: true,
        aliases: ['exempt company'],
    },
    {
        code: 'UEKV',
        country: 'US',
        jurisdiction: 'US-UT',
        jurisdictionName: 'Utah',
        name: 'Low Profit LLC',
        abbreviation: 'L3C;l3c',
        active: true,
        aliases: ['Low Profit LLC', 'L3C;l3c'],
    },
    {
        code: 'UESF',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Javni sklad',
        abbreviation: '',
        active: true,
        aliases: ['Javni sklad'],
    },
    {
        code: 'UF6Y',
        country: 'US',
        jurisdiction: 'US-VT',
        jurisdictionName: 'Vermont',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP'],
    },
    {
        code: 'UFBW',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Comunidad de Bienes',
        abbreviation: 'CB',
        active: true,
        aliases: ['Comunidad de Bienes', 'CB'],
    },
    {
        code: 'UFDA',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Národní podnik',
        abbreviation: '',
        active: true,
        aliases: ['Národní podnik'],
    },
    {
        code: 'UFG8',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Фондация',
        abbreviation: '',
        active: true,
        aliases: ['Фондация', 'Fondatsia'],
    },
    {
        code: 'UFIY',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Bank',
        abbreviation: 'corp.;inc.;co.;ltd. Incorporated;company;limited;corporation',
        active: false,
        aliases: ['Bank', 'corp.;inc.;co.;ltd. Incorporated;company;limited;corporation'],
    },
    {
        code: 'UFM7',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SA coopérative de construction à directoire',
        abbreviation: '',
        active: true,
        aliases: ['SA coopérative de construction à directoire'],
    },
    {
        code: 'UG0E',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Dobrodelna organizacija',
        abbreviation: '',
        active: true,
        aliases: ['Dobrodelna organizacija'],
    },
    {
        code: 'UG3Z',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Société par actions par Loi sur les sociétés par actions',
        abbreviation: 's.a.;ltée;inc.',
        active: true,
        aliases: [
            'Société par actions par Loi sur les sociétés par actions',
            's.a.;ltée;inc.',
            'corp.;ltd;inc.',
        ],
    },
    {
        code: 'UGE3',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'Nonprofit Electric Generation and Transmission Cooperative Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Electric Generation and Transmission Cooperative Corporation'],
    },
    {
        code: 'UGKR',
        country: 'US',
        jurisdiction: 'US-IA',
        jurisdictionName: 'Iowa',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'UGVB',
        country: 'KR',
        jurisdiction: 'KR',
        jurisdictionName: 'Korea (Republic of)',
        name: '신탁형 펀드',
        abbreviation: '',
        active: true,
        aliases: ['신탁형 펀드', 'SinTakHyeong fund'],
    },
    {
        code: 'UGWE',
        country: 'AM',
        jurisdiction: 'AM',
        jurisdictionName: 'Armenia',
        name: 'Վստահության վրա հիմնված ընկերակցություն',
        abbreviation: '',
        active: true,
        aliases: [
            'Վստահության վրա հիմնված ընկերակցություն',
            'Vstahutʿyan vra himnvats enkeraktsʿutʿyun',
        ],
    },
    {
        code: 'UHKH',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société de caution mutuelle',
        abbreviation: '',
        active: true,
        aliases: ['Société de caution mutuelle'],
    },
    {
        code: 'UHNL',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Žemės ūkio bendrovės',
        abbreviation: 'ZUB',
        active: true,
        aliases: ['Žemės ūkio bendrovės', 'ZUB'],
    },
    {
        code: 'UI81',
        country: 'AT',
        jurisdiction: 'AT',
        jurisdictionName: 'Austria',
        name: 'Gesellschaft des bürgerlichen Rechts',
        abbreviation: 'GesbR',
        active: true,
        aliases: ['Gesellschaft des bürgerlichen Rechts', 'GesbR'],
    },
    {
        code: 'UJ35',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Fondo de Inversion Mobiliaria',
        abbreviation: 'F.I.M.',
        active: true,
        aliases: ['Fondo de Inversion Mobiliaria', 'F.I.M.'],
    },
    {
        code: 'UJ49',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Cooperative (Investor)',
        abbreviation: '',
        active: true,
        aliases: ['Cooperative (Investor)'],
    },
    {
        code: 'UJKE',
        country: 'US',
        jurisdiction: 'US-MO',
        jurisdictionName: 'Missouri',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'UJZB',
        country: 'US',
        jurisdiction: 'US-MI',
        jurisdictionName: 'Michigan',
        name: 'Ecclesiastical Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Ecclesiastical Corporation'],
    },
    {
        code: 'UK9P',
        country: 'US',
        jurisdiction: 'US-ID',
        jurisdictionName: 'Idaho',
        name: 'General Partnership',
        abbreviation: '',
        active: true,
        aliases: ['General Partnership'],
    },
    {
        code: 'UKOL',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'enkelt bolag',
        abbreviation: '',
        active: true,
        aliases: ['enkelt bolag'],
    },
    {
        code: 'UKX4',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'State Savings Bank',
        abbreviation: 'corp.;inc.;co.;ltd. Incorporated;company;limited;corporation;SSB',
        active: false,
        aliases: [
            'State Savings Bank',
            'corp.;inc.;co.;ltd. Incorporated;company;limited;corporation;SSB',
        ],
    },
    {
        code: 'UL6C',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Savings & Credit Cooperative',
        abbreviation: '',
        active: false,
        aliases: ['Savings & Credit Cooperative', 'Corporación Intima'],
    },
    {
        code: 'ULJ1',
        country: 'CA',
        jurisdiction: 'CA-NS',
        jurisdictionName: 'Nova Scotia',
        name: 'company limited by shares (limited company)',
        abbreviation: 'limited company;limited by guarantee;Limited;Limitée;Ltd.;Ltée;Incorporated;Inc.;Ltd',
        active: true,
        aliases: [
            'company limited by shares (limited company)',
            'limited company;limited by guarantee;Limited;Limitée;Ltd.;Ltée;Incorporated;Inc.;Ltd',
        ],
    },
    {
        code: 'UMCR',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '农民专业合作社',
        abbreviation: '',
        active: true,
        aliases: ['农民专业合作社', 'nong min zhuan ye he zuo she'],
    },
    {
        code: 'UMF0',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Konkurssipesä',
        abbreviation: '',
        active: true,
        aliases: ['Konkurssipesä', 'Konkursbo'],
    },
    {
        code: 'UNA9',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Swiss branch registered at the registry of commerce',
        abbreviation: 'Branch RC',
        active: false,
        aliases: [
            'Swiss branch registered at the registry of commerce',
            'Branch RC',
            'Succursale suisse enregistrée au registre de commerce',
            'Succ. RC',
            'Schweizerische Zweigniederlassung im Handelsregister eingetragen',
            'Zweig. HR',
            'Succursale svizzera registrata nel registro di commercio',
        ],
    },
    {
        code: 'UNCO',
        country: 'PA',
        jurisdiction: 'PA',
        jurisdictionName: 'Panama',
        name: 'Fundación de Interés Privado',
        abbreviation: 'F.I.P.',
        active: true,
        aliases: ['Fundación de Interés Privado', 'F.I.P.'],
    },
    {
        code: 'UNJ2',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'rederij',
        abbreviation: '',
        active: true,
        aliases: ['rederij'],
    },
    {
        code: 'UO3D',
        country: 'GG',
        jurisdiction: 'GG',
        jurisdictionName: 'Guernsey',
        name: 'Limited Partnership',
        abbreviation: 'LP;limited partnership;Limited Partnership',
        active: false,
        aliases: ['Limited Partnership', 'LP;limited partnership;Limited Partnership'],
    },
    {
        code: 'UQRY',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Ecole nationale non dotée de la personnalité morale',
        abbreviation: '',
        active: true,
        aliases: ['Ecole nationale non dotée de la personnalité morale'],
    },
    {
        code: 'UQWQ',
        country: 'US',
        jurisdiction: 'US-OR',
        jurisdictionName: 'Oregon',
        name: 'Cooperative Corporation',
        abbreviation: 'Cooperative;co-op',
        active: true,
        aliases: ['Cooperative Corporation', 'Cooperative;co-op'],
    },
    {
        code: 'UR1O',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'entreprise individuelle',
        abbreviation: '',
        active: true,
        aliases: ['entreprise individuelle'],
    },
    {
        code: 'URQH',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'Public Unlimited Company',
        abbreviation: 'PUC / uc',
        active: true,
        aliases: ['Public Unlimited Company', 'PUC / uc', 'Cuideachta Neamhtheoranta', 'cn'],
    },
    {
        code: 'US8E',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Genossenschaft',
        abbreviation: '',
        active: true,
        aliases: ['Genossenschaft'],
    },
    {
        code: 'USJP',
        country: 'NE',
        jurisdiction: 'NE',
        jurisdictionName: 'Niger',
        name: 'Société Anonyme à participation publique',
        abbreviation: 'SAP',
        active: true,
        aliases: ['Société Anonyme à participation publique', 'SAP'],
    },
    {
        code: 'USOG',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Sociedade por Quotas',
        abbreviation: '',
        active: true,
        aliases: ['Sociedade por Quotas'],
    },
    {
        code: 'UTBN',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Коллегии адвокатов',
        abbreviation: '',
        active: true,
        aliases: ['Коллегии адвокатов', 'Kollegii advokatov'],
    },
    {
        code: 'UTY8',
        country: 'GB',
        jurisdiction: 'GB-NIR',
        jurisdictionName: 'Northern Ireland',
        name: 'Community Benefit Society (Northern Ireland)',
        abbreviation: 'BenCom',
        active: true,
        aliases: ['Community Benefit Society (Northern Ireland)', 'BenCom'],
    },
    {
        code: 'UUT8',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SCP de directeurs de laboratoire d'analyse médicale",
        abbreviation: '',
        active: true,
        aliases: ["SCP de directeurs de laboratoire d'analyse médicale"],
    },
    {
        code: 'UUYB',
        country: 'GI',
        jurisdiction: 'GI',
        jurisdictionName: 'Gibraltar',
        name: 'Public Limited Company ',
        abbreviation: 'PLC',
        active: true,
        aliases: ['Public Limited Company ', 'PLC'],
    },
    {
        code: 'UV02',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Service central d'un ministère",
        abbreviation: '',
        active: true,
        aliases: ["Service central d'un ministère"],
    },
    {
        code: 'UV8T',
        country: 'AW',
        jurisdiction: 'AW',
        jurisdictionName: 'Aruba',
        name: 'Maatschap',
        abbreviation: '',
        active: true,
        aliases: ['Maatschap'],
    },
    {
        code: 'UVCG',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Société par actions constitué par Loi sur les sociétés de construction',
        abbreviation: '',
        active: true,
        aliases: ['Société par actions constitué par Loi sur les sociétés de construction'],
    },
    {
        code: 'UVH6',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'UW1C',
        country: 'MH',
        jurisdiction: 'MH',
        jurisdictionName: 'Marshall Islands',
        name: 'Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Partnership'],
    },
    {
        code: 'UW1Y',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Vennootschap onder firma',
        abbreviation: 'V.O.F.',
        active: true,
        aliases: [
            'Vennootschap onder firma',
            'V.O.F.',
            'Société en nom collectif',
            'SNC',
            'Offene Handelsgesellschaft',
            'OHG',
        ],
    },
    {
        code: 'UWEE',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Societate Cooperativă Europeană',
        abbreviation: 'SCE',
        active: true,
        aliases: ['Societate Cooperativă Europeană', 'SCE'],
    },
    {
        code: 'UWMY',
        country: 'CA',
        jurisdiction: 'CA-SK',
        jurisdictionName: 'Saskatchewan',
        name: 'Business Corporations',
        abbreviation: 'Ltd.;Inc.;Corp.',
        active: true,
        aliases: ['Business Corporations', 'Ltd.;Inc.;Corp.'],
    },
    {
        code: 'UX5E',
        country: 'US',
        jurisdiction: 'US-SD',
        jurisdictionName: 'South Dakota',
        name: 'Limited Liability Limited Partnership',
        abbreviation: 'L.L.L.P.;LLLP',
        active: true,
        aliases: ['Limited Liability Limited Partnership', 'L.L.L.P.;LLLP'],
    },
    {
        code: 'UX9X',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Personligt ejet Mindre Virksomhed ',
        abbreviation: '',
        active: true,
        aliases: ['Personligt ejet Mindre Virksomhed '],
    },
    {
        code: 'UXEW',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Aatteellinen yhdistys',
        abbreviation: '',
        active: true,
        aliases: ['Aatteellinen yhdistys', 'Ideell förening'],
    },
    {
        code: 'UY49',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Районные суды, городские суды, межрайонные суды (районные суды)',
        abbreviation: '',
        active: true,
        aliases: [
            'Районные суды, городские суды, межрайонные суды (районные суды)',
            'Rayonnyye sudy, gorodskiye sudy, mezhrayonnyye sudy (rayonnyye sudy)',
        ],
    },
    {
        code: 'UY66',
        country: 'GG',
        jurisdiction: 'GG',
        jurisdictionName: 'Alderney',
        name: 'public company',
        abbreviation: '',
        active: true,
        aliases: ['public company'],
    },
    {
        code: 'UZ83',
        country: 'US',
        jurisdiction: 'US-OR',
        jurisdictionName: 'Oregon',
        name: 'Nonprofit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation'],
    },
    {
        code: 'UZ9W',
        country: 'VI',
        jurisdiction: 'VI',
        jurisdictionName: 'Virgin Islands (U.S.)',
        name: 'Foreign Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Profit Corporation'],
    },
    {
        code: 'UZLR',
        country: 'NP',
        jurisdiction: 'NP',
        jurisdictionName: 'Nepal',
        name: 'Institution',
        abbreviation: '',
        active: true,
        aliases: ['Institution', 'संस्थान ', 'sansthaan '],
    },
    {
        code: 'UZUP',
        country: 'TO',
        jurisdiction: 'TO',
        jurisdictionName: 'Tonga',
        name: 'Local Company',
        abbreviation: '',
        active: true,
        aliases: ['Local Company'],
    },
    {
        code: 'UZWE',
        country: 'BM',
        jurisdiction: 'BM',
        jurisdictionName: 'Bermuda',
        name: 'Local LLC',
        abbreviation: '',
        active: true,
        aliases: ['Local LLC'],
    },
    {
        code: 'UZY3',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Établissement d'hospitalisation",
        abbreviation: '',
        active: true,
        aliases: ["Établissement d'hospitalisation"],
    },
    {
        code: 'V03J',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Internationale vereniging zonder winstoogmerk',
        abbreviation: 'IVZW',
        active: true,
        aliases: [
            'Internationale vereniging zonder winstoogmerk',
            'IVZW',
            'Association internationale sans but lucratif',
            'AISBL',
            'Internationale Vereinigung ohne Gewinnerzielungsabsicht',
            'IVoG',
        ],
    },
    {
        code: 'V05A',
        country: 'ID',
        jurisdiction: 'ID',
        jurisdictionName: 'Indonesia',
        name: 'Persekutuan Perdata',
        abbreviation: '',
        active: true,
        aliases: ['Persekutuan Perdata'],
    },
    {
        code: 'V06W',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Europeisk selskap',
        abbreviation: 'SE',
        active: true,
        aliases: ['Europeisk selskap', 'SE'],
    },
    {
        code: 'V0FL',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Societate în comandită simplă',
        abbreviation: 'SCS',
        active: true,
        aliases: ['Societate în comandită simplă', 'SCS'],
    },
    {
        code: 'V0TJ',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Asunto-osakeyhtiö',
        abbreviation: '',
        active: true,
        aliases: ['Asunto-osakeyhtiö', 'Bostadsaktiebolag'],
    },
    {
        code: 'V10Q',
        country: 'US',
        jurisdiction: 'US-OR',
        jurisdictionName: 'Oregon',
        name: 'Professional Corporation',
        abbreviation: 'Professional Corporation;P.C.;Prof. Corp',
        active: true,
        aliases: ['Professional Corporation', 'Professional Corporation;P.C.;Prof. Corp'],
    },
    {
        code: 'V19Y',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Fondation',
        abbreviation: 'FON',
        active: true,
        aliases: ['Fondation', 'FON'],
    },
    {
        code: 'V1Z5',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SARL coopérative de production (SCOP)',
        abbreviation: '',
        active: true,
        aliases: ['SARL coopérative de production (SCOP)'],
    },
    {
        code: 'V251',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '仲裁委员会',
        abbreviation: '',
        active: true,
        aliases: ['仲裁委员会', 'zhong cai wei yuan hui'],
    },
    {
        code: 'V2PA',
        country: 'AE',
        jurisdiction: 'AE-DU',
        jurisdictionName: 'Dubai',
        name: 'Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Partnership'],
    },
    {
        code: 'V2YH',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Stiftung des privaten Rechts',
        abbreviation: '',
        active: true,
        aliases: ['Stiftung des privaten Rechts'],
    },
    {
        code: 'V3LT',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Erdőbirtokossági Társulat',
        abbreviation: '',
        active: true,
        aliases: ['Erdőbirtokossági Társulat'],
    },
    {
        code: 'V42B',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Ortodoksinen kirkko',
        abbreviation: '',
        active: true,
        aliases: ['Ortodoksinen kirkko', 'Ortodoxa kyrkan'],
    },
    {
        code: 'V44D',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'stichting',
        abbreviation: '',
        active: true,
        aliases: ['stichting'],
    },
    {
        code: 'V4RX',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Non Profit Dom Limited Cooperative Association',
        abbreviation: '',
        active: true,
        aliases: ['Non Profit Dom Limited Cooperative Association'],
    },
    {
        code: 'V5G5',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Professional Benefit Corporation',
        abbreviation: 'Professional Corporation;Professional Service Corporation;PC;PSC',
        active: true,
        aliases: [
            'Professional Benefit Corporation',
            'Professional Corporation;Professional Service Corporation;PC;PSC',
        ],
    },
    {
        code: 'V5IH',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur l’aménagement et l’urbanisme',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur l’aménagement et l’urbanisme'],
    },
    {
        code: 'V5OS',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Société coopérative',
        abbreviation: 'SC',
        active: true,
        aliases: ['Société coopérative', 'SC'],
    },
    {
        code: 'V5SV',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Société civile coopérative d'intérêt maritime",
        abbreviation: '',
        active: true,
        aliases: ["Société civile coopérative d'intérêt maritime"],
    },
    {
        code: 'V5VG',
        country: 'PA',
        jurisdiction: 'PA',
        jurisdictionName: 'Panama',
        name: 'Sociedad en Comandita simple',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad en Comandita simple'],
    },
    {
        code: 'V65U',
        country: 'US',
        jurisdiction: 'US-AL',
        jurisdictionName: 'Alabama',
        name: 'Non-Profit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Non-Profit Corporation'],
    },
    {
        code: 'V6G1',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Régime maladie des non-salariés non agricoles',
        abbreviation: '',
        active: true,
        aliases: ['Régime maladie des non-salariés non agricoles'],
    },
    {
        code: 'V6YH',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Společná zájmová organizace družstev',
        abbreviation: '',
        active: true,
        aliases: ['Společná zájmová organizace družstev'],
    },
    {
        code: 'V6YL',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Societas Cooperativa Europaea',
        abbreviation: 'SCE',
        active: true,
        aliases: ['Societas Cooperativa Europaea', 'SCE'],
    },
    {
        code: 'V7FT',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Naamloze vennootschap met een sociaal oogmerk',
        abbreviation: 'NV SO',
        active: true,
        aliases: [
            'Naamloze vennootschap met een sociaal oogmerk',
            'NV SO',
            'Société anonyme à finalité sociale',
            'SA FS',
            'Aktiengesellschaft mit sozialer Zielsetzung',
            'AGmsZ',
        ],
    },
    {
        code: 'V7QY',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Groupement européen d’intérêt économique',
        abbreviation: 'GEIE',
        active: true,
        aliases: ['Groupement européen d’intérêt économique', 'GEIE'],
    },
    {
        code: 'V816',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '组级集体经济组织',
        abbreviation: '',
        active: true,
        aliases: ['组级集体经济组织', 'zu ji ji ti jing ji zu zhi'],
    },
    {
        code: 'V89C',
        country: 'MT',
        jurisdiction: 'MT',
        jurisdictionName: 'Malta',
        name: 'Private Limited Liability Company',
        abbreviation: 'Ltd;Ltd.;Limited',
        active: true,
        aliases: ['Private Limited Liability Company', 'Ltd;Ltd.;Limited', 'kumpanija privata'],
    },
    {
        code: 'V89I',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Nonprofit Corporation',
        abbreviation: 'Corporation;Incorporated;Company;Limited;Corp;Inc.;Co.;Ltd.',
        active: true,
        aliases: [
            'Nonprofit Corporation',
            'Corporation;Incorporated;Company;Limited;Corp;Inc.;Co.;Ltd.',
        ],
    },
    {
        code: 'V8L7',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Burgerlijke vennootschap onder vorm van besloten vennootschap met beperkte aansprakelijkheid',
        abbreviation: 'BV BVBA',
        active: false,
        aliases: [
            'Burgerlijke vennootschap onder vorm van besloten vennootschap met beperkte aansprakelijkheid',
            'BV BVBA',
            'Société civile sous forme de société privée à responsabilité limitée',
            'SC SPRL',
            'Zivilrechtliche Gesellschaft in der Rechtsform einer Privatgesellschaft mit beschränkter Haftung',
            'ZvGPgbH',
        ],
    },
    {
        code: 'V905',
        country: 'AW',
        jurisdiction: 'AW',
        jurisdictionName: 'Aruba',
        name: 'Vennootschap met beperkte aansprakelijkheid',
        abbreviation: 'VBA;vba;V.B.A.;v.b.a.',
        active: true,
        aliases: ['Vennootschap met beperkte aansprakelijkheid', 'VBA;vba;V.B.A.;v.b.a.'],
    },
    {
        code: 'V9GU',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur la société Saint-Jean-Baptiste de Trois-Rivières',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur la société Saint-Jean-Baptiste de Trois-Rivières',
        ],
    },
    {
        code: 'V9QP',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société à responsabilité limitée (sans autre indication)',
        abbreviation: '',
        active: true,
        aliases: ['Société à responsabilité limitée (sans autre indication)'],
    },
    {
        code: 'VA0A',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Рыболовецкие артели (колхозы)',
        abbreviation: '',
        active: true,
        aliases: ['Рыболовецкие артели (колхозы)', 'Rybolovetskiye arteli (kolkhozy)'],
    },
    {
        code: 'VA1V',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società Di Mutuo Soccorso',
        abbreviation: '',
        active: true,
        aliases: ['Società Di Mutuo Soccorso'],
    },
    {
        code: 'VA1X',
        country: 'SC',
        jurisdiction: 'SC',
        jurisdictionName: 'Seychelles',
        name: 'Limited Partnership',
        abbreviation: 'LP',
        active: true,
        aliases: ['Limited Partnership', 'LP'],
    },
    {
        code: 'VAB6',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Обособленные подразделения юридических лиц',
        abbreviation: '',
        active: true,
        aliases: [
            'Обособленные подразделения юридических лиц',
            'Obosoblennyye podrazdeleniya yuridicheskikh lits',
        ],
    },
    {
        code: 'VALH',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Empresário em Nome Individual',
        abbreviation: '',
        active: true,
        aliases: ['Empresário em Nome Individual'],
    },
    {
        code: 'VAPL',
        country: 'NE',
        jurisdiction: 'NE',
        jurisdictionName: 'Niger',
        name: 'Société en Participations',
        abbreviation: 'SEP',
        active: true,
        aliases: ['Société en Participations', 'SEP'],
    },
    {
        code: 'VAPN',
        country: 'CA',
        jurisdiction: 'CA-NT',
        jurisdictionName: 'Northwest Territories',
        name: 'general partnership',
        abbreviation: '',
        active: true,
        aliases: ['general partnership'],
    },
    {
        code: 'VAQS',
        country: 'AE',
        jurisdiction: 'AE',
        jurisdictionName: 'United Arab Emirates',
        name: 'Public Corporate',
        abbreviation: '',
        active: true,
        aliases: ['Public Corporate'],
    },
    {
        code: 'VATN',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Európske zoskupenie územnej spolupráce',
        abbreviation: 'Európ.zoskup.územ.spol',
        active: true,
        aliases: ['Európske zoskupenie územnej spolupráce', 'Európ.zoskup.územ.spol'],
    },
    {
        code: 'VATV',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima promotora de inversión de capital variable',
        abbreviation: 'S.A. P.I. de C.V.',
        active: true,
        aliases: ['Sociedad anónima promotora de inversión de capital variable', 'S.A. P.I. de C.V.'],
    },
    {
        code: 'VBC7',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Institution Banque de France',
        abbreviation: '',
        active: true,
        aliases: ['Institution Banque de France'],
    },
    {
        code: 'VBJW',
        country: 'GH',
        jurisdiction: 'GH',
        jurisdictionName: 'Ghana',
        name: 'Public Limited Company',
        abbreviation: '',
        active: true,
        aliases: ['Public Limited Company'],
    },
    {
        code: 'VBQP',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Fonds à forme sociétale à directoire',
        abbreviation: '',
        active: true,
        aliases: ['Fonds à forme sociétale à directoire'],
    },
    {
        code: 'VBVM',
        country: 'US',
        jurisdiction: 'US-KS',
        jurisdictionName: 'Kansas',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'VC3E',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Private Limited by Guarantee and having a Share Capital (1931 Act)',
        abbreviation: '',
        active: true,
        aliases: ['Private Limited by Guarantee and having a Share Capital (1931 Act)'],
    },
    {
        code: 'VCQZ',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Series',
        abbreviation: 'Limited Liabilty Company;LLC',
        active: true,
        aliases: ['Series', 'Limited Liabilty Company;LLC'],
    },
    {
        code: 'VD7Z',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société en commandite simple',
        abbreviation: '',
        active: true,
        aliases: ['Société en commandite simple'],
    },
    {
        code: 'VDRB',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Consorzio Municipale',
        abbreviation: '',
        active: true,
        aliases: ['Consorzio Municipale'],
    },
    {
        code: 'VE1P',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Организационно-правовые формы юридических лиц, являющихся некоммерческими корпоративными организациями',
        abbreviation: '',
        active: true,
        aliases: [
            'Организационно-правовые формы юридических лиц, являющихся некоммерческими корпоративными организациями',
            'Organizatsionno-pravovyye formy yuridicheskikh lits, yavlyayushchikhsya nekommercheskimi korporativnymi organizatsiyami',
        ],
    },
    {
        code: 'VE28',
        country: 'US',
        jurisdiction: 'US-KY',
        jurisdictionName: 'Kentucky',
        name: 'Limited Partnership',
        abbreviation: 'LP;LIMTED PARTNERSHIP;LTD',
        active: true,
        aliases: ['Limited Partnership', 'LP;LIMTED PARTNERSHIP;LTD'],
    },
    {
        code: 'VEOU',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Унитарные предприятия',
        abbreviation: '',
        active: true,
        aliases: ['Унитарные предприятия', 'Unitarnyye predpriyatiya'],
    },
    {
        code: 'VEX5',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Муниципальные казенные учреждения',
        abbreviation: '',
        active: true,
        aliases: ['Муниципальные казенные учреждения', "Munitsipal'nyye kazennyye uchrezhdeniya"],
    },
    {
        code: 'VF4C',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Sociedade Unipessoal por Quotas',
        abbreviation: '',
        active: true,
        aliases: ['Sociedade Unipessoal por Quotas'],
    },
    {
        code: 'VFIU',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Sociedad Comanditaria Simple Profesional',
        abbreviation: 'S. en C.P.;S.Com.P.',
        active: true,
        aliases: ['Sociedad Comanditaria Simple Profesional', 'S. en C.P.;S.Com.P.'],
    },
    {
        code: 'VFXJ',
        country: 'BM',
        jurisdiction: 'BM',
        jurisdictionName: 'Bermuda',
        name: 'Mutual Fund Company',
        abbreviation: '',
        active: true,
        aliases: ['Mutual Fund Company'],
    },
    {
        code: 'VG3S',
        country: 'US',
        jurisdiction: 'US-NM',
        jurisdictionName: 'New Mexico',
        name: 'Profit Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.',
        active: true,
        aliases: ['Profit Corporation', 'corp.;inc.;co.;ltd.'],
    },
    {
        code: 'VGP6',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les fabriques',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur les fabriques'],
    },
    {
        code: 'VHIY',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Cooperatie',
        abbreviation: '',
        active: true,
        aliases: ['Cooperatie'],
    },
    {
        code: 'VHOW',
        country: 'BN',
        jurisdiction: 'BN',
        jurisdictionName: 'Brunei Darussalam',
        name: 'Sole-Proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['Sole-Proprietorship'],
    },
    {
        code: 'VHXN',
        country: 'CA',
        jurisdiction: 'CA-AB',
        jurisdictionName: 'Alberta',
        name: 'public non-profit company',
        abbreviation: '',
        active: true,
        aliases: ['public non-profit company'],
    },
    {
        code: 'VIE3',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Zájmové sdružení právnických osob',
        abbreviation: '',
        active: true,
        aliases: ['Zájmové sdružení právnických osob'],
    },
    {
        code: 'VIGZ',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Филиалы юридических лиц',
        abbreviation: '',
        active: true,
        aliases: ['Филиалы юридических лиц', 'Filialy yuridicheskikh lits'],
    },
    {
        code: 'VIMA',
        country: 'PA',
        jurisdiction: 'PA',
        jurisdictionName: 'Panama',
        name: 'Micro-empresa de Responsabilidad Limitada',
        abbreviation: 'M.R.L.',
        active: true,
        aliases: ['Micro-empresa de Responsabilidad Limitada', 'M.R.L.'],
    },
    {
        code: 'VIOQ',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Estado',
        abbreviation: 'Edo.',
        active: true,
        aliases: ['Estado', 'Edo.'],
    },
    {
        code: 'VJ3G',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Дружество с ограничена отговорност',
        abbreviation: 'ООД',
        active: true,
        aliases: [
            'Дружество с ограничена отговорност',
            'Druzhestvo s ogranichena otgovornost',
            'ООД',
            'OOD',
        ],
    },
    {
        code: 'VJBO',
        country: 'LV',
        jurisdiction: 'LV',
        jurisdictionName: 'Latvia',
        name: 'Akciju sabiedrība',
        abbreviation: 'AS',
        active: true,
        aliases: ['Akciju sabiedrība', 'AS'],
    },
    {
        code: 'VJRL',
        country: 'GI',
        jurisdiction: 'GI',
        jurisdictionName: 'Gibraltar',
        name: 'Private Unlimited Company',
        abbreviation: '',
        active: true,
        aliases: ['Private Unlimited Company'],
    },
    {
        code: 'VJV5',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SARL d'économie mixte",
        abbreviation: '',
        active: true,
        aliases: ["SARL d'économie mixte"],
    },
    {
        code: 'VJXH',
        country: 'US',
        jurisdiction: 'US-OK',
        jurisdictionName: 'Oklahoma',
        name: 'Not-for-profit Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.',
        active: true,
        aliases: ['Not-for-profit Corporation', 'corp.;inc.;co.;ltd.'],
    },
    {
        code: 'VKKN',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Eurooppaosuuspankki',
        abbreviation: '',
        active: true,
        aliases: ['Eurooppaosuuspankki', 'Europaandelsbank'],
    },
    {
        code: 'VKPN',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'Close Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Close Corporation'],
    },
    {
        code: 'VKSR',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Συμπλοιοκτησία',
        abbreviation: 'JSO',
        active: true,
        aliases: ['Συμπλοιοκτησία', 'Simplioktisia', 'JSO'],
    },
    {
        code: 'VKSV',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Insurance Company',
        abbreviation: '',
        active: true,
        aliases: ['Insurance Company', 'Compañía de Seguros'],
    },
    {
        code: 'VKZD',
        country: 'AE',
        jurisdiction: 'AE-AZ',
        jurisdictionName: 'Abu Dhabi',
        name: 'Foundation',
        abbreviation: '',
        active: true,
        aliases: ['Foundation'],
    },
    {
        code: 'VN3F',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad cooperativa de productores de bienes y/o servicios',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad cooperativa de productores de bienes y/o servicios'],
    },
    {
        code: 'VNIU',
        country: 'US',
        jurisdiction: 'US-DC',
        jurisdictionName: 'District of Columbia',
        name: 'Limited Liability Company (including professional LLC and series LLC)',
        abbreviation: 'L.L.C.;LLC;L.C.;LC;P.L.L.C.;PLLC',
        active: true,
        aliases: [
            'Limited Liability Company (including professional LLC and series LLC)',
            'L.L.C.;LLC;L.C.;LC;P.L.L.C.;PLLC',
        ],
    },
    {
        code: 'VO18',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Établissement public local à caractére industriel ou commercial',
        abbreviation: '',
        active: true,
        aliases: ['Établissement public local à caractére industriel ou commercial'],
    },
    {
        code: 'VOTI',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Kuntayhtymä',
        abbreviation: '',
        active: true,
        aliases: ['Kuntayhtymä', 'Samkommun'],
    },
    {
        code: 'VOUU',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Организационно-правовые формы юридических лиц, являющихся коммерческими унитарными организациями',
        abbreviation: '',
        active: true,
        aliases: [
            'Организационно-правовые формы юридических лиц, являющихся коммерческими унитарными организациями',
            'Organizatsionno-pravovyye formy yuridicheskikh lits, yavlyayushchikhsya kommercheskimi unitarnymi organizatsiyami',
        ],
    },
    {
        code: 'VPBH',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Limited Liability Company',
        abbreviation: 'L.L.C.;LLC',
        active: true,
        aliases: ['Limited Liability Company', 'L.L.C.;LLC'],
    },
    {
        code: 'VPFY',
        country: 'MK',
        jurisdiction: 'MK',
        jurisdictionName: 'North Macedonia',
        name: 'Трговец поединец',
        abbreviation: 'TP',
        active: true,
        aliases: ['Трговец поединец', 'Trgovec poedinec', 'TP'],
    },
    {
        code: 'VPRH',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'District public company',
        abbreviation: 'Distr. publ. co.',
        active: true,
        aliases: [
            'District public company',
            'Distr. publ. co.',
            'Entreprise publique de district',
            'Ent. pub. district',
            'öffentliches Unternehmen des Bezirks',
            'öff. Unt. Bezirk',
            'Impresa pubblica di distretto',
            'Imp. pubb. distretto',
        ],
    },
    {
        code: 'VQLD',
        country: 'JP',
        jurisdiction: 'JP',
        jurisdictionName: 'Japan',
        name: 'その他',
        abbreviation: 'そ',
        active: false,
        aliases: ['その他', 'sonota', 'そ'],
    },
    {
        code: 'VQU7',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Organizační složka zahraniční nadace',
        abbreviation: '',
        active: true,
        aliases: ['Organizační složka zahraniční nadace'],
    },
    {
        code: 'VQV6',
        country: 'PK',
        jurisdiction: 'PK',
        jurisdictionName: 'Pakistan',
        name: 'Public Limited Company (listed)',
        abbreviation: 'Ltd;Ltd.;Limited',
        active: true,
        aliases: ['Public Limited Company (listed)', 'Ltd;Ltd.;Limited'],
    },
    {
        code: 'VRJP',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Nezisková organizácia poskytujúca všeobecne prospešné služby',
        abbreviation: 'Nezisk.org.poskyt.všeob.prosp.služby',
        active: true,
        aliases: [
            'Nezisková organizácia poskytujúca všeobecne prospešné služby',
            'Nezisk.org.poskyt.všeob.prosp.služby',
        ],
    },
    {
        code: 'VRSU',
        country: 'NP',
        jurisdiction: 'NP',
        jurisdictionName: 'Nepal',
        name: 'Private Firm',
        abbreviation: '',
        active: true,
        aliases: ['Private Firm', 'प्राइभेट फर्म ', 'praibhet farm'],
    },
    {
        code: 'VRVJ',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Code des professions',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Code des professions'],
    },
    {
        code: 'VSC1',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Zahraničné kultúrne, informačné stredisko, rozhlasová, tlačová a televízna agentúra',
        abbreviation: 'Zahr.kul.,inf.strediská',
        active: true,
        aliases: [
            'Zahraničné kultúrne, informačné stredisko, rozhlasová, tlačová a televízna agentúra',
            'Zahr.kul.,inf.strediská',
        ],
    },
    {
        code: 'VSDJ',
        country: 'US',
        jurisdiction: 'US-MN',
        jurisdictionName: 'Minnesota',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: 'VSEV',
        country: 'EE',
        jurisdiction: 'EE',
        jurisdictionName: 'Estonia',
        name: 'Tulundusühistu',
        abbreviation: 'TÜH',
        active: true,
        aliases: ['Tulundusühistu', 'TÜH'],
    },
    {
        code: 'VSTJ',
        country: 'TH',
        jurisdiction: 'TH',
        jurisdictionName: 'Thailand',
        name: 'นิติบุคคลอื่นที่จัดตั้งขึ้นตามกฎหมายพิเศษ',
        abbreviation: '',
        active: true,
        aliases: [
            'นิติบุคคลอื่นที่จัดตั้งขึ้นตามกฎหมายพิเศษ',
            'Nitibukhkhl xụ̄̀n thī̀ cạdtậng k̄hụ̂n tām kḍh̄māy phiṣ̄es̄ʹ',
        ],
    },
    {
        code: 'VSZS',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Spoločnosť s ručením obmedzeným',
        abbreviation: 'Spol. s r. o.',
        active: true,
        aliases: ['Spoločnosť s ručením obmedzeným', 'Spol. s r. o.'],
    },
    {
        code: 'VTFS',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SARL coopérative artisanale',
        abbreviation: '',
        active: true,
        aliases: ['SARL coopérative artisanale'],
    },
    {
        code: 'VTH4',
        country: 'KR',
        jurisdiction: 'KR',
        jurisdictionName: 'Korea (Republic of)',
        name: '비영리 사단법인',
        abbreviation: '',
        active: true,
        aliases: ['비영리 사단법인', 'BiYeongRi SaDanBeobIn'],
    },
    {
        code: 'VTIP',
        country: 'AE',
        jurisdiction: 'AE-DU',
        jurisdictionName: 'Dubai',
        name: 'Close Ended Investment Company',
        abbreviation: '',
        active: true,
        aliases: ['Close Ended Investment Company'],
    },
    {
        code: 'VUPE',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società Europea',
        abbreviation: 'SE',
        active: true,
        aliases: ['Società Europea', 'SE'],
    },
    {
        code: 'VUUU',
        country: 'US',
        jurisdiction: 'US-WA',
        jurisdictionName: 'Washington',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'VUXH',
        country: 'US',
        jurisdiction: 'US-IL',
        jurisdictionName: 'Illinois',
        name: 'Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Partnership'],
    },
    {
        code: 'VV0W',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Investment Company with Variable Capital',
        abbreviation: '',
        active: true,
        aliases: ['Investment Company with Variable Capital'],
    },
    {
        code: 'VVJ3',
        country: 'US',
        jurisdiction: 'US-VA',
        jurisdictionName: 'Virginia',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'VVOW',
        country: 'BS',
        jurisdiction: 'BS',
        jurisdictionName: 'Bahamas',
        name: 'Foundation',
        abbreviation: '',
        active: true,
        aliases: ['Foundation'],
    },
    {
        code: 'VVOX',
        country: 'SG',
        jurisdiction: 'SG',
        jurisdictionName: 'Singapore',
        name: 'Public Company Limited by Shares',
        abbreviation: '',
        active: true,
        aliases: ['Public Company Limited by Shares'],
    },
    {
        code: 'VVPD',
        country: 'US',
        jurisdiction: 'US-IA',
        jurisdictionName: 'Iowa',
        name: 'Professional Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Professional Limited Liability Company'],
    },
    {
        code: 'VWC5',
        country: 'US',
        jurisdiction: 'US-NJ',
        jurisdictionName: 'New Jersey',
        name: 'Savings Bank',
        abbreviation: '',
        active: true,
        aliases: ['Savings Bank'],
    },
    {
        code: 'VWY9',
        country: 'US',
        jurisdiction: 'US-IA',
        jurisdictionName: 'Iowa',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'VX5J',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Mutual Fund-Sub Scheme',
        abbreviation: '',
        active: true,
        aliases: ['Mutual Fund-Sub Scheme'],
    },
    {
        code: 'VXDE',
        country: 'US',
        jurisdiction: 'US-AK',
        jurisdictionName: 'Alaska',
        name: 'Limited Partnership',
        abbreviation: 'LP',
        active: true,
        aliases: ['Limited Partnership', 'LP'],
    },
    {
        code: 'VYAX',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'Public Limited Company',
        abbreviation: 'PLC',
        active: true,
        aliases: ['Public Limited Company', 'PLC', 'Cuideachta Phoiblí Theoranta', 'cpt'],
    },
    {
        code: 'VYEO',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Fraternal Society',
        abbreviation: '',
        active: true,
        aliases: ['Fraternal Society'],
    },
    {
        code: 'VYF8',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'United Kingdom Economic Interest Grouping',
        abbreviation: 'UKEIG',
        active: true,
        aliases: ['United Kingdom Economic Interest Grouping', 'UKEIG'],
    },
    {
        code: 'VZ3G',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Sociedad en Comandita Civil',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad en Comandita Civil'],
    },
    {
        code: 'W0G7',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Pension Fund Sub Scheme',
        abbreviation: '',
        active: true,
        aliases: ['Pension Fund Sub Scheme'],
    },
    {
        code: 'W0U4',
        country: 'US',
        jurisdiction: 'US-NM',
        jurisdictionName: 'New Mexico',
        name: 'Nonprofit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation'],
    },
    {
        code: 'W0XQ',
        country: 'US',
        jurisdiction: 'US-NM',
        jurisdictionName: 'New Mexico',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'W126',
        country: 'CA',
        jurisdiction: 'CA-NT',
        jurisdictionName: 'Northwest Territories',
        name: 'private act not-for-profit corporation',
        abbreviation: '',
        active: true,
        aliases: ['private act not-for-profit corporation'],
    },
    {
        code: 'W1DV',
        country: 'US',
        jurisdiction: 'US-NH',
        jurisdictionName: 'New Hampshire',
        name: 'Cooperative Bank',
        abbreviation: '',
        active: true,
        aliases: ['Cooperative Bank'],
    },
    {
        code: 'W2NK',
        country: 'GR',
        jurisdiction: 'GR',
        jurisdictionName: 'Greece',
        name: 'Ανώνυμη Εταιρία',
        abbreviation: 'SA',
        active: true,
        aliases: ['Ανώνυμη Εταιρία', 'Anónimi Etería', 'SA'],
    },
    {
        code: 'W2PE',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società non prevista dalla Legislazione Italiana',
        abbreviation: '',
        active: false,
        aliases: ['Società non prevista dalla Legislazione Italiana'],
    },
    {
        code: 'W2SQ',
        country: 'TR',
        jurisdiction: 'TR',
        jurisdictionName: 'Türkiye',
        name: 'anonim şirket',
        abbreviation: 'A.Ş.',
        active: true,
        aliases: ['anonim şirket', 'A.Ş.'],
    },
    {
        code: 'W3LD',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Groupement agricole foncier',
        abbreviation: '',
        active: true,
        aliases: ['Groupement agricole foncier'],
    },
    {
        code: 'W3WH',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Vereniging zonder winstoogmerk',
        abbreviation: 'VZW',
        active: true,
        aliases: [
            'Vereniging zonder winstoogmerk',
            'VZW',
            'Association sans but lucratif',
            'ASBL',
            'Vereinigung ohne Gewinnerzielungsabsicht',
            'VoG',
        ],
    },
    {
        code: 'W3YV',
        country: 'TV',
        jurisdiction: 'TV',
        jurisdictionName: 'Tuvalu',
        name: 'international company',
        abbreviation: '',
        active: true,
        aliases: ['international company'],
    },
    {
        code: 'W4DB',
        country: 'CA',
        jurisdiction: 'CA-PE',
        jurisdictionName: 'Prince Edward Island',
        name: 'private company',
        abbreviation: 'Ltd.;Inc.;Corp.;Ltée',
        active: true,
        aliases: ['private company', 'Ltd.;Inc.;Corp.;Ltée'],
    },
    {
        code: 'W4G1',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SARL coopérative de transport',
        abbreviation: '',
        active: true,
        aliases: ['SARL coopérative de transport'],
    },
    {
        code: 'W50Q',
        country: 'QA',
        jurisdiction: 'QA',
        jurisdictionName: 'Qatar',
        name: 'شركة المساهمة الخاصة',
        abbreviation: 'ش.م.خ',
        active: true,
        aliases: ['شركة المساهمة الخاصة', 'Sharikat Almusahama Alkhasa', 'ش.م.خ'],
    },
    {
        code: 'W5H8',
        country: 'XK',
        jurisdiction: 'XK',
        jurisdictionName: 'Kosovo',
        name: 'Ndërmarrjet publike sipas ligjit në fuqi për ndërmarrjet publike',
        abbreviation: 'NP',
        active: true,
        aliases: ['Ndërmarrjet publike sipas ligjit në fuqi për ndërmarrjet publike', 'NP'],
    },
    {
        code: 'W61J',
        country: 'KR',
        jurisdiction: 'KR',
        jurisdictionName: 'Korea (Republic of)',
        name: '기타 법인',
        abbreviation: '',
        active: true,
        aliases: ['기타 법인', 'Gita beobin'],
    },
    {
        code: 'W6A7',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Patnership limited by shares',
        abbreviation: '',
        active: true,
        aliases: [
            'Patnership limited by shares',
            'Société en commandite par action',
            'SCmA',
            'Kommanditaktiengesellschaft',
            'KmAG',
            'Società in accomandita per azioni',
            'SAcA',
        ],
    },
    {
        code: 'W6JC',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Personengesellschaft',
        abbreviation: '',
        active: true,
        aliases: ['Personengesellschaft'],
    },
    {
        code: 'W6NI',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'International Financial Entity (Corporation)',
        abbreviation: '',
        active: true,
        aliases: [
            'International Financial Entity (Corporation)',
            'Entidad Financiera Internacional (Corporación)',
        ],
    },
    {
        code: 'W7HT',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Autoritatea Administratiei Publice Locale',
        abbreviation: '',
        active: true,
        aliases: ['Autoritatea Administratiei Publice Locale'],
    },
    {
        code: 'W7KV',
        country: 'XK',
        jurisdiction: 'XK',
        jurisdictionName: 'Kosovo',
        name: 'Ortakëri e Kufizuar',
        abbreviation: 'OK',
        active: true,
        aliases: ['Ortakëri e Kufizuar', 'OK'],
    },
    {
        code: 'W86L',
        country: 'CY',
        jurisdiction: 'CY',
        jurisdictionName: 'Cyprus',
        name: 'Εταιρεία Περιορισμένης Ευθύνης με εγγύηση, χωρίς μετοχικό κεφάλαιο',
        abbreviation: '',
        active: true,
        aliases: [
            'Εταιρεία Περιορισμένης Ευθύνης με εγγύηση, χωρίς μετοχικό κεφάλαιο',
            'Etaireia Periorismenis Efthynis me engyisi, choris metochiko kefalaio',
        ],
    },
    {
        code: 'W8V9',
        country: 'TR',
        jurisdiction: 'TR',
        jurisdictionName: 'Türkiye',
        name: 'şahıs şirketi',
        abbreviation: '',
        active: true,
        aliases: ['şahıs şirketi'],
    },
    {
        code: 'W8XG',
        country: 'CA',
        jurisdiction: 'CA-NS',
        jurisdictionName: 'Nova Scotia',
        name: 'sole proprietors',
        abbreviation: '',
        active: true,
        aliases: ['sole proprietors'],
    },
    {
        code: 'W9FI',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Trust',
        abbreviation: '',
        active: true,
        aliases: ['Trust'],
    },
    {
        code: 'W9K6',
        country: 'AM',
        jurisdiction: 'AM',
        jurisdictionName: 'Armenia',
        name: 'Փակ բաժնետիրական ընկերություն',
        abbreviation: 'ՓԲԸ',
        active: true,
        aliases: ['Փակ բաժնետիրական ընկերություն', 'Pʿak bazhnetirakan enkerutʿyun', 'ՓԲԸ', 'PʿBĒ'],
    },
    {
        code: 'W9RU',
        country: 'KW',
        jurisdiction: 'KW',
        jurisdictionName: 'Kuwait',
        name: 'الشركة المھنیة',
        abbreviation: '',
        active: true,
        aliases: ['الشركة المھنیة', 'Alsharikat almuھnay'],
    },
    {
        code: 'W9SC',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Mutua Assicurazione',
        abbreviation: '',
        active: true,
        aliases: ['Mutua Assicurazione'],
    },
    {
        code: 'W9T7',
        country: 'GT',
        jurisdiction: 'GT',
        jurisdictionName: 'Guatemala',
        name: 'Sociedad en Comandita Simple',
        abbreviation: 'Cía. S. en C.',
        active: true,
        aliases: ['Sociedad en Comandita Simple', 'Cía. S. en C.'],
    },
    {
        code: 'W9W3',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Sociedade Anónima Desportiva',
        abbreviation: '',
        active: true,
        aliases: ['Sociedade Anónima Desportiva'],
    },
    {
        code: 'W9WS',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Empresa productiva del estado',
        abbreviation: 'E.P.E.',
        active: true,
        aliases: ['Empresa productiva del estado', 'E.P.E.'],
    },
    {
        code: 'W9ZD',
        country: 'GH',
        jurisdiction: 'GH',
        jurisdictionName: 'Ghana',
        name: 'Public Limited By Guarantee',
        abbreviation: '',
        active: true,
        aliases: ['Public Limited By Guarantee'],
    },
    {
        code: 'WAK8',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Europäische Gesellschaft',
        abbreviation: 'SE',
        active: true,
        aliases: ['Europäische Gesellschaft', 'SE'],
    },
    {
        code: 'WBEC',
        country: 'BR',
        jurisdiction: 'BR',
        jurisdictionName: 'Brazil',
        name: 'Sociedade em Comdandita Simples',
        abbreviation: 'S.C.S.',
        active: true,
        aliases: ['Sociedade em Comdandita Simples', 'S.C.S.'],
    },
    {
        code: 'WBKH',
        country: 'GI',
        jurisdiction: 'GI',
        jurisdictionName: 'Gibraltar',
        name: 'Private Limited Company',
        abbreviation: 'Limited;Ltd;Ltd.',
        active: true,
        aliases: ['Private Limited Company', 'Limited;Ltd;Ltd.'],
    },
    {
        code: 'WBQU',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Credit Union',
        abbreviation: '',
        active: true,
        aliases: ['Credit Union'],
    },
    {
        code: 'WBWC',
        country: 'SR',
        jurisdiction: 'SR',
        jurisdictionName: 'Suriname',
        name: 'Vennootschap onder een firma',
        abbreviation: 'VOF;vof;V.O.F.;v.o.f.',
        active: true,
        aliases: ['Vennootschap onder een firma', 'VOF;vof;V.O.F.;v.o.f.'],
    },
    {
        code: 'WC8Q',
        country: 'US',
        jurisdiction: 'US-KS',
        jurisdictionName: 'Kansas',
        name: 'Business Trust',
        abbreviation: '',
        active: true,
        aliases: ['Business Trust'],
    },
    {
        code: 'WCEP',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Société Européenne',
        abbreviation: 'SE',
        active: true,
        aliases: ['Société Européenne', 'société européenne', 'SE'],
    },
    {
        code: 'WDT2',
        country: 'US',
        jurisdiction: 'US-AL',
        jurisdictionName: 'Alabama',
        name: 'Limited Liability Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Limited Partnership'],
    },
    {
        code: 'WE9D',
        country: 'US',
        jurisdiction: 'US-CO',
        jurisdictionName: 'Colorado',
        name: 'Limited Liability Limited Partnership',
        abbreviation: 'Limited;Company;L.P.;Lp;Co.;L.L.L.P.;Lllp;LTD.;R.L.L.L.P.;RLLLP',
        active: true,
        aliases: [
            'Limited Liability Limited Partnership',
            'Limited;Company;L.P.;Lp;Co.;L.L.L.P.;Lllp;LTD.;R.L.L.L.P.;RLLLP',
        ],
    },
    {
        code: 'WEIB',
        country: 'NZ',
        jurisdiction: 'NZ',
        jurisdictionName: 'New Zealand',
        name: 'Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Partnership'],
    },
    {
        code: 'WEUX',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '其他（民政）',
        abbreviation: '',
        active: true,
        aliases: ['其他（民政）', 'qi ta（ min zheng ）'],
    },
    {
        code: 'WF3Q',
        country: 'BM',
        jurisdiction: 'BM',
        jurisdictionName: 'Bermuda',
        name: 'Permit (Overseas) Company',
        abbreviation: '',
        active: true,
        aliases: ['Permit (Overseas) Company'],
    },
    {
        code: 'WFPH',
        country: 'CA',
        jurisdiction: 'CA-BC',
        jurisdictionName: 'British Columbia',
        name: 'Society (includes member-funded society)',
        abbreviation: '',
        active: true,
        aliases: ['Society (includes member-funded society)'],
    },
    {
        code: 'WFYL',
        country: 'KN',
        jurisdiction: 'KN',
        jurisdictionName: 'Saint Kitts and Nevis',
        name: 'private company',
        abbreviation: '',
        active: true,
        aliases: ['private company'],
    },
    {
        code: 'WGCY',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Groupement d'employeurs",
        abbreviation: '',
        active: true,
        aliases: ["Groupement d'employeurs"],
    },
    {
        code: 'WGEA',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur l’organisation municipale de certains territoires',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur l’organisation municipale de certains territoires',
        ],
    },
    {
        code: 'WHCI',
        country: 'SA',
        jurisdiction: 'SA',
        jurisdictionName: 'Saudi Arabia',
        name: 'شركه توصية بسيطة',
        abbreviation: '',
        active: true,
        aliases: ['شركه توصية بسيطة', 'sharakah tawsiat basita'],
    },
    {
        code: 'WHCV',
        country: 'PG',
        jurisdiction: 'PG',
        jurisdictionName: 'Papua New Guinea',
        name: 'Foreign Enterprise',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Enterprise'],
    },
    {
        code: 'WHGH',
        country: 'PH',
        jurisdiction: 'PH',
        jurisdictionName: 'Philippines',
        name: 'stock corporation',
        abbreviation: 'Inc.',
        active: true,
        aliases: ['stock corporation', 'Inc.'],
    },
    {
        code: 'WI0P',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'agricultural society',
        abbreviation: '',
        active: true,
        aliases: ['agricultural society', 'société agricole'],
    },
    {
        code: 'WIU6',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Community Development Corporation',
        abbreviation: 'corp;inc.;CDC;C.D.C.',
        active: true,
        aliases: ['Community Development Corporation', 'corp;inc.;CDC;C.D.C.'],
    },
    {
        code: 'WJ0A',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Partneriaeth Atebolrwydd Cyfyngedig',
        abbreviation: 'PAC',
        active: false,
        aliases: ['Partneriaeth Atebolrwydd Cyfyngedig', 'PAC'],
    },
    {
        code: 'WJ30',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Družstevní podnik zemědělský',
        abbreviation: '',
        active: true,
        aliases: ['Družstevní podnik zemědělský'],
    },
    {
        code: 'WJXS',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Жилищные накопительные кооперативы',
        abbreviation: '',
        active: true,
        aliases: ['Жилищные накопительные кооперативы', "Zhilishchnyye nakopitel'nyye kooperativy"],
    },
    {
        code: 'WKFL',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Kommun',
        abbreviation: '',
        active: true,
        aliases: ['Kommun'],
    },
    {
        code: 'WKFR',
        country: 'SC',
        jurisdiction: 'SC',
        jurisdictionName: 'Seychelles',
        name: 'International Business Company - Limited Life Company',
        abbreviation: 'IBC',
        active: true,
        aliases: ['International Business Company - Limited Life Company', 'IBC'],
    },
    {
        code: 'WL83',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Zvláštní organizace pro zastoupení českých zájmů v mezinárodních nevládních organizacích',
        abbreviation: '',
        active: true,
        aliases: [
            'Zvláštní organizace pro zastoupení českých zájmů v mezinárodních nevládních organizacích',
        ],
    },
    {
        code: 'WMJ9',
        country: 'VU',
        jurisdiction: 'VU',
        jurisdictionName: 'Vanuatu',
        name: 'Foundation',
        abbreviation: '',
        active: true,
        aliases: ['Foundation'],
    },
    {
        code: 'WMTY',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Publicity Rights Name Registration',
        abbreviation: '',
        active: false,
        aliases: ['Publicity Rights Name Registration'],
    },
    {
        code: 'WNKG',
        country: 'US',
        jurisdiction: 'US-AK',
        jurisdictionName: 'Alaska',
        name: 'Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Partnership'],
    },
    {
        code: 'WNV6',
        country: 'US',
        jurisdiction: 'US-WI',
        jurisdictionName: 'Wisconsin',
        name: 'Limited Partnership',
        abbreviation: 'L.P.;LP',
        active: true,
        aliases: ['Limited Partnership', 'L.P.;LP'],
    },
    {
        code: 'WNX1',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'towarzystwo ubezpieczeń wzajemnych',
        abbreviation: 'TUW',
        active: true,
        aliases: ['towarzystwo ubezpieczeń wzajemnych', 'TUW'],
    },
    {
        code: 'WO0T',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Pobočná mezinárodní odborová organizace',
        abbreviation: '',
        active: false,
        aliases: ['Pobočná mezinárodní odborová organizace'],
    },
    {
        code: 'WOK7',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'związki inne niż zawodowe',
        abbreviation: '',
        active: true,
        aliases: ['związki inne niż zawodowe'],
    },
    {
        code: 'WP5I',
        country: 'GH',
        jurisdiction: 'GH',
        jurisdictionName: 'Ghana',
        name: 'Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Partnership'],
    },
    {
        code: 'WP6R',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Co-op',
        abbreviation: 'corp.;corporation;co.;company;ltd.;limited;inc.;incorporated',
        active: true,
        aliases: ['Co-op', 'corp.;corporation;co.;company;ltd.;limited;inc.;incorporated'],
    },
    {
        code: 'WPCN',
        country: 'US',
        jurisdiction: 'US-MS',
        jurisdictionName: 'Mississippi',
        name: 'Limited Liability Company',
        abbreviation: 'L.L.C.;LLC',
        active: true,
        aliases: ['Limited Liability Company', 'L.L.C.;LLC'],
    },
    {
        code: 'WPED',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Associazione Impresa',
        abbreviation: '',
        active: true,
        aliases: ['Associazione Impresa'],
    },
    {
        code: 'WQCR',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Podnikateľ-fyzická osoba-zapís.v OR-podnikajúca súčasne ako osoba so slobodným povolaním',
        abbreviation: 'Živ.a sl.povolanie v OR',
        active: true,
        aliases: [
            'Podnikateľ-fyzická osoba-zapís.v OR-podnikajúca súčasne ako osoba so slobodným povolaním',
            'Živ.a sl.povolanie v OR',
        ],
    },
    {
        code: 'WQLU',
        country: 'US',
        jurisdiction: 'US-OR',
        jurisdictionName: 'Oregon',
        name: 'Limited Liability Partnership',
        abbreviation: 'Limited Liability Partnership;LLP;L.L.P.',
        active: true,
        aliases: ['Limited Liability Partnership', 'Limited Liability Partnership;LLP;L.L.P.'],
    },
    {
        code: 'WQRG',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Centrinis bankas',
        abbreviation: 'CB',
        active: true,
        aliases: ['Centrinis bankas', 'CB'],
    },
    {
        code: 'WR09',
        country: 'AE',
        jurisdiction: 'AE',
        jurisdictionName: 'United Arab Emirates',
        name: 'Private Joint Stock Company',
        abbreviation: '',
        active: true,
        aliases: ['Private Joint Stock Company'],
    },
    {
        code: 'WRF9',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Religious Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Religious Corporation'],
    },
    {
        code: 'WRU2',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società Consortile in Accomandita Semplice',
        abbreviation: '',
        active: true,
        aliases: ['Società Consortile in Accomandita Semplice'],
    },
    {
        code: 'WSE1',
        country: 'TN',
        jurisdiction: 'TN',
        jurisdictionName: 'Tunisia',
        name: 'Société à responsabilité limitée',
        abbreviation: 'SARL',
        active: true,
        aliases: ['Société à responsabilité limitée', 'SARL'],
    },
    {
        code: 'WT0G',
        country: 'US',
        jurisdiction: 'US-CT',
        jurisdictionName: 'Connecticut',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'WTK4',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Акционерно дружество',
        abbreviation: 'АД',
        active: true,
        aliases: ['Акционерно дружество', 'Aktsionerno druzhestvo', 'АД', 'AD'],
    },
    {
        code: 'WTLP',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Burgerlijke vennootschap onder vorm van coöperatieve vennootschap met onbeperkte aansprakelijkheid',
        abbreviation: 'BV CVOA',
        active: false,
        aliases: [
            'Burgerlijke vennootschap onder vorm van coöperatieve vennootschap met onbeperkte aansprakelijkheid',
            'BV CVOA',
            'Société civile sous forme de société coopérative à responsabilité illimitée',
            'SC SCRI',
            'Zivilrechtliche Gesellschaft in der Rechtsform einer Genossenschaft mit unbeschränkter Haftung',
            'ZvGGugcH',
        ],
    },
    {
        code: 'WTWK',
        country: 'US',
        jurisdiction: 'US-SC',
        jurisdictionName: 'South Carolina',
        name: 'Limited Liability Partnership',
        abbreviation: 'L.L.P.',
        active: true,
        aliases: ['Limited Liability Partnership', 'L.L.P.'],
    },
    {
        code: 'WU7R',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Forening med begrænset ansvar',
        abbreviation: 'FMBA',
        active: true,
        aliases: ['Forening med begrænset ansvar', 'FMBA'],
    },
    {
        code: 'WUAZ',
        country: 'AR',
        jurisdiction: 'AR',
        jurisdictionName: 'Argentina',
        name: 'Sociedad Anonima Unipersonal',
        abbreviation: 'S.A.U.',
        active: true,
        aliases: ['Sociedad Anonima Unipersonal', 'S.A.U.'],
    },
    {
        code: 'WUFK',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Odštěpný závod',
        abbreviation: '',
        active: true,
        aliases: ['Odštěpný závod'],
    },
    {
        code: 'WUJ2',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'uczelnia',
        abbreviation: '',
        active: true,
        aliases: ['uczelnia'],
    },
    {
        code: 'WUJC',
        country: 'KR',
        jurisdiction: 'KR',
        jurisdictionName: 'Korea (Republic of)',
        name: '공공단체',
        abbreviation: '',
        active: true,
        aliases: ['공공단체', 'GongGongDanChe'],
    },
    {
        code: 'WV3I',
        country: 'CW',
        jurisdiction: 'CW',
        jurisdictionName: 'Curaçao',
        name: 'Vereniging',
        abbreviation: '',
        active: true,
        aliases: ['Vereniging'],
    },
    {
        code: 'WVIN',
        country: 'BG',
        jurisdiction: 'BG',
        jurisdictionName: 'Bulgaria',
        name: 'Еднолично дружество с ограничена отговорност',
        abbreviation: 'ЕООД',
        active: true,
        aliases: [
            'Еднолично дружество с ограничена отговорност',
            'Ednolichno druzhestvo s ogranichena otgovornost',
            'ЕООД',
            'EOOD',
        ],
    },
    {
        code: 'WVQN',
        country: 'JM',
        jurisdiction: 'JM',
        jurisdictionName: 'Jamaica',
        name: 'sole trader',
        abbreviation: '',
        active: true,
        aliases: ['sole trader'],
    },
    {
        code: 'WVZF',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Účelová zahraničně obchodní organizace',
        abbreviation: '',
        active: true,
        aliases: ['Účelová zahraničně obchodní organizace'],
    },
    {
        code: 'WX45',
        country: 'CO',
        jurisdiction: 'CO',
        jurisdictionName: 'Colombia',
        name: 'Sociedad de Responsabilidad Limitada',
        abbreviation: 'Ltda.',
        active: true,
        aliases: ['Sociedad de Responsabilidad Limitada', 'Ltda.'],
    },
    {
        code: 'WXNU',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SCP d'huissiers",
        abbreviation: '',
        active: true,
        aliases: ["SCP d'huissiers"],
    },
    {
        code: 'WXPM',
        country: 'US',
        jurisdiction: 'US-WY',
        jurisdictionName: 'Wyoming',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'WY1B',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Municipal',
        abbreviation: 'corp.;inc.;co.;ltd. Incorporated;company;limited;corporation',
        active: true,
        aliases: ['Municipal', 'corp.;inc.;co.;ltd. Incorporated;company;limited;corporation'],
    },
    {
        code: 'WYG5',
        country: 'US',
        jurisdiction: 'US-TX',
        jurisdictionName: 'Texas',
        name: 'Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Company'],
    },
    {
        code: 'WYNO',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Союзы (ассоциации) кредитных кооперативов',
        abbreviation: '',
        active: true,
        aliases: [
            'Союзы (ассоциации) кредитных кооперативов',
            'Soyuzy (assotsiatsii) kreditnykh kooperativov',
        ],
    },
    {
        code: 'WZ78',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'komanditna delniška družba',
        abbreviation: 'k.d.d.',
        active: true,
        aliases: ['komanditna delniška družba', 'k.d.d.'],
    },
    {
        code: 'WZDB',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Bostadsförening',
        abbreviation: '',
        active: true,
        aliases: ['Bostadsförening'],
    },
    {
        code: 'X088',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Vereniging zonder rechtsbevoegdheid',
        abbreviation: '',
        active: true,
        aliases: ['Vereniging zonder rechtsbevoegdheid'],
    },
    {
        code: 'X0MP',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'limited liability partnership',
        abbreviation: 'LLP;ltd;Liability partnership;rllp;registered limited liability partnership',
        active: true,
        aliases: [
            'limited liability partnership',
            'LLP;ltd;Liability partnership;rllp;registered limited liability partnership',
        ],
    },
    {
        code: 'X0SD',
        country: 'BR',
        jurisdiction: 'BR',
        jurisdictionName: 'Brazil',
        name: 'Sociedade Anônima',
        abbreviation: 'S.A.;S/A',
        active: true,
        aliases: ['Sociedade Anônima', 'S.A.;S/A', 'Companhia'],
    },
    {
        code: 'X0SX',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Takarék- és hitelszövetkezet',
        abbreviation: 'tksz,;hsz.',
        active: true,
        aliases: ['Takarék- és hitelszövetkezet', 'tksz,;hsz.'],
    },
    {
        code: 'X1EL',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Limited Liability Company',
        abbreviation: 'LLC;limited liability company;ltd;liability company',
        active: true,
        aliases: ['Limited Liability Company', 'LLC;limited liability company;ltd;liability company'],
    },
    {
        code: 'X2X1',
        country: 'BB',
        jurisdiction: 'BB',
        jurisdictionName: 'Barbados',
        name: 'limited partnership',
        abbreviation: '',
        active: true,
        aliases: ['limited partnership'],
    },
    {
        code: 'X2ZT',
        country: 'BR',
        jurisdiction: 'BR',
        jurisdictionName: 'Brazil',
        name: 'Sociedade em Comandita por Ações',
        abbreviation: 'C/A',
        active: true,
        aliases: ['Sociedade em Comandita por Ações', 'C/A'],
    },
    {
        code: 'X32V',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società per Azioni con Socio Unico',
        abbreviation: '',
        active: true,
        aliases: ['Società per Azioni con Socio Unico'],
    },
    {
        code: 'X4EB',
        country: 'US',
        jurisdiction: 'US-IN',
        jurisdictionName: 'Indiana',
        name: 'Benefit Corporation',
        abbreviation: 'Corporation;Incorporated;Company;Limited;Corp;Inc. Co.;Ltd.',
        active: true,
        aliases: ['Benefit Corporation', 'Corporation;Incorporated;Company;Limited;Corp;Inc. Co.;Ltd.'],
    },
    {
        code: 'X4IT',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Government Company',
        abbreviation: '',
        active: true,
        aliases: ['Government Company'],
    },
    {
        code: 'X4TB',
        country: 'US',
        jurisdiction: 'US-KS',
        jurisdictionName: 'Kansas',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'X62Z',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Consorzio Di Cui Alla Dlgs 267/2000',
        abbreviation: '',
        active: true,
        aliases: ['Consorzio Di Cui Alla Dlgs 267/2000'],
    },
    {
        code: 'X6N9',
        country: 'CA',
        jurisdiction: 'CA-PE',
        jurisdictionName: 'Prince Edward Island',
        name: 'co-operative association',
        abbreviation: 'Co-operative Ltd;Coopérative Ltée',
        active: true,
        aliases: ['co-operative association', 'Co-operative Ltd;Coopérative Ltée'],
    },
    {
        code: 'X78I',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Fonds à forme sociétale à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["Fonds à forme sociétale à conseil d'administration"],
    },
    {
        code: 'X7W6',
        country: 'MC',
        jurisdiction: 'MC',
        jurisdictionName: 'Monaco',
        name: 'Entreprise en Nom Personnel',
        abbreviation: '',
        active: true,
        aliases: ['Entreprise en Nom Personnel'],
    },
    {
        code: 'X8J8',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Politinės partijos',
        abbreviation: 'PP',
        active: true,
        aliases: ['Politinės partijos', 'PP'],
    },
    {
        code: 'X8ZK',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Coöperatieve vennootschap met beperkte aansprakelijkheid van publiek recht',
        abbreviation: 'CVBA PR',
        active: true,
        aliases: [
            'Coöperatieve vennootschap met beperkte aansprakelijkheid van publiek recht',
            'CVBA PR',
            'Société coopérative à responsabilité limitée de droit public',
            'SCRL DPU',
            'Öffentlich-rechtliche Genossenschaft mit beschränkter Haftung',
            'ÖfrGmbH',
        ],
    },
    {
        code: 'X94Z',
        country: 'SI',
        jurisdiction: 'SI',
        jurisdictionName: 'Slovenia',
        name: 'Republika Slovenija',
        abbreviation: '',
        active: true,
        aliases: ['Republika Slovenija'],
    },
    {
        code: 'X9J8',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Asociación ganadera local especializada',
        abbreviation: '',
        active: true,
        aliases: ['Asociación ganadera local especializada'],
    },
    {
        code: 'XAQA',
        country: 'KY',
        jurisdiction: 'KY',
        jurisdictionName: 'Cayman Islands',
        name: 'limited partnership',
        abbreviation: 'LP',
        active: true,
        aliases: ['limited partnership', 'LP'],
    },
    {
        code: 'XBK3',
        country: 'PK',
        jurisdiction: 'PK',
        jurisdictionName: 'Pakistan',
        name: 'Limited Liability Partnership',
        abbreviation: 'LLP;L.L.P.;limited liability partnership;Limited Liability Partnership',
        active: true,
        aliases: [
            'Limited Liability Partnership',
            'LLP;L.L.P.;limited liability partnership;Limited Liability Partnership',
        ],
    },
    {
        code: 'XBKP',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Agricultural Association',
        abbreviation: '',
        active: true,
        aliases: ['Agricultural Association'],
    },
    {
        code: 'XBRI',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Неправительственные международные организации',
        abbreviation: '',
        active: true,
        aliases: [
            'Неправительственные международные организации',
            "Nepravitel'stvennyye mezhdunarodnyye organizatsii",
        ],
    },
    {
        code: 'XD16',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Empresa Metropolitana',
        abbreviation: '',
        active: true,
        aliases: ['Empresa Metropolitana'],
    },
    {
        code: 'XDGC',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad cooperativa limitada',
        abbreviation: 'S.C.L.',
        active: true,
        aliases: ['Sociedad cooperativa limitada', 'S.C.L.'],
    },
    {
        code: 'XDKS',
        country: 'BS',
        jurisdiction: 'BS',
        jurisdictionName: 'Bahamas',
        name: 'Sole Proprietor',
        abbreviation: '',
        active: true,
        aliases: ['Sole Proprietor'],
    },
    {
        code: 'XDZ7',
        country: 'GT',
        jurisdiction: 'GT',
        jurisdictionName: 'Guatemala',
        name: 'Fundacion',
        abbreviation: '',
        active: true,
        aliases: ['Fundacion'],
    },
    {
        code: 'XE4Z',
        country: 'ZA',
        jurisdiction: 'ZA',
        jurisdictionName: 'South Africa',
        name: 'Public Company',
        abbreviation: 'Ltd;Ltd.;Limited',
        active: true,
        aliases: ['Public Company', 'Ltd;Ltd.;Limited'],
    },
    {
        code: 'XE7O',
        country: 'HN',
        jurisdiction: 'HN',
        jurisdictionName: 'Honduras',
        name: 'Sociedad de Responsabilidad Limitada',
        abbreviation: 'S. De R. L.',
        active: true,
        aliases: ['Sociedad de Responsabilidad Limitada', 'S. De R. L.'],
    },
    {
        code: 'XEN5',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad en comandita simple',
        abbreviation: 'S. en C.',
        active: true,
        aliases: ['Sociedad en comandita simple', 'S. en C.'],
    },
    {
        code: 'XEOV',
        country: 'MY',
        jurisdiction: 'MY',
        jurisdictionName: 'Malaysia',
        name: 'Private Limited Company',
        abbreviation: 'Sdn Bhd;Pte. Ltd',
        active: true,
        aliases: ['Private Limited Company', 'Sdn Bhd;Pte. Ltd', 'Sendirian Berhad'],
    },
    {
        code: 'XFHP',
        country: 'ID',
        jurisdiction: 'ID',
        jurisdictionName: 'Indonesia',
        name: 'Usaha Dagang',
        abbreviation: '',
        active: true,
        aliases: ['Usaha Dagang'],
    },
    {
        code: 'XFUO',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'XG70',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Právnikcá osoba zřízená zvláštním zákonem zapisovaná do veřejného rejstříku',
        abbreviation: '',
        active: true,
        aliases: ['Právnikcá osoba zřízená zvláštním zákonem zapisovaná do veřejného rejstříku'],
    },
    {
        code: 'XGKW',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Ahvenanmaan liikelaitos',
        abbreviation: '',
        active: true,
        aliases: ['Ahvenanmaan liikelaitos', 'Ålands affärsverk'],
    },
    {
        code: 'XH5R',
        country: 'GT',
        jurisdiction: 'GT',
        jurisdictionName: 'Guatemala',
        name: 'Sociedad Anónima',
        abbreviation: 'S.A.',
        active: true,
        aliases: ['Sociedad Anónima', 'S.A.'],
    },
    {
        code: 'XH7Z',
        country: 'MK',
        jurisdiction: 'MK',
        jurisdictionName: 'North Macedonia',
        name: 'Командитно друштво',
        abbreviation: 'KD',
        active: true,
        aliases: ['Командитно друштво', 'Komanditno drustvo', 'KD'],
    },
    {
        code: 'XH8C',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Association déclarée, reconnue d'utilité publique",
        abbreviation: '',
        active: true,
        aliases: ["Association déclarée, reconnue d'utilité publique"],
    },
    {
        code: 'XHCV',
        country: 'AU',
        jurisdiction: 'AU',
        jurisdictionName: 'Australia',
        name: 'Indigenous Corporation',
        abbreviation: 'Indigenous corporation;RNTBC',
        active: true,
        aliases: ['Indigenous Corporation', 'Indigenous corporation;RNTBC'],
    },
    {
        code: 'XHN1',
        country: 'RO',
        jurisdiction: 'RO',
        jurisdictionName: 'Romania',
        name: 'Societate cu răspundere limitată',
        abbreviation: 'SRL',
        active: true,
        aliases: ['Societate cu răspundere limitată', 'SRL'],
    },
    {
        code: 'XHT1',
        country: 'US',
        jurisdiction: 'US-MD',
        jurisdictionName: 'Maryland',
        name: 'Sole Proprietorship',
        abbreviation: '',
        active: true,
        aliases: ['Sole Proprietorship'],
    },
    {
        code: 'XHWP',
        country: 'FJ',
        jurisdiction: 'FJ',
        jurisdictionName: 'Fiji',
        name: 'Non-Profit Organisation',
        abbreviation: '',
        active: true,
        aliases: ['Non-Profit Organisation'],
    },
    {
        code: 'XIGI',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Муниципальные казенные предприятия',
        abbreviation: '',
        active: true,
        aliases: ['Муниципальные казенные предприятия', "Munitsipal'nyye kazennyye predpriyatiya"],
    },
    {
        code: 'XINV',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Кооперативные хозяйства (коопхозы)',
        abbreviation: '',
        active: true,
        aliases: ['Кооперативные хозяйства (коопхозы)', 'Kooperativnyye khozyaystva (koopkhozy)'],
    },
    {
        code: 'XIZI',
        country: 'US',
        jurisdiction: 'US-NY',
        jurisdictionName: 'New York',
        name: 'Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Limited Liability Partnership'],
    },
    {
        code: 'XJH3',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Eurooppayhtiö',
        abbreviation: 'SE',
        active: true,
        aliases: ['Eurooppayhtiö', 'SE', 'Europabolag'],
    },
    {
        code: 'XJHM',
        country: 'SE',
        jurisdiction: 'SE',
        jurisdictionName: 'Sweden',
        name: 'Aktiebolag',
        abbreviation: 'AB',
        active: true,
        aliases: ['Aktiebolag', 'AB'],
    },
    {
        code: 'XJJR',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Союзы (ассоциации) общин малочисленных народов',
        abbreviation: '',
        active: true,
        aliases: [
            'Союзы (ассоциации) общин малочисленных народов',
            'Soyuzy (assotsiatsii) obshchin malochislennykh narodov',
        ],
    },
    {
        code: 'XJOT',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'Investment company with variable capital',
        abbreviation: '',
        active: true,
        aliases: [
            'Investment company with variable capital',
            "Société d'investissement à capital variable (SICAV)",
            'Investmentgesellschaft mit variablem Kapital (SICAV)',
            'Società di investimento a capitale variabile (SICAV)',
        ],
    },
    {
        code: 'XK4T',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Comité social économique d’entreprise',
        abbreviation: '',
        active: true,
        aliases: ['Comité social économique d’entreprise'],
    },
    {
        code: 'XK6L',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'International Financial Entity (Corporation)',
        abbreviation: '',
        active: false,
        aliases: ['International Financial Entity (Corporation)', 'Cooperative de Consumo'],
    },
    {
        code: 'XL51',
        country: 'BQ',
        jurisdiction: 'BQ',
        jurisdictionName: 'Bonaire, Sint Eustatius and Saba',
        name: 'Commanditaire vennootschap met één beherend vennoot',
        abbreviation: '',
        active: true,
        aliases: ['Commanditaire vennootschap met één beherend vennoot'],
    },
    {
        code: 'XLEO',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Gewone commanditaire vennootschap met een sociaal oogmerk',
        abbreviation: 'GCW SO',
        active: true,
        aliases: [
            'Gewone commanditaire vennootschap met een sociaal oogmerk',
            'GCW SO',
            'Société en commandite simple à finalité sociale',
            'SCS FS',
            'Einfache Kommanditgesellschaft mit sozialer Zielsetzung',
            'EKGmsZ',
        ],
    },
    {
        code: 'XLVZ',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad de responsabilidad limitada de capital variable',
        abbreviation: 'S. de R. L. de C. V.',
        active: true,
        aliases: ['Sociedad de responsabilidad limitada de capital variable', 'S. de R. L. de C. V.'],
    },
    {
        code: 'XLWA',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Anstalt des öffentlichen Rechts',
        abbreviation: '',
        active: true,
        aliases: ['Anstalt des öffentlichen Rechts'],
    },
    {
        code: 'XLXU',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Politická strana, politické hnutie',
        abbreviation: '',
        active: true,
        aliases: ['Politická strana, politické hnutie'],
    },
    {
        code: 'XLZV',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Registered Society',
        abbreviation: '',
        active: true,
        aliases: ['Registered Society'],
    },
    {
        code: 'XMXM',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Fundo',
        abbreviation: '',
        active: false,
        aliases: ['Fundo'],
    },
    {
        code: 'XNKN',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Кредитные потребительские кооперативы граждан',
        abbreviation: '',
        active: true,
        aliases: [
            'Кредитные потребительские кооперативы граждан',
            "Kreditnyye potrebitel'skiye kooperativy grazhdan",
        ],
    },
    {
        code: 'XOAD',
        country: 'EC',
        jurisdiction: 'EC',
        jurisdictionName: 'Ecuador',
        name: 'Compañía de Responsabilidad Limitada',
        abbreviation: 'CIA LTDA',
        active: true,
        aliases: ['Compañía de Responsabilidad Limitada', 'CIA LTDA'],
    },
    {
        code: 'XOYI',
        country: 'CA',
        jurisdiction: 'CA-BC',
        jurisdictionName: 'British Columbia',
        name: 'Credit union',
        abbreviation: '',
        active: true,
        aliases: ['Credit union'],
    },
    {
        code: 'XPE5',
        country: 'HK',
        jurisdiction: 'HK',
        jurisdictionName: 'Hong Kong',
        name: '有限責任合夥',
        abbreviation: 'LP;limited partnership;Limited Partnership',
        active: true,
        aliases: [
            '有限責任合夥',
            'you xian ze ren he huo',
            'LP;limited partnership;Limited Partnership',
            'Limited partnership',
        ],
    },
    {
        code: 'XPX6',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA coopérative de production (SCOP) à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["SA coopérative de production (SCOP) à conseil d'administration"],
    },
    {
        code: 'XQBA',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société en participation avec personne morale',
        abbreviation: '',
        active: true,
        aliases: ['Société en participation avec personne morale'],
    },
    {
        code: 'XQEC',
        country: 'US',
        jurisdiction: 'US-KS',
        jurisdictionName: 'Kansas',
        name: 'Limited Partnership',
        abbreviation: 'LP',
        active: true,
        aliases: ['Limited Partnership', 'LP'],
    },
    {
        code: 'XQLW',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Jedinica lokalne ili područne (regionalne) samouprave',
        abbreviation: '',
        active: true,
        aliases: ['Jedinica lokalne ili područne (regionalne) samouprave'],
    },
    {
        code: 'XQRI',
        country: 'BR',
        jurisdiction: 'BR',
        jurisdictionName: 'Brazil',
        name: 'Sociedade em Conta de Participação',
        abbreviation: 'S.C.P.',
        active: true,
        aliases: ['Sociedade em Conta de Participação', 'S.C.P.'],
    },
    {
        code: 'XQZX',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Burgerlijke vennootschap onder vorm van naamloze vennootschap',
        abbreviation: 'BV NV',
        active: false,
        aliases: [
            'Burgerlijke vennootschap onder vorm van naamloze vennootschap',
            'BV NV',
            'Société civile sous forme de société anonyme',
            'SC SA',
            'Zivilrechtliche Gesellschaft in der Rechtsform einer Aktiengesellschaft',
            'ZRG AG',
        ],
    },
    {
        code: 'XRK7',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Politická strana, politické hnutí',
        abbreviation: '',
        active: true,
        aliases: ['Politická strana, politické hnutí'],
    },
    {
        code: 'XS49',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi concernant le regroupement et la gestion des commissions scolaires',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi concernant le regroupement et la gestion des commissions scolaires',
        ],
    },
    {
        code: 'XSNP',
        country: 'US',
        jurisdiction: 'US-NJ',
        jurisdictionName: 'New Jersey',
        name: 'Business Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Business Corporation'],
    },
    {
        code: 'XST3',
        country: 'US',
        jurisdiction: 'US-MS',
        jurisdictionName: 'Mississippi',
        name: 'Business Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.',
        active: true,
        aliases: ['Business Corporation', 'corp.;inc.;co.;ltd.'],
    },
    {
        code: 'XSZY',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad anónima financiera popular',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad anónima financiera popular'],
    },
    {
        code: 'XTCQ',
        country: 'BO',
        jurisdiction: 'BO',
        jurisdictionName: 'Bolivia (Plurinational State of)',
        name: 'Sociedad en Comandita Simple.',
        abbreviation: 'S.C.S.',
        active: true,
        aliases: ['Sociedad en Comandita Simple.', 'S.C.S.'],
    },
    {
        code: 'XTIQ',
        country: 'US',
        jurisdiction: 'US-DE',
        jurisdictionName: 'Delaware',
        name: 'Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Corporation'],
    },
    {
        code: 'XTOF',
        country: 'US',
        jurisdiction: 'US-MI',
        jurisdictionName: 'Michigan',
        name: 'Railroad',
        abbreviation: '',
        active: true,
        aliases: ['Railroad'],
    },
    {
        code: 'XTZG',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Banking Company - Nationalised Bank',
        abbreviation: '',
        active: true,
        aliases: ['Banking Company - Nationalised Bank'],
    },
    {
        code: 'XUUL',
        country: 'US',
        jurisdiction: 'US-AZ',
        jurisdictionName: 'Arizona',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'XUVE',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Bank',
        abbreviation: '',
        active: false,
        aliases: ['Bank'],
    },
    {
        code: 'XUYT',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'International Banking Center (LLC)',
        abbreviation: '',
        active: false,
        aliases: ['International Banking Center (LLC)', 'Cooperative de Ahorro y Crédito'],
    },
    {
        code: 'XVC6',
        country: 'US',
        jurisdiction: 'US-MT',
        jurisdictionName: 'Montana',
        name: 'Series Limited Liability Company',
        abbreviation: '',
        active: true,
        aliases: ['Series Limited Liability Company'],
    },
    {
        code: 'XW5K',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur la Fédération des guides catholiques du Québec',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur la Fédération des guides catholiques du Québec',
        ],
    },
    {
        code: 'XW5U',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Európai részvénytársaság',
        abbreviation: 'SE',
        active: true,
        aliases: ['Európai részvénytársaság', 'SE'],
    },
    {
        code: 'XWPT',
        country: 'GH',
        jurisdiction: 'GH',
        jurisdictionName: 'Ghana',
        name: 'Subsidiary Business Name',
        abbreviation: '',
        active: true,
        aliases: ['Subsidiary Business Name'],
    },
    {
        code: 'XXCZ',
        country: 'MU',
        jurisdiction: 'MU',
        jurisdictionName: 'Mauritius',
        name: 'Public company limited by shares',
        abbreviation: 'PC;PLC;LTD;LTEE',
        active: true,
        aliases: ['Public company limited by shares', 'PC;PLC;LTD;LTEE'],
    },
    {
        code: 'XXQQ',
        country: 'BJ',
        jurisdiction: 'BJ',
        jurisdictionName: 'Benin',
        name: 'Société en Nom Collectif',
        abbreviation: 'SNC',
        active: true,
        aliases: ['Société en Nom Collectif', 'SNC'],
    },
    {
        code: 'XY6R',
        country: 'VC',
        jurisdiction: 'VC',
        jurisdictionName: 'Saint Vincent and the Grenadines',
        name: 'co-operative society',
        abbreviation: '',
        active: true,
        aliases: ['co-operative society'],
    },
    {
        code: 'XYGP',
        country: 'ES',
        jurisdiction: 'ES',
        jurisdictionName: 'Spain',
        name: 'Fondo de Capital-Riesgo-Pyme',
        abbreviation: 'FCR-Pyme',
        active: true,
        aliases: ['Fondo de Capital-Riesgo-Pyme', 'FCR-Pyme'],
    },
    {
        code: 'Y182',
        country: 'US',
        jurisdiction: 'US-CT',
        jurisdictionName: 'Connecticut',
        name: 'Limited Liability Company',
        abbreviation: 'LLC;L.L.C;, Limited Liability Co.;Ltd. Liability Company;Ltd. Liability Co;P.L.L.C.;PLLC',
        active: true,
        aliases: [
            'Limited Liability Company',
            'LLC;L.L.C;, Limited Liability Co.;Ltd. Liability Company;Ltd. Liability Co;P.L.L.C.;PLLC',
        ],
    },
    {
        code: 'Y18E',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Společný podnik',
        abbreviation: '',
        active: true,
        aliases: ['Společný podnik'],
    },
    {
        code: 'Y1Q4',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Private stichting',
        abbreviation: 'PRIV ST.;PS',
        active: true,
        aliases: [
            'Private stichting',
            'PRIV ST.;PS',
            'Fondation privée',
            'FONDPRIV',
            'Privatstiftung',
            'PrSt',
        ],
    },
    {
        code: 'Y1W1',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Section de commune',
        abbreviation: '',
        active: true,
        aliases: ['Section de commune'],
    },
    {
        code: 'Y1X5',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Štátny podnik',
        abbreviation: '',
        active: true,
        aliases: ['Štátny podnik'],
    },
    {
        code: 'Y1ZD',
        country: 'US',
        jurisdiction: 'US-NM',
        jurisdictionName: 'New Mexico',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'Y21X',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Sponsored By Municipal Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Sponsored By Municipal Corporation', 'Corporación Auspiciada Por Municipios'],
    },
    {
        code: 'Y2L3',
        country: 'BW',
        jurisdiction: 'BW',
        jurisdictionName: 'Botswana',
        name: 'Companies limited by Guarantee',
        abbreviation: '',
        active: true,
        aliases: ['Companies limited by Guarantee'],
    },
    {
        code: 'Y33B',
        country: 'CA',
        jurisdiction: 'CA-PE',
        jurisdictionName: 'Prince Edward Island',
        name: 'partnership',
        abbreviation: '',
        active: true,
        aliases: ['partnership'],
    },
    {
        code: 'Y3T2',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Special Corporation for Municipal Development',
        abbreviation: '',
        active: false,
        aliases: ['Special Corporation for Municipal Development', 'Corporación Professional'],
    },
    {
        code: 'Y3ZB',
        country: 'NL',
        jurisdiction: 'NL',
        jurisdictionName: 'Netherlands',
        name: 'Societas Cooperativa Europaea',
        abbreviation: 'SCE;S.C.E.',
        active: true,
        aliases: ['Societas Cooperativa Europaea', 'SCE;S.C.E.'],
    },
    {
        code: 'Y45C',
        country: 'TW',
        jurisdiction: 'TW',
        jurisdictionName: 'Taiwan (Province of China)',
        name: '有限公司',
        abbreviation: '',
        active: true,
        aliases: ['有限公司', 'Yǒuxiàn gōngsī'],
    },
    {
        code: 'Y45Q',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Podnik zahraničného obchodu',
        abbreviation: 'PZO',
        active: true,
        aliases: ['Podnik zahraničného obchodu', 'PZO'],
    },
    {
        code: 'Y485',
        country: 'CA',
        jurisdiction: 'CA-MB',
        jurisdictionName: 'Manitoba',
        name: 'Credit union',
        abbreviation: 'credit union Limited;credit union Ltd;caisse populaire limitée;caisee populaire ltée',
        active: true,
        aliases: [
            'Credit union',
            'Credit union or Caisse Populaire',
            'credit union Limited;credit union Ltd;caisse populaire limitée;caisee populaire ltée',
        ],
    },
    {
        code: 'Y4VA',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Département',
        abbreviation: '',
        active: true,
        aliases: ['Département'],
    },
    {
        code: 'Y5L0',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Mutual Burial Association',
        abbreviation: 'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation',
        active: true,
        aliases: [
            'Mutual Burial Association',
            'corp.;inc.;co.;ltd.;Incorporated;company;limited;corporation',
        ],
    },
    {
        code: 'Y64R',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Országos betétbiztosítási alap',
        abbreviation: 'OBA',
        active: true,
        aliases: ['Országos betétbiztosítási alap', 'OBA'],
    },
    {
        code: 'Y7BG',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Hospital Authority',
        abbreviation: '',
        active: true,
        aliases: ['Hospital Authority'],
    },
    {
        code: 'Y7G8',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Caisse locale de crédit mutuel',
        abbreviation: '',
        active: true,
        aliases: ['Caisse locale de crédit mutuel'],
    },
    {
        code: 'Y7LW',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Low Profit LLC',
        abbreviation: '',
        active: false,
        aliases: ['Low Profit LLC', 'Corporación Auspiciada Por Municipios'],
    },
    {
        code: 'Y7PW',
        country: 'US',
        jurisdiction: 'US-WI',
        jurisdictionName: 'Wisconsin',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'Y80K',
        country: 'CA',
        jurisdiction: 'CA-NS',
        jurisdictionName: 'Nova Scotia',
        name: 'Non-profit Corporations',
        abbreviation: 'Society;Association',
        active: true,
        aliases: ['Non-profit Corporations', 'Society;Association'],
    },
    {
        code: 'Y8CL',
        country: 'GI',
        jurisdiction: 'GI',
        jurisdictionName: 'Gibraltar',
        name: 'Limited Partnerships',
        abbreviation: 'LP;limited partnership;Limited Partnership',
        active: true,
        aliases: ['Limited Partnerships', 'LP;limited partnership;Limited Partnership'],
    },
    {
        code: 'Y8F1',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Organización Deportiva',
        abbreviation: '',
        active: true,
        aliases: ['Organización Deportiva'],
    },
    {
        code: 'Y8GA',
        country: 'US',
        jurisdiction: 'US-MI',
        jurisdictionName: 'Michigan',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'Y8LH',
        country: 'LI',
        jurisdiction: 'LI',
        jurisdictionName: 'Liechtenstein',
        name: 'Gesellschaft mit beschränkter Haftung',
        abbreviation: 'GmbH;Ges.m.b.H.',
        active: true,
        aliases: ['Gesellschaft mit beschränkter Haftung', 'GmbH;Ges.m.b.H.'],
    },
    {
        code: 'Y8W9',
        country: 'SG',
        jurisdiction: 'SG',
        jurisdictionName: 'Singapore',
        name: 'Exempt Private Company',
        abbreviation: '',
        active: true,
        aliases: ['Exempt Private Company'],
    },
    {
        code: 'Y8WC',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Groupement de coopération sanitaire à gestion privée',
        abbreviation: '',
        active: true,
        aliases: ['Groupement de coopération sanitaire à gestion privée'],
    },
    {
        code: 'Y9F2',
        country: 'US',
        jurisdiction: 'US-NV',
        jurisdictionName: 'Nevada',
        name: 'Industrial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Industrial Bank'],
    },
    {
        code: 'YA01',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Gemeinnützige Aktiengesellschaft',
        abbreviation: 'gAG',
        active: true,
        aliases: ['Gemeinnützige Aktiengesellschaft', 'gAG'],
    },
    {
        code: 'YA7H',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Частные учреждения',
        abbreviation: '',
        active: true,
        aliases: ['Частные учреждения', 'Chastnyye uchrezhdeniya'],
    },
    {
        code: 'YA9S',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Zajednica ustanova',
        abbreviation: '',
        active: true,
        aliases: ['Zajednica ustanova'],
    },
    {
        code: 'YADL',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Autorité administrative ou publique indépendante',
        abbreviation: '',
        active: true,
        aliases: ['Autorité administrative ou publique indépendante'],
    },
    {
        code: 'YB0U',
        country: 'MT',
        jurisdiction: 'MT',
        jurisdictionName: 'Malta',
        name: 'European Economic Interest Grouping',
        abbreviation: 'EEIG',
        active: true,
        aliases: ['European Economic Interest Grouping', 'EEIG'],
    },
    {
        code: 'YB1Q',
        country: 'GU',
        jurisdiction: 'GU',
        jurisdictionName: 'Guam',
        name: 'limited liability partnership',
        abbreviation: '',
        active: true,
        aliases: ['limited liability partnership'],
    },
    {
        code: 'YB59',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Podnik so zahraničnou majetkovou účasťou',
        abbreviation: 'Podnik so zahr.maj.úč.',
        active: true,
        aliases: ['Podnik so zahraničnou majetkovou účasťou', 'Podnik so zahr.maj.úč.'],
    },
    {
        code: 'YBHM',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Europese Coöperatieve Vennootschap',
        abbreviation: 'SCE',
        active: true,
        aliases: [
            'Europese Coöperatieve Vennootschap',
            'SCE',
            'Société coopérative européenne',
            'Europäische Genossenschaft',
            'OFP',
        ],
    },
    {
        code: 'YBMJ',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les assurances',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur les assurances'],
    },
    {
        code: 'YCQM',
        country: 'CK',
        jurisdiction: 'CK',
        jurisdictionName: 'Cook Islands',
        name: 'International Trust',
        abbreviation: '',
        active: true,
        aliases: ['International Trust'],
    },
    {
        code: 'YCV2',
        country: 'AW',
        jurisdiction: 'AW',
        jurisdictionName: 'Aruba',
        name: 'Commanditaire vennootschap (1+)',
        abbreviation: '',
        active: true,
        aliases: ['Commanditaire vennootschap (1+)'],
    },
    {
        code: 'YDNQ',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Fundación',
        abbreviation: '',
        active: true,
        aliases: ['Fundación'],
    },
    {
        code: 'YF99',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Verejnoprávna inštitúcia',
        abbreviation: 'Verejnopráv.inštitúcia',
        active: true,
        aliases: ['Verejnoprávna inštitúcia', 'Verejnopráv.inštitúcia'],
    },
    {
        code: 'YFZL',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Fideicomiso de Partidos Políticos',
        abbreviation: '',
        active: true,
        aliases: ['Fideicomiso de Partidos Políticos'],
    },
    {
        code: 'YG5M',
        country: 'CA',
        jurisdiction: 'CA-BC',
        jurisdictionName: 'British Columbia',
        name: 'Company (includes community contribution company and unlimited liability company)',
        abbreviation: 'Ltd.;Inc.;Corp.',
        active: true,
        aliases: [
            'Company (includes community contribution company and unlimited liability company)',
            'Ltd.;Inc.;Corp.',
        ],
    },
    {
        code: 'YGHZ',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Паевые инвестиционные фонды',
        abbreviation: '',
        active: true,
        aliases: ['Паевые инвестиционные фонды', 'Payevyye investitsionnyye fondy'],
    },
    {
        code: 'YGN4',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Organizačná zložka podniku',
        abbreviation: '',
        active: true,
        aliases: ['Organizačná zložka podniku'],
    },
    {
        code: 'YHI5',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Pôle métropolitain',
        abbreviation: '',
        active: true,
        aliases: ['Pôle métropolitain'],
    },
    {
        code: 'YI42',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Aksjeselskap',
        abbreviation: 'AS',
        active: true,
        aliases: ['Aksjeselskap', 'AS'],
    },
    {
        code: 'YIIS',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les corporations religieuses',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur les corporations religieuses'],
    },
    {
        code: 'YJ4C',
        country: 'DE',
        jurisdiction: 'DE',
        jurisdictionName: 'Germany',
        name: 'Kirchliche Stiftung des öffentlichen Rechts',
        abbreviation: '',
        active: true,
        aliases: ['Kirchliche Stiftung des öffentlichen Rechts'],
    },
    {
        code: 'YJ6A',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Общественные движения',
        abbreviation: '',
        active: true,
        aliases: ['Общественные движения', 'Obshchestvennyye dvizheniya'],
    },
    {
        code: 'YJM5',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Officier public ou ministériel',
        abbreviation: '',
        active: false,
        aliases: ['Officier public ou ministériel'],
    },
    {
        code: 'YJZ3',
        country: 'US',
        jurisdiction: 'US-NC',
        jurisdictionName: 'North Carolina',
        name: 'Registered Limited Liability Limited Partnership',
        abbreviation: 'RLLLP;LLLP;Registered Ltd.;Liability Ltd.;Partnership',
        active: true,
        aliases: [
            'Registered Limited Liability Limited Partnership',
            'RLLLP;LLLP;Registered Ltd.;Liability Ltd.;Partnership',
        ],
    },
    {
        code: 'YK5G',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Säätiö',
        abbreviation: 'sr',
        active: true,
        aliases: ['Säätiö', 'sr', 'Stiftelse'],
    },
    {
        code: 'YLZL',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'spółka cywilna',
        abbreviation: 's.c.',
        active: true,
        aliases: ['spółka cywilna', 's.c.'],
    },
    {
        code: 'YMB7',
        country: 'GT',
        jurisdiction: 'GT',
        jurisdictionName: 'Guatemala',
        name: 'Sociedad de Emprendimiento',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad de Emprendimiento'],
    },
    {
        code: 'YMBC',
        country: 'PE',
        jurisdiction: 'PE',
        jurisdictionName: 'Peru',
        name: 'Sociedad legal',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad legal'],
    },
    {
        code: 'YMLD',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Agrupamento Complementar de Empresas',
        abbreviation: '',
        active: true,
        aliases: ['Agrupamento Complementar de Empresas'],
    },
    {
        code: 'YN9X',
        country: 'FJ',
        jurisdiction: 'FJ',
        jurisdictionName: 'Fiji',
        name: 'Government Owned Trading Entity',
        abbreviation: '',
        active: true,
        aliases: ['Government Owned Trading Entity'],
    },
    {
        code: 'YN9Y',
        country: 'VC',
        jurisdiction: 'VC',
        jurisdictionName: 'Saint Vincent and the Grenadines',
        name: 'international business company - company limited by shares - segregated cell company',
        abbreviation: 'SCC Limited;SCC Ltd',
        active: true,
        aliases: [
            'international business company - company limited by shares - segregated cell company',
            'SCC Limited;SCC Ltd',
        ],
    },
    {
        code: 'YNEH',
        country: 'GU',
        jurisdiction: 'GU',
        jurisdictionName: 'Guam',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'YOB3',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Electric Cooperative Corporations',
        abbreviation: 'coop;co-op',
        active: true,
        aliases: ['Electric Cooperative Corporations', 'coop;co-op'],
    },
    {
        code: 'YOIW',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Sociedad Anónima',
        abbreviation: 'S.A.',
        active: true,
        aliases: ['Sociedad Anónima', 'S.A.'],
    },
    {
        code: 'YOMR',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Őstermelők családi gazdasága ',
        abbreviation: 'ÖCSG',
        active: true,
        aliases: ['Őstermelők családi gazdasága ', 'ÖCSG'],
    },
    {
        code: 'YOP9',
        country: 'VG',
        jurisdiction: 'VG',
        jurisdictionName: 'Virgin Islands (British)',
        name: 'segregated portfolio company',
        abbreviation: 'SPC',
        active: true,
        aliases: ['segregated portfolio company', 'SPC'],
    },
    {
        code: 'YOUG',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Commercial Registered Agent',
        abbreviation: 'C.R.A.',
        active: false,
        aliases: ['Commercial Registered Agent', 'C.R.A.'],
    },
    {
        code: 'YP04',
        country: 'US',
        jurisdiction: 'US-MA',
        jurisdictionName: 'Massachusetts',
        name: 'Commercial Bank',
        abbreviation: '',
        active: true,
        aliases: ['Commercial Bank'],
    },
    {
        code: 'YP63',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Sociedad en comandita',
        abbreviation: 'S. en C.',
        active: true,
        aliases: ['Sociedad en comandita', 'S. en C.'],
    },
    {
        code: 'YPG1',
        country: 'TZ',
        jurisdiction: 'TZ',
        jurisdictionName: 'Tanzania',
        name: 'Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Partnership'],
    },
    {
        code: 'YQDQ',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Domestic Limited Liability Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Domestic Limited Liability Partnership'],
    },
    {
        code: 'YQLO',
        country: 'US',
        jurisdiction: 'US-UT',
        jurisdictionName: 'Utah',
        name: 'Uniform Limited Cooperative Association',
        abbreviation: '',
        active: true,
        aliases: ['Uniform Limited Cooperative Association'],
    },
    {
        code: 'YRGM',
        country: 'CH',
        jurisdiction: 'CH',
        jurisdictionName: 'Switzerland',
        name: 'District administration',
        abbreviation: 'District administration',
        active: true,
        aliases: [
            'District administration',
            'Administration du district',
            'District',
            'Verwaltung des Bezirks',
            'Bezirk',
            'Amministrazione del distretto',
            'Distretto',
        ],
    },
    {
        code: 'YRI0',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Fideicomiso público de fomento económico',
        abbreviation: '',
        active: true,
        aliases: ['Fideicomiso público de fomento económico'],
    },
    {
        code: 'YRIU',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Nezisková organizácia',
        abbreviation: '',
        active: true,
        aliases: ['Nezisková organizácia'],
    },
    {
        code: 'YRMK',
        country: 'UY',
        jurisdiction: 'UY',
        jurisdictionName: 'Uruguay',
        name: 'Sociedad Anónima',
        abbreviation: 'S.A.',
        active: true,
        aliases: ['Sociedad Anónima', 'S.A.'],
    },
    {
        code: 'YRUJ',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Société en nom collectif',
        abbreviation: 'S.E.N.C.',
        active: true,
        aliases: ['Société en nom collectif', 'S.E.N.C.'],
    },
    {
        code: 'YRXK',
        country: 'LT',
        jurisdiction: 'LT',
        jurisdictionName: 'Lithuania',
        name: 'Savivaldybių įmonės',
        abbreviation: 'SI',
        active: true,
        aliases: ['Savivaldybių įmonės', 'SI'],
    },
    {
        code: 'YS05',
        country: 'US',
        jurisdiction: 'US-SC',
        jurisdictionName: 'South Carolina',
        name: 'Savings and Loan Association',
        abbreviation: '',
        active: true,
        aliases: ['Savings and Loan Association'],
    },
    {
        code: 'YS16',
        country: 'PR',
        jurisdiction: 'PR',
        jurisdictionName: 'Puerto Rico',
        name: 'Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Corporation', 'Corporación'],
    },
    {
        code: 'YSBJ',
        country: 'SB',
        jurisdiction: 'SB',
        jurisdictionName: 'Solomon Islands',
        name: 'Overseas Company',
        abbreviation: '',
        active: true,
        aliases: ['Overseas Company'],
    },
    {
        code: 'YSP9',
        country: 'IN',
        jurisdiction: 'IN',
        jurisdictionName: 'India',
        name: 'Private Limited Company',
        abbreviation: 'Pvt Ltd;Pvt. Ltd.;PVT LTD',
        active: true,
        aliases: ['Private Limited Company', 'Pvt Ltd;Pvt. Ltd.;PVT LTD'],
    },
    {
        code: 'YTMC',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Interkommunalt selskap',
        abbreviation: 'IKS',
        active: true,
        aliases: ['Interkommunalt selskap', 'IKS'],
    },
    {
        code: 'YTY3',
        country: 'US',
        jurisdiction: 'US-IL',
        jurisdictionName: 'Illinois',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: 'YUCL',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Institution de retraite complémentaire',
        abbreviation: '',
        active: true,
        aliases: ['Institution de retraite complémentaire'],
    },
    {
        code: 'YVE8',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Európske zoskupenie hospodárskych záujmov',
        abbreviation: 'Európ.zoskup.hosp.záujm.;EZHZ',
        active: true,
        aliases: ['Európske zoskupenie hospodárskych záujmov', 'Európ.zoskup.hosp.záujm.;EZHZ'],
    },
    {
        code: 'YVGA',
        country: 'SA',
        jurisdiction: 'SA',
        jurisdictionName: 'Saudi Arabia',
        name: 'شركة محاصة',
        abbreviation: '',
        active: true,
        aliases: ['شركة محاصة', 'sharikat muhasa'],
    },
    {
        code: 'YVPW',
        country: 'RS',
        jurisdiction: 'RS',
        jurisdictionName: 'Serbia',
        name: 'Акционарско друштво',
        abbreviation: 'а.д;ад',
        active: true,
        aliases: ['Акционарско друштво', 'Akcionarsko društvo', 'а.д;ад', 'a.d;ad'],
    },
    {
        code: 'YVRM',
        country: 'SM',
        jurisdiction: 'SM',
        jurisdictionName: 'San Marino',
        name: 'Società anonima',
        abbreviation: 'SA',
        active: true,
        aliases: ['Società anonima', 'SA'],
    },
    {
        code: 'YVSB',
        country: 'US',
        jurisdiction: 'US-NY',
        jurisdictionName: 'New York',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: 'YVSL',
        country: 'TN',
        jurisdiction: 'TN',
        jurisdictionName: 'Tunisia',
        name: 'Société anonyme',
        abbreviation: 'SA',
        active: true,
        aliases: ['Société anonyme', 'SA'],
    },
    {
        code: 'YVWB',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Záujmové združenie fyzických osôb bez právnej spôsobilosti',
        abbreviation: 'Záujmové združ.fyz.osôb',
        active: true,
        aliases: [
            'Záujmové združenie fyzických osôb bez právnej spôsobilosti',
            'Záujmové združ.fyz.osôb',
        ],
    },
    {
        code: 'YVZD',
        country: 'GG',
        jurisdiction: 'GG',
        jurisdictionName: 'Guernsey',
        name: 'unlimited liability company',
        abbreviation: '',
        active: true,
        aliases: ['unlimited liability company'],
    },
    {
        code: 'YW6W',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Empresa Individual de Responsabilidad Limitada',
        abbreviation: 'E.I.R.L.',
        active: true,
        aliases: ['Empresa Individual de Responsabilidad Limitada', 'E.I.R.L.'],
    },
    {
        code: 'YWK0',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Foreign Limited Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Limited Partnership'],
    },
    {
        code: 'YX4E',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Société civile de placement collectif immobilier (SCPI)',
        abbreviation: '',
        active: true,
        aliases: ['Société civile de placement collectif immobilier (SCPI)'],
    },
    {
        code: 'YXJ5',
        country: 'CN',
        jurisdiction: 'CN',
        jurisdictionName: 'China',
        name: '宗教活动场所',
        abbreviation: '',
        active: true,
        aliases: ['宗教活动场所', 'zong jiao huo dong chang suo'],
    },
    {
        code: 'YXX0',
        country: 'SX',
        jurisdiction: 'SX',
        jurisdictionName: 'Sint Maarten',
        name: 'commanditaire vennootschap',
        abbreviation: 'CV',
        active: true,
        aliases: ['commanditaire vennootschap', 'CV'],
    },
    {
        code: 'YY5A',
        country: 'US',
        jurisdiction: 'US-TX',
        jurisdictionName: 'Texas',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: 'YYZO',
        country: 'CR',
        jurisdiction: 'CR',
        jurisdictionName: 'Costa Rica',
        name: 'Asociación Cooperativa',
        abbreviation: '',
        active: true,
        aliases: ['Asociación Cooperativa'],
    },
    {
        code: 'Z016',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Collection Agency',
        abbreviation: '',
        active: true,
        aliases: ['Collection Agency'],
    },
    {
        code: 'Z0EY',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Limited Liability Partnership',
        abbreviation: 'limited liability partnership;LLP;Limited Liability Partnership',
        active: true,
        aliases: [
            'Limited Liability Partnership',
            'limited liability partnership;LLP;Limited Liability Partnership',
            'Partneriaeth Atebolrwydd Cyfyngedig',
            'PAC',
        ],
    },
    {
        code: 'Z0JP',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Établissement public national à caractére industriel ou commercial non doté d'un comptable public",
        abbreviation: '',
        active: true,
        aliases: [
            "Établissement public national à caractére industriel ou commercial non doté d'un comptable public",
        ],
    },
    {
        code: 'Z0NE',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Fundação',
        abbreviation: '',
        active: true,
        aliases: ['Fundação'],
    },
    {
        code: 'Z2AQ',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Негосударственные пенсионные фонды',
        abbreviation: '',
        active: true,
        aliases: ['Негосударственные пенсионные фонды', 'Negosudarstvennyye pensionnyye fondy'],
    },
    {
        code: 'Z2FQ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Groupement d'intérêt public (GIP)",
        abbreviation: '',
        active: true,
        aliases: ["Groupement d'intérêt public (GIP)"],
    },
    {
        code: 'Z2OV',
        country: 'AE',
        jurisdiction: 'AE-AZ',
        jurisdictionName: 'Abu Dhabi',
        name: 'DLT Foundation',
        abbreviation: '',
        active: true,
        aliases: ['DLT Foundation'],
    },
    {
        code: 'Z38E',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Säästöpankki',
        abbreviation: '',
        active: true,
        aliases: ['Säästöpankki', 'Sparbank'],
    },
    {
        code: 'Z3BF',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Zemědělské družstvo',
        abbreviation: '',
        active: true,
        aliases: ['Zemědělské družstvo'],
    },
    {
        code: 'Z3P8',
        country: 'AE',
        jurisdiction: 'AE-RK',
        jurisdictionName: 'Ras Al Khaimah',
        name: 'Unlimited Company',
        abbreviation: '',
        active: true,
        aliases: ['Unlimited Company'],
    },
    {
        code: 'Z3SH',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Муниципальные унитарные предприятия',
        abbreviation: '',
        active: true,
        aliases: ['Муниципальные унитарные предприятия', "Munitsipal'nyye unitarnyye predpriyatiya"],
    },
    {
        code: 'Z3Y0',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Садоводческие, огороднические или дачные некоммерческие партнерства',
        abbreviation: '',
        active: true,
        aliases: [
            'Садоводческие, огороднические или дачные некоммерческие партнерства',
            'Sadovodcheskiye, ogorodnicheskiye ili dachnyye nekommercheskiye partnerstva',
        ],
    },
    {
        code: 'Z3Y2',
        country: 'CK',
        jurisdiction: 'CK',
        jurisdictionName: 'Cook Islands',
        name: 'Foreign Company',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Company'],
    },
    {
        code: 'Z4YC',
        country: 'KH',
        jurisdiction: 'KH',
        jurisdictionName: 'Cambodia',
        name: 'General Partnership',
        abbreviation: '',
        active: true,
        aliases: [
            'General Partnership',
            'ក្រុមហ៊ុនសហកម្មសិទ្ធិទូទៅ',
            'kromhoun sahakammosetthi toutow',
        ],
    },
    {
        code: 'Z4ZP',
        country: 'SB',
        jurisdiction: 'SB',
        jurisdictionName: 'Solomon Islands',
        name: 'Public Company',
        abbreviation: '',
        active: true,
        aliases: ['Public Company'],
    },
    {
        code: 'Z54A',
        country: 'US',
        jurisdiction: 'US-RI',
        jurisdictionName: 'Rhode Island',
        name: 'Business Corporation',
        abbreviation: 'corp.;inc.;co.;ltd.',
        active: true,
        aliases: ['Business Corporation', 'corp.;inc.;co.;ltd.'],
    },
    {
        code: 'Z5WG',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Groupement pastoral',
        abbreviation: '',
        active: true,
        aliases: ['Groupement pastoral'],
    },
    {
        code: 'Z6MF',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Selon la loi par Loi spéciale du Québec à caractère privé',
        abbreviation: '',
        active: true,
        aliases: ['Selon la loi par Loi spéciale du Québec à caractère privé'],
    },
    {
        code: 'Z6ZU',
        country: 'NZ',
        jurisdiction: 'NZ',
        jurisdictionName: 'New Zealand',
        name: 'Cooperative Company',
        abbreviation: 'COOP',
        active: true,
        aliases: ['Cooperative Company', 'COOP'],
    },
    {
        code: 'Z73Z',
        country: 'US',
        jurisdiction: 'US-MA',
        jurisdictionName: 'Massachusetts',
        name: 'Voluntary Association and Business Trusts',
        abbreviation: '',
        active: true,
        aliases: ['Voluntary Association and Business Trusts'],
    },
    {
        code: 'Z7ER',
        country: 'US',
        jurisdiction: 'US',
        jurisdictionName: 'United States of America',
        name: 'Mutual Savings and Loan Holding Company',
        abbreviation: '',
        active: true,
        aliases: ['Mutual Savings and Loan Holding Company'],
    },
    {
        code: 'Z7ZX',
        country: 'PT',
        jurisdiction: 'PT-30',
        jurisdictionName: 'Madeira',
        name: 'Sucursal Financeira Exterior',
        abbreviation: '',
        active: true,
        aliases: ['Sucursal Financeira Exterior'],
    },
    {
        code: 'Z89H',
        country: 'NE',
        jurisdiction: 'NE',
        jurisdictionName: 'Niger',
        name: 'Société en Commandite par actions',
        abbreviation: 'SCA',
        active: true,
        aliases: ['Société en Commandite par actions', 'SCA'],
    },
    {
        code: 'Z92A',
        country: 'US',
        jurisdiction: 'US-WI',
        jurisdictionName: 'Wisconsin',
        name: 'Limited Liability Partnership',
        abbreviation: 'RLLP, LLP, R.L.L.P., L.L.P.',
        active: true,
        aliases: ['Limited Liability Partnership', 'RLLP, LLP, R.L.L.P., L.L.P.'],
    },
    {
        code: 'Z9C5',
        country: 'US',
        jurisdiction: 'US-OR',
        jurisdictionName: 'Oregon',
        name: 'Non-deposit Trust Company',
        abbreviation: '',
        active: true,
        aliases: ['Non-deposit Trust Company'],
    },
    {
        code: 'Z9CH',
        country: 'US',
        jurisdiction: 'US-SD',
        jurisdictionName: 'South Dakota',
        name: 'Limited Liability Partnership',
        abbreviation: 'RLLP, LLP, R.L.L.P., L.L.P.',
        active: true,
        aliases: ['Limited Liability Partnership', 'RLLP, LLP, R.L.L.P., L.L.P.'],
    },
    {
        code: 'Z9IE',
        country: 'SA',
        jurisdiction: 'SA',
        jurisdictionName: 'Saudi Arabia',
        name: 'شركات أجنبية',
        abbreviation: '',
        active: false,
        aliases: ['شركات أجنبية', "sharikat 'ajnabia"],
    },
    {
        code: 'Z9K8',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Association d'avocats à responsabilité professionnelle individuelle",
        abbreviation: '',
        active: true,
        aliases: ["Association d'avocats à responsabilité professionnelle individuelle"],
    },
    {
        code: 'Z9KU',
        country: 'OM',
        jurisdiction: 'OM',
        jurisdictionName: 'Oman',
        name: 'شركة محاصة',
        abbreviation: '',
        active: true,
        aliases: ['شركة محاصة', 'sharikat muhasa'],
    },
    {
        code: 'ZACY',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'trust company',
        abbreviation: 'Trust Corporation;Trust Corp.;Trust Company;Trust Co.;Trustco;Trustee Corporation;Trustee Corp.;Trustee Company',
        active: true,
        aliases: [
            'trust company',
            'Trust Corporation;Trust Corp.;Trust Company;Trust Co.;Trustco;Trustee Corporation;Trustee Corp.;Trustee Company',
            'compagnie de fiducie',
            'Corporation de fiducie;Compagnie de fiducie;Corporation fiduciaire;Compagnie fiduciaire;Société fiduciaire',
        ],
    },
    {
        code: 'ZAIS',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad en nombre colectivo de capital variable',
        abbreviation: '',
        active: true,
        aliases: ['Sociedad en nombre colectivo de capital variable'],
    },
    {
        code: 'ZCFU',
        country: 'KH',
        jurisdiction: 'KH',
        jurisdictionName: 'Cambodia',
        name: 'Foreign Company',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Company', 'ក្រុមហ៊ុនបរទេស', 'kromhoun bartes'],
    },
    {
        code: 'ZCHO',
        country: 'US',
        jurisdiction: 'US-CO',
        jurisdictionName: 'Colorado',
        name: 'Cooperative Association',
        abbreviation: 'incorporated;company;limited;coop;ass’n;assn;assoc.;inc.;co.;ltd.',
        active: true,
        aliases: [
            'Cooperative Association',
            'incorporated;company;limited;coop;ass’n;assn;assoc.;inc.;co.;ltd.',
        ],
    },
    {
        code: 'ZD39',
        country: 'US',
        jurisdiction: 'US-OH',
        jurisdictionName: 'Ohio',
        name: 'Limited Partnership',
        abbreviation: 'Limited Partnership;L.P.;Limited;Ltd.',
        active: true,
        aliases: ['Limited Partnership', 'Limited Partnership;L.P.;Limited;Ltd.'],
    },
    {
        code: 'ZD74',
        country: 'AZ',
        jurisdiction: 'AZ',
        jurisdictionName: 'Azerbaijan',
        name: 'Fondlar',
        abbreviation: '',
        active: true,
        aliases: ['Fondlar'],
    },
    {
        code: 'ZDW0',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'ZE1G',
        country: 'PG',
        jurisdiction: 'PG',
        jurisdictionName: 'Papua New Guinea',
        name: 'Overseas Company',
        abbreviation: '',
        active: true,
        aliases: ['Overseas Company'],
    },
    {
        code: 'ZE81',
        country: 'ZA',
        jurisdiction: 'ZA',
        jurisdictionName: 'South Africa',
        name: 'Co-operatives (Tertiary)',
        abbreviation: '',
        active: true,
        aliases: ['Co-operatives (Tertiary)'],
    },
    {
        code: 'ZECH',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Syndicat mixte ouvert',
        abbreviation: '',
        active: true,
        aliases: ['Syndicat mixte ouvert'],
    },
    {
        code: 'ZEZ2',
        country: 'US',
        jurisdiction: 'US-NE',
        jurisdictionName: 'Nebraska',
        name: 'Foreign Limited Cooperative Association',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Limited Cooperative Association'],
    },
    {
        code: 'ZFFA',
        country: 'LU',
        jurisdiction: 'LU',
        jurisdictionName: 'Luxembourg',
        name: 'Etablissement public',
        abbreviation: 'EP',
        active: true,
        aliases: ['Etablissement public', 'EP'],
    },
    {
        code: 'ZFQS',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Ustanova',
        abbreviation: '',
        active: true,
        aliases: ['Ustanova'],
    },
    {
        code: 'ZG2I',
        country: 'SK',
        jurisdiction: 'SK',
        jurisdictionName: 'Slovakia',
        name: 'Spoločenstvá vlastníkov pozemkov, bytov a pod.',
        abbreviation: 'Spoločenstvá vlastníkov',
        active: true,
        aliases: ['Spoločenstvá vlastníkov pozemkov, bytov a pod.', 'Spoločenstvá vlastníkov'],
    },
    {
        code: 'ZG6S',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Ente Pubblico Economico',
        abbreviation: '',
        active: true,
        aliases: ['Ente Pubblico Economico'],
    },
    {
        code: 'ZGEX',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les services correctionnels',
        abbreviation: '',
        active: true,
        aliases: ['Personne morale sans but lucratif par Loi sur les services correctionnels'],
    },
    {
        code: 'ZGPY',
        country: 'IM',
        jurisdiction: 'IM',
        jurisdictionName: 'Isle of Man',
        name: 'Public Limited by Shares (1931 Act)',
        abbreviation: '',
        active: true,
        aliases: ['Public Limited by Shares (1931 Act)'],
    },
    {
        code: 'ZGYA',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Торгово-промышленные палаты',
        abbreviation: '',
        active: true,
        aliases: ['Торгово-промышленные палаты', 'Torgovo-promyshlennyye palaty'],
    },
    {
        code: 'ZH3O',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Хозяйственные партнерства',
        abbreviation: '',
        active: true,
        aliases: ['Хозяйственные партнерства', 'Khozyaystvennyye partnerstva'],
    },
    {
        code: 'ZHED',
        country: 'VG',
        jurisdiction: 'VG',
        jurisdictionName: 'Virgin Islands (British)',
        name: 'company limited by guarantee that is authorised to issue shares',
        abbreviation: 'Ltd;Corp;Inc;S.A.',
        active: true,
        aliases: [
            'company limited by guarantee that is authorised to issue shares',
            'Ltd;Corp;Inc;S.A.',
        ],
    },
    {
        code: 'ZHHH',
        country: 'CL',
        jurisdiction: 'CL',
        jurisdictionName: 'Chile',
        name: 'Comunidad o Asociación Indígena',
        abbreviation: '',
        active: true,
        aliases: ['Comunidad o Asociación Indígena'],
    },
    {
        code: 'ZHT0',
        country: 'BZ',
        jurisdiction: 'BZ',
        jurisdictionName: 'Belize',
        name: 'Company Limited by Guarantee',
        abbreviation: '',
        active: true,
        aliases: ['Company Limited by Guarantee'],
    },
    {
        code: 'ZHZP',
        country: 'US',
        jurisdiction: 'US-RI',
        jurisdictionName: 'Rhode Island',
        name: 'Cooperative',
        abbreviation: 'corp.;inc.;co.;ltd.',
        active: true,
        aliases: ['Cooperative', 'corp.;inc.;co.;ltd.'],
    },
    {
        code: 'ZILA',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Estabelecimento Individual de Responsabilidade Limitada',
        abbreviation: '',
        active: true,
        aliases: ['Estabelecimento Individual de Responsabilidade Limitada'],
    },
    {
        code: 'ZJEX',
        country: 'PH',
        jurisdiction: 'PH',
        jurisdictionName: 'Philippines',
        name: 'religious corporation',
        abbreviation: '',
        active: true,
        aliases: ['religious corporation'],
    },
    {
        code: 'ZJPG',
        country: 'US',
        jurisdiction: 'US-DC',
        jurisdictionName: 'District of Columbia',
        name: 'Nonprofit Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonprofit Corporation'],
    },
    {
        code: 'ZJS8',
        country: 'IE',
        jurisdiction: 'IE',
        jurisdictionName: 'Ireland',
        name: 'Industrial and Provident Society',
        abbreviation: 'I&PS',
        active: true,
        aliases: ['Industrial and Provident Society', 'I&PS'],
    },
    {
        code: 'ZJTK',
        country: 'US',
        jurisdiction: 'US-MA',
        jurisdictionName: 'Massachusetts',
        name: 'Domestic Business  Corporation',
        abbreviation: 'Company;Co.;Corporation;Corp.;Incorporated;Inc. Limited;Ltd.',
        active: true,
        aliases: [
            'Domestic Business  Corporation',
            'Company;Co.;Corporation;Corp.;Incorporated;Inc. Limited;Ltd.',
        ],
    },
    {
        code: 'ZJZB',
        country: 'KN',
        jurisdiction: 'KN',
        jurisdictionName: 'Saint Kitts and Nevis',
        name: 'exempt private company',
        abbreviation: '',
        active: true,
        aliases: ['exempt private company'],
    },
    {
        code: 'ZKAF',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Полные товарищества',
        abbreviation: '',
        active: true,
        aliases: ['Полные товарищества', 'Polnyye tovarishchestva'],
    },
    {
        code: 'ZKTC',
        country: 'CW',
        jurisdiction: 'CW',
        jurisdictionName: 'Curaçao',
        name: 'Trust',
        abbreviation: '',
        active: true,
        aliases: ['Trust'],
    },
    {
        code: 'ZLIW',
        country: 'US',
        jurisdiction: 'US-HI',
        jurisdictionName: 'Hawaii',
        name: 'Trademark',
        abbreviation: '',
        active: false,
        aliases: ['Trademark'],
    },
    {
        code: 'ZLTD',
        country: 'BM',
        jurisdiction: 'BM',
        jurisdictionName: 'Bermuda',
        name: 'Overseas (Permit) Partnership',
        abbreviation: '',
        active: true,
        aliases: ['Overseas (Permit) Partnership'],
    },
    {
        code: 'ZM5P',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "SA d'économie mixte à directoire",
        abbreviation: '',
        active: true,
        aliases: ["SA d'économie mixte à directoire"],
    },
    {
        code: 'ZMTL',
        country: 'FI',
        jurisdiction: 'FI',
        jurisdictionName: 'Finland',
        name: 'Kuolinpesä',
        abbreviation: '',
        active: true,
        aliases: ['Kuolinpesä', 'Dödsbo'],
    },
    {
        code: 'ZMY8',
        country: 'HR',
        jurisdiction: 'HR',
        jurisdictionName: 'Croatia',
        name: 'Zaklada',
        abbreviation: '',
        active: true,
        aliases: ['Zaklada'],
    },
    {
        code: 'ZNHF',
        country: 'RU',
        jurisdiction: 'RU',
        jurisdictionName: 'Russian Federation',
        name: 'Государственные казенные учреждения субъектов Российской Федерации',
        abbreviation: '',
        active: true,
        aliases: [
            'Государственные казенные учреждения субъектов Российской Федерации',
            'Gosudarstvennyye kazennyye uchrezhdeniya sub"yektov Rossiyskoy Federatsii',
        ],
    },
    {
        code: 'ZOK2',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Landbouwvennootschap',
        abbreviation: 'LV',
        active: true,
        aliases: [
            'Landbouwvennootschap',
            'LV',
            'Société agricole',
            'S. Agr.',
            'Landwirtschaftliche Gesellschaft',
            'LG',
        ],
    },
    {
        code: 'ZOSP',
        country: 'NE',
        jurisdiction: 'NE',
        jurisdictionName: 'Niger',
        name: 'Société en Commandite simple',
        abbreviation: 'SCS',
        active: true,
        aliases: ['Société en Commandite simple', 'SCS'],
    },
    {
        code: 'ZPEZ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Association syndicale libre',
        abbreviation: '',
        active: true,
        aliases: ['Association syndicale libre'],
    },
    {
        code: 'ZPOY',
        country: 'RS',
        jurisdiction: 'RS',
        jurisdictionName: 'Serbia',
        name: 'Ортачко друштво',
        abbreviation: 'о.д.;од',
        active: true,
        aliases: ['Ортачко друштво', 'Ortačko društvo', 'о.д.;од', 'o.d.;od'],
    },
    {
        code: 'ZPRC',
        country: 'US',
        jurisdiction: 'US-AK',
        jurisdictionName: 'Alaska',
        name: 'credit union',
        abbreviation: '',
        active: true,
        aliases: ['credit union'],
    },
    {
        code: 'ZQ0Q',
        country: 'NO',
        jurisdiction: 'NO',
        jurisdictionName: 'Norway',
        name: 'Eierseksjonssameie',
        abbreviation: '',
        active: true,
        aliases: ['Eierseksjonssameie'],
    },
    {
        code: 'ZQ6S',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Old Public Company',
        abbreviation: 'Ltd;Ltd.;Limited',
        active: true,
        aliases: ['Old Public Company', 'Ltd;Ltd.;Limited'],
    },
    {
        code: 'ZQ9B',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Exploitant public',
        abbreviation: '',
        active: true,
        aliases: ['Exploitant public'],
    },
    {
        code: 'ZQAQ',
        country: 'HU',
        jurisdiction: 'HU',
        jurisdictionName: 'Hungary',
        name: 'Közjegyzői iroda',
        abbreviation: '',
        active: true,
        aliases: ['Közjegyzői iroda'],
    },
    {
        code: 'ZQEN',
        country: 'TO',
        jurisdiction: 'TO',
        jurisdictionName: 'Tonga',
        name: 'Overseas Company',
        abbreviation: '',
        active: true,
        aliases: ['Overseas Company'],
    },
    {
        code: 'ZQIT',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'SA coopérative de consommation à directoire',
        abbreviation: '',
        active: true,
        aliases: ['SA coopérative de consommation à directoire'],
    },
    {
        code: 'ZQO8',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Evropská společnost',
        abbreviation: 'SE',
        active: true,
        aliases: ['Evropská společnost', 'SE'],
    },
    {
        code: 'ZQQU',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur la société Saint-Jean-Baptiste du Québec',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur la société Saint-Jean-Baptiste du Québec',
        ],
    },
    {
        code: 'ZQZW',
        country: 'US',
        jurisdiction: 'US-LA',
        jurisdictionName: 'Louisiana',
        name: 'Foreign Public Benefit',
        abbreviation: '',
        active: true,
        aliases: ['Foreign Public Benefit'],
    },
    {
        code: 'ZRPO',
        country: 'DK',
        jurisdiction: 'DK',
        jurisdictionName: 'Denmark',
        name: 'Aktieselskab',
        abbreviation: 'A/S',
        active: true,
        aliases: ['Aktieselskab', 'A/S'],
    },
    {
        code: 'ZSFX',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Naamloze vennootschap met een sociaal oogmerk',
        abbreviation: 'NV SO',
        active: true,
        aliases: [
            'Naamloze vennootschap met een sociaal oogmerk',
            'NV SO',
            'Société anonyme à finalité sociale',
            'SA FS',
            'Aktiengesellschaft mit sozialer Zielsetzung',
            'AGmsZ',
        ],
    },
    {
        code: 'ZSWE',
        country: 'PT',
        jurisdiction: 'PT',
        jurisdictionName: 'Portugal',
        name: 'Empresa Regional',
        abbreviation: '',
        active: true,
        aliases: ['Empresa Regional'],
    },
    {
        code: 'ZTUI',
        country: 'MU',
        jurisdiction: 'MU',
        jurisdictionName: 'Mauritius',
        name: 'Association',
        abbreviation: '',
        active: true,
        aliases: ['Association'],
    },
    {
        code: 'ZU32',
        country: 'CZ',
        jurisdiction: 'CZ',
        jurisdictionName: 'Czechia',
        name: 'Jiné družstvo',
        abbreviation: '',
        active: true,
        aliases: ['Jiné družstvo'],
    },
    {
        code: 'ZU9S',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Piccola Società Cooperativa a Responsabilità Limitata',
        abbreviation: '',
        active: true,
        aliases: ['Piccola Società Cooperativa a Responsabilità Limitata'],
    },
    {
        code: 'ZUDG',
        country: 'EC',
        jurisdiction: 'EC',
        jurisdictionName: 'Ecuador',
        name: 'Fundacion',
        abbreviation: '',
        active: true,
        aliases: ['Fundacion'],
    },
    {
        code: 'ZUHK',
        country: 'BE',
        jurisdiction: 'BE',
        jurisdictionName: 'Belgium',
        name: 'Stichting van openbaar nut',
        abbreviation: 'SON',
        active: true,
        aliases: [
            'Stichting van openbaar nut',
            'SON',
            "Fondation d'utilité publique",
            'FUP',
            'Gemeinnützige Stiftung',
            'gnS',
        ],
    },
    {
        code: 'ZULC',
        country: 'US',
        jurisdiction: 'US-ND',
        jurisdictionName: 'North Dakota',
        name: 'Development Corporation',
        abbreviation: 'corp;inc.',
        active: true,
        aliases: ['Development Corporation', 'corp;inc.'],
    },
    {
        code: 'ZVS9',
        country: 'US',
        jurisdiction: 'US-MD',
        jurisdictionName: 'Maryland',
        name: 'Nonstock Corporation',
        abbreviation: '',
        active: true,
        aliases: ['Nonstock Corporation'],
    },
    {
        code: 'ZVVM',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'osoby fizyczne prowadzące działalność gospodarczą',
        abbreviation: '',
        active: true,
        aliases: ['osoby fizyczne prowadzące działalność gospodarczą'],
    },
    {
        code: 'ZWYK',
        country: 'MY',
        jurisdiction: 'MY-15',
        jurisdictionName: 'Labuan',
        name: 'Labuan Company (Limited By Share)',
        abbreviation: '',
        active: true,
        aliases: ['Labuan Company (Limited By Share)'],
    },
    {
        code: 'ZX1F',
        country: 'CA',
        jurisdiction: 'CA-QC',
        jurisdictionName: 'Quebec',
        name: 'Personne morale sans but lucratif par Loi sur les compagnies de cimetières catholiques romains',
        abbreviation: '',
        active: true,
        aliases: [
            'Personne morale sans but lucratif par Loi sur les compagnies de cimetières catholiques romains',
        ],
    },
    {
        code: 'ZXHJ',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Société d'exercice libéral à forme anonyme à conseil d'administration",
        abbreviation: '',
        active: true,
        aliases: ["Société d'exercice libéral à forme anonyme à conseil d'administration"],
    },
    {
        code: 'ZXVG',
        country: 'MX',
        jurisdiction: 'MX',
        jurisdictionName: 'Mexico',
        name: 'Sociedad en comandita por acciones de capital variable',
        abbreviation: 'S. en C. por A. de C. V.',
        active: true,
        aliases: ['Sociedad en comandita por acciones de capital variable', 'S. en C. por A. de C. V.'],
    },
    {
        code: 'ZXZ7',
        country: 'US',
        jurisdiction: 'US-WI',
        jurisdictionName: 'Wisconsin',
        name: 'Common Law Trust (Business Trust)',
        abbreviation: '',
        active: true,
        aliases: ['Common Law Trust (Business Trust)'],
    },
    {
        code: 'ZY4E',
        country: 'CA',
        jurisdiction: 'CA-NB',
        jurisdictionName: 'New Brunswick',
        name: 'appellation commerciale - propriétaire unique',
        abbreviation: '',
        active: false,
        aliases: ['appellation commerciale - propriétaire unique'],
    },
    {
        code: 'ZY9X',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: 'Entrepreneur individuel',
        abbreviation: '',
        active: true,
        aliases: ['Entrepreneur individuel'],
    },
    {
        code: 'ZYQX',
        country: 'UY',
        jurisdiction: 'UY',
        jurisdictionName: 'Uruguay',
        name: 'Persona Jurídica de Derecho Público No Estatal',
        abbreviation: '',
        active: true,
        aliases: ['Persona Jurídica de Derecho Público No Estatal'],
    },
    {
        code: 'ZZ0X',
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        name: "Établissement public des cultes d'Alsace-Lorraine",
        abbreviation: '',
        active: true,
        aliases: ["Établissement public des cultes d'Alsace-Lorraine"],
    },
    {
        code: 'ZZGG',
        country: 'GB',
        jurisdiction: 'GB',
        jurisdictionName: 'United Kingdom of Great Britain and Northern Ireland',
        name: 'Co-operative Society',
        abbreviation: 'Co-op',
        active: true,
        aliases: ['Co-operative Society', 'Co-op'],
    },
    {
        code: 'ZZKE',
        country: 'PL',
        jurisdiction: 'PL',
        jurisdictionName: 'Poland',
        name: 'stowarzyszenie i związki stowarzyszeń',
        abbreviation: '',
        active: true,
        aliases: ['stowarzyszenie i związki stowarzyszeń'],
    },
    {
        code: 'ZZOG',
        country: 'IT',
        jurisdiction: 'IT',
        jurisdictionName: 'Italy',
        name: 'Società Tra Professionisti',
        abbreviation: '',
        active: true,
        aliases: ['Società Tra Professionisti'],
    },
];
//# sourceMappingURL=legal-forms.js.map